/**
* @fileOverview This javascript contains javascript functions used by the newsletter function
*/

NewsLetterJS={
        
    version: "Common Implementation v0.01",
	/** language ID to be used, default to -1 (English) */
	langId: "-1",
	
	/** store ID to be used */
	storeId: "",
	
	/** store Name to be used */
	appName :"",
	/** catalog ID to be used */
	catalogId: "",
	
	email :"",
	
	formId:"",
	
	/** 
	* Sets common parameters used by this javascript object
	* @param {String} langId language ID to use
	* @param {String} storeId store ID to use

	*/	
	setCommonParameters:function(langId,storeId,catalogId,appName){
		this.langId = langId;
		this.storeId = storeId;
		this.catalogId = catalogId;
        this.appName = appName;
	},
	
	updateParamObject:function(params, key, value, index){
		if(params == null){
			params = [];
		}

		if(index != null && index !== "" && index !== -1){
			//overwrite the old value at specified index
			params[key+"_"+index] = value;
		}else if(index === -1){
			var i = 1;
			while(params[key + "_" + i] != null){
				i++;
			}
			params[key + "_" + i] = value;
		}else{
			params[key] = value;
		}
		return params;
	},
	
	/**
	* This function clears all the input fields of the form passed in by parameter
	* @param {String} formName The name of the form containing the input fields.	
	*/
	 clearForm:function(formName){
		var form = document.forms[formName];
		for(var i=0; i<form.elements.length; i++) {
			if (form.elements[i].type == "text") {
				form.elements[i].value = "";
			}
		}
	},
	
	/**
	 * submitting to newsletter after checking email param
	 */
	subscribeToNewsLetter:function(formName, page){
		if(this.validateSubscriptionParams(formName)){
            var zipcode = '';  
            var firstName = '';
            var lastName = '';
            var gender = '';
            var dateOfBirth = '';
            var promo = false;
            var primaryNewsLetterFlow=true;
		    this.formId = formName;
		    emailInput = document.querySelector("form[name="+formName+"] #newsletterPopupEmail");
		    if (formName == "newsLetterForm") {
		        emailInput = document.querySelector("form[name="+formName+"] #newsletterEmail");
		        if (isCarol) {
		            emailInput.parentElement.classList.remove("errorGeneric");
	                emailInput.parentElement.classList.remove("errorDuplicate");
		        }
            }
            if(formName == "newsLetterFormLandingPage" && isOliver) {
                emailInput = document.querySelector("form[name="+formName+"] #newsletterEmailLandingPage");
                if(countryCode == 'US' || countryCode == 'CA') {
                	zipcode = document.querySelector("form[name="+formName+"] #newsletterZipcodeLandingPage").value;
                }
                firstName = document.querySelector("form[name="+formName+"] #newsletterFirstNameLandingPage").value;
            	lastName = document.querySelector("form[name="+formName+"] #newsletterLastNameLandingPage").value;
            	gender = document.querySelector("form[name="+formName+"] #newsletterGenderLandingPage").value;
            	dateOfBirth = document.querySelector("form[name="+formName+"] #newsletterBirthdayLandingPage").value;
            } else if (formName == "newsLetterFormPromoLandingPage"){
            	emailInput = document.querySelector("form[name="+formName+"] #newsletterEmailLandingPage");
            	firstName = document.querySelector("form[name="+formName+"] #newsletterFirstNameLandingPage").value;
            	lastName = document.querySelector("form[name="+formName+"] #newsletterLastNameLandingPage").value;
            	gender = document.querySelector("form[name="+formName+"] #newsletterGenderLandingPage").value;
            	dateOfBirth = document.querySelector("form[name="+formName+"] #newsletterBirthdayLandingPage").value;
            	promo = true;
            } //#EMAIL_ME# 
            else if (formName == "newsLetterForm_emailme") { 
		        emailInput = document.querySelector("form[name="+formName+"] #input_Emailme");
			} //#EMAIL_ME#
		    this.email = emailInput.value.toLowerCase();
		    
		    var cidCookie = null;
	        
	        if(document.cookie.includes('X_WC_CID')){
	        	cidCookie = $.cookie("X_WC_CID");
	        }
		    
			var params = {
				storeId: this.storeId,
				langId : this.langId,
				email: this.email,
                zipCode: zipcode,
                promo: promo,
                pageIdentifier: page,
                firstName: firstName,
                lastName: lastName,
                gender: gender,
                dob: dateOfBirth,
                primaryNewsLetterFlow:primaryNewsLetterFlow,
                cid: cidCookie
			}
            if(typeof updateDuplicate != 'undefined' && updateDuplicate == 'true')
                params.update = updateDuplicate

		 	cursor_wait();
		 	wcService.invoke("JoinNewsletterService", params);
		 	
		 	if(formName=="newsletterPopupForm"){
		 		setCookie("WELCOME_STICKY_SHOWN_"+this.appName,true,{expires: 10000,path: "/", domain: cookieDomain});
		 	}
		}
		
	},

    validateSubscriptionParams: function(formName) {
        this.cleanErrors(formName); 
        var namePattern = /[A-Za-z]/;
        var isValid = true; //we use this variable to check all fields and show,eventually, all errors

        /*EMAIL VALDATION - MANDATORY*/
        var emailInput = $("form[name="+formName+"] [name='EMAIL']");
        if (!emailInput.val()) { //empty or undefined
            this.toggleFormError('EMAIL','EMPTY',formName);
            isValid = false;
        } else if (emailInput.length > 0 && !AddressHelper.validateEmail(emailInput.get(0))) {
            this.toggleFormError('EMAIL','INVALID',formName);
            isValid = false;
        }
        
        /*FIRSTNAME VALDATION*/
        var firstNameInput = $("form[name="+formName+"] [name='NAME'],form[name="+formName+"] [name='FIRSTNAME']");
        if (firstNameInput.length > 0 && needsValidation(firstNameInput)) { //if fild not available or disabled do not check
            var firstNameValue = firstNameInput.val();
            if (!firstNameValue) {
                this.toggleFormError('NAME','EMPTY',formName);  
                isValid = false; 
            } else if (!namePattern.test(firstNameValue)){
                this.toggleFormError('NAME','INVALID',formName);  
                isValid = false;
            }
        }

        /*LASTNAME VALIDATION*/
        var lastNameInput = $("form[name="+formName+"] [name='LASTNAME']");
        if (lastNameInput.length > 0 && needsValidation(lastNameInput)) { //if fild not available or disabled do not check
            var lastNameValue = lastNameInput.val();
            if (!lastNameValue) {
                this.toggleFormError('LASTNAME','EMPTY',formName);  
                isValid = false; 
            } else if (!namePattern.test(lastNameValue)){
                this.toggleFormError('LASTNAME','INVALID',formName);  
                isValid = false;
            }
        }

        /*GENDER VALIDATION*/
        var genderInput = $("form[name="+formName+"] [name='gender']");
        if (genderInput.length > 0 && needsValidation(genderInput)) { //if fild not available or disabled do not check
            var genderSelected = genderInput.find('option:selected').val();

            if(!genderSelected) {
                this.toggleFormError('GENDER','EMPTY',formName);  
                isValid = false;
            } 
        }
       
        /*BIRTHDAY VALIDATION*/
        var birthdayInput = $("form[name="+formName+"] [name='BIRTHDAY']");
        if (birthdayInput.length > 0 && needsValidation(birthdayInput)) { //if fild not available or disabled do not check
            var  dateOfBirth = birthdayInput.val();
            // Variables for birthday validation
            var birthdayDate = new Date(dateOfBirth);
            var birthdayYear = birthdayDate.getFullYear();
            var currentYear = new Date().getFullYear();
            var maxAge = currentYear - birthdayYear;

            if (dateOfBirth == '') {
                this.toggleFormError('BIRTHDAY','EMPTY',formName);   
                isValid = false;
            } else if (maxAge > 100 || maxAge < 16 || birthdayYear >= currentYear){
                this.toggleFormError('BIRTHDAY','INVALID',formName);  
                isValid = false;
            }
        }

         /*ZIPCODE VALIDATION*/
         var zipCodeInput = $("form[name="+formName+"] [name='ZIPCODE']");
         if (zipCodeInput.length > 0 && needsValidation(zipCodeInput)) { //if fild not available or disabled do not check
            var  zipCodeValue = zipCodeInput.val();
            var zipCodeRegexp = AddressHelper.getZipCodeRegexpForCurrentCountryCode();
            
            if (!zipCodeRegexp.test(zipCodeValue)){
                this.toggleFormError('ZIPCODE','INVALID',formName);  
                isValid = false;
            }
         }

                 
        return isValid;
    },

    toggleFormError: function(element,error, formName) {
        switch(formName) {
            case 'newsLetterFormPromoLandingPage' : case 'newsLetterFormLandingPage': {
                switch(element) {
                    case 'EMAIL': {
                        $("#mce-error-response-landingpage--email").show();
                        $("#mce-error-response-landingpage--email").children().hide();
                        $("#newsletterEmailForm input").css('border','solid 1px red');
                        if(error=='EMPTY'){ 
                            $("#mce-error-response-landingpage--email [id^=\"mce-error-response-empty-landingpage\"]").show();
                        }    
                        else if (error=='INVALID') { 
                            $("#mce-error-response-landingpage--email [id^=\"mce-error-response-invalid-landingpage\"]").show();
                        }
                        else console.log('NewsletterJS.toggleFormError - EMAIL CASE '+error+' NOT DEFINED');
                        
                        break;
                    }
                    case 'NAME': {
                        $('#mce-error-response-landingpage--name').show();
                        $('#mce-error-response-landingpage--name').children().hide();
                        $('#newsletterNameForm input').css('border','solid 1px red');
        
                        if(error == 'EMPTY')  {
                            $("#mce-error-response-landingpage--name [id^=\"mce-error-response-empty-landingpage\"]").show();
                        }
                        else if(error == 'INVALID') {
                            $('#mce-error-response-landingpage--name  [id^=\"mce-error-response-invalid-landingpage\"]').show();
                        }
                        else console.log('NewsletterJS.toggleFormError - NAME CASE '+error+' NOT DEFINED');
                        
                        break;
                    }
                    
                    case 'LASTNAME': {
                        $('#mce-error-response-landingpage--lastname').show();
                        $('#mce-error-response-landingpage--lastname').children().hide();
                        $('#newsletterLastnameForm input').css('border','solid 1px red');
        
                        if(error == 'EMPTY')  {
                            $("#mce-error-response-landingpage--lastname [id^=\"mce-error-response-empty-landingpage\"]").show();
                        }
                        else if(error == 'INVALID') {
                            $('#mce-error-response-landingpage--lastname [id^=\"mce-error-response-invalid-landingpage\"]').show();
                        }
                        else console.log('NewsletterJS.toggleFormError - LASTNAME CASE '+error+' NOT DEFINED');
                        
                        break;
                    } 
        
                    case 'GENDER': {
                        $('#mce-error-response-landingpage--gender').show();
                        $('#mce-error-response-landingpage--gender').children().hide();
                        $('#newsletterGenderForm select').css('border','solid 1px red');
                        $('#newsletterGenderForm select').css('margin-bottom','0');
        
                        if(error == 'EMPTY')  {
                            $("#mce-error-response-landingpage--gender [id^=\"mce-error-response-empty-landingpage\"]").show();
                        }
                        else console.log('NewsletterJS.toggleFormError - GENDER CASE '+error+' NOT DEFINED');
                        
                        break;
                    }
                    
                    case 'BIRTHDAY': {
                        $('#mce-error-response-landingpage--birthday').show();
                        $('#mce-error-response-landingpage--birthday').children().hide();
                        $('#newsletterBirthdayForm input').css('border','solid 1px red');
        
                        if(error == 'EMPTY')  {
                            $("#mce-error-response-landingpage--birthday [id^=\"mce-error-response-empty-landingpage\"]").show();
                        }
                        else if(error == 'INVALID') {
                            $('#mce-error-response-landingpage--birthday [id^=\"mce-error-response-invalid-landingpage\"]').show();
                        }
                        else console.log('NewsletterJS.toggleFormError - BIRTHDAY CASE '+error+' NOT DEFINED');
                        
                        break;
                    }
        
                    case 'ZIPCODE': {
                        $('#mce-error-response-landingpage').show();
                        $('#mce-error-response-landingpage').children().hide();
                        $('#newsletterZipCodeForm input').css('border','solid 1px red');
        
                        if(error == 'INVALID') {
                            $('#mce-error-response-zipcode-landingpage').show();
                        }
                        else console.log('NewsletterJS.toggleFormError - ZIPCODE CASE '+error+' NOT DEFINED');
                        
                        break;
                    }
                    default: console.log('NewsletterJS.toggleFormError - '+element+' CASE  NOT DEFINED')
                }

                break;
            }
            case 'newsLetterForm_emailme' : {
                $("#mce-error-response_emailme").show();
                $("#mce-error-response_emailme").children().hide();
                if(error=='EMPTY')
                    $("#mce-error-response-empty_emailme").show();  
                else if (error=='INVALID') $("#mce-error-response-invalid_emailme").show();
                else console.log('NewsletterJS.toggleFormError - EMAILME - CASE '+error+' NOT DEFINED')
                break;
            }
            default : {
                $("#mce-error-response").show();
                $("#mce-error-response").children().hide();
                if(error=='EMPTY')
                    $("#mce-error-response-empty").show();
                else if (error=='INVALID') $("#mce-error-response-invalid").show();
                else console.log('NewsletterJS.toggleFormError - '+formName+' - CASE '+error+' NOT DEFINED');
            }
        }
    },

    cleanErrors: function(formName) {
        $("[id^=mce-error-response").hide()
        switch(formName) {
            case 'newsLetterFormPromoLandingPage' : case 'newsLetterFormLandingPage': {
                $("form[name="+formName+"] input").css('border','');
                $("form[name="+formName+"] select").css('border','');
                $("form[name="+formName+"] select").css('margin-bottom','40px');
                break;
            }
            default : {
                $("#mce-error-response").hide();
            }
        }
    },

	hideAllMessagews : function () {
	    $('#newsletterSignUpResultPopup .message-error').hide();
	    $('#newsletterSignUpResultPopup .message-duplicate').hide();
	    $('#newsletterSignUpResultPopup .message-success').hide();
	},
    handleJoinNewsletterError : function(){
        this.hideAllMessagews();
        if (this.formId == "newsLetterForm") {
            if (isCarol) {
                document.getElementById("newsletterEmail").parentElement.classList.add("errorGeneric");
            } else {
            	$('#mce-error-response').show();
            	$('#mce-error-response').children().hide();
            	$('#mce-error-response-error').show();
            }
        } else if (this.formId == "newsLetterFormLandingPage" && isOliver) {
        	$('#mce-error-response-landingpage').show();
            $('#mce-error-response-landingpage').children().hide();
            $('#mce-error-response-error-landingpage').show();
        } else {
            $('#newsletterSignUpResultPopup .message-error').show();
            $('#newsletterSignUpResultPopup').fadeIn("fast");
        }
    },  

    handleJoinNewsletterDuplicate : function(){
        this.hideAllMessagews();
        if (this.formId == "newsLetterForm") {
            if (isCarol) {
                document.getElementById("newsletterEmail").parentElement.classList.add("errorDuplicate");           
            } else if(isVogue) {                
                $('#mce-error-response').show();
                $('#mce-error-response').children().hide();
                if(window.innerWidth < 1024) {
                    $('.newsletter__title').hide();
                }
                //$('.newsletter__policy').hide();
                //$('.newsletter__form').hide();
                $('#mce-error-response-duplicate').show();
            	$('#mce-success-response').hide();
            
            } else {
            	$('#mce-error-response').show();
            	$('#mce-error-response').children().hide();
            	$('#mce-error-response-duplicate').show();
            	$('#mce-success-response').hide();
            }
        } else if (this.formId == "newsLetterFormLandingPage" && isOliver) {
        	$('#mce-error-response-landingpage--email').show();
            $('#mce-error-response-landingpage--email').children().hide();
            $('#mce-error-response-duplicate-landingpage').show();
            
        } else if (this.formId == "newsLetterFormPromoLandingPage") {
            $('#mce-error-response-landingpage--email').show();
            $('#mce-error-response-landingpage--email').children().hide();
            $('#mce-error-response-landingpage--email #mce-error-response-duplicate-landingpage').show();
        } else if(this.formId == "newsLetterForm_emailme"){ //#EMAIL_ME#
         /* email me messaggi di errore per duplicati newsletter 
            $('#mce-error-response_emailme').show();
            $('#mce-error-response_emailme').children().hide();
            $('#mce-error-response-duplicate_emailme').show();
            $('#mce-success-response_emailme').hide();*/
        } //#EMAIL_ME#
        else {
            $('#newsletterSignUpResultPopup .message-duplicate').show();
            $('#newsletterSignUpResultPopup').fadeIn("fast");
        }
    },  
    
    handleJoinNewsletterSuccess : function(){
        this.hideAllMessagews();
        
        /*if(typeof customerWeekActive != 'undefined' && customerWeekActive){
          activateCustomerWeek();
        }*/
        
        if (this.formId == "newsLetterForm") {
            if (isCarol) {
                $('#newsLetterFormDiv').hide();
                $('#newsLetterSuccessDiv').fadeIn("fast");
            } else if(isVogue) {                
                $('#mce-error-response').show();
                $('#mce-error-response').children().hide();
                $('.newsletter__policy').hide();
                $('.newsletter--form--input.input-style').hide();
                $('.button.gray-alpha.button--newsletter').hide()
                $('#mce-success-response').show();
                
            } else {
            	$('#mce-error-response').show();
            	$('#mce-error-response').children().hide();
            	$('#mce-success-response').show();
            }
        } else if (this.formId == "newsLetterFormLandingPage" && isOliver) {
            $('#mce-error-response-landingpage').show();
            $('#mce-error-response-landingpage').children().hide();
            $('#opnewsletter-success-response-landingpage').show();
            $('.newsletter__wrapper').hide();
        } else if (this.formId == "newsLetterFormPromoLandingPage"){
        	//Generic
        	 $('.newsletter-page .newsletter__form').hide();
        	 $('.newsletter_homepage-button').show();
        	 $('.newsletter__policy.no-gdpr').hide();
        	//Vogue
        	 $('#mbb-success-response-landingpage').show();
        	 $('.newsletter__title-mbb').hide();
 	         $('.newsletter__info-mbb').hide();
 	         $('.newsletter__image.newsletter-mbb_image img:nth-child(2)').hide();
             $('.newsletter__image.newsletter-mbb_image img:nth-child(3)').show();
        	//Persol
        	 $('#ponewsletter-success-response-landingpage').show();
        	 $('.newsletter__title-ponewsletter').hide();
 	         $('.newsletter__info-ponewsletter').hide();
 	         $('.newsletter__image.newsletter-ponewsletter_image img:nth-child(2)').hide();
             $('.newsletter__image.newsletter-ponewsletter_image img:nth-child(3)').show();
             $('#POnewsletterImage').hide();
             $('#POnewsletterImageMobile').hide();
             if(window.mobilecheck()){
            	 $('#POnewsletterImageMobile_TP').show();
             }
             else {
            	 $('#POnewsletterImage_TP').show();
             }

            window.scrollTo(0,0);
            if (isPersol || isVogue) {
                window.setTimeout(function(){
                    window.location.href = WCParamJS.homePageURL + ($('#redirectSunglasses').length > 0 && $('#redirectSunglasses').attr('value') != undefined && $('#redirectSunglasses').attr('value') != '' ? $('#redirectSunglasses').attr('value') : '');
                }, 3200);
            }
        } else if(this.formId == "newsLetterForm_emailme"){ //#EMAIL_ME#
            $('#mce-error-response_emailme').show();
            $('#mce-error-response_emailme').children().hide();
            $('#mce-success-response_emailme').show();
            $('#mce-error-response-duplicate_emailme').hide();//#EMAIL_ME#
        } else {
            $('#newsletterSignUpResultPopup .message-success').show();
            $('#newsletterSignUpResultPopup').fadeIn("fast");
        }

        /* START Early Access */
        if (isPersol || isVogue) { 
            if ($("#boxCheckout").length == 0){
                assignCustomerSegment();
                if (this.formId == "newsLetterForm"){
                    if (window.customerSegment != undefined && document.cookie.includes("X_WC_PR_SEGMENTS")){
                        var queryString = window.location.search;
                        var urlParams = new URLSearchParams(queryString);
                        if (!urlParams.has('promo')) {
                            if (location.href.indexOf("?") === -1){
                                window.setTimeout(function(){
                                    window.location = location.href += "?promo=" + window.customerSegment;
                                }, 2000);
                            } else {
                                window.setTimeout(function(){
                                    window.location = location.href += "&promo=" + window.customerSegment;
                                }, 2000);
                            }
                        }   
                    }
                }
            }
        }
        /* END Early Access */
    }		
},
 
/**
 * This service calls JoinNewsletterCmd to make a subscription to newsLetter
 */
wcService.declare({
	id: "JoinNewsletterService",
	actionId: "JoinNewsletterService",
	url: "JoinNewsletterService",
	formId: "",

	successHandler: function(serviceResponse) {
		localStorage.setItem('chekoutUserOptin',serviceResponse.userOptin);
		if(serviceResponse.responseMessage == 'duplicate'){
		    NewsLetterJS.handleJoinNewsletterDuplicate();
		}else if(serviceResponse.responseMessage == 'success'){
		    if(typeof utag_data !== 'undefined')
               utag_data.User_EmailOptin = serviceResponse.userOptin;
		    if(pageType!=='Delivery'){
		    	tealiumPushUserOptin(serviceResponse.userOptin,serviceResponse.email);
		    }
			NewsLetterJS.handleJoinNewsletterSuccess();
            if(isVogue){
                setCookieNlEvent();
            }
		}
		cursor_clear();
		
	},

	failureHandler: function(serviceResponse) {
	    NewsLetterJS.handleJoinNewsletterError();
	    cursor_clear();
	}
});

//  Display/undisplay Landing Page fields
function toggleLandingPageFields() {
    var landingForm = $("form[name='newsLetterFormPromoLandingPage'],form[name='newsLetterFormLandingPage']");
    if (landingForm.length > 0) {
        var formId = landingForm.attr('id')
        toggleSubscriptionForms("X_SignInForms_Info");
        if (typeof subscriptionFormsJSONData != 'undefined'){
        for (var key in subscriptionFormsJSONData) {
            var dataValue = subscriptionFormsJSONData[key];
            switch(dataValue) {
                case 'disabled','false': {
                    $("#"+formId+" #"+key+" input,#"+formId+" #"+key+" select").attr("disabled","disabled");
                    $("#"+formId+" #"+key).hide();
                    if (key == 'newsletterBirthdayForm') {
                        $('#newsletter_age-disclaimer').hide();
                    }
                    break;
                }
                case 'optional' : {
                    $("#"+formId+" #"+key+" input,#"+formId+" #"+key+" select").attr("optional","optional");
                    break;
                }
                default:{}
            }
        }
      }
    }
}

function toggleSubscriptionForms(espotName){

    var espotServiceUrl = WCParamJS.urlPrefixForHTTPS + "/wcs/resources/store/" + WCParamJS.storeId + "/espot/" + espotName+"?"+Date.now();
  
    $.ajax({
      type: "GET", 
      dataType: 'json', 
      url: espotServiceUrl,
      async: false,
      contentType: "application/json",
      success: function (data) {
        //console.log(data);
        if (data.MarketingSpotData[0].baseMarketingSpotActivityData != undefined) {
          window.subscriptionFormsJSONData = JSON.parse(data.MarketingSpotData[0].baseMarketingSpotActivityData[0].marketingContentDescription[0].marketingText);
        }
      },
      error: function(data){
        console.log("Error retrieving newsletter subscription forms info");
      }
    });
}

function needsValidation(inputElement) {
    var needValidation = true;

    if(inputElement.attr('disabled'))
        needValidation = false;

    if(inputElement.attr('optional'))
        needValidation = false;

    return needValidation;
}
//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2007, 2015 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/**
 * @fileOverview This javascript is used by UserRegistrationAddForm.jsp and CheckoutLogon.jsp.
 * @version 1.0
 */

/**
 *  The functions defined in the class helps the customer to register with the store. Another function enables a returning
 *  customer to Sign in for quickcheckout from the shopping cart page.
 *
 *  @class This LogonForm class defines all the functions and variables used to validate the information provided by the
 *  customer to register with the store.To register, a customer creates a logon ID and password. Then, the customer provides their first name,
 *  last name, street address, city, country/region, state/province, ZIP/postal code, e-mail address and phone number. Other registration options
 *  include promotional e-mails, preferred language and currency, age, gender, and the remember me option.
 */
LogonForm ={

    /**
     * This function validates the logon ID and password for returning customers to sign in and complete the checkout process.
     * @param {string} form The name of the form containing logon ID and password fields.
     */
    SubmitAjaxLogin:function(form){

        if(!this.validateAjaxLogin(form)){
            return;
        };
        setDeleteCartCookie();

        form.submit();

    },

    validateAjaxLogin:function(form){
        reWhiteSpace = new RegExp(/^\s+$/);

        if(form.logonId != null && reWhiteSpace.test(form.logonId.value) || form.logonId.value == ""){
            MessageHelper.formErrorHandleClient(form.logonId.id,MessageHelper.messages["LOGON_REQUIRED_FIELD_ENTER"]); return false;}

        if(form.logonPassword != null && reWhiteSpace.test(form.logonPassword.value) || form.logonPassword.value == ""){
            MessageHelper.formErrorHandleClient(form.logonPassword.id,MessageHelper.messages["PASSWORD_REQUIRED_FIELD_ENTER"]); return false;}

        return true;
    },

    /**
     * This function is called when the Submit button is clicked on the Registration page. 
     * Ensures that the newsletter check exists and perform the submit.
     * 
     * @param {string} form The name of the registration form containing all the customer information.
     */
    performRegistration:function(form){

        //HB-2946 - All registration an newsletter should be performed on lower case
        form.elements.email1.value = form.elements.email1.value.toLowerCase();

        var newsletterCheck = $("#gdpr-checkbox-newsletter").is(":checked");
        if(isPersol){
        	var profiling = $("#gdpr-checkbox-personal").is(":checked");
        }else{
        	var profiling = $("#gdpr-checkbox-profiling").is(":checked");
        }
        
        
        
        var emailRegistration = form.elements.email1.value;
        var fName = form.elements.firstName.value;
        var lName = form.elements.lastName.value;

        //Validate just in case that isChecked the newsletter only for Persol or is a non GDPR store
        if (typeof isGDPR !== 'undefined' && (!isGDPR && !isPersol) || newsletterCheck || profiling) {
            wcService.declare({
                id: "JoinNewsletterServiceRegistration",
                actionId: "JoinNewsletterService",
                url: "JoinNewsletterService",
                formId: ""
            
                ,successHandler: function(serviceResponse) {
                    form.submit();
                    localStorage.setItem('chekoutUserOptin',serviceResponse.userOptin);
                    /* START Early Access */
                    if (isPersol || isVogue) assignCustomerSegment();
                    /* END Early Access */
                    cursor_clear();
                }
                ,failureHandler: function(serviceResponse) {
                    form.submit();
                    cursor_clear();
                }
            
            });
            var cidCookie = null;
            
            if(document.cookie.includes('X_WC_CID')){
            	cidCookie = $.cookie("X_WC_CID");
            }
            
            var params = {
                    storeId: WCParamJS.storeId,
                    langId : WCParamJS.langId,
                    email: emailRegistration,
                    firstName: fName,
                    lastName: lName,
                    profiling: profiling,
                    subscription: newsletterCheck,
                    isFormRegistration:true,  
                    cid: cidCookie
                }
            cursor_wait();
            wcService.invoke("JoinNewsletterServiceRegistration", params);

        } else {
            /* START Early Access */
            if (isPersol || isVogue) assignCustomerSegment();
            /* END Early Access */
            form.submit();
        }
        
    },
    /**
     * This function is called when the Submit button is clicked on the Registration page. All the fields containing customer
     * information are validated and PersonProcessServicePersonRegistration is called.
     * @param {string} form The name of the registration form containing all the customer information.
     */
    prepareSubmit:function (form) {
        //cursor_clear();
        if(CSRWCParamJS.env_shopOnBehalfSessionEstablished == 'true' || CSRWCParamJS.env_shopOnBehalfEnabled_CSR == 'true') {
            var random = Math.random();
            var randomPassword = random.toString(36).slice(-7); // Get last 7 chars. Will add one numeric char to make it 8 char long...
            var randomInt = Math.floor((random * 9) + 1);
            randomPassword += randomInt; //Password should contain atleast one numeric character...
            if ($("#logonPassword").val() == null || $("#logonPassword").val() == "") {
                $('<input>').attr({
                    type: 'hidden',
                    value: randomPassword,
                    name: "logonPassword",
                    id: "logonPassword",
                }).appendTo('form');
            }

            if ($("#logonPasswordVerify").val() == null || $("#logonPasswordVerify").val() == "") {
                $('<input>').attr({
                    type: 'hidden',
                    value: randomPassword,
                    name: "logonPasswordVerify",
                    id: "logonPasswordVerify"
                }).appendTo('form');
            }

            if ($("#passwordExpired").val() == null || $("#passwordExpired").val() == "") {
                $("#passwordExpired").val("1");
            }
        }

        if (!this.validatePrepareForm(form)) {
            moveToError();
            console.log("There is something wrong with in register form");
            restoreAjaxButtons();
             /* TEALIUM BEGIN Logon fail */
            if(typeof tealium_data2track !== 'undefined'){
            	var message =  $('.password-policies-title-error').text();
	             var trackData = {};
	             trackData['id'] = "Event";
                 trackData['Events_Error'] = "1";
	             trackData['Error_Code'] = 'Form Filling Error';
	             trackData['Error_Source'] = "User";
	             trackData['Error_Message'] = this.tealiumValidateError;
	             trackData['Error_Details'] = this.tealiumValidateError;
	             tealium_data2track.push(trackData);
            }
            /* TEALIUM END */
            console.log("TEALIUM::Create user fail.");
            
            return;
        }

        setCookie("WC_SHOW_USER_ACTIVATION_" + WCParamJS.storeId, "true", {path:'/', domain:cookieDomain});
        if(CSRWCParamJS.env_shopOnBehalfEnabled_CSR == 'true' ||
                (CSRWCParamJS.env_shopOnBehalfSessionEstablished == 'true' &&  form.userId != null && form.userId.value != null)){
            // CSR is creating the user OR
            // OnBehalf session is started and CSR is registering existing guestUser.
            // Uses UserRegistrationAdminAddCmd
            if(registeredCustomersJS != null) {
                registeredCustomersJS.createRegisteredUser(form.landingURL_CSR.value);
            }
        } else {
            this.performRegistration(form);
        }
    },

    /**
     * The function is called to validate and prepare the form.
     * @param {string} form The name of the registration form containing all the customer information.
     * @return (Boolean) true if the form is ready to submit, false otherwise.
     */
    validatePrepareForm: function(form) {
        var isValid = true;
        reWhiteSpace = new RegExp(/^\s+$/);
        if (form.logonId != null && reWhiteSpace.test(form.logonId.value) || form.logonId.value == "") {
            this.manageMultipleErrorFields(form.logonId,MessageHelper.messages["ERROR_LogonIdEmpty"], false);
            isValid = false;
        } else if (!AddressHelper.validateEmail(form.logonId)) {
            this.manageMultipleErrorFields(form.logonId,MessageHelper.messages["ERROR_INVALIDEMAILFORMAT"], false);
            isValid = false;
        } else if (typeof this.validateLoginId == "function") {
            if (!this.validateLoginId(form.logonId)) {
                isValid = false;
            }
        } else {
            this.manageMultipleErrorFields(form.logonId, "", true);
        }

        $('#emailError').css('display', 'none');

        if (form.ancestorOrgs != null) {
            if (form.ancestorOrgs.value == "") {
            	validateError = MessageHelper.messages["ERROR_OrgNameEmpty"];
                this.manageMultipleErrorFields(form.ancestorOrgs,MessageHelper.messages["ERROR_OrgNameEmpty"], false);
                this.tealiumValidateError = validateError;
                isValid = false;
            } else if (form.ancestorOrgs.value == "Default Organization") {
            	validateError = MessageHelper.messages["ERROR_DefaultOrgRegistration"];
                this.manageMultipleErrorFields(form.ancestorOrgs,MessageHelper.messages["ERROR_DefaultOrgRegistration"], false);
                this.tealiumValidateError = validateError;
                isValid = false;
            }
        }

        if (form.logonPassword != null && reWhiteSpace.test(form.logonPassword.value) || form.logonPassword.value == "") {
	        validateError = MessageHelper.messages["ERROR_PasswordEmpty"];
            this.manageMultipleErrorFields(form.logonPassword,MessageHelper.messages["ERROR_PasswordEmpty"], false);
            this.tealiumValidateError = validateError;
            isValid = false;
        } else {
            this.manageMultipleErrorFields(form.logonPassword, "", true);
        }

        if (form.logonPasswordVerify != null && reWhiteSpace.test(form.logonPasswordVerify.value) || form.logonPasswordVerify.value == "") {
	        validateError = MessageHelper.messages["ERROR_VerifyPasswordEmpty"];
            this.manageMultipleErrorFields(form.logonPasswordVerify,MessageHelper.messages["ERROR_VerifyPasswordEmpty"], false);
            this.tealiumValidateError = validateError;
            isValid = false;
        } else {
            this.manageMultipleErrorFields(form.logonPasswordVerify, "", true);
        }

        if (form.logonPassword.value != form.logonPasswordVerify.value) {
	        validateError = MessageHelper.messages["PWDREENTER_DO_NOT_MATCH"];
            this.manageMultipleErrorFields(form.logonPasswordVerify,MessageHelper.messages["PWDREENTER_DO_NOT_MATCH"], false);
            this.tealiumValidateError = validateError;
            isValid = false;
        } else if (!(reWhiteSpace.test(form.logonPasswordVerify.value) || form.logonPasswordVerify.value == "")) {
            this.manageMultipleErrorFields(form.logonPasswordVerify, "", true);
        }

        if(!checkPasswordStrenght(form.logonPassword)) {
            $('.password-policies-title').addClass('hidden');
            $('.password-policies-title-error').removeClass('hidden');
            $('.input-style--password').addClass('error');
            this.tealiumValidateError =  $('.password-policies-title-error').text();
            isValid = false;
            var trackData = {};
            trackData['id'] = "Error"
            trackData['Error_Code'] = 'Form Filling Error' ;
            trackData['Error_Source'] = "User";
            trackData['Error_Message'] = this.tealiumValidateError;
            trackData['Error_Details'] = this.tealiumValidateError;
            pushDataToTealium(trackData);
        }
        else {
            $('.password-policies-title').removeClass('hidden');
            $('.password-policies-title-error').addClass('hidden');
            $('.input-style--password').removeClass('error');
            this.tealiumValidateError =  $('.password-policies-title-error').text();
        }
        

        /** Uses the common validation function defined in AddressHelper class for validating first name,
         *  last name, street address, city, country/region, state/province, ZIP/postal code, e-mail address and phone number.
         */
        if (!AddressHelper.validateAddressForm(form)) {
            isValid = false;
        }

        /* Checks whether the customer has registered for promotional e-mails. */
        if (form.sendMeEmail && form.sendMeEmail.checked) {
            form.receiveEmail.value = true;
        } else if (form["gdpr-checkbox-newsletter"] && form["gdpr-checkbox-newsletter"].checked) {
            form.receiveEmail.value = true;
        } else {
            form.receiveEmail.value = false;
        }

        if (form.sendMeSMSNotification &&  form.sendMeSMSNotification.checked) {
            form.receiveSMSNotification.value = true;
        } else {
            form.receiveSMSNotification.value = false;
        }

        if (form.sendMeSMSPreference && form.sendMeSMSPreference.checked) {
            form.receiveSMS.value = true;
        } else {
            form.receiveSMS.value = false;
        }

        if (form.mobileDeviceEnabled != null && form.mobileDeviceEnabled.value == "true") {
            if (!MyAccountDisplay.validateMobileDevice(form)) {
                isValid = false;
            }
        }
        if (form.birthdayEnabled != null && form.birthdayEnabled.value == "true") {
            if (!MyAccountDisplay.validateBirthday(form)) {
                isValid =  false;
            }
        }
        return isValid;
    },
    
    /**
     * Manage multiple address form error messages for each concerned field.
    */
    manageMultipleErrorFields: function (field, errorMsg, isNotEmpty) {
        var mandatoryErrorFieldId = 'mandatoryField_' + field.id;
        // var mandatoryErrorFieldId = 'mandatoryField_' + field.id;

        // Deletes the error message if the field is not empty anymore.
        if (isNotEmpty) {
            var currentField = document.getElementById(mandatoryErrorFieldId);
            if (currentField != null) {
                $(field).removeClass("field-error-message");
                currentField.remove();
            }
        } else {
            if (!document.getElementById(mandatoryErrorFieldId)) {
                var mandatoryField = this.getMandatoryField(field.id, errorMsg, isNotEmpty);
                if (field != null && field.parentNode != null) {
                    $(field).addClass("field-error-message");
                    // if (field.name != undefined && field.name.indexOf('logonPassword') >= 0) {
                    //     field.after(mandatoryField);
                    // } else {
                    //     field.parentNode.appendChild(mandatoryField);
                    // }
                    if(isVogue && field.name == 'logonPassword') {
                        field.insertAdjacentElement('afterend', mandatoryField);
                    } else {
                        field.parentNode.insertAdjacentElement('beforeend', mandatoryField);
                    }
                }
            }
        }
    },
   
   /**
    * mandatory field shown when one or multiple empty fields in forms
    */
   getMandatoryField: function (parentID, errorMsg, isNotEmpty) {
       //showing specific message per field
       if (typeof errorMsg === 'undefined' || errorMsg == null || errorMsg == "") {
           errorMsg = MessageHelper.messages["ADDR_MANDATORY_FIELD"];
       }

       var mandatoryField = document.createElement('div');
       mandatoryField.setAttribute("class", "address-erros-message-cont");
       mandatoryField.innerHTML = '<span tabindex="0" id="mandatoryField_' + parentID + '" class="error-message wcag__error">' + errorMsg + '</span>';
/* <div class="address-erros-message-cont"><span id="mandatoryField_+ parentID" +  class="error-message"> errorMsg </span></div> */
       return mandatoryField;
   }
}

//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2008, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/**
 * @fileOverview This class contains declarations of AJAX services used by the Madisons store pages.
 */

/**
 * @class This class stores common parameters needed to make the service call.
 */
ServicesDeclarationJS = {
    langId: "-1", /* language of the  store */
    storeId: "", /*numeric unique identifier of the store */
    catalogId: "", /*catalog of the store that is currently in use */

    /**
     * Sets common parameters used by the services
     * @param (int) langId The language of the store.
     * @param (int) storeId The store currently in use.
     * @param (int) catalogId The catalog of the store currently in use.
     */
    setCommonParameters:function(langId,storeId,catalogId){
            this.langId = langId;
            this.storeId = storeId;
            this.catalogId = catalogId;
    }
}

function nullCartTotalCookie(orderId){
    setCookie("WC_CartTotal_"+orderId, null, {expires: -1, path:'/', domain:cookieDomain});

    var cookies = document.cookie.split(";");
    for (var i = 0; i < cookies.length; i++) {
        var index = cookies[i].indexOf("=");
        var name = cookies[i].substr(0,index);
        var value = cookies[i].substr(index+1)
        name = name.replace(/^\s+|\s+$/g,"");
        value = value.replace(/^\s+|\s+$/g,"");
        if (value == orderId) {
            setCookie(name, null, {expires: -1, path:'/', domain:cookieDomain});
            break;
        }
    }
}

    /**
    * Adds an item to to the wishlist and remove the same item from the shopping
    * cart.
    * @constructor
     */
    wcService.declare({
        id: "AjaxInterestItemAddAndDeleteFromCart",
        actionId: "AjaxInterestItemAddAndDeleteFromCart",
        url: getAbsoluteURL() + "AjaxInterestItemAdd",
        formId: ""

     /**
     * display a success message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            //Now delete from cart..
            MessageHelper.hideAndClearMessage();
            resetRequest();
            CheckoutHelperJS.deleteFromCart(serviceResponse.orderItemId,true);
            MessageHelper.displayStatusMessage(MessageHelper.messages["WISHLIST_ADDED"]);
        }

     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

    /**
     * Add an item to a shopping cart in Ajax mode. A message is displayed after
     * the service call.
     * @constructor
     */
    wcService.declare({
        id: "AjaxAddOrderItem",
        actionId: "AjaxAddOrderItem",
        url: getAbsoluteURL() + "AjaxRESTOrderItemAdd",
        formId: ""

     /**
     * display a success message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */

        ,successHandler: function(serviceResponse) {
            MessageHelper.hideAndClearMessage();
            MessageHelper.displayStatusMessage(MessageHelper.messages["SHOPCART_ADDED"]);
            cursor_clear();
            if(categoryDisplayJS){

                var attributes = document.getElementsByName("attrValue");

                var singleSKU = true;

                for(var i=0; i<attributes.length; i++){
                    if (attributes[i].options.length > 1)
                    {
                        singleSKU = false;
                    }
                }

                if (!singleSKU)
                {
                    categoryDisplayJS.selectedAttributes = [];
                    for(var i=0; i<attributes.length; i++){
                        if(attributes[i] != null){
                            attributes[i].value = "";
                        }
                    }
                }
            }
            if(typeof(ShipmodeSelectionExtJS)!= null && typeof(ShipmodeSelectionExtJS)!='undefined'){
                ShipmodeSelectionExtJS.setOrderItemId((serviceResponse.orderItem != null && serviceResponse.orderItem[0].orderItemId != null) ? serviceResponse.orderItem[0].orderItemId : serviceResponse.orderItemId);
            }
        }
     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                if(serviceResponse.errorMessageKey == "_ERR_NO_ELIGIBLE_TRADING"){
                    MessageHelper.displayErrorMessage(MessageHelper.messages["ERROR_CONTRACT_EXPIRED_GOTO_ORDER"]);
                } else if (serviceResponse.errorMessageKey == "_ERR_RETRIEVE_PRICE") {
                    MessageHelper.displayErrorMessage(MessageHelper.messages["ERROR_RETRIEVE_PRICE"]);
                } else {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                }
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

   /**
   * Add an item to a shopping cart in non-Ajax mode. Upon a successful request,
   * the shopping cart page is loaded. An error message is displayed otherwise.
   * @constructor
   */
    wcService.declare({
        id: "AjaxAddOrderItem_shopCart",
        actionId: "AjaxAddOrderItem",
        url: getAbsoluteURL() + "AjaxOrderChangeServiceItemAdd",
        formId: ""

     /**
     * redirects to the shopping cart page
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            //Now delete from cart..
            document.location.href =  appendWcCommonRequestParameters("AjaxOrderItemDisplayView?storeId=" + ServicesDeclarationJS.storeId + "&catalogId=" + ServicesDeclarationJS.catalogId + "&langId=" + ServicesDeclarationJS.langId);
        }
     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                if(serviceResponse.errorMessageKey == "_ERR_NO_ELIGIBLE_TRADING"){
                    MessageHelper.displayErrorMessage(MessageHelper.messages["ERROR_CONTRACT_EXPIRED_GOTO_ORDER"]);
                } else if (serviceResponse.errorMessageKey == "_ERR_RETRIEVE_PRICE") {
                    MessageHelper.displayErrorMessage(MessageHelper.messages["ERROR_RETRIEVE_PRICE"]);
                } else {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                }
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

    /**
     * Remove an item from shopping cart. A message is displayed after the service
     * call.
     * @constructor
     */
    wcService.declare({
        id: "AjaxDeleteOrderItem",
        actionId: "AjaxDeleteOrderItem",
        url: getAbsoluteURL() + "AjaxCustomRESTOrderItemDelete",
        formId: ""
    /**
     * display a success message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse, params) {
            MessageHelper.hideAndClearMessage();
            if (typeof addCheckoutLoader === 'function') {
                addCheckoutLoader();
            }
            MessageHelper.displayStatusMessage(MessageHelper.messages["SHOPCART_REMOVEITEM"],null);
            /* HB-1050 :: workaround */
            if (!$("#page").hasClass("pdp")) {
            	setTimeout(function() { location.reload(); }, ($("#page.shopping-bag-page").length == 1 ? 2500 : 500));
            }
            if (typeof addToCartInput !== "undefined") {
                fn_ext_genericAddToCart(addToCartInput.frameObject, addToCartInput.lensObject, addToCartInput.warrantyObject, addToCartInput.reviewObject, addToCartInput.imagery, addToCartInput.merchandisingAssociations);
            }
        }
     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            if(serviceResponse.errorCode){
                wcTopic.publish("OrderError",serviceResponse);
            }
            cursor_clear();
        }

    }),


    /**
     * Removes an item from shopping cart on the shipping & billing page. A message is displayed after the service call.
     * @constructor
     */
    wcService.declare({
        id: "AjaxDeleteOrderItemForShippingBillingPage",
        actionId: "AjaxDeleteOrderItemForShippingBillingPage",
        url: getAbsoluteURL() + "AjaxRESTOrderItemDelete",
        formId: ""

        /**
         * display a success message
         * @param (object) serviceResponse The service response object, which is the
         * JSON object returned by the service invocation
         */
        ,successHandler: function(serviceResponse) {
            MessageHelper.hideAndClearMessage();
            addCheckoutLoader();
            MessageHelper.displayStatusMessage(MessageHelper.messages["SHOPCART_REMOVEITEM"],null);
        }

        /**
         * display an error message
         * @param (object) serviceResponse The service response object, which is the
         * JSON object returned by the service invocation
         */
        ,failureHandler: function(serviceResponse) {
            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }
    }),


    /**
     * Remove an item from shopping cart. A message is only displayed if the service
     * call returns an error Message. It is used to remove an item from the shopping
     * cart and add the same item to the wish list.
     * @constructor
     */
    wcService.declare({
        id: "AjaxDeleteOrderItemFromCart",
        actionId: "AjaxDeleteOrderItem",
        url: getAbsoluteURL() + "AjaxRESTOrderItemDelete",
        formId: ""
     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }


    }),

    /**
     * Remove an item from shopping cart.
     * Upon a successful request, this function will load the AjaxOrderItemDisplayView page or the OrderShippingBillingView page depending on what page the service was invoked from.
     * An error message will be displayed otherwise.
     * @constructor
     */
    wcService.declare({
        id: "AjaxDeleteOrderItem1",
        actionId: "AjaxDeleteOrderItem",
        url: getAbsoluteURL() + "AjaxRESTOrderItemDelete",
        formId: ""

    /**
     *redirect to the Shopping Cart Page
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            MessageHelper.hideAndClearMessage();
            addCheckoutLoader();
            MessageHelper.displayStatusMessage(MessageHelper.messages["SHOPCART_REMOVEITEM"],null);
            if (!CheckoutHelperJS.pendingOrderDetailsPage)
            {
                setDeleteCartCookie();
                if(CheckoutHelperJS.shoppingCartPage){

                    document.location.href = appendWcCommonRequestParameters("AjaxOrderItemDisplayView?storeId=" + ServicesDeclarationJS.storeId + "&catalogId=" + ServicesDeclarationJS.catalogId + "&langId=" + ServicesDeclarationJS.langId);
                }else{
                    document.location.href = appendWcCommonRequestParameters("OrderShippingBillingView?storeId=" + ServicesDeclarationJS.storeId + "&catalogId=" + ServicesDeclarationJS.catalogId + "&langId=" + ServicesDeclarationJS.langId + "&orderId=" + serviceResponse.orderId);
                }
            }
            else
            {
                cursor_clear();
            }
        }

    /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),


    /**
     * This service updates an order item in the shopping cart.
     * A message is displayed after the service call.
     * @constructor
     */
    wcService.declare({
        id: "AjaxUpdateOrderItem",
        actionId: "AjaxUpdateOrderItem",
        url: getAbsoluteURL() + "AjaxRESTOrderItemUpdate",
        formId: ""

    /**
     * hides all the messages and the progress bar
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            MessageHelper.hideAndClearMessage();
            MessageHelper.hideFormErrorHandle();
            cursor_clear();
        }

    /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                if (serviceResponse.errorMessageKey == "_ERR_RETRIEVE_PRICE") {
                    MessageHelper.displayErrorMessage(MessageHelper.messages["ERROR_RETRIEVE_PRICE_QTY_UPDATE"]);
                }
                else{
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                }
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            if(serviceResponse.errorCode){
                wcTopic.publish("OrderError",serviceResponse);
            }
            cursor_clear();
        }

    }),

    /**
     * Updates an order item in the shopping cart.
     * Upon a successful request, this function will load the AjaxOrderItemDisplayView page
     * An error message will be displayed otherwise.
     * @constructor
     */
    wcService.declare({
        id: "AjaxUpdateOrderItem1",
        actionId: "AjaxUpdateOrderItem",
        url: getAbsoluteURL() + "AjaxRESTOrderItemUpdate",
        formId: ""
    /**
     *redirect to the Shopping Cart Page
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            if (!CheckoutHelperJS.pendingOrderDetailsPage)
            {
                if(CheckoutHelperJS.shoppingCartPage){
                    document.location.href = appendWcCommonRequestParameters("AjaxOrderItemDisplayView?storeId=" + ServicesDeclarationJS.storeId + "&catalogId=" + ServicesDeclarationJS.catalogId + "&langId=" + ServicesDeclarationJS.langId);
                }
            }
            else
            {
                cursor_clear();
            }
        }

    /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                if (serviceResponse.errorMessageKey == "_ERR_RETRIEVE_PRICE") {
                    MessageHelper.displayErrorMessage(MessageHelper.messages["ERROR_RETRIEVE_PRICE_QTY_UPDATE"]);
                }
                else{
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                }
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

    /**
     * This service updates shipping information (shipping mode, shipping address)
     * for a shopping cart. A message is displayed after the service call.
     * @constructor
     */
    wcService.declare({
        id: "AjaxUpdateOrderShippingInfo",
        actionId: "AjaxUpdateOrderShippingInfo",
        url: getAbsoluteURL() + "AjaxRESTOrderShipInfoUpdate",
        formId: ""
    /**
     * hides all the messages and the progress bar
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            MessageHelper.hideAndClearMessage();
            cursor_clear();
        }

     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

    /**
     * This service prepares an order for submission. Upon success, it submits the order.
     * @constructor
     */
    wcService.declare({
        id: "AjaxPrepareOrderForSubmit",
        actionId: "AjaxPrepareOrderForSubmit",
        url: getAbsoluteURL() + "AjaxRESTOrderPrepare",
        formId: ""

    /**
     * On success, checkout the order by calling order submit.
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            CheckoutHelperJS.setOrderPrepared("true");
            CheckoutHelperJS.checkoutOrder(CheckoutHelperJS.getSavedParameter('tempOrderId'),CheckoutHelperJS.getSavedParameter('tempUserType'),CheckoutHelperJS.getSavedParameter('tempEmailAddresses'),CheckoutHelperJS.getSavedParameter('tempIsQuote'));
        }

    /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),


    /**
     * This service submits the order. Upon success, the order billing confirmation
     * page is shown. A error message is displayed otherwise.
     * @constructor
     */
    wcService.declare({
        id: "AjaxSubmitOrder",
        actionId: "AjaxSubmitOrder",
        url: getAbsoluteURL() + "AjaxRESTOrderSubmit",
        formId: ""

    /**
     *redirect to the Order Confirmation page
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            nullCartTotalCookie(serviceResponse.orderId);
            /* START - Online Return Form */
            if (typeof goToOnlineReturnTYP == 'function') {
                goToOnlineReturnTYP();
            } else {
                var shipmentTypeId = CheckoutHelperJS.getShipmentTypeId();
                document.location.href = appendWcCommonRequestParameters("OrderShippingBillingConfirmationView?storeId=" + ServicesDeclarationJS.storeId + "&catalogId=" + ServicesDeclarationJS.catalogId + "&langId=" + ServicesDeclarationJS.langId + "&orderId=" + serviceResponse.orderId + "&shipmentTypeId=" + shipmentTypeId);
            }
            /* END - Online Return Form */
        }

    /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     *
     * In case of failure, the next error messages will not be sent to Tealium: See paymentResponseCodesNotToSendToTealium set in CommonUtilities.js
     *
     */
        ,failureHandler: function(serviceResponse) {
            //NERD-727: Start the authentication session in case the card is enrolled in pyaer authentications.
            if (serviceResponse.errorMessageKey == "PLUGIN_RC_475" && $("#JWT").length > 0) {
                var url = "/wcs/resources/store/" + ServicesDeclarationJS.storeId + "/cart/@self/payment_instruction";
                createPaymentLoaderOverlay() //creates a dark overlay with a spinner;

                $.ajax({
                    url: url,
                    type: 'GET',
                    cache: false,
                    data: {
                        "timestamp": Date.now()
                    },
                    success: function (data) {
                        if (data != undefined) {
                            var payerAuthEnrollReply_paReq;
                            var payerAuthEnrollReply_acsURL;
                            var payerAuthEnrollReply_authenticationTransactionID;
                            $.each(data.paymentInstruction[0].protocolData, function (index, value) {
                                if (value.name == 'payerAuthEnrollReply_paReq') {
                                    payerAuthEnrollReply_paReq = value.value;
                                } else if (value.name == 'payerAuthEnrollReply_acsURL') {
                                    payerAuthEnrollReply_acsURL = value.value;
                                } else if (value.name == 'payerAuthEnrollReply_authenticationTransactionID') {
                                    payerAuthEnrollReply_authenticationTransactionID = value.value;
                                }
                            });
                            // Start the authentication session.
                            Cardinal.continue('cca',
                            {
                                "AcsUrl": payerAuthEnrollReply_acsURL,
                                "Payload": payerAuthEnrollReply_paReq
                            },
                            {
                                "OrderDetails":{
                                    "TransactionId" : payerAuthEnrollReply_authenticationTransactionID
                                }
                            });
                        }
                    },
                    error: function(data){
                        deletePaymentLoaderOverlay();

                        MessageHelper.displayErrorMessage("There was a problem while retrieving the payment data.");
                        cursor_clear();
                    }
                });
            } else if (serviceResponse.errorMessage) {
                deletePaymentLoaderOverlay();
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);

                sendPaymentErrorMessageToTealium(serviceResponse.errorMessageKey, serviceResponse.errorMessage);
                cursor_clear();
            } else {
                if (serviceResponse.errorMessageKey) {
                    deletePaymentLoaderOverlay();
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);

                    sendPaymentErrorMessageToTealium(serviceResponse.errorMessageKey, serviceResponse.errorMessage);
                }
                cursor_clear();
            }
        }
    }),

    /**
     * This service submits the quote. Upon success, the quote  confirmation
     * page is shown. A error message is displayed otherwise.
     * @constructor
     */
    wcService.declare({
        id: "AjaxSubmitQuote",
        actionId: "AjaxSubmitQuote",
        url: getAbsoluteURL() + "AjaxSubmitQuote",
        formId: ""

   /**
    *redirect to the Quote Confirmation page
    * @param (object) serviceResponse The service response object, which is the
    * JSON object returned by the service invocation
    */
        ,successHandler: function(serviceResponse) {
            var redirectURL = "OrderShippingBillingConfirmationView?storeId=" + ServicesDeclarationJS.storeId
            + "&catalogId=" + ServicesDeclarationJS.catalogId
            + "&langId=" + ServicesDeclarationJS.langId
            + "&orderId=" + CheckoutHelperJS.getOrderId()
            + "&shipmentTypeId=" + CheckoutHelperJS.getShipmentTypeId()
            + "&isQuote=true"
            + "&quoteId=" + serviceResponse.outOrderId// outOrderId is the id of the new quote created.

            if(serviceResponse.outExternalQuoteId != undefined && serviceResponse.outExternalQuoteId != null){
                redirectURL += redirectURL + "&externalQuoteId=" + serviceResponse.outExternalQuoteId;
            }
            document.location.href = appendWcCommonRequestParameters(redirectURL);
        }

   /**
    * display an error message
    * @param (object) serviceResponse The service response object, which is the
    * JSON object returned by the service invocation
    */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

    /**
     * This service adds an address for the person. An error message is displayed
     * if the service failed.
     * @constructor
     */
    wcService.declare({
        id: "AjaxAddAddressForPerson",
        actionId: "AjaxAddAddressForPerson",
        url: getAbsoluteURL() + "AjaxPersonChangeServiceAddressAdd",
        formId: ""

    /**
     * hides all the messages and the progress bar
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            AddressHelper.updateOrderAfterAddressUpdate();
            MessageHelper.hideAndClearMessage();
            cursor_clear();
        }

     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

    /**
     * This service adds an address for the person. An error message is displayed
     * if the service failed.
     * @constructor
     */
    wcService.declare({
        id: "AjaxUpdateAddressForPerson",
        actionId: "AjaxUpdateAddressForPerson",
        url: getAbsoluteURL() + "AjaxPersonChangeServiceAddressUpdate",
        formId: ""

    /**
     * hides all the messages and the progress bar
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            AddressHelper.updateOrderAfterAddressUpdate();
            MessageHelper.hideAndClearMessage();
            cursor_clear();
        }
     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

    /**
     * This service calls AjaxRESTOrderItemUpdate to update order total after shipping address is updated in the order.
     */
    wcService.declare({
        id: "AjaxUpdateOrderAfterAddressUpdate",
        actionId: "AjaxUpdateOrderAfterAddressUpdate",
        url: getAbsoluteURL() + "AjaxRESTOrderItemUpdate",
        formId: ""

    /**
     * hides all the messages and the progress bar
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            MessageHelper.hideAndClearMessage();
            cursor_clear();
        }

    /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

    /**
     * This service adds an item to the wishlist. This is different from
     * AjaxInterestItemAddAndDeleteFromCart in that this function does not remove
     * the item from the shopping cart. It is used mainly in catalog browsing.
     * @constructor
     */
    wcService.declare({
        id: "AjaxInterestItemAdd",
        actionId: "AjaxInterestItemAdd",
        url: getAbsoluteURL() + "AjaxInterestItemAdd",
        formId: ""
    /**
     * hides all the messages and the progress bar
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            MessageHelper.hideAndClearMessage();
            cursor_clear();
            MessageHelper.displayStatusMessage(MessageHelper.messages["WISHLIST_ADDED"]);
            if(categoryDisplayJS)
            categoryDisplayJS.selectedAttributes = [];
        }
     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

    /**
     * This service adds an item to the wishlist in non-Ajax mode. Upon success,
     * the shopping cart page is displayed. This is different from
     * AjaxInterestItemAddAndDeleteFromCart in that this function does not remove
     * the item from the shopping cart. It is used mainly in catalog browsing.
     * @constructor
     */
    wcService.declare({
        id: "AjaxInterestItemAdd_shopCart",
        actionId: "AjaxInterestItemAdd",
        url: getAbsoluteURL() + "AjaxInterestItemAdd",
        formId: ""

    /**
     * hides all the messages and the progress bar
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            document.location.href = appendWcCommonRequestParameters("AjaxOrderItemDisplayView?storeId=" + ServicesDeclarationJS.storeId + "&catalogId=" + ServicesDeclarationJS.catalogId + "&langId=" + ServicesDeclarationJS.langId);
        }

     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

  /**
   * This service deletes an item from the wish list. An error message will be
   * displayed if the service call failed.
   */
    wcService.declare({
        id: "AjaxInterestItemDelete",
        actionId: "AjaxInterestItemDelete",
        url: getAbsoluteURL() + "AjaxInterestItemDelete",
        formId: ""

    /**
     * hides all the messages and the progress bar
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            MessageHelper.hideAndClearMessage();
        }

     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

    /**
     * This service sends the wish list to a specified email address.
     */
    wcService.declare({
        id: "AjaxInterestItemListMessage",
        actionId: "AjaxInterestItemListMessage",
        url: getAbsoluteURL() + "AjaxInterestItemListMessage",
        formId: ""

    /**
     * hides all the messages and the progress bar
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            MessageHelper.hideAndClearMessage();
        }
     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

    /**
     * This service applies the promotion code to the order(s).
     */
    wcService.declare({
        id: "AjaxPromotionCodeManage",
        actionId: "AjaxPromotionCodeManage",
        url: getAbsoluteURL() + "AjaxRESTPromotionCodeApply",
        formId: ""

    /**
     * hides all the messages and the progress bar
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
        	var obj = {
        			'id' : 'Event',
                    'Events_DiscountApplied' : '1',
        			'Order_DiscountCode':serviceResponse.promoCode,
                    'Order_DiscountName':serviceResponse.promoCode
        	}
        	pushDiscountCode(obj);
            MessageHelper.hideAndClearMessage();

            /*var params = [];

            params.storeId		= ServicesDeclarationJS.storeId;
            params.catalogId	= ServicesDeclarationJS.catalogId;
            params.langId		= ServicesDeclarationJS.langId;
            params.orderItemId 	= "";
            params.orderId = serviceResponse.orderId;
            if(CheckoutHelperJS.shoppingCartPage){
                params.calculationUsage = "-1,-2,-5,-6,-7";
            }else{
                params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
            }
            params.calculateOrder = "1";
            wcService.invoke("AjaxUpdateOrderItem",params);*/
            
            /* CHECKOUT 3.0 - mustache obj for checkout summary for OP with promotion form update */
            ajaxCallCart(true);
            /* CHECKOUT 3.0 - mustache obj for checkout summary for OP with promotion form update */

        }

     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse){
            if (serviceResponse.errorMessage){
                $("#promoCode").addClass("error");
                addErrorMessageToElement(document.forms.PromotionCodeForm, serviceResponse.errorMessage);
                var obj = {
                		'id' : 'Event',
                        'Events_DiscountTentative' : '1', 
                		'Error_Source' : 'User', 
                		'Error_Code' : 'PromoCode -'+ serviceResponse.errorMessage,
                		'Order_DiscountCode':serviceResponse.errorMessageParam[0],
                        'Order_DiscountName': "",
                        'Error_Message' : 'PromoCode -'+ serviceResponse.errorMessage
                }
                pushDiscountCode(obj);
                restoreAjaxButton("WC_PromotionCodeDisplay_links_1");
            } else if (serviceResponse.errorMessageKey){
                $("#promoCode").addClass("error");
                MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                var obj = {
                		'id' : 'Event',
                        'Events_DiscountTentative' : '1', 
                		'Error_Source' : 'User', 
                		'Error_Code' : 'PromoCode -'+ serviceResponse.errorMessageKey,
                		'Order_DiscountCode':serviceResponse.errorMessageParam[0],
                        'Order_DiscountName': ""
                }
                pushDiscountCode(obj);
            }
            cursor_clear();
        }
    }),

    /**
     * This service applies the promotion code to the order(s).
     */
    wcService.declare({
        id: "AjaxPromotionCodeDelete",
        actionId: "AjaxPromotionCodeManage",
        url: getAbsoluteURL() + "AjaxRESTPromotionCodeRemove",
        formId: ""

    /**
     * hides all the messages and the progress bar
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            MessageHelper.hideAndClearMessage();

            /*var params = [];

            params.storeId		= ServicesDeclarationJS.storeId;
            params.catalogId	= ServicesDeclarationJS.catalogId;
            params.langId		= ServicesDeclarationJS.langId;
            params.orderItemId 	= "";
            params.orderId = serviceResponse.orderId;
            if(CheckoutHelperJS.shoppingCartPage){
                params.calculationUsage = "-1,-2,-5,-6,-7";
            }else{
                params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
            }
            params.calculateOrder = "1";

            wcService.invoke("AjaxUpdateOrderItem",params);*/
            
            /* CHECKOUT 3.0 - mustache obj for checkout summary for OP with promotion form update */
            ajaxCallCart(true);
            /* CHECKOUT 3.0 - mustache obj for checkout summary for OP with promotion form update */

        }

     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

  /**
   * This services adds or removes a coupon from the order(s).
   */
    wcService.declare({
        id: "AjaxCouponsAdd",
        actionId: "AjaxCouponsAddRemove",
        url: getAbsoluteURL() + "AjaxRESTCouponsAdd",
        formId: ""

    /**
     * Hides all the messages and the progress bar. It will then called the
     * AjaxRESTOrderItemUpdate service
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
      */
        ,successHandler: function(serviceResponse) {
            MessageHelper.hideAndClearMessage();

            var params = [];

            params.storeId		= ServicesDeclarationJS.storeId;
            params.catalogId	= ServicesDeclarationJS.catalogId;
            params.langId		= ServicesDeclarationJS.langId;
            params.orderItemId	= "";
            params.orderId = serviceResponse.orderId;
            if(CheckoutHelperJS.shoppingCartPage){
                params.calculationUsage = "-1,-2,-5,-6,-7";
            }else{
                params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
            }
            params.calculateOrder = "1";

            wcService.invoke("AjaxUpdateOrderItem",params);

        }

     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

  /**
   * This services adds or removes a coupon from the order(s).
   */
    wcService.declare({
        id: "AjaxCouponsRemove",
        actionId: "AjaxCouponsAddRemove",
        url: getAbsoluteURL() + "AjaxRESTCouponsRemove",
        formId: ""

    /**
     * Hides all the messages and the progress bar. It will then called the
     * AjaxRESTOrderItemUpdate service
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
      */
        ,successHandler: function(serviceResponse) {
            MessageHelper.hideAndClearMessage();

            var params = [];

            params.storeId		= ServicesDeclarationJS.storeId;
            params.catalogId	= ServicesDeclarationJS.catalogId;
            params.langId		= ServicesDeclarationJS.langId;
            params.orderItemId	= "";
            params.orderId = serviceResponse.orderId;
            if(CheckoutHelperJS.shoppingCartPage){
                params.calculationUsage = "-1,-2,-5,-6,-7";
            }else{
                params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
            }
            params.calculateOrder = "1";

            wcService.invoke("AjaxUpdateOrderItem",params);

        }

     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

    /**
     * This service adds a billing address to the order(s).
     */
    wcService.declare({
        id: "AddBillingAddress",
        actionId: "AddBillingAddress",
        url: getAbsoluteURL() + "AjaxPersonChangeServiceAddressAdd",
        formId: ""

    /**
     * hides all the messages and the progress bar
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            console.log("PSL::ServicesDeclaration.js::AddBillingAddress::successHandler");
            MessageHelper.hideAndClearMessage();
        }

     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {
            console.log("PSL::ServicesDeclaration.js::AddBillingAddress::failureHandler");
            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

/**
 * This service schedules an order based on the input order date and order interval parameters.
 */
wcService.declare({
    id: "ScheduleOrder",
    actionId: "ScheduleOrder",
    url: getAbsoluteURL() + "AjaxRESTScheduleOrder",
    formId: ""

    /**
     * Hides all the messages and the progress bar.
     * Constructs a URL that deletes the current order and forward to the order confirmation page.
     * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation
     */
    ,successHandler: function(serviceResponse) {
        MessageHelper.hideAndClearMessage();
        var originalOrderId = document.getElementById("orderIdToSchedule").value;
        var newOrderId = serviceResponse.orderId;
        nullCartTotalCookie(serviceResponse.orderId);
        var shipmentTypeId = CheckoutHelperJS.getShipmentTypeId();
        var purchaseOrderNumber = "";
        if(document.forms["purchaseOrderNumberInfo"].purchase_order_number.value != null){
            purchaseOrderNumber = document.forms["purchaseOrderNumberInfo"].purchase_order_number.value;
        }
        var url = "RESTOrderCancel?orderId=" + originalOrderId + "&storeId="  + ServicesDeclarationJS.storeId + "&catalogId=" + ServicesDeclarationJS.catalogId + "&langId=" + ServicesDeclarationJS.langId + "&URL=OrderShippingBillingConfirmationView%3ForderId%3D" + newOrderId + "%26originalOrderId%3D" + originalOrderId + "%26shipmentTypeId%3D" + shipmentTypeId + "%26purchaseOrderNumber%3D" + purchaseOrderNumber;
        document.location.href = appendWcCommonRequestParameters(url);
    }

    /**
     * Displays an error message if the the service call failed.
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
    ,failureHandler: function(serviceResponse) {
        if (serviceResponse.errorMessage) {
            MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
        } else {
             if (serviceResponse.errorMessageKey) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
             }
        }
        cursor_clear();
    }
}),

/**
 * This service schedules an order based on the input order date and order interval parameters.
 */
wcService.declare({
    id: "SubmitRecurringOrder",
    actionId: "SubmitRecurringOrder",
    url: getAbsoluteURL() + "AjaxRESTSubmitRecurringOrSubscription",
    formId: ""

    /**
     * Hides all the messages and the progress bar.
     * Constructs a URL that deletes the current order and forward to the order confirmation page.
     * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation
     */
    ,successHandler: function(serviceResponse) {
        MessageHelper.hideAndClearMessage();
        nullCartTotalCookie(serviceResponse.orderId);
        var shipmentTypeId = CheckoutHelperJS.getShipmentTypeId();
        var url = "OrderShippingBillingConfirmationView?storeId=" + ServicesDeclarationJS.storeId + "&catalogId=" + ServicesDeclarationJS.catalogId + "&langId=" + ServicesDeclarationJS.langId + "&orderId=" + serviceResponse.orderId + "&shipmentTypeId=" + shipmentTypeId;
        document.location.href = appendWcCommonRequestParameters(url);
        cursor_clear();
    }

    /**
     * Displays an error message if the the service call failed.
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
    ,failureHandler: function(serviceResponse) {
        if (serviceResponse.errorMessage) {
            MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
        } else {
             if (serviceResponse.errorMessageKey) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
             }
        }
        cursor_clear();
    }
}),

/**
 * This service updates the free gift choices made by the shopper for the
 * promotion.
 */
wcService.declare({
    id: "AjaxUpdateRewardOption",
    actionId: "AjaxUpdateRewardOption",
    url: getAbsoluteURL() + "AjaxRESTOrderRewardOptionUpdate",
    formId: ""

/**
 * Hides all the messages and the progress bar.
 * @param (object) serviceResponse The service response object, which is the
 * JSON object returned by the service invocation
 */
    ,successHandler: function(serviceResponse) {
        MessageHelper.hideAndClearMessage();
        cursor_clear();

    }
 /**
 * Display an error message.
 * @param (object) serviceResponse The service response object, which is the
 * JSON object returned by the service invocation
 */
    ,failureHandler: function(serviceResponse) {

        if (serviceResponse.errorMessage) {
            MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
        }
        else {
             if (serviceResponse.errorMessageKey) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
             }
        }
        cursor_clear();
    }

}),

    /**
     * Create a new saved order.
     * Perform the service or command call.
     */
    wcService.declare({
        id: "AjaxOrderCreate",
        actionId: "AjaxOrderCreate",
        url: getAbsoluteURL() + "AjaxOrderCreate",
        formId: ""

     /**
     * display a success message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            MessageHelper.hideAndClearMessage();
            MessageHelper.displayStatusMessage(MessageHelper.messages["ORDER_CREATED"]);

            cursor_clear();

        }

     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {

                 if (serviceResponse.errorCode == "CMN0409E")
                 {
                     MessageHelper.displayErrorMessage(MessageHelper.messages["ORDER_NOT_CREATED"]);
                 }
                 else
                 {
                     MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                 }
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }
    }),

    /**
     * Cancel a single saved order.
     * Perform the service or command call.
     */
    wcService.declare({
        id: "AjaxSingleOrderCancel",
        actionId: "AjaxSingleOrderCancel",
        url: getAbsoluteURL() + "AjaxRESTOrderCancel",
        formId: ""

     /**
     * display a success message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            MessageHelper.hideAndClearMessage();
            MessageHelper.displayStatusMessage(MessageHelper.messages["ORDERS_CANCELLED"]);
            cursor_clear();
        }

     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                 if (serviceResponse.errorCode == "CMN0409E")
                 {
                     MessageHelper.displayErrorMessage(MessageHelper.messages["ORDER_NOT_CANCELLED"]);
                 }
                 else
                 {
                     MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                 }
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }
    }),

    /**
     * Cancel a saved order. This service is used to delete multiple saved orders one at a time.
     * Perform the service or command call.
     */
    wcService.declare({
        id: "AjaxOrderCancel",
        actionId: "AjaxOrderCancel",
        url: getAbsoluteURL() + "AjaxRESTOrderCancel",
        formId: ""

     /**
     * display a success message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            // Call again to delete any other orders in the list.
            savedOrdersJS.cancelSavedOrder(false);
        }

     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                 if (serviceResponse.errorCode == "CMN0409E")
                 {
                     MessageHelper.displayErrorMessage(MessageHelper.messages["ORDER_NOT_CANCELLED"]);
                 }
                 else
                 {
                     MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                 }
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }
    }),

    /**
     * Update the description of a saved order. This service is used to update the description of multiple saved orders one at a time.
     * Perform the service or command call.
     */
    wcService.declare({
        id: "AjaxOrderSave",
        actionId: "AjaxOrderSave",
        url: getAbsoluteURL() + "AjaxOrderCopy",
        formId: ""

     /**
     * display a success message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            // Call again to delete any other orders in the list.
            savedOrdersJS.saveOrder(false);
        }

     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                 if (serviceResponse.errorCode == "CMN0409E")
                 {
                     MessageHelper.displayErrorMessage(MessageHelper.messages["ORDER_NOT_SAVED"]);
                 }
                 else
                 {
                     MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                 }
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }
    }),

    /**
     * Set the current order to be that of a saved order.
     * Perform the service or command call.
     */
    wcService.declare({
        id: "AjaxSetPendingOrder",
        actionId: "AjaxSetPendingOrder",
        url: getAbsoluteURL() + "AjaxRESTSetPendingOrder",
        formId: ""

     /**
     * display a success message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */

        ,successHandler: function(serviceResponse) {

            MessageHelper.hideAndClearMessage();

            MessageHelper.displayStatusMessage(MessageHelper.messages["ORDER_SET_CURRENT"]);

            savedOrdersJS.determinePageForward("AjaxSetPendingOrder");

            cursor_clear();

        }
     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                 if (serviceResponse.errorCode == "CMN0409E" || serviceResponse.errorCode == "CMN1024E")
                 {
                     MessageHelper.displayErrorMessage(MessageHelper.messages["ORDER_NOT_SET_CURRENT"]);
                 }
                 else
                 {
                     MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                 }
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),


    /**
     * Updates the current pending order setting it to the current shopping cart.
     * This service does not cause a refresh of the ListOrdersDisplay_Controller registered widgets.
     * The main function of this service is to keep the cpendorder database table in line with the current shopping cart.
     * Perform the service or command call.
     * @constructor
     */
    wcService.declare({
        id: "AjaxUpdatePendingOrder",
        actionId: "AjaxUpdatePendingOrder",
        url: getAbsoluteURL() + "AjaxRESTSetPendingOrder",
        formId: ""

     /**
     * There is nothing to do in the event of a success of this service since it is executed in the background.
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */

        ,successHandler: function(serviceResponse) {

            savedOrdersJS.determinePageForward("AjaxUpdatePendingOrder");
            cursor_clear();

        }
     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                if (serviceResponse.errorCode == "CMN0409E")
                 {
                     MessageHelper.displayErrorMessage(MessageHelper.messages["ORDER_NOT_SET_CURRENT"]);
                 }
                 else
                 {
                     MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                 }
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

    /**
     * Copy a saved order.
     * Perform the service or command call.
     */
    wcService.declare({
        id: "AjaxSingleOrderCopy",
        actionId: "AjaxSingleOrderCopy",
        url: getAbsoluteURL() + "AjaxOrderCopy",
        formId: ""

     /**
     * display a success message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */

        ,successHandler: function(serviceResponse) {

        var params = [];

        params.storeId		= ServicesDeclarationJS.storeId;
        params.catalogId	= ServicesDeclarationJS.catalogId;
        params.langId		= ServicesDeclarationJS.langId;
        params.URL="";
        params.updatePrices = "1";

        params.orderId = serviceResponse.orderId;
        params.calculationUsageId = "-1";

        wcService.invoke("AjaxSingleOrderCalculate", params);
            MessageHelper.hideAndClearMessage();

        }

     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                 if (serviceResponse.errorCode == "CMN0409E")
                 {
                     MessageHelper.displayErrorMessage(MessageHelper.messages["ORDER_NOT_COPIED"]);
                 }
                 else
                 {
                     MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                 }
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

    /**
     * Copy a saved order.
     * Perform the service or command call.
     */
    wcService.declare({
        id: "AjaxOrderCopy",
        actionId: "AjaxOrderCopy",
        url: getAbsoluteURL() + "AjaxOrderCopy",
        formId: ""

    /**
    * display a success message
    * @param (object) serviceResponse The service response object, which is the
    * JSON object returned by the service invocation
    */

        ,successHandler: function(serviceResponse) {

        var params = [];

        params.storeId		= ServicesDeclarationJS.storeId;
        params.catalogId	= ServicesDeclarationJS.catalogId;
        params.langId		= ServicesDeclarationJS.langId;
        params.URL="";
        params.updatePrices = "1";

        params.orderId = serviceResponse.orderId;
        params.calculationUsageId = "-1";

        wcService.invoke("AjaxOrderCalculate", params);
            MessageHelper.hideAndClearMessage();

        }

    /**
    * display an error message
    * @param (object) serviceResponse The service response object, which is the
    * JSON object returned by the service invocation
    */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                 if (serviceResponse.errorCode == "CMN0409E")
                 {
                     MessageHelper.displayErrorMessage(MessageHelper.messages["ORDER_NOT_COPIED"]);
                 }
                 else
                 {
                     MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                 }
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

    /**
     * Perform the order calculation operations to compute the contract prices for the order items in an order.
     * Perform the service or command call.
     */
    wcService.declare({
        id: "AjaxSingleOrderCalculate",
        actionId: "AjaxSingleOrderCalculate",
        url: getAbsoluteURL() + "AjaxRESTOrderCalculate",
        formId: ""

     /**
     * display a success message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */

        ,successHandler: function(serviceResponse) {

            MessageHelper.hideAndClearMessage();
            MessageHelper.displayStatusMessage(MessageHelper.messages["ORDER_COPIED"]);
            cursor_clear();
        }

     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                if (serviceResponse.errorCode == "CMN0409E")
                 {
                     MessageHelper.displayErrorMessage(MessageHelper.messages["ORDER_NOT_COPIED"]);
                 }
                 else
                 {
                     MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                 }
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

    /**
     * Perform the order calculation operations to compute the contract prices for the order items in an order.
     * Perform the service or command call.
     */
    wcService.declare({
        id: "AjaxCurrentOrderCalculate",
        actionId: "AjaxCurrentOrderCalculate",
        url: getAbsoluteURL() + "AjaxRESTOrderCalculate",
        formId: ""

     /**
     * display a success message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */

        ,successHandler: function(serviceResponse) {

            MessageHelper.hideAndClearMessage();
            MessageHelper.displayStatusMessage(MessageHelper.messages["ORDER_SET_CURRENT"]);
            cursor_clear();
        }

     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                if (serviceResponse.errorCode == "CMN0409E")
                 {
                     MessageHelper.displayErrorMessage(MessageHelper.messages["ORDER_NOT_COPIED"]);
                 }
                 else
                 {
                     MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                 }
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

    /**
     * Perform the order calculation operations to compute the contract prices for the order items in an order.
     * Perform the service or command call.
     */
    wcService.declare({
        id: "AjaxOrderCalculate",
        actionId: "AjaxOrderCalculate",
        url: getAbsoluteURL() + "AjaxRESTOrderCalculate",
        formId: ""

     /**
     * display a success message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */

        ,successHandler: function(serviceResponse) {

            MessageHelper.hideAndClearMessage();
            // Call again to copy any other orders in the list.
            savedOrdersJS.copyOrder(false);
        }

     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                if (serviceResponse.errorCode == "CMN0409E")
                 {
                     MessageHelper.displayErrorMessage(MessageHelper.messages["ORDER_NOT_COPIED"]);
                 }
                 else
                 {
                     MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                 }
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),


    /**
     * Processes a punchout payment request.
     */
    wcService.declare({
        id: "AjaxPunchoutPay",
        actionId: "AjaxPunchoutPay",
        url: "AjaxRESTOrderRePay",
        formId: ""

        /**
         * Calls PunchoutJS.handleResponse to render the punchout payment section on the page.
         * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation
         */
        ,successHandler: function(serviceResponse) {
            PunchoutJS.handleResponse(serviceResponse.orderId);
            MessageHelper.hideAndClearMessage();
            cursor_clear();
        }

        /**
         * Displays an error message on the page if the request failed.
         * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
         */
        ,failureHandler: function(serviceResponse) {
            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            } else {
                if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                }
            }
            cursor_clear();
        }
    }),


    /**
     * Subscribes to or unsubscribes from receiving information related to a particular category in the store.
     */
    wcService.declare({
        id: "AjaxCategorySubscribe",
        actionId: "AjaxCategorySubscribe",
        url: "AjaxRESTMarketingTriggerProcessServiceEvaluate",
        formId: ""

        /**
         * Clear messages on the page.
         * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation
         */
        ,successHandler: function(serviceResponse) {
            MessageHelper.hideAndClearMessage();
            MessageHelper.displayStatusMessage(MessageHelper.messages["SUBSCRIPTION_UPDATED"]);
        }

        /**
         * Displays an error message on the page if the request failed.
         * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
         */
        ,failureHandler: function(serviceResponse) {
            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            } else {
                if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                }
            }
            cursor_clear();
        }
    })

//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2008, 2015 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/**
 * @fileOverview This javascript contains declarations of AJAX services used within
 * WebSphere Commerce.
 */

/**
 * @class This class stores common parameters needed to make the service call.
 */
MyAccountServicesDeclarationJS = {
	/* The common parameters used in service calls */
	langId: "-1",
	storeId: "",
	catalogId: "",
	/**
	 * This function initializes common parameters used in all service calls.
	 * @param {int} langId The language id to use.
	 * @param {int} storeId The store id to use.
	 * @param {int} catalogId The catalog id to use.
	 */

	setCommonParameters:function(langId,storeId,catalogId){
			this.langId = langId;
			this.storeId = storeId;
			this.catalogId = catalogId;
	}
}

	/**
	 *  Removes an item from the customer wishlist in Ajax mode.
	 *  @constructor
	 */
	wcService.declare({
		id: "InterestItemDelete",
		actionId: "InterestItemDelete",
		url: "AjaxInterestItemDelete",
		formId: ""

	/**
	 * display a success message.
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation.
	 */
		,successHandler: function(serviceResponse) {
			MessageHelper.displayStatusMessage(MessageHelper.messages["WISHLIST_REMOVEITEM"]);
			for (var prop in serviceResponse) {
				console.debug(prop + "=" + serviceResponse[prop]);
			}
			cursor_clear();
		}
	/**
	 * display an error message.
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation.
	 */
		,failureHandler: function(serviceResponse) {
			if (serviceResponse.errorMessage) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
			}
			else {
				 if (serviceResponse.errorMessageKey) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
				 }
			}
			cursor_clear();
		}

	}),

	/**
	 *  Adds an item to the customer wishlist in Ajax mode.
	 *  @constructor
	 */
	wcService.declare({
		id: "AjaxInterestItemAdd",
		actionId: "AjaxInterestItemAdd",
		url: "AjaxInterestItemAdd",
		formId: ""
	/**
	 * display a success message.
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation.
	 */
		,successHandler: function(serviceResponse) {
			MessageHelper.hideAndClearMessage();
			cursor_clear();
			MessageHelper.displayStatusMessage(MessageHelper.messages["WISHLIST_ADDED"]);
            if(categoryDisplayJS)
                categoryDisplayJS.selectedAttributes = [];
		}
	/**
	 * display an error message.
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation.
	 */
		,failureHandler: function(serviceResponse) {

			if (serviceResponse.errorMessage) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
			}
			else {
				 if (serviceResponse.errorMessageKey) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
				 }
			}
			cursor_clear();
		}

	}),

	/**
	 *  This service enables the customer to email his/her wishlist.
	 *  @constructor
	 */
	wcService.declare({
		id: "InterestItemListMessage",
		actionId: "InterestItemListMessage",
		url: "AjaxInterestItemListMessage",
		formId: ""

	/**
	 * hdes the progress bar and displays a success message.
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation.
	 */
		,successHandler: function(serviceResponse) {
			for (var prop in serviceResponse) {
				console.debug(prop + "=" + serviceResponse[prop]);
			}
			cursor_clear();
		}
	/**
	 * display an error message.
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation.
	 */
		,failureHandler: function(serviceResponse) {
			if (serviceResponse.errorMessage) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
			}
			else {
				 if (serviceResponse.errorMessageKey) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
				 }
			}
			cursor_clear();
		}

	}),

	/**
	 * This service adds a billing address to the order(s).
	 * @constructor
	 */
	wcService.declare({
		id: "AddBillingAddress",
		actionId: "AddBillingAddress",
		url: "AjaxPersonChangeServiceAddressAdd",
		formId: ""

	 /**
	  *	 calls the saveAddress function defined in the AddressHelper class.
	  *  @param (object) serviceResponse The service response object, which is the
	  *  JSON object returned by the service invocation.
	  */
		,successHandler: function(serviceResponse) {
		    console.log("PSL::MyAccountServicesDeclaration.js::AddBillingAddress::successHandler");
			resetRequest();
			javascript:AddressHelper.saveAddress('AddShippingAddress','shippingAddressCreateEditFormDiv_1');
		}

	/**
	 * display an error message.
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation.
	 */
		,failureHandler: function(serviceResponse) {
		    console.log("PSL::MyAccountServicesDeclaration.js::AddBillingAddress::failureHandler");
			if (serviceResponse.errorMessage) {
						 MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
				  } else {
						 if (serviceResponse.errorMessageKey) {
								MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
						 }
				  }
		}

	}),

	/**
	 *  This service adds a shipping address to the order(s).
	 *  @constructor
	 */
	wcService.declare({
		id: "AddShippingAddress",
		actionId: "AddShippingAddress",
		url: "AjaxPersonChangeServiceAddressAdd",
		formId: ""

	/**
	 *  redirects to the Shipping and Billing Method page.
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation.
	 */
		,successHandler: function(serviceResponse) {
		    console.log("PSL::MyAccountServicesDeclaration.js::AddShippingAddress::successHandler");
			//document.location.href=appendWcCommonRequestParameters("OrderShippingBillingView?langId="+MyAccountServicesDeclarationJS.langId+"&storeId="+MyAccountServicesDeclarationJS.storeId+"&catalogId="+MyAccountServicesDeclarationJS.catalogId+"&shipmentType=single&orderPrepare=true");
			CheckoutHelperJS.updateAddressIdForOrderItem(serviceResponse.addressId);
		}

	/**
	 * display an error message.
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation.
	 */
		,failureHandler: function(serviceResponse) {
		    console.log("PSL::MyAccountServicesDeclaration.js::AddShippingAddress::failureHandler");
			if (serviceResponse.errorMessage) {
						 MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
				  } else {
						 if (serviceResponse.errorMessageKey) {
								MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
						 }
				  }
		}

	}),

	/**
	 * This service updates a billing address to the order(s).
	 * @constructor
	 */
	wcService.declare({
		id: "UpdateBillingAddress",
		actionId: "UpdateBillingAddress",
		url: "AjaxPersonChangeServiceAddressUpdate",
		formId: ""

	 /**
	  *	 calls the saveAddress function defined in the AddressHelper class.
	  *  @param (object) serviceResponse The service response object, which is the
	  *  JSON object returned by the service invocation.
	  */
		,successHandler: function(serviceResponse) {
		    console.log("PSL::MyAccountServicesDeclaration.js::UpdateBillingAddress::successHandler");
			resetRequest();
			javascript:AddressHelper.saveAddress('UpdateShippingAddress','shippingAddressCreateEditFormDiv_1');
		}

	/**
	 * display an error message.
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation.
	 */
		,failureHandler: function(serviceResponse) {
		    console.log("PSL::MyAccountServicesDeclaration.js::UpdateBillingAddress::failureHandler");
			if (serviceResponse.errorMessage) {
						 MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
				  } else {
						 if (serviceResponse.errorMessageKey) {
								MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
						 }
				  }
		}

	}),

	/**
	 *  This service adds a shipping address to the order(s).
	 *  @constructor
	 */
	wcService.declare({
		id: "UpdateShippingAddress",
		actionId: "UpdateShippingAddress",
		url: "AjaxPersonChangeServiceAddressUpdate",
		formId: ""

	/**
	 *  redirects to the Shipping and Billing Method page.
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation.
	 */
		,successHandler: function(serviceResponse) {
		    console.log("PSL::MyAccountServicesDeclaration.js::UpdateShippingAddress::successHandler");
			CheckoutHelperJS.updateAddressIdForOrderItem(serviceResponse.addressId);
		}

	/**
	 * display an error message.
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation.
	 */
		,failureHandler: function(serviceResponse) {
		    console.log("PSL::MyAccountServicesDeclaration.js::UpdateShippingAddress::failureHandler");
			if (serviceResponse.errorMessage) {
						 MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
				  } else {
						 if (serviceResponse.errorMessageKey) {
								MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
						 }
				  }
		}

	}),

  /**
   * This services adds or removes a coupon from the order(s).
   * @constructor
   */
	wcService.declare({
		id: "AjaxCouponsAddRemove",
		actionId: "AjaxCouponsAddRemove",
		url: "AjaxCouponsAddRemove",
		formId: ""

   /**
	 * Hides all the messages and the progress bar.
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation.
	 */
		,successHandler: function(serviceResponse) {
			MessageHelper.hideAndClearMessage();
			cursor_clear();
		}

	/**
	 * display an error message.
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation.
	 */
		,failureHandler: function(serviceResponse) {

			if (serviceResponse.errorMessage) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
			}
			else {
				 if (serviceResponse.errorMessageKey) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
				 }
			}
			cursor_clear();
		}

	}),
	

	/**
	 * This services deletes a coupon from the wallet.
	 * 
	 * @constructor
	 */
	wcService.declare({
		id : "AjaxRESTWalletCouponsDelete",
		actionId : "AjaxCouponsAddRemove",
		url : "AjaxRESTWalletCouponsDelete",
		formId : ""

		/**
		 * Hides all the messages and the progress bar.
		 * 
		 * @param (object)
		 *            serviceResponse The service response object,
		 *            which is the JSON object returned by the
		 *            service invocation.
		 */
		,
		successHandler : function(serviceResponse) {
			MessageHelper.hideAndClearMessage();
			cursor_clear();
		}

		/**
		 * display an error message.
		 * 
		 * @param (object)
		 *            serviceResponse The service response object,
		 *            which is the JSON object returned by the
		 *            service invocation.
		 */
		,
		failureHandler : function(serviceResponse) {

			if (serviceResponse.errorMessage) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
			} else {
				if (serviceResponse.errorMessageKey) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
				}
			}
			cursor_clear();
		}

	}),

	/**
	 * This service adds or removes a wallet item.
	 * @constructor
	 */
	wcService.declare({
		id: "AjaxWalletItemProcessServiceDelete",
		actionId: "AjaxWalletItemProcessServiceDelete",
		url: "AjaxWalletItemProcessServiceDelete",
		formId: ""

	/**
	 * Hides all messages and the progress bar.
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation.
	 */
	,successHandler: function(serviceResponse) {
		MessageHelper.hideAndClearMessage();
		cursor_clear();
	}

	/**
	 * Displays an error message in case of a failure.
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation.
	 */
	,failureHandler: function(serviceResponse) {
		if (serviceResponse.errorMessage) {
			MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
		} else {
			if (serviceResponse.errorMessageKey) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
			}
		}
		cursor_clear();
		}

	}),

	/**
	 * This service cancels a subscription.
	 * @constructor
	 */
	wcService.declare({
		id: "AjaxCancelSubscription",
		actionId: "AjaxCancelSubscription",
		url: "AjaxRESTRecurringOrSubscriptionCancel",
		formId: ""

		/**
		 * Clear messages on the page.
		 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation
		 */
		,successHandler: function(serviceResponse) {
			MessageHelper.hideAndClearMessage();
			cursor_clear();
            closeAllDialogs();
			if(serviceResponse.subscriptionType == "RecurringOrder"){
				if(serviceResponse.state == "PendingCancel"){
					MessageHelper.displayStatusMessage(MessageHelper.messages["SCHEDULE_ORDER_PENDING_CANCEL_MSG"]);
				}
				else{
					MessageHelper.displayStatusMessage(MessageHelper.messages["SCHEDULE_ORDER_CANCEL_MSG"]);
				}
			}
			else{
				if(serviceResponse.state == "PendingCancel"){
					MessageHelper.displayStatusMessage(MessageHelper.messages["SUBSCRIPTION_PENDING_CANCEL_MSG"]);
				}
				else{
					MessageHelper.displayStatusMessage(MessageHelper.messages["SUBSCRIPTION_CANCEL_MSG"]);
				}
			}
		}

		/**
		 * Displays an error message on the page if the request failed.
		 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
		 */
		,failureHandler: function(serviceResponse) {
			if (serviceResponse.errorMessage) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
			} else {
				if (serviceResponse.errorMessageKey) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
				}
			}
			cursor_clear();
		}
	}),


	/**
	 *  This service enables customer to Reorder an already existing order.
	 *  @constructor
	 */
	wcService.declare({
		id: "OrderCopy",
		actionId: "OrderCopy",
		url: "AjaxRESTOrderCopy",
		formId: ""

	 /**
	  *  Copies all the items from the existing order to the shopping cart and redirects to the shopping cart page.
	  *  @param (object) serviceResponse The service response object, which is the
	  *  JSON object returned by the service invocation.
	  */
		,successHandler: function(serviceResponse) {
			for (var prop in serviceResponse) {
				console.debug(prop + "=" + serviceResponse[prop]);
			}
			if (serviceResponse.newOrderItemsCount != null && serviceResponse.newOrderItemsCount<=0){
				MessageHelper.displayErrorMessage(MessageHelper.messages["CANNOT_REORDER_ANY_MSG"]);
			}
			else {
				setDeleteCartCookie();

				var postRefreshHandlerParameters = [];
				var initialURL = "AjaxRESTOrderPrepare";
				var urlRequestParams = [];
				urlRequestParams["orderId"] = serviceResponse.orderId;

				postRefreshHandlerParameters.push({"URL":"AjaxCheckoutDisplayView","requestType":"GET", "requestParams":{}}); 
				var service = getCustomServiceForURLChaining(initialURL,postRefreshHandlerParameters,null);
				wcService.invoke(service.getParam("id"), urlRequestParams);

			}
		}

	/**
	 * display an error message.
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation.
	 */
		,failureHandler: function(serviceResponse) {
			if (serviceResponse.errorMessageKey == "_ERR_PROD_NOT_ORDERABLE") {
				MessageHelper.displayErrorMessage(MessageHelper.messages["PRODUCT_NOT_BUYABLE"]);
			} else if (serviceResponse.errorMessageKey == "_ERR_INVALID_ADDR") {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
			}else {
				if (serviceResponse.errorMessage) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
				}
				else {
					 if (serviceResponse.errorMessageKey) {
						MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
					 }
				}
			}
			cursor_clear();
		}

	}),

	/**
	 *  This service enables customer to Reorder an already existing order in external system.
	 *  @constructor
	 */
	wcService.declare({
		id: "SSFSOrderCopy",
		actionId: "SSFSOrderCopy",
		url: "AjaxSSFSOrderCopy",
		formId: ""

		 /**
		  *  Copies all the items from the existing order to the shopping cart and redirects to the shopping cart page.
		  *  @param (object) serviceResponse The service response object, which is the
		  *  JSON object returned by the service invocation.
		  */
		,successHandler: function(serviceResponse) {
			for (var prop in serviceResponse) {
				console.debug(prop + "=" + serviceResponse[prop]);
			}

			setDeleteCartCookie();
			document.location.href=appendWcCommonRequestParameters("AjaxCheckoutDisplayView?langId="+MyAccountServicesDeclarationJS.langId+"&storeId="+MyAccountServicesDeclarationJS.storeId+"&catalogId="+MyAccountServicesDeclarationJS.catalogId);
		}

		/**
		* display an error message.
		* @param (object) serviceResponse The service response object, which is the
		* JSON object returned by the service invocation.
		*/
		,failureHandler: function(serviceResponse) {
			if (serviceResponse.errorMessageKey == "_ERR_PROD_NOT_ORDERABLE") {
				MessageHelper.displayErrorMessage(MessageHelper.messages["PRODUCT_NOT_BUYABLE"]);
			} else if (serviceResponse.errorMessageKey == "_ERR_INVALID_ADDR") {
				MessageHelper.displayErrorMessage(MessageHelper.messages["INVALID_CONTRACT"]);
			}else {
				if (serviceResponse.errorMessage) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
				}
				else {
					 if (serviceResponse.errorMessageKey) {
						MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
					 }
				}
			}
			cursor_clear();
		}

	}),


	/**
	 *  This service enables customer to Renew a subscription.
	 *  @constructor
	 */
	wcService.declare({
		id: "SubscriptionRenew",
		actionId: "SubscriptionRenew",
		url: "AjaxRESTOrderCopy",
		formId: ""

	 /**
	  *  Copies all the items from the existing subscription to the shopping cart and calls service to update requested shipping date.
	  *  @param (object) serviceResponse The service response object, which is the
	  *  JSON object returned by the service invocation.
	  */
		,successHandler: function(serviceResponse) {
			for (var prop in serviceResponse) {
				console.debug(prop + "=" + serviceResponse[prop]);
			}

			var params = [];

			params.storeId		= MyAccountServicesDeclarationJS.storeId;
			params.catalogId	= MyAccountServicesDeclarationJS.catalogId;
			params.langId		= MyAccountServicesDeclarationJS.langId;
			params.orderId      = serviceResponse.orderId;
			params.calculationUsage  = "-1,-2,-3,-4,-5,-6,-7";
			params.requestedShipDate = MyAccountDisplay.getSubscriptionDate();

			MyAccountDisplay.subscriptionOrderId = serviceResponse.orderId;
			MyAccountDisplay.subscriptionOrderItemId = serviceResponse.orderItemId[0];

			wcService.invoke("SetRequestedShippingDate",params);
		}

	/**
	 * display an error message.
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation.
	 */
		,failureHandler: function(serviceResponse) {
			if (serviceResponse.errorMessageKey == "_ERR_PROD_NOT_ORDERABLE") {
				MessageHelper.displayErrorMessage(MessageHelper.messages["PRODUCT_NOT_BUYABLE"]);
			} else if (serviceResponse.errorMessageKey == "_ERR_INVALID_ADDR") {
				MessageHelper.displayErrorMessage(MessageHelper.messages["INVALID_CONTRACT"]);
			}else {
				if (serviceResponse.errorMessage) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
				}
				else {
					 if (serviceResponse.errorMessageKey) {
						MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
					 }
				}
			}
			cursor_clear();
		}

	}),


	/**
	 *  This service sets the requested shipping date for a subscription renewal.
	 *  @constructor
	 */
	wcService.declare({
		id: "SetRequestedShippingDate",
		actionId: "SetRequestedShippingDate",
		url: "AjaxRESTOrderShipInfoUpdate",
		formId: ""
	/**
	 * hides all the messages and the progress bar
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation
	 */
		,successHandler: function(serviceResponse) {
			cursor_clear();
			document.location.href=appendWcCommonRequestParameters("RESTOrderPrepare?langId="+MyAccountServicesDeclarationJS.langId+"&storeId="+MyAccountServicesDeclarationJS.storeId+"&catalogId="+MyAccountServicesDeclarationJS.catalogId+"&orderId="+serviceResponse.orderId+"&URL=AjaxCheckoutDisplayView?langId="+MyAccountServicesDeclarationJS.langId+"&storeId="+MyAccountServicesDeclarationJS.storeId+"&catalogId="+MyAccountServicesDeclarationJS.catalogId);
		}

	 /**
	 * display an error message
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation
	 */
		,failureHandler: function(serviceResponse) {
			if (serviceResponse.errorMessageKey == "_ERR_ORDER_ITEM_FUTURE_SHIP_DATE_OVER_MAXOFFSET") {
				var params = [];

				params.storeId		= MyAccountServicesDeclarationJS.storeId;
				params.catalogId	= MyAccountServicesDeclarationJS.catalogId;
				params.langId		= MyAccountServicesDeclarationJS.langId;
				params.orderId      = MyAccountDisplay.subscriptionOrderId;
				params.orderItemId      = MyAccountDisplay.subscriptionOrderItemId;
				params.calculationUsage  = "-1,-2,-3,-4,-5,-6,-7";
				wcService.invoke("RemoveSubscriptionItem",params);

				MessageHelper.displayStatusMessage(MessageHelper.messages["CANNOT_RENEW_NOW_MSG"]);
			}
			else{
				if (serviceResponse.errorMessage) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
				}
				else {
					if (serviceResponse.errorMessageKey) {
						MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
					 }
				}
				cursor_clear();
			}
		}

	}),

	/**
	 * This service removes the subscription item from the shopping cart if renewal fails.
	 * @constructor
	 */
	wcService.declare({
		id: "RemoveSubscriptionItem",
		actionId: "RemoveSubscriptionItem",
		url: "AjaxRESTOrderItemDelete",
		formId: ""

		/**
		 * @param (object) serviceResponse The service response object, which is the
		 * JSON object returned by the service invocation.
		 */
		,successHandler: function(serviceResponse) {
				cursor_clear();
		}

		 /**
		 * display an error message
		 * @param (object) serviceResponse The service response object, which is the
		 * JSON object returned by the service invocation
		 */
		,failureHandler: function(serviceResponse) {
			if (serviceResponse.errorMessage) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
			}
			else {
				 if (serviceResponse.errorMessageKey) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
				 }
			}
			if(serviceResponse.errorCode){
				wcTopic.publish("OrderError",serviceResponse);
			}
			cursor_clear();
		}

	}),

/**
 *  This service enables customer to cancel a scheduled order or an order waiting for approval.
 *  @constructor
 */
wcService.declare({
	id: "AjaxScheduledOrderCancel",
	actionId: "AjaxScheduledOrderCancel",
	url: "AjaxRESTRecurringOrSubscriptionCancel",
	formId: ""

	/**
	 * Displays a success message.
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation.
	 */
	,successHandler: function(serviceResponse) {
		MessageHelper.hideAndClearMessage();
		cursor_clear();
		MessageHelper.displayStatusMessage(MessageHelper.messages["MO_ORDER_CANCELED_MSG"]);
	}

	/**
	 * Displays an error message.
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation.
	 */
	,failureHandler: function(serviceResponse) {

		if (serviceResponse.errorMessage) {
			MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
		}
		else {
			 if (serviceResponse.errorMessageKey) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
			 }
		}
		cursor_clear();
	}
})

//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2007, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/**
 *@fileOverview This javascript file defines all the javascript functions used to display
 *and handle the information messages, error messages.
 */

if (typeof (MessageHelper) == "undefined" || !MessageHelper || !MessageHelper.topicNamespace) {

    /**
     * @class The MessageHelper class contains variables and functions that are used
     * to initialize, display and handle informational and error message.
     */
    MessageHelper = {
        /**A variable that contains all the messages to be displayed*/
        messages: {},

        /**
         * internal variable to keep track of the current element id that has
         * an error tooltip assigned to it */
        identifier: "",

        /**
         * internal variable to keep track of the element id that needs to
         * give focus to on dialog dismissal */
        focusElement: "",

        /**
         * returns the current year
         * @return (int) the current year
         */
        getCurrentYear: function () {
            return new Date().getFullYear();
        },

        /**
         * returns the current month. January is 1, and December is 12.
         * @return (int) the current month
         */
        getCurrentMonth: function () {
            return new Date().getMonth() + 1;
        },

        /**
         * returns the current day of the current month, starting from 1.
         * @return (int) the current day
         */
        getCurrentDay: function () {
            return new Date().getDate();
        },

        /**
         *
         *summary: retrieves the value of the property from a render context
         *description: This function retrieves the value of the property whose name is propertName
         *from the given context.
         *
         * @param (wc.render.Content) content The context in which the properties
         * belong to.
         * @param (string) propertyName The property to be retrieved
         * @return (string) null if the context is null. undefined if the property is not found.
         * otherwise, the value of the property int he given context.
         */
        getRenderContextProperty: function ( /*wc.render.Context*/ context, /*String*/ propertyName) {

            console.debug("enter getRenderContextProperty with propertyName = " + propertyName);
            if (context == null) {
                console.debug("context is null. Return null...");
                return null;
            }

            var result = context.properties[propertyName]
            console.debug("the found property value is: " + result);

            return result;
        },

        /**
         * This function is used to initialize the messages object with all the
         * required messages. It is used to setup a JS object with any key/value.
         * @param (string) key The key used to access this message.
         * @param (string) msg The message in the correct language.
         *
         */
        setMessage: function (key, msg) {
            this.messages[key] = msg;
        },
        /**
         * This function is used to initialize the element that needs to give focus to on dialog dismissal.
         * @param (string) element The element needs to give focus to.
         *
         */
        setFocusElement: function (element) {
            this.focusElement = element;
        },



        /**
         * Use fadeIn and fadeOut to display error and informative messages in the store.
         * @param (int) topOffset how far from the top the message display area will be displayed.
         */
        showHideMessageArea: function (topOffset) {
            cursor_clear();
            if (topOffset == null || topOffset == undefined) {
                topOffset = 0;
            }
            var node = $("#MessageArea");

            if ($("#MessageArea_ACCE_Title") !== null) {
                $("#MessageArea_ACCE_Title").css("display", "block");
            }
            // fade in
            $(node).fadeIn(200);


        },

        /**
         * Use fadeOut to hide error and informative messages in the store.
         */
        hideMessageArea: function () {
            cursor_clear();
            var focusOnElement = "";
            if (this.focusElement !== "" && $("#" + this.focusElement) !== null) {
                focusOnElement = $("#" + this.focusElement);
            }
            var node = $("#MessageArea");

            if ($("#MessageArea_ACCE_Title") !== null) {
                $("#MessageArea_ACCE_Title").css("display", "none");
            }
            if (document.getElementById(focusOnElement) != null) {
                focusOnElement.focus();
            }
            $(node).fadeOut(500);
            $('#ErrorMessageText').html("");
            this.focusElement = "";
            if (typeof removeCheckoutLoader == 'function') {
                setTimeout(removeCheckoutLoader, 250);
            }
            setTimeout(function() {
                $('#MessageArea .message_text').removeClass('oosMessage');
            }, 400);
        },

        /**
         * This function is used to display the error messages to the user.
         * @param (string) msg The error/information message to be displayed
         * @param (int) topOffset how far from the top the message display area will be displayed.
         * @param (boolean) showType whether or not the message type should be appended to the actual message
         *
         * @return (element) a HTML element that contains the error message.
         *
         */
        displayErrorMessage: function (msg, topOffset, showType) {
            //HB-1988 BEGIN
            restoreAjaxButtons();
            //HB-1988 END

            //MiniShopCart BEGIN
            unlockShoppingBagIcon();
            //MiniShopCart END

            if (topOffset == null || topOffset == undefined) {
                topOffset = 0;
            }

            if (showType == undefined || showType == null || showType == true) {
                //if showType is undefined, keep the FEP1 behaviour.
                if (this.messages["ERROR_MESSAGE_TYPE"] != null && this.messages["ERROR_MESSAGE_TYPE"] != 'undefined') {
                    var MsgType = this.messages["ERROR_MESSAGE_TYPE"];
                    msg = MsgType + msg;
                }
            }

            this.setMessageAreaStyle('error_icon');
            $('#ErrorMessageText').html(msg);
            $('#MessageArea').addClass('active');
            this.showHideMessageArea(topOffset);
            $('#clickableErrorMessageImg').focus();
            setTimeout(function () {
                if ($('#ErrorMessageText') !== null) {
                    $('#ErrorMessageText').focus();
                }
            }, 1000);
            if (typeof TealeafWCJS != "undefined") {
                TealeafWCJS.logClientValidationCustomEvent({
                    fieldId: "-1",
                    message: msg
                });
            }

            /* TEALIUM BEGIN */
            // Send error to Tealium
            // TODO Fill 'source' and 'code' parameters before calling pushErrorToTealium(source, message, code)
            //pushErrorToTealium("",msg,"");
            /* TEALIUM END */

        },


        /**
         * Sets the style for the message area on the page.
         * @param (String) styleId The style Id.
         */
        setMessageAreaStyle: function (styleId) {
            $("#success_icon").css("display", "none");
            $("#error_icon").css("display", "none");
            if ($("#" + styleId) != null) {
                $("#" + styleId).css("display", "inline");
            }
        },


        /**
         * This function is used to display the informative messages to the user.
         * @param (string) msg The status message to be displayed.
         * @param (int) topOffset how far from the top of the browser the message will be displayed.
         * @return (element) a HTML element that contains the status message.
         */
        displayStatusMessage: function (msg, topOffset) {
            //HB-1988 BEGIN
            restoreAjaxButtons();
            //HB-1988 END

            if (topOffset == null || topOffset == undefined) {
                topOffset = 0;
            }
            this.setMessageAreaStyle('success_icon');
            $('#ErrorMessageText').html(msg);
            $('#MessageArea').addClass('active');
            this.showHideMessageArea(topOffset);
            $('#clickableErrorMessageImg').focus();

            setTimeout(function () {
                if ($('#ErrorMessageText') !== null) {
                    $('#ErrorMessageText').focus();
                }
            }, 1000);
        },


        /**
         * This function is used to hide and clear the message display area in
         * the page.
         */
        hideAndClearMessage: function () {
            $('#ErrorMessageText').html("");
            $('#MessageArea').css("display", "none");
            $('#MessageArea').removeClass('active')
        },

        /**
         * This function is used to re-adjust the coordinates of the message display area on the page. Its location is relative to the "page" element.
         * @param (int) topOffset how far from the top the message display area will be displayed.
         */
        adjustCoordinates: function (topOffset) {
            if ($("#MessageArea").css("display") != "none") {
                var page = $("#page");
                var node = $("#MessageArea");
                if (page != null && node != null) {
                    var postion = $(page).position();;
                    var width = $(page).width();


                    if (topOffset == null || topOffset == undefined) {
                        topOffset = 0;
                    }

                    $(node).css({
                        "width": width + 20 + "px",
                        "left": postion.left - 10 + "px",
                        "top": (postion.top + topOffset) + "px"
                    });
                }
            }
        },

        /**
         * This function will show the an error message tooltip
         * around the input field with the problem.
         *
         * The function assumes the "serviceResponse" is the
         * JSON object from a WebSphere Commerce exception. The error
         * field is in the serviceResponse.errorMessageParam and the
         * error message is in the serviceResponse.errorMessage.
         *
         * @see MessageHelper.formErrorHandleClient
         * @param (object) serviceResponse The JSON object with the error data.
         * @param (string) formName The name of the form where the error field is.
         *
         */
        formErrorHandle: function (serviceResponse, formName) {

            this.formErrorHandleClient(serviceResponse.errorMessageParam, serviceResponse.errorMessage);

        },


        /**
         * This function will show the an error message tooltip
         * around the input field with the problem.
         *
         * This function will check for the emptiness of the required
         * filed and displays the "errorMessage" related to that field as a tooltip.
         * The tooltip will be closed on focus lost.
         *
         * @param (string) id The identifier for the filed in the form.
         * @param (string) errorMessage The message that should be displayed to the user.
         */
        formErrorHandleClient: function (id, errorMessage) {
            if (id.id) {
                id = id.id;
            }
            var element = $("#"+id);
            if (errorMessage == null) {
                console.debug("formErrorHandleClient: The error message is null.");
                return;
            }
            if (element) {
                if (Utils.has_ios()) {
                    this.setMessageAreaStyle('error_icon');
                    $('#MessageArea').css("display", "block");
                    $('#ErrorMessageText').html(errorMessage);
                    window.setTimeout(function () {
                        window.scrollTo(0, 0);
                    }, 0);
                } else if (this.identifier != (id + "_tooltip")) {
                    element.focus();
                    this.identifier = id + "_tooltip";
                    var node = document.createElement('span');
                    var imgDirPath = getImageDirectoryPath();
                    if (Utils.get_IE_version() < 7) {
                        node.innerHTML = errorMessage + "<iframe id='errorMessageIFrame' scrolling='no' frameborder='0' src='" + imgDirPath + "images/empty.gif'></iframe>";
                    } else {
                        node.innerHTML = errorMessage;
                    }


                    if (Utils.hasTouch()) {
                        var _this = this;
                        setTimeout(function () {
                        var _this = this;
                        var $toolTipConnector = '/wcsstore/AuroraStorefrontAssetStore/images/colors/color1/tooltipConnectorUp.png';
                        this.tooltip = $("<div class='WCTooltip'><div class='container' style='padding:5px;' ><div class='connector''></div>" + errorMessage + "</div></div>");
                        $("#" + id).after(this.tooltip);
                        this.tooltip.position({
                            my: "center top",
                            at: "center bottom",
                            of: $("#" + id)

                        });

                        $("#" + id).blur(function () {
                            if (_this.tooltip) {
                                _this.tooltip.hide();
                                _this.tooltip.remove();
                            }
                            MessageHelper.clearCurrentIdentifier();

                        });

                        }, 1000);
                    } else {
                        var _this = this;
                        var $toolTipConnector = '/wcsstore/AuroraStorefrontAssetStore/images/colors/color1/tooltipConnectorUp.png';
                        this.tooltip = $("<div class='WCTooltip'><div class='container' style='padding:5px;' ><div class='connector''></div>" + errorMessage + "</div></div>");
                        $("#" + id).after(this.tooltip);
                        this.tooltip.position({
                            my: "center top",
                            at: "center bottom",
                            of: $("#" + id)

                        });

                        $("#" + id).blur(function () {
                            if (_this.tooltip) {
                                _this.tooltip.hide();
                                _this.tooltip.remove();
                            }
                            MessageHelper.clearCurrentIdentifier();

                        });

                    }
                }
                if (typeof TealeafWCJS != "undefined") {
                    TealeafWCJS.logClientValidationCustomEvent({
                        fieldId: element.id,
                        message: errorMessage
                    });
                }
	}
            },

            /**
             * This function hides and destroys the current form error handler tooltip that is displayed
             * and clears the identifier that is currently tracked.
             */
            hideFormErrorHandle: function () {
                    if (this.tooltip != null) {
                        this.tooltip.destroyRecursive();
                        this.tooltip = null;
                        this.clearCurrentIdentifier();
                    }
                },

                /**
                 * This function clears the internal variable that has the element id
                 * with the error tooltip.
                 *
                 */
                clearCurrentIdentifier: function () {

                    this.identifier = "";
                },

                /**
                 * This function is used to override any of the default functions
                 * associated with the events. Ex: Tooltip widget tracks onMouseOver event
                 * and display the tooltip. To remove this association,
                 * tooltip widgets onMouseOver function will be overridden by this empty
                 * function.
                 *
                 * It is an empty implementation which does nothing.
                 *
                 * @param (string) event  The event which triggers this function.
                 */
                emptyFunc: function (event) {

                },



                /**
                 * Checks whether a string contains a double byte character.
                 *
                 * @param (string) target the string to be checked
                 * @return (boolean) true if target contains a double byte char;
                 * false otherwise
                 */
                containsDoubleByte: function (target) {

                    var str = new String(target);
                    var oneByteMax = 0x007F;

                    for (var i = 0; i < str.length; i++) {
                        chr = str.charCodeAt(i);
                        chr2 = str.charAt(i);
                        if ((chr > oneByteMax) && (chr2!='ñ')) {
                            return true;
                        }
                    }
                    return false;
                },

                /**
                 * This function validate email address. It does not allow double byte
                 * characters in the email address.
                 *
                 * @return (boolean) true if the email address is valid; false otherwise
                 *
                 * @param (string) strEmail the email address string to be validated
                 */
                 isValidEmail: function (strEmail) {

                     if (this.containsDoubleByte(strEmail)) {
                         return false;
                     }
                     if (strEmail.length == 0) {
                         return true;
                     } else if (strEmail.length < 5) {
                         return false;
                     } else {
                         if (strEmail.indexOf(" ") > 0) {
                             return false;
                         } else {
                             if (strEmail.indexOf("@") < 1) {
                                 return false;
                             } else {
                                 if (strEmail.lastIndexOf(".") < (strEmail.indexOf("@") + 2)) {
                                     return false;
                                 } else {
                                     if (strEmail.lastIndexOf(".") >= strEmail.length - 2) {
                                         return false;
                                     }
                                 }
                             }
                         }
                     }
                     return true;
                 },

                /**
                 * This function will check if the number of bytes of the string
                 * is within the maxlength specified.
                 *
                 * @param (string) UTF16String the UTF-16 string
                 * @param (int) maxlength the maximum number of bytes allowed in your input
                 *
                 * @return (boolean) false is this input string is larger than maxlength
                 */
                isValidUTF8length: function (UTF16String, maxlength) {
                    if (this.utf8StringByteLength(UTF16String) > maxlength) return false;
                    else return true;
                },

                /**
                 * This function will count the number of bytes represented in a UTF-8
                 * string.
                 *
                 * @param (string) UTF16String the UTF-16 string you want a byte count of
                 * @return (int) the integer number of bytes represented in a UTF-8 string
                 */
                utf8StringByteLength: function (UTF16String) {

                    if (UTF16String === null) return 0;

                    var str = String(UTF16String);
                    var oneByteMax = 0x007F;
                    var twoByteMax = 0x07FF;
                    var byteSize = str.length;

                    for (i = 0; i < str.length; i++) {
                        chr = str.charCodeAt(i);
                        if (chr > oneByteMax) byteSize = byteSize + 1;
                        if (chr > twoByteMax) byteSize = byteSize + 1;
                    }
                    return byteSize;
                },

                /**
                 * this function will check whether the text is a numeric or not.
                 *
                 * @param allowDot is a boolean wich specifies whether to consider
                 * the '.' or not.
                 *
                 * @return (boolean) true if text is numeric
                 */
                IsNumeric: function (text, allowDot) {
                    if (allowDot) var ValidChars = "0123456789.";
                    else var ValidChars = "0123456789";

                    var IsNumber = true;
                    var Char;


                    for (i = 0; i < text.length && IsNumber == true; i++) {
                        Char = text.charAt(i);
                        if (ValidChars.indexOf(Char) == -1) {
                            IsNumber = false;
                        }
                    }
                    return IsNumber;
                },

                /**
                 *
                 *This function will check for a valid Phone Number
                 *
                 *@param (string) text The string to check
                 *
                 *@return (boolean) true if text is a phone number, ie if each character of
                 *input is one of 0123456789() -+
                 */
                IsValidPhone: function (text) {

                    var ValidChars = "0123456789()-+ ";

                    var IsValid = true;
                    var Char;

                    for (i = 0; i < text.length && IsValid == true; i++) {
                        Char = text.charAt(i);
                        if (ValidChars.indexOf(Char) == -1) {
                            IsValid = false;
                        }
                    }
                    return IsValid;
                },

                /**
                 *  To use confirmation popup, the ${StoreDirectory}/Common/ConfirmationPopup.jspf must be included
                 *  in the jsp page where the confirmation popup launches from.
                 *	This function launch confirmation popup
                 *
                 * @param (string) topicName The name of the topic that calling widget subscribing to.
                 * @param (stirng) message The message to be displayed in the confirmation dialog.
                 */
                showConfirmationDialog: function (topicName, message) {
                    $("#confirmationPopupMessage").html(message);
                    var confirmationPopupWidget = $("#confirmationPopup").data("wc-WCDialog"),
                        // Also add a namespace to the click event so we
                        // only remove our click handler instead of other click handlers
                        eventName = "click.MessageHelper";
                    // Do this only once.
                    confirmationPopupWidget.primary_button.one(eventName, function (e) {
                        e.preventDefault();
                        confirmationPopupWidget.secondary_button.off(eventName);
                        wcTopic.publish(topicName, {
                            action: "YES"
                        });
                    });

                    confirmationPopupWidget.secondary_button.one(eventName, function (e) {
                        e.preventDefault();
                        confirmationPopupWidget.primary_button.off(eventName);
                        wcTopic.publish(topicName, {
                            action: "NO"
                        });
                    });
                    confirmationPopupWidget.open();

                }
        }
    }

//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2008, 2017 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/**
* @fileOverview This JavaScript file contains functions used by the payment section of the checkout pages.
*/

//declare the namespace if it does not already exist
if (CheckoutPayments == null || typeof(CheckoutPayments) != "object") {
	var CheckoutPayments = new Object();
}
CheckoutPayments = {
	/** used to hold error messages for any error encountered */
	errorMessages: {},

	/** indicates the number of payment methods a shopper has selected to use from the shipping and billing page, default to 1 */
	numberOfPaymentMethods: 1,

	/** language ID to be used, default to -1 (English) */
	langId: "-1",

	/** store ID to be used */
	storeId: "",

	/** catalog ID to be used */
	catalogId: "",

	/** indicates if the shipping information on the checkout page has been changed */
	dirtyFlag: false,

	/** locale code to be passed to jQuery functions */
	jQlocale: "",

    /** This constant is the standard number of payment methods supported during order check out. */
    //HB-1028 BEGIN
    //maxNumberOfPaymentMethodsSupported: 3,
    maxNumberOfPaymentMethodsSupported: 2,
    //HB-1028 END

	/** Stores all payment objects on the shipping & billing page. */
	paymentObjects: new Array(),

	/** Stores the payment instructions that should be deleted from the order. */
	paymentsToDelete: new Array(),

	/** Stores the payment instructions that should be added to the order. */
	paymentsToAdd: new Array(),

	/** Stores the payment instructions that should be updated in the order. */
	paymentsToUpdate: new Array(),

	/** Keeps track of the previous number of payment methods selected by the user. */
	prevNumberOfPaymentMethods: 1,

	/** The Purchase Order Number entered */
	purchaseOrderNumber: "",

	/** This flag indicates whether billing address dropdown box should be refreshed on change of the payment method.*/
	paymentSpecificAddress: false,

	/** This flag indicates whether quick checkout is enabled*/
	quickCheckoutProfileForPaymentFlag: false,

	/** Keep track of which payment method selection was changed */
    currentPaymentMethodChanged: 1,

	/**
	* Sets the jQlocale variable to be used by jQuery functions
	* @param {String} locale Locale to be set
	*/
	setLocale: function (locale) {
		this.jQlocale = locale;
	},

	/**
	* Sets the quickCheckoutProfileForPaymentFlag variable to be used to display masked credit card info.
	* @param {String} flag to be set true or false
	*/
	setQuickCheckoutProfileForPaymentFlag: function (flag) {
		this.quickCheckoutProfileForPaymentFlag = flag;
	},

	/**
	* This function is used to initialize the error messages object with all the required error messages.
	* @param {String} key The key used to access this error message.
	* @param {String} msg The error message in the correct language.
	*/
	setErrorMessage:function(key, msg) {
		this.errorMessages[key] = msg;
	},

	/**
	* Sets common parameters used by this JavaScript object
	* @param {String} langId language ID to use
	* @param {String} storeId store ID to use
	* @param {String} catalog Catalog ID to use
	*/
	setCommonParameters:function(langId,storeId,catalogId){
		this.langId = langId;
		this.storeId = storeId;
		this.catalogId = catalogId;
	},

	/**
	* This function checks to see how many payments are selected and decides if the number of payment indicator
	* should be shown or not.
	* Initially, the indicator is hidden because there's only 1 payment.
	* If there are more payments methods, the indicator is turned on.
	* @param {String} numPayments number of payments to set
	*/
	setNumPaymentIndicator:function(numPayments) {
		var payment2 = document.getElementById('paymentSection2');

		if (payment2.style.display=='block') {
			//if paymentSection2 is shown, that means there are more than one payment methods. Show all indicators
			for (i=1; i<numPayments; i++){
				var div = document.getElementById('paymentHeading'+i);
				div.style.display="block";
			}
		}else {
			//there's only 1 payment method. Hide the indicators
			document.getElementById('paymentHeading1').style.display="none";
		}
	},

	/**
	* This function displays (unhides) the number of payment methods specified. The pre-requisite is
	* that the payment sections	are named as the prefix that is passed in.
	* Look for the HTML elements named as the prefix passed	in and the number of payment methods required.
	* The rest are disabled.
	* @param {String} totalPaymentMethods The total number of payment methods blocks.
	* @param {String} numberOfPaymentMethodsField The number of payment method block to show.
	* @param {String} divNamePrefix The name of the root HTML element that contains each payment method block.
	*/
	setNumberOfPaymentMethods:function(totalPaymentMethods,numberOfPaymentMethodsField,divNamePrefix) {
		this.numberOfPaymentMethods = numberOfPaymentMethodsField.value;
		for (i=1; i<=totalPaymentMethods; i++) {
			var divNode = document.getElementById(divNamePrefix+i);
			if (divNode != undefined) {
				if (i<=numberOfPaymentMethodsField.value) {
					divNode.style.display = "block";
				} else {
					divNode.style.display = "none";
				}
			}
		}
		var orderTotal = document.getElementById("OrderTotalAmount").value;
		this.updateAmountFields(orderTotal);
		this.setNumPaymentIndicator(numberOfPaymentMethodsField.value);
	},

	/**
	* Clears all payment data for a specified form
	* @param {String} paymentFormName Name of the payment form to be cleared
	*/
	clearPaymentFormData:function(paymentFormName, cleanBrand) {
		if (this.getValue(paymentFormName,"cc_brand") !== " " && cleanBrand) {
			paymentFormName["cc_brand"].value = " ";
		}
		if (this.getValue(paymentFormName,"cc_cvc") !== " ") {
			paymentFormName["cc_cvc"].value = " ";
		}
		if (this.getValue(paymentFormName,"account") !== " ") {
			paymentFormName["account"].value = " ";
		}
		if (this.getValue(paymentFormName,"payment_token") !== " ") {
			paymentFormName["payment_token"].value = " ";
		}
		if (this.getValue(paymentFormName,"expire_month") !== " ") {
			paymentFormName["expire_month"].value = " ";
		}
		if (this.getValue(paymentFormName,"expire_year") !== " ") {
			paymentFormName["expire_year"].value = " ";
		}
		if (this.getValue(paymentFormName,"check_routing_number") !== " ") {
			paymentFormName["check_routing_number"].value = " ";
		}
		if (this.getValue(paymentFormName,"checkingAccountNumber") !== " ") {
			paymentFormName["checkingAccountNumber"].value = " ";
		}
		if (this.getValue(paymentFormName,"checkRoutingNumber") !== " ") {
			paymentFormName["checkRoutingNumber"].value = " ";
		}
		if (this.getValue(paymentFormName,"numberOfInstallments") !== " ") {
			paymentFormName["numberOfInstallments"].value = " ";
		}
	},

	/**
	* This function sets the context to the selected payment method so that the controller loads
	* the desired struts action.
	* Sets the specific payment block context to the selected payment method. The controller has
	* the mapping of what struts action to load for each payment method.
	* @param {String} paymentMethodSelectBox The identifier of the selected payment method.
	* @param {String} paymentAreaNumber The payment block that this payment method applies to.
	*/
	loadPaymentSnippet:function(paymentMethodSelectBox, paymentAreaNumber, cleanBrand){
        // before updating context, clear previous form data
		var formObj = document.forms['PaymentForm'+paymentAreaNumber];
		this.clearPaymentFormData(formObj, cleanBrand);

		var selectBoxValueArray = paymentMethodSelectBox.value.split("_");
		var paymentMethodName = selectBoxValueArray[0];
		var paymentTCId = '';
		if(selectBoxValueArray[1] != null){
			paymentTCId = selectBoxValueArray[1];
		}

		if(this.paymentSpecificAddress){
			wcRenderContext.getRenderContextProperties("billingAddressDropDownBoxContext")["payment"+paymentAreaNumber] = paymentMethodName;
			wcRenderContext.getRenderContextProperties("billingAddressDropDownBoxContext")["paymentTCId" + paymentAreaNumber] = paymentTCId;
			wcRenderContext.updateRenderContext("billingAddressDropDownBoxContext");
		}
		MessageHelper.hideAndClearMessage();
		var currentTotal = 0;
		for(var i = 1; i < paymentAreaNumber; i++){
			var formName = document.forms["PaymentForm"+i];
			if (formName.piAmount != null && formName.piAmount.value != "" && !isNaN(formName.piAmount.value)){
				currentTotal = (currentTotal) * (1) + (formName.piAmount.value) * (1);
			}
		}

		var contextPropertyName = "payment" + paymentAreaNumber;
		var buyerOrgDN = formObj.buyerOrgDN.value;
		var orderId = formObj.orderId.value;
		var piAmount = formObj.piAmount.value;
		var params = {};
		params[contextPropertyName] = paymentMethodName;
		params["paymentTCId" + paymentAreaNumber] = paymentTCId;
		params["currentPaymentArea"] = paymentAreaNumber;
		params["payMethodId"] = paymentMethodName;
		params["currentTotal"] = currentTotal;
		params["paymentTCId"] = paymentTCId;
		params["buyerOrgDN"] = buyerOrgDN;
		params["orderId"] = orderId;
		params["piAmount"] = piAmount;
		wcRenderContext.updateRenderContext("paymentContext", params);

		var currentForm = document.forms["PaymentForm"+paymentAreaNumber];
		if (paymentMethodName == "PayInStore") {
			//need to hide the billing address id
			var billingDiv = document.getElementById("billingAddressSelectBoxArea_"+paymentAreaNumber);
			billingDiv.style.display = "none";
			if (currentForm["billing_address_id"]) {
				currentForm.billing_address_id.value = "";
			}
		} else {
			var billingDiv = document.getElementById("billingAddressSelectBoxArea_"+paymentAreaNumber);
			billingDiv.style.display = "block";
			if (currentForm["billing_address_id"] == "") {
				currentForm.billing_address_id.value = "-1";
			}
		}
	},

	/**
	* Loads the payment snippet
	* @param {String} paymentMethodSelectBox The identifier of the selected payment method.
	* @param {String} paymentNumber The payment block that this payment method applies to.
	*
	*/
	loadPaymentSnippetLocally:function(paymentMethodSelectBox, paymentNumber){
		var selectBoxValueArray = paymentMethodSelectBox.value.split("_");
		var selectedPayMethod = selectBoxValueArray[0];
		var selectedDivContents ="";

		// save the current display amount and hidden amount of this payment form
		var thisPaymentAmount = "";
		var thisPaymentDisplayAmount = "";
		var thisForm = document.forms["PaymentForm"+paymentNumber];
		if (thisForm.piAmount != null && thisForm.piAmount.value != "" && !isNaN(thisForm.piAmount.value)){
			thisPaymentAmount = thisForm.piAmount.value;
		}
		if (thisForm.piAmount_display != null && thisForm.piAmount_display.value != "" && !isNaN(thisForm.piAmount_display.value)){
			thisPaymentDisplayAmount = thisForm.piAmount_display.value;
		}

		if(selectBoxValueArray[1] != null){
			var paymentTCId = selectBoxValueArray[1];
			selectedDivContents = $("#PIInfo_Div_"+selectedPayMethod+"_"+paymentNumber + "_" + paymentTCId).html();
		}else{
			selectedDivContents = $("#PIInfo_Div_"+selectedPayMethod+"_"+paymentNumber).html();
		}

		var divNode = document.getElementById("paymentFormDiv"+paymentNumber);
		divNode.html(selectedDivContents);

		// retrieve previously saved display amount and hidden amount of this payment form
		if (thisPaymentAmount != "") {
			thisForm.piAmount.value = thisPaymentAmount;
		}
		if (thisPaymentDisplayAmount != "") {
			thisForm.piAmount_display.value = thisPaymentDisplayAmount;
		}

		//Now set the amount field in the selected payment option with the remaining amount..
		var orderTotal = document.getElementById("OrderTotalAmount").value;
		this.updateAmountFields(orderTotal);
	},

	/**
	* This function processes the current shopping cart. The sequence of operations are:
	* 1. If its a non-ajax checkout, see if shopper has changed anything in current page. If so, alert shopper
	* to update these changes before starting checkout process.
	* 2. Check if its a singlePageCheckout or Traditional Checkout.
	* 2A. If Traditional Checkout, then call OrderPrepare Service and then display the BillingPage, by calling
	* showBillingPage() method
	* 2B. If SinglePageCheckout, then delete existing payment methods, add the new payment methods, call
	* OrderPrepare service and finally call showSummaryPage() method to display the OrderSummaryPage.
	* @param {String} ipFormName Name of the payment form containing payment data
	* @param {Boolean} skipOrderPrepare Indicates if Order Prepare process should be skipped. It defaults to false, if no value is passed.
	*/
	processCheckout:function(piFormName, skipOrderPrepare) {
		//NERD-88 , validate CVV..
		if(!this.extraFormValidation(piFormName)){
			return;
		}

		if (CheckoutHelperJS.isSinglePageCheckout() && !this.validatePaymentTotals(piFormName)) {
			return;
		}

		if (skipOrderPrepare == undefined || skipOrderPrepare == null){
			skipOrderPrepare = false;
		}

		if(CheckoutHelperJS.checkForDirtyFlag()){
			return;
		}

		if (CheckoutHelperJS.getShipmentTypeId() == "1") {
			if (document.getElementById("requestShippingDateCheckbox") != null) {

				// Validate input and create error message tooltip when there's error
				var jsDate = $("#requestedShippingDate");
				if(!jsDate.ValidationTextbox("validationAndErrorHandler")) {
					jsDate.focus();
					return;
				}
			}

		} else {
			var totalItemsDiv = document.getElementById("totalNumberOfItems");
			if (totalItemsDiv != null) {
				for (var i = 0; i < totalItemsDiv.value; i++) {

					var orderItemIdDiv = document.getElementById("orderItem_"+(i+1));
					if (orderItemIdDiv != null) {
						// Order items are being shown, so check shipping date
						var orderItemId = orderItemIdDiv.value;

						var requestShippingDateCheckbox = $("#MS_requestShippingDateCheckbox_" + orderItemId)[0];

						if (requestShippingDateCheckbox != null){

							var jsDate = $("#MS_requestedShippingDate_" + orderItemId);
							if(!jsDate.ValidationTextbox("validationAndErrorHandler")) {
								jsDate.focus();
								return;
							}
						}
					}
				}
			}
		}

		//Validate schedule orders or recurring orders section before allowing checkout. Only one of these
		//two features may be enable at a time.
		//1. schedule order fields are mandatory if either field is selected otherwise is a normal order
		//2. recurring order fields are always mandatory
		if(document.getElementById("scheduleOrderInputSection") != null){
			var scheduleOrderFrequencyObj = document.getElementById("ScheduleOrderFrequency");
			var scheduleOrderStartDateObj = $("#ScheduleOrderStartDate");
			var isRecurringOrderMandatory = document.getElementById("makeRecurringOrderMandatory");
			if((scheduleOrderFrequencyObj.value == "undefined" && scheduleOrderStartDateObj.val() != null) ||
						(isRecurringOrderMandatory && isRecurringOrderMandatory.value == "true" && scheduleOrderFrequencyObj.value == "undefined")){
				MessageHelper.formErrorHandleClient(scheduleOrderFrequencyObj.id, MessageHelper.messages["SCHEDULE_ORDER_MISSING_FREQUENCY"]);
				tealiumPushFormError(this.errorMessages["SCHEDULE_ORDER_MISSING_FREQUENCY"]);
				return;
			}
			if(scheduleOrderFrequencyObj.value != "undefined" && scheduleOrderStartDateObj.val() == null){
				MessageHelper.formErrorHandleClient(scheduleOrderStartDateObj[0].id, MessageHelper.messages["SCHEDULE_ORDER_MISSING_START_DATE"]);
				tealiumPushFormError(this.errorMessages["SCHEDULE_ORDER_MISSING_START_DATE"]);
				return;
			}
			if(!CheckoutHelperJS.validateDate(scheduleOrderStartDateObj, 'ScheduleOrderStartDate')){
				return;
			}
		}

//		// The following code snippet is used to drop the paymentTermConditionId (if there is one) in the constructed payMethodId value before adding the payment instructions
//		var numberOfPaymentMethodsRef = 1;
//		if(numberOfPaymentMethodsRef){
//			var paymentMethodsCount = numberOfPaymentMethodsRef.value;
//			for(var i=1; i<=paymentMethodsCount; i++){
//				var currentPaymentForm = document.forms[piFormName + i];
//				//we don't need this block for "PayInStore" flow
//				if (currentPaymentForm['payMethodId'].type == "select-one") {
//					for(var j=0; j<currentPaymentForm['payMethodId'].options.length; j++){
//						var payMethodId = currentPaymentForm['payMethodId'].options[j].value.split('_')[0];
//						currentPaymentForm['payMethodId'].options[j].value = payMethodId;
//					}
//				}
//			}
//		}
		if(!skipOrderPrepare && !CheckoutHelperJS.isSinglePageCheckout()){
			//Call service to PrepareOrder and then show the billingPage....
			var params = [];
			params["storeId"] = this.storeId;
			params["catalogId"] = this.catalogId;
			params["langId"] = this.langId;
			params.orderId		= ".";
			if(!submitRequest()){
				return;
			}
			cursor_wait();
			wcService.invoke('AjaxPrepareOrderBeforePaymentCapture',params);
			return;
		}
		else{
			//SinglePageCheckout feature enabled.. So billing information is captured on the same page.. Delete existing
			//billing info, Validate and add these new billing info...
			if(skipOrderPrepare){
				this.processPIAndCheckout(piFormName,skipOrderPrepare);
			} else {
				var params = [];
				params["storeId"] = this.storeId;
				params["catalogId"] = this.catalogId;
				params["langId"] = this.langId;
			 	//should migrate this solution to GlobalLoginActions.js to avoid GlobalLoginJS.updateGlobalLoginUserDisplay("...") which is causing original prob
			 	var header = document.getElementById("header");
			 	if (header == null  || !this.hasClass(header,"checkout") || !this.hasClass(header,"checkout-header")){
					if(!submitRequest()){
					}
			 	}

				cursor_wait();
				wcService.invoke('AjaxPrepareOrderBeforeSubmit', params);
			}
		}
	},


	 hasClass : function(element, inputClass) {
	     return (" " + element.className + " " ).indexOf( " "+inputClass+" " ) > -1;
	},


	/**
	 * extra empty fields validation (payment form)
	 */
	extraFormValidation : function(piFormName){
		var validForm = true;

		var cvvElement = document.getElementById('cc_cvc_1');
		var creditCardNumberElement = document.getElementById('account1_1');


		// we are not in case of Visa payment, simple test instead of testing payment method
		if(!cvvElement && !creditCardNumberElement){
			return validForm;
		}else{
			var cvv = cvvElement.value;
			var creditCardNumber = creditCardNumberElement.value;

			//dealing with CVV field
			var emptyCVVField = document.getElementById('emptyCVV');
			if(!cvv){
			   validForm = false;
			   this.manageEmptyVisaFieldError(emptyCVVField,this.errorMessages["EDPaymentMethods_EMPTY_CVV"]);

			}else{
				//delete error message
				emptyCVVField.style.display ="none";
			}

			//dealing with Credit Card Field

			var emptyCreditCardField = document.getElementById('emptyCreditCard');
			if(!creditCardNumber){
				validForm = false;
				this.manageEmptyVisaFieldError(emptyCreditCardField,this.errorMessages["EDPaymentMethods_EMPTY_CVV"]);

			}else{
				//delete error message
				emptyCreditCardField.style.display = "none";
			}
		}


		return validForm;

	},

	/**
	 * displays error message for Visa payment form empty fields
	 */
	manageEmptyVisaFieldError : function(visaFormField,errorMsg){

		visaFormField.style.color = '#e35152';
		visaFormField.style.display = "block";

		//push tealium error info
		tealiumPushFormError(errorMsg);

	},

	/**
	* This function examines all payment instructions to find out which one(s) needs to be deleted, added or updated, then calls the corresponding AJAX service to process them.
	* Once all payment instructions are processed successfully, the current shopping cart is submitted.
	* @param {String} ipFormName Name of the payment form containing payment data
	* @param {Boolean} skipOrderPrepare Indicates if Order Prepare process should be skipped. It defaults to false, if no value is passed.
	*/
	processPIAndCheckout:function(piFormName, skipOrderPrepare) {
		if (skipOrderPrepare == undefined || skipOrderPrepare == null){
			skipOrderPrepare = false;
		} else if (skipOrderPrepare == 'true' || skipOrderPrepare == 'false'){
			//If skipOrderPrepare is passed in as a string instead of boolean from a service response
			//Cast the value back to a boolean before further processing
			skipOrderPrepare = (skipOrderPrepare === 'true');
		}

		if (this.checkValidPaymentInstructions(piFormName)){
        
			var formName = document.forms[piFormName + '1'];
			if(this.getValue(formName,"valueFromProfileOrder") == "Y") {
				this.setQuickCheckoutProfileForPaymentFlag("true");

				// Only the first payment method could be from the quick checkout profile. If it is, then re-add the payment instruction (PI).
				// This fixes the problem where a standard PI has already been registered with the order and the user now chooses quick checkout profile to check out without further modifying the payment.
				this.updatePaymentObject(1, "account");
			}

            var maxNumberOfPaymentMethodsSupported = parseInt(this.maxNumberOfPaymentMethodsSupported);

            for(var i=1; i<=maxNumberOfPaymentMethodsSupported && document.forms["PaymentForm" + i] !== undefined; i++){
                var paymentObj = this.retrievePaymentObject(i);

                //HB-1028 BEGIN Only one payment instruction allowed
                var myPiIds = document.forms["PaymentForm" + i].existingPiId.value;
                if (typeof myPiIds !== 'undefined' && myPiIds != ""){
                    var myPiIdsArr = myPiIds.split(",");
                    if(myPiIdsArr.length>0){
                        paymentObj['piId'] = myPiIdsArr[0];
                        paymentObj['action']='re-add';
                    }
                }
                //HB-1028 END

				if(paymentObj != null){
					if((paymentObj['action'] == 'delete' || paymentObj['action'] == 're-add') && paymentObj['piId'] != ""){
						this.setPaymentsToDelete(i);
					}
					if(paymentObj['action'] == 'add' || paymentObj['action'] == 're-add'){
						this.setPaymentsToAdd(i);
					}
					if(paymentObj['action'] == 'update' && paymentObj['piId'] != ""){
						this.setPaymentsToUpdate(i);
					}
				}
            }

            
			if(sessionStorage.getItem("isStepPayPalExpress") == null){
				if(this.getPaymentsToDelete().length > 0){
					this.deletePaymentInstructions();
				}else if(this.getPaymentsToAdd().length > 0){
					this.addPaymentInstructions();
				}else if(this.getPaymentsToUpdate().length > 0){
					this.updatePaymentInstructions();
				}else{
					CheckoutPayments.setCommonParameters(SBServicesDeclarationJS.langId,SBServicesDeclarationJS.storeId,SBServicesDeclarationJS.catalogId);
					CheckoutPayments.showSummaryPage();
					cursor_clear();
				}
			}else{
				if(this.getPaymentsToDelete().length > 0){
					this.deletePaymentInstructions();
				}else if(this.getPaymentsToAdd().length > 0){
					this.addPaymentInstructions();
				}else if(this.getPaymentsToUpdate().length > 0){
					this.updatePaymentInstructions();
				}else{
					CheckoutPayments.setCommonParameters(SBServicesDeclarationJS.langId,SBServicesDeclarationJS.storeId,SBServicesDeclarationJS.catalogId);
					CheckoutPayments.showSummaryPage();
					cursor_clear();
				}
			}
			CheckoutHelperJS.setFieldDirtyFlag(false);
		}
	},

	/**
	* Determines the URL of the order summary page and invokes the page
	*/
	showSummaryPage:function(){
		if(document.getElementById("scheduleOrderInputSection") != null){
			CheckoutHelperJS.prepareOrderSchedule();
		}

		var po_id = encodeURIComponent(this.purchaseOrderNumber);
		var url = '';
		if(CheckoutHelperJS.getShipmentTypeId() == "1"){
			url = "SingleShipmentOrderSummaryView?langId="+this.langId+"&storeId="+this.storeId+"&catalogId="+this.catalogId+"&purchaseorder_id="+po_id+"&quickCheckoutProfileForPayment="+this.quickCheckoutProfileForPaymentFlag;
			document.location.href = appendWcCommonRequestParameters(url);
		}
		else {
			url = "MultipleShipmentOrderSummaryView?langId="+this.langId+"&storeId="+this.storeId+"&catalogId="+this.catalogId+"&purchaseorder_id="+po_id+"&quickCheckoutProfileForPayment="+this.quickCheckoutProfileForPaymentFlag;
			document.location.href = appendWcCommonRequestParameters(url);
		}
	},

	showBillingPage:function(){
		document.location.href = appendWcCommonRequestParameters("OrderBillingView?langId="+this.langId+"&storeId="+this.storeId+"&catalogId="+this.catalogId+"&forceShipmentType="+CheckoutHelperJS.getShipmentTypeId());
	},

	/**
	* Populates payment data
	* @param {String} formName Name of the payment form to be populated
	* @param {Object} params Object containing payment data
	* @retrun {Object} params Object holding payment data
	*/
	populateProtocolData:function(formName,params){
		params = this.updateParamObject(params,"storeId",this.getValue(formName,"storeId"),true);
		params = this.updateParamObject(params,"payment_token",this.getValue(formName,"payment_token"),true);
		params = this.updateParamObject(params,"catalogId",this.getValue(formName,"catalogId"),true);
		params = this.updateParamObject(params,"langId",this.getValue(formName,"langId"),true);
		params = this.updateParamObject(params,"valueFromProfileOrder",this.getValue(formName,"valueFromProfileOrder"),true);
		params = this.updateParamObject(params,"valueFromPaymentTC",this.getValue(formName,"valueFromPaymentTC"),true);
		params = this.updateParamObject(params,"paymentTCId",this.getValue(formName,"paymentTCId"),true);
		params = this.updateParamObject(params,"payMethodId",this.getValue(formName,"payMethodId"),true);
		params = this.updateParamObject(params,"piAmount",this.getValue(formName,"piAmount"),true);
		params = this.updateParamObject(params,"billing_address_id",this.getValue(formName,"billing_address_id"),true);
		params = this.updateParamObject(params,"cc_brand",$.payment.cardType(this.getValue(formName, "account")),true);
		params = this.updateParamObject(params,"cc_cvc",this.getValue(formName,"cc_cvc"),true);
		params = this.updateParamObject(params,"cc_nameoncard",this.getValue(formName,"cc_nameoncard"),true);
		
		if(isPersol) {
			params = this.updateParamObject(params,"run_check_enroll_psd2", "true", true);
		}
		
		if(isCarol) {
			params = this.updateParamObject(params,"installment_totalCount",this.getValue(formName,"installment_totalCount"));
			params = this.updateParamObject(params,"card_type",this.getCardType(this.getValue(formName,"account")),true);
		}

		params = this.updateParamObject(params,"account",this.getValue(formName,"account"),true);
		params = this.updateParamObject(params,"expire_month",this.getValue(formName,"expire_month"),true);
		params = this.updateParamObject(params,"expire_year",this.getValue(formName,"expire_year"),true);
		//FOR PSD2 UPDATE
		params = this.updateParamObject(params,"browserWidth",window.innerWidth,true);
        params = this.updateParamObject(params,"browserHeight",window.innerHeight,true);

		//LUXHB-865
		if(!isCarol) {
			let httpAccept = this.getValue(formName,"httpAccept");
			if(httpAccept == '*/*'){
				httpAccept = "all";
			}
			params = this.updateParamObject(params, "billTo_httpBrowserJavaEnabled",navigator.javaEnabled(),true);
			params = this.updateParamObject(params, "billTo_httpBrowserLanguage",language,true);
			params = this.updateParamObject(params, "billTo_httpBrowserColorDepth",screen.colorDepth,true);
			params = this.updateParamObject(params, "billTo_httpBrowserTimeDifference",date.getTimezoneOffset(),true);
			params = this.updateParamObject(params, "payerAuthEnrollService_httpUserAgent",navigator.userAgent,true);
			params = this.updateParamObject(params, "billTo_httpBrowserJavaScriptEnabled", typeof window !== 'undefined' && typeof document !== 'undefined', true);
			params = this.updateParamObject(params,"payerAuthEnrollService_httpAccept",httpAccept,true);
			params = this.updateParamObject(params,"payerAuthEnrollService_httpUserAccept",httpAccept,true);
			params = this.updateParamObject(params,"payerAuthEnrollService_deviceChannel","Browser",true);
		}

		params = this.updateParamObject(params,"check_routing_number",this.getValue(formName,"check_routing_number"),true);
		params = this.updateParamObject(params,"checkingAccountNumber",this.getValue(formName,"checkingAccountNumber"),true);
		params = this.updateParamObject(params,"checkRoutingNumber",this.getValue(formName,"checkRoutingNumber"),true);
		params = this.updateParamObject(params,"requesttype","ajax",true);
		if(formName.authToken){
			params = this.updateParamObject(params,"authToken",this.getValue(formName,"authToken"),true);
		}
	    params = this.updateParamObject(params,"customerWebId",window.forterWebId,true);
		params = this.updateParamObject(params,"customerIPAddress",window.ipaddress,true);
        params = this.updateParamObject(params,"forterToken",window.forterToken,true);

        if ($("#JWT").length > 0) {
            var responseJWT = $("#JWT").attr("responseJWT");
            if (responseJWT.length > 0) {
                params = this.updateParamObject(params,"responseJWT",responseJWT,true);
                params = this.updateParamObject(params,"payerAuthServiceToRun","validate_service",true);
                $("#JWT").attr("responseJWT", "");
            } else {
                if ($("#JWT").attr("ignoreAuthService") == "true") {
                    $("#JWT").attr("ignoreAuthService", "");
                } else {
                    params = this.updateParamObject(params,"payerAuthServiceToRun","enroll_service",true);
                }
            }
        }

		return params;

    },
    
    /**
    * Send request to https://lookup.binlist.net to get the card type (debit or credit). It will retuen the value
    * unknown if the type doesn't return in the response.
    * @param {String} card number.
    * @retrun {String} the card type: credit, debit or unknown if case of no type value returned from the ajax request.
    */
   getCardType:function(cardNumber) {
    var cardType = "unknown";
    $.ajax({
        url : "https://lookup.binlist.net/" + cardNumber.replace(/ /g,"").substring(0,6),
        method : "GET",
        dataType : "json",
        async : false,
        context : this,
        success : function(data) {
            if (data["type"] != undefined) {
                cardType = data["type"];
            } else {
                console.log("CheckoutPayments.getCardType(): card type not existing in the json response");
            }
        },
        error : function(jqXHR, textStatus, error) {
            console.debug("error - inside CheckoutPayments.getCardType()");
            console.debug(error);
        }
    });
    return cardType;
},

	/**
	* Populates payment data based on a specified array of fields.
	* @param {DOM Object} formName The payment form that contains input data.
	* @param {Array} params The array object that contains payment data.
	* @param {Array} arrayFields The array object containing the specified input fields that this function should populate data for.
	* @retrun {Array} params Array holding payment data.
	*/
	populateProtocolDataForGivenFields:function(formName,params,arrayFields){
		for(var i=0; i<arrayFields.length; i++){
			var field = arrayFields[i];
			params = this.updateParamObject(params,field,this.getValue(formName,field),true);
		}
		params = this.updateParamObject(params,"requesttype","ajax",true);
		return params;
	},

	/**
	* Gets the text value of a particular 'selectBox' from the form
	* @param {String} formName Name of the payment form
	* @param {String} fieldName Name of the filed to get value from
	* @return {String} the selected text of the field
	*/
	getSelected: function(formName,fieldName)
	{
		if (formName[fieldName] != null){
			var selObj = formName[fieldName];

			var selIndex = selObj.selectedIndex;
			  //in case index/selected option not found, return blank
			return (selIndex !== -1 ) ? selObj.options[selIndex].text : "";
		}
		else{
			return "";
		}
	},

	/**
	* Gets the value of a particular field in the form
	* @param {String} formName Name of the payment form
	* @param {String} fieldName Name of the filed to get value from
	* @return {String} value of the field
	*/
	getValue:function(formName,fieldName){
		if (formName[fieldName] != null)
			return formName[fieldName].value;
		else return " ";
	},

	/**
	* This function trims the spaces from the passed in word.
	* Delete all pre and trailing spaces around the word.
	* @param {String} inword The word to trim.
	* @return {String} Word with leading and trailing spaces trimmed
	*/
	trim:function(inword)
	{
	   word = inword.toString();
	   var i=0;
	   var j=word.length-1;
	   while(word.charAt(i) == " ") i++;
	   while(word.charAt(j) == " ") j=j-1;
	   if (i > j) {
			return word.substring(i,i);
		} else {
			return word.substring(i,j+1);
		}
	},

	/**
	* This function verifies that all the characters in the word are numbers.
	* This function is used to verify if a word is made up of all numbers.
	* @param {String} word The prefix used for the payment blocks.
	* @return {Boolean} False if word is not a number. True if word is a number.
	*/
	isNumber:function(word)
	{
		var numbers="0123456789";
		var word=this.trim(word);
		for (var i=0; i < word.length; i++)
		{
			if (numbers.indexOf(word.charAt(i)) == -1)
			return false;
		}
		return true;
	},

	/**
	* Make sure all changes to the hidden piAmount are synchronized with the piAmount_display
	* and formatted to the current locale
	* This function will check whether the hidden piAmount field has been updated by other
	* services or calculations etc, if so, format the value and copy it over to the
	* piAmount_display field
	* @param {String} paymentAreaNumber The payment area number to check the amount for.
	*/
	formatAmountDisplayForLocale:function(paymentAreaNumber) {
		//Take the hidden payment amount and format it to the current locale
		var paymentAmount = document.getElementById("piAmount_"+paymentAreaNumber);
        var paymentAmount_display = document.getElementById("piAmount_"+paymentAreaNumber+"_display");

        var localeFormat = locale.replace('_', '-').replace(locale.substr(-2), locale.substr(-2).toUpperCase());
        var parsePrice = parseFloat((paymentAmount.value).replace(',','.')).toFixed(2); //replace the (,) to (.) to parse the string, if its string, to float

		if(this.jQlocale == 'ar-eg')
		{
            var formattedPaymentAmountValue = parsePrice;
		}
		else
		{
			if (this.jQlocale.indexOf('zh') === 0 || this.jQlocale.indexOf('ja') === 0 || this.jQlocale.indexOf('ko') === 0) {
				// Add trailing 0 only if necessary.  Only useful for double-byte languages
				var formattedPaymentAmountValue = new Intl.NumberFormat(localeFormat, {maximumFractionDigits:1}).format(parsePrice);
			}
			else {
                // Always add 2 trailing 0.  Only useful for single-byte languages
                var formattedPaymentAmountValue = new Intl.NumberFormat(localeFormat, { minimumFractionDigits: 2, maximumFractionDigits:2}).format(parsePrice);
			}
		}

		//If the displayed payment amount is different from the hidden payment amount
		//Synchronize the display payment amount according to the hidden payment amount
		if(paymentAmount_display.value != formattedPaymentAmountValue || this.jQlocale == 'ar-eg'){
			paymentAmount_display.value = formattedPaymentAmountValue;
		}
	},

	/**
	* This function verifies that the amount is valid.
	* This function will check that the amount field is not	empty, and is not negative and that
	* is numeric.
	* @param {String} formNamePrefix The prefix used for the payment blocks.
	* @param {String} paymentAreaNumber The payment area number to check the amount for.
	* @return {Boolean} False if amount is not valid. True if amount is valid.
	*/
	validateAmount:function(formNamePrefix, paymentAreaNumber) {
		//verify the field amount entered is a number
		var formName = document.forms[formNamePrefix+paymentAreaNumber];

		//Take the displayed payment amount, parse it back to a number
		// First trim leading and trailing spaces
		formName.piAmount_display.value = formName.piAmount_display.value.replace(/^\s+|\s+$/g,"");
		formName.piAmount_display.value = formName.piAmount_display.value.replace(/\xa0/g,'');
		var valueToParse = formName.piAmount_display.value;

		if(this.jQlocale == 'ar-eg')
		{
			valueToParse = valueToParse.replace(',','');
			var parsedAmountValue = Utils.formatNumber(valueToParse, {maximumFractionDigits: 2, minimumFractionDigits: 2});
		}
		else
		{
			var parsedAmountValue = Utils.parseNumber(valueToParse);
		}

		//If the displayed payment amount and the hidden payment amount are different
		//Synchronize the 2 fields according to the displayed payment amount
		if(parsedAmountValue != formName.piAmount.value){
			formName.piAmount.value = parsedAmountValue;
		}

		if (formName.piAmount != null && formName.piAmount.value == "") {
			MessageHelper.formErrorHandleClient(formName.piAmount_display,this.errorMessages["EDPPaymentMethods_NO_AMOUNT"]);
			tealiumPushFormError(this.errorMessages["EDPPaymentMethods_NO_AMOUNT"]);
			return false;
		} else if (formName.piAmount != null && parseFloat(formName.piAmount.value) < 0){
			MessageHelper.formErrorHandleClient(formName.piAmount_display,this.errorMessages["EDPPaymentMethods_AMOUNT_LT_ZERO"]);
			tealiumPushFormError(this.errorMessages["EDPPaymentMethods_AMOUNT_LT_ZERO"]);
			return false;
		} else if (formName.piAmount != null && isNaN(formName.piAmount.value)) {
			MessageHelper.formErrorHandleClient(formName.piAmount_display,this.errorMessages["EDPPaymentMethods_AMOUNT_NAN"]);
			tealiumPushFormError(this.errorMessages["EDPPaymentMethods_AMOUNT_NAN"]);
			return false;
		}


		//amount total is correct. Save it in the context so that we can retrieve it when user changes payment method
		var params = {};
		params["paymentAreaAmount"+paymentAreaNumber] = parsedAmountValue;
		wcRenderContext.updateRenderContext("paymentContext", params);

		return true;

	},

	/**
	* This function submits the current shopping cart once all the payment instructions are added successfully.
	* This function will add all the payment instructions first with AJAX calls and then calls the order
	* processing service.
	* @param {String} formNamePrefix The prefix used for the payment blocks.
	* @retrun {Boolean} True if sum of payment amounts is equal to the order total. False if sum of payment amounts does not equal order total.
	*/
	validatePaymentTotals:function(formNamePrefix) {
		//verify that all payment amounts sum up to the order total
		var runningTotal = parseFloat(0.0);
		var orderTotal = document.getElementById("OrderTotalAmount").value;
		for (var i=1; i<=this.numberOfPaymentMethods; i++) {
			var formName = document.forms[formNamePrefix+i];

			if (this.validateAmount(formNamePrefix, i)) {
				runningTotal = runningTotal + parseFloat(formName.piAmount.value);
				var temp = runningTotal.toFixed(2);
				runningTotal = parseFloat(temp);
			} else {
				return false;
			}
		}
		if (runningTotal == orderTotal) {
			return true;
		} else {
			var element = (document.getElementsByName("piAmount_display"))[0]; // get the Amount field of the first payment method
			if (runningTotal < orderTotal) {
				MessageHelper.formErrorHandleClient(element, this.errorMessages["EDPPaymentMethods_CANNOT_RECONCILE_PAYMENT_AMT"]);
				tealiumPushFormError(this.errorMessages["EDPPaymentMethods_CANNOT_RECONCILE_PAYMENT_AMT"]);
				return false;
			} else if (runningTotal > orderTotal) {
				MessageHelper.formErrorHandleClient(element, this.errorMessages["EDPPaymentMethods_PAYMENT_AMOUNT_LARGER_THAN_ORDER_AMOUNT"]);
				tealiumPushFormError(this.errorMessages["EDPPaymentMethods_PAYMENT_AMOUNT_LARGER_THAN_ORDER_AMOUNT"]);
				return false;
			} else {
				MessageHelper.formErrorHandleClient(element, this.errorMessages["EDPPaymentMethods_PAYMENT_AMOUNT_PROBLEM"]);
				tealiumPushFormError(this.errorMessages["EDPPaymentMethods_PAYMENT_AMOUNT_PROBLEM"]);
				return false;
			}
		}
	},

	/**
	* This function validates the billing address details to make sure that they are not empty.
	* @param {String} formNamePrefix The prefix used for the payment blocks.
	* @return {Boolean} True if all fields are validated without error. False if an error has encountered.
	*/
	isBillingAddressValid:function(formNamePrefix) {
		for (var i=1; i<=this.numberOfPaymentMethods; i++) {
			var formName = document.forms[formNamePrefix+i];
			var billing_address_isValid = formName.billing_address_isValid;
			if (billing_address_isValid) {
				if (billing_address_isValid.value == "false") {
					return false;
				}
			}
		}
		return true;
	},

	/**
	* This function validates all mandatory fields in the payment section are not empty.
	* This function makes sure all fields are valid before calling order services.
	* @param {String} formNamePrefix The prefix used for the payment blocks.
	* @return {Boolean} True if all fields are validated without error. False if an error has encountered.
	*/
	checkValidPaymentInstructions:function(formNamePrefix) {
		for (var i=1; i<=this.numberOfPaymentMethods; i++) {
			var formName = document.forms[formNamePrefix+i];
			var mandatoryFields = " ";
			if(formName["mandatoryFields_"+i] != null){
				mandatoryFields = formName["mandatoryFields_"+i].value;
			}
			var purchaseOrderForm = document.forms["purchaseOrderNumberInfo"];
			if (purchaseOrderForm) {
				this.purchaseOrderNumber = purchaseOrderForm.purchase_order_number.value;
				if(purchaseOrderForm.purchaseOrderNumberRequired.value == 'true' && purchaseOrderForm.purchase_order_number.value == ""){
					MessageHelper.formErrorHandleClient(purchaseOrderForm.purchase_order_number,this.errorMessages["ERROR_PONumberEmpty"]);
					tealiumPushFormError(this.errorMessages["ERROR_PONumberEmpty"]);
					return false;
				}
				else if(!MessageHelper.isValidUTF8length(purchaseOrderForm.purchase_order_number.value, 128)){
					MessageHelper.formErrorHandleClient(purchaseOrderForm.purchase_order_number,this.errorMessages["ERROR_PONumberTooLong"]);
					tealiumPushFormError(this.errorMessages["ERROR_PONumberTooLong"]);
					return false;
				}
			}
//			if (formName.payMethodId.type == "select-one") {
//				if (formName.payMethodId.options[formName.payMethodId.options.selectedIndex].value == "empty") {
//					MessageHelper.formErrorHandleClient(formName.payMethodId,this.errorMessages["EDPPaymentMethods_NO_PAYMENT_SELECTED"]);
//					tealiumPushFormError(this.errorMessages["EDPPaymentMethods_NO_PAYMENT_SELECTED"]);
//					return false;
//				}
//			}
			/* All the visa, masterCard and Amex  pages will have account1 field which will be filled by user and one more hidden field by name
			account...
			1. If its a quickcheckout profile and data is valid (!dirty) then copy the value of unmaskedAccount field into hidden account field
			2. If its not a quickcheckout or if data is dirty, then copy the value entered by user (account1 into hidden field account */
			//Its not a quick checkout..so just assign value of account1 to account..
			if(CheckoutHelperJS.isPaymentDataDirty(i)){
				if(document.getElementById("account_"+i) != null){
					document.getElementById("account_"+i).value = document.getElementById("account1_"+i).value;
				}
			}

			if (document.getElementById("expire_month_"+i) != null || document.getElementById("expire_year_"+i) != null) {
				var now = new Date(formName.curr_year.value,formName.curr_month.value - 1,formName.curr_date.value);
				var lastday = 1;
				var lastmonth = 1;

				if (document.getElementById("expire_month_"+i) != null) {
					lastmonth = new Number(document.getElementById("expire_month_"+i).value) + 1;
					if (lastmonth > 13) {
						lastmonth = 1;
					}
				}

				var expiry = 2000;
				if (document.getElementById("expire_year_"+i) != null) {
					expiry = new Date(document.getElementById("expire_year_"+i).value,lastmonth - 1,lastday);
				}
			}

			//Start validations...
			if (formName.piAmount != null && parseFloat(formName.piAmount.value) < 0){
				MessageHelper.formErrorHandleClient(formName.piAmount_display,this.errorMessages["EDPPaymentMethods_AMOUNT_LT_ZERO"]);
				tealiumPushFormError(this.errorMessages["EDPPaymentMethods_AMOUNT_LT_ZERO"]);
				return false;
			// account is checked for StandardAmex, StandardMasterCard, StandardVisa, StandardLOC and StandardCheck
			} else if (mandatoryFields.indexOf("account_"+i) != -1 && document.getElementById("account_"+i) != null && document.getElementById("account_"+i).value == "" ) {
				MessageHelper.displayErrorMessage(this.errorMessages["EDPPaymentMethods_NO_ACCOUNT_NUMBER"]);
				tealiumPushFormError(this.errorMessages["EDPPaymentMethods_NO_ACCOUNT_NUMBER"]);
				return false;
			// expiry date can be checked for credit cards StandardAmex, StandardMasterCard and StandardVisa
			} else if ((mandatoryFields.indexOf("expire_month_"+i) != -1 && mandatoryFields.indexOf("expire_year_"+i) != -1 && document.getElementById("expire_month_"+i) != null && document.getElementById("expire_year_"+i) != null)
					&& now >= expiry) {
				MessageHelper.displayErrorMessage(this.errorMessages["EDPPaymentMethods_INVALID_EXPIRY_DATE"]);
				tealiumPushFormError(this.errorMessages["EDPPaymentMethods_INVALID_EXPIRY_DATE"]);
				return false;
			} else if (formName.piAmount != null && formName.piAmount.value == "") {
				MessageHelper.formErrorHandleClient(formName.piAmount_display,this.errorMessages["EDPPaymentMethods_NO_AMOUNT"]);
				tealiumPushFormError(this.errorMessages["EDPPaymentMethods_NO_AMOUNT"]);
				return false;
			} else if (formName.piAmount != null && isNaN(formName.piAmount.value)) {
				MessageHelper.formErrorHandleClient(formName.piAmount_display,this.errorMessages["EDPPaymentMethods_AMOUNT_NAN"]);
				tealiumPushFormError(this.errorMessages["EDPPaymentMethods_AMOUNT_NAN"]);
				return false;
			} else if (mandatoryFields.indexOf("check_routing_number_"+i) != -1 && document.getElementById("check_routing_number_"+i) != null && document.getElementById("check_routing_number_"+i).value == "") {
				MessageHelper.displayErrorMessage(this.errorMessages["EDPPaymentMethods_NO_ROUTING_NUMBER"]);
				tealiumPushFormError(this.errorMessages["EDPPaymentMethods_NO_ROUTING_NUMBER"]);
				return false;
			}
			else if (mandatoryFields.indexOf("CheckAccount_"+i) != -1 && document.getElementById("CheckAccount_"+i) != null && document.getElementById("CheckAccount_"+i).value == "") {
				MessageHelper.displayErrorMessage(this.errorMessages["EDPPaymentMethods_NO_BANK_ACCOUNT_NO"]);
				tealiumPushFormError(this.errorMessages["EDPPaymentMethods_NO_BANK_ACCOUNT_NO"]);
				return false;
			}
			else if (mandatoryFields.indexOf("billing_address_id") != -1 && formName.billing_address_id != null && (formName.billing_address_id.value == "" || formName.billing_address_id.value == "-1")) {
				MessageHelper.displayErrorMessage(this.errorMessages["EDPPaymentMethods_NO_BILLING_ADDRESS"]);
				tealiumPushFormError(this.errorMessages["EDPPaymentMethods_NO_BILLING_ADDRESS"]);
				return false;
			} else if (CheckoutHelperJS.isPaymentDataDirty(i) && mandatoryFields.indexOf("cc_cvc_"+i) != -1 && document.getElementById("cc_cvc_"+i) != null && this.trim(document.getElementById("cc_cvc_"+i).value)!= null && this.trim(document.getElementById("cc_cvc_"+i).value)!= ""){
				if (!this.isNumber(document.getElementById("cc_cvc_"+i).value)) {
					MessageHelper.displayErrorMessage(this.errorMessages["EDPPaymentMethods_CVV_NOT_NUMERIC"]);
					tealiumPushFormError(this.errorMessages["EDPPaymentMethods_CVV_NOT_NUMERIC"]);
					return false;
				}
			}
		}

		if (!this.isBillingAddressValid(formNamePrefix)) {
			MessageHelper.displayErrorMessage(this.errorMessages["EDPPaymentMethods_BILLING_ADDRESS_INVALID"]);
			tealiumPushFormError(this.errorMessages["EDPPaymentMethods_BILLING_ADDRESS_INVALID"]);
			return false;
		}

		if (!CheckoutHelperJS.isSinglePageCheckout() && !this.validatePaymentTotals(formNamePrefix)) {
			return false;
		}
		return true;
	},

	/**
	* Updates existingPiId element of the payment form passed in
	* @param {String} piFormName Form name of the payment form
	* @param {String} piId
	*/
	updateExistingPiId:function(piFormName,piId){
		if(piFormName != null){
			var formName = document.forms[piFormName+1];
			formName.existingPiId.value = piId;
		}
	},

	/**
	* This function updates the given params object with Key value pair.
	* If the toArray value is true, It creates an Array for duplicate entries. Else, It overwrites the old value.
	* It is useful while making a service call which excepts few paramters of type array
	* @param {Object} params array holding parameters
	* @param {String} key Key to store and retrieve the parameter
	* @param {String} value	Value of the parameter
	* @param {Boolean} toArray If true, creates an Array for duplicate entries. If false, does not creat an
	* Array for duplicate entries. It overwrites the old value.
	* @return	{Object} params A JavaScript Object having key - value pair.
	*/
	updateParamObject:function(params, key, value, toArray, index){
	   if(params == null){
		   params = [];
	   }

	   if(params[key] != null && toArray)
	   {
			if($.isArray(params[key]))
			{
				//3rd time onwards
				if(index != null && index != "")
				{
					//overwrite the old value at specified index
					 params[key][index] = value;
				}
				else
				{
					params[key].push(value);
				 }
			}
			else
			{
				 //2nd time
				 var tmpValue = params[key];
				 params[key] = [];
				 params[key].push(tmpValue);
				 params[key].push(value);
			}
	   }
	   else
	   {
			//1st time
		   if(index != null && index != "" && index != -1)
		   {
			  //overwrite the old value at specified index
			  params[key+"_"+index] = value;
		   }
		   else if(index == -1)
		   {
			  var i = 1;
			  while(params[key + "_" + i] != null)
			  {
				   i++;
			  }
			  params[key + "_" + i] = value;
		   }
		   else
		   {
			  params[key] = value;
			}
	   }
	   return params;
	 },

	/**
	* Save the selected address in billingAddressDropDownBoxContext,so that we can reselect this when the billing address
	* drop down box is refreshed. Billing address drop down box is refreshed on create New billing address action.
	* @param {String} actionType Type of action to be performed (e.g. edit)
	* @param {String} paymentArea The payment area number for this function to work on.
	*/
	saveBillingAddressDropDownBoxContextProperties:function(actionType,paymentArea){
		for(var i = 1; i < 4; i++){
			var form = document.forms["PaymentForm"+i];
			if(form) {
				if(form.billing_address_id != null){
					var selectedBillingAddress = form.billing_address_id.value;
					if (actionType == 'create' && paymentArea == i) {
						//creating a new address here. make selectedBillingAddress to -1 to indicated that the payment area needs to be refreshed later
						selectedBillingAddress = "-1";
					}
					wcRenderContext.getRenderContextProperties("billingAddressDropDownBoxContext")["billingAddress"+i] = selectedBillingAddress;
				}
			} else if(form == null && i > 1) {
				//do nothing it is fine
			} else {
				return;
			}
		}

		if(actionType == 'edit'){
			//If its edit, then set the billingAddress property to -1 for all the billing address select boxes, which has edited address selected.
			//so that the new addressId is selected...
			//Otherwise we would have saved old addressId and this old addressId doesnt exist anymore, since addressId changes on edit..
			var form = document.forms["PaymentForm"+paymentArea];
			if (form) {
				var selectedBillingAddress = form.billing_address_id.value;
				for(var i = 1; i < 4; i++){
					var form1 = document.forms["PaymentForm"+i];
					if (form1) {
						var selectedBillingAddress1 = form1.billing_address_id.value;
						if(selectedBillingAddress1 == selectedBillingAddress){
							wcRenderContext.getRenderContextProperties("billingAddressDropDownBoxContext")["billingAddress"+i] = "-1";
						}
					}
				}
			}
		}
	},

	/**
	* helper function to create a new billing address
	* @param {String} paymentAreaNumber The payment area number for this function to work on.
	* @param {String} addressType Value to pass to createAddress function. Address type of the address to be created.
	*/
	createBillingAddress:function(paymentAreaNumber,addressType){
		this.saveBillingAddressDropDownBoxContextProperties('create',paymentAreaNumber);
		CheckoutHelperJS.createAddress(-1,addressType);
	},

	/**
	* Displays detail information of the billing address
	* @param {String} addressSelectBox HTML dropdown box that contains billing address selection
	* @param {String} paymentAreaNumber The payment area number for this function to work on.
	* @param {String} addressType Value to pass to createAddress function. Address type of the address to be created.
	*/
	displayBillingAddressDetails:function(addressSelectBox,paymentAreaNumber,addressType){
		if(addressSelectBox.value != -1){
			document.getElementById("selectedAddressId_"+paymentAreaNumber).value = addressSelectBox.value;
		}

		//Also save the selected address in billingAddressDropDownBoxContext,so that we can reselect this when the billing address
		//drop down box is refreshed...Billing address drop down box is refreshed on create New billing address action...
		this.saveBillingAddressDropDownBoxContextProperties('create','-1');

		if(addressSelectBox.value != -1){
			//Display selected address details..
			var addressKey = "billingAddress" + paymentAreaNumber;
			wcRenderContext.updateRenderContext('billingAddressDropDownBoxContext', {addressKey:addressSelectBox.value, 'areaNumber':paymentAreaNumber});
		}

	},
	/**
	 * returns the current total of the order in a JSON object.
	 * @param {String} operation Identifies where this method is being called from, to determine the processing after.
	 * @param {String} ipFormName Name of the payment form containing payment data
	 * @param {Boolean} skipOrderPrepare Indicates if Order Prepare process should be skipped.
	 */
	getTotalInJSON: function (operation, piFormName, skipOrderPrepare) {
		var parameters = {};
		parameters.operation = operation;
		parameters.piFormName = piFormName;
		parameters.skipOrderPrepare = skipOrderPrepare;
		parameters.storeId = this.storeId;
		parameters.catalogId = this.catalogId;
		parameters.langId = this.langId;
		var url = appendWcCommonRequestParameters("orderTotalAsJSON");
		wcTopic.publish("ajaxRequestInitiated");
		$.ajax({
				url: url,
				method: "POST",
				dataType: "json",
				data: parameters,
				context: this,
				success: CheckoutPayments.updateAmountFieldsWithTotalInJSON,
				error: function(jqXHR, textStatus, error) {
					console.debug("error - inside CheckoutPayments.getTotalInJSON()");
					console.debug(error);
					if(isVogue) {
						restoreAjaxButtons();
					}
					wcTopic.publish("ajaxRequestCompleted");
				}
		});
	},

	/**
	 * This is helper function for updateAmountFields. It retrieves the total from a JSON object and passes it to updateAmountFields.
	 * @param {Object} The data returned from $.ajax, formatted according to the dataType parameter or the dataFilter callback function, if specified
	 * @param {String} A string describing the status of the $.ajax call
	 * @param {Object} The jqXHR (in jQuery 1.4.x, XMLHttpRequest) object from $.ajax
	 */
	updateAmountFieldsWithTotalInJSON:function(data, textStatus, jqXHR){
		if (data != null && data != undefined) {
			 CheckoutPayments.updateAmountFields(data.orderTotal, data.operation, data.piFormName,data.skipOrderPrepare );
		}
		wcTopic.publish("ajaxRequestCompleted");
	},

	/**
	* This functions calculates payment amount value of each payment area
	* @param {String} updatedTotal The grand total of the order
	* @param {String} operation Identifies where this method is being called from, to determine the processing after.
	* @param {String} ipFormName Name of the payment form containing payment data
	* @param {String} skipOrderPrepare Indicates if Order Prepare process should be skipped.
	*/
	updateAmountFields:function(updatedTotal, operation, piFormName, skipOrderPrepare){
		var totalPayments = 0;
		var formName;
		var currentTotal = 0.0;
		this.numberOfPaymentMethods = 1;
		if(document.getElementById("OrderTotalAmount") != null){
			document.getElementById("OrderTotalAmount").value = updatedTotal;
		}
		if(this.numberOfPaymentMethods == 1){
			formName = document.forms["PaymentForm1"];
			if (formName.piAmount != null && formName.piAmount.value != "" && !isNaN(formName.piAmount.value)){
				formName.piAmount.value = updatedTotal;
				formName.piAmount_display.value = updatedTotal;
				this.formatAmountDisplayForLocale("1");
				if(this.retrievePaymentObject(1) != null){
					this.updatePaymentObject(1, 'piAmount');
				}
			}
			if(operation != undefined && operation == 'OrderPrepare'){
				this.processPIAndCheckout(piFormName,skipOrderPrepare);
			} else if ((operation != undefined && operation == 'loadPaymentSnippet') || supportPaymentTypePromotions) {
				if (this.currentPaymentMethodChanged) {
					this.loadPaymentSnippet(document.getElementById("payMethodId_" + this.currentPaymentMethodChanged), this.currentPaymentMethodChanged);
					this.updatePaymentObject(this.currentPaymentMethodChanged, 'payMethodId');
				}
			}

			return;
		}

		for (var i=1; i<=this.numberOfPaymentMethods; i++) {
			formName = document.forms["PaymentForm"+i];
			if (formName.piAmount != null && formName.piAmount.value != "" && !isNaN(formName.piAmount.value)){
				currentTotal = (currentTotal) * (1) + (formName.piAmount.value) * (1);
			}
		}

		var difference = updatedTotal - currentTotal;
		difference = Math.round(difference*100)/100;

		if(difference > 0){
			//So difference is > 0.. order total is increased.. add this to last payment..
			var j = this.numberOfPaymentMethods;
			formName = document.forms["PaymentForm"+j];
			if (formName.piAmount != null && formName.piAmount.value != "" && !isNaN(formName.piAmount.value)){
				formName.piAmount.value = parseFloat(formName.piAmount.value) + parseFloat(difference);
				formName.piAmount_display.value = formName.piAmount.value;
				this.formatAmountDisplayForLocale(j);
				if(this.retrievePaymentObject(j) != null){
					this.updatePaymentObject(j, 'piAmount');
				}
			}
		}
		else{
			//The order total is decreased..remove it from last payment..if last payment goes negative, then set it to 0 and remove remaining from last but one...and so on..
			difference = difference * -1;
			for(var k = this.numberOfPaymentMethods; k > 0; k--){
				formName = document.forms["PaymentForm"+k];
				if (formName.piAmount != null && formName.piAmount.value != "" && !isNaN(formName.piAmount.value)){
					if(formName.piAmount.value > difference){
						var t = formName.piAmount.value - difference;
						formName.piAmount.value = Math.round(t*100)/100;
						formName.piAmount_display.value = formName.piAmount.value;
						this.formatAmountDisplayForLocale(k);
						if(this.retrievePaymentObject(k) != null){
							this.updatePaymentObject(k, 'piAmount');
						}
						difference = 0;
						break;
					}
					else{
						//Set this payment to 0 and decrease the difference...
						difference = difference - formName.piAmount.value;
						formName.piAmount.value = 0;
						if(this.retrievePaymentObject(k) != null){
							this.updatePaymentObject(k, 'piAmount');
						}
						this.formatAmountDisplayForLocale(k);
					}
				}
			}
		}
		if(operation != undefined && operation == 'OrderPrepare'){
			this.processPIAndCheckout(piFormName,skipOrderPrepare);
		} else if (operation != undefined && operation == 'loadPaymentSnippet') {
			if (this.currentPaymentMethodChanged ) {
				this.loadPaymentSnippet(document.getElementById("payMethodId_" + this.currentPaymentMethodChanged), this.currentPaymentMethodChanged);
				this.updatePaymentObject(this.currentPaymentMethodChanged, 'payMethodId');
			}
		}
	},


	/**
	 * Removes the credit card number and the security code from the given payment area.
	 * @param {Integer} paymentAreaNumber The payment area number.
	 * @param {Boolean} removeCardNumber A true or false value to indicate if the credit card number should be removed from the payment form.
	 * @param {Boolean} removeCVV A true or false value to indicate if the credit card security code should be removed from the payment form.
	 */
	removeCreditCardNumberAndCVV: function(paymentAreaNumber, removeCardNumber, removeCVV){
		if(!CheckoutHelperJS.isPaymentDataDirty(paymentAreaNumber)){
			if(removeCardNumber){
				if(document.forms["PaymentForm" + paymentAreaNumber].valueFromProfileOrder == null || document.forms["PaymentForm" + paymentAreaNumber].valueFromProfileOrder.value != 'Y'){
					if($("#account1_" + paymentAreaNumber).length){
						$("#account1_" + paymentAreaNumber).val("");
					}
				}
			}
			if(removeCVV){
				if($("#cc_cvc_" + paymentAreaNumber).length){
					$("#cc_cvc_" + paymentAreaNumber).val("");
				}
			}
		}
	},
	
	/**
     * Removes the name on card from the given payment area.
     * @param {Integer} paymentAreaNumber The payment area number.
     * @param {Boolean} removeNameOnCard A true or false value to indicate if the name on card should be removed from the payment form.
     */
    removeNameOnCard: function(paymentAreaNumber, removeNameOnCard){
        if(!CheckoutHelperJS.isPaymentDataDirty(paymentAreaNumber)){
            if(removeNameOnCard){
                if($("#cc_nameoncard_" + paymentAreaNumber).length){
                    $("#cc_nameoncard_" + paymentAreaNumber).val("");
                }
            }
        }
    },

	/**
	 * Initializes the payment area dirty flags when the order shipping & billing page is loaded.
	 */
	initializePaymentAreaDataDirtyFlags: function(){
		CheckoutHelperJS.dataDirty[1] = false;
		CheckoutHelperJS.dataDirty[2] = false;
		CheckoutHelperJS.dataDirty[3] = false;
	},

	/**
	 * Initializes the master payment objects array when the order shipping & billing page is loaded.
	 */
	initializeOverallPaymentObjects: function(){
        //Aurora default
        //this.prevNumberOfPaymentMethods = document.getElementById('numberOfPaymentMethods').value;
		//this.numberOfPaymentMethods = parseInt($("#numberOfPaymentMethods").val());

        //Customized
		this.prevNumberOfPaymentMethods = 1;
		this.numberOfPaymentMethods = 1;
		var maxNumberOfPaymentMethodsSupported = parseInt(this.maxNumberOfPaymentMethodsSupported);

		for(var i=1; i<=maxNumberOfPaymentMethodsSupported; i++){
			this.initializePaymentObject(i);
		}

		var piIds = document.forms["PaymentForm1"].existingPiId.value;
		var unboundpiIds = null;
		if (document.forms["PaymentForm1"].unboundPiId) {
			unboundpiIds = document.forms["PaymentForm1"].unboundPiId.value;
			if(unboundpiIds != null && unboundpiIds != ""){
				var unboundpiArray = unboundpiIds.split(",");
			}
		}
		if(piIds != null && piIds != ""){
			var piArray = piIds.split(",");
			for(var i=0; i<piArray.length; i++){
				var paymentObjIndex = i+1;
				this.retrievePaymentObject(paymentObjIndex)['piId'] = piArray[i];
				document.forms["PaymentForm" + (paymentObjIndex)].piId.value = piArray[i];
				if(paymentObjIndex > this.numberOfPaymentMethods){
					// If regular payment instructions had already been registered with the order, then user goes back to the shopping cart page and chooses quick checkout,
					// and since only the payment defined in quick checkout profile would be displayed on the shipping & billing page, then the rest of payments that have been registered with the order need to be deleted.
					this.retrievePaymentObject(paymentObjIndex)['action'] = 'delete';
				}
				if(supportPaymentTypePromotions && unboundpiIds != null && unboundpiIds != ""){
					for(var j=0; j<unboundpiArray.length; j++){
						if (this.retrievePaymentObject(paymentObjIndex)['piId'] == unboundpiArray[j]) {
							this.retrievePaymentObject(paymentObjIndex)['action'] = 're-add';
							break;
						}
						}
				}
			}
		}else{
			this.retrievePaymentObject(1)['action'] = 'add';
		}
		// does quick checkout profile or payInStore qualify for payment type promotion?
		if(supportPaymentTypePromotions &&
				(this.getValue(document.forms['PaymentForm1'],"valueFromProfileOrder") == "Y" || this.getValue(document.forms['PaymentForm1'],"payMethodId") == "PayInStore"
					)){
			if(requestSubmitted){
				// 'requestSubmitted' will be set to false upon whole page loaded, listen to value change of 'requestSubmitted'
				this['updatePaymentTypePromotionForProfileCheckoutHandler'] = wcTopic.subscribe("requestSubmittedChanged", function(isRequestSubmitted) {
					if (!isRequestSubmitted ) {
						CheckoutPayments['updatePaymentTypePromotionForProfileCheckoutHandler'].remove();
						CheckoutPayments.updateUnboundPaymentToOrder();
					}
				});
			} else {
				this.updateUnboundPaymentToOrder();
			}
        }
	},

	/**
	 * Initializes a payment object for the given payment area.
	 * @param {Integer} paymentAreaNum The payment area number.
	 */
	initializePaymentObject: function(paymentAreaNum){
		var paymentObj = new Array();
		paymentObj['piId'] = "";
		paymentObj['action'] = "";
		paymentObj['fields'] = new Array();
		paymentObj['options'] = "";
		this.storePaymentObject(paymentAreaNum, paymentObj);
	},

	/**
	 * Stores the given payment object and its payment area number into the master payment objects array.
	 * @param {Integer} paymentAreaNum The payment area number.
	 * @param {Object} payObj The payment object to store.
	 */
	storePaymentObject: function(paymentAreaNum, payObj){
		this.paymentObjects[paymentAreaNum] = payObj;
	},

	/**
	 * Retrieves payment object associated with the given payment area number from the master payment objects array.
	 * @param {Integer} paymentAreaNum The payment area number.
	 * @return {Object} paymentObject The payment object associated with the given area number.
	 */
	retrievePaymentObject: function(paymentAreaNum){
		return this.paymentObjects[paymentAreaNum];
	},

	/**
	 * Updates the properties in a payment object.
	 * @param {Integer} paymentAreaNum The payment area number.
	 * @param {String} field The field that was changed by a user on the page.
	 */
	updatePaymentObject: function(paymentAreaNum, field){
		var paymentObj = this.retrievePaymentObject(paymentAreaNum);

		if(paymentObj != null){
			console.debug(field + " was changed.");
			if(paymentObj['piId'] == ''){
				paymentObj['action'] = 'add';
				console.debug("The action property in the payment object associated with payment area " + paymentAreaNum + " was updated to 'add'.");
			}else{
				if(field == 'piAmount' && paymentObj['action'] != 'add' && paymentObj['action'] != 'delete' && paymentObj['action'] != 're-add'){
					paymentObj['action'] = 'update';
					console.debug("The action property in the payment object associated with payment area " + paymentAreaNum + " was updated to 'update'.");
				}else{
					// For changes in fields other than piAmount, the existing payment instruction needs to be deleted first, then a new payment instruction will be created.
					paymentObj['action'] = 're-add';
					console.debug("The action property in the payment object associated with payment area " + paymentAreaNum + " was updated to 're-add'.");
				}
			}

			if(field == 'piAmount'){
				var thisFieldExists = false;
				for(var i=0; i< paymentObj['fields'].length; i++){
					if(paymentObj['fields'][i] == field){
						thisFieldExists = true;
						break;
					}
				}
				if(!thisFieldExists){
					paymentObj['fields'].push(field);
				}
			}
		}else{
			console.debug("CheckoutPayments.updatePaymentObject -- payment object not found.");
		}
		if(document.forms['PaymentForm1'].billing_address_id.value == ''){
            $(document.forms['PaymentForm1'].billing_address_id).find('option[selected=selected]').prop('selected', true);
		}
	},

	/**
	 * Stores the payment area number of the payment instruction that needs to be deleted.
	 * @param {Integer} paymentAreaNumber The payment area number of a payment instruction.
	 */
	setPaymentsToDelete: function(paymentAreaNumber){
		this.paymentsToDelete.push(paymentAreaNumber);
	},

	/**
	 * Retrieves the array containing the payment area numbers of all payment instructions that need to be deleted.
	 * @return {Array} paymentsToDelete The array that contains the payment area numbers.
	 */
	getPaymentsToDelete: function(){
		return this.paymentsToDelete;
	},

	/**
	 * Stores the payment area number of the payment instruction that needs to be added.
	 * @param {Integer} paymentAreaNumber The payment area number of a payment instruction.
	 */
	setPaymentsToAdd: function(paymentAreaNumber){
		this.paymentsToAdd.push(paymentAreaNumber);
	},

	/**
	 * Retrieves the array containing the payment area numbers of all payment instructions that need to be added.
	 * @return {Array} paymentsToDelete The array that contains the payment area numbers.
	 */
	getPaymentsToAdd: function(){
		return this.paymentsToAdd;
	},

	/**
	 * Stores the payment area number of the payment instruction that needs to be added.
	 * @param {Integer} paymentAreaNumber The payment area number of a payment instruction.
	 */
	setPaymentsToUpdate: function(paymentAreaNumber){
		this.paymentsToUpdate.push(paymentAreaNumber);
	},

	/**
	 * Retrieves the array containing the payment area numbers of all payment instructions that need to be added.
	 * @return {Array} paymentsToDelete The array that contains the payment area numbers.
	 */
	getPaymentsToUpdate: function(){
		return this.paymentsToUpdate;
	},


	/**
	 * Deletes payment instruction(s) from the current order.
	 */
	deletePaymentInstructions: function(){
		var params = [];
		if (this.getPaymentsToDelete().length > 0) {
			var paymentAreaNumber = this.getPaymentsToDelete().pop();
			params["paymentAreaNumber"] = paymentAreaNumber;
			params["orderId"] = document.forms["PaymentForm" + paymentAreaNumber].orderId.value;
			if(document.forms["PaymentForm" + paymentAreaNumber].authToken != null){
				params["authToken"] = document.forms["PaymentForm" + paymentAreaNumber].authToken.value;
			}
		}
		if(!submitRequest()){
			return;
		}
		cursor_wait();
		wcService.invoke('AjaxDeletePaymentInstructionFromThisOrder',params);
	},

	/**
	 * Adds payment instruction(s) to the current order.
	 */
	addPaymentInstructions: function(){
		var params = [];
		if(this.getPaymentsToAdd().length > 0) {
			var paymentAreaNumber = this.getPaymentsToAdd().pop();
			var form = document.forms["PaymentForm" + paymentAreaNumber];
			params = this.populateProtocolData(form,params);
		}
		if(!submitRequest()){
			return;
		}
        cursor_wait();
        wcService.invoke('AjaxAddPaymentInstructionToThisOrder',params);
	},
	
	retrivePaymentInstructions: function(){
		var params = {
		           orderId : CheckoutHelperJS.getSavedParameter('tempOrderId') 
		       };
		if(!submitRequest()){
			return;
		}
        cursor_wait();
        wcService.invoke('PaymentInfoEditTaskService',params);
	},

	/**
	 * Updates payment instruction(s) in the current order.
	 */
	updatePaymentInstructions: function(){
		var params = [];
		if(this.getPaymentsToUpdate().length > 0){
			var paymentAreaNumber = this.getPaymentsToUpdate().pop();
			var form = document.forms["PaymentForm" + paymentAreaNumber];
			var paymentObj = this.retrievePaymentObject(paymentAreaNumber);
			paymentObj['fields'].push('storeId');
			paymentObj['fields'].push('catalogId');
			paymentObj['fields'].push('langId');
			paymentObj['fields'].push('piId');
			paymentObj['fields'].push('payMethodId');
			paymentObj['fields'].push('authToken');
			paymentObj['fields'].push('orderId');
			document.forms["PaymentForm" + paymentAreaNumber].paymentDataEditable.value = false;
			paymentObj['fields'].push('paymentDataEditable');

			params = this.populateProtocolDataForGivenFields(form,params,paymentObj['fields']);
		}
		if(!submitRequest()){
			return;
		}
		cursor_wait();
		wcService.invoke('AjaxUpdatePaymentInstructionInThisOrder',params);
	},

	/**
	 * Updates the payment objects on the page when the number of payment methods is changed by a user.
	 * @param {Object} numberOfPaymentMethodsField The select drop-down object on the page that contains the number of payment methods.
	 */
	reinitializePaymentObjects: function(numberOfPaymentMethodsField){
		//Payment type promotion: call the updateUnboundPaymentToOrder() function
		if(supportPaymentTypePromotions){
			this.updateUnboundPaymentToOrder();
		}

		var currentNumberOfPaymentMethods = parseInt(numberOfPaymentMethodsField.value);
		var prevNumberOfPaymentMethods = parseInt(this.prevNumberOfPaymentMethods);
		var maxNumberOfPaymentMethodsSupported = parseInt(this.maxNumberOfPaymentMethodsSupported);
		if(currentNumberOfPaymentMethods < prevNumberOfPaymentMethods){
			for(var i=currentNumberOfPaymentMethods+1; i<=maxNumberOfPaymentMethodsSupported; i++){
				var paymentObj = this.retrievePaymentObject(i);
				if(paymentObj['piId'] == ''){
					paymentObj['action'] = '';
				}else{
					paymentObj['action'] = 'delete';
					console.debug("The action in the payment object associated with payment area " + i + " was updated to 'delete'.");
				}
			}
		}else if(currentNumberOfPaymentMethods > prevNumberOfPaymentMethods){
			for(var i=prevNumberOfPaymentMethods+1; i<=maxNumberOfPaymentMethodsSupported; i++){
				var paymentObj = this.retrievePaymentObject(i);
				if (paymentObj['piId'] != '') {
					// payment object has a piId, so it exists in the database and is not really a new payment object
					if (i > currentNumberOfPaymentMethods && i <=maxNumberOfPaymentMethodsSupported) {
						// delete any payment objects that exist beyond the current number of payment methods
						paymentObj['action'] == 'delete';
						console.debug("The action in the payment object associated with payment area " + i + " was updated to 'delete'.");
					}
					else {
						// re-add any payment objects that exist within the current number of payment methods
						paymentObj['action'] == 're-add';
						console.debug("The action in the payment object associated with payment area " + i + " was updated to 're-add'.");
					}
				}
				else {
					// payment object does not have a piId, so it really is a new payment object
					this.initializePaymentObject(i);
					console.debug("A new payment object was initialized to be associated with payment area " + i + ".");
				}

			}
		}
		this.prevNumberOfPaymentMethods = currentNumberOfPaymentMethods;
	},

	/**
	 * Payment type promotion - START
	 */

	/**
	 * Sets the value of the piId parameter in PaymentForm1 to the passed value.
	 * @param {Integer} piId The piId to set in PaymentForm.
	 * @param {Integer} paymentArea The payment area number for the Payment form.
	 */
	setPaymentFormPiId: function(paymentArea,piId){
	   var formObj = document.forms['PaymentForm'+ paymentArea];
	   if (formObj){
		   //payInStore only have 1 form
		   formObj["piId"].value = piId;
	   }
	},

	/**
	 * Adds or removes an unbounded payment to/from the current order.
	 * An unbound payment is a dummy/temporary payment instruction added to
	 * an order without any of its protocol data information.
	 *
	 * The function is invoked when numberOfPaymentMethods or payment method is chosen/changed.
	 * The function works in following way:
	 * 1. the method try to delete all payment instructions and clear all payment objects first
	 * 2. upon the deletion of existing payment instructions, a new dummy payment instruction
	 * 	  will be added if <code>isSinglePaymentType</code> return <code>true</code>, the function
	 *	  <code>addNewUnboundPaymentInstruction</code> will be invoked. See also
	 *	  <code>AjaxDeleteUnboundPaymentInstructionFromThisOrder</code> for detail.
	 * 3. if <code>isSinglePaymentType</code> return <code>false</code>, leave the order without
	 *    any payment instruction.
	 * 4. upon adding or deleting of payment instruction. The service
	 *    <code>AjaxPrepareOrderForPaymentSubmit</code> will be invoked to determine if
	 *    the order qualify for payment type promotion.
	 */
	updateUnboundPaymentToOrder: function(paymentMethodChanged){
		this.currentPaymentMethodChanged = paymentMethodChanged;
		 var form1 = document.forms["PaymentForm1"];
		 var piIdForm1 = this.getValue(form1, "piId");
			 // If payment methods existed already, delete it.
		 if(piIdForm1 != null && piIdForm1 != ""){
			var params = [];
			params.storeId = this.storeId;
			params.catalogId = this.catalogId;
			params.langId = this.langId;
			params.orderId = ".";
			params.piId = "";
			if(!submitRequest()){
				 return;
			}
			cursor_wait();
			wcService.invoke('AjaxDeleteUnboundPaymentInstructionFromThisOrder', params);
		 } else if (this.isSinglePaymentType()) {
			this.addNewUnboundPaymentInstruction();
		 } else if (paymentMethodChanged ){
			this.loadPaymentSnippet(document.getElementById("payMethodId_" + paymentMethodChanged), paymentMethodChanged);
			this.updatePaymentObject(paymentMethodChanged, 'payMethodId');
		 }
	},

	/**
	 * Adds a new unbounded payment method to the order. An unbound payment is a
	 * dummy/temporary payment instruction added to an order without any of its
	 * protocol data information. Only add unbounded payment method when all
	 * selected payment types are same.
	 */
	addNewUnboundPaymentInstruction: function(){
	   var form = document.forms["PaymentForm1"];
	   var params = [];
	   params.storeId = this.storeId;
	   params.catalogId = this.catalogId;
	   params.langId = this.langId;
	   if(document.forms["PaymentForm1"].authToken != null){
			params["authToken"] = document.forms["PaymentForm1"].authToken.value;
	   }

	   params["payMethodId"] = this.getValue(form,"payMethodId",true);
	   params["unbound"] = true;

	   if(params["payMethodId"] != "empty" && params["payMethodId"] != ""){
		  if(!submitRequest()){
			return;
		  }
		  cursor_wait();
		  wcService.invoke('AjaxAddUnboundPaymentInstructionToThisOrder', params);
	   }

   },

   /**
	 * Check whether the all selected payment types are same or not
	 * @return {boolean} true if selected payment types are same, false otherwise
	 */
   isSinglePaymentType: function() {
		var form = document.forms["PaymentForm1"];
		var fistFormPayType = this.getValue(form,"payMethodId");
		var isSinglePaymentType = fistFormPayType != "empty" && fistFormPayType != "";
		for (var i = 2; isSinglePaymentType && i <= this.numberOfPaymentMethods; i++) {
			var currentPaymentForm = document.forms["PaymentForm" + i];
			var currntPayType = this.getValue(currentPaymentForm,"payMethodId")
			isSinglePaymentType = currntPayType == fistFormPayType;
		}
		return isSinglePaymentType;
   },
  /**
   * Payment type promotion - END
   */

   /**
    * Initializes the Cardinal Cruise when the order shipping & billing page is loaded.
    */
   initializeCardinalCruise : function() {
       var cardinalLoggingLevel = $("#JWT").attr("cardinalLoggingLevel");
       var timeout = $("#JWT").attr("timeout");
       var maxRequestRetries = $("#JWT").attr("maxRequestRetries");

       if (cardinalLoggingLevel.length == 0) {
           cardinalLoggingLevel = "off";    //possible values: on, off or verbose
       }
       if (timeout.length == 0) {
           timeout = 8000;    //set to default value
       }
       if (maxRequestRetries.length == 0) {
           maxRequestRetries = 2    //set to default value
       }

       Cardinal.configure({
           timeout: timeout,
           maxRequestRetries: maxRequestRetries,
           logging : {
               level : cardinalLoggingLevel
           },
           payment : {
               displayLoading : true
           }
       });

       Cardinal.setup("init", {
           jwt : $("#JWT").val()
       });

       Cardinal.on('payments.setupComplete', function() {
           console.log("payments.setupComplete");
           $("#JWT").attr("setupComplete", "true");
       });

       Cardinal.on("payments.validated", function(data, jwt) {
           if (data.Validated != undefined && data.ErrorNumber != 0) {
               if ($("#JWT").attr("ignoreAuthOnCardinalError") == "true" && $("#JWT").attr("setupComplete") == "true") {
                   $("#JWT").attr("ignoreAuthService", "true");
                   makePayment('cc');
               } else {
                   MessageHelper.displayErrorMessage(data.ErrorDescription);
                   pushErrorToTealium("Server",data.ErrorDescription,"Error occurred on PSD2 side",String(data.ErrorNumber));
				   if(isVogue){
						deletePaymentLoaderOverlay(); //deletes a dark overlay with a spinner();
					}						
                   cursor_clear();
               }
           } else {
               $("#JWT").attr("responseJWT", jwt);
               makePayment('cc');
           }
       });
   }
}

//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2008, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

//
//

/**
 * @fileOverview This file declares services that are used in the store check-out pages.
 */


/**
 * This file declares services that are used in the store check-out pages.
 *
 * @class This SBServicesDeclarationJS class defines all the variables and functions for the page(s) that use shipping and billing functionality in the store.
 *
 */
SBServicesDeclarationJS = {
	/**
	 * This variable stores the ID of the language that the store is currently using.
	 *
	 * @private
	 */
	langId: "-1",

	/**
	 * This variable stores the ID of the current store.
	 *
	 * @private
	 */
	storeId: "",

	/**
	 * This variable stores the ID of the catalog that is used in the store.
	 *
	 * @private
	 */
	catalogId: "",

	/**
	 * This variable stores the true/false value that indicates if the 'SinglePageCheckout' feature is enabled/disabled.
	 * When it is true, both shipping and billing information are captured in a single page. If it is false, checkout will
	 * be a two step process where shipping is captured in first step and billing in second step.
	 * It is set to true by default.
	 *
	 * @private
	 */
	singlePageCheckout:true,

	/**
	 * This variable stores the value that indicates if an <code>OrderProcessServiceOrderPrepare</code> service call is required.
	 *
	 * @private
	 */
	orderPrepare: false,


	/**
 	 * Sets the common parameters for this instance.
 	 *
 	 * @param {int} langId The ID of the language used in the store.
 	 * @param {int} storeId The ID of the store.
 	 * @param {catalogId} catalogId The ID of the catalog used in the store.
	 */
	setCommonParameters:function(langId,storeId,catalogId){
			this.langId = langId;
			this.storeId = storeId;
			this.catalogId = catalogId;
	},


	/**
	 * Sets the SinglePageCheckout variable to indicate if the 'SinglePageCheckout' feature is enabled or disabled.
	 *
	 * @param {Boolean} singlePageCheckout. A true/false value that indicates if the 'SinglePageCheckout' feature is enabled.
	 *
	 * @see CheckoutHelperJS.isSinglePageCheckout
	 */
	setSinglePageCheckout:function(singlePageCheckout){
		this.singlePageCheckout = singlePageCheckout;
	},


	/**
	 * Returns the singlePageCheckout variable that indicates if the 'SinglePageCheckout' feature is enabled/disabled.
	 *
	 * @returns {Boolean} singlePageCheckout A true/false value that indicates if the 'SinglePageCheckout' feature is
	 * enabled/disabled.
	 *
	 * @see CheckoutHelperJS.setSinglePageCheckout
	 */
	isSinglePageCheckout:function(){
		return this.singlePageCheckout;
	}

}

/**
 * Declares an AJAX service that adds an item to the wish list and delete an item from the shopping cart.
 * @constructor
 */
wcService.declare({
	id: "AjaxInterestItemAddAndDeleteFromCart",
	actionId: "AjaxInterestItemAddAndDeleteFromCart",
	url: "AjaxInterestItemAdd",
	formId: ""

	/**
	 * Hides the progress bar and deletes the order item from the shopping cart.
	 *
	 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
	 */
	,successHandler: function(serviceResponse) {
		cursor_clear();
		CheckoutHelperJS.deleteFromCart(serviceResponse.orderItemId);
	}

	/**
	 * Displays the error message returned with the service response and hides the progress bar.
	 *
	 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
	 */
	,failureHandler: function(serviceResponse) {
		if (serviceResponse.errorMessage) {
			MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
		} else {
			if (serviceResponse.errorMessageKey) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
			}
		}
		cursor_clear();
	}

}),


/**
 * Declares an AJAX service that updates the shipping address and shipping method for items in the order.
 * @constructor
 */
wcService.declare({
	id: "OrderItemAddressShipMethodUpdate",
	actionId: "OrderItemAddressShipMethodUpdate",
	url: "AjaxRESTOrderShipInfoUpdate",
	formId: ""

	/**
	 * hides all the messages and the progress bar
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation
	 */
	,successHandler: function(serviceResponse) {
		MessageHelper.hideAndClearMessage();
		cursor_clear();
	}

	/**
	 * Displays the error message returned with the service response and hides the progress bar.
	 *
	 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
	 */
	,failureHandler: function(serviceResponse) {
		if (serviceResponse.errorMessage) {
			MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
		} else {
			if (serviceResponse.errorMessageKey) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
			}
		}
		cursor_clear();
	}

}),

/**
 * Declares an AJAX service that updates the shipping charge type for items in the order.
 * @constructor
 */
wcService.declare({
	id: "AjaxOrderShipChargeUpdate",
	actionId: "AjaxOrderShipChargeUpdate",
	url: "AjaxShipInfoUpdate",
	formId: ""

	/**
	 * hides all the messages and the progress bar
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation
	 */
	,successHandler: function(serviceResponse) {
		/*
		MessageHelper.hideAndClearMessage();
		cursor_clear();
		*/
		var params = [];
		params.orderId = ".";
		params["storeId"] = CheckoutHelperJS.storeId;
		params["catalogId"] = CheckoutHelperJS.catalogId;
		params["langId"] = CheckoutHelperJS.langId;
		wcService.invoke("AjaxPrepareOrderForShipChargeUpdate", params);
	}

	/**
	 * Displays the error message returned with the service response and hides the progress bar.
	 *
	 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
	 */
	,failureHandler: function(serviceResponse) {
		if (serviceResponse.errorMessage) {
			MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
		} else {
			if (serviceResponse.errorMessageKey) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
			}
		}
		cursor_clear();
	}

}),

/**
 *This service calculates charges, performs inventory actions, and locks the
 *price of the order to indicate that the order can be submitted.
 *A message is displayed after the service call.
 * @constructor
 */
wcService.declare({
	id: "AjaxPrepareOrderForShipChargeUpdate",
	actionId: "AjaxPrepareOrderForShipChargeUpdate",
	url: getAbsoluteURL() + "AjaxRESTOrderPrepare",
	formId: ""
    /**
   * hides all the messages and the progress bar
   * @param (object) serviceResponse The service response object, which is the
   * JSON object returned by the service invocation
   */
	,successHandler: function(serviceResponse) {
		MessageHelper.hideAndClearMessage();
			cursor_clear();
	}

    /**
   * hides all the messages and the progress bar
   * @param (object) serviceResponse The service response object, which is the
   * JSON object returned by the service invocation
   */
	,failureHandler: function(serviceResponse) {

		if (serviceResponse.errorMessage) {
			MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
		}
		else {
			 if (serviceResponse.errorMessageKey) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
			 }
		}
		cursor_clear();
	}

}),


/**
 * Declares an AJAX service that updates the shipping address and shipping instruction for items in the order.
 * @constructor
 */
wcService.declare({
	id: "OrderItemAddressShipInstructionsUpdate",
	actionId: "OrderItemAddressShipInstructionsUpdate",
	url: "AjaxRESTOrderShipInfoUpdate",
	formId: ""

	/**
	 * Invokes the <code>OrderItemAddressShipInstructionsUpdate1</code> service if shipping instructions were specified, otherwise hides all the messages and the progress bar
	 *
	 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
	 */
	,successHandler: function(serviceResponse) {
		var params = [];
		params.orderId = ".";
		params["storeId"] = CheckoutHelperJS.storeId;
		params["catalogId"] = CheckoutHelperJS.catalogId;
		params["langId"] = CheckoutHelperJS.langId;
		params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
		params.calculateOrder = "1";

		//Check if Shipping Instructions is enabled
		if(document.getElementById("shipInstructions") != null){
			var shipInstructions = document.getElementById("shipInstructions").value;
			var orderItemId = document.getElementById("orderItem_1").value;

			params["shipInstructions"] = shipInstructions;
			params["orderItemId"] = orderItemId;

			wcService.invoke("OrderItemAddressShipInstructionsUpdate1", params);
		} else {
			MessageHelper.hideAndClearMessage();
			cursor_clear();
		}
	}

	/**
	 * Displays the error message returned with the service response and hides the progress bar.
	 *
	 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
	 */
	,failureHandler: function(serviceResponse) {
		if (serviceResponse.errorMessage) {
			MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
		} else {
			if (serviceResponse.errorMessageKey) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
			}
		}
		cursor_clear();
	}

}),


/**
 * Declares an AJAX service that updates the shipping instruction for items in the order.
 * @constructor
 */
wcService.declare({
	id: "OrderItemAddressShipInstructionsUpdate1",
	actionId: "OrderItemAddressShipInstructionsUpdate1",
	url: "AjaxRESTOrderShipInfoUpdate",
	formId: ""

	/**
	 * hides all the messages and the progress bar
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation
	 */
	,successHandler: function(serviceResponse) {
		MessageHelper.hideAndClearMessage();
		cursor_clear();
	}

	/**
	 * Displays the error message returned with the service response and hides the progress bar.
	 *
	 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
	 */
	,failureHandler: function(serviceResponse) {
		if (serviceResponse.errorMessage) {
			MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
		} else {
			if (serviceResponse.errorMessageKey) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
			}
		}
		cursor_clear();
	}

}),

/**
 * Declares an AJAX service that updates the shipping method for items in the order. This service is used to move all order items to single addressId and shipModeId when a user clicks on the single shipment button.
 * @constructor
 */
wcService.declare({
	id: "OrderItemAddressShipMethodUpdate1",
	actionId: "OrderItemAddressShipMethodUpdate1",
	url: "AjaxRESTOrderShipInfoUpdate",
	formId: ""

	/**
	 * Invokes the <code>OrderChangeServiceShipInfoUpdate</code> service, then redirects the browser to OrderShippingBillingView.
	 *
	 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
	 */
	,successHandler: function(serviceResponse) {
		//Store the ids
		var storeId = CheckoutHelperJS.storeId;
		var catalogId = CheckoutHelperJS.catalogId;
		var langId = CheckoutHelperJS.langId;
		var orderId = serviceResponse.orderId;

		//Obtain the shipmode id for the first order item
		var orderItemId = document.getElementById("orderItem_1").value;
		var commonShipModeId = document.getElementById("commonShipModeId").value;
		if(commonShipModeId !=null && commonShipModeId!='undefined'){
			var shipModeId = commonShipModeId;
		}else{
			var shipModeId = document.getElementById("MS_ShippingMode_"+orderItemId).value;
		}

		var postRefreshHandlerParameters = [];
		var initialURL = "AjaxRESTOrderShipInfoUpdate";
		var urlRequestParams = [];
		urlRequestParams["remerge"] = "***";
		urlRequestParams["check"] = "*n";
		urlRequestParams["allocate"] = "***";
		urlRequestParams["backorder"] = "***";
		urlRequestParams["storeId"] = storeId;
		urlRequestParams["catalogId"] = catalogId;
		urlRequestParams["langId"] = langId;
		urlRequestParams["orderId"] = orderId;
		urlRequestParams["shipModeId"] = shipModeId;
		urlRequestParams["calculationUsage"] = "-1,-2,-3,-4,-5,-6,-7";
		urlRequestParams["calculateOrder"] = "1";

		//do not want to pass an empty purchaseorder_id to OrderChangeServiceShipInfoUpdate because it'll cause an failure in OrderFacadeClient.java
		var purchaseorderRef = document.getElementById("purchase_order_number");
		if(purchaseorderRef){
			var purchaseorder_id = purchaseorderRef.value;
			if(purchaseorder_id !=null && purchaseorder_id !='undefined' && purchaseorder_id !=''){
				urlRequestParams["purchaseorder_id"] = purchaseorder_id;
			}
		}
		//checks to see if quick checkout is enabled to display the credit card masked info  by checking the valueFromProfileOrder parameter
		if (valueFromProfileOrderElement = document.getElementsByName("valueFromProfileOrder")[0]&&valueFromProfileOrderElement.value == 'Y') {
			urlRequestParams["quickCheckoutProfileForPayment"] = "true";
		}
		postRefreshHandlerParameters.push({"URL":"OrderShippingBillingView","requestType":"GET", "requestParams":{}});
		var service = getCustomServiceForURLChaining(initialURL,postRefreshHandlerParameters,null);
		service.invoke(urlRequestParams);
	}

	/**
	 * Displays the error message returned with the service response and hides the progress bar.
	 *
	 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
	 */
	,failureHandler: function(serviceResponse) {
		if(serviceResponse.errorMessageKey == '_ERR_INVALID_ADDR'){
			MessageHelper.displayErrorMessage(MessageHelper.messages["ERROR_SWITCH_SINGLE_SHIPMENT"]);
		} else {
			if (serviceResponse.errorMessage) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
			} else {
				if (serviceResponse.errorMessageKey) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
				}
			}
		}
		cursor_clear();
	}
}),

/**
 * Declares an AJAX service that updates the shipping address for items in the order.
 * @constructor
 */
wcService.declare({
	id: "AjaxUpdateOrderItemsAddressId",
	actionId: "AjaxUpdateOrderItemsAddressId",
	url: "AjaxRESTOrderShipInfoUpdate",
	formId: ""

	/**
	 * After service was successfully performed, hides all messages and the progress bar.
	 * Otherwise, routes to shipping and billing page.
	 *
	 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
	 */
	,successHandler: function(serviceResponse) {
		MessageHelper.hideAndClearMessage();
		CheckoutHelperJS.orderItemIds = [];
		cursor_clear();
	}

	/**
	 * Displays the error message returned with the service response and hides the progress bar.
	 *
	 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
	 */
	,failureHandler: function(serviceResponse) {
		if (serviceResponse.errorMessage) {
			MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
		} else {
			if (serviceResponse.errorMessageKey) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
			}
		}
		cursor_clear();
	}
}),


/**
 * Declares an AJAX service that adds a billing address during order check-out.
 * @constructor
 */
wcService.declare({
	id: "AddBillingAddressInCheckOut",
	actionId: "AddBillingAddressInCheckOut",
	url: "AjaxPersonChangeServiceAddressAdd",
	formId: ""

	/**
	 * This function renders the area having the context ID contextForMainAndAddressDiv with the specified properties.
	 *
	 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
	 */
	,successHandler: function(serviceResponse) {
		cursor_clear();
		wcRenderContext.updateRenderContext('contextForMainAndAddressDiv', {'showArea':'mainContents','hideArea':'editAddressContents'});
		if (this.formId != '' && document.getElementById(this.formId)){
			serviceResponse.addBillingAddressInCheckOutAddressType = document.getElementById(this.formId).addressType.value;
		}
	}

	/**
	 * Displays the error message returned with the service response and hides the progress bar.
	 *
	 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
	 */
	,failureHandler: function(serviceResponse) {
		if (serviceResponse.errorMessage) {
			MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
		} else {
			if (serviceResponse.errorMessageKey) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
			}
		}
		cursor_clear();
	}
}),

/**
 * This service edits an billing address for the person during checkout. An error message is displayed
 * if the service failed.
 * @constructor
 */
wcService.declare({
	id: "UpdateBillingAddressInCheckout",
	actionId: "UpdateBillingAddressInCheckout",
	url: getAbsoluteURL() + "AjaxPersonChangeServiceAddressUpdate",
	formId: ""

/**
 * hides all the messages and the progress bar
 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation
 *
 */
	,successHandler: function(serviceResponse) {
		cursor_clear();
		wcRenderContext.updateRenderContext('contextForMainAndAddressDiv', {'showArea':'mainContents','hideArea':'editAddressContents'});
	}
 /**
 * display an error message
 * @param (object) serviceResponse The service response object, which is the
 * JSON object returned by the service invocation
 */
	,failureHandler: function(serviceResponse) {

		if (serviceResponse.errorMessage) {
			MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
		}
		else {
			 if (serviceResponse.errorMessageKey) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
			 }
		}
		cursor_clear();
	}

}),

/**
 * Declares an AJAX service that updates shipping information for order items during check-out.
 * @constructor
 */
wcService.declare({
	id: "OrderShippingInfoUpdate",
	actionId: "OrderShippingInfoUpdate",
	url: "AjaxRESTOrderShipInfoUpdate",
	formId: ""

	/**
	 * Clears the progress bar.
	 *
	 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
	 */
	,successHandler: function(serviceResponse) {
		cursor_clear();
	}

	/**
	 * Displays the error message returned with the service response and hides the progress bar.
	 *
	 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
	 */
	,failureHandler: function(serviceResponse) {
		if (serviceResponse.errorMessage) {
			MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
		} else {
			if (serviceResponse.errorMessageKey) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
			}
		}
		cursor_clear();
	}
}),


/**
 * Declares an AJAX service that prepares order information before submitting the order.
 * @constructor
 */
wcService.declare({
	id: "AjaxPrepareOrderBeforeSubmit",
	actionId: "AjaxPrepareOrderBeforeSubmit",
	url: "AjaxRESTOrderPrepare",
	formId: ""

	/**
	 * Submits the order with the name of the payment form.
	 *
	 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
	 */
	,successHandler: function(serviceResponse) {
        console.log("PSL::ShippingAndBillingServicesDeclaration.js::AjaxPrepareOrderBeforeSubmit service::successHandler");
		cursor_clear();
		CheckoutPayments.getTotalInJSON("OrderPrepare", 'PaymentForm', false);
	}

	/**
	 * Displays the error message returned with the service response and hides the progress bar.
	 *
	 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
	 */
	,failureHandler: function(serviceResponse) {
        console.log("PSL::ShippingAndBillingServicesDeclaration.js::AjaxPrepareOrderBeforeSubmit service::failureHandler");
		if (serviceResponse.errorMessage) {
			MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
			
			if(serviceResponse.errorMessageKey == "_ERR_NO_ELIGIBLE_TRADING" || serviceResponse.errorMessageKey == "_ERR_RETRIEVE_PRICE" 
                || serviceResponse.errorMessageKey == "_API_CANT_RESOLVE_FFMCENTER" || serviceResponse.errorMessageKey == "_ERR_PROD_NOT_ORDERABLE"
                || serviceResponse.errorMessageKey == "_ERR_PROD_NOT_BUYABLE") {
                pushErrorToTealium('Product', serviceResponse.errorMessage, 'error occured on payment of order');
            }
            else{
                pushErrorToTealium('Server', serviceResponse.errorMessage, 'error occured on payment of order');
            }
			
		} else {
			if (serviceResponse.errorMessageKey) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
				pushErrorToTealium('Server', serviceResponse.errorMessage, 'error occured on payment of order','');
			}
		}
		cursor_clear();
	}

}),

/**
 * Declares an AJAX service that prepares order information before submitting the order.
 * @constructor
 */
wcService.declare({
	id: "AjaxPrepareOrderBeforePaymentCapture",
	actionId: "AjaxPrepareOrderBeforePaymentCapture",
	url: "AjaxRESTOrderPrepare",
	formId: ""

	/**
	 * Submits the order with the name of the payment form.
	 *
	 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
	 */
	,successHandler: function(serviceResponse) {
		CheckoutPayments.setCommonParameters(SBServicesDeclarationJS.langId,SBServicesDeclarationJS.storeId,SBServicesDeclarationJS.catalogId);
		CheckoutPayments.showBillingPage();
		cursor_clear();
	}


	/**
	 * Displays the error message returned with the service response and hides the progress bar.
	 *
	 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
	 */
	,failureHandler: function(serviceResponse) {
		if (serviceResponse.errorMessage) {
			MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
		} else {
			if (serviceResponse.errorMessageKey) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
			}
		}
		cursor_clear();
	}

}),

/**
 * Declares an AJAX service that sets the address ID for all items in the order.
 * @constructor
 */
wcService.declare({
	id: "AjaxSetAddressIdOfOrderItems",
	actionId: "AjaxSetAddressIdOfOrderItems",
	url: "AjaxRESTOrderShipInfoUpdate",
	formId: ""

	/**
	 * Redirects the browser to OrderShippingBillingView
	 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
	 */
	,successHandler: function(serviceResponse) {
		if($('#newCheckout').length > 0){ //only for new checkout
			loadAddressInfo();
		}else if (isKlarnaExpressProcessing){
			//do not redirect if klarna express checkout was clicked and authentication succeded
			//save addressId
			var url = "/wcs/resources/store/" + ServicesDeclarationJS.storeId + "/person/@self/contact";
			$.ajax({
				url: url,
				type: 'GET',
				async: false,
				headers: {
					"Content-Type": "application/json",
					"Cache-Control": "no-cache, no-store, must-revalidate"
				},
				data: {
					"timestamp": Date.now()
				},
				success: function (data) {
					isKlarnaExpressProcessing = false;
					if(data.contact != undefined){
						billingAddressId = data.contact[0].addressId;
						$("#billingAddressIdForKlarna").val(billingAddressId);
						invokeKlarnaForwardAndUpdate();
					} else {
						MessageHelper.displayErrorMessage("There was a problem while retrieving current user contact data.");
					}
				},
				error: function(){
					isKlarnaExpressProcessing = false;
					restoreAjaxButtons();
					console.log("PSL::AddressHelper.js::Error getting contact");
				}
			});
		}else {
			var url="OrderShippingBillingView?orderId="+(serviceResponse.orderId?serviceResponse.orderId:".")+"&langId="+serviceResponse.langId+"&storeId="+serviceResponse.storeId+"&catalogId="+serviceResponse.catalogId+"&showRegTag=T";
			document.location.href=appendWcCommonRequestParameters(url);
		}
		
	}

	/**
	 * Displays the error message returned with the service response and hides the progress bar.
	 *
	 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
	 */
	,failureHandler: function(serviceResponse) {
		if (serviceResponse.errorMessage) {
			MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
		} else {
			if (serviceResponse.errorMessageKey) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
			}
		}
		document.getElementById("OrderShippingBillingErrorArea").style.display = "block";
		cursor_clear();
	}

}),


/**
 * Declares an AJAX service that sets the shipping mode ID for the order.
 * @constructor
 */
wcService.declare({
	id: "AjaxSetShipModeIdForOrder",
	actionId: "AjaxSetShipModeIdForOrder",
	url: "AjaxRESTOrderShipInfoUpdate",
	formId: ""

	/**
	 * Redirects the browser to OrderShippingBillingView.
	 *
	 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
	 */
	,successHandler: function(serviceResponse) {
		var url="OrderShippingBillingView?langId="+SBServicesDeclarationJS.langId+"&storeId="+SBServicesDeclarationJS.storeId+"&catalogId="+SBServicesDeclarationJS.catalogId;
		document.location.href=appendWcCommonRequestParameters(url);
	}

	/**
	 * Displays the error message returned with the service response and hides the progress bar.
	 *
	 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
	 */
	,failureHandler: function(serviceResponse) {
		if (serviceResponse.errorMessage) {
			MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
		} else {
			if (serviceResponse.errorMessageKey) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
			}
		}
		document.getElementById("OrderShippingBillingErrorArea").style.display = "block";
		cursor_clear();
	}

}),

/**
 * Declares an AJAX service that sets the requested ship date for all items in the order.
 * @constructor
 */
wcService.declare({
	id: "AjaxSetRequestedShipDateForOrder",
	actionId: "AjaxSetRequestedShipDateForOrder",
	url: "AjaxRESTOrderShipInfoUpdate",
	formId: ""

	/**
	 * Redirects the browser to OrderShippingBillingView
	 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
	 */
	,successHandler: function(serviceResponse) {
		var url = "OrderShippingBillingView?orderId="+(serviceResponse.orderId?serviceResponse.orderId:".")+"&langId="+SBServicesDeclarationJS.langId+"&storeId="+SBServicesDeclarationJS.storeId+"&catalogId="+SBServicesDeclarationJS.catalogId+"&showRegTag=T";
		document.location.href=appendWcCommonRequestParameters(url);
	}

	/**
	 * Displays the error message returned with the service response and hides the progress bar.
	 *
	 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
	 */
	,failureHandler: function(serviceResponse) {
		if (serviceResponse.errorMessage) {
			MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
		} else {
			if (serviceResponse.errorMessageKey) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
			}
		}
		document.getElementById("OrderShippingBillingErrorArea").style.display = "block";
		cursor_clear();
	}

}),


/**
* This service adds a shipping and billing address during order check out. An error message is displayed if the service failed.
* @constructor
*/
wcService.declare({
	id: "AjaxAddShippingAndBillingAddressForPersonDuringCheckout",
	actionId: "AjaxAddShippingAndBillingAddressForPersonDuringCheckout",
	url: getAbsoluteURL() + "AjaxPersonChangeServiceAddressAdd",
	formId: ""

/**
* Hides all the messages and the progress bar
* @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
*/
	,successHandler: function(serviceResponse) {
		if (this.formId != ""){
			serviceResponse.originalServiceId = document.getElementById(this.formId).originalServiceId.value;
		}
		MessageHelper.hideAndClearMessage();
		cursor_clear();
	}

/**
* Displays an error message in case of failure.
* @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
*/
	,failureHandler: function(serviceResponse) {

		if (serviceResponse.errorMessage) {
			MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
		}
		else {
			 if (serviceResponse.errorMessageKey) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
			 }
		}
		cursor_clear();
	}

}),
/**
* This service updates a shipping and billing address during order check out. An error message is displayed if the service failed.
* @constructor
*/
wcService.declare({
	id: "AjaxUpdateShippingAndBillingAddressForPersonDuringCheckout",
	actionId: "AjaxUpdateShippingAndBillingAddressForPersonDuringCheckout",
	url: getAbsoluteURL() + "AjaxPersonChangeServiceAddressUpdate",
	formId: ""

/**
* Hides all the messages and the progress bar
* @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
*/
	,successHandler: function(serviceResponse) {
		if (this.formId != ""){
			serviceResponse.originalServiceId = document.getElementById(this.formId).originalServiceId.value;
		}
		MessageHelper.hideAndClearMessage();
		cursor_clear();
	}

/**
* Displays an error message in case of failure.
* @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
*/
	,failureHandler: function(serviceResponse) {

		if (serviceResponse.errorMessage) {
			MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
		}
		else {
			 if (serviceResponse.errorMessageKey) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
			 }
		}
		cursor_clear();
	}

}),
/**
* Declares an AJAX service that deletes payment instructions from the current order.
* @constructor
*/
wcService.declare({
	id: "AjaxDeletePaymentInstructionFromThisOrder",
	actionId: "AjaxDeletePaymentInstructionFromThisOrder",
	url: "PaymentDeleteTaskService",
	formId: ""

	/**
	 * Removes piId from payment objects and payment forms on the page, clears the progress bar.
	 * Invokes the AjaxPrepareOrderBeforeProceedingToSummary service to prepare order information.
	 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
	 */
	,successHandler: function(serviceResponse) {
		var paymentObj = CheckoutPayments.retrievePaymentObject(serviceResponse["paymentAreaNumber"]);
		if (typeof(paymentObj) != "undefined") {
			paymentObj['piId'] = "";
		}
		cursor_clear();
		if (serviceResponse.message){
			console.log(serviceResponse.message);
		}
		if (CheckoutPayments.getPaymentsToDelete().length < 1) {
			cursor_clear();
			if(CheckoutPayments.getPaymentsToAdd().length > 0){
				CheckoutPayments.addPaymentInstructions();
			}else if(CheckoutPayments.getPaymentsToUpdate().length > 0){
				CheckoutPayments.updatePaymentInstructions();
			}else{
				if(!submitRequest()){
					return;
				}
				cursor_wait();
				CheckoutPayments.setCommonParameters(SBServicesDeclarationJS.langId,SBServicesDeclarationJS.storeId,SBServicesDeclarationJS.catalogId);
				CheckoutPayments.showSummaryPage();
				cursor_clear();
			}
		} else {
			CheckoutPayments.deletePaymentInstructions();
		}
	}

	/**
	 * Resets the array object that contains existing payment objects to delete.
	 * Displays the error message returned with the service response and hides the progress bar.
	 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
	 */
	,failureHandler: function(serviceResponse) {
		CheckoutPayments.paymentsToDelete = new Array();
		if (serviceResponse.errorMessage) {
			MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
		} else {
			if (serviceResponse.errorMessageKey) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
			}
		}
		cursor_clear();
	}

}),


/**
* Declares an AJAX service that adds a payment instruction to the current order.
* @constructor
*/
wcService.declare({
	id: "AjaxAddPaymentInstructionToThisOrder",
	actionId: "AjaxAddPaymentInstructionToThisOrder",
	url: "AjaxRESTOrderPIAdd",
	formId: ""

	/**
	 * Resets the array object that contains payment objects to add. Verifies if there is any payment instruction that needs to be updated.
	 * If there is no payment instruction that needs to be updated, direct the browser to the order summary page.
	 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
	 */
	,successHandler: function(serviceResponse) {
        console.log("PSL::ShippingAndBillingServicesDeclaration.js::AjaxAddPaymentInstructionToThisOrder success handler::BEGIN");
		cursor_clear();
		if (CheckoutPayments.getPaymentsToAdd().length < 1) {
			if(CheckoutPayments.getPaymentsToUpdate().length > 0){
				CheckoutPayments.updatePaymentInstructions();
			}else{
				if(!submitRequest()){
					return;
				}
				resetRequest();
				CheckoutHelperJS.checkoutOrder(CheckoutHelperJS.getSavedParameter('tempOrderId'),CheckoutHelperJS.getSavedParameter('tempUserType'),CheckoutHelperJS.getSavedParameter('tempEmailAddresses'),CheckoutHelperJS.getSavedParameter('tempIsQuote'));
			}
		} else {
			CheckoutPayments.addPaymentInstructions();
        }
	
		//HB-1028 BEGIN Only one payment method pero order allowed
        //Add the payment ids to the form
		CheckoutPayments.retrivePaymentInstructions();
        //HB-1028 END
        console.log("PSL::ShippingAndBillingServicesDeclaration.js::AjaxAddPaymentInstructionToThisOrder success handler::END");
        
	}

	/**
	 * Resets the array object that contains existing payment objects to add.
	 * Displays the error message returned with the service response and hides the progress bar.
	 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
	 */
	,failureHandler: function(serviceResponse) {
        console.log("PSL::ShippingAndBillingServicesDeclaration.js::AjaxAddPaymentInstructionToThisOrder failure handler.");
		CheckoutPayments.paymentsToAdd = new Array();
		if (serviceResponse.errorMessage) {
			MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
		} else {
			if (serviceResponse.errorMessageKey) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
			}
		}
		cursor_clear();
		//Payment type promotion: If add payment object failed, then if the number of payment methods is 1, call the service to associate an unbounded payment method with the order.
		if(supportPaymentTypePromotions && CheckoutPayments.numberOfPaymentMethods == 1){
			CheckoutPayments.addNewUnboundPaymentInstruction();
        }
	}

}),


wcService.declare({
	id: "PaymentInfoEditTaskService",
	actionId: "PaymentInfoEditTaskService",
	url: "PaymentInfoEditTaskService"

	/**
	 * Resets the array object that contains payment objects to add. Verifies if there is any payment instruction that needs to be updated.
	 * If there is no payment instruction that needs to be updated, direct the browser to the order summary page.
	 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
	 */
	,successHandler: function(serviceResponse) {
		console.log("Pagamento recuperato con successo:", serviceResponse);
		cursor_clear();
        var pidValue;
        pidValue = serviceResponse.pid;
        document.PaymentForm1.existingPiId.value = pidValue;
        document.PaymentForm1.piId.value = pidValue;
        console.log("document.PaymentForm1.existingPiId.value = "+document.PaymentForm1.existingPiId.value);
        console.log("PSL::ShippingAndBillingServicesDeclaration.js::PaymentInfoEditTaskService success handler::END");
        
    },
    failureHandler: function(serviceResponse) {
    	console.log("PSL::ShippingAndBillingServicesDeclaration.js::PaymentInfoEditTaskService failure handler.");
        console.error("Errore nel recupero del pagamento:", serviceResponse.errorMessage);
        if (serviceResponse.errorMessage) {
			MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
		} else {
			if (serviceResponse.errorMessageKey) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
			}
		}
		cursor_clear();
    }

}),


/**
* Declares an AJAX service that updates payment instructions in the current order.
* @constructor
*/
wcService.declare({
	id: "AjaxUpdatePaymentInstructionInThisOrder",
	actionId: "AjaxUpdatePaymentInstructionInThisOrder",
	url: "AjaxRESTOrderPIUpdate",
	formId: ""

	/**
	 * Clears the progress bar, verifies if there is any more payment instruction that needs to be updated.
	 * If there is no more payment instruction that needs to be updated, direct the browser to the order summary page.
	 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
	 */
	,successHandler: function(serviceResponse) {
		cursor_clear();
		if(CheckoutPayments.getPaymentsToUpdate().length < 1){
			if(!submitRequest()){
				return;
			}
			cursor_wait();

			CheckoutPayments.setCommonParameters(SBServicesDeclarationJS.langId,SBServicesDeclarationJS.storeId,SBServicesDeclarationJS.catalogId);
			CheckoutPayments.showSummaryPage();
			cursor_clear();
		}else{
			CheckoutPayments.updatePaymentInstructions();
		}
	}

	/**
	 * Resets the array object that contains existing payment objects to update.
	 * Displays the error message returned with the service response and hides the progress bar.
	 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
	 */
	,failureHandler: function(serviceResponse) {
		CheckoutPayments.paymentsToUpdate = new Array();
		if (serviceResponse.errorMessage) {
			MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
		} else {
			if (serviceResponse.errorMessageKey) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
			}
		}
		cursor_clear();
	}
}),

/**
 * Payment type promotion - START
 */

/**
* Declares an AJAX service that adds an unbounded payment instruction to the current order.
* @constructor
*/
wcService.declare({
	id: "AjaxAddUnboundPaymentInstructionToThisOrder",
	actionId: "AjaxAddUnboundPaymentInstructionToThisOrder",
	url: "AjaxRESTOrderPIAdd",
	formId: ""

	/**
	 * Sets the piId of payment object 1 to the returned piId from the service
	 * call and updates its action to re-add, so that its correctly handled by
	 * the client logic of associating actions to payment objects. Invokes the
	 * AjaxPrepareOrderForPaymentSubmit service to prepare order information.
	 *
	 * @param (object)
	 *            serviceResponse The service response object, which is the JSON
	 *            object returned by the service invocation.
	 */
	 ,successHandler: function(serviceResponse) {
		cursor_clear();

		CheckoutPayments.setPaymentFormPiId(1, serviceResponse.paymentInstruction[0].piId);
		CheckoutPayments.paymentObjects[1]['piId'] = serviceResponse.paymentInstruction[0].piId;
		CheckoutPayments.paymentObjects[1]['action'] = 're-add';

		var params = [];
		params.orderId = serviceResponse.orderId;
		params["storeId"] = CheckoutHelperJS.storeId;
		params["catalogId"] = CheckoutHelperJS.catalogId;
		params["langId"] = CheckoutHelperJS.langId;
		cursor_wait();
		wcService.invoke("AjaxPrepareOrderForPaymentSubmit", params);
 	 }
	/**
	 * Displays the error message returned with the service response and hides the progress bar.
	 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
	 */
	,failureHandler: function(serviceResponse) {
		if (serviceResponse.errorMessage) {
			MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
		} else {
			if (serviceResponse.errorMessageKey) {
				if(getParameterByName("klarnaExpress",window.location.href)== null || !serviceResponse.errorMessage.includes("payMethodId")){
					  MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
				}
			}
		}
		cursor_clear();
	}
}),

/**
* Declares an AJAX service that deletes an unbounded payment instruction from the current order.
* @constructor
*/
wcService.declare({
	id: "AjaxDeleteUnboundPaymentInstructionFromThisOrder",
	actionId: "AjaxDeleteUnboundPaymentInstructionFromThisOrder",
	url: "AjaxRESTOrderPIDelete",
	formId: ""

	/**
	 * The piId of all payment objects is set to empty string, the
	 * action is set to 'add' or empty string depends on whether the
	 * payment object is in the scope of <code>numberOfPaymentMethods</code>,
	 * so that they are correctly handled by the client logic of associating
	 * actions to payment objects. Invokes addNewUnboundPaymentInstruction
	 * if isSinglePaymentType return true. Else, it
	 * calls the AjaxPrepareOrderForPaymentSubmit service to prepare order
	 * information.
	 *
	 * @param (object)
	 *            serviceResponse The service response object, which is the JSON
	 *            object returned by the service invocation.
	 */
	,successHandler: function(serviceResponse) {
		cursor_clear();
		for(var i = 1; i < CheckoutPayments.paymentObjects.length; i++){
			// In order for adding new dummy instruction to calculate payment type promotion,
			// all payment instructions (dummy or non-dummy) were deleted at this point.
			//
			// We also need to clear the card number (the number are shown in: ******1111),
			// since the corresponding non-dummy instruction for paymentObjects[i]['piId'] is deleted.
			if($("#account1_" + i).length ){
				CheckoutPayments.removeCreditCardNumberAndCVV(i, true, true);
				CheckoutHelperJS.paymentDataDirty(i, true);
			}
			CheckoutPayments.setPaymentFormPiId(i,'');
			CheckoutPayments.paymentObjects[i]['piId'] = '';
			if (i > CheckoutPayments.numberOfPaymentMethods){
				CheckoutPayments.paymentObjects[i]['action'] = '';
			} else {
				CheckoutPayments.paymentObjects[i]['action'] = 'add';
			}
		}
		if(CheckoutPayments.isSinglePaymentType()){
			//Add new unbound instruction if is single payment type
			CheckoutPayments.addNewUnboundPaymentInstruction();
		} else {
			 var params = [];
			 params.orderId = serviceResponse.orderId;
			 params["storeId"] = CheckoutHelperJS.storeId;
			 params["catalogId"] = CheckoutHelperJS.catalogId;
			 params["langId"] = CheckoutHelperJS.langId;
			 cursor_wait();
			 wcService.invoke("AjaxPrepareOrderForPaymentSubmit", params);
		}
	}
	/**
	 * Displays the error message returned with the service response and hides the progress bar.
	 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
	 */
	,failureHandler: function(serviceResponse) {
		if (serviceResponse.errorMessage) {
			MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
		} else {
			if (serviceResponse.errorMessageKey) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
			}
		}
		cursor_clear();
	}
}),

/**
* Declares an AJAX service that prepares order information before submitting the order.
* @constructor
*/
wcService.declare({
	id: "AjaxPrepareOrderForPaymentSubmit",
	actionId: "AjaxPrepareOrderForPaymentSubmit",
	url: "AjaxRESTOrderPrepare",
	formId: ""

	/**
	 * If required, sets payment objects 2 and above to null. Triggers the
	 * calculation of order total and payment amounts.
	 *
	 * @param (object)
	 *            serviceResponse The service response object, which is the JSON
	 *            object returned by the service invocation.
	 */
	,successHandler: function(serviceResponse) {
		cursor_clear();

		/**
		 * We want to update the total and load the payment snippets
		 */
		CheckoutPayments.getTotalInJSON("loadPaymentSnippet", "PaymentForm", true);
	}

	/**
	 * Displays the error message returned with the service response and hides the progress bar.
	 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
	 */
	,failureHandler: function(serviceResponse) {
		if (serviceResponse.errorMessage) {
			MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
		} else {
			if (serviceResponse.errorMessageKey) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
			}
		}
		cursor_clear();
	}
})

//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2014, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/**
 * @fileOverview This javascript is used by the Global Login widget to handle the services
 * @version 1.10
 */

/* global document, window, $, wc, Utils, WCParamJS, MessageHelper, cursor_clear, getAbsoluteURL */


/**
 * This service allows customer to sign in
 * @constructor
 */
wcService.declare({
    id: "globalLoginAjaxLogon", 
    actionId: "globalLoginAjaxLogon",
    url: getAbsoluteURL() + "AjaxLogon",
    formId: "",

    /**
     * Hides all the messages and the progress bar.
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation.
     */
    successHandler: function (serviceResponse) {
        cursor_clear();
        var errorMessage = "";
        if (serviceResponse.ErrorCode != null) {
            var errorCode = Number(serviceResponse.ErrorCode);
            switch (errorCode) {
            case 2000:
                errorMessage = MessageHelper.messages["GLOBALLOGIN_SIGN_IN_ERROR_2000"];
                break;
            case 2010:
                errorMessage = MessageHelper.messages["GLOBALLOGIN_SIGN_IN_ERROR_2010"];
                break;
            case 2020:
                errorMessage = MessageHelper.messages["GLOBALLOGIN_SIGN_IN_ERROR_2020"];
                break;
            case 2030:
                errorMessage = MessageHelper.messages["GLOBALLOGIN_SIGN_IN_ERROR_2030"];
                break;
            case 2110:
                errorMessage = MessageHelper.messages["GLOBALLOGIN_SIGN_IN_ERROR_2110"];
                break;
            case 2300:
                errorMessage = MessageHelper.messages["GLOBALLOGIN_SIGN_IN_ERROR_2300"];
                break;
            case 2340:
                errorMessage = MessageHelper.messages["GLOBALLOGIN_SIGN_IN_ERROR_2340"];
                break;
            case 2400:
                errorMessage = MessageHelper.messages["GLOBALLOGIN_SIGN_IN_ERROR_2400"];
                break;
            case 2410:
                errorMessage = MessageHelper.messages["GLOBALLOGIN_SIGN_IN_ERROR_2410"];
                break;
            case 2420:
                errorMessage = MessageHelper.messages["GLOBALLOGIN_SIGN_IN_ERROR_2420"];
                break;
            case 2430:
                document.location.href = "ResetPasswordForm?storeId=" + WCParamJS.storeId + "&catalogId=" + WCParamJS.catalogId + "&langId=" + WCParamJS.langId + "&errorCode=" + errorCode;
                break;
            case 2170:
                document.location.href = "ChangePassword?storeId=" + WCParamJS.storeId + "&catalogId=" + WCParamJS.catalogId + "&langId=" + WCParamJS.langId + "&errorCode=" + errorCode + "&logonId=" + serviceResponse.logonId;
                break;
            case 2570:
                errorMessage = MessageHelper.messages["GLOBALLOGIN_SIGN_IN_ERROR_2570"];
                    break;
                case 2440:
                    errorMessage = MessageHelper.messages["GLOBALLOGIN_SIGN_IN_ERROR_2440"];
                    break;
                case 2450:
                    errorMessage = MessageHelper.messages["GLOBALLOGIN_SIGN_IN_ERROR_2450"];
                    break;
                case 2711 : 
                	GlobalLoginJS.InitHTTPSecureFromPolicy();
                	GlobalLoginJS.showPolicyPopup();
                	
            }
            if (document.getElementById(serviceResponse.widgetId + "_logonErrorMessage_GL") != null) {
                document.getElementById(serviceResponse.widgetId + "_logonErrorMessage_GL").innerHTML = errorMessage;
                document.getElementById(serviceResponse.widgetId + "_WC_AccountDisplay_FormInput_logonId_In_Logon_1").setAttribute("aria-invalid", "true");
                document.getElementById(serviceResponse.widgetId + "_WC_AccountDisplay_FormInput_logonId_In_Logon_1").setAttribute("aria-describedby", "logonErrorMessage_GL_alt");
                document.getElementById(serviceResponse.widgetId + "_WC_AccountDisplay_FormInput_logonPassword_In_Logon_1").setAttribute("aria-invalid", "true");
                document.getElementById(serviceResponse.widgetId + "_WC_AccountDisplay_FormInput_logonPassword_In_Logon_1").setAttribute("aria-describedby", "logonErrorMessage_GL_alt");
                document.querySelectorAll(".form-group .myaccount_error").forEach((el) => {
                    el.classList.add("active");
                });
            }

            /*--- WCAG Begin MCB --*/
            var attr = $('.myaccount_error').attr('tabindex');
            if(!(typeof attr !== typeof undefined && attr !== false)) {
                $('.myaccount_error').attr('tabindex', '0');
            }
            //this if prevents js error if WCAG.js are not imported
            if(typeof moveToError === 'function'){
                moveToError();
            }
            /*--- WCAG Begin MCB --*/

            /* TEALIUM BEGIN Logon fail */
            if(typeof tealium_data2track !== 'undefined'){
	            var code = 'Error while trying to login user';
	            pushErrorToTealium('Server', '', code, errorMessage);
            }
            /* TEALIUM END */

        } else {
        	sessionStorage.setItem('logged', 'true');
            var url = serviceResponse.URL[0].replace(/&amp;/g, '&'),
                languageId = serviceResponse.langId;
            if (languageId != null && document.getElementById('langSEO' + languageId) != null) { // Need to switch language.

                var browserURL = document.location.href,
                    currentLangSEO = '/' + $('#currentLanguageSEO').val() + '/';

                if (browserURL.indexOf(currentLangSEO) !== -1) {
                    // If it's SEO URL.
                    var preferLangSEO = '/' + $('#langSEO' + languageId).val() + '/';

                    var query = url.substring(url.indexOf('?') + 1, url.length),
                        parameters = Utils.queryToObject(query);
                    if (parameters["URL"] != null) {
                        var redirectURL = parameters["URL"],
                            query2 = redirectURL.substring(redirectURL.indexOf('?') + 1, redirectURL.length),
                            parameters2 = Utils.queryToObject(query2);
                        // No redirect URL
                        if (parameters2["URL"] != null) {
                            var finalRedirectURL = parameters2["URL"];
                            if (finalRedirectURL.indexOf(currentLangSEO) != -1) {
                                // Get the prefer language, and replace with prefer language.
                                finalRedirectURL = finalRedirectURL.replace(currentLangSEO, preferLangSEO);
                                parameters2["URL"] = finalRedirectURL;
                            }
                            query2 = $.param(parameters2);
                            redirectURL = redirectURL.substring(0, redirectURL.indexOf('?')) + '?' + query2;
                        } else {
                            //Current URL is the final redirect URL.
                            redirectURL = redirectURL.toString().replace(currentLangSEO, preferLangSEO);
                        }
                        parameters["URL"] = redirectURL;
                    }
                    query = $.param(parameters);
                    url = url.substring(0, url.indexOf('?')) + '?' + query;

                } else {
                    // Not SEO URL.
                    // Parse the parameter and check whether if have langId parameter.
                    if (url.contains('?')) {
                        var query = url.substring(url.indexOf('?') + 1, url.length),
                            parameters = Utils.queryToObject(query);
                        if (parameters["langId"] != null) {
                            parameters["langId"] = languageId;
                            var query2 = $.param(parameters);
                            url = url.substring(0, url.indexOf('?')) + '?' + query2;
                        } else {
                            url = url + "&langId=" + languageId;
                        }
                    } else {
                        url = url + "?langId=" + languageId;
                    }
                }
            }

            if (isPersol && $("#page").hasClass("checkout")){
                var physicalStoreSelectionURL = $("#GLPhysicalStoreSelectionURL").val();
                var billingShippingPageURLForOnline = $("#GLRegisteredUserOrderCalculateURL").val();
		
                if (ShipmodeSelectionExtJS.isBOPISEnabled() && ShipmodeSelectionExtJS.isPickUpInStore()) {
                    url = physicalStoreSelectionURL;
                } else {
                    url = billingShippingPageURLForOnline;
                }
            }

            if (serviceResponse["MERGE_CART_FAILED_SHOPCART_THRESHOLD"] == "1") {
                setCookie("MERGE_CART_FAILED_SHOPCART_THRESHOLD", "1", {path: "/", domain: cookieDomain});
            }

            /* START Early Access */
            if (isPersol || isVogue) assignCustomerSegment();
            /* END Early Access */

            /* START - Wishlist */
            if (isPersol || isOliver) {
                sessionStorage.removeItem("defaultWishlistExternalId");
                sessionStorage.removeItem("wishlistObj");
            }
            /* END - Wishlist */

            window.location = url;

             /*--- WCAG Begin MCB --*/
             var attr = $('.myaccount_error').attr('tabindex');
             if(typeof attr !== typeof undefined && attr !== false) {
                 $('.myaccount_error'). removeAttr('tabindex');
             }
             /*--- WCAG Begin MCB --*/
            
            /* TEALIUM BEGIN Login success */
            /* HB-11904 BEGIN*/
            /*if(typeof tealium_data2track !== 'undefined'){
                tealium_data2track.push({
             	   'id' : 'X-X-CheckoutDelivery-Login',
             	   'User_Email_MD5' : serviceResponse.userEmail
             	});
            }*/
            /* HB-11904 END*/
            /* TEALIUM END */
        }
    },

    /**
     * display an error message.
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation.
     */
    failureHandler: function (serviceResponse) {
        if (serviceResponse.errorMessage) {
            MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
        } else {
            if (serviceResponse.errorMessageKey) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
            }
        }
        cursor_clear();
    }
});
//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2014, 2015 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/**
 * @fileOverview This file provides all the functions and variables to manage Global Login panel.
 */

/* global document, window, $, setCookie, getCookie, cookieDomain, WCParamJS, GlobalLoginJS, Utils, cursor_clear, cursor_wait, submitRequest, wc, processAndSubmitForm, invokeItemAdd, invokeOtherService, isOnPasswordUpdateForm, service */

/**
* Constant key in activePanel
*/
var KEY_ACTIVE = 'active',

    /**
    * Constant key in activePanel
    */
    KEY_SELECTED = 'selected'; 

GlobalLoginJS = {

    /**
     * This variable stores the ID of the language that the store currently uses. Its default value is set to -1, which corresponds to United States English.
     * @private
     */
    langId: "-1",

    /**
     * This variable stores the ID of the current store. Its default value is empty.
     * @private
     */
    storeId: "",

    /**
     * This variable stores the ID of the catalog. Its default value is empty.
     * @private
     */
    catalogId: "",

    /**
     * This variable stores the ID of active panels. Its default value is empty.
     * @private
     */
    activePanel: {},

    widgetsLoadedOnPage: [],

    /**
     * This variable stores the ID of active panels. Its default value is empty.
     * @private
     */
    isPanelVisible: true,

    /**
     * True if mouse down event registered, false otherwise (prevents registering
     * event more than once).
     */
    mouseDownConnectHandle: null,
          
    logonId:null,
        
    reLogonURL : null,
       
    URL:null,
    
    /**
     * Sets the common parameters for the current page.
     * For example, the language ID, store ID, and catalog ID.
     *
     * @param {Integer} langId The ID of the language that the store currently uses.
     * @param {Integer} storeId The ID of the current store.
     * @param {Integer} catalogId The ID of the catalog.
     */
    setCommonParameters: function (langId, storeId, catalogId) {
        this.langId = langId;
        this.storeId = storeId;
        this.catalogId = catalogId;
        cursor_clear();
    },

    hideGLPanel: function (isPanelVisible) {
        this.isPanelVisible = isPanelVisible;
    },

    registerWidget: function (widgetId) {
        this.widgetsLoadedOnPage.push(widgetId);
    },
    
       
      /**
       * 
       */
     InitHTTPSecureFromPolicy : function(){
        	
        	 var href = document.location.href;
             var index = href.lastIndexOf("s", 4);
        	
             if(index == -1){
             	// Loaded with HTTP. Change it to HTTPS along with appropriate port.
         		if (WCParamJS.urlPrefixForHTTP) {
         			var newHref = href.substring(WCParamJS.urlPrefixForHTTP.length);
         			index = newHref.indexOf("/");
         			newHref = WCParamJS.urlPrefixForHTTPS + newHref.substring(index);
         		} else {
         			var newHref = href.substring(0,4) + "s" + (href.substring(4));
        		}
                 setCookie("WC_DisplaySignInPanel_" + WCParamJS.storeId, "true", {
                     path: '/',
                     domain: cookieDomain
                 });
                 window.location = newHref;
             }
    
            
            return;
        	
     },

    InitHTTPSecure: function (widgetId) {
        var href = document.location.href;
        var index = href.lastIndexOf("s", 4);

        if (index != -1) {
            // Open sign in panel if loaded with HTTPS.
            GlobalLoginJS.displayPanel(widgetId);

        } else {
			// Loaded with HTTP. Change it to HTTPS along with appropriate port.
			if (WCParamJS.urlPrefixForHTTP) {
				var newHref = href.substring(WCParamJS.urlPrefixForHTTP.length);
				index = newHref.indexOf("/");
				newHref = WCParamJS.urlPrefixForHTTPS + newHref.substring(index);
			} else {
				var newHref = href.substring(0,4) + "s" + (href.substring(4));
			}
            setCookie("WC_DisplaySignInPanel_" + WCParamJS.storeId, "true", {
                path: '/',
                domain: cookieDomain
            });
            window.location = newHref;
            return;
        }
    },

    displayPanel: function (widgetId) {
        //check if the sign in panel is loaded. if loaded, toggle the dropdown. Else, trigger a refresh.
        var widgetNode = $("#" + widgetId);
        if (widgetNode.length > 0) {
            var panelLoaded = widgetNode.attr("panel-loaded");
            if (panelLoaded) {
                this.togglePanel(widgetNode);
            } else if (typeof isOnPasswordUpdateForm === 'undefined' || isOnPasswordUpdateForm == false) {
                if (!submitRequest()) {
                    return;
                }
                cursor_wait();
                wcRenderContext.updateRenderContext("GlobalLogin_context",{"displayContract":"false", "widgetId" : widgetId});
            }
        }
    },

    togglePanel: function (widgetNode) {
        // toggle the current active global login panel
    	 if (this.activePanel[KEY_ACTIVE] != null && this.activePanel[KEY_SELECTED] != null) {
    		 //HB-661
    		 var idPrefix = this.activePanel[KEY_ACTIVE] + "_";
    		 var form_input_user = idPrefix + "WC_AccountDisplay_FormInput_logonId_In_Logon_1";
    		 var form_input_pass = idPrefix + "WC_AccountDisplay_FormInput_logonPassword_In_Logon_1";
    		 if (!$("#" + form_input_user).is(":focus") && !$("#" + form_input_pass).is(":focus")) {
    			 $("#" + this.activePanel[KEY_ACTIVE]).toggleClass("active");
	             $("#" + this.activePanel[KEY_SELECTED]).toggleClass("selected");
	
	             //if the current active panel is not the caller
	             if (this.activePanel[KEY_ACTIVE] != widgetNode.attr("id")) {
	                 var toggleControl = widgetNode.attr("data-toggle-control");
	                 //toggle current widget
	                 widgetNode.toggleClass("active");
	                 toggleControl.toggleClass("selected");
	
	                 //set the current caller as active
	                 this.activePanel[KEY_ACTIVE] = widgetNode.attr("id");
	                 this.activePanel[KEY_SELECTED] = toggleControl;
	             } else {
	                 delete this.activePanel.active;
	                 delete this.activePanel.selected;
	                 widgetNode.attr("panel-loaded", false);
	                 this.unregisterMouseDown();
	             }
    		 }
         } else {
             var toggleControl = widgetNode.attr("data-toggle-control");
             //no panel is active. toggle the current
             widgetNode.toggleClass("active");
             $("#" + toggleControl).toggleClass("selected");

             //set the current caller as active
             this.activePanel[KEY_ACTIVE] = widgetNode.attr("id");
             this.activePanel[KEY_SELECTED] = toggleControl;
             this.registerMouseDown();
         }
    },

    updateGlobalLoginSignInContent: function (widgetId) {
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        var redirectToPageName = getCookie("WC_RedirectToPage_" + WCParamJS.storeId);
        if (redirectToPageName != undefined && redirectToPageName != null) {
            setCookie("WC_RedirectToPage_" + WCParamJS.storeId, null, {
                expires: -1,
                path: '/',
                domain: cookieDomain
            });
        }
        wcRenderContext.updateRenderContext("GlobalLogin_context",{"displayContract":"false", "widgetId": widgetId, "redirectToPageName": redirectToPageName});
    },

    updateGlobalLoginUserDisplay: function (displayName) {
        $("#Header_GlobalLogin_signOutQuickLinkUser").html(displayName);
    },

    updateGlobalLoginContent: function (widgetId) {
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        if($('#'+widgetId).length){
	    	wcRenderContext.updateRenderContext("GlobalLogin_context",{"displayContract":"true", "widgetId": widgetId});
	    }else{
	    	cursor_clear();
	    }
    },

    updateOrganization: function (formName, widgetId) {
        var orgSetInSessionURL = widgetId + '_' + 'orgSetInSessionURL';
        var orgSetInSessionURLEle = document.getElementById(orgSetInSessionURL);
        if (orgSetInSessionURLEle != null) {
            var href = document.location.href;
            orgSetInSessionURLEle.value = href;
        }
        var form = document.forms[widgetId + '_' + formName];
        if (!submitRequest()) {
            return;
        }
        processAndSubmitForm(form);
    },

    prepareSubmit: function (widgetId) {
        var idPrefix = widgetId + "_";
        if (document.getElementById(idPrefix + "signInDropdown") != null && document.getElementById(idPrefix + "signInDropdown").className.indexOf("active") > -1) {
            document.getElementById(idPrefix + "inlinelogonErrorMessage_GL_logonPassword").setAttribute("class", "wcag__error errorLabel");
            document.getElementById(idPrefix + "inlineLogonErrorMessage_GL_logonId").setAttribute("class", "wcag__error errorLabel");
            var form_input_field = document.getElementById(idPrefix + "WC_AccountDisplay_FormInput_logonId_In_Logon_1");
            if (form_input_field != null) {
                if (this.isEmpty(form_input_field.value)) {
                    document.getElementById(idPrefix + "inlineLogonErrorMessage_GL_logonId").className = document.getElementById(idPrefix + "inlineLogonErrorMessage_GL_logonId").className + " active";
                    return false;
                }
            }
            var form_input_field = document.getElementById(idPrefix + "WC_AccountDisplay_FormInput_logonPassword_In_Logon_1");
            if (form_input_field != null) {
                if (this.isEmpty(form_input_field.value)) {
                    document.getElementById(idPrefix + "inlinelogonErrorMessage_GL_logonPassword").className = document.getElementById(idPrefix + "inlinelogonErrorMessage_GL_logonPassword").className + " active";
                    return false;
                }
            }
        }
        return true;
    },

    /**
     * Checks if a string is null or empty.
     * @param (string) str The string to check.
     * @return (boolean) Indicates whether the string is empty.
     */
    isEmpty: function (str) {
        var reWhiteSpace = new RegExp(/^\s+$/);
        if (str == null || str == '' || reWhiteSpace.test(str)) {
            return true;
        }
        return false;
    },

    /**
     * Updates the contract that is available to the current user.
     * @param {string} formName  The name of the form that contains the selected contracts.
     */
    updateContract: function (formName) {
        var form = document.forms[formName];

        /* For Handling multiple clicks. */
        if (!submitRequest()) {
            return;
        }

        form.submit();
    },

    deleteUserLogonIdCookie: function (contractURL) {
        var userLogonIdCookie = getCookie("WC_LogonUserId_" + WCParamJS.storeId);
        sessionStorage.setItem('logged', 'false');
        if (userLogonIdCookie != null) {
            setCookie("WC_LogonUserId_" + WCParamJS.storeId, null, {
                expires: -1,
                path: '/',
                domain: cookieDomain
            });
        }
        /* START - Wishlist */
        if (isPersol || isOliver) {
            sessionStorage.removeItem("defaultWishlistExternalId");
            sessionStorage.removeItem("wishlistObj");
        }
        /* END - Wishlist */
    },

    changeRememberMeState: function (jspStoreImgDir, target) {
        var targetEle = document.getElementById(target);
        if (targetEle.className.indexOf("active") > -1) {
            targetEle.className = targetEle.className.replace('active', '');
            targetEle.setAttribute("aria-checked", "false");
            targetEle.setAttribute("src", jspStoreImgDir + "images/checkbox.png");
            document.getElementById(target.replace("_img", "")).setAttribute("value", "false");
        } else {
            targetEle.className = targetEle.className + " active";
            targetEle.setAttribute("src", jspStoreImgDir + "images/checkbox_checked.png");
            targetEle.setAttribute("aria-checked", "true");
            document.getElementById(target.replace("_img", "")).setAttribute("value", "true");
        }
    },

    deleteLoginCookies: function () {
        this.deleteUserLogonIdCookie();
        setCookie("WC_BuyOnBehalf_" + WCParamJS.storeId, null, {
            path: '/',
            expires: -1,
            domain: cookieDomain
        });
    },

    /**
     * Submit a global login sign in form
     * @param (object) widgetId The form widgetId id.
     */
    submitGLSignInForm: function (formId, widgetId) {
        service = wcService.getServiceById('globalLoginAjaxLogon');
        service.setFormId(formId);
        
        var logonForm = document.getElementById(formId);
        if(logonForm != null){
        	if(logonForm.logonId != null){
                this.logonId = logonForm.logonId.value;
        	}
        	if(logonForm.URL != null){
        		this.URL = logonForm.URL.value
        	}
        	if(logonForm.reLogonURL != null){
        		this.relogonURL = logonForm.reLogonURL.value;
        	}
        }

        
        var params = {
            widgetId: widgetId,
            acceptedPolicyValue: 'false',
            isShopperLogin: 'true'
        };

        /*For Handling multiple clicks. */
        if (!submitRequest()) {
            return;
        }
        cursor_wait();

        wcService.invoke('globalLoginAjaxLogon', params);
    },
    
    /**
     * 
     */
    submitGLSignInFormFromPolicyPopup : function(formId,widgetId,reLogonURL){
    	
        var encodedReLogonURI = encodeURI(reLogonURL);
        var acceptedPolicyValue = "";
           	
        //NERD-93 accept policy
        var acceptPolicyCheckBox = document.getElementById('agreeConcent_popup');

        
        if(acceptPolicyCheckBox != null){
        	acceptedPolicyValue = acceptPolicyCheckBox.checked;
        }
                
        service = wcService.getServiceById('globalLoginAjaxLogon');
        service.setFormId(formId);
        
        var params = {
            acceptedPolicyValue:acceptedPolicyValue,
        	reLogonURL : this.relogonURL,
            URL : this.URL,
            isShopperLogin: 'true'
        };

        /*For Handling multiple clicks. */
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        
        wcService.invoke('globalLoginAjaxLogon', params);
    	
    },

    /**
     * After successful login and setting a contract in session, we need to process the action that the shopper
     * was performing before signing in. It will do nothing if shopper was not trying to perform any actions.
     */
    processNextURL: function () {
        var myNextURL = getCookie("WC_nextURL_" + WCParamJS.storeId);
        if (myNextURL != undefined && myNextURL.length > 0) {
            myNextURL = myNextURL.replace(/&amp;/g, "&");
            if (myNextURL.indexOf('AjaxRESTOrderItemAdd') != -1) {
                invokeItemAdd(myNextURL);
            } else {
                invokeOtherService(myNextURL);
            }
        }
    },

    registerMouseDown: function () {
        if (!this.mouseDownConnectHandle) {
            $(document.documentElement).on("mousedown", $.proxy(this.handleMouseDown, this));
            this.mouseDownConnectHandle = true;
        }
    },

    unregisterMouseDown: function () {
        if (this.mouseDownConnectHandle) {
            $(document.documentElement).off("mousedown");
            this.mouseDownConnectHandle = false;
        }
    },

    handleMouseDown: function (evt) {
        if (this.activePanel[KEY_ACTIVE] != null && this.activePanel[KEY_SELECTED] != null) {
            Utils.ifSelectorExists("#" + this.activePanel[KEY_ACTIVE], function(widgetNode) {
                var toggleControl = $("#" + this.activePanel[KEY_SELECTED]);
                var node = evt.target;
                if (node != document.documentElement) {
                    var close = true;
                    while (node && node != document.documentElement) {
                        if (Utils.elementExists("#" + node.id + "_dropdown") && Utils.elementExists("#" + widgetNode.id + "_numEntitledContracts") != null && $("#" + widgetNode.id + "_numEntitledContracts").val() > 0) {
                            var nodePosition = Utils.position(node),
                                windowHeight = window.innerHeight,
                                newHeight;
                            if (windowHeight - nodePosition.y > nodePosition.y) {
                                newHeight = windowHeight - nodePosition.y;
                            } else {
                                newHeight = nodePosition.y;
                            }
                            var dropdownHeight = $("#" + node.id + "_dropdown").get(0).clientHeight;
                            if (dropdownHeight > newHeight) {
                                $("#" + node.id + "_dropdown").css("height", newHeight + "px");
                            }
                        }
                        if (widgetNode.is(node) || toggleControl.is(node) || $(node).hasClass("dijitPopup")) {
                            close = false;
                            break;
                        }
                        node = node.parentNode;
                    }
                    node = null;
                    if (node == null) {
                        widgetNode.children("div").each(function(i, e) {
                            var position = Utils.position(e);
                            if (evt.clientX >= position.x && evt.clientX < position.x + position.w &&
                                evt.clientY >= position.y && evt.clientY < position.y + position.h) {
                                close = false;
                                return false; // breaks
                            }
                        });
                        if (Utils.elementExists("#" + widgetNode.id + "_WC_B2BMyAccountParticipantRole_select_2_dropdown") &&
                            $("#" + widgetNode.id + "_WC_B2BMyAccountParticipantRole_select_2_dropdown").css("display") != "none" &&
                            Utils.elementExists("#" + widgetNode.id + "_numEntitledContracts") && $("#" + widgetNode.id + "_numEntitledContracts").val() > 0) {
                            var nodePosition = Utils.position("#" + widgetNode.id + "_WC_B2BMyAccountParticipantRole_select_2"),
                                windowHeight = window.innerHeight,
                                newHeight;
                            if (windowHeight - nodePosition.y > nodePosition.y) {
                                newHeight = windowHeight - nodePosition.y;
                            } else {
                                newHeight = nodePosition.y;
                            }
                            var dropDown = $("#" + widgetNode.id + "_WC_B2BMyAccountParticipantRole_select_2_dropdown"),
                                dropdownHeight = dropDown.get(0).clientHeight;
                            if (dropdownHeight > newHeight) {
                                dropDown.css("height", newHeight + "px");
                            }
                        }
                    }
                    if (close) {
                        this.togglePanel(widgetNode);
                    }
                }
            }, this);
        }
    },
    
      /**
        * show store policy popup
        */
       showPolicyPopup : function(){
         var policyPopup = $('#acceptance_policy_popup');
         policyPopup.data("wc-WCDialog").open();
        },
        
        /**
         * hides store policy popup
         */
        hidePolicyPopup : function(){
        	var policyPopup = $('#acceptance_policy_popup');
        	policyPopup.data("wc-WCDialog").close();
         }
};
//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2008, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/**
 * @fileOverview This class contains declarations of AJAX services used by the Madisons store pages.
 */

/**
 * @class This class stores common parameters needed to make the service call.
 */



shoppingActionsServicesDeclarationJS = {

	langId: "-1", /* language of the  store */
	storeId: "", /*numeric unique identifier of the store */
	catalogId: "", /*catalog of the store that is currently in use */

	/**
	 * Sets common parameters used by the services
	 * @param (int) langId The language of the store.
	 * @param (int) storeId The store currently in use.
	 * @param (int) catalogId The catalog of the store currently in use.
	 */
	setCommonParameters:function(langId,storeId,catalogId){
			this.langId = langId;
			this.storeId = storeId;
			this.catalogId = catalogId;
	}
}

	/**
	 * Add an item to a shopping cart in Ajax mode. A message is displayed after
	 * the service call.
	 * @constructor
	 */
	wcService.declare({
		id: "AddOrderItem",
		actionId: "AddOrderItem",
		url: getAbsoluteURL() + "AjaxCustomRESTOrderItemAdd",
		formId: ""

     /**
     * display a success message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */

		,successHandler: function(serviceResponse) {

			if(productDisplayJS.wasEngraved && productDisplayJS.wasEngraved != null && productDisplayJS.wasEngraved != undefined) {
				var wasEngravedOrderItems = JSON.parse(sessionStorage.getItem("wasEngravedOrderItems"));
				if(checkIsNull(wasEngravedOrderItems)) {
					wasEngravedOrderItems = [];
				}
				wasEngravedOrderItems.push(serviceResponse.orderItemId[0]);
				sessionStorage.setItem("wasEngravedOrderItems", JSON.stringify(wasEngravedOrderItems));
			}

			//START Wunderkind
			if(typeof updateWkndCartValue == 'function') {
				updateWkndCartValue();
			}
			//END Wunderkind
			MessageHelper.hideAndClearMessage();
			// Do not show this message. When item is added, we open up mini cart to display the currently added item.
			// MessageHelper.displayStatusMessage(Utils.getLocalizationMessage("SHOPCART_ADDED"));
            cursor_clear();
            
            //HB-1988 BEGIN
            restoreAjaxButtons();
            //HB-1988 END
            
			if(shoppingActionsJS){

				var attributes_container = $('div[id^="attrValue_"]');

				if (($(".definingAttributes")[0]) != null) {
					var attributes_container = $(".definingAttributes");
				}
				else if (($(".product_sizes")[0]) != null) {
					var attributes_container = $(".product_sizes");
				}
				else if (($(".product_info")[0]) != null) {
					var attributes_container = $(".product_info");
				}

				var attributes = new Array();
				for (var i = 0; i < attributes_container.length; i++) {
					var attribute_selectors = attributes_container[i].querySelectorAll(".dijitSelect");
					for (var j = 0; j < attribute_selectors.length; j++) {
						attributes = attributes.concat(attribute_selectors[j]);
					}
				}

				var dijitSelect = new Array();
				for (var i = 0; i < attributes.length; i++) {
					dijitSelect[i] = dijit.registry.byNode(attributes[i]);
				}

				var singleSKU = true;
				for(var i=0; i<dijitSelect.length; i++){
					if (dijitSelect[i].options.length > 2)
					{
						singleSKU = false;
					}
				}

				if (!singleSKU)
				{
					shoppingActionsJS.selectedAttributes = new Object();
					wcTopic.publish('DefiningAttributes_Resolved_'+shoppingActionsJS.baseCatalogEntryId, shoppingActionsJS.baseCatalogEntryId, -1);
					for(var i=0; i<dijitSelect.length; i++){
						if(dijitSelect[i] != null){
							dijitSelect[i].value = "";
						}
					}
				}

			}
			if(typeof(ShipmodeSelectionExtJS)!= null && typeof(ShipmodeSelectionExtJS)!='undefined'){
				ShipmodeSelectionExtJS.setOrderItemId((serviceResponse.orderItem != null && serviceResponse.orderItem[0].orderItemId != null) ? serviceResponse.orderItem[0].orderItemId : serviceResponse.orderItemId);
			}

			//BEGIN Lens Configurator
			//update prescription with the generated orderitemsid from cart service
			if(productDisplayJS.prescription === true){
                _prescriptionObject = $.cookie("_prescriptionObject");
				if(_prescriptionObject != undefined){
                    $.ajax({
                        url: "/wcs/resources/store/" + WCParamJS.storeId + "/cart/@self",
                        method: "GET",
                        async: false,
						headers: {
							"Content-Type": "application/json",
							"Cache-Control": "no-cache, no-store, must-revalidate"
						},
						data: {
							"timestamp": Date.now()
						},
                        success: function(data) {
                                var maxOrderItemId = 0;
								var roxFrameSelected = $('#roxFrameID').val();
                                //retrieve object with roxframeId in the array orderitem and extract the orderitemsid
                                //in case there are more than one item with same catentry take the greater one
                                $.each(data.orderItem,(index,element) => {
                                    if(element.productId === roxFrameSelected && maxOrderItemId < element.orderItemId){
                                        console.log(element.orderItemId);
                                         maxOrderItemId = element.orderItemId;
                                    }
                                });
                                
                                _prescriptionObject = JSON.parse(_prescriptionObject);
                                parameters = {};
                                parameters.orderItemsId = maxOrderItemId;
                                parameters.prescriptionId = _prescriptionObject.prescriptionId;
                                
                                parameters.type = "S";
                                if (productDisplayJS.lensOptionValue === "Progressive"){
                                    parameters.type = "P";
                                }
                                
                            
                                var docStr = generateXML(parameters);
                                var xmldoc = {};
                                xmldoc.XML = docStr;
                                //asynchronous call: if the prescription hasn't be updated it will not go to the cart
                                AddPrescription(xmldoc).then(function(){
                                    console.log("prescription updated with orderitemsid"  + parameters.orderItemsId);
                                    
                                    /* remove cookie when item have been added to cart so if the same user add a new prescription
                                     both for error (more the one prescription are not allowed) or for replace the old one
                                     it will be treated as new prescription in the configurator */
                                     //$.removeCookie("_prescriptionObject");
									 $.removeCookie("_userId");
                                    goToCart2();
                                }).catch(function(){
									console.log("prescription not updated");
                                    console.log("orderitemsId used" + parameters.orderItemsId);

								});
                        
                        },
                        error: function(err) {
                            console.log("failed to updated the prescription");
                        }
                    });
                }else{
                    //it has choosen the send it later option
                    goToCart2();
                }
			}


			if(productDisplayJS.isFrameOnly){ //this if is necessary because the sunglasses still have add to cart button 
				//it has choose the frame  only option
				goToCart2();
			}

			//END
			
			wcTopic.publish('ProductAddedToCart');
			
		}
     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
		,failureHandler: function(serviceResponse) {
		    if(productDisplayJS && productDisplayJS.YMALProductFlag) //reset flag if add fails
				productDisplayJS.YMALProductFlag = false;
				
		    var productUPC = $('#parentProductUpc').val();
			if (serviceResponse.errorMessage) {
			 	if(serviceResponse.errorMessageKey == "_ERR_NO_ELIGIBLE_TRADING"){
			 		MessageHelper.displayErrorMessage(Utils.getLocalizationMessage("ERROR_CONTRACT_EXPIRED_GOTO_ORDER"));
 				} else if (serviceResponse.errorMessageKey == "_ERR_RETRIEVE_PRICE") {
					var tempString = Utils.getLocalizationMessage("GENERICERR_MAINTEXT", {0:Utils.getLocalizationMessage("GENERICERR_CONTACT_US")});
 					MessageHelper.displayErrorMessage(tempString);
 				} else if ("_API_CANT_RESOLVE_FFMCENTER" == serviceResponse.errorMessageKey) {
 		            MessageHelper.displayErrorMessage(API_CANT_RESOLVE_FFMCENTER_MSG);
 		        } else {
 					MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
 				}
			 	
                if(serviceResponse.errorMessageKey == "_ERR_NO_ELIGIBLE_TRADING" || serviceResponse.errorMessageKey == "_ERR_RETRIEVE_PRICE" 
                    || serviceResponse.errorMessageKey == "_API_CANT_RESOLVE_FFMCENTER" || serviceResponse.errorMessageKey == "_ERR_PROD_NOT_ORDERABLE") {
                   trackAddToCartFailure('Product', serviceResponse.errorMessage, productUPC);
                }
                else{
                   trackAddToCartFailure('Server', serviceResponse.errorMessage, productUPC); 
                }
			}
			else {
				 if (serviceResponse.errorMessageKey) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
					trackAddToCartFailure('Product', serviceResponse.errorMessageKey, productUPC);
				 }
			}

			if(serviceResponse.errorCode){
				wcTopic.publish("OrderError",serviceResponse);
			}

			cursor_clear();
		}

	}),

	/**
	 * Adds a pre-defined dynamic kit to a shopping cart in Ajax mode. A message is displayed after
	 * the service call.
	 * @constructor
	 */
	wcService.declare({
		id: "AddPreConfigurationToCart",
		actionId: "AddOrderItem",
		url: getAbsoluteURL() + "AjaxRESTOrderAddPreConfigurationToCart",
		formId: ""

     /**
     * display a success message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */

		,successHandler: function(serviceResponse) {
			MessageHelper.hideAndClearMessage();
			cursor_clear();
			if(shoppingActionsJS){

				var attributes = document.getElementsByName("attrValue");

				var singleSKU = true;

				for(var i=0; i<attributes.length; i++){
					if (attributes[i].options.length > 1)
					{
						singleSKU = false;
					}
				}

				if (!singleSKU)
				{
					shoppingActionsJS.selectedAttributes = new Object();
					for(var i=0; i<attributes.length; i++){
						if(attributes[i] != null){
							attributes[i].value = "";
							attributes[i].onchange();
						}
					}
				}
			}
			if(typeof(ShipmodeSelectionExtJS)!= null && typeof(ShipmodeSelectionExtJS)!='undefined'){
				ShipmodeSelectionExtJS.setOrderItemId(serviceResponse.orderItem[0].orderItemId);
			}
		}
     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
		,failureHandler: function(serviceResponse) {

			if (serviceResponse.errorMessage) {
			 	if(serviceResponse.errorMessageKey == "_ERR_NO_ELIGIBLE_TRADING"){
			 		MessageHelper.displayErrorMessage(Utils.getLocalizationMessage("ERROR_CONTRACT_EXPIRED_GOTO_ORDER"));
 				} else if (serviceResponse.errorMessageKey == "_ERR_RETRIEVE_PRICE") {
					var tempString = Utils.getLocalizationMessage("GENERICERR_MAINTEXT",{0:Utils.getLocalizationMessage("GENERICERR_CONTACT_US")});
 					MessageHelper.displayErrorMessage(tempString);
 				} else {
 					MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
 				}
			}
			else {
				 if (serviceResponse.errorMessageKey) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
				 }
			}
			cursor_clear();
		}

	})

//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2011, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

shoppingActionsJS = {

    /** The language ID currently in use **/
    langId: "-1",

    /** The store ID currently in use **/
    storeId: "",

    /** The catalog ID currently in use **/
    catalogId: "",

    /** Holds the current user type such as guest or registered user. Allowed values are 'G' for guest and 'R' for registered.**/
    userType: "",

    /** A boolean used in a variety of the add to cart methods to tell whether or not the base item was added to the cart. **/
    baseItemAddedToCart: false,

    /** An array of entitled items which is used in various methods throughout ShoppingActions.js **/
    entitledItems: [],

    /** a JSON object that holds attributes of an entitled item **/
    entitledItemJsonObject: null,

    /** A map of attribute name value pairs for the currently selected attribute values **/
    selectedAttributesList: {},

    /** A variable used to form the url dynamically for the more info link in the Quickinfo popup */
    moreInfoUrl: "",

    /**
     * A boolean used to to determine is it from a Qick info popup or not. 
     **/
    isPopup: false,

    /**
     * A boolean used to to determine whether or not to diplay the price range when the catEntry is selected. 
     **/
    displayPriceRange: true,

    /**
     * This array holds the json object retured from the service, holding the price information of the catEntry.
     **/
    itemPriceJsonOject: [],

    /** 
     * stores all name and value of all swatches 
     * this is a 2 dimension array and each record i contains the following information:
     * allSwatchesArray[i][0] - attribute name of the swatch
     * allSwatchesArray[i][1] - attribute value of the swatch
     * allSwatchesArray[i][2] - image1 of swatch (image to use for enabled state)
     * allSwatchesArray[i][3] - image2 of swatch (image to use for disabled state)
     * allSwatchesArray[i][4] - onclick action of the swatch when enabled
     **/
    allSwatchesArrayList: {},

    /**
     * Holds the ID of the image used for swatch
     **/
    skuImageId: "",

    /**
     * The prefix of the cookie key that is used to store item Ids. 
     */
    cookieKeyPrefix: "CompareItems_",

    /**
     * The delimiter used to separate item Ids in the cookie.
     */
    cookieDelimiter: ";",

    /**
     * The maximum number of items allowed in the compare zone. 
     */
    maxNumberProductsAllowedToCompare: 4,

    /**
     * The minimum number of items allowed in the compare zone. 
     */
    minNumberProductsAllowedToCompare: 2,

    /**
     * Id of the base catalog entry. 
     */
    baseCatalogEntryId: 0,

    /**
     * An map which holds the attributes of a set of products
     */
    selectedProducts: {},

    /**
     * An array to keep the quantity of the products in a list (bundle)
     */
    productList: {},

    /**
     * stores the currency symbol
     */
    currencySymbol: "",

    /**
     * stores the compare return page name
     */
    compareReturnName: "",
    /**
     * stores the search term
     */
    searchTerm: "",

    search01: "'",

    search02: '"',

    replaceStr01: /\\\'/g,

    replaceStr02: /\\\"/g,

    ampersandChar: /&/g,

    ampersandEntityName: "&amp;",

    /**
     * An array to keep the details of the newly added products.
     */
    productAddedList: {},

    setCompareReturnName: function (compareReturnName) {
        this.compareReturnName = compareReturnName;
    },

    setSearchTerm: function (searchTerm) {
        this.searchTerm = searchTerm;
    },

    setCommonParameters: function (langId, storeId, catalogId, userType, currencySymbol) {
        this.langId = langId;
        this.storeId = storeId;
        this.catalogId = catalogId;
        this.userType = userType;
        this.currencySymbol = currencySymbol;
    },

    setEntitledItems: function (entitledItemArray) {
        this.entitledItems = entitledItemArray;
    },

    getCatalogEntryId: function (entitledItemId) {
        var attributeArray = [];
        var selectedAttributes = this.selectedAttributesList[entitledItemId];
        for (attribute in selectedAttributes) {
            attributeArray.push(attribute + "_|_" + selectedAttributes[attribute]);
        }
        return this.resolveSKU(attributeArray);
    },

    /**
     * getCatalogEntryIdforProduct Returns the catalog entry ID for a catalog entry that has the same attribute values as a specified product's selected attributes as passed in via the selectedAttributes parameter.
     *
     * @param {String[]} selectedAttributes The array of selected attributes upon which to resolve the SKU.
     *
     * @return {String} catalog entry ID of the SKU.
     *
     **/
    getCatalogEntryIdforProduct: function (selectedAttributes) {
        var attributeArray = [];
        for (attribute in selectedAttributes) {
            attributeArray.push(attribute + "_|_" + selectedAttributes[attribute]);
        }
        return this.resolveSKU(attributeArray);
    },

    /**
     * retrieves the entitledItemJsonObject
     */
    getEntitledItemJsonObject: function () {
        return this.entitledItemJsonObject;
    },

    /**
     * resolveSKU Resolves a SKU using an array of defining attributes.
     *
     * @param {String[]} attributeArray An array of defining attributes upon which to resolve a SKU.
     *
     * @return {String} catentry_id The catalog entry ID of the SKU.
     *
     **/
    resolveSKU: function (attributeArray) {

        console.debug("Resolving SKU >> " + attributeArray + ">>" + this.entitledItems);
        var catentry_id = "";
        var attributeArrayCount = attributeArray.length;

        // if there is only one item, no need to check the attributes to resolve the sku
        if (this.entitledItems.length == 1) {
            return this.entitledItems[0].catentry_id;
        }
        for (x in this.entitledItems) {
            var catentry_id = this.entitledItems[x].catentry_id;
            var Attributes = this.entitledItems[x].Attributes;
            var attributeCount = 0;
            for (index in Attributes) {
                attributeCount++;
            }

            // Handle special case where a catalog entry has one sku with no attributes
            if (attributeArrayCount == 0 && attributeCount == 0) {
                return catentry_id;
            }
            if (attributeCount != 0 && attributeArrayCount >= attributeCount) {
                var matchedAttributeCount = 0;

                for (attributeName in attributeArray) {
                    var attributeValue = attributeArray[attributeName];
                    var attributeValue2 = attributeValue.replace(this.search02, this.search01);
                    if (attributeValue in Attributes || attributeValue2 in Attributes) {
                        matchedAttributeCount++;
                    }
                }

                if (attributeCount == matchedAttributeCount) {
                    console.debug("CatEntryId:" + catentry_id + " for Attribute: " + attributeArray);
                    this.disableBuyButtonforUnbuyable(x);
                    return catentry_id;
                }
            }
        }
        return null;
    },

    /**
     * setSelectedAttribute Sets the selected attribute value for a particular attribute not in reference to any catalog entry.
     *					   One place this function is used is on CachedProductOnlyDisplay.jsp where there is a drop down box of attributes.
     *					   When an attribute is selected from that drop down this method is called to update the selected value for that attribute.
     *
     * @param {String} selectedAttributeName The name of the attribute.
     * @param {String} selectedAttributeValue The value of the selected attribute.
     * @param {String} entitledItemId The element id where the json object of the sku is stored
     * @param {String} skuImageId This is optional. The element id of the product image - image element id is different in product page and category list view. Product page need not pass it because it is set separately
     * @param {String} imageField This is optional. The json field from which image should be picked. Pass value if a different size image need to be picked
     *
     **/
    setSelectedAttribute: function (selectedAttributeName, selectedAttributeValue, entitledItemId, skuImageId, imageField) {
        console.debug(selectedAttributeName + " : " + selectedAttributeValue);
        var selectedAttributes = this.selectedAttributesList[entitledItemId];
        if (selectedAttributes == null) {
            selectedAttributes = {};
        }
        selectedAttributeValue = selectedAttributeValue.replace(this.replaceStr01, this.search01);
        selectedAttributeValue = selectedAttributeValue.replace(this.replaceStr02, this.search02);
        selectedAttributeValue = selectedAttributeValue.replace(this.ampersandChar, this.ampersandEntityName);
        selectedAttributes[selectedAttributeName] = selectedAttributeValue;
        this.moreInfoUrl = this.moreInfoUrl + '&' + selectedAttributeName + '=' + selectedAttributeValue;
        this.selectedAttributesList[entitledItemId] = selectedAttributes;
        this.changeProdImage(entitledItemId, selectedAttributeName, selectedAttributeValue, skuImageId, imageField);
    },

    /**
     * setSelectedAttributeOfProduct Sets the selected attribute value for an attribute of a specified product.
     *								This function is used to set the assigned value of defining attributes to specific 
     *								products which will be stored in the selectedProducts map.
     *
     * @param {String} productId The catalog entry ID of the catalog entry to use.
     * @param {String} selectedAttributeName The name of the attribute.
     * @param {String} selectedAttributeValue The value of the selected attribute.
     * @param {boolean} true, if it is single SKU
     *
     **/
    setSelectedAttributeOfProduct: function (productId, selectedAttributeName, selectedAttributeValue, isSingleSKU) {

        var selectedAttributesForProduct = null;

        if (this.selectedProducts[productId]) {
            selectedAttributesForProduct = this.selectedProducts[productId];
        } else {
            selectedAttributesForProduct = {};
        }

        // add only if attribute has some name. value can be empty
        if (null != selectedAttributeName && '' != selectedAttributeName) {
            selectedAttributesForProduct[selectedAttributeName] = selectedAttributeValue;
        }
        this.selectedProducts[productId] = selectedAttributesForProduct;

        //the json object for entitled items are already in the HTML. 
        var entitledItemJSON = eval('(' + $("#entitledItem_" + productId).html() + ')');

        this.setEntitledItems(entitledItemJSON);

        var catalogEntryId = this.getCatalogEntryIdforProduct(selectedAttributesForProduct);

        if (catalogEntryId == null) {
            catalogEntryId = 0;
        } else {
            // pass true to display price range
            this.changePrice("entitledItem_" + productId, false, true, productId);

            //Update selected sku in merchandising association array
            if (typeof MerchandisingAssociationJS != 'undefined') {
                if (MerchandisingAssociationJS.baseItemParams != null) {
                    if (MerchandisingAssociationJS.baseItemParams.type == 'BundleBean') {
                        // Update items in the bundle
                        for (idx = 0; idx < MerchandisingAssociationJS.baseItemParams.components.length; idx++) {
                            if (productId == MerchandisingAssociationJS.baseItemParams.components[idx].productId) {
                                MerchandisingAssociationJS.baseItemParams.components[idx].id = catalogEntryId;
                            }
                        }
                    }
                }
            }
        }
        var productDetails = null;
        if (this.productList[productId]) {
            productDetails = this.productList[productId];
        } else {
            productDetails = {};
            this.productList[productId] = productDetails;
            productDetails.baseItemId = productId;
        }

        productDetails.id = catalogEntryId;
        if (productDetails.quantity) {
            wcTopic.publish("Quantity_Changed", JSON.stringify(productDetails));
        }

        if (!isSingleSKU) {
            // publish the attribute change event
            if (catalogEntryId != 0) {
                wcTopic.publish('DefiningAttributes_Resolved_' + productId, catalogEntryId, productId);
            } else {
                wcTopic.publish('DefiningAttributes_Changed_' + productId, catalogEntryId, productId);
            }
        }
    },

    /**
     * Add2ShopCartAjax This function is used to add a catalog entry to the shopping cart using an AJAX call. This will resolve the catentryId using entitledItemId and adds the item to the cart.
     *				This function will resolve the SKU based on the entitledItemId passed in and call {@link this.AddItem2ShopCartAjax}.
     * @param {String} entitledItemId A DIV containing a JSON object which holds information about a catalog entry. You can reference CachedProductOnlyDisplay.jsp to see how that div is constructed.
     * @param {int} quantity The quantity of the item to add to the cart.
     * @param {String} isPopup If the value is true, then this implies that the function was called from a quick info pop-up. 	
     * @param {Object} customParams - Any additional parameters that needs to be passed during service invocation.
     *
     **/
    Add2ShopCartAjax: function (entitledItemId, quantity, isPopup, customParams) {
        var dialog = $('#quick_cart_container').data("wc-WCDialog");
        if (dialog) {
            dialog.close();
        }
        if (browseOnly) {
            MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('ERROR_ADD2CART_BROWSE_ONLY'));
            return;
        }
        var entitledItemJSON;

        if ($("#" + entitledItemId).length) {
            //the json object for entitled items are already in the HTML. 
            entitledItemJSON = eval('(' + $("#" + entitledItemId).html() + ')');
        } else {
            //if $("#" +entitledItemId).length is 0, that means there's no <div> in the HTML that contains the JSON object. 
            //in this case, it must have been set in catalogentryThumbnailDisplay.js when the quick info
            entitledItemJSON = this.getEntitledItemJsonObject();
        }

        this.setEntitledItems(entitledItemJSON);
        var catalogEntryId = this.getCatalogEntryId(entitledItemId);

        if (catalogEntryId != null) {
            var productId = entitledItemId.substring(entitledItemId.indexOf("_") + 1);
            this.AddItem2ShopCartAjax(catalogEntryId, quantity, customParams, productId);
            this.baseItemAddedToCart = true;
        } else if (isPopup == true) {
            $('#second_level_category_popup').css("zIndex", '1');
            MessageHelper.formErrorHandleClient('addToCartLinkAjax', Utils.getLocalizationMessage('ERR_RESOLVING_SKU'));
        } else {
            MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('ERR_RESOLVING_SKU'));
            this.baseItemAddedToCart = false;
        }
    },

    AddItem2ShopCartAjax: function (catEntryIdentifier, quantity, customParams, productId) {
        if (browseOnly) {
            MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('ERROR_ADD2CART_BROWSE_ONLY'));
            return;
        }
        var params = {storeId: this.storeId,
catalogId: this.catalogId,
langId: this.langId,
orderId: "."};
        // Remove calculations for performance
        // params.calculationUsage = "-1,-2,-5,-6,-7";
        params.inventoryValidation = "true";
        params.calculateOrder = "0";
        var ajaxShopCartService = "AddOrderItem";

        this.productAddedList = {};
        if (Array.isArray(catEntryIdentifier) && Array.isArray(quantity)) {
            for (var i = 0; i < catEntryIdentifier.length; i++) {
                if (!isPositiveInteger(quantity[i])) {
                    MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('QUANTITY_INPUT_ERROR'));
                    return;
                }
                params["catEntryId_" + (i + 1)] = catEntryIdentifier[i];
                params["quantity_" + (i + 1)] = quantity[i];
            }
        } else {
            if (!isPositiveInteger(quantity)) {
                MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('QUANTITY_INPUT_ERROR'));
                return;
            }
            params.catEntryId = catEntryIdentifier;
            params.quantity = quantity;

            var selectedAttrList = {};
            for (attr in this.selectedAttributesList['entitledItem_' + productId]) {
                selectedAttrList[attr] = this.selectedAttributesList['entitledItem_' + productId][attr];
            }

            if (productId == undefined) {
                this.saveAddedProductInfo(quantity, catEntryIdentifier, catEntryIdentifier, selectedAttrList);
            } else {
                this.saveAddedProductInfo(quantity, productId, catEntryIdentifier, selectedAttrList);
            }
        }

        //Pass any other customParams set by other add on features
        if (customParams != null && customParams != 'undefined') {
            for (i in customParams) {
                params[i] = customParams[i];
            }
            if (customParams['catalogEntryType'] == 'dynamicKit') {
                ajaxShopCartService = "AddPreConfigurationToCart";
            }
        }

        var contractIdElements = document.getElementsByName('contractSelectForm_contractId');
        if (contractIdElements != null && contractIdElements != "undefined") {
            for (i = 0; i < contractIdElements.length; i++) {
                if (contractIdElements[i].checked) {
                    params.contractId = contractIdElements[i].value;
                    break;
                }
            }
        }

        //For Handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        cursor_wait();

        wcService.invoke(ajaxShopCartService, params);
        this.baseItemAddedToCart = true;

        if (document.getElementById("headerShopCartLink") && document.getElementById("headerShopCartLink").style.display != "none") {
            $("#headerShopCart").focus();
        } else {
            $("#headerShopCart1").focus();
        }
    },

    /**
     * AddBundle2ShopCartAjax This function is used to add a bundle to the shopping cart.
     **/
    AddBundle2ShopCartAjax: function () {
        if (browseOnly) {
            MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('ERROR_ADD2CART_BROWSE_ONLY'));
            return;
        }
        var ajaxShopCartService = "AddOrderItem";
        var params = {
            storeId: this.storeId,
            catalogId: this.catalogId,
            langId: this.langId,
            orderId: ".",
            inventoryValidation: "true",
            calculateOrder: "0"
        };
        // Remove calculations for performance
        // params.calculationUsage = "-1,-2,-5,-6,-7";
        
        var idx = 1;
        this.productAddedList = {};

        for (productId in this.productList) {
            var productDetails = this.productList[productId];
            var quantity = Utils.parseNumber(productDetails.quantity);

            if (quantity == 0) {
                continue;
            }
            if (productDetails.id == 0) {
                MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('ERR_RESOLVING_SKU'));
                return;
            }
            if (isNaN(quantity) || quantity < 0) {
                MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('QUANTITY_INPUT_ERROR'));
                return;
            }

            params["catEntryId_" + idx] = productDetails.id;
            params["quantity_" + idx++] = quantity;
            this.baseItemAddedToCart = true;

            this.saveAddedProductInfo(quantity, productId, productDetails.id, this.selectedProducts[productId]);
        }

        //For Handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        wcService.invoke(ajaxShopCartService, params);

    },

    resetProductAddedList: function () {
        shoppingActionsJS.productAddedList = {};
    },
    /**
     * Save the product information of the newly added product(s) to be used for the mini cart product added popup
     *
     * @param {String} quantity The quantity of the product being purchased.
     * @param {String} productId The id of the product.
     * @param {String} skuId The id of the sku.
     * @param {String} attrList The list of selected attributes for the product, if any.
     **/
    saveAddedProductInfo: function (quantity, productId, skuId, attrList) {

        var productName = "";
        if ($("#ProductInfoName_" + productId).length) {
            productName = document.getElementById("ProductInfoName_" + productId).value;
        } else if ($("#ProductInfoName_" + skuId).length) {
            productName = document.getElementById("ProductInfoName_" + skuId).value;
        }

        var productThumbnail = "";
        if ($("#ProductInfoImage_" + productId).length) {
            productThumbnail = document.getElementById("ProductInfoImage_" + productId).value;
        } else if ($("#ProductInfoImage_" + skuId).length) {
            productThumbnail = document.getElementById("ProductInfoImage_" + skuId).value;
        }

        var productPrice = "";
        if ($("#ProductInfoPrice_" + productId).length) {
            productPrice = document.getElementById('ProductInfoPrice_' + productId).value;
        } else if ($("#ProductInfoPrice_" + skuId).length) {
            productPrice = document.getElementById('ProductInfoPrice_' + skuId).value;
        }

        var productAdded = [productName, productThumbnail, productPrice, quantity, attrList];
        if (productId != skuId) {
            this.productAddedList[skuId] = productAdded;
        } else {
            this.productAddedList[productId] = productAdded;
        }

        wcTopic.publish("ProductInfo_Added", this.productAddedList);
    },

    /* SwatchCode start */

    /**
     *setSKUImageId Sets the ID of the image to use for swatch.
     **/
    setSKUImageId: function (skuImageId) {
        this.skuImageId = skuImageId;
    },

    /**
     * getImageForSKU Returns the full image of the catalog entry with the selected attributes as specified in the {@link this.selectedAttributes} value.
     *					This method uses resolveImageForSKU to find the SKU image with the selected attributes values.
     *
     * @param {String} imageField, the field name from which the image should be picked
     * @return {String} path to the SKU image.
     * 
     *
     **/
    getImageForSKU: function (entitledItemId, imageField) {
        var attributeArray = [];
        var selectedAttributes = this.selectedAttributesList[entitledItemId];
        for (attribute in selectedAttributes) {
            attributeArray.push(attribute + "_|_" + selectedAttributes[attribute]);
        }
        return this.resolveImageForSKU(attributeArray, imageField);
    },

    /**
     * resolveImageForSKU Resolves image of a SKU using an array of defining attributes.
     *
     * @param {String[]} attributeArray An array of defining attributes upon which to resolve a SKU.
     * @param {String} imageField, the field name from which the image should be picked
     *
     * @return {String} imagePath The location of SKU image.
     *
     **/
    resolveImageForSKU: function (attributeArray, imageField) {

        console.debug("Resolving SKU >> " + attributeArray + ">>" + this.entitledItems);
        var imagePath = "";
        var attributeArrayCount = attributeArray.length;

        for (x in this.entitledItems) {
            if (null != imageField) {
                var imagePath = this.entitledItems[x][imageField];
            } else {
                var imagePath = this.entitledItems[x].ItemImage467;
            }

            var Attributes = this.entitledItems[x].Attributes;
            var attributeCount = 0;
            for (index in Attributes) {
                attributeCount++;
            }

            // Handle special case where a catalog entry has one sku with no attributes
            if (attributeArrayCount == 0 && attributeCount == 0) {
                return imagePath;
            }
            if (attributeCount != 0 && attributeArrayCount >= attributeCount) {
                var matchedAttributeCount = 0;

                for (attributeName in attributeArray) {
                    var attributeValue = attributeArray[attributeName];
                    if (attributeValue in Attributes) {
                        matchedAttributeCount++;
                    }
                }

                if (attributeCount == matchedAttributeCount) {
                    console.debug("ItemImage:" + imagePath + " for Attribute: " + attributeArray);
                    this.disableBuyButtonforUnbuyable(x);
                    var imageArray = [];
                    imageArray.push(imagePath);
                    imageArray.push(this.entitledItems[x].ItemThumbnailImage);
                    if (this.entitledItems[x].ItemAngleThumbnail != null && this.entitledItems[x].ItemAngleThumbnail != undefined) {
                        imageArray.push(this.entitledItems[x].ItemAngleThumbnail);
                        imageArray.push(this.entitledItems[x].ItemAngleFullImage);
                    }
                    return imageArray;
                }
            }
        }
        return null;
    },

    disableBuyButtonforUnbuyable: function (entitledItemIndex) {
        var buyableFlag = this.entitledItems[entitledItemIndex].buyable;
        //				disable the add to cart button
        var btn = document.getElementById("listViewAdd2Cart_" + this.entitledItems[entitledItemIndex].productId);
        if (buyableFlag != null && btn != null) {
            if (buyableFlag == 'false') {
                btn.className += " add2CartButtonDisabled";
            } else {
                btn.className = btn.className.replace(" add2CartButtonDisabled", "");
            }
        }
    },

    /**
     * changeViewImages Updates the angle views of the SKU.
     *
     * @param {String[]} itemAngleThumbnail An array of SKU view thumbnails.
     * @param {String[]} itemAngleFullImage An array of SKU view full images.
     **/
    changeViewImages: function (itemAngleThumbnail, itemAngleFullImage) {
        var imageCount = 0;
        for (x in itemAngleThumbnail) {
            var prodAngleCount = imageCount;
            imageCount++;
            $("#WC_CachedProductOnlyDisplay_images_1_" + imageCount).attr('src', itemAngleThumbnail[x]);
            if ($("#WC_CachedProductOnlyDisplay_links_1_" + imageCount).length) {
                $("#WC_CachedProductOnlyDisplay_links_1_" + imageCount).attr('href',
                    "JavaScript:changeThumbNail('productAngleLi" + prodAngleCount + "','" + itemAngleFullImage[x] + "');");
            }

            if ($("#productAngleLi" + prodAngleCount).length && $("#productAngleLi" + prodAngleCount).attr('className') === ('selected')) {
                changeThumbNail("productAngleLi" + prodAngleCount, itemAngleFullImage[x]);
            }
        }
    },


    /**
     * updates the product image from the PDP page to use the selected SKU image
     * @param String swatchAttrName the newly selection attribute name
     * @param String swatchAttrValue the newly selection attribute value
     * @param {String} imageField, the field name from which the image should be picked
     **/
    changeProdImage: function (entitledItemId, swatchAttrName, swatchAttrValue, skuImageId, imageField) {
        if ($("#" + entitledItemId).length) {
            //the json object for entitled items are already in the HTML. 
            entitledItemJSON = eval('(' + $("#" + entitledItemId).html() + ')');
        }

        this.setEntitledItems(entitledItemJSON);
        var productId = entitledItemId.substring(entitledItemId.indexOf("_") + 1);

        var skuImage = null;
        var imageArr = shoppingActionsJS.getImageForSKU(entitledItemId, imageField);
        if (imageArr != null) {
            skuImage = imageArr[0];
        }

        if (skuImageId != undefined) {
            this.setSKUImageId(skuImageId);
        }

        if (skuImage != null) {
            if ($("#" + this.skuImageId).length) {
                document.getElementById(this.skuImageId).src = skuImage;
                if ($("#ProductInfoImage_" + productId).length) {
                    document.getElementById("ProductInfoImage_" + productId).value = skuImage;
                }

                var itemAngleThumbnail = imageArr[2];
                var itemAngleFullImage = imageArr[3];
                if (itemAngleThumbnail != null && itemAngleThumbnail != undefined) {
                    shoppingActionsJS.changeViewImages(itemAngleThumbnail, itemAngleFullImage);
                }
            }
        } else {
            var imageFound = false;
            for (x in this.entitledItems) {
                var Attributes = this.entitledItems[x].Attributes;
                if (null != imageField) {
                    var itemImage = this.entitledItems[x][imageField];
                } else {
                    var itemImage = this.entitledItems[x].ItemImage467;
                }


                var itemAngleThumbnail = this.entitledItems[x].ItemAngleThumbnail;
                var itemAngleFullImage = this.entitledItems[x].ItemAngleFullImage;

                for (y in Attributes) {
                    var index = y.indexOf("_|_");
                    var entitledSwatchName = y.substring(0, index);
                    var entitledSwatchValue = y.substring(index + 3);

                    if (entitledSwatchName == swatchAttrName && entitledSwatchValue == swatchAttrValue) {
                        // set sku image only if the img element is present
                        if ($("#" + this.skuImageId).length) {
                            $("#" + this.skuImageId).attr('src', itemImage);
                            if (document.getElementById("ProductInfoImage_" + productId) != null) {
                                document.getElementById("ProductInfoImage_" + productId).value = itemImage;
                            }
                        }
                        if (itemAngleThumbnail != null && itemAngleThumbnail != undefined) {
                            shoppingActionsJS.changeViewImages(itemAngleThumbnail, itemAngleFullImage);
                        }
                        imageFound = true;
                        break;
                    }
                }

                if (imageFound) {
                    break;
                }
            }
        }
    },

    /**
     * Updates the swatches selections on list view.
     * Sets up the swatches array and sku images, then selects a default swatch value.
     **/
    updateSwatchListView: function () {
        var swatchArray = $("a[id^='swatch_array_']");
        for (var i = 0; i < swatchArray.length; i++) {
            var swatchArrayElement = swatchArray[i];
            eval($(swatchArrayElement).attr("href"));
        }

        var swatchSkuImage = $("a[id^='swatch_setSkuImage_']");
        for (var i = 0; i < swatchSkuImage.length; i++) {
            var swatchSkuImageElement = swatchSkuImage[i];
            eval($(swatchSkuImageElement).attr("href"));
        }

        var swatchDefault = $("a[id^='swatch_selectDefault_']");
        for (var i = 0; i < swatchDefault.length; i++) {
            var swatchDefaultElement = swatchDefault[i];
            eval($(swatchDefaultElement).attr("href"));
        }
    },

    /**
     * Handles the case when a swatch is selected. Set the border of the selected swatch.
     * @param {String} selectedAttributeName The name of the selected swatch attribute.
     * @param {String} selectedAttributeValue The value of the selected swatch attribute.
     * @param {String} entitledItemId The ID of the SKU
     * @param {String} doNotDisable The name of the swatch attribute that should never be disabled.
     * @param {String} imageField, the field name from which the image should be picked
     * @return boolean Whether the swatch is available for selection
     **/
    selectSwatch: function (selectedAttributeName, selectedAttributeValue, entitledItemId, doNotDisable, selectedAttributeDisplayValue, skuImageId, imageField) {
        if ($("#swatch_" + entitledItemId + "_" + selectedAttributeValue).hasClass("color_swatch_disabled")) {
            return;
        }
        var selectedAttributes = this.selectedAttributesList[entitledItemId];
        for (attribute in selectedAttributes) {
            if (attribute == selectedAttributeName) {
                // case when the selected swatch is already selected with a value, if the value is different than
                // what's being selected, reset other swatches and deselect the previous value and update selection
                if (selectedAttributes[attribute] != selectedAttributeValue) {
                    // deselect previous value and update swatch selection
                    var swatchElement = document.getElementById("swatch_" + entitledItemId + "_" + selectedAttributes[attribute]);
                    swatchElement.className = "color_swatch";
                    swatchElement.src = swatchElement.src.replace("_disabled.png", "_enabled.png");

                    //change the title text of the swatch link
                    document.getElementById("swatch_link_" + entitledItemId + "_" + selectedAttributes[attribute]).title = swatchElement.alt;
                }
            }
            if (document.getElementById("swatch_link_" + entitledItemId + "_" + selectedAttributes[attribute]) != null) {
                document.getElementById("swatch_link_" + entitledItemId + "_" + selectedAttributes[attribute]).setAttribute("aria-checked", "false");
            }
        }
        this.makeSwatchSelection(selectedAttributeName, selectedAttributeValue, entitledItemId, doNotDisable, selectedAttributeDisplayValue, skuImageId, imageField);
    },

    /**
     * Make swatch selection - add to selectedAttribute, select image, and update other swatches and SKU image based on current selection.
     * @param {String} swatchAttrName The name of the selected swatch attribute.
     * @param {String} swatchAttrValue The value of the selected swatch attribute.
     * @param {String} entitledItemId The ID of the SKU.
     * @param {String} doNotDisable The name of the swatch attribute that should never be disabled.	
     * @param {String} skuImageId This is optional. The element id of the product image - image element id is different in product page and category list view. Product page need not pass it because it is set separately
     * @param {String} imageField This is optional. The json field from which image should be picked. Pass value if a different size image need to be picked
     **/
    makeSwatchSelection: function (swatchAttrName, swatchAttrValue, entitledItemId, doNotDisable, selectedAttributeDisplayValue, skuImageId, imageField) {
        // setSelectedAttribute internally calls changeProdImage method to change product image.
        this.setSelectedAttribute(swatchAttrName, swatchAttrValue, entitledItemId, skuImageId, imageField);
        document.getElementById("swatch_" + entitledItemId + "_" + swatchAttrValue).className = "color_swatch_selected";
        document.getElementById("swatch_link_" + entitledItemId + "_" + swatchAttrValue).setAttribute("aria-checked", "true");
        document.getElementById("swatch_selection_label_" + entitledItemId + "_" + swatchAttrName).className = "header color_swatch_label";
        if (document.getElementById("swatch_selection_" + entitledItemId + "_" + swatchAttrName).style.display == "none") {
            document.getElementById("swatch_selection_" + entitledItemId + "_" + swatchAttrName).style.display = "inline";
        }
        if (selectedAttributeDisplayValue != null) {
            document.getElementById("swatch_selection_" + entitledItemId + "_" + swatchAttrName).innerHTML = selectedAttributeDisplayValue;
        } else {
            document.getElementById("swatch_selection_" + entitledItemId + "_" + swatchAttrName).innerHTML = swatchAttrValue;
        }

        this.updateSwatchImages(swatchAttrName, entitledItemId, doNotDisable, imageField);
    },

    /**
     * Constructs record and add to this.allSwatchesArray.
     * @param {String} swatchName The name of the swatch attribute.
     * @param {String} swatchValue The value of the swatch attribute.	
     * @param {String} swatchImg1 The path to the swatch image.
     **/
    addToAllSwatchsArray: function (swatchName, swatchValue, swatchImg1, entitledItemId, swatchDisplayValue) {
        var swatchList = this.allSwatchesArrayList[entitledItemId];
        if (swatchList == null) {
            swatchList = [];;
        }
        if (!this.existInAllSwatchsArray(swatchName, swatchValue, swatchList)) {
            var swatchRecord = [];
            swatchRecord[0] = swatchName;
            swatchRecord[1] = swatchValue;
            swatchRecord[2] = swatchImg1;
            swatchRecord[4] = document.getElementById("swatch_link_" + entitledItemId + "_" + swatchValue).onclick;
            swatchRecord[5] = null;
            swatchRecord[6] = swatchDisplayValue;
            swatchList.push(swatchRecord);
            this.allSwatchesArrayList[entitledItemId] = swatchList;
        }
    },

    /**
     * Checks if a swatch is already exist in this.allSwatchesArray.
     * @param {String} swatchName The name of the swatch attribute.
     * @param {String} swatchValue The value of the swatch attribute.		
     * @return boolean Value indicating whether or not the specified swatch name and value exists in the allSwatchesArray.
     */
    existInAllSwatchsArray: function (swatchName, swatchValue, swatchList) {
        for (var i = 0; i < swatchList.length; i++) {
            var attrName = swatchList[i][0];
            var attrValue = swatchList[i][1];
            if (attrName == swatchName && attrValue == swatchValue) {
                return true;
            }
        }
        return false;
    },

    /**
     * Check the entitledItems array and pre-select the first entited SKU as the default swatch selection.
     * @param {String} entitledItemId The ID of the SKU.
     * @param {String} doNotDisable The name of the swatch attribute that should never be disabled.		
     **/
    makeDefaultSwatchSelection: function (entitledItemId, doNotDisable) {
        if (this.entitledItems.length == 0) {
            if ($("#" + entitledItemId).length) {
                entitledItemJSON = eval('(' + $("#" + entitledItemId).html() + ')');
            }
            this.setEntitledItems(entitledItemJSON);
        }

        // need to make selection for every single swatch
        for (x in this.entitledItems) {
            var Attributes = this.entitledItems[x].Attributes;
            for (y in Attributes) {
                var index = y.indexOf("_|_");
                var swatchName = y.substring(0, index);
                var swatchValue = y.substring(index + 3);
                this.makeSwatchSelection(swatchName, swatchValue, entitledItemId, doNotDisable, null, imageField);
            }
            break;
        }
    },

    /**
     * Update swatch images - this is called after selection of a swatch is made, and this function checks for
     * entitlement and disable swatches that are not available
     * @param selectedAttrName The attribute that is selected
     * @param {String} entitledItemId The ID of the SKU.
     * @param {String} doNotDisable The name of the swatch attribute that should never be disabled.	
     **/
    updateSwatchImages: function (selectedAttrName, entitledItemId, doNotDisable, imageField) {
        var swatchToUpdate = [];
        var selectedAttributes = this.selectedAttributesList[entitledItemId];
        var selectedAttrValue = selectedAttributes[selectedAttrName];
        var swatchList = this.allSwatchesArrayList[entitledItemId];

        // finds out which swatch needs to be updated, add to swatchToUpdate array
        for (var i = 0; i < swatchList.length; i++) {
            var attrName = swatchList[i][0];
            var attrValue = swatchList[i][1];
            var attrImg1 = swatchList[i][2];
            var attrImg2 = swatchList[i][3];
            var attrOnclick = swatchList[i][4];
            var attrDisplayValue = swatchList[i][6];

            if (attrName != doNotDisable && attrName != selectedAttrName) {
                var swatchRecord = [];
                swatchRecord[0] = attrName;
                swatchRecord[1] = attrValue;
                swatchRecord[2] = attrImg1;
                swatchRecord[4] = attrOnclick;
                swatchRecord[5] = false;
                swatchRecord[6] = attrDisplayValue;
                swatchToUpdate.push(swatchRecord);
            }
        }

        // finds out which swatch is entitled, if it is, image should be set to enabled
        // go through entitledItems array and find out swatches that are entitled 
        for (x in this.entitledItems) {
            var Attributes = this.entitledItems[x].Attributes;

            for (y in Attributes) {
                var index = y.indexOf("_|_");
                var entitledSwatchName = y.substring(0, index);
                var entitledSwatchValue = y.substring(index + 3);

                //the current entitled item has the selected attribute value
                if (entitledSwatchName == selectedAttrName && entitledSwatchValue == selectedAttrValue) {
                    //go through the other attributes that are available to the selected attribute
                    //exclude the one that is selected
                    for (z in Attributes) {
                        var index2 = z.indexOf("_|_");
                        var entitledSwatchName2 = z.substring(0, index2);
                        var entitledSwatchValue2 = z.substring(index2 + 3);

                        if (y != z) { //only check the attributes that are not the one selected
                            for (i in swatchToUpdate) {
                                var swatchToUpdateName = swatchToUpdate[i][0];
                                var swatchToUpdateValue = swatchToUpdate[i][1];

                                if (entitledSwatchName2 == swatchToUpdateName && entitledSwatchValue2 == swatchToUpdateValue) {
                                    swatchToUpdate[i][5] = true;
                                }
                            }
                        }
                    }
                }
            }
        }

        // Now go through swatchToUpdate array, and update swatch images
        var disabledAttributes = [];
        for (i in swatchToUpdate) {
            var swatchToUpdateName = swatchToUpdate[i][0];
            var swatchToUpdateValue = swatchToUpdate[i][1];
            var swatchToUpdateImg1 = swatchToUpdate[i][2];
            var swatchToUpdateImg2 = swatchToUpdate[i][3];
            var swatchToUpdateOnclick = swatchToUpdate[i][4];
            var swatchToUpdateEnabled = swatchToUpdate[i][5];

            if (swatchToUpdateEnabled) {
                if (document.getElementById("swatch_" + entitledItemId + "_" + swatchToUpdateValue).className != "color_swatch_selected") {
                    var swatchElement = document.getElementById("swatch_" + entitledItemId + "_" + swatchToUpdateValue);
                    swatchElement.className = "color_swatch";
                    swatchElement.src = swatchElement.src.replace("_disabled.png", "_enabled.png");

                    //change the title text of the swatch link
                    document.getElementById("swatch_link_" + entitledItemId + "_" + swatchToUpdateValue).title = swatchElement.alt;
                }
                document.getElementById("swatch_link_" + entitledItemId + "_" + swatchToUpdateValue).setAttribute("aria-disabled", "false");
                document.getElementById("swatch_link_" + entitledItemId + "_" + swatchToUpdateValue).onclick = swatchToUpdateOnclick;
            } else {
                if (swatchToUpdateName != doNotDisable) {
                    var swatchElement = document.getElementById("swatch_" + entitledItemId + "_" + swatchToUpdateValue);
                    var swatchLinkElement = document.getElementById("swatch_link_" + entitledItemId + "_" + swatchToUpdateValue);
                    swatchElement.className = "color_swatch_disabled";
                    swatchLinkElement.onclick = null;
                    swatchElement.src = swatchElement.src.replace("_enabled.png", "_disabled.png");

                    //change the title text of the swatch link

                    var titleText = Utils.getLocalizationMessage("INV_ATTR_UNAVAILABLE", [swatchElement.alt]);

                    document.getElementById("swatch_link_" + entitledItemId + "_" + swatchToUpdateValue).setAttribute("aria-disabled", "true");

                    //The previously selected attribute is now unavailable for the new selection
                    //Need to switch the selection to an available value
                    if (selectedAttributes[swatchToUpdateName] == swatchToUpdateValue) {
                        disabledAttributes.push(swatchToUpdate[i]);
                    }
                }
            }
        }

        //If there were any previously selected attributes that are now unavailable
        //Find another available value for that attribute and update other attributes according to the new selection
        for (i in disabledAttributes) {
            var disabledAttributeName = disabledAttributes[i][0];
            var disabledAttributeValue = disabledAttributes[i][1];

            for (i in swatchToUpdate) {
                var swatchToUpdateName = swatchToUpdate[i][0];
                var swatchToUpdateValue = swatchToUpdate[i][1];
                var swatchToUpdateDisplayValue = swatchToUpdate[i][6];
                var swatchToUpdateEnabled = swatchToUpdate[i][5];

                if (swatchToUpdateName == disabledAttributeName && swatchToUpdateValue != disabledAttributeValue && swatchToUpdateEnabled) {
                    this.makeSwatchSelection(swatchToUpdateName, swatchToUpdateValue, entitledItemId, doNotDisable, swatchToUpdateDisplayValue, imageField);
                    break;
                }
            }
        }
    },
    /* SwatchCode end */

    /**
     * This function is used to change the price displayed in the Product Display Page on change of  a attribute of the product using an AJAX call. 
     * This function will resolve the catentryId using entitledItemId and displays the price of the catentryId.
     *				
     * @param {Object} entitledItemId A DIV containing a JSON object which holds information about a catalog entry. You can reference CachedProductOnlyDisplay.jsp to see how that div is constructed.
     * @param {Boolean} isPopup If the value is true, then this implies that the function was called from a quick info pop-up.
     * @param {Boolean} displayPriceRange If the value is true, then display the price range. If it is false then donot display the price range.
     *
     **/
    changePrice: function (entitledItemId, isPopup, displayPriceRange, productId) {
        this.displayPriceRange = displayPriceRange;
        this.isPopup = isPopup;
        var entitledItemJSON;

        if ($("#" + entitledItemId).length && !this.isPopup) {
            //the json object for entitled items are already in the HTML. 
            entitledItemJSON = eval('(' + $("#" + entitledItemId).html() + ')');
        } else {
            //if $("#"+ entitledItemId).length is 0, that means there's no <div> in the HTML that contains the JSON object. 
            //in this case, it must have been set in catalogentryThumbnailDisplay.js when the quick info
            entitledItemJSON = this.getEntitledItemJsonObject();
        }
        var catalogEntryId = null;
        this.setEntitledItems(entitledItemJSON);

        if (this.selectedProducts[productId]) {
            var catalogEntryId = this.getCatalogEntryIdforProduct(this.selectedProducts[productId]);
        } else {
            var catalogEntryId = this.getCatalogEntryId(entitledItemId);
        }

        if (catalogEntryId != null) {
            //check if the json object is already present for the catEntry.
            if (this.itemPriceJsonOject[catalogEntryId] != null && this.itemPriceJsonOject[catalogEntryId] != 'undefined') {
                this.displayPrice(this.itemPriceJsonOject[catalogEntryId].catalogEntry, productId);
                console.debug("ShoppingActions.changePrice: using stored json object.");
            }
            //if json object is not present, call the service to get the details.
            else {
                var parameters = {
                    storeId: this.storeId,
                    langId: this.langId,
                    catalogId: this.catalogId,
                    catalogEntryId: catalogEntryId,
                    productId: productId
                };

                //Declare a service for retrieving catalog entry detailed information for an item...
                wcService.declare({
                    id: "getCatalogEntryDetailsSA",
                    actionId: "getCatalogEntryDetailsSA",
                    url: getAbsoluteURL() + appendWcCommonRequestParameters("GetCatalogEntryDetailsByIDView"),
                    formId: ""

                    ,
                    successHandler: function (serviceResponse, ioArgs) {
                        shoppingActionsJS.displayPriceServiceResponse(serviceResponse, ioArgs);
                    }

                    ,
                    failureHandler: function (serviceResponse, ioArgs) {
                        console.debug("ShoppingActions.changePrice: Unexpected error occurred during an xhrPost request.");
                    }

                });
                wcService.invoke("getCatalogEntryDetailsSA", parameters);
            }
        } else {
            console.debug("ShoppingActions.changePrice: all attributes are not selected.");
        }

    },

    /** 
     * Displays price of the catEntry selected with the JSON objrct returned from the server.
     * 
     * @param {object} serviceRepsonse The JSON response from the service.
     * @param {object} ioArgs The arguments from the service call.
     */
    displayPriceServiceResponse: function (serviceResponse, ioArgs) {
        var productId = ioArgs.productId;
        //stores the json object, so that the service is not called when same catEntry is selected.
        shoppingActionsJS.itemPriceJsonOject[serviceResponse.catalogEntry.catalogEntryIdentifier.uniqueID] = serviceResponse;

        shoppingActionsJS.displayPrice(serviceResponse.catalogEntry, productId);
    },

    /** 
     * Displays price of the attribute selected with the JSON oject.
     * 
     * @param {object} catEntry The JSON object with catalog entry details.
     */
    displayPrice: function (catEntry, productId) {

        var tempString;
        var popup = shoppingActionsJS.isPopup;

        if (popup == true) {
            $("#productPrice").html(catEntry.offerPrice);
            document.getElementById('productName').innerHTML = catEntry.description[0].name;
            document.getElementById('productSKUValue').innerHTML = catEntry.catalogEntryIdentifier.externalIdentifier.partNumber;
        }

        if (popup == false) {
            var innerHTML = "";
            var listPrice = Utils.parseNumber(catEntry.listPrice);
            var offerPrice = Utils.parseNumber(catEntry.offerPrice);

            this.setPriceInProductList(productId, offerPrice);

            if (!catEntry.listPriced || listPrice <= offerPrice) {
                innerHTML = "<span id='offerPrice_" + catEntry.catalogEntryIdentifier.uniqueID + "' class='price'>" + catEntry.offerPrice + "</span>";
            } else {
                innerHTML = "<span id='listPrice_" + catEntry.catalogEntryIdentifier.uniqueID + "' class='old_price'>" + catEntry.listPrice + "</span>" +
                    "<span id='offerPrice_" + catEntry.catalogEntryIdentifier.uniqueID + "' class='price'>" + catEntry.offerPrice + "</span>";
            }
            document.getElementById('price_display_' + productId).innerHTML = innerHTML + "<input type='hidden' id='ProductInfoPrice_" + catEntry.catalogEntryIdentifier.uniqueID + "' value='" + catEntry.offerPrice + "'/>";

            innerHTML = "";
            if (shoppingActionsJS.displayPriceRange == true) {
                for (var i in catEntry.priceRange) {
                    if (catEntry.priceRange[i].endingNumberOfUnits == catEntry.priceRange[i].startingNumberOfUnits) {
                        tempString = Utils.getLocalizationMessage('PQ_PRICE_X', {
                            0: catEntry.priceRange[i].startingNumberOfUnits
                        });
                        innerHTML = innerHTML + "<p>" + tempString;
                    } else if (catEntry.priceRange[i].endingNumberOfUnits != 'null') {
                        tempString = Utils.getLocalizationMessage('PQ_PRICE_X_TO_Y', {
                            0: catEntry.priceRange[i].startingNumberOfUnits,
                            1: catEntry.priceRange[i].endingNumberOfUnits
                        });
                        innerHTML = innerHTML + "<p>" + tempString;
                    } else {
                        tempString = Utils.getLocalizationMessage('PQ_PRICE_X_OR_MORE', {
                            0: catEntry.priceRange[i].startingNumberOfUnits
                        });
                        innerHTML = innerHTML + "<p>" + tempString;
                    }
                    innerHTML = innerHTML + " <span class='price'>" + catEntry.priceRange[i].localizedPrice + "</span></p>";
                }
            }
            // Append productId so that element is unique in bundle page, where there can be multiple components
            var quantityDiscount = document.getElementById("productLevelPriceRange_" + productId);
            var itemQuantityDiscount = document.getElementById("itemLevelPriceRange_" + productId);

            // if product level price exists and no section to update item level price
            if (null != quantityDiscount && null == itemQuantityDiscount) {
                quantityDiscount.style.display = ""; //display product level price range
            }
            // if item level price range is present
            else if ("" != innerHTML && null != itemQuantityDiscount) {
                innerHTML = Utils.getLocalizationMessage('PQ_PURCHASE') + innerHTML;
                itemQuantityDiscount.innerHTML = innerHTML;
                itemQuantityDiscount.style.display = "";
                // hide the product level price range
                if (null != quantityDiscount) {
                    quantityDiscount.style.display = "none";
                }
            }
            // if item level price range is not present
            else if ("" == innerHTML) {
                if (null != itemQuantityDiscount) {
                    itemQuantityDiscount.style.display = "none"; //hide item level price range
                }
                if (null != quantityDiscount) {
                    quantityDiscount.style.display = ""; //display product level price range
                }
            }

            /*
             * If the product name is a link, do not replace the link only replace the text in the link.
             * Otherwise, replace the whole text
             */
            var productNameLink = $('#product_name_' + productId + ' > a');
            if (productNameLink.length == 1) {
                $(productNameLink[0]).html(catEntry.description[0].name);
            } else if ($('#product_name_' + productId)) {
                $('#product_name_' + productId).html(catEntry.description[0].name);
            }

            if ($("#widget_product_info_viewer > div[id^='PageHeading_']").length) {
                $("#widget_product_info_viewer > div[id^='PageHeading_']").each(function (i, node) {
                    if (node.childNodes != null && node.childNodes.length == 3) {
                        node.childNodes[1].innerHTML = catEntry.description[0].name;
                    }
                });
            }
            if (document.getElementById("ProductInfoName_" + productId) != null) {
                document.getElementById("ProductInfoName_" + productId).value = catEntry.description[0].name;
            }
            if (document.getElementById('product_shortdescription_' + productId)) {
                document.getElementById('product_shortdescription_' + productId).innerHTML = catEntry.description[0].shortDescription;
            }
            if (document.getElementById('product_SKU_' + productId)) {
                document.getElementById('product_SKU_' + productId).innerHTML = Utils.getLocalizationMessage('SKU') + " " + catEntry.catalogEntryIdentifier.externalIdentifier.partNumber;
            }
        }
    },

    /**
     *This method will show the WC Dialog popup
     *@param{String} widgetId The ID of the WC Dialog which should be shown
     */
    showWCDialogPopup: function (widgetId) {
        var dialog = $("#" + widgetId).data("wc-WCDialog");
        if (dialog) {
            dialog.open();
            $("#" + widgetId).css("display", "block");
        } else {
            console.debug(widgetId + " does not exist");
        }
    },

    /**
     * To notify the change in attribute to other components that is subscribed to DefiningAttributes_Resolved_[productId] event.
     */
    notifyAttributeChange: function (catalogEntryID) {
        this.baseCatalogEntryId = catalogEntryID;
        var selectedAttributes = this.selectedAttributesList["entitledItem_" + catalogEntryID];
        wcTopic.publish('DefiningAttributes_Resolved_' + catalogEntryID, catalogEntryID, -1);
    },

    /**
     * To notify the change in quantity to other components that is subscribed to Quantity_Changed event.
     */
    notifyQuantityChange: function (quantity) {
        wcTopic.publish("Quantity_Changed", quantity);
    },

    /**
     * Initializes the compare check box for all the products added to compare.
     */
    initCompare: function (fromPage) {
        if (fromPage == 'compare' || fromPage == 'catalogEntryList') {
            this.checkForCompare();
        } else {
            var cookieKey = this.cookieKeyPrefix + this.storeId;
            var newCookieValue = "";
            setCookie(cookieKey, newCookieValue, {
                path: '/',
                domain: cookieDomain
            });
        }

    },

    /**
     * Change the compare box status to checked or unchecked
     * @param{String} cbox The ID of the compare check box of the given catentry identifier.
     * @param{String} catEntryIdentifier The catalog entry identifer to current product.
     */
    changeCompareBox: function (cbox, catEntryIdentifier) {
        box = document.getElementById(cbox);
        box.checked = !box.checked;
        this.addOrRemoveFromCompare(catEntryIdentifier, box.checked);
    },

    /**
     * Adds or removes the product from the compare depending on the compare box checked or unchecked.
     * @param{String} catEntryIdentifier The catalog entry identifer to current product.
     * @param{boolean} checked True if the checkbox is checked or False
     */
    addOrRemoveFromCompare: function (catEntryIdentifier, checked) {
        //box = eval(cbox);
        if (checked) {
            this.addToCompare(catEntryIdentifier);
        } else {
            this.removeFromCompare(catEntryIdentifier);
        }
    },

    /**
     * Adds the product to the compare cookie.
     * @param{String} catEntryIdentifier The catalog entry identifer to current product.
     */
    addToCompare: function (catEntryIdentifier) {

        var cookieKey = this.cookieKeyPrefix + this.storeId;
        var cookieValue = getCookie(cookieKey);

        if (cookieValue != null) {
            if (cookieValue.indexOf(catEntryIdentifier) != -1 || catEntryIdentifier == null) {
                MessageHelper.displayErrorMessage(Utils.getLocalizationMessage("COMPARE_ITEM_EXISTS"));
                return;
            }
        }

        var currentNumberOfItemsInCompare = 0;
        if (cookieValue != null && cookieValue !== "") {
            currentNumberOfItemsInCompare = cookieValue.split(this.cookieDelimiter).length;
        }

        if (currentNumberOfItemsInCompare < parseInt(this.maxNumberProductsAllowedToCompare)) {
            var newCookieValue = "";
            if (cookieValue == null || cookieValue === "") {
                newCookieValue = catEntryIdentifier;
            } else {
                newCookieValue = cookieValue + this.cookieDelimiter + catEntryIdentifier;
            }
            setCookie(cookieKey, newCookieValue, {
                path: '/',
                domain: cookieDomain
            });
            shoppingActionsJS.checkForCompare();
        } else {
            this.showWCDialogPopup('widget_product_comparison_popup');
            document.getElementById("comparebox_" + catEntryIdentifier).checked = false;
            console.debug("You can only compare up to 4 products");
        }
    },

    /**
     * Removes the product from the compare cookie.
     * @param{String} catEntryIdentifier The catalog entry identifer to current product.
     */
    removeFromCompare: function (catEntryIdentifier) {
        var cookieKey = this.cookieKeyPrefix + this.storeId;
        var cookieValue = getCookie(cookieKey);
        var currentNumberOfItemsInCompare = 0;
        if (cookieValue != null) {
            if (cookieValue.trim() == "") {
                setCookie(cookieKey, null, {
                    expires: -1
                });
            } else {
                var cookieArray = cookieValue.split(this.cookieDelimiter);
                var newCookieValue = "";
                for (index in cookieArray) {
                    if (cookieArray[index] != catEntryIdentifier) {
                        if (newCookieValue === "") {
                            newCookieValue = cookieArray[index];
                        } else {
                            newCookieValue = newCookieValue + this.cookieDelimiter + cookieArray[index];
                        }
                    }
                }
                setCookie(cookieKey, newCookieValue, {
                    path: '/',
                    domain: cookieDomain
                });
                currentNumberOfItemsInCompare = newCookieValue.split(this.cookieDelimiter).length;
            }
            shoppingActionsJS.checkForCompare();
        }
    },

    /**
     * Re-directs the browser to the CompareProductsDisplay page to compare products side-by-side.
     */
    compareProducts: function (categoryIds, manufacturer) {
        var url = appendWcCommonRequestParameters("CompareProductsDisplayView?storeId=" + this.storeId + "&catalogId=" + this.catalogId + "&langId=" + this.langId + "&compareReturnName=" + encodeURIComponent(this.compareReturnName) + "&searchTerm=" + this.searchTerm);
        if ('' != categoryIds.top_category) {
            url = url + "&top_category=" + categoryIds.top_category;
        }
        if ('' != categoryIds.parent_category_rn) {
            url = url + "&parent_category_rn=" + categoryIds.parent_category_rn;
        }
        if ('' != categoryIds.categoryId) {
            url = url + "&categoryId=" + categoryIds.categoryId;
        }
		if (manufacturer != undefined && '' != manufacturer) {
			url = url + "&manufacturer=" + manufacturer;
		}
		
        var cookieKey = this.cookieKeyPrefix + this.storeId;
        var cookieValue = getCookie(cookieKey);
        if (cookieValue != null && cookieValue.trim() != "") {
            url = url + "&catentryId=" + cookieValue;
        }
        var returnUrl = appendWcCommonRequestParameters(location.href);
        if (returnUrl.indexOf("?") === -1) {
            returnUrl = returnUrl + "?fromPage=compare";
        } else if (returnUrl.indexOf("fromPage=compare") === -1) {
            returnUrl = returnUrl + "&fromPage=compare";
        }
        url = url + "&returnUrl=" + encodeURIComponent(returnUrl);
        location.href = getAbsoluteURL() + url;
    },

    /**
     * Sets the quantity of a product in the list (bundle)
     * 
     * @param {String} catalogEntryType, type of catalogEntry (item/product/bundle/package)
     * @param {int} catalogEntryId The catalog entry identifer to current product.
     * @param {int} quantity The quantity of current product.
     * @param {float} price The price of current product.
     */
    setProductQuantity: function (catalogEntryType, catalogEntryId, quantity, price) {
        var productDetails = null;
        if (this.productList[catalogEntryId]) {
            productDetails = this.productList[catalogEntryId];
        } else {
            productDetails = {};
            this.productList[catalogEntryId] = productDetails;
            productDetails.baseItemId = catalogEntryId;
            if ("item" == catalogEntryType) {
                productDetails.id = catalogEntryId;
            } else {
                productDetails.id = 0;
            }
        }
        productDetails.quantity = quantity;
        wcTopic.publish("Quantity_Changed", JSON.stringify(productDetails));
        productDetails.price = Utils.parseNumber(price);
    },

    /**
     * Sets the quantity of a product in the list (bundle)
     * 
     * @param {int} catalogEntryId The catalog entry identifer to current product.
     * @param {int} quantity The quantity of current product.
     */
    quantityChanged: function (catalogEntryId, quantity) {
        if (this.productList[catalogEntryId]) {
            var productDetails = this.productList[catalogEntryId];
            productDetails.quantity = quantity.trim();
            wcTopic.publish("Quantity_Changed", JSON.stringify(productDetails));

            //Update quantity for catentries in the merchandising association array
            if (MerchandisingAssociationJS != null) {
                if (MerchandisingAssociationJS.baseItemParams != null) {
                    if (MerchandisingAssociationJS.baseItemParams.type == 'BundleBean') {
                        // Update items in the bundle
                        for (idx = 0; idx < MerchandisingAssociationJS.baseItemParams.components.length; idx++) {
                            if (catalogEntryId == MerchandisingAssociationJS.baseItemParams.components[idx].productId || catalogEntryId == MerchandisingAssociationJS.baseItemParams.components[idx].id) {
                                MerchandisingAssociationJS.baseItemParams.components[idx].quantity = productDetails.quantity;
                            }
                        }
                    }
                }
            }
        }
    },

    /**
     * Sets the price of a product in the list (bundle)
     * 
     * @param {int} catalogEntryId The catalog entry identifer to current product.
     * @param {int} price The price of current product.
     */
    setPriceInProductList: function (catalogEntryId, price) {
        var productDetails = this.productList[catalogEntryId];
        if (productDetails) {
            productDetails.price = price;
        }
    },

    /**
     * Select bundle item swatch
     * 
     * @param {int} catalogEntryId The catalog entry identifer to current product.
     * @param {String} swatchName
     * @param {String} swatchValue
     * @param {String} doNotDisable, the first swatch, that should not be disabled
     */
    selectBundleItemSwatch: function (catalogEntryId, swatchName, swatchValue, doNotDisable) {
        if ($("#swatch_" + catalogEntryId + "_" + swatchName + "_" + swatchValue).hasClass("color_swatch_disabled")) {
            return;
        }
        if ($("#entitledItem_" + catalogEntryId).length) {
            var entitledItemJSON;
            var currentSwatchkey = swatchName + "_" + swatchValue;
            //the json object for entitled items are already in the HTML. 
            entitledItemJSON = JSON.stringify($("#entitledItem_" + catalogEntryId).html());
            var validSwatchArr = [];
            for (idx in entitledItemJSON) {
                var validItem = false;
                var entitledItem = entitledItemJSON[idx];
                for (attribute in entitledItem.Attributes) {

                    if (currentSwatchkey == attribute) {
                        validItem = true;
                        break;
                    }
                }
                if (validItem) {
                    for (attribute in entitledItem.Attributes) {
                        var currentSwatch = attribute.substring(0, attribute.lastIndexOf("_|_"));
                        if (currentSwatch != doNotDisable && currentSwatch != swatchName) {
                            validSwatchArr.push(attribute);
                        }
                    }
                }
            }

            var swatchesDisabled = [];
            var selectedSwatches = [];
            for (idx in entitledItemJSON) {
                var entitledItem = entitledItemJSON[idx];
                for (attribute in entitledItem.Attributes) {
                    var currentSwatch = attribute.substring(0, attribute.lastIndexOf("_|_"));
                    if (currentSwatch != doNotDisable && currentSwatch != swatchName) {
                        var swatchId = "swatch_" + catalogEntryId + "_" + attribute;
                        var swatchLinkId = swatchId.replace("swatch_", "swatch_link_");
                        if (validSwatchArr.indexOf(attribute) > -1) {
                            if (!$("#" + swatchId).hasClass("color_swatch_selected")) {
                                document.getElementById(swatchId).className = "color_swatch";
                                document.getElementById(swatchId).src = document.getElementById(swatchId).src.replace("_disabled.png", "_enabled.png");

                                //change the title text of the swatch link
                                document.getElementById(swatchLinkId).title = document.getElementById(swatchId).alt;
                                document.getElementById(swatchLinkId).setAttribute("aria-disabled", "false");
                            }
                        } else if (swatchesDisabled.indexOf(attribute) === -1) {
                            swatchesDisabled.push(attribute);
                            if ($("#" + swatchId).hasClass("color_swatch_selected")) {
                                selectedSwatches.push(swatchId);
                            }
                            document.getElementById(swatchId).className = "color_swatch_disabled";
                            document.getElementById(swatchId).src = document.getElementById(swatchId).src.replace("_enabled.png", "_disabled.png");

                            //change the title text of the swatch link
			    
			    var altText = document.getElementById(swatchId).alt;
                            var titleText = Utils.getLocalizationMessage("INV_ATTR_UNAVAILABLE", [altText]);
                            

                           
                            $("#" + swatchLinkId).attr("aria-disabled", "true");
                        }
                    }
                    if (document.getElementById("swatch_link_" + catalogEntryId + "_" + attribute) != null) {
                        document.getElementById("swatch_link_" + catalogEntryId + "_" + attribute).setAttribute("aria-checked", "false");
                    }
                }
            }

            for (idx in selectedSwatches) {
                var selectedSwatch = selectedSwatches[idx];
                var idSelector = selectedSwatch.substring(0, selectedSwatch.lastIndexOf("_|_"));
                var swatchSelected = false;
                $("[id^='" + idSelector + "']").each(function (index, node, arr) {
                    if (!swatchSelected && $(node).hasClass("color_swatch")) {
                        var values = node.id.split("_");
                        shoppingActionsJS.selectBundleItemSwatch(values[1], values[2], values[3], doNotDisable);
                        shoppingActionsJS.setSelectedAttributeOfProduct(values[1], values[2], values[3], false);
                        swatchSelected = true;
                    }
                });
            }
        }

        if ($("#swatch_selection_" + catalogEntryId + "_" + swatchName).css("display") == ("none")) {
            $("#swatch_selection_" + catalogEntryId + "_" + swatchName).css("display", "inline");
        }
        $("#swatch_selection_" + catalogEntryId + "_" + swatchName).html(swatchValue);

        var swatchItem = "swatch_" + catalogEntryId + "_" + swatchName + "_";
        var swatchItemLink = "swatch_link_" + catalogEntryId + "_" + swatchName + "_";

        $("img[id^='" + swatchItem + "']").each(function (index, node, arr) {
            if ($(node).hasClass("color_swatch_disabled")) {
                $(node).removeClass("color_swatch")
            } else {
                $(node).addClass("color_swatch");
            }
            $(node).removeClass("color_swatch_selected");
        });

        $("#" + swatchItem + swatchValue).attr("className", "color_swatch_selected");
        document.getElementById(swatchItemLink + swatchValue).setAttribute("aria-checked", "true");

        this.setSelectedAttributeOfProduct(catalogEntryId, swatchName, swatchValue, false);
        // select image
        this.changeBundleItemImage(catalogEntryId, swatchName, swatchValue, "productThumbNailImage_" + catalogEntryId);

    },

    changeBundleItemImage: function (catalogEntryId, swatchAttrName, swatchAttrValue, skuImageId) {
        var entitledItemId = "entitledItem_" + catalogEntryId;
        if ($("#" + entitledItemId).length) {
            //the json object for entitled items are already in the HTML. 
            entitledItemJSON = eval('(' + $("#" + entitledItemId).html() + ')');
        }

        this.setEntitledItems(entitledItemJSON);

        var skuImage = null;
        var imageArr = shoppingActionsJS.getImageForBundleItem(catalogEntryId);
        if (imageArr != null) {
            skuImage = imageArr[1];
        }

        if (skuImageId != undefined) {
            this.setSKUImageId(skuImageId);
        }

        if (skuImage != null) {
            if ($("#" + this.skuImageId) != null) {
                document.getElementById(this.skuImageId).src = skuImage;
                if (document.getElementById("ProductInfoImage_" + catalogEntryId) != null) {
                    document.getElementById("ProductInfoImage_" + catalogEntryId).value = skuImage;
                }
            }
        } else {
            var imageFound = false;
            for (x in this.entitledItems) {
                var Attributes = this.entitledItems[x].Attributes;
                var itemImage = this.entitledItems[x].ItemThumbnailImage;

                for (y in Attributes) {
                    var index = y.indexOf("_|_");
                    var entitledSwatchName = y.substring(0, index);
                    var entitledSwatchValue = y.substring(index + 3);

                    if (entitledSwatchName == swatchAttrName && entitledSwatchValue == swatchAttrValue) {
                        document.getElementById(this.skuImageId).src = itemImage;
                        if (document.getElementById("ProductInfoImage_" + catalogEntryId) != null) {
                            document.getElementById("ProductInfoImage_" + catalogEntryId).value = itemImage;
                        }
                        imageFound = true;
                        break;
                    }
                }

                if (imageFound) {
                    break;
                }
            }
        }
    },

    getImageForBundleItem: function (entitledItemId) {
        var attributeArray = [];
        var selectedAttributes = this.selectedProducts[entitledItemId];
        for (attribute in selectedAttributes) {
            attributeArray.push(attribute + "_|_" + selectedAttributes[attribute]);
        }
        return this.resolveImageForSKU(attributeArray);
    },

    /**
     * Check if any product is already selected for compare in other pages and select them
     */
    checkForCompare: function () {
        var cookieValues = getCookie(shoppingActionsJS.cookieKeyPrefix + shoppingActionsJS.storeId);
        cookieValues = (cookieValues ? cookieValues.split(shoppingActionsJS.cookieDelimiter) : []);
        var labels = $(".compareCheckboxLabels > label");
        $(".compare_target").each(function (i, div) {
            var checkbox = $("input[type=\"checkbox\"]", div)[0];
            checkbox.checked = (cookieValues.indexOf(checkbox.value) !== -1);
            var state = (checkbox.checked ? (cookieValues.length > 1 ? 2 : 1) : 0);
            div.setAttribute("data-state", state.toString());
            var label = $("label[for=\"" + checkbox.id + "\"]", div)[0];
            $(label).html($(labels[state]).html());
        });
    },

    /**
     * replaceItemAjaxHelper This function is used to replace an item in the cart. This will be called from the {@link this.ReplaceItemAjax} method.
     *
     * @param {String} catalogEntryId The catalog entry of the item to replace to the cart.
     * @param {int} qty The quantity of the item to add.
     * @param {String} removeOrderItemId The order item ID of the catalog entry to remove from the cart.
     * @param {String} addressId The address ID of the order item.
     * @param {String} shipModeId The shipModeId of the order item.
     * @param {String} physicalStoreId The physicalStoreId of the order item.
     *
     **/
    replaceItemAjaxHelper: function (catalogEntryId, qty, removeOrderItemId, addressId, shipModeId, physicalStoreId) {

        var params = {
            storeId: WCParamJS.storeId,
            catalogId: WCParamJS.catalogId,
            langId: WCParamJS.langId,
            orderItemId: removeOrderItemId,
            orderId: "."
        };
        if (CheckoutHelperJS.shoppingCartPage) {
            params.calculationUsage = "-1,-2,-5,-6,-7";
        } else {
            params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
        }

        var params2 = {
            storeId: WCParamJS.storeId,
            catalogId: WCParamJS.catalogId,
            langId: WCParamJS.langId,
            catEntryId: catalogEntryId,
            quantity: qty,
            orderId: ".",
	    calculateOrder: "1"
        };
        if (CheckoutHelperJS.shoppingCartPage) {
            params2.calculationUsage = "-1,-2,-5,-6,-7";
        } else {
            params2.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
        }

        var params3 = {
            storeId: WCParamJS.storeId,
            catalogId: WCParamJS.catalogId,
            langId: WCParamJS.langId,
            orderId: "."
        };
        if (CheckoutHelperJS.shoppingCartPage) {
            params3.calculationUsage = "-1,-2,-5,-6,-7";
        } else {
            params3.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
        }

        var shipInfoUpdateNeeded = false;
        var orderItemReqd = true;
        if (addressId != null && addressId !== "") {
            params3.addressId = addressId;
        }
        if (shipModeId != null && shipModeId !== "") {
            params3.shipModeId = shipModeId;
        }
        if (physicalStoreId != null && physicalStoreId !== "") {
            params3.physicalStoreId = physicalStoreId;
            orderItemReqd = false;
        }
        if (params3.shipModeId != null && (params3.addressId != null || params3.physicalStoreId != null)) {
            shipInfoUpdateNeeded = true;
        }

        if (orderItemReqd) {
            params3.allocate = "***";
            params3.backorder = "***";
            params3.remerge = "***";
            params3.check = "*n";
        }

        //Delcare service for deleting item...
        wcService.declare({
            id: "AjaxReplaceItem",
            actionId: "AjaxReplaceItem",
            url: "AjaxRESTOrderItemDelete",
            formId: ""

            ,
            successHandler: function (serviceResponse) {
                //Now add the new item to cart..
                if (!shipInfoUpdateNeeded) {
                    //We dont plan to update addressId and shipMOdeId..so call AjaxAddOrderItem..
                    wcService.invoke("AjaxAddOrderItem", params2);
                } else {
                    //We need to update the adderessId and shipModeId..so call our temp service to add..
                    wcService.invoke("AjaxAddOrderItemTemp", params2);
                }
            }

            ,
            failureHandler: function (serviceResponse) {
                if (serviceResponse.errorMessage) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                } else {
                    if (serviceResponse.errorMessageKey) {
                        MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                    }
                }
                cursor_clear();
            }

        });

        //Delcare service for adding item..
        wcService.declare({
            id: "AjaxAddOrderItemTemp",
            actionId: "AjaxAddOrderItemTemp",
            url: "AjaxRESTOrderItemAdd",
            formId: ""

            ,
            successHandler: function (serviceResponse) {
                // setting the newly created orderItemId
                params3.orderItemId = (serviceResponse.orderItem != null && serviceResponse.orderItem[0].orderItemId != null) ? serviceResponse.orderItem[0].orderItemId : serviceResponse.orderItemId;

                MessageHelper.displayStatusMessage(MessageHelper.messages["SHOPCART_ADDED"]);

                //Now item is added.. call update to set addressId and shipModeId...
                wcService.invoke("OrderItemAddressShipMethodUpdate", params3);
            }

            ,
            failureHandler: function (serviceResponse) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
            }
        });

        //For Handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        wcService.invoke("AjaxReplaceItem", params);
    },

    /**
     * customizeDynamicKit This function is used to call the configurator page for a dynamic kit.
     * @param {String} catEntryIdentifier A catalog entry ID of the item to add to the cart.
     * @param {int} quantity A quantity of the item to add to the cart.
     * @param {Object} customParams - Any additional parameters that needs to be passed to the configurator page.
     *
     **/
    customizeDynamicKit: function (catEntryIdentifier, quantity, customParams) {
        var params = {
            storeId: this.storeId,
            catalogId: this.catalogId,
            langId: this.langId,
            catEntryId: catEntryIdentifier,
            quantity: quantity
        };

        if (!isPositiveInteger(quantity)) {
            MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('QUANTITY_INPUT_ERROR'));
            return;
        }

        var contractIdElements = document.getElementsByName('contractSelectForm_contractId');
        if (contractIdElements != null && contractIdElements != "undefined") {
            for (i = 0; i < contractIdElements.length; i++) {
                if (contractIdElements[i].checked) {
                    params.contractId = contractIdElements[i].value;
                    break;
                }
            }
        }

        //Pass any other customParams set by other add on features
        if (customParams != null && customParams != 'undefined') {
            for (i in customParams) {
                params[i] = customParams[i];
            }
        }

        //For Handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        cursor_wait();

        var configureURL = "ConfigureView";
        var i = 0;
        for (param in params) {
            configureURL += ((i++ == 0) ? "?" : "&") + param + "=" + params[param];
        }
        document.location.href = getAbsoluteURL() + appendWcCommonRequestParameters(configureURL);
    }

}

wcTopic.subscribe("ProductInfo_Reset", shoppingActionsJS.resetProductAddedList);

$(document).ready(function () {
    var ie_version = Utils.get_IE_version();
    if (ie_version < 9) {
        $(document).on("click", ".compare_target > input[type=\"checkbox\"]:click", function (event) {
            this.blur();
            this.focus();
        });
    }
});

//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2013, 2017 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

productDisplayJS = {
	/** Last price saved for post minicart display **/
	lastPriceSaved : "",
	lastOfferPriceSaved : "",
	priceSwitched : false,
	pst:"",
	fullPrice:"",
    /** The language ID currently in use **/
    langId: "-1",

    pst: "",
    /** The store ID currently in use **/
    storeId: "",

    /** The catalog ID currently in use **;/
    catalogId: "",

    /** Holds the current user type such as guest or registered user. Allowed values are 'G' for guest and 'R' for registered.**/
    userType: "",

    /** A boolean used in a variety of the add to cart methods to tell whether or not the base item was added to the cart. **/
    baseItemAddedToCart: false,

    /** An array of entitled items which is used in various methods throughout ShoppingActions.js **/
    entitledItems: [],

    /** a JSON object that holds attributes of an entitled item **/
    entitledItemJsonObject: null,

    /** A map of attribute name value pairs for the currently selected attribute values **/
    selectedAttributesList: {},

    /** A map of currently selected attribute values for a catalog entry **/
    selectedAttributeValues: {},

    /** A map of HTML element ids associated with an attribute name **/
    registeredAttributeIds: {},

    /** A variable used to form the url dynamically for the more info link in the Quickinfo popup */
    moreInfoUrl: "",
    
    mostSoldSize:"",
    
    /**
     * A boolean used to to determine is it from a Qick info popup or not.
     **/
    isPopup: false,

    /**
     * A boolean used to to determine whether or not to display the price range when the catEntry is selected.
     **/
    displayPriceRange: true,

    /**
     * This array holds the json object returned from the service, holding the price information of the catEntry.
     **/
    itemPriceJsonOject: [],

    /**
     * stores all name and value of all swatches
     * this is a 2 dimension array and each record i contains the following information:
     * allSwatchesArray[i][0] - attribute name of the swatch
     * allSwatchesArray[i][1] - attribute value of the swatch
     * allSwatchesArray[i][2] - image1 of swatch (image to use for enabled state)
     * allSwatchesArray[i][3] - image2 of swatch (image to use for disabled state)
     * allSwatchesArray[i][4] - onclick action of the swatch when enabled
     **/
    allSwatchesArrayList: {},

    /**
     * stores all name and id of all dropdowns
     **/
    allDropdownsList: {},

    /**
     * Holds the ID of the image used for swatch
     **/
    skuImageId: "",

    /**
     * The prefix of the cookie key that is used to store item IDs.
     */
    cookieKeyPrefix: "CompareItems_",

    /**
     * The delimiter used to separate item IDs in the cookie.
     */
    cookieDelimiter: ";",

    /**
     * The maximum number of items allowed in the compare zone.
     */
    maxNumberProductsAllowedToCompare: 4,

    /**
     * The minimum number of items allowed in the compare zone.
     */
    minNumberProductsAllowedToCompare: 2,

    /**
     * Id of the base catalog entry.
     */
    baseCatalogEntryId: 0,

    /**
     * An map which holds the attributes of a set of products
     */
    selectedProducts: {},

    /**
     * An array to keep the quantity of the products in a list (bundle)
     */
    productList: {},

    /**
     * stores the currency symbol
     */
    currencySymbol: "",

    /**
     * stores the compare return page name
     */
    compareReturnName: "",
    /**
     * stores the search term
     */
    searchTerm: "",

    search01: "'",

    search02: '"',

    replaceStr01: /\\\'/g,

    replaceStr02: /\\\"/g,

    ampersandChar: /&/g,

    ampersandEntityName: "&amp;",

    singleSKUProductWithoutDefiningAttribute: false,

    replaceStr001: "&#039;",
    replaceStr002: "&#034;",

    engraving : false,

    engravingText :"",

    engravingFont : "",

    prescription : false,
    lensMaterialValue : "",
    lensOptionValue : "",
    lensTypeValue : "",
    changedCatEntryId : "",

    isFrameOnly : false,

    /**
     * Prescription variables
     */
    hasPres : "",
    sizeHasPres : "",
    modelHasPres : "",
    lensId : "",
    isContactLens : false,
    YMALProductFlag : false, //true if a product is added directly from cart
    RMAProductFlag : false,
    /**
     * A boolean used to to determine if product is added using Lens Configurator
    **/
    usingLensConfigurator: false,

    setCommonParameters: function (langId, storeId, catalogId, userType, currencySymbol) {
        productDisplayJS.langId = langId;
        productDisplayJS.storeId = storeId;
        productDisplayJS.catalogId = catalogId;
        productDisplayJS.userType = userType;
        productDisplayJS.currencySymbol = currencySymbol;
    },

    setEntitledItems: function (entitledItemArray) {
        productDisplayJS.entitledItems = entitledItemArray;
    },

    
    
    getCatalogEntryId: function (entitledItemId) {
        var attributeArray = [];
        var selectedAttributes = productDisplayJS.selectedAttributesList[entitledItemId];
        for (attribute in selectedAttributes) {
            attributeArray.push(attribute + "_|_" + selectedAttributes[attribute]);
        }
        // there are no selected attribute and no entitled item, this must be a single sku item without defining attribute
        if (selectedAttributes == null && this.entitledItems == null) {
            return entitledItemId.substring(entitledItemId.indexOf("_") + 1);
        }
        return productDisplayJS.resolveSKU(attributeArray);
    },

    getContactLensCatalogEntryIds: function (entitledItemId) {
        var attributeArray = [];
        var catetryIds = [];
        var selectedAttributes = productDisplayJS.selectedAttributesList[entitledItemId];
        if (typeof selectedAttributes !== 'undefined') {
            for (attribute in selectedAttributes) {
                if (attribute.split("__")[1] === "right") {
                    attributeArray.push(attribute.split("__")[0] + "_|_" + selectedAttributes[attribute]);
                }
            }

            var catId = productDisplayJS.resolveSKU(attributeArray);
            if (catId != null && $('.defining-contact-lens #check-Right').prop( "checked")) {
                catetryIds.push(catId);
            } else {
                catetryIds.push(0);
            }

            var attributeArray = [];
            for (attribute in selectedAttributes) {
                if (attribute.split("__")[1] === "left") {
                    attributeArray.push(attribute.split("__")[0] + "_|_" + selectedAttributes[attribute]);
                }
            }
            var catId = productDisplayJS.resolveSKU(attributeArray);
            if (catId != null &&  $('.defining-contact-lens #check-Left').prop( "checked")) {
                catetryIds.push(catId);
            } else {
                catetryIds.push(0);
            }
        }
        return catetryIds;
    },

    /**
     * getCatalogEntryIdforProduct Returns the catalog entry ID for a catalog entry that has the same attribute values as a specified product's selected attributes as passed in via the selectedAttributes parameter.
     *
     * @param {String[]} selectedAttributes The array of selected attributes upon which to resolve the SKU.
     *
     * @return {String} catalog entry ID of the SKU.
     *
     **/
    getCatalogEntryIdforProduct: function (selectedAttributes) {
        var attributeArray = [];
        for (attribute in selectedAttributes) {
            attributeArray.push(attribute + "_|_" + selectedAttributes[attribute]);
        }
        return productDisplayJS.resolveSKU(attributeArray);
    },

    /**
     * retrieves the entitledItemJsonObject
     */
    getEntitledItemJsonObject: function () {
        return productDisplayJS.entitledItemJsonObject;
    },

    /**
     * resolveSKU Resolves a SKU using an array of defining attributes.
     *
     * @param {String[]} attributeArray An array of defining attributes upon which to resolve a SKU.
     *
     * @return {String} catentry_id The catalog entry ID of the SKU.
     *
     **/
    resolveSKU: function (attributeArray) {
        console.debug("Resolving SKU >> " + attributeArray + ">>" + this.entitledItems);
        var catentry_id = "";
        var attributeArrayCount = attributeArray.length;

        // if there is only one item, no need to check the attributes to resolve the sku
        if (this.entitledItems.length == 1) {
            return this.entitledItems[0].catentry_id;
        }
        for (x in this.entitledItems) {
            var catentry_id = this.entitledItems[x].catentry_id;
            var Attributes = this.entitledItems[x].Attributes;
            var attributeCount = 0;
            for (index in Attributes) {
                attributeCount++;
            }

            // Handle special case where a catalog entry has one sku with no attributes
            if (attributeArrayCount == 0 && attributeCount == 0) {
                return catentry_id;
            }
            if (attributeCount != 0 && attributeArrayCount >= attributeCount) {
                var matchedAttributeCount = 0;

                for (attributeName in attributeArray) {
                    var attributeValue = attributeArray[attributeName];
                    if (attributeValue in Attributes) {
                        matchedAttributeCount++;
                    }
                }

                if (attributeCount == matchedAttributeCount) {
                    console.debug("CatEntryId:" + catentry_id + " for Attribute: " + attributeArray);
                    this.disableBuyButtonforUnbuyable(x);
                    return catentry_id;
                }
            }
        }
        return null;
    },

    /**
     * disables add2cart button in case where the buyable flag is set to false
     */
    disableBuyButtonforUnbuyable: function (entitledItemIndex) {
        var buyableFlag = this.entitledItems[entitledItemIndex].buyable;
        //disable the add to cart button
        var btn = document.getElementById("add2CartBtn");
        if (buyableFlag != null && btn != null) {
            if (buyableFlag == 'false') {
                btn.className += " add2CartButtonDisabled";
            } else {
                btn.className = btn.className.replace(" add2CartButtonDisabled", "");
            }
        }
    },

    /**
     * Set the prescription variables
     *
     * @param {boolean} hasPresc indicates if the item has prescription
     * @param {boolean} sizeHasPresc indicates if the product has prescription
     * @param {boolean} modelHasPresc indicates if the model has prescription
     */

    setHasPrescription : function (hasPresc, sizeHasPresc, modelHasPresc) {
        this.hasPres = hasPresc;
        this.sizeHasPres = sizeHasPresc;
        this.modelHasPres = modelHasPresc;
    },

    /**
     * function that show or hide the prescription size message or prescription button if has or not prescription
     */
    prescChangeSelect : function () {
        var itemInventory = getInventory(this.changedCatEntryId);
        if(wkndActive) {
            try {
                var currentSku = skus.filter((sku) => sku.uniqueID == this.changedCatEntryId);
                if(currentSku.length>0) {
                    window.wunderkind.product.sku = currentSku[0].partNumber;
                }
            } catch (error) {
                console.error(error);
            }
            
        }
        console.log("PSL::ProductDisplay.js::prescChangeSelect::changedCatEntryId::"+this.changedCatEntryId);
        console.log("PSL::ProductDisplay.js::ItemInventory::"+itemInventory);
        var roxframeIdAvailable = ($('#roxFrameID').val()!= undefined && $('#roxFrameID').val()!=  null && $('#roxFrameID').val()!=  '');
        if (itemInventory !== false){
            if (itemInventory>0){

                $("#catEntryID").val(this.changedCatEntryId); 
                if(this.hasPres === "true" || this.sizeHasPres === "true" || roxframeIdAvailable == true){
                    /*if ($("#presc-lens-info__" + this.changedCatEntryId).length) {
                        var lensJSON = JSON.parse($("#presc-lens-info__" + this.changedCatEntryId).text());
                        var merchan = lensJSON.merchandisingAssociations;
                        if(typeof merchan !== "undefined"){
                            for (var i = 0; i < merchan.length; i++){
                                if(merchan[i].associationType == "ROX"){
                                   // $("#presc--button").css("display", "block");
                                    var roxFramePrice = null;
                                    if(frameMap != undefined &&
                                        frameMap[merchan[i].uniqueID] != undefined &&
                                        frameMap[merchan[i].uniqueID].price != undefined &&
                                        frameMap[merchan[i].uniqueID].price.price != "" ){
                                            roxFramePrice = frameMap[merchan[i].uniqueID].price.price;
                                        }
                                    if(frameMap === null){
                                        $(".presc--side--button").addClass("disabledButton");
                                    } else {
                                        $(".presc--side--button").removeClass("disabledButton");
                                    } 
                                /*
                                } else {
                                    $("#presc--button").css("display", "none");
                                    $("#presc--msg--size").css("display", "block");
                                }
                            }
                        } else {
                            $("#presc--button").css("display", "none");
                            $("#presc--msg--size").css("display", "block");
                        }
                    }*/
                    $("#presc--msg--size").css("display", "none");
                    $("#roxLenses").val(this.changedCatEntryId);
                    $("#roxFrameID").val(this.changedCatEntryId);
                }
                
	     		for(var i = 0; i < productDisplayJS.entitledItems.length; i++){
	     			if(productDisplayJS.entitledItems[i].catentry_id == productDisplayJS.changedCatEntryId ){
                        $("a[data-element-id='X_Pdp_Prod_AddLens']").attr('data-description',productDisplayJS.entitledItems[i].seo_url.split('/')[productDisplayJS.entitledItems[i].seo_url.split('/').length-1]);//// set Partnumber in LensConfigurator analytics
	     				var upcSizeChanged = productDisplayJS.entitledItems[i].seo_url.split('/')[productDisplayJS.entitledItems[i].seo_url.split('/').length-1];
	     			   $('#vm_box').attr('data-vm',upcSizeChanged);
                       $("a[data-element-id='X_X_VirtualMirror_Start']").attr('data-description',productDisplayJS.entitledItems[i].seo_url.split('/')[productDisplayJS.entitledItems[i].seo_url.split('/').length-1]);
	     			   if (typeof vmUpcAvailability != 'undefined') {
                        if(!$('vm_box').hasClass('hide') && $.cookie("isVMOpen") == "1"){
                            if(vmUpcAvailability != undefined && vmUpcAvailability[upcSizeChanged] != undefined &&  vmUpcAvailability[upcSizeChanged].isAvailable()){
                                if((isOliver || (window.mobilecheck() || window.tabletPortraitCheck())) && !isVogue){
                                    $('.container-btn').show();
                                }else{
                                    $('.container-btn-dsk').show();
                                }
                                $("[data-espot-name='X_PDP_Editorial_VirtualMirror']").show();
                                moveVMOverProduct();
                                vmTryThemOn();  
                            }else{
                            	if (typeof vmSwitchOff === 'function') {
                                	vmSwitchOff(false);
                            	   }
                                if((isOliver || (window.mobilecheck() || window.tabletPortraitCheck())) && !isVogue){
                                    $('.container-btn').hide();
                                }else{
                                    $('.container-btn-dsk').hide();
                                }
                                $("[data-espot-name='X_PDP_Editorial_VirtualMirror']").hide();	     					 
                            }	     		    	 
                        }else if($.cookie("isVMOpen") != "1"){
                            if(vmUpcAvailability != undefined && vmUpcAvailability[upcSizeChanged] != undefined && vmUpcAvailability[upcSizeChanged].isAvailable()){	     		    		  
                                if((isOliver || (window.mobilecheck() || window.tabletPortraitCheck())) && !isVogue){
                                    $('.container-btn').show();
                                }else{
                                    $('.container-btn-dsk').show();
                                }
                                $("[data-espot-name='X_PDP_Editorial_VirtualMirror']").show();
                            }else{
                                if((isOliver || (window.mobilecheck() || window.tabletPortraitCheck())) && !isVogue){
                                    //$('.container-btn').hide();
                                }else{
                                    //hide try them on while loading
                                    //$('.container-btn-dsk').hide();
                                    
                                }
                                $("[data-espot-name='X_PDP_Editorial_VirtualMirror']").hide();
                            }	 
                        }
                      }
	     		      break;
	     		    }
	     		}
            }else{
                $(".presc--side").hide();
            }
        }

    },

    /**
     * registerAttributeIds Register the ids of HTML attributes that are associated with the specified attribute.
     *
     * @param {String} attributeName The name of the attribute.
     * @param {String} entitledItemId The element id where the json object of the sku is stored
     * @param {Object} ids Map of named HTML element ids
     *
     **/
    registerAttributeIds: function (attributeName, entitledItemId, ids) {
        var attributeIds = productDisplayJS.registeredAttributeIds[entitledItemId];
        if (attributeIds == null) {
            attributeIds = {};
            productDisplayJS.registeredAttributeIds[entitledItemId] = attributeIds;
        }

        attributeIds[productDisplayJS.removeQuotes(attributeName)] = ids;
    },

    /**
     * getAttributeIds Get the map of ids of HTML attributes that are associated with the specified attribute.
     *
     * @param {String} attributeName The name of the attribute.
     * @param {String} entitledItemId The element id where the json object of the sku is stored
     *
     * @return {Object} ids Map of named HTML element ids
     *
     **/
    getAttributeIds: function (attributeName, entitledItemId) {
        var ids = null;
        var attributeIds = productDisplayJS.registeredAttributeIds[entitledItemId];
        if (attributeIds != null) {
            ids = attributeIds[productDisplayJS.removeQuotes(attributeName)];
        }
        return ids;
    },

    /**
     * setSelectedAttribute Sets the selected attribute value for a particular attribute not in reference to any catalog entry.
     *					   One place this function is used is on CachedProductOnlyDisplay.jsp where there is a drop down box of attributes.
     *					   When an attribute is selected from that drop down this method is called to update the selected value for that attribute.
     *
     * @param {String} selectedAttributeName The name of the attribute.
     * @param {String} selectedAttributeValue The value of the selected attribute.
     * @param {String} entitledItemId The element id where the json object of the sku is stored
     * @param {String} skuImageId This is optional. The element id of the product image - image element id is different in product page and category list view. Product page need not pass it because it is set separately
     * @param {String} imageField This is optional. The json field from which image should be picked. Pass value if a different size image need to be picked
     * @param {String} selectedAttributeDisplayValue This is optional. The attribute display value formatted with UOM
     *
     **/
    setSelectedAttribute: function (selectedAttributeName, selectedAttributeValue, entitledItemId, skuImageId, imageField, selectedAttributeDisplayValue, eye) {
        var selectedAttributes = productDisplayJS.selectedAttributesList[entitledItemId];
        if (selectedAttributes == null) {
            selectedAttributes = {};
        }
        selectedAttributeValue = selectedAttributeValue.replace(productDisplayJS.replaceStr001, productDisplayJS.search01);
        selectedAttributeValue = selectedAttributeValue.replace(productDisplayJS.replaceStr002, productDisplayJS.search02);
        selectedAttributeValue = selectedAttributeValue.replace(productDisplayJS.replaceStr01, productDisplayJS.search01);
        selectedAttributeValue = selectedAttributeValue.replace(productDisplayJS.replaceStr02, productDisplayJS.search02);
        selectedAttributeValue = selectedAttributeValue.replace(productDisplayJS.ampersandChar, productDisplayJS.ampersandEntityName);
        if (eye != null && eye != '') {
            selectedAttributes[selectedAttributeName + "__" + eye] = selectedAttributeValue;
        } else {
            selectedAttributes[selectedAttributeName] = selectedAttributeValue;
        }

        productDisplayJS.moreInfoUrl = productDisplayJS.moreInfoUrl + '&' + selectedAttributeName + '=' + selectedAttributeValue;
        productDisplayJS.selectedAttributesList[entitledItemId] = selectedAttributes;
        if (skuImageId != undefined) {
            productDisplayJS.setSKUImageId(skuImageId);
        }
        var entitledItemJSON;
        if ($("#" + entitledItemId).length && !productDisplayJS.isPopup) {
            //the json object for entitled items are already in the HTML.
            entitledItemJSON = eval('(' + $("#" + entitledItemId).html() + ')');
        } else {
            //if $("#" + entitledItemId).length is 0, that means there's no <div> in the HTML that contains the JSON object.
            //in this case, it must have been set in catalogentryThumbnailDisplay.js when the quick info
            entitledItemJSON = productDisplayJS.getEntitledItemJsonObject();
        }
        productDisplayJS.setEntitledItems(entitledItemJSON);
        var attributeIds = productDisplayJS.getAttributeIds(selectedAttributeName, entitledItemId);
        if (attributeIds != null) {
            var usedFilterValue = $("#" + attributeIds.usedFilterValueId);
            if (usedFilterValue != null) {
                if (selectedAttributeDisplayValue) {
                    $(usedFilterValue).html(selectedAttributeDisplayValue);
                } else {
                    $(usedFilterValue).html(selectedAttributeValue);
                }
            }
            if (selectedAttributeValue === "") {
                $("#" + attributeIds.usedFilterId).removeClass("visible");
                var hideCurrentUsedFilters = true;
                var dropdownList = this.allDropdownsList[entitledItemId];
                for (var i in dropdownList) {
                    if (selectedAttributes[dropdownList[i].name] !== "") {
                        hideCurrentUsedFilters = false;
                        break;
                    }
                }
                if (hideCurrentUsedFilters) {
                    $("#currentUsedFilters_" + entitledItemId).addClass("hidden");
                }
            } else {
                $("#" + attributeIds.usedFilterId).addClass("visible");
                $("#currentUsedFilters_" + entitledItemId).removeClass("hidden");
                //var selectedAttributeNameId = selectedAttributeName.replace(productDisplayJS.search01, "\\\'").replace(productDisplayJS.search02, '\\\"');
                //$("[id='attr_" + entitledItemId + '_' + selectedAttributeNameId + "']").addClass("hidden");
            }

            //Create dropdown combo only when the product has more than one size
            if (entitledItemJSON.length>1){
                productDisplayJS.makeDropdownSelection(selectedAttributeName, selectedAttributeValue, entitledItemId);
            };
        }
    },

    /**
     * resetSelectedAttribute Resets the the selected attribute value for the specified attribute.
     *
     * @param {String} attributeName The name of the attribute.
     * @param {String} entitledItemId The element id where the json object of the sku is stored
     * @param {String} productUrl The url of the parent product
     *
     **/
    resetSelectedAttribute: function (attributeName, entitledItemId) {
        var attributeName = attributeName.replace(productDisplayJS.search01, "\\\'").replace(productDisplayJS.search02, '\\\"');
        $("[id='attr_" + entitledItemId + '_' + attributeName + "']").removeClass("hidden");

        var attributeIds = productDisplayJS.getAttributeIds(attributeName, entitledItemId);
        if (attributeIds != null) {
            var selectWidget = $(attributeIds.selectAttributeValueId);
            if (selectWidget.length) {
                selectWidget.val("");
                selectWidget.Select("refresh");
            }
        }

        var dropdownList = this.allDropdownsList[entitledItemId];
        var remainingSelectedAttributes = {};

        for (var i = 0; i < dropdownList.length; i++) {
            if (dropdownList[i].name.replace(/\\'/g, "'") == attributeName.replace(/\\'/g, "'")) {
                $(dropdownList[i].node).removeClass("hidden");
                $(dropdownList[i].node).val('');
                $(dropdownList[i].node).Select("refresh");
                $(dropdownList[i].node).change();
            } else {
                for (var j = 0; j < dropdownList[i].options.length; j++) {
                    if (dropdownList[i].options[j].selected === true) {
                        remainingSelectedAttributes[dropdownList[i].name] = dropdownList[i].options[j].value;
                    }
                }
            }
        }

        var urlWithoutParams = document.location.href.split('?')[0];
        var params = "?";

        var productUrl = "";
        if ($("#ProductDisplayURL").length) {
            productUrl = $("#ProductDisplayURL").html();
        }

        var displaySKUContextData = false;
        if ($("#displaySKUContextData").length) {
            displaySKUContextData = eval('(' + $("#displaySKUContextData").html() + ')');
        }

        if (displaySKUContextData && urlWithoutParams !== productUrl) {
            for (attr in remainingSelectedAttributes) {
                if (remainingSelectedAttributes.hasOwnProperty(attr)) {
                    params += attr + '=' + remainingSelectedAttributes[attr] + '&';
                }
            }

            params = params.slice(0, -1);
            params = params.replace("\\\'", "'").replace('\\\"', '"');
            document.location.replace(productUrl + params);
        }
    },

    /**
     * setSelectedAttributeName Set the selected attribute name and make the drop-down associated with the attribute visible.
     *
     * @param {String} attributeName The name of the attribute.
     * @param {String} entitledItemId The element id where the json object of the sku is stored
     *
     **/
    setSelectedAttributeName: function (attributeName, entitledItemId) {
        var oldSelectedAttributeValuesId = productDisplayJS.selectedAttributeValues[entitledItemId];
        if (oldSelectedAttributeValuesId != null && oldSelectedAttributeValuesId !== "") {
            $("#" + oldSelectedAttributeValuesId).addClass("mobileHidden");
        }
        var selectedAttributeValuesId = null;
        var attributeIds = productDisplayJS.getAttributeIds(attributeName, entitledItemId);
        if (attributeIds != null) {
            selectedAttributeValuesId = attributeIds.attributeValuesId;
        }
        if (selectedAttributeValuesId != null && selectedAttributeValuesId !== "") {
            $("#" + selectedAttributeValuesId).removeClass("mobileHidden");
        }
        productDisplayJS.selectedAttributeValues[entitledItemId] = selectedAttributeValuesId;
    },

    /**
     * Add2ShopCartAjax This function is used to add a catalog entry to the shopping cart using an AJAX call. This will resolve the catentryId using entitledItemId and adds the item to the cart.
     *				This function will resolve the SKU based on the entitledItemId passed in and call {@link productDisplayJS.AddItem2ShopCartAjax}.
     * @param {String} entitledItemId A DIV containing a JSON object which holds information about a catalog entry. You can reference CachedProductOnlyDisplay.jsp to see how that div is constructed.
     * @param {int} quantity The quantity of the item to add to the cart.
     * @param {String} isPopup If the value is true, then this implies that the function was called from a quick info pop-up.
     * @param {Object} customParams - Any additional parameters that needs to be passed during service invocation.
     *
     **/
    Add2ShopCartAjax: function (entitledItemId, quantity, isPopup, customParams) {
    	var isWishlistPage = $("#page").hasClass("wishListDisplay") ? true : false;
        var itemId = entitledItemId.split("_")[1];
        if(isPersol) {
    		productDisplayJS.lastPriceSaved = isWishlistPage ? document.getElementById('offerPrice_'+ itemId).innerText : document.getElementById('offerPrice_'+catalogEntryDetails.uniqueID).innerText;
    		if (isWishlistPage){ // Wishlist
                if(typeof document.getElementById('listPrice_'+ itemId)!= 'undefined' && document.getElementById('listPrice_'+ itemId) != null){
                    productDisplayJS.lastOfferPriceSaved = document.getElementById('listPrice_'+ itemId).innerText;
                }
            } else {
                if(typeof document.getElementById('listPrice_'+catalogEntryDetails.uniqueID)!= 'undefined' && document.getElementById('listPrice_'+catalogEntryDetails.uniqueID) != null){
                    productDisplayJS.lastOfferPriceSaved = document.getElementById('listPrice_'+catalogEntryDetails.uniqueID).innerText;
                }
            }
    	}
    	else if(isOliver) {
    		var elements = !isWishlistPage ? document.querySelectorAll('[id=offerPrice_'+productParent+']') : document.querySelectorAll('[id=offerPrice_'+itemId+']');
    		var div;
    		for(var i = 0; i<elements.length;i++) {
    			if(elements[i].nodeName == "DIV") {
    				div = elements[i];
    			}
    		}
    		if(div != undefined) {
    			productDisplayJS.lastPriceSaved = div.getElementsByClassName('price__unity')[0].innerText;
    		}
            if (!isWishlistPage){
                productDisplayJS.lastOfferPriceSaved = document.getElementById('listPrice_'+productParent).innerText;
            } else {
                productDisplayJS.lastOfferPriceSaved = document.getElementById('listPrice_'+itemId).innerText;
            }
        	
    	}
    	var productUPC = $('#parentProductUpc').val();
        var dialog = $('#quick_cart_container').data("wc-WCDialog");
        if (dialog) {
            dialog.close(); 
            $('#quick_cart_container').remove();  
        }
        if (browseOnly) {
            MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('ERROR_ADD2CART_BROWSE_ONLY'));
            pushErrorToTealium('Product', Utils.getLocalizationMessage('ERROR_ADD2CART_BROWSE_ONLY'), 'add to cart error', productUPC);
            return;
        }
        var entitledItemJSON;

        if ($("#" + entitledItemId).length) {
            //the json object for entitled items are already in the HTML.
            entitledItemJSON = eval('(' + $("#" + entitledItemId).html() + ')');
        } else {
            //if $("#" + entitledItemId).length is 0, that means there's no <div> in the HTML that contains the JSON object.
            //in this case, it must have been set in catalogentryThumbnailDisplay.js when the quick info
            entitledItemJSON = this.getEntitledItemJsonObject();
        }

        productDisplayJS.setEntitledItems(entitledItemJSON);
        if (productDisplayJS.isContactLens) {
            var catalogEntryIds = productDisplayJS.getContactLensCatalogEntryIds(entitledItemId);

            if (catalogEntryIds != null && catalogEntryIds.length > 0
                    && ($('.defining-contact-lens #check-Right').prop( "checked") || $('.defining-contact-lens #check-Left').prop( "checked"))) {
                var productId = entitledItemId.substring(entitledItemId.indexOf("_") + 1);
                var rightQuantity = $('#qty_right').val();
                var leftQuantity = $('#qty_left').val();
                var quantitys = [rightQuantity, leftQuantity];
                productDisplayJS.AddItem2ShopCartAjax(catalogEntryIds, quantitys, customParams, productId);
                productDisplayJS.baseItemAddedToCart = true;

            } else {
                $('#second_level_category_popup').css("zIndex", '1');
                if (isCarol && $(".shopperActions").find(".WCTooltip").length == 0) {
                	MessageHelper.formErrorHandleClient('add2CartBtn', Utils.getLocalizationMessage('ERR_RESOLVING_SKU_LENS'));
                	pushErrorToTealium('Product', Utils.getLocalizationMessage('ERR_RESOLVING_SKU_LENS'), 'add to cart error', productUPC);
	                $(".shopperActions").find(".WCTooltip").css("top", "+=35");
	                setTimeout(function() {
						MessageHelper.clearCurrentIdentifier();
						$(".shopperActions").find(".WCTooltip").remove();
					}, 3000);
				}
            }
        } else {
            var catalogEntryId = productDisplayJS.getCatalogEntryId(entitledItemId);

            if (catalogEntryId != null) {
                var productId = entitledItemId.substring(entitledItemId.indexOf("_") + 1);
                productDisplayJS.AddItem2ShopCartAjax(catalogEntryId, quantity, customParams, productId);
                productDisplayJS.baseItemAddedToCart = true;


            } else if (isPopup == true) {
                $('#second_level_category_popup').css("zIndex", '1');
                MessageHelper.formErrorHandleClient('addToCartLinkAjax', Utils.getLocalizationMessage('ERR_RESOLVING_SKU'));
                pushErrorToTealium('Product', Utils.getLocalizationMessage('ERR_RESOLVING_SKU'), 'add to cart error', productUPC);
            } else {
                MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('ERR_RESOLVING_SKU'));
                pushErrorToTealium('Product', Utils.getLocalizationMessage('ERR_RESOLVING_SKU'), 'add to cart error', productUPC);
                productDisplayJS.baseItemAddedToCart = false;
            }
        }
    },
 
    AddItem2ShopCartAjax: function (catEntryIdentifier, quantity, customParams, productId) { 

        var productUPC = $('#parentProductUpc').val();
        if (browseOnly) {
            MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('ERROR_ADD2CART_BROWSE_ONLY'));
            pushErrorToTealium('Product', Utils.getLocalizationMessage('ERROR_ADD2CART_BROWSE_ONLY'), 'add to cart error', productUPC);
            return;     
        }
        
        if(typeof this.storeId !== 'undefined' || this.storeId == null || this.storeId == ''){
           this.storeId = document.getElementById("storeIdHidden").value;
        }

            var token = $("#authToken").val();
     
            var params = {
                storeId: this.storeId,
                catalogId: this.catalogId,
                langId: this.langId,
                orderId: ".",
                authToken: token /*CSRF protection */
            };
        
        
        // Remove calculations for performance
        // params.calculationUsage = "-1,-2,-5,-6,-7";
        params.inventoryValidation = "true";
        params.calculateOrder = "0";
        var ajaxShopCartService = "AddOrderItem";

        shoppingActionsJS.productAddedList = {};
        if (Array.isArray(catEntryIdentifier) && Array.isArray(quantity)) {
            var itemIndex = 0;
            for (var i = 0; i < catEntryIdentifier.length; i++) {
                if (isPositiveInteger(catEntryIdentifier[i]) && !isPositiveInteger(quantity[i])) {
                	if (isCarol && productDisplayJS.isContactLens) {
                		MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('ERR_RESOLVING_SKU_LENS'));
                	} else {
                    	MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('QUANTITY_INPUT_ERROR'));
                    }
                    pushErrorToTealium('Product', Utils.getLocalizationMessage('QUANTITY_INPUT_ERROR'), 'add to cart error', productUPC);
                    return;
                }
                if (isPositiveInteger(catEntryIdentifier[i]) && isPositiveInteger(quantity[i])) {
                    params["catEntryId_" + (itemIndex + 1)] = catEntryIdentifier[i];
                    params["quantity_" + (itemIndex + 1)] = quantity[i];
                    itemIndex++;
                }
            }
        } else {
            if (!isPositiveInteger(quantity)) {
                MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('QUANTITY_INPUT_ERROR'));
                pushErrorToTealium('Product', Utils.getLocalizationMessage('QUANTITY_INPUT_ERROR'), 'add to cart error', productUPC);
                return;
            }
            params.catEntryId = catEntryIdentifier;
            params.quantity = quantity;

            var selectedAttrList = {};
            for (attr in productDisplayJS.selectedAttributesList['entitledItem_' + productId]) {
                selectedAttrList[attr] = productDisplayJS.selectedAttributesList['entitledItem_' + productId][attr];
            }

            if (productId == undefined) {
                shoppingActionsJS.saveAddedProductInfo(quantity, catEntryIdentifier, catEntryIdentifier, selectedAttrList);
            } else {
                shoppingActionsJS.saveAddedProductInfo(quantity, productId, catEntryIdentifier, selectedAttrList);
            }
        }



        if(customParams == null){
            customParams = [];
        }

        // adding engraving custom params
        customParams["engravingText"] = this.engravingText;
        customParams["engravingFont"] = this.engravingFont;
        customParams["engraving"] = this.engraving;


        // adding new prescription parameter
        if (this.prescription) {
            customParams["prescription"] = this.prescription;
            customParams["lensMaterial"] = this.lensMaterialValue;
            customParams["lensOption"] = this.lensOptionValue;
            customParams["lensType"] = this.lensTypeValue;
            customParams["lensId"] = this.lensId;
        }

        if(this.engraving && this.prescription && isPersol) {
            customParams["engraving"] = false;
            this.wasEngraved = true;
        }

        //Pass any other customParams set by other add on features
        if (customParams != null && customParams != 'undefined') {
            for (i in customParams) {
                params[i] = customParams[i];
            }
            if (customParams['catalogEntryType'] == 'dynamicKit') {
                ajaxShopCartService = "AddPreConfigurationToCart";
            }
        }


        var contractIdElements = document.getElementsByName('contractSelectForm_contractId');
        if (contractIdElements != null && contractIdElements != "undefined") {
            for (i = 0; i < contractIdElements.length; i++) {
                if (contractIdElements[i].checked) {
                    params.contractId = contractIdElements[i].value;
                    break;
                }
            }
        }

        //For Handling multiple clicks
        if (!submitRequest()) {
            return;
        }

        cursor_wait();
        var addToCartEventConsumed = false;

        if(typeof callCenterIntegrationJS != 'undefined' && callCenterIntegrationJS != undefined && callCenterIntegrationJS != null){
            var catEntry = productDisplayJS.itemPriceJsonOject[params.catEntryId].catalogEntry;
            var partNumber = catEntry.catalogEntryIdentifier.externalIdentifier.partNumber;
            var wccParams = {};
            wccParams["partNumber"] = partNumber;
            addToCartEventConsumed = callCenterIntegrationJS.consumeAddToCartEvent(params,wccParams);
        }
        
        if(!addToCartEventConsumed) {

            wcService.invoke(ajaxShopCartService, params);
        }

        productDisplayJS.baseItemAddedToCart = true;

        if (document.getElementById("headerShopCartLink") && document.getElementById("headerShopCartLink").style.display != "none") {
            $("#headerShopCart").focus();
        } else {
            $("#headerShopCart1").focus();
        }
         
    },

    AddItem2ShopCartYMAL: function(catEntryIdentifierYMAL, quantity) {
        addCheckoutLoader();
        this.YMALProductFlag = true;
        if (browseOnly) {
            MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('ERROR_ADD2CART_BROWSE_ONLY'));
            pushErrorToTealium('Product', Utils.getLocalizationMessage('ERROR_ADD2CART_BROWSE_ONLY'), 'add to cart error', productUPC);
            return;     
        }
        
        var params = {
            storeId: WCParamJS.storeId,
            catalogId: WCParamJS.catalogId,
            langId: WCParamJS.langId,
            orderId: tealiumCart_Id
        };

        params.inventoryValidation = "true";
        params.calculateOrder = "0";
        var ajaxShopCartService = "AddOrderItem";

        shoppingActionsJS.productAddedList = {};
        params.catEntryId = catEntryIdentifierYMAL;
        params.quantity = quantity;

        wcService.invoke(ajaxShopCartService, params);
    },

    AddItem2ShopCartRMA: function(catEntryIdentifier, quantity) {
        /* TODO: Before adding the shipping charge item to cart, empty out cart from any product. */
        /* TODO: Before adding products to cart, empty out cart from the shipping charge item. */
        this.RMAProductFlag = true;
        if (browseOnly) {
            MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('ERROR_ADD2CART_BROWSE_ONLY'));
            pushErrorToTealium('Product', Utils.getLocalizationMessage('ERROR_ADD2CART_BROWSE_ONLY'), 'add to cart error', productUPC);
            return;     
        }
        
        var params = {
            storeId: WCParamJS.storeId,
            catalogId: WCParamJS.catalogId,
            langId: WCParamJS.langId,
            orderId: '.'
        };

        params.inventoryValidation = "true";
        params.calculateOrder = "0";
        var ajaxShopCartService = "AddOrderItem";

        shoppingActionsJS.productAddedList = {};
        params.catEntryId = catEntryIdentifier;
        params.quantity = quantity;

        wcService.invoke(ajaxShopCartService, params);

        $checkoutObj.getCartData(function(){
            renderOrderSummary();
        });
    },

    /**
     * setting engraving params
     */
    AddEngravingToCart : function(){
        if(isPersol){
            $('.bottom-scrollable-section').css('z-index', '3');
        }
        //setting engraving param to true
        this.engraving = true;

        //setting engraving text
        var monogram1 = document.getElementById("monogramText1");
        var monogram2 = document.getElementById("monogramText2");
        var monogram3 = document.getElementById("monogramText3");

        var monogramText1 = monogram1 != null ? document.getElementById("monogramText1").value : "";
        var monogramText2 = monogram2 != null ? document.getElementById("monogramText2").value : "";
        var monogramText3 = monogram3 != null ? document.getElementById("monogramText3").value : "";

        this.engravingText = monogramText1 + monogramText2 + monogramText3;

        //setting engraving font value


        var fonts = document.getElementsByName('engravingFont');
        var countFont = 0;
        for (var i = 0, length = fonts.length; i < length; i++)
        {
        countFont ++;	
         if (fonts[i].checked)
         {
              //getting checked radio button for fonts
              this.engravingFont = fonts[i].value;
              break;
         }
        }
        tealiumProducts[partNumber].Engraving = 'ZSMF|'+ this.engravingText + '|P'+countFont;
        /* WCAG MCB Begin - Focus on price to read the price with screen readers for accessible users */
        $('.namePartPriceContainer .list-price, .namePartPriceContainer .offer-price').first().focus();
        /* WCAG MCB End */
        if(isPersol && !(window.mobilecheck() || window.tabletPortraitCheck())){
            var newPrice = $('.namePartPriceContainer .offer-price').html()
            $('.shopperActions .sticky-price').html("<span class='price-sticky-separator'> &#8212; </span>"  + newPrice)
        }
    },

    /**
     * setting prescription params
     */
    AddPrescriptionToItem : function(){
        //setting prescription param to true
        this.prescription = true;

        //setting prescription values
        var lensMaterial = document.getElementById("lensMaterial");
        var lensOption = document.getElementById("lensOption");
        var lensType = document.getElementById("lensType");
        var lensId =$("#presc--lens--id");

        this.lensMaterialValue = lensMaterial != null ? document.getElementById("lensMaterial").innerHTML : "";
        this.lensOptionValue = lensOption != null ? document.getElementById("lensOption").innerHTML : "";
        this.lensTypeValue = lensType != null ? document.getElementById("lensType").innerHTML : "";
        this.lensId = lensId != null ? $("#presc--lens--id").val() : "";

    },

    //BEGIN LensConfigurator
    //setting prescription params
     AddPrescriptionToItem : function(lensMaterial,lensOption,lensType,lensId){

        //setting prescription param to true
        
        this.prescription = true;

        this.lensMaterialValue = lensMaterial;
        this.lensOptionValue = lensOption;
        this.lensTypeValue = lensType;
        this.lensId = lensId;

    },
    //END LensConfigurator
    
    /**
     * reset prescription params to null
     */
    ResetPrescription : function(){
        this.prescription = false;
        this.lensOptionValue = "";
        this.lensMaterialValue = "";
        this.lensTypeValue = "";
        this.lensId = "";
    },

    /**
     * reset engraving params to null
     */
    ResetEngraving : function(){
        this.engraving = false;
        productDisplayJS.engraving = false;
        this.engravingText = "";
        this.engravingFont = "";
    },

    /* SwatchCode start */

    /**
     * Sets the ID of the image to use for swatch.
     * @param {String} skuImageId The ID of the full image element.
     **/
    setSKUImageId: function (skuImageId) {
        productDisplayJS.skuImageId = skuImageId;
    },

    /**
     * getImageForSKU Returns the full image of the catalog entry with the selected attributes as specified in the {@link productDisplayJS.selectedAttributes} value.
     *					This method uses resolveImageForSKU to find the SKU image with the selected attributes values.
     *
     * @param {String} imageField, the field name from which the image should be picked
     * @return {String} path to the SKU image.
     *
     *
     **/
    getImageForSKU: function (entitledItemId, imageField) {
        var attributeArray = [];
        var selectedAttributes = productDisplayJS.selectedAttributesList[entitledItemId];
        for (attribute in selectedAttributes) {
            attributeArray.push(attribute + "_|_" + selectedAttributes[attribute]);
        }
        return productDisplayJS.resolveImageForSKU(attributeArray, imageField);
    },

    /**
     * resolveImageForSKU Resolves image of a SKU using an array of defining attributes.
     *
     * @param {String[]} attributeArray An array of defining attributes upon which to resolve a SKU.
     * @param {String} imageField, the field name from which the image should be picked
     *
     * @return {String} imagePath The location of SKU image.
     *
     **/
    resolveImageForSKU: function (attributeArray, imageField) {
        console.debug("Resolving SKU >> " + attributeArray + ">>" + this.entitledItems);
        var imagePath = "";
        var attributeArrayCount = attributeArray.length;

        for (x in this.entitledItems) {
            if (null != imageField) {
                var imagePath = this.entitledItems[x][imageField];
            } else {
                var imagePath = this.entitledItems[x].ItemImage467;
            }

            var Attributes = this.entitledItems[x].Attributes;
            var attributeCount = 0;
            for (index in Attributes) {
                attributeCount++;
            }

            // Handle special case where a catalog entry has one sku with no attributes
            if (attributeArrayCount == 0 && attributeCount == 0) {
                return imagePath;
            }
            if (attributeCount != 0 && attributeArrayCount >= attributeCount) {
                var matchedAttributeCount = 0;

                for (attributeName in attributeArray) {
                    var attributeValue = attributeArray[attributeName];
                    if (attributeValue in Attributes) {
                        matchedAttributeCount++;
                    }
                }

                if (attributeCount == matchedAttributeCount) {
                    console.debug("ItemImage:" + imagePath + " for Attribute: " + attributeArray);
                    var imageArray = [];
                    imageArray.push(imagePath);
                    imageArray.push(this.entitledItems[x].ItemThumbnailImage);
                    if (this.entitledItems[x].ItemAngleThumbnail != null && this.entitledItems[x].ItemAngleThumbnail != undefined) {
                        imageArray.push(this.entitledItems[x].ItemAngleThumbnail);
                        imageArray.push(this.entitledItems[x].ItemAngleFullImage);
                        imageArray.push(this.entitledItems[x].ItemAngleThumbnailShortDesc);
                    }
                    return imageArray;
                }
            }
        }
        return null;
    },


    /**
     * changeViewImages Updates the angle views of the SKU.
     *
     * @param {String[]} itemAngleThumbnail An array of SKU view thumbnails.
     * @param {String[]} itemAngleFullImage An array of SKU view full images.
     * @param {String[]} itemAngleThumbnailShortDesc An array of short description for the SKU view thumbnails.
     **/
    changeViewImages: function (itemAngleThumbnail, itemAngleFullImage, itemAngleThumbnailShortDesc) {
        var imageCount = 0;
        for (x in itemAngleThumbnail) {
            var prodAngleCount = imageCount;
            imageCount++;

            var thumbnailWidgets = $("ul[id^='ProductAngleImagesAreaList']");
            if ($(thumbnailWidgets).length) {
                for (var i = 0; i < thumbnailWidgets.length; i++) {
                    if (null != thumbnailWidgets[i]) {
                        var angleThumbnail = document.createElement("li");
                        var angleThumbnailLink = document.createElement("a");
                        var angleThumbnailImg = document.createElement("img");

                        angleThumbnail.id = "productAngleLi" + prodAngleCount;

                        angleThumbnailLink.href = "JavaScript:changeThumbNail('productAngleLi" + prodAngleCount + "','" + itemAngleFullImage[x] + "');";
                        angleThumbnailLink.id = "WC_CachedProductOnlyDisplay_links_1_" + imageCount;
                        if (itemAngleThumbnailShortDesc != 'undefined' && itemAngleThumbnailShortDesc != null) {
                            angleThumbnailLink.title = itemAngleThumbnailShortDesc[x];
                        }

                        angleThumbnailImg.src = itemAngleThumbnail[x];
                        angleThumbnailImg.id = "WC_CachedProductOnlyDisplay_images_1_" + imageCount;
                        if (itemAngleThumbnailShortDesc != 'undefined' && itemAngleThumbnailShortDesc != null) {
                            angleThumbnailImg.alt = itemAngleThumbnailShortDesc[x];
                        }

                        if (prodAngleCount == 0) {
                            $(thumbnailWidgets[i]).empty();
                        }

                        angleThumbnailLink.appendChild(angleThumbnailImg);
                        angleThumbnail.appendChild(angleThumbnailLink);
                        thumbnailWidgets[i].appendChild(angleThumbnail);
                    }
                }
            }
        }

        var displayImageArea = "";
        if (imageCount > 0) {
            displayImageArea = 'block';
        } else {
            displayImageArea = 'none';
        }
        var angleImageArea = $("div[id^='ProductAngleImagesArea']");
        if (angleImageArea.length) {
            for (var i = 0; i < angleImageArea.length; i++) {
                if (null != angleImageArea[i]) {
                    $(angleImageArea[i]).css("display", displayImageArea);
                }
            }
        }
    },

    /**
     * Updates the swatches selections on list view.
     * Sets up the swatches array and sku images, then selects a default swatch value.
     **/
    updateSwatchListView: function () {
        var swatchArray = $("a[id^='swatch_array_']");
        for (var i = 0; i < swatchArray.length; i++) {
            var swatchArrayElement = $(swatchArray[i]);
            eval($(swatchArrayElement).attr("href"));
        }

        var swatchSkuImage = $("a[id^='swatch_setSkuImage_']");
        for (var i = 0; i < swatchSkuImage.length; i++) {
            var swatchSkuImageElement = $(swatchSkuImage[i]);
            eval(swatchSkuImageElement.attr("href"));
        }

        var swatchDefault = $("a[id^='swatch_selectDefault_']");
        for (var i = 0; i < swatchDefault.length; i++) {
            var swatchDefaultElement = swatchDefault[i];
            eval(swatchDefaultElement.attr("href"));
        }
    },

    /**
     * Handles the case when a swatch is selected. Set the border of the selected swatch.
     * @param {String} selectedAttributeName The name of the selected swatch attribute.
     * @param {String} selectedAttributeValue The value of the selected swatch attribute.
     * @param {String} entitledItemId The ID of the SKU
     * @param {String} doNotDisable The name of the swatch attribute that should never be disabled.
     * @param {String} imageField, the field name from which the image should be picked
     * @return boolean Whether the swatch is available for selection
     **/
    selectSwatch: function (selectedAttributeName, selectedAttributeValue, entitledItemId, doNotDisable, selectedAttributeDisplayValue, skuImageId, imageField) {
        if ($("#swatch_" + entitledItemId + "_" + selectedAttributeValue).hasClass("color_swatch_disabled")) {
            return;
        }
        var selectedAttributes = this.selectedAttributesList[entitledItemId];
        for (attribute in selectedAttributes) {
            if (attribute == selectedAttributeName) {
                // case when the selected swatch is already selected with a value, if the value is different than
                // what's being selected, reset other swatches and deselect the previous value and update selection
                if (selectedAttributes[attribute] != selectedAttributeValue) {
                    // deselect previous value and update swatch selection
                    var swatchElement = document.getElementById("swatch_" + entitledItemId + "_" + selectedAttributes[attribute]);
                    swatchElement.className = "color_swatch";
                    swatchElement.src = swatchElement.src.replace("_disabled.png", "_enabled.png");

                    //change the title text of the swatch link
                    document.getElementById("swatch_link_" + entitledItemId + "_" + selectedAttributes[attribute]).title = swatchElement.alt;
                }
            }
            $("#swatch_link_" + entitledItemId + "_" + selectedAttributes[attribute]).attr("aria-checked", "false");
        }
        this.makeSwatchSelection(selectedAttributeName, selectedAttributeValue, entitledItemId, doNotDisable, selectedAttributeDisplayValue, skuImageId, imageField);
    },

    /**
     * Make swatch selection - add to selectedAttribute, select image, and update other swatches and SKU image based on current selection.
     * @param {String} swatchAttrName The name of the selected swatch attribute.
     * @param {String} swatchAttrValue The value of the selected swatch attribute.
     * @param {String} entitledItemId The ID of the SKU.
     * @param {String} doNotDisable The name of the swatch attribute that should never be disabled.
     * @param {String} skuImageId This is optional. The element id of the product image - image element id is different in product page and category list view. Product page need not pass it because it is set separately
     * @param {String} imageField This is optional. The json field from which image should be picked. Pass value if a different size image need to be picked
     **/
    makeSwatchSelection: function (swatchAttrName, swatchAttrValue, entitledItemId, doNotDisable, selectedAttributeDisplayValue, skuImageId, imageField) {
        productDisplayJS.setSelectedAttribute(swatchAttrName, swatchAttrValue, entitledItemId, skuImageId, imageField);
        document.getElementById("swatch_" + entitledItemId + "_" + swatchAttrValue).className = "color_swatch_selected";
        $("#swatch_link_" + entitledItemId + "_" + swatchAttrValue).attr("aria-checked", "true");
        document.getElementById("swatch_selection_label_" + entitledItemId + "_" + swatchAttrName).className = "header color_swatch_label";
        if ($("#swatch_selection_" + entitledItemId + "_" + swatchAttrName).css("display") == "none") {
            document.getElementById("swatch_selection_" + entitledItemId + "_" + swatchAttrName).style.display = "inline";
        }
        if (selectedAttributeDisplayValue != null) {
            $("#swatch_selection_" + entitledItemId + "_" + swatchAttrName).html(selectedAttributeDisplayValue);
        } else {
            $("#swatch_selection_" + entitledItemId + "_" + swatchAttrName).html(swatchAttrValue);
        }
        productDisplayJS.updateSwatchImages(swatchAttrName, entitledItemId, doNotDisable, imageField);
    },

    /**
     * Make dropdown selection.
     * @param {String} selectedAttrName The name of the selected dropdown attribute.
     * @param {String} selectedAttrValue The value of the selected dropdown attribute.
     * @param {String} entitledItemId The ID of the SKU.
     **/
    makeDropdownSelection: function (selectedAttrName, selectedAttrValue, entitledItemId) {
        //Add indexOf function to arrays for IE8
        if (!Array.prototype.indexOf) {
            Array.prototype.indexOf = function (obj, start) {
                for (var i = (start || 0), j = this.length; i < j; i++) {
                    if (this[i] === obj) {
                        return i;
                    }
                }
                return -1;
            };
        }

        var dropdownsToUpdate = [];
        var selectedAttributes = productDisplayJS.selectedAttributesList[entitledItemId];
        var selectedAttrValues = selectedAttributes[selectedAttrName];
        var dropdownList = productDisplayJS.allDropdownsList[entitledItemId];

        // finds out which dropdowns needs to be updated, add to dropdownsToUpdate array
        for (var i = 0; i < dropdownList.length; i++) {
            if (productDisplayJS.removeQuotes(dropdownList[i].name) != productDisplayJS.removeQuotes(selectedAttrName)) {
                dropdownsToUpdate.push(dropdownList[i]);
            }
        }

        //Finds out which attributes are entitled and add them to list of enabled
        var attributesToEnable = {};
        for (var x in productDisplayJS.entitledItems) {
            var Attributes = productDisplayJS.entitledItems[x].Attributes;

            // Turn Attributes into object
            var attrList = {};
            for (var y in Attributes) {
                var index = y.indexOf("_|_");
                var entitledDropdownName = y.substring(0, index);
                var entitledDropdownValue = y.substring(index + 3);

                attrList[entitledDropdownName] = entitledDropdownValue;
            }

            for (var attrName in attrList) {
                //the current entitled item has the selected attribute value
                if (productDisplayJS.removeQuotes(attrName) == productDisplayJS.removeQuotes(selectedAttrName) && (attrList[attrName] == selectedAttrValue || selectedAttrValue === '')) {
                    //go through the other attributes that are available to the selected attribute
                    for (var attrName2 in attrList) {
                        var attrName2NQ = productDisplayJS.removeQuotes(attrName2);
                        //only check the non-selected attribute
                        if (productDisplayJS.removeQuotes(attrName) != attrName2NQ) {
                            // Find all entitled items that match the current list of selected attributes other than attrName2
                            var matchSelectedAttributes = true;
                            for (var selected in selectedAttributes) {
                                if (productDisplayJS.removeQuotes(selected) != attrName2NQ) {
                                    if (selectedAttributes[selected] && selectedAttributes[selected] !== attrList[selected]) {
                                        matchSelectedAttributes = false;
                                    }
                                }
                            }

                            // Find all enabled values for the unselected attributes
                            if (matchSelectedAttributes && attrList[attrName2]) {
                                if (!attributesToEnable[attrName2NQ]) {
                                    attributesToEnable[attrName2NQ] = [];
                                }
                                if (attributesToEnable[attrName2NQ].indexOf(attrList[attrName2].replace(/^\s+|\s+$/g, '')) == -1) {
                                    attributesToEnable[attrName2NQ].push(attrList[attrName2].replace(/^\s+|\s+$/g, ''));
                                }
                            }
                        }
                    }
                }
            }
        }

        //Flag all attributes that should be enabled as enabled
        for (var i in dropdownsToUpdate) {
            var attrValues = attributesToEnable[productDisplayJS.removeQuotes(dropdownsToUpdate[i].name)];
            if (attrValues) {
                for (var j = 0; j < dropdownsToUpdate[i].options.length; j++) {
                    var dropdownToUpdateOption = dropdownsToUpdate[i].options[j];
                    if (attrValues.indexOf(dropdownToUpdateOption.value.replace(/^\s+|\s+$/g, '')) != -1 || dropdownToUpdateOption.value === '') {
                        dropdownToUpdateOption.enabled = true;
                    }
                }
            }
        }

        //Set all dropdown options that are enabled to disabled = false, others to disabled = true
        for (var i in dropdownsToUpdate) {
            if (dropdownsToUpdate[i].options) {
                for (var j = 0; j < dropdownsToUpdate[i].options.length; j++) {
                    var dropdownToUpdateOption = dropdownsToUpdate[i].options[j];

                    if (dropdownToUpdateOption.enabled) {
                        dropdownToUpdateOption.disabled = false;
                    } else {
                        dropdownToUpdateOption.disabled = true;
                    }

                    delete dropdownToUpdateOption.enabled;
                }

                var dropdown = $(dropdownsToUpdate[i].node);
                dropdown.Select("refresh");
            }
        }
    },

    /**
     * Constructs record and add to this.allSwatchesArray.
     * @param {String} swatchName The name of the swatch attribute.
     * @param {String} swatchValue The value of the swatch attribute.
     * @param {String} swatchImg1 The path to the swatch image.
    * @param {String} swatchImg2 The path to the swatch image representing disabled state.
     **/
    addToAllSwatchsArray: function(swatchName, swatchValue, swatchImg1, entitledItemId, swatchDisplayValue, swatchImg2) {
        var swatchList = this.allSwatchesArrayList[entitledItemId];
        if (swatchList == null) {
            swatchList = [];;
        }
        if (!this.existInAllSwatchsArray(swatchName, swatchValue, swatchList)) {
            var swatchRecord = [];
            swatchRecord[0] = swatchName;
            swatchRecord[1] = swatchValue;
            swatchRecord[2] = swatchImg1;
            swatchRecord[3] = swatchImg2;
            swatchRecord[4] = document.getElementById("swatch_link_" + entitledItemId + "_" + swatchValue).onclick;
            swatchRecord[5] = null;
            swatchRecord[6] = swatchDisplayValue;
            swatchList.push(swatchRecord);
            this.allSwatchesArrayList[entitledItemId] = swatchList;
        }
    },

    /**
     * Constructs record and add to this.allDropdownsArray.
     * @param {String} attributeName The name of the dropdown attribute.
     * @param {String} dropdownId The id of the dropdown.
     **/
    addToAllDropdownsArray: function (attributeName, dropdownId, entitledItemId) {
        var dropdownList = this.allDropdownsList[entitledItemId];
        if (dropdownList == null) {
            dropdownList = [];
        }

        var dropdownNode = productDisplayJS.findDropdownById(dropdownId);

        if (!this.existInAllDropdownsArray(attributeName, dropdownId, dropdownList)) {
            dropdownList.push({
                name: attributeName,
                id: dropdownId,
                node: dropdownNode,
                options: $(dropdownNode).find("option"),
            });
            this.allDropdownsList[entitledItemId] = dropdownList;
        }
    },

    /**
     * Checks if a swatch is already exist in this.allSwatchesArray.
     * @param {String} swatchName The name of the swatch attribute.
     * @param {String} swatchValue The value of the swatch attribute.
     * @return boolean Value indicating whether or not the specified swatch name and value exists in the allSwatchesArray.
     */
    existInAllSwatchsArray: function (swatchName, swatchValue, swatchList) {
        for (var i = 0; i < swatchList.length; i++) {
            var attrName = swatchList[i][0];
            var attrValue = swatchList[i][1];
            if (attrName == swatchName && attrValue == swatchValue) {
                return true;
            }
        }
        return false;
    },

    /**
     * Checks if a dropdown already exists in this.allDropdownsArray.
     * @param {String} dropdownName The name of the dropdown.
     * @param {String} dropdownId The id of the dropdown.
     * @return boolean Value indicating whether or not the specified dropdown name and value exists in the allDropdownsArray.
     */
    existInAllDropdownsArray: function (dropdownName, dropdownId, dropdownsList) {
        for (var i = 0; i < dropdownsList.length; i++) {
            if (dropdownsList[i].name == dropdownName && dropdownsList[i].id == dropdownId) {
                return true;
            }
        }
        return false;
    },

    /**
     * Check the entitledItems array and pre-select the first entitled SKU as the default swatch selection.
     * @param {String} entitledItemId The ID of the SKU.
     * @param {String} doNotDisable The name of the swatch attribute that should never be disabled.
     **/
    makeDefaultSwatchSelection: function (entitledItemId, doNotDisable) {
        if (this.entitledItems.length == 0) {
            if ($("#" + entitledItemId).length) {
                entitledItemJSON = eval('(' + $("#" + entitledItemId).html() + ')');
            }
            productDisplayJS.setEntitledItems(entitledItemJSON);
        }

        // need to make selection for every single swatch
        for (x in this.entitledItems) {
            var Attributes = this.entitledItems[x].Attributes;
            for (y in Attributes) {
                var index = y.indexOf("_|_");
                var swatchName = y.substring(0, index);
                var swatchValue = y.substring(index + 3);
                this.makeSwatchSelection(swatchName, swatchValue, entitledItemId, doNotDisable, null, imageField);
            }
            break;
        }
    },

    /**
     * Update swatch images - this is called after selection of a swatch is made, and this function checks for
     * entitlement and disable swatches that are not available
     * @param {String} selectedAttrName The attribute that is selected
     * @param {String} entitledItemId The ID of the SKU.
     * @param {String} doNotDisable The name of the swatch attribute that should never be disabled.
     **/
    updateSwatchImages: function (selectedAttrName, entitledItemId, doNotDisable, imageField) {
        var swatchToUpdate = [];
        var selectedAttributes = productDisplayJS.selectedAttributesList[entitledItemId];
        var selectedAttrValue = selectedAttributes[selectedAttrName];
        var swatchList = productDisplayJS.allSwatchesArrayList[entitledItemId];

        // finds out which swatch needs to be updated, add to swatchToUpdate array
        for (var i = 0; i < swatchList.length; i++) {
            var attrName = swatchList[i][0];
            var attrValue = swatchList[i][1];
            var attrImg1 = swatchList[i][2];
            var attrImg2 = swatchList[i][3];
            var attrOnclick = swatchList[i][4];
            var attrDisplayValue = swatchList[i][6];

            if (attrName != doNotDisable && attrName != selectedAttrName) {
                var swatchRecord = [];
                swatchRecord[0] = attrName;
                swatchRecord[1] = attrValue;
                swatchRecord[2] = attrImg1;
                swatchRecord[3] = attrImg2;
                swatchRecord[4] = attrOnclick;
                swatchRecord[5] = false;
                swatchRecord[6] = attrDisplayValue;
                swatchToUpdate.push(swatchRecord);
            }
        }

        // finds out which swatch is entitled, if it is, image should be set to enabled
        // go through entitledItems array and find out swatches that are entitled
        for (x in productDisplayJS.entitledItems) {
            var Attributes = productDisplayJS.entitledItems[x].Attributes;

            for (y in Attributes) {
                var index = y.indexOf("_|_");
                var entitledSwatchName = y.substring(0, index);
                var entitledSwatchValue = y.substring(index + 3);

                //the current entitled item has the selected attribute value
                if (entitledSwatchName == selectedAttrName && entitledSwatchValue == selectedAttrValue) {
                    //go through the other attributes that are available to the selected attribute
                    //exclude the one that is selected
                    for (z in Attributes) {
                        var index2 = z.indexOf("_|_");
                        var entitledSwatchName2 = z.substring(0, index2);
                        var entitledSwatchValue2 = z.substring(index2 + 3);

                        if (y != z) { //only check the attributes that are not the one selected
                            for (i in swatchToUpdate) {
                                var swatchToUpdateName = swatchToUpdate[i][0];
                                var swatchToUpdateValue = swatchToUpdate[i][1];

                                if (entitledSwatchName2 == swatchToUpdateName && entitledSwatchValue2 == swatchToUpdateValue) {
                                    swatchToUpdate[i][5] = true;
                                }
                            }
                        }
                    }
                }
            }
        }

        // Now go through swatchToUpdate array, and update swatch images
        var disabledAttributes = [];
        for (i in swatchToUpdate) {
            var swatchToUpdateName = swatchToUpdate[i][0];
            var swatchToUpdateValue = swatchToUpdate[i][1];
            var swatchToUpdateImg1 = swatchToUpdate[i][2];
            var swatchToUpdateImg2 = swatchToUpdate[i][3];
            var swatchToUpdateOnclick = swatchToUpdate[i][4];
            var swatchToUpdateEnabled = swatchToUpdate[i][5];

            if (swatchToUpdateEnabled) {
                if (document.getElementById("swatch_" + entitledItemId + "_" + swatchToUpdateValue).className != "color_swatch_selected") {
                    var swatchElement = document.getElementById("swatch_" + entitledItemId + "_" + swatchToUpdateValue);
                    swatchElement.className = "color_swatch";
                    if (swatchToUpdateImg1 != "" && swatchToUpdateImg2 != "") {
                        swatchElement.src = swatchToUpdateImg1;
                    }
                    else {
                        swatchElement.src = swatchElement.src.replace("_disabled.png","_enabled.png");
                    }

                    //change the title text of the swatch link
                    document.getElementById("swatch_link_" + entitledItemId + "_" + swatchToUpdateValue).title = swatchElement.alt;
                }
                $("#swatch_link_" + entitledItemId + "_" + swatchToUpdateValue).attr("aria-disabled", "false");
                document.getElementById("swatch_link_" + entitledItemId + "_" + swatchToUpdateValue).onclick = swatchToUpdateOnclick;
            } else {
                if (swatchToUpdateName != doNotDisable) {
                    var swatchElement = document.getElementById("swatch_" + entitledItemId + "_" + swatchToUpdateValue);
                    var swatchLinkElement = document.getElementById("swatch_link_" + entitledItemId + "_" + swatchToUpdateValue);
                    swatchElement.className = "color_swatch_disabled";
                    swatchLinkElement.onclick = null;
                    if (swatchToUpdateImg1 != "" && swatchToUpdateImg2 != "") {
                        swatchElement.src = swatchToUpdateImg2;
                    }
                    else {
                        swatchElement.src = swatchElement.src.replace("_enabled.png","_disabled.png");
                    }

                    //change the title text of the swatch link
                    var titleText = Utils.getLocalizationMessage("INV_ATTR_UNAVAILABLE", [swatchElement.alt]);


                    $("#swatch_link_" + entitledItemId + "_" + swatchToUpdateValue).attr("aria-disabled", "true");

                    //The previously selected attribute is now unavailable for the new selection
                    //Need to switch the selection to an available value
                    if (selectedAttributes[swatchToUpdateName] == swatchToUpdateValue) {
                        disabledAttributes.push(swatchToUpdate[i]);
                    }
                }
            }
        }

        //If there were any previously selected attributes that are now unavailable
        //Find another available value for that attribute and update other attributes according to the new selection
        for (i in disabledAttributes) {
            var disabledAttributeName = disabledAttributes[i][0];
            var disabledAttributeValue = disabledAttributes[i][1];

            for (i in swatchToUpdate) {
                var swatchToUpdateName = swatchToUpdate[i][0];
                var swatchToUpdateValue = swatchToUpdate[i][1];
                var swatchToUpdateDisplayValue = swatchToUpdate[i][6];
                var swatchToUpdateEnabled = swatchToUpdate[i][5];

                if (swatchToUpdateName == disabledAttributeName && swatchToUpdateValue != disabledAttributeValue && swatchToUpdateEnabled) {
                    productDisplayJS.makeSwatchSelection(swatchToUpdateName, swatchToUpdateValue, entitledItemId, doNotDisable, swatchToUpdateDisplayValue, imageField);
                    break;
                }
            }
        }
    },
    /* SwatchCode end */

    /**
     * Displays price of the attribute selected with the catalog entry id.
     *
     * @param {string} catEntryId The identifier of the sku.
     * @param {string} productId The identifier of the product.
     */
    displayPrice: function (catEntryId, productId) {
    	
    	productDisplayJS.pst = productDisplayJS.getPST();
        var catEntry = productDisplayJS.itemPriceJsonOject[catEntryId].catalogEntry;
        var tempString;
        var popup = productDisplayJS.isPopup;

        if (popup == true) {
            $("#productPrice").html(catEntry.offerPrice);
        }

        if (popup == false) {
            var innerHTML = "";
            /**
             * Daniel Rilo 19/10/2018
            if (!catEntry.listPriced || catEntry.listPrice <= catEntry.offerPrice) {
                innerHTML = "<span id='offerPrice_" + catEntry.catalogEntryIdentifier.uniqueID + "' class='price'>" + catEntry.offerPrice + "</span>";
            } else {
                innerHTML = "<span id='listPrice_" + catEntry.catalogEntryIdentifier.uniqueID + "' class='old_price'>" + catEntry.listPrice + "</span>" +
                    "<span id='offerPrice_" + catEntry.catalogEntryIdentifier.uniqueID + "' class='price'>" + catEntry.offerPrice + "</span>";
            }
            if (document.getElementById('price_display_' + productId)) {
                document.getElementById('price_display_' + productId).innerHTML = innerHTML + "<input type='hidden' id='ProductInfoPrice_" + catEntry.catalogEntryIdentifier.uniqueID + "' value='" + catEntry.offerPrice.replace(/"/g, "&#034;").replace(/'/g, "&#039;") + "'/>";
            } else if (document.getElementById('price_display_' + catEntryId)) {
                document.getElementById('price_display_' + catEntryId).innerHTML = innerHTML + "<input type='hidden' id='ProductInfoPrice_" + catEntry.catalogEntryIdentifier.uniqueID + "' value='" + catEntry.offerPrice.replace(/"/g, "&#034;").replace(/'/g, "&#039;") + "'/>";
            }

            innerHTML = "";
            */
            if (productDisplayJS.displayPriceRange == true) {
                for (var i in catEntry.priceRange) {
                    if (catEntry.priceRange[i].endingNumberOfUnits == catEntry.priceRange[i].startingNumberOfUnits) {
                        tempString = Utils.getLocalizationMessage('PQ_PRICE_X', {
                            0: catEntry.priceRange[i].startingNumberOfUnits
                        });
                        innerHTML = innerHTML + "<p>" + tempString;
                    } else if (catEntry.priceRange[i].endingNumberOfUnits != 'null') {
                        tempString = Utils.getLocalizationMessage('PQ_PRICE_X_TO_Y', {
                            0: catEntry.priceRange[i].startingNumberOfUnits,
                            1: catEntry.priceRange[i].endingNumberOfUnits
                        });
                        innerHTML = innerHTML + "<p>" + tempString;
                    } else {
                        tempString = Utils.getLocalizationMessage('PQ_PRICE_X_OR_MORE', {
                            0: catEntry.priceRange[i].startingNumberOfUnits
                        });
                        innerHTML = innerHTML + "<p>" + tempString;
                    }
                    innerHTML = innerHTML + " <span class='price'>" + catEntry.priceRange[i].localizedPrice + "</span></p>";
                }
            }
            // Append productId so that element is unique in bundle page, where there can be multiple components
            if (document.getElementById('price_display_' + productId) && innerHTML !== '') {
                $("#price_display_" + productId).html($('#price_display_' + productId).html() + '<div class="item_spacer_3px"></div><div id="priceRange_' + productId + '" class="quantity_discount">' + Utils.getLocalizationMessage('PQ_PURCHASE') + innerHTML + '</div>');
            }
        }
        //check if the engraving was before
        if(productDisplayJS.engraving){
            productDisplayJS.AddEngravingToCart();
            addPriceMonogram = true;
            priceMonogram('add');
            addPriceMonogram = false;
        }
    },

    /**
     * @param {*} measurements
     */
    getMeasurementsDisplayValue: function (measurements){
       var arrM = measurements.split(",");
       return arrM.join("-");
    },

    /**
    * Updates the product name in the NameAndPrice widget.
    *
    * @param {string} catEntryId The catentryId of the selected product
    * @param {string} productId The productId of the product shown
    */
    updateItemName: function (catEntryId, productId) {
       var catEntry = productDisplayJS.itemPriceJsonOject[catEntryId].catalogEntry;
       var modelCodeValueElement = document.querySelector("#descAttributeValue_modelCode");
       if (modelCodeValueElement != null) {
          modelCodeValueElement.innerHTML = catEntry.description[0].name;
       }

       var modelMeasurements = document.querySelector(".ItemMeasurements_"+catEntryId);

       var modelMeasurementsValueElement = document.querySelector("#descAttributeValue_modelMeasurements");
       if (modelMeasurementsValueElement != null) {
           modelMeasurementsValueElement.innerHTML = productDisplayJS.getMeasurementsDisplayValue(modelMeasurements.innerHTML);
       }
    },

    /**
     * Updates the product name in the NameAndPrice widget.
     *
     * @param {string} catEntryId The identifier of the sku.
     * @param {string} productId The identifier of the product.
     */
    updateProductName: function (catEntryId, productId) {
        var catEntry = productDisplayJS.itemPriceJsonOject[catEntryId].catalogEntry;

        if (productDisplayJS.isPopup == true) {
            $("#productName").html(catEntry.description[0].name);
        } else {
            if ($(".top > div[id^='PageHeading_']") != null) {
                $(".top > div[id^='PageHeading_']").each(function (i, node) {
                    if (node.childNodes != null && node.childNodes.length == 3) {
                        node.childNodes[1].innerHTML = catEntry.description[0].name;
                    }
                });
            }

            var productInfoWidgets = $("input[id^='ProductInfoName_" + productId + "']");
            if (productInfoWidgets != null) {
                for (var i = 0; i < productInfoWidgets.length; i++) {
                    if (productInfoWidgets[i] != null) {
                        $(productInfoWidgets[i]).val(catEntry.description[0].name);
                    }
                }
            }
        }
    },

    /**
     * Updates the product part number in the NameAndPrice widget.
     *
     * @param {string} catEntryId The identifier of the sku.
     * @param {string} productId The identifier of the product.
     */
    updateProductPartNumber: function (catEntryId, productId) {
        var catEntry = productDisplayJS.itemPriceJsonOject[catEntryId].catalogEntry;

        if (productDisplayJS.isPopup == true) {
            $("#productSKUValue").html(catEntry.catalogEntryIdentifier.externalIdentifier.partNumber);
        } else {
            var partnumWidgets = $("span[id^='product_SKU_" + productId + "']");
            if (partnumWidgets != null) {
                for (var i = 0; i < partnumWidgets.length; i++) {
                    if ($(partnumWidgets[i])) {
                        $(partnumWidgets[i]).html(Utils.getLocalizationMessage('SKU') + " " + catEntry.catalogEntryIdentifier.externalIdentifier.partNumber);
                    }
                }
            }
        }
    },

    /**
     * Updates the product short description in the ShortDescription widget.
     *
     * @param {string} catEntryId The identifier of the sku.
     * @param {string} productId The identifier of the product.
     */
    updateProductShortDescription: function (catEntryId, productId) {
        var catEntry = productDisplayJS.itemPriceJsonOject[catEntryId].catalogEntry;

        var shortDescWidgets = $("p[id^='product_shortdescription_" + productId + "']");
        if (shortDescWidgets != null) {
            for (var i = 0; i < shortDescWidgets.length; i++) {
                if (shortDescWidgets[i]) {
                    shortDescWidgets[i].innerHTML = catEntry.description[0].shortDescription;
                }
            }
        }
    },

    /**
     * Updates the product long description in the LongDescription widget.
     *
     * @param {string} catEntryId The identifier of the sku.
     * @param {string} productId The identifier of the product.
     */
    updateProductLongDescription: function (catEntryId, productId) {
        var catEntry = productDisplayJS.itemPriceJsonOject[catEntryId].catalogEntry;

        var longDescWidgets = $("p[id^='product_longdescription_" + productId + "']");
        if (longDescWidgets != null) {
            for (var i = 0; i < longDescWidgets.length; i++) {
                if (longDescWidgets[i]) {
                    longDescWidgets[i].innerHTML = catEntry.description[0].longDescription;
                }
            }
        }
    },

    /**
     * Updates the product discounts in the Discounts widget.
     *
     * @param {string} catEntryId The identifier of the sku.
     * @param {string} productId The identifier of the product.
     */
    updateProductDiscount: function (catEntryId, productId) {
        var catEntry = productDisplayJS.itemPriceJsonOject[catEntryId].catalogEntry;

        var newHtml = '';
        if (typeof catEntry.discounts != 'undefined') {
            for (var i = 0; i < catEntry.discounts.length; i++) {
                if (i > 0) {
                    newHtml += '<div class="clear_float"></div><div class="item_spacer_2px"></div>';
                }
                /* catEntry.discounts[i].description comes from short description associated with the promotion.
                 * If it is blank or missing, the link text is blank, thus is not clickable or displayed.
                 */
                newHtml += '<a class="promotion" href="' + catEntry.discounts[i].url + '">' + catEntry.discounts[i].description + '</a>';
            }
        }

        var discountWidgets = $("div[id^='Discounts_']");
        if (discountWidgets != null) {
            for (var i = 0; i < discountWidgets.length; i++) {
                if (discountWidgets[i]) {
                    discountWidgets[i].innerHTML = newHtml;
                }
            }
        }
    },

    /**
     * Updates the product full image and angle images in the FullImage widget.
     *
     * @param {string} catEntryId The identifier of the sku.
     * @param {string} productId The identifier of the product.
     */
    updateProductImage: function (catEntryId, productId) {
        var newFullImage = null;
        var newAngleThumbnail = null;
        var newAngleFullImage = null;
        var newAngleThumbnailShortDesc = null;

        var skuFullImageFromService = null;
        var catEntry = null;
        if (productDisplayJS.itemPriceJsonOject[catEntryId] != null) {
            catEntry = productDisplayJS.itemPriceJsonOject[catEntryId].catalogEntry;
        }
        if (catEntry != null) {
            skuFullImageFromService = catEntry.description[0].fullImage;
        }

        var entitledItemId = "entitledItem_" + productId;
        var imageArr = productDisplayJS.getImageForSKU(entitledItemId);
        if (imageArr != null) {
            newAngleThumbnail = imageArr[2];
            newAngleFullImage = imageArr[3];
            newAngleThumbnailShortDesc = imageArr[4];
        }

        if (catEntryId != null) {
        	if(imageArr!=null){
        	   newFullImage = imageArr[0];
        	}    
            if (skuFullImageFromService != null && skuFullImageFromService !== "") {
                newFullImage = skuFullImageFromService;
            }
        } else if (productId != null && productDisplayJS.singleSKUProductWithoutDefiningAttribute) {
            newFullImage = productDisplayJS.entitledItems[0].ItemImage467;
            if (skuFullImageFromService != null && skuFullImageFromService !== "") {
                newFullImage = skuFullImageFromService;
            }
            newAngleThumbnail = productDisplayJS.entitledItems[0].ItemAngleThumbnail;
            newAngleFullImage = productDisplayJS.entitledItems[0].ItemAngleFullImage;
            newAngleThumbnailShortDesc = productDisplayJS.entitledItems[0].ItemAngleThumbnailShortDesc;
        } else {
            var imageFound = false;
            var selectedAttributes = productDisplayJS.selectedAttributesList[entitledItemId];
            for (x in productDisplayJS.entitledItems) {
                var Attributes = productDisplayJS.entitledItems[x].Attributes;

                for (attribute in selectedAttributes) {
                    var matchingAttributeFound = false;
                    if (selectedAttributes[attribute] !== '') {
                        for (y in Attributes) {
                            var index = y.indexOf("_|_");
                            var entitledSwatchName = y.substring(0, index);
                            var entitledSwatchValue = y.substring(index + 3);

                            if (entitledSwatchName == attribute && entitledSwatchValue == selectedAttributes[attribute]) {
                                matchingAttributeFound = true;
                                break;
                            }
                        }

                        // No matching attributes found, so this is not the correct SKU
                        if (!matchingAttributeFound) {
                            imageFound = false;
                            break;
                        }
                        imageFound = true;
                    }
                }

                // imageFound will only be true if all attributes have been matched (so the first correct SKU)
                if (imageFound) {
                    newFullImage = productDisplayJS.entitledItems[x].ItemImage467;
                    newAngleThumbnail = productDisplayJS.entitledItems[x].ItemAngleThumbnail;
                    newAngleFullImage = productDisplayJS.entitledItems[x].ItemAngleFullImage;
                    newAngleThumbnailShortDesc = productDisplayJS.entitledItems[x].ItemAngleThumbnailShortDesc;
                    break;
                }
            }
        }

        var imgWidgets = $("img[id^='" + productDisplayJS.skuImageId + "']");
        for (var i = 0; i < imgWidgets.length; i++) {
            if (imgWidgets[i] != null && newFullImage != null) {
                //imgWidgets[i].src = newFullImage;
            }
        }

        var productImgWidgets = $("input[id^='ProductInfoImage_" + productId + "']");
        for (var i = 0; i < productImgWidgets.length; i++) {
            if (productImgWidgets[i] != null && newFullImage != null) {
                productImgWidgets[i].value = newFullImage;
            }
        }

        var prodAngleImageArea = $("div[id^='ProductAngleProdImagesArea']");
        var skuAngleImageArea = $("div[id^='ProductAngleImagesArea']");

        if (newAngleThumbnail != null && newAngleFullImage != null) {
            if (prodAngleImageArea.length) {
                for (var i = 0; i < prodAngleImageArea.length; i++) {
                    if (null != prodAngleImageArea[i]) {
                        $(prodAngleImageArea[i]).css("display", 'none');
                    }
                }
            }
            productDisplayJS.changeViewImages(newAngleThumbnail, newAngleFullImage, newAngleThumbnailShortDesc);
        } else {
            var prodDisplayClass = 'block';
            var selectedAttributes = productDisplayJS.selectedAttributesList[entitledItemId];
            for (attribute in selectedAttributes) {
                if (null != selectedAttributes[attribute] && '' != selectedAttributes[attribute]) {
                    prodDisplayClass = 'none';
                }
            }

            if (prodAngleImageArea.length) {
                for (var i = 0; i < prodAngleImageArea.length; i++) {
                    if (prodAngleImageArea[i].length) {
                        $(prodAngleImageArea[i]).css("display", prodDisplayClass);
                    }
                }
            }

            if (skuAngleImageArea != null) {
                for (var i = 0; i < skuAngleImageArea.length; i++) {
                    if (skuAngleImageArea[i].length) {
                        $(skuAngleImageArea[i]).css("display", 'none');
                    }
                }
            }
        }
    },

    /**
     * To notify the change in attribute to other components that is subscribed to 'DefiningAttributes_Changed' or 'DefiningAttributes_Resolved' event.
     *
     * @param {string} productId The identifier of the product.
     * @param {string} entitledItemId The identifier of the entitled item.
     * @param {boolean} isPopup If the value is true, then this implies that the function was called from a quick info pop-up.
     * @param {boolean} displayPriceRange A boolean used to to determine whether or not to display the price range when the catEntry is selected.
     */
    notifyAttributeChange: function (productId, entitledItemId, isPopup, displayPriceRange) {
        productDisplayJS.baseCatalogEntryId = productId;
        var selectedAttributes = productDisplayJS.selectedAttributesList[entitledItemId];

        productDisplayJS.displayPriceRange = displayPriceRange;
        productDisplayJS.isPopup = isPopup;

        var catalogEntryId = null;
        if (productDisplayJS.selectedProducts[productId]) {
            catalogEntryId = productDisplayJS.getCatalogEntryIdforProduct(productDisplayJS.selectedProducts[productId]);
        } else {
            catalogEntryId = productDisplayJS.getCatalogEntryId(entitledItemId);
        }

        this.changedCatEntryId = catalogEntryId;
        $(".wishlist-icon-container").attr("data-catentryIdItem-wishlist",this.changedCatEntryId);// WISHLIST --set catentry id of itemsBean
        if(this.hasPres || this.sizeHasPres || this.modelHasPres){
            this.prescChangeSelect();
            $("#removeButton").click();
        }
        
        //set partnumber in #vm_box
        for(var i = 0; i < productDisplayJS.entitledItems.length; i++){
        if(productDisplayJS.entitledItems[i].catentry_id == productDisplayJS.changedCatEntryId ){
            $("#addLenses").attr('data-description',productDisplayJS.entitledItems[i].seo_url.split('/')[productDisplayJS.entitledItems[i].seo_url.split('/').length-1]); // set Partnumber in LensConfigurator analytics
        	$('#vm_box').attr('data-vm',productDisplayJS.entitledItems[i].seo_url.split('/')[productDisplayJS.entitledItems[i].seo_url.split('/').length-1]);
            $("a[data-element-id='X_X_VirtualMirror_Start']").attr('data-description',productDisplayJS.entitledItems[i].seo_url.split('/')[productDisplayJS.entitledItems[i].seo_url.split('/').length-1]);
                break;
            }
        }
        
        if (catalogEntryId != null) {
            wcTopic.publish('DefiningAttributes_Resolved_' + productId, catalogEntryId, productId);

            //check if the json object is already present for the catEntry.
            var catEntry = productDisplayJS.itemPriceJsonOject[catalogEntryId];

            if (catEntry != null && catEntry != undefined && !productDisplayJS.engraving) {
                productDisplayJS.publishAttributeResolvedEvent(catalogEntryId, productId);
            }
            //if json object is not present, call the service to get the details.
            else {
                var parameters = {
                    storeId: productDisplayJS.storeId,
                    langId: productDisplayJS.langId,
                    catalogId: productDisplayJS.catalogId,
                    catalogEntryId: catalogEntryId,
                    productId: productId
                };

                //Declare a service for retrieving catalog entry detailed information for an item...
                wcService.declare({
                    id: "getCatalogEntryDetails",
                    actionId: "getCatalogEntryDetails",
                    url: getAbsoluteURL() + appendWcCommonRequestParameters("GetCatalogEntryDetailsByIDView"),
                    formId: ""

                    ,
                    successHandler: function (serviceResponse, ioArgs) {
                        productDisplayJS.publishAttributeResolvedEventServiceResponse(serviceResponse, ioArgs);
                        /* START Early Access */
                        if (isVogue){
                            replacePDPMainPrice(catEntryIdSubscribe);
                            checkOfferListPrice();

                            if (window.mobilecheck() || window.tabletPortraitCheck()) {
                                var earlyAccessTooltip = $(".contentRecommendationWidget[id*='X_PDP_CustomerSegment_Tooltip']");
                                if ($(".namePartPriceContainer .list-price").eq(1).text() != ""){
                                    earlyAccessTooltip.eq(1).css("left", "20px").css("top","34.7em").css("position","absolute").width("44%");
                                 }
                            }
                        }
                        /* END Early Access */
                    }

                    ,
                    failureHandler: function (serviceResponse, ioArgs) {
                        console.debug("productDisplayJS.notifyAttributeChange: Unexpected error occurred during an xhrPost request.");
                    }

                });
                wcService.invoke("getCatalogEntryDetails", parameters);
            }
        } else {
            wcTopic.publish('DefiningAttributes_Changed', catalogEntryId, productId);
            wcTopic.publish('DefiningAttributes_Changed_' + productId, catalogEntryId, productId);
            console.debug("Publishing event 'DefiningAttributes_Changed' with params: catEntryId=" + catalogEntryId + ", productId=" + productId);
        }

         //HB-10122
        if(isOliver && (window.mobilecheck() || window.tabletPortraitCheck())){
            var modelMeasurements = document.querySelector(".ItemMeasurements_" + catalogEntryId);

            var modelMeasurementsValueElement = document.querySelector("#featureMenu #descAttributeValue_modelMeasurements");
            if (modelMeasurementsValueElement != null) {
                modelMeasurementsValueElement.innerHTML = productDisplayJS.getMeasurementsDisplayValue(modelMeasurements.innerHTML);
            }
            $("#descriptiveAttributes #descAttributeValue_modelMeasurements").html(productDisplayJS.getMeasurementsDisplayValue(modelMeasurements.innerHTML))
            $("#tabAttr #descAttributeValue_modelMeasurements").html(productDisplayJS.getMeasurementsDisplayValue(modelMeasurements.innerHTML));
        }
    },

    /**
     * Publishes the 'DefiningAttributes_Resolved' event using the JSON object returned from the server.
     *
     * @param {object} serviceRepsonse The JSON response from the service.
     * @param {object} ioArgs The arguments from the service call.
     */
    publishAttributeResolvedEventServiceResponse: function (serviceResponse, ioArgs) {
        var productId = ioArgs.productId;
        //stores the json object, so that the service is not called when same catEntry is selected.
        productDisplayJS.itemPriceJsonOject[serviceResponse.catalogEntry.catalogEntryIdentifier.uniqueID] = serviceResponse;

        productDisplayJS.publishAttributeResolvedEvent(serviceResponse.catalogEntry.catalogEntryIdentifier.uniqueID, productId);
    },

    /**
     * Publishes the 'DefiningAttributes_Resolved' event with the necessary parameters.
     *
     * @param {string} catEntryId The identifier of the sku.
     * @param {string} productId The identifier of the product.
     */
    publishAttributeResolvedEvent: function (catEntryId, productId) {
        if (!productDisplayJS.isPopup) {
            if (this.entitledItems) {
                for (x in this.entitledItems) {
                    var sku = this.entitledItems[x];
                    if (sku.catentry_id === catEntryId) {
                        if (sku.displaySKUContextData === 'true') {
                            if (document.location.href !== sku.seo_url) {
                                document.location.replace(sku.seo_url);
                            } else {
                                wcTopic.publish('DefiningAttributes_Resolved', catEntryId, productId);
                                console.debug("Publishing event 'DefiningAttributes_Resolved' with params: catEntryId=" + catEntryId + ", productId=" + productId);
                            }
                        } else {
                            wcTopic.publish('DefiningAttributes_Resolved', catEntryId, productId);
                            console.debug("Publishing event 'DefiningAttributes_Resolved' with params: catEntryId=" + catEntryId + ", productId=" + productId);
                        }
                    }
                }
            } else {
                console.debug("Publishing event 'DefiningAttributes_Resolved' with params: catEntryId=" + catEntryId + ", productId=" + productId);
                wcTopic.publish('DefiningAttributes_Resolved', catEntryId, productId);
            }
        }
    },

    /**
     * To notify the change in quantity to other components that is subscribed to ShopperActions_Changed event.
     */
    notifyQuantityChange: function (quantity) {
        wcTopic.publish('ShopperActions_Changed', quantity);
        console.debug("Publishing event 'ShopperActions_Changed' with params: quantity=" + quantity);
    },

    /**
     * To display attachment page.
     */
    showAttachmentPage: function (data) {
        var pageNumber = data['pageNumber'];
        var pageSize = data['pageSize'];
        pageNumber = Number(pageNumber);
        pageSize = Number(pageSize);

        setCurrentId(data["linkId"]);

        if (!submitRequest()) {
            return;
        }

        var beginIndex = pageSize * (pageNumber - 1);
        cursor_wait();
        wcRenderContext.updateRenderContext('AttachmentPagination_Context', {
            'beginIndex': beginIndex
        });
        MessageHelper.hideAndClearMessage();
    },

    /**
     * Register mouse down event
     */
    registerMouseDown: function (node) {
        $(node).on("mousedown",
            function () {
                productDisplayJS.calculateScrollingHeight(node);
            }
        );
    },

    /**
     * Calculate scrolling height.
     */
    calculateScrollingHeight: function (node) {
        var selectedNode = productDisplayJS.findDropdownById(node);
        var nodePosition = null;
        if (selectedNode) {
            nodePosition = Utils.position(selectedNode);
        } else {
            return;
        }
        var windowHeight = window.innerHeight;
        if (windowHeight - nodePosition.y > nodePosition.y) {
            var newHeight = windowHeight - nodePosition.y;
        } else {
            var newHeight = nodePosition.y;
        }
        if ($("#" + node + "_dropdown").length) {
            if (windowHeight - nodePosition.y > nodePosition.y) {
                var newHeight = windowHeight - nodePosition.y;
            } else {
                var newHeight = nodePosition.y;
            }
            var dropdownHeight = $("#" + node + "_dropdown").clientHeight;
            if (dropdownHeight > newHeight) {
                $("#" + node + "_dropdown").css("height", newHeight + "px");
            }
        } else {
            //			$("#" + node + "_dropdown").css("height", windowHeight + "px");
        }
    },

    findDropdownById: function (node) {
        var newNode = productDisplayJS.removeQuotes(node);
        var nodes = $('[id^=attrValue_]');
        var foundNode = null;

        $(nodes).each(function (key, domNode) {
            var id = productDisplayJS.removeQuotes(domNode.id);
            if (newNode === id) {
                foundNode = domNode;
            }
        });

        return foundNode;
    },

    removeQuotes: function (str) {
        if (str) {
            return str.replace(/&#039;/g, '').replace(/\\'/g, '').replace(/'/g, '');
        } else {
            return str;
        }
    },

    getPST: function(){
    	if(document.getElementById('listPrice_'+productDisplayJS.baseCatalogEntryId) != null)
           return document.getElementById('listPrice_'+productDisplayJS.baseCatalogEntryId).innerText;
    }
}
$(document).ready(function () {
    var ie_version = Utils.get_IE_version();
    if (ie_version < 9) {
        $(document).on("click", ".compare_target > input[type=\"checkbox\"]", function (event) {
            this.blur();
            this.focus();
        });
    }
});

/*! @vimeo/player v2.10.0 | (c) 2019 Vimeo | MIT License | https://github.com/vimeo/player.js */
!function(e,t){"object"==typeof exports&&"undefined"!=typeof module?module.exports=t():"function"==typeof define&&define.amd?define(t):((e=e||self).Vimeo=e.Vimeo||{},e.Vimeo.Player=t())}(this,function(){"use strict";function r(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}var e="undefined"!=typeof global&&"[object global]"==={}.toString.call(global);function i(e,t){return 0===e.indexOf(t.toLowerCase())?e:"".concat(t.toLowerCase()).concat(e.substr(0,1).toUpperCase()).concat(e.substr(1))}function s(e){return/^(https?:)?\/\/((player|www)\.)?vimeo\.com(?=$|\/)/.test(e)}function l(){var e,t=0<arguments.length&&void 0!==arguments[0]?arguments[0]:{},n=t.id,r=t.url,o=n||r;if(!o)throw new Error("An id or url must be passed, either in an options object or as a data-vimeo-id or data-vimeo-url attribute.");if(e=o,!isNaN(parseFloat(e))&&isFinite(e)&&Math.floor(e)==e)return"https://vimeo.com/".concat(o);if(s(o))return o.replace("http:","https:");if(n)throw new TypeError("“".concat(n,"” is not a valid video id."));throw new TypeError("“".concat(o,"” is not a vimeo.com url."))}var t=void 0!==Array.prototype.indexOf,n="undefined"!=typeof window&&void 0!==window.postMessage;if(!(e||t&&n))throw new Error("Sorry, the Vimeo Player API is not available in this browser.");var o="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{};!function(e){if(!e.WeakMap){var n=Object.prototype.hasOwnProperty,o=function(e,t,n){Object.defineProperty?Object.defineProperty(e,t,{configurable:!0,writable:!0,value:n}):e[t]=n};e.WeakMap=function(){function e(){if(void 0===this)throw new TypeError("Constructor WeakMap requires 'new'");if(o(this,"_id","_WeakMap"+"_"+t()+"."+t()),0<arguments.length)throw new TypeError("WeakMap iterable is not supported")}function r(e,t){if(!i(e)||!n.call(e,"_id"))throw new TypeError(t+" method called on incompatible receiver "+typeof e)}function t(){return Math.random().toString().substring(2)}return o(e.prototype,"delete",function(e){if(r(this,"delete"),!i(e))return!1;var t=e[this._id];return!(!t||t[0]!==e)&&(delete e[this._id],!0)}),o(e.prototype,"get",function(e){if(r(this,"get"),i(e)){var t=e[this._id];return t&&t[0]===e?t[1]:void 0}}),o(e.prototype,"has",function(e){if(r(this,"has"),!i(e))return!1;var t=e[this._id];return!(!t||t[0]!==e)}),o(e.prototype,"set",function(e,t){if(r(this,"set"),!i(e))throw new TypeError("Invalid value used as weak map key");var n=e[this._id];return n&&n[0]===e?n[1]=t:o(e,this._id,[e,t]),this}),o(e,"_polyfill",!0),e}()}function i(e){return Object(e)===e}}("undefined"!=typeof self?self:"undefined"!=typeof window?window:o);var a,f=(function(e){var t,n,r;r=function(){var t,a,n,e=Object.prototype.toString,r="undefined"!=typeof setImmediate?function(e){return setImmediate(e)}:setTimeout;try{Object.defineProperty({},"x",{}),t=function(e,t,n,r){return Object.defineProperty(e,t,{value:n,writable:!0,configurable:!1!==r})}}catch(e){t=function(e,t,n){return e[t]=n,e}}function i(e,t){n.add(e,t),a||(a=r(n.drain))}function u(e){var t,n=typeof e;return null==e||"object"!=n&&"function"!=n||(t=e.then),"function"==typeof t&&t}function c(){for(var e=0;e<this.chain.length;e++)o(this,1===this.state?this.chain[e].success:this.chain[e].failure,this.chain[e]);this.chain.length=0}function o(e,t,n){var r,o;try{!1===t?n.reject(e.msg):(r=!0===t?e.msg:t.call(void 0,e.msg))===n.promise?n.reject(TypeError("Promise-chain cycle")):(o=u(r))?o.call(r,n.resolve,n.reject):n.resolve(r)}catch(e){n.reject(e)}}function s(e){var t=this;t.triggered||(t.triggered=!0,t.def&&(t=t.def),t.msg=e,t.state=2,0<t.chain.length&&i(c,t))}function l(e,n,r,o){for(var t=0;t<n.length;t++)!function(t){e.resolve(n[t]).then(function(e){r(t,e)},o)}(t)}function f(e){this.def=e,this.triggered=!1}function d(e){this.promise=e,this.state=0,this.triggered=!1,this.chain=[],this.msg=void 0}function h(e){if("function"!=typeof e)throw TypeError("Not a function");if(0!==this.__NPO__)throw TypeError("Not a promise");this.__NPO__=1;var r=new d(this);this.then=function(e,t){var n={success:"function"!=typeof e||e,failure:"function"==typeof t&&t};return n.promise=new this.constructor(function(e,t){if("function"!=typeof e||"function"!=typeof t)throw TypeError("Not a function");n.resolve=e,n.reject=t}),r.chain.push(n),0!==r.state&&i(c,r),n.promise},this.catch=function(e){return this.then(void 0,e)};try{e.call(void 0,function(e){(function e(n){var r,o=this;if(!o.triggered){o.triggered=!0,o.def&&(o=o.def);try{(r=u(n))?i(function(){var t=new f(o);try{r.call(n,function(){e.apply(t,arguments)},function(){s.apply(t,arguments)})}catch(e){s.call(t,e)}}):(o.msg=n,o.state=1,0<o.chain.length&&i(c,o))}catch(e){s.call(new f(o),e)}}}).call(r,e)},function(e){s.call(r,e)})}catch(e){s.call(r,e)}}n=function(){var n,r,o;function i(e,t){this.fn=e,this.self=t,this.next=void 0}return{add:function(e,t){o=new i(e,t),r?r.next=o:n=o,r=o,o=void 0},drain:function(){var e=n;for(n=r=a=void 0;e;)e.fn.call(e.self),e=e.next}}}();var v=t({},"constructor",h,!1);return t(h.prototype=v,"__NPO__",0,!1),t(h,"resolve",function(n){return n&&"object"==typeof n&&1===n.__NPO__?n:new this(function(e,t){if("function"!=typeof e||"function"!=typeof t)throw TypeError("Not a function");e(n)})}),t(h,"reject",function(n){return new this(function(e,t){if("function"!=typeof e||"function"!=typeof t)throw TypeError("Not a function");t(n)})}),t(h,"all",function(t){var a=this;return"[object Array]"!=e.call(t)?a.reject(TypeError("Not an array")):0===t.length?a.resolve([]):new a(function(n,e){if("function"!=typeof n||"function"!=typeof e)throw TypeError("Not a function");var r=t.length,o=Array(r),i=0;l(a,t,function(e,t){o[e]=t,++i===r&&n(o)},e)})}),t(h,"race",function(t){var r=this;return"[object Array]"!=e.call(t)?r.reject(TypeError("Not an array")):new r(function(n,e){if("function"!=typeof n||"function"!=typeof e)throw TypeError("Not a function");l(r,t,function(e,t){n(t)},e)})}),h},(n=o)[t="Promise"]=n[t]||r(),e.exports&&(e.exports=n[t])}(a={exports:{}},a.exports),a.exports),d=new WeakMap;function u(e,t,n){var r=d.get(e.element)||{};t in r||(r[t]=[]),r[t].push(n),d.set(e.element,r)}function c(e,t){return(d.get(e.element)||{})[t]||[]}function h(e,t,n){var r=d.get(e.element)||{};if(!r[t])return!0;if(!n)return r[t]=[],d.set(e.element,r),!0;var o=r[t].indexOf(n);return-1!==o&&r[t].splice(o,1),d.set(e.element,r),r[t]&&0===r[t].length}var v=["autopause","autoplay","background","byline","color","controls","dnt","height","id","loop","maxheight","maxwidth","muted","playsinline","portrait","responsive","speed","texttrack","title","transparent","url","width"];function p(r){var e=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{};return v.reduce(function(e,t){var n=r.getAttribute("data-vimeo-".concat(t));return(n||""===n)&&(e[t]=""===n?1:n),e},e)}function y(e,t){var n=e.html;if(!t)throw new TypeError("An element must be provided");if(null!==t.getAttribute("data-vimeo-initialized"))return t.querySelector("iframe");var r=document.createElement("div");return r.innerHTML=n,t.appendChild(r.firstChild),t.setAttribute("data-vimeo-initialized","true"),t.querySelector("iframe")}function m(i){var a=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{},u=2<arguments.length?arguments[2]:void 0;return new Promise(function(t,n){if(!s(i))throw new TypeError("“".concat(i,"” is not a vimeo.com url."));var e="https://vimeo.com/api/oembed.json?url=".concat(encodeURIComponent(i));for(var r in a)a.hasOwnProperty(r)&&(e+="&".concat(r,"=").concat(encodeURIComponent(a[r])));var o="XDomainRequest"in window?new XDomainRequest:new XMLHttpRequest;o.open("GET",e,!0),o.onload=function(){if(404!==o.status)if(403!==o.status)try{var e=JSON.parse(o.responseText);if(403===e.domain_status_code)return y(e,u),void n(new Error("“".concat(i,"” is not embeddable.")));t(e)}catch(e){n(e)}else n(new Error("“".concat(i,"” is not embeddable.")));else n(new Error("“".concat(i,"” was not found.")))},o.onerror=function(){var e=o.status?" (".concat(o.status,")"):"";n(new Error("There was an error fetching the embed code from Vimeo".concat(e,".")))},o.send()})}function g(e){if("string"==typeof e)try{e=JSON.parse(e)}catch(e){return console.warn(e),{}}return e}function w(e,t,n){if(e.element.contentWindow&&e.element.contentWindow.postMessage){var r={method:t};void 0!==n&&(r.value=n);var o=parseFloat(navigator.userAgent.toLowerCase().replace(/^.*msie (\d+).*$/,"$1"));8<=o&&o<10&&(r=JSON.stringify(r)),e.element.contentWindow.postMessage(r,e.origin)}}function b(n,r){var t,e=[];if((r=g(r)).event){if("error"===r.event)c(n,r.data.method).forEach(function(e){var t=new Error(r.data.message);t.name=r.data.name,e.reject(t),h(n,r.data.method,e)});e=c(n,"event:".concat(r.event)),t=r.data}else if(r.method){var o=function(e,t){var n=c(e,t);if(n.length<1)return!1;var r=n.shift();return h(e,t,r),r}(n,r.method);o&&(e.push(o),t=r.value)}e.forEach(function(e){try{if("function"==typeof e)return void e.call(n,t);e.resolve(t)}catch(e){}})}var k=new WeakMap,E=new WeakMap,Player=function(){function Player(u){var e,c=this,n=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{};if(function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,Player),window.jQuery&&u instanceof jQuery&&(1<u.length&&window.console&&console.warn&&console.warn("A jQuery object with multiple elements was passed, using the first element."),u=u[0]),"undefined"!=typeof document&&"string"==typeof u&&(u=document.getElementById(u)),e=u,!Boolean(e&&1===e.nodeType&&"nodeName"in e&&e.ownerDocument&&e.ownerDocument.defaultView))throw new TypeError("You must pass either a valid element or a valid id.");var r=u.ownerDocument.defaultView;if("IFRAME"!==u.nodeName){var t=u.querySelector("iframe");t&&(u=t)}if("IFRAME"===u.nodeName&&!s(u.getAttribute("src")||""))throw new Error("The player element passed isn’t a Vimeo embed.");if(k.has(u))return k.get(u);this.element=u,this.origin="*";var o=new f(function(i,a){var e=function(e){if(s(e.origin)&&c.element.contentWindow===e.source){"*"===c.origin&&(c.origin=e.origin);var t=g(e.data);if(t&&"error"===t.event&&t.data&&"ready"===t.data.method){var n=new Error(t.data.message);return n.name=t.data.name,void a(n)}var r=t&&"ready"===t.event,o=t&&"ping"===t.method;if(r||o)return c.element.setAttribute("data-ready","true"),void i();b(c,t)}};if(r.addEventListener?r.addEventListener("message",e,!1):r.attachEvent&&r.attachEvent("onmessage",e),"IFRAME"!==c.element.nodeName){var t=p(u,n);m(l(t),t,u).then(function(e){var t,n,r,o=y(e,u);return c.element=o,c._originalElement=u,t=u,n=o,r=d.get(t),d.set(n,r),d.delete(t),k.set(c.element,c),e}).catch(a)}});return E.set(this,o),k.set(this.element,this),"IFRAME"===this.element.nodeName&&w(this,"ping"),this}var e,t,n;return e=Player,(t=[{key:"callMethod",value:function(n){var r=this,o=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{};return new f(function(e,t){return r.ready().then(function(){u(r,n,{resolve:e,reject:t}),w(r,n,o)}).catch(t)})}},{key:"get",value:function(n){var r=this;return new f(function(e,t){return n=i(n,"get"),r.ready().then(function(){u(r,n,{resolve:e,reject:t}),w(r,n)}).catch(t)})}},{key:"set",value:function(n,r){var o=this;return new f(function(e,t){if(n=i(n,"set"),null==r)throw new TypeError("There must be a value to set.");return o.ready().then(function(){u(o,n,{resolve:e,reject:t}),w(o,n,r)}).catch(t)})}},{key:"on",value:function(e,t){if(!e)throw new TypeError("You must pass an event name.");if(!t)throw new TypeError("You must pass a callback function.");if("function"!=typeof t)throw new TypeError("The callback must be a function.");0===c(this,"event:".concat(e)).length&&this.callMethod("addEventListener",e).catch(function(){}),u(this,"event:".concat(e),t)}},{key:"off",value:function(e,t){if(!e)throw new TypeError("You must pass an event name.");if(t&&"function"!=typeof t)throw new TypeError("The callback must be a function.");h(this,"event:".concat(e),t)&&this.callMethod("removeEventListener",e).catch(function(e){})}},{key:"loadVideo",value:function(e){return this.callMethod("loadVideo",e)}},{key:"ready",value:function(){var e=E.get(this)||new f(function(e,t){t(new Error("Unknown player. Probably unloaded."))});return f.resolve(e)}},{key:"addCuePoint",value:function(e){var t=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{};return this.callMethod("addCuePoint",{time:e,data:t})}},{key:"removeCuePoint",value:function(e){return this.callMethod("removeCuePoint",e)}},{key:"enableTextTrack",value:function(e,t){if(!e)throw new TypeError("You must pass a language.");return this.callMethod("enableTextTrack",{language:e,kind:t})}},{key:"disableTextTrack",value:function(){return this.callMethod("disableTextTrack")}},{key:"pause",value:function(){return this.callMethod("pause")}},{key:"play",value:function(){return this.callMethod("play")}},{key:"unload",value:function(){return this.callMethod("unload")}},{key:"destroy",value:function(){var t=this;return new f(function(e){E.delete(t),k.delete(t.element),t._originalElement&&(k.delete(t._originalElement),t._originalElement.removeAttribute("data-vimeo-initialized")),t.element&&"IFRAME"===t.element.nodeName&&t.element.parentNode&&t.element.parentNode.removeChild(t.element),e()})}},{key:"getAutopause",value:function(){return this.get("autopause")}},{key:"setAutopause",value:function(e){return this.set("autopause",e)}},{key:"getBuffered",value:function(){return this.get("buffered")}},{key:"getColor",value:function(){return this.get("color")}},{key:"setColor",value:function(e){return this.set("color",e)}},{key:"getCuePoints",value:function(){return this.get("cuePoints")}},{key:"getCurrentTime",value:function(){return this.get("currentTime")}},{key:"setCurrentTime",value:function(e){return this.set("currentTime",e)}},{key:"getDuration",value:function(){return this.get("duration")}},{key:"getEnded",value:function(){return this.get("ended")}},{key:"getLoop",value:function(){return this.get("loop")}},{key:"setLoop",value:function(e){return this.set("loop",e)}},{key:"setMuted",value:function(e){return this.set("muted",e)}},{key:"getMuted",value:function(){return this.get("muted")}},{key:"getPaused",value:function(){return this.get("paused")}},{key:"getPlaybackRate",value:function(){return this.get("playbackRate")}},{key:"setPlaybackRate",value:function(e){return this.set("playbackRate",e)}},{key:"getPlayed",value:function(){return this.get("played")}},{key:"getSeekable",value:function(){return this.get("seekable")}},{key:"getSeeking",value:function(){return this.get("seeking")}},{key:"getTextTracks",value:function(){return this.get("textTracks")}},{key:"getVideoEmbedCode",value:function(){return this.get("videoEmbedCode")}},{key:"getVideoId",value:function(){return this.get("videoId")}},{key:"getVideoTitle",value:function(){return this.get("videoTitle")}},{key:"getVideoWidth",value:function(){return this.get("videoWidth")}},{key:"getVideoHeight",value:function(){return this.get("videoHeight")}},{key:"getVideoUrl",value:function(){return this.get("videoUrl")}},{key:"getVolume",value:function(){return this.get("volume")}},{key:"setVolume",value:function(e){return this.set("volume",e)}}])&&r(e.prototype,t),n&&r(e,n),Player}();return e||(function(){var e=0<arguments.length&&void 0!==arguments[0]?arguments[0]:document,t=[].slice.call(e.querySelectorAll("[data-vimeo-id], [data-vimeo-url]")),n=function(e){"console"in window&&console.error&&console.error("There was an error creating an embed: ".concat(e))};t.forEach(function(t){try{if(null!==t.getAttribute("data-vimeo-defer"))return;var e=p(t);m(l(e),e,t).then(function(e){return y(e,t)}).catch(n)}catch(e){n(e)}})}(),function(){var r=0<arguments.length&&void 0!==arguments[0]?arguments[0]:document;if(!window.VimeoPlayerResizeEmbeds_){window.VimeoPlayerResizeEmbeds_=!0;var e=function(e){if(s(e.origin)&&e.data&&"spacechange"===e.data.event)for(var t=r.querySelectorAll("iframe"),n=0;n<t.length;n++)if(t[n].contentWindow===e.source){t[n].parentElement.style.paddingBottom="".concat(e.data.data[0].bottom,"px");break}};window.addEventListener?window.addEventListener("message",e,!1):window.attachEvent&&window.attachEvent("onmessage",e)}}()),Player});

/*!
	Zoom 1.7.20
	license: MIT
	http://www.jacklmoore.com/zoom
*/
(function(o){var t={url:!1,callback:!1,target:!1,duration:120,on:"mouseover",touch:!0,onZoomIn:!1,onZoomOut:!1,magnify:1};o.zoom=function(t,n,e,i){var u,c,r,a,m,l,s,f=o(t),h=f.css("position"),d=o(n);return t.style.position=/(absolute|fixed)/.test(h)?h:"relative",t.style.overflow="hidden",e.style.width=e.style.height="",o(e).addClass("zoomImg").css({position:"absolute",top:0,left:0,opacity:0,width:e.width*i,height:e.height*i,border:"none",maxWidth:"none",maxHeight:"none"}).appendTo(t),{init:function(){c=f.outerWidth(),u=f.outerHeight(),n===t?(a=c,r=u):(a=d.outerWidth(),r=d.outerHeight()),m=(e.width-c)/a,l=(e.height-u)/r,s=d.offset()},move:function(o){var t=o.pageX-s.left,n=o.pageY-s.top;n=Math.max(Math.min(n,r),0),t=Math.max(Math.min(t,a),0),e.style.left=t*-m+"px",e.style.top=n*-l+"px"}}},o.fn.zoom=function(n){return this.each(function(){var e=o.extend({},t,n||{}),i=e.target&&o(e.target)[0]||this,u=this,c=o(u),r=document.createElement("img"),a=o(r),m="mousemove.zoom",l=!1,s=!1;if(!e.url){var f=u.querySelector("img");if(f&&(e.url=f.getAttribute("data-src")||f.currentSrc||f.src),!e.url)return}c.one("zoom.destroy",function(o,t){c.off(".zoom"),i.style.position=o,i.style.overflow=t,r.onload=null,a.remove()}.bind(this,i.style.position,i.style.overflow)),r.onload=function(){function t(t){f.init(),f.move(t),a.stop().fadeTo(o.support.opacity?e.duration:0,1,o.isFunction(e.onZoomIn)?e.onZoomIn.call(r):!1)}function n(){a.stop().fadeTo(e.duration,0,o.isFunction(e.onZoomOut)?e.onZoomOut.call(r):!1)}var f=o.zoom(i,u,r,e.magnify);"grab"===e.on?c.on("mousedown.zoom",function(e){1===e.which&&(o(document).one("mouseup.zoom",function(){n(),o(document).off(m,f.move)}),t(e),o(document).on(m,f.move),e.preventDefault())}):"click"===e.on?c.on("click.zoom",function(e){return l?void 0:(l=!0,t(e),o(document).on(m,f.move),o(document).one("click.zoom",function(){n(),l=!1,o(document).off(m,f.move)}),!1)}):"toggle"===e.on?c.on("click.zoom",function(o){l?n():t(o),l=!l}):"mouseover"===e.on&&(f.init(),c.on("mouseenter.zoom",t).on("mouseleave.zoom",n).on(m,f.move)),e.touch&&c.on("touchstart.zoom",function(o){o.preventDefault(),s?(s=!1,n()):(s=!0,t(o.originalEvent.touches[0]||o.originalEvent.changedTouches[0]))}).on("touchmove.zoom",function(o){o.preventDefault(),f.move(o.originalEvent.touches[0]||o.originalEvent.changedTouches[0])}).on("touchend.zoom",function(o){o.preventDefault(),s&&(s=!1,n())}),o.isFunction(e.callback)&&e.callback.call(r)},r.setAttribute("role","presentation"),r.src=e.url})},o.fn.zoom.defaults=t})(window.jQuery);
!function($){"use strict";function simulateEvent(name,e){for(var id in instances)if(instances.hasOwnProperty(id)){var i,module,data=instances[id];for(i=0;i<data.mods.length;i+=1)module=data.mods[i],"function"==typeof module[name]&&module[name].apply(data.target,[e,data])}}function bindSimulatedEvent(eName){$(window.document).bind(eName+"."+name,function(e){simulateEvent("document"+eName,e)})}function handleResizeEvent(){for(var id in instances)if(instances.hasOwnProperty(id)){var data=instances[id];data.responsive&&Spin.boot(data)}}function pushInstance(data){idCounter+=1,data.id=idCounter,instances[idCounter]=data}function popInstance(data){delete instances[data.id]}function padNumber(num,length,pad){for(num=String(num);num.length<length;)num=String(pad)+num;return num}function clamp(value,min,max){return value>max?max:value<min?min:value}function wrap(value,min,max,size){for(;value>max;)value-=size;for(;value<min;)value+=size;return value}function prevent(e){return e.preventDefault(),!1}function log(){window.console&&window.console.log&&window.console.log.apply(window.console,arguments)}function bind(target,event,func){func&&target.bind(event+"."+name,function(e){func.apply(target,[e,target.spritespin("data")])})}function unbind(target){target.unbind("."+name)}function load(opts){var i,img,src="string"==typeof opts.source?[opts.source]:opts.source,count=0,images=[],targetCount=opts.preloadCount||src.length,completed=!1,firstLoaded=!1,tick=function(){count+=1,"function"==typeof opts.progress&&opts.progress({index:$.inArray(this,images),loaded:count,total:src.length,percent:Math.round(count/src.length*100)}),firstLoaded=firstLoaded||this===images[0],!completed&&count>=targetCount&&firstLoaded&&"function"==typeof opts.complete&&(completed=!0,opts.complete(images))};for(i=0;i<src.length;i+=1)img=new Image,images.push(img),img.onload=img.onabort=img.onerror=tick,img.src=src[i];"function"==typeof opts.initiated&&opts.initiated(images)}function detectSubsampling(img,size){var iw=(size||img).width,ih=(size||img).height;if(iw*ih<=1048576)return!1;var canvas;if(canvas=document.createElement("canvas"),!canvas||!canvas.getContext)return!1;var context=canvas.getContext("2d");if(!context)return!1;canvas.width=canvas.height=1,context.fillStyle="#FF00FF",context.fillRect(0,0,1,1),context.drawImage(img,-iw+1,0);try{var dat=context.getImageData(0,0,1,1).data;return 255===dat[0]&&0===dat[1]&&255===dat[2]}catch(err){return log(err.message,err.stack),!1}}function naturalSize(image){if(null!=image.naturalWidth)return{width:image.naturalWidth,height:image.naturalHeight};var img=new Image;return img.src=image.src,{width:img.width,height:img.height}}function pixelRatio(context){var devicePixelRatio=window.devicePixelRatio||1,backingStoreRatio=context.webkitBackingStorePixelRatio||context.mozBackingStorePixelRatio||context.msBackingStorePixelRatio||context.oBackingStorePixelRatio||context.backingStorePixelRatio||1;return devicePixelRatio/backingStoreRatio}var name="spritespin",Spin={};window.SpriteSpin=Spin,Spin.namespace=name,Spin.mods={},Spin.eventNames=["mousedown","mousemove","mouseup","mouseenter","mouseover","mouseleave","dblclick","mousewheel","touchstart","touchmove","touchend","touchcancel","selectstart","gesturestart","gesturechange","gestureend"],Spin.eventsToPrevent=["dragstart"],Spin.defaults={source:void 0,width:void 0,height:void 0,frames:void 0,framesX:void 0,lanes:1,sizeMode:void 0,module:"360",behavior:"drag",renderer:"canvas",lane:0,frame:0,frameTime:40,animate:!0,reverse:!1,loop:!0,stopFrame:0,wrap:!0,wrapLane:!1,sense:1,senseLane:void 0,orientation:"horizontal",detectSubsampling:!0,scrollThreshold:50,preloadCount:void 0,onInit:void 0,onProgress:void 0,onLoad:void 0,onFrame:void 0,onDraw:void 0};var idCounter=0,instances={};Spin.instances=instances;var resizeTimeout=null;$(window).on("resize",function(){clearTimeout(resizeTimeout),resizeTimeout=setTimeout(handleResizeEvent,100)});for(var i=0;i<Spin.eventNames.length;i+=1)bindSimulatedEvent(Spin.eventNames[i]);Spin.clamp=clamp,Spin.wrap=wrap,Spin.bind=bind,Spin.sourceArray=function(path,opts){var fStart=0,fEnd=0,lStart=0,lEnd=0,digits=opts.digits||2;opts.frame&&(fStart=opts.frame[0],fEnd=opts.frame[1]),opts.lane&&(lStart=opts.lane[0],lEnd=opts.lane[1]);var i,j,temp,result=[];for(i=lStart;i<=lEnd;i+=1)for(j=fStart;j<=fEnd;j+=1)temp=path.replace("{lane}",padNumber(i,digits,0)),temp=temp.replace("{frame}",padNumber(j,digits,0)),result.push(temp);return result},Spin.measureSource=function(data){var img=data.images[0],size=naturalSize(img);if(1===data.images.length){if(data.sourceWidth=size.width,data.sourceHeight=size.height,data.detectSubsampling&&detectSubsampling(img,size)&&(data.sourceWidth/=2,data.sourceHeight/=2),data.framesX=data.framesX||data.frames,!data.frameWidth||!data.frameHeight)if(data.framesX){data.frameWidth=Math.floor(data.sourceWidth/data.framesX);var framesY=Math.ceil(data.frames*data.lanes/data.framesX);data.frameHeight=Math.floor(data.sourceHeight/framesY)}else data.frameWidth=size.width,data.frameHeight=size.height}else data.sourceWidth=data.frameWidth=size.width,data.sourceHeight=data.frameHeight=size.height,detectSubsampling(img,size)&&(data.sourceWidth=data.frameWidth=size.width/2,data.sourceHeight=data.frameHeight=size.height/2),data.frames=data.frames||data.images.length},Spin.resetInput=function(data){data.startX=data.startY=void 0,data.currentX=data.currentY=void 0,data.oldX=data.oldY=void 0,data.dX=data.dY=data.dW=0,data.ddX=data.ddY=data.ddW=0},Spin.updateInput=function(e,data){void 0===e.touches&&void 0!==e.originalEvent&&(e.touches=e.originalEvent.touches),data.oldX=data.currentX,data.oldY=data.currentY,void 0!==e.touches&&e.touches.length>0?(data.currentX=e.touches[0].clientX||0,data.currentY=e.touches[0].clientY||0):(data.currentX=e.clientX||0,data.currentY=e.clientY||0),void 0!==data.oldX&&void 0!==data.oldY||(data.oldX=data.currentX,data.oldY=data.currentY),void 0!==data.startX&&void 0!==data.startY||(data.startX=data.currentX,data.startY=data.currentY,data.clickframe=data.frame,data.clicklane=data.lane),data.dX=data.currentX-data.startX,data.dY=data.currentY-data.startY,data.ddX=data.currentX-data.oldX,data.ddY=data.currentY-data.oldY,data.ndX=data.dX/data.width,data.ndY=data.dY/data.height,data.nddX=data.ddX/data.width,data.nddY=data.ddY/data.height},Spin.updateFrame=function(data,frame,lane){data.lastFrame=data.frame,data.lastLane=data.lane,void 0!==frame?data.frame=Number(frame):data.animation&&(data.frame+=data.reverse?-1:1),data.animation?(data.frame=wrap(data.frame,0,data.frames-1,data.frames),data.loop||data.frame!==data.stopFrame||Spin.stopAnimation(data)):data.wrap?data.frame=wrap(data.frame,0,data.frames-1,data.frames):data.frame=clamp(data.frame,0,data.frames-1),void 0!==lane&&(data.lane=lane,data.wrapLane?data.lane=wrap(data.lane,0,data.lanes-1,data.lanes):data.lane=clamp(data.lane,0,data.lanes-1)),data.lastFrame==data.frame&&data.lastLane==data.lane||data.target.trigger("onFrameChanged",data),data.target.trigger("onFrame",data),data.target.trigger("onDraw",data)},Spin.stopAnimation=function(data){data.animate=!1,data.animation&&(window.clearInterval(data.animation),data.animation=null)},Spin.setAnimation=function(data){data.animate?Spin.requestFrame(data):Spin.stopAnimation(data)},Spin.requestFrame=function(data){data.animation||(void 0===data.frameFunction&&(data.frameFunction=function(){try{Spin.updateFrame(data)}catch(ignore){}}),data.animation=window.setInterval(data.frameFunction,data.frameTime))},Spin.setModules=function(data){var i,modName,mod;for(i=0;i<data.mods.length;i+=1)modName=data.mods[i],"string"==typeof modName&&(mod=Spin.mods[modName],mod?data.mods[i]=mod:$.error("No module found with name "+modName))},Spin.displaySize=function(data){var w=Math.floor(data.width||data.frameWidth||data.target.innerWidth()),h=Math.floor(data.height||data.frameHeight||data.target.innerHeight()),a=w/h;return{width:w,height:h,aspect:a}},Spin.calculateInnerLayout=function(data){var w=Math.floor(data.width||data.frameWidth||data.target.innerWidth()),h=Math.floor(data.height||data.frameHeight||data.target.innerHeight()),a=w/h,w1=data.frameWidth||w,h1=data.frameHeight||h,a1=w1/h1,css={width:"100%",height:"100%",top:0,left:0,bottom:0,right:0,position:"absolute",overflow:"hidden"},mode=data.sizeMode;return mode&&"scale"!=mode?("original"==mode?(css.width=w1,css.height=h1):"fit"==mode?a1>=a?(css.width=w,css.height=w/a1):(css.height=h,css.width=h*a1):"fill"==mode?a1>=a?(css.height=h,css.width=h*a1):(css.width=w,css.height=w/a1):(css.width=w,css.height=h),css.width=0|css.width,css.height=0|css.height,css.top=(h-css.height)/2|0,css.left=(w-css.width)/2|0,css.right=css.left,css.bottom=css.top,css):css},Spin.setLayout=function(data){data.target.attr("unselectable","on").css({width:"",height:"","-ms-user-select":"none","-moz-user-select":"none","-khtml-user-select":"none","-webkit-user-select":"none","user-select":"none"});var w=Math.floor(data.width||data.frameWidth||data.target.innerWidth()),h=Math.floor(data.height||data.frameHeight||data.target.innerHeight());if(data.responsive&&"function"==typeof window.getComputedStyle){var style=getComputedStyle(data.target[0]);if(style.width){var a=w/h;w=0|Number(style.width.replace("px","")),h=w/a|0}}data.target.css({width:w,height:h,position:"relative",overflow:"hidden"});var css=Spin.calculateInnerLayout(data);data.stage.css(css).hide(),data.canvas&&(data.canvasRatio=data.canvasRatio||pixelRatio(data.context),data.canvas[0].width=css.width*data.canvasRatio||w,data.canvas[0].height=css.height*data.canvasRatio||h,data.canvas.css(css).hide(),data.context.scale(data.canvasRatio,data.canvasRatio))},Spin.setEvents=function(data){var i,j,mod,target=data.target;for(unbind(target),j=0;j<Spin.eventsToPrevent.length;j+=1)bind(target,Spin.eventsToPrevent[j],prevent);for(i=0;i<data.mods.length;i+=1){for(mod=data.mods[i],j=0;j<Spin.eventNames.length;j+=1)bind(target,Spin.eventNames[j],mod[Spin.eventNames[j]]);bind(target,"onInit",mod.onInit),bind(target,"onProgress",mod.onProgress),bind(target,"onLoad",mod.onLoad),bind(target,"onFrameChanged",mod.onFrameChanged),bind(target,"onFrame",mod.onFrame),bind(target,"onDraw",mod.onDraw)}bind(target,"onLoad",function(e,data){Spin.setAnimation(data)}),bind(target,"onInit",data.onInit),bind(target,"onProgress",data.onProgress),bind(target,"onLoad",data.onLoad),bind(target,"onFrameChanged",mod.onFrameChanged),bind(target,"onFrame",data.onFrame),bind(target,"onDraw",data.onDraw)},Spin.boot=function(data){Spin.setModules(data),Spin.setLayout(data),Spin.setEvents(data),data.target.addClass("loading").trigger("onInit",data),data.loading=!0,load({source:data.source,preloadCount:data.preloadCount,progress:function(progress){data.target.trigger("onProgress",[progress,data])},complete:function(images){data.images=images,data.loading=!1,Spin.measureSource(data),Spin.setLayout(data),data.stage.show(),data.target.removeClass("loading").trigger("onLoad",data).trigger("onFrame",data).trigger("onDraw",data)}})},Spin.create=function(options){var $this=options.target,data=$this.data(name);if(data)$.extend(data,options);else{if(data=$.extend({},Spin.defaults,options),data.source=data.source||[],$this.find("img").each(function(){data.source.push($(this).attr("src"))}),$this.empty().addClass("spritespin-instance").append("<div class='spritespin-stage'></div>"),"canvas"===data.renderer){var canvas=$("<canvas class='spritespin-canvas'></canvas>")[0];canvas.getContext&&canvas.getContext("2d")?(data.canvas=$(canvas),data.context=canvas.getContext("2d"),$this.append(data.canvas),$this.addClass("with-canvas")):data.renderer="image"}data.target=$this,data.stage=$this.find(".spritespin-stage"),$this.data(name,data),pushInstance(data)}"string"==typeof data.source&&(data.source=[data.source]),data.mods&&(delete data.behavior,delete data.module),(data.behavior||data.module)&&(data.mods=[],data.behavior&&data.mods.push(data.behavior),data.module&&data.mods.push(data.module),delete data.behavior,delete data.module),Spin.boot(data)},Spin.destroy=function(data){data&&(popInstance(data),Spin.stopAnimation(data),unbind(data.target),data.target.removeData(name))},Spin.registerModule=function(name,module){return Spin.mods[name]&&$.error("Module name is already taken: "+name),module=module||{},Spin.mods[name]=module,module},Spin.Api=function(data){this.data=data},Spin.extendApi=function(methods){var key,api=Spin.Api.prototype;for(key in methods)methods.hasOwnProperty(key)&&(api[key]?$.error("API method is already defined: "+key):api[key]=methods[key]);return api},$.fn.spritespin=function(obj,value){if("data"===obj)return this.data(name);if("api"===obj){var data=this.data(name);return data.api=data.api||new Spin.Api(data),data.api}if("destroy"===obj)return $(this).each(function(){Spin.destroy($(this).data(name))});if(2===arguments.length&&"string"==typeof obj){var tmp={};tmp[obj]=value,obj=tmp}return"object"==typeof obj?(obj.target=obj.target||$(this),Spin.create(obj),obj.target):$.error("Invalid call to spritespin")}}(window.jQuery||window.Zepto||window.$),function($){"use strict";var SpriteSpin=window.SpriteSpin;SpriteSpin.extendApi({isPlaying:function(){return null!==this.data.animation},isLooping:function(){return this.data.loop},toggleAnimation:function(){this.data.animate=!this.data.animate,SpriteSpin.setAnimation(this.data)},stopAnimation:function(){this.data.animate=!1,SpriteSpin.setAnimation(this.data)},startAnimation:function(){this.data.animate=!0,SpriteSpin.setAnimation(this.data)},loop:function(value){return this.data.loop=value,SpriteSpin.setAnimation(this.data),this},currentFrame:function(){return this.data.frame},updateFrame:function(frame){return SpriteSpin.updateFrame(this.data,frame),this},skipFrames:function(step){var data=this.data;return SpriteSpin.updateFrame(data,data.frame+(data.reverse?-step:+step)),this},nextFrame:function(){return this.skipFrames(1)},prevFrame:function(){return this.skipFrames(-1)},playTo:function(frame,options){var data=this.data;if(options=options||{},options.force||data.frame!==frame){if(options.nearest){var a=frame-data.frame,b=frame>data.frame?a-data.frames:a+data.frames,c=Math.abs(a)<Math.abs(b)?a:b;data.reverse=c<0}return data.animate=!0,data.loop=!1,data.stopFrame=frame,SpriteSpin.setAnimation(data),this}}})}(window.jQuery||window.Zepto||window.$),function($){"use strict";function requestFullscreen(e){e=e||document.documentElement,e[fn.requestFullscreen]()}function exitFullscreen(){return document[fn.exitFullscreen]()}function fullscreenEnabled(){return document[fn.fullscreenEnabled]}function fullscreenElement(){return document[fn.fullscreenElement]}function isFullscreen(){return!!fullscreenElement()}function unbindChangeEvent(){$(document).unbind(changeEvent)}function bindChangeEvent(callback){unbindChangeEvent(),$(document).bind(changeEvent,callback)}function unbindOrientationEvent(){$(window).unbind(orientationEvent)}function bindOrientationEvent(callback){unbindOrientationEvent(),$(window).bind(orientationEvent,callback)}var fn=function(){for(var val,valLength,fnMap=[["requestFullscreen","exitFullscreen","fullscreenElement","fullscreenEnabled","fullscreenchange","fullscreenerror"],["webkitRequestFullscreen","webkitExitFullscreen","webkitFullscreenElement","webkitFullscreenEnabled","webkitfullscreenchange","webkitfullscreenerror"],["webkitRequestFullScreen","webkitCancelFullScreen","webkitCurrentFullScreenElement","webkitCancelFullScreen","webkitfullscreenchange","webkitfullscreenerror"],["mozRequestFullScreen","mozCancelFullScreen","mozFullScreenElement","mozFullScreenEnabled","mozfullscreenchange","mozfullscreenerror"],["msRequestFullscreen","msExitFullscreen","msFullscreenElement","msFullscreenEnabled","MSFullscreenChange","MSFullscreenError"]],i=0,l=fnMap.length,ret={};i<l;i++)if(val=fnMap[i],val&&val[1]in document){for(i=0,valLength=val.length;i<valLength;i++)ret[fnMap[0][i]]=val[i];return ret}return!1}(),changeEvent=fn.fullscreenchange+"."+SpriteSpin.namespace+"-fullscreen",orientationEvent="orientationchange."+SpriteSpin.namespace+"-fullscreen";SpriteSpin.extendApi({fullscreenEnabled:fullscreenEnabled,fullscreenElement:fullscreenElement,exitFullscreen:exitFullscreen,toggleFullscreen:function(opts){isFullscreen()?this.requestFullscreen(opts):this.exitFullscreen()},requestFullscreen:function(opts){opts=opts||{};var api=this,data=api.data,oWidth=data.width,oHeight=data.height,oSource=data.source,oSize=data.sizeMode,oResponsive=data.responsive,enter=function(){data.width=window.screen.width,data.height=window.screen.height,data.source=opts.source||oSource,data.sizeMode=opts.sizeMode||"fit",data.responsive=!1,SpriteSpin.boot(data)},exit=function(){data.width=oWidth,data.height=oHeight,data.source=oSource,data.sizeMode=oSize,data.responsive=oResponsive,SpriteSpin.boot(data)};bindChangeEvent(function(){isFullscreen()?(enter(),bindOrientationEvent(enter)):(unbindChangeEvent(),unbindOrientationEvent(),exit())}),requestFullscreen(data.target[0])}})}(window.jQuery||window.Zepto||window.$,window.SpriteSpin),function($,SpriteSpin){"use strict";function click(e,data){if(!data.loading&&data.stage.is(":visible")){SpriteSpin.updateInput(e,data);var half,pos,target=data.target,offset=target.offset();"horizontal"===data.orientation?(half=target.innerWidth()/2,pos=data.currentX-offset.left):(half=target.innerHeight()/2,pos=data.currentY-offset.top),SpriteSpin.updateFrame(data,data.frame+(pos>half?1:-1))}}SpriteSpin.registerModule("click",{mouseup:click,touchend:click})}(window.jQuery||window.Zepto||window.$,window.SpriteSpin),function($,SpriteSpin){"use strict";function dragStart(e,data){data.loading||data.dragging||!data.stage.is(":visible")||(data.dragFrame=data.frame||0,data.dragLane=data.lane||0,data.dragging=!0,SpriteSpin.updateInput(e,data))}function dragEnd(e,data){data.dragging&&(data.dragging=!1,SpriteSpin.resetInput(data))}function drag(e,data){if(data.dragging){if(SpriteSpin.updateInput(e,data),Math.abs(data.ddX)+Math.abs(data.ddY)>data.scrollThreshold)return data.dragging=!1,void SpriteSpin.resetInput(data);e.preventDefault();var angle=0;angle="number"==typeof data.orientation?(Number(data.orientation)||0)*Math.PI/180:"horizontal"===data.orientation?0:Math.PI/2;var sn=Math.sin(angle),cs=Math.cos(angle),x=(data.nddX*cs-data.nddY*sn)*data.sense||0,y=(data.nddX*sn+data.nddY*cs)*(data.senseLane||data.sense)||0;data.dragFrame+=data.frames*x,data.dragLane+=data.lanes*y;var frame=Math.floor(data.dragFrame),lane=Math.floor(data.dragLane);SpriteSpin.updateFrame(data,frame,lane),SpriteSpin.stopAnimation(data)}}SpriteSpin.registerModule("drag",{mousedown:dragStart,mousemove:drag,mouseup:dragEnd,documentmousemove:drag,documentmouseup:dragEnd,touchstart:dragStart,touchmove:drag,touchend:dragEnd,touchcancel:dragEnd}),SpriteSpin.registerModule("move",{mousemove:function(e,data){dragStart.call(this,e,data),drag.call(this,e,data)},mouseleave:dragEnd,touchstart:dragStart,touchmove:drag,touchend:dragEnd,touchcancel:dragEnd})}(window.jQuery||window.Zepto||window.$,window.SpriteSpin),function($,SpriteSpin){"use strict";function start(e,data){data.loading||data.dragging||!data.stage.is(":visible")||(SpriteSpin.updateInput(e,data),data.dragging=!0,data.animate=!0,SpriteSpin.setAnimation(data))}function stop(e,data){data.dragging=!1,SpriteSpin.resetInput(data),SpriteSpin.stopAnimation(data)}function update(e,data){if(data.dragging){SpriteSpin.updateInput(e,data);var half,delta,target=data.target,offset=target.offset();"horizontal"===data.orientation?(half=target.innerWidth()/2,delta=(data.currentX-offset().left-half)/half):(half=data.height/2,delta=(data.currentY-offset().top-half)/half),data.reverse=delta<0,delta=delta<0?-delta:delta,data.frameTime=80*(1-delta)+20,("horizontal"===data.orientation&&data.dX<data.dY||"vertical"===data.orientation&&data.dX<data.dY)&&e.preventDefault()}}SpriteSpin.registerModule("hold",{mousedown:start,mousemove:update,mouseup:stop,mouseleave:stop,touchstart:start,touchmove:update,touchend:stop,touchcancel:stop,onFrame:function(){$(this).spritespin("api").startAnimation()}})}(window.jQuery||window.Zepto||window.$,window.SpriteSpin),function($,SpriteSpin){"use strict";function init(e,data){data.swipeFling=data.swipeFling||10,data.swipeSnap=data.swipeSnap||.5}function start(e,data){data.loading||data.dragging||(SpriteSpin.updateInput(e,data),data.dragging=!0)}function update(e,data){if(data.dragging){SpriteSpin.updateInput(e,data);var frame=data.frame,lane=data.lane;SpriteSpin.updateFrame(data,frame,lane)}}function end(e,data){if(data.dragging){data.dragging=!1;var dS,dF,frame=data.frame,lane=data.lane,snap=data.swipeSnap,fling=data.swipeFling;"horizontal"===data.orientation?(dS=data.ndX,dF=data.ddX):(dS=data.ndY,dF=data.ddY),dS>snap||dF>fling?frame=data.frame-1:(dS<-snap||dF<-fling)&&(frame=data.frame+1),SpriteSpin.resetInput(data),SpriteSpin.updateFrame(data,frame,lane),SpriteSpin.stopAnimation(data)}}SpriteSpin.registerModule("swipe",{onLoad:init,mousedown:start,mousemove:update,mouseup:end,mouseleave:end,touchstart:start,touchmove:update,touchend:end,touchcancel:end})}(window.jQuery||window.Zepto||window.$,window.SpriteSpin),function($,SpriteSpin){"use strict";function drawSprite(data){var index=data.lane*data.frames+data.frame,x=data.frameWidth*(index%data.framesX),y=data.frameHeight*floor(index/data.framesX);if("canvas"===data.renderer){var w=data.canvas[0].width/data.canvasRatio,h=data.canvas[0].height/data.canvasRatio;return data.context.clearRect(0,0,w,h),void data.context.drawImage(data.images[0],x,y,data.frameWidth,data.frameHeight,0,0,w,h)}x=-floor(x*data.scaleWidth),y=-floor(y*data.scaleHeight),"background"===data.renderer?data.stage.css({"background-image":["url('",data.source[0],"')"].join(""),"background-position":[x,"px ",y,"px"].join("")}):$(data.images).css({top:y,left:x,"max-width":"initial"})}function drawFrames(data){var index=data.lane*data.frames+data.frame,img=data.images[index];if("canvas"===data.renderer){if(img&&img.complete!==!1){var w=data.canvas[0].width/data.canvasRatio,h=data.canvas[0].height/data.canvasRatio;data.context.clearRect(0,0,w,h),data.context.drawImage(img,0,0,w,h)}}else"background"===data.renderer?data.stage.css({"background-image":["url('",data.source[index],"')"].join(""),"background-position":[0,"px ",0,"px"].join("")}):($(data.images).hide(),$(data.images[index]).show())}var floor=Math.floor;SpriteSpin.registerModule("360",{onLoad:function(e,data){var w,h;if(data.width&&data.frameWidth?data.scaleWidth=data.width/data.frameWidth:data.scaleWidth=1,data.height&&data.frameHeight?data.scaleHeight=data.height/data.frameHeight:data.scaleHeight=1,data.sourceIsSprite=1===data.images.length,data.stage.empty().css({"background-image":"none"}).show(),"canvas"===data.renderer){var w=data.canvas[0].width/data.canvasRatio,h=data.canvas[0].height/data.canvasRatio;data.context.clearRect(0,0,w,h),data.canvas.show()}else if("background"===data.renderer){data.sourceIsSprite?(w=floor(data.sourceWidth*data.scaleWidth),h=floor(data.sourceHeight*data.scaleHeight)):(w=floor(data.frameWidth*data.scaleWidth),h=floor(data.frameHeight*data.scaleHeight));var background=[w,"px ",h,"px"].join("");data.stage.css({"background-repeat":"no-repeat","-webkit-background-size":background,"-moz-background-size":background,"-o-background-size":background,"background-size":background})}else"image"===data.renderer&&(data.sourceIsSprite?(w=floor(data.sourceWidth*data.scaleWidth),h=floor(data.sourceHeight*data.scaleHeight)):w=h="100%",$(data.images).appendTo(data.stage).css({width:w,height:h,position:"absolute"}))},onDraw:function(e,data){data.sourceIsSprite?drawSprite(data):drawFrames(data)}})}(window.jQuery||window.Zepto||window.$,window.SpriteSpin),function($,SpriteSpin){"use strict";function init(e,data){var scope=scopeFrom(data),css=SpriteSpin.calculateInnerLayout(data);scope.canvas[0].width=data.width*data.canvasRatio,scope.canvas[0].height=data.height*data.canvasRatio,scope.canvas.css(css).show(),scope.context.scale(data.canvasRatio,data.canvasRatio),data.target.append(scope.canvas)}function onFrame(e,data){var scope=scopeFrom(data);trackFrame(data,scope),null==scope.timeout&&loop(data,scope)}function scopeFrom(data){data.blurScope=data.blurScope||{};var scope=data.blurScope;return scope.canvas=scope.canvas||$("<canvas class='blur-layer'></canvas>"),scope.context=scope.context||scope.canvas[0].getContext("2d"),scope.steps=scope.steps||[],scope.fadeTime=Math.max(data.blurFadeTime||200,1),scope.frameTime=Math.max(data.blurFrameTime||data.frameTime,16),scope.trackTime=null,scope.cssBlur=!!data.blurCss,scope}function trackFrame(data,scope){var d=Math.abs(data.frame-data.lastFrame);d>=data.frames/2&&(d=data.frames-d),scope.steps.unshift({index:data.lane*data.frames+data.frame,live:1,step:scope.frameTime/scope.fadeTime,d:d})}function removeOldFrames(frames){toRemove.length=0;var i;for(i=0;i<frames.length;i+=1)frames[i].alpha<=0&&toRemove.push(i);for(i=0;i<toRemove.length;i+=1)frames.splice(toRemove[i],1)}function loop(data,scope){scope.timeout=window.setTimeout(function(){tick(data,scope)},scope.frameTime)}function killLoop(data,scope){window.clearTimeout(scope.timeout),scope.timeout=null}function applyCssBlur(canvas,d){d=Math.min(Math.max(d/2-4,0),1.5),canvas.css({"-webkit-filter":"blur("+d+"px)",filter:"blur("+d+"px)"})}function drawFrame(data,scope,step){var context=scope.context,index=step.index,img=data.sourceIsSprite?data.images[0]:data.images[index];if(!(step.alpha<=0)&&img&&img.complete!==!1)if(context.globalAlpha=step.alpha,data.sourceIsSprite){var x=data.frameWidth*(index%data.framesX),y=data.frameHeight*Math.floor(index/data.framesX);context.drawImage(img,x,y,data.frameWidth,data.frameHeight,0,0,data.width,data.height)}else context.drawImage(img,0,0,data.width,data.height)}function tick(data,scope){if(killLoop(data,scope),scope.context){var i,step,context=scope.context,d=0;for(context.clearRect(0,0,data.width,data.height),i=0;i<scope.steps.length;i+=1)step=scope.steps[i],step.live=Math.max(step.live-step.step,0),step.alpha=Math.max(step.live-.25,0),drawFrame(data,scope,step),d+=step.alpha+step.d;scope.cssBlur&&applyCssBlur(scope.canvas,d),removeOldFrames(scope.steps),scope.steps.length&&loop(data,scope)}}var toRemove=[];SpriteSpin.registerModule("blur",{onLoad:init,onFrameChanged:onFrame})}(window.jQuery||window.Zepto||window.$,window.SpriteSpin),function($,SpriteSpin){"use strict";function init(e,data){data.easeAbortAfterMs=max(data.easeAbortAfterMs||250,0),data.easeDamping=max(min(data.easeDamping||.9,.999),0),data.easeSamples=max(data.easeSamples||5,1),data.easeUpdateTime=max(data.easeUpdateTime||data.frameTime,16),data.easeScope={samples:[],steps:[]}}function update(e,data){data.dragging&&(killLoop(data,data.easeScope),sampleInput(data,data.easeScope))}function end(e,data){for(var last,sample,ease=data.easeScope,samples=ease.samples,lanes=0,frames=0,time=0,i=0;i<samples.length;i+=1)if(sample=samples[i],last){var dt=sample.time-last.time;if(dt>data.easeAbortAfterMs)return lanes=frames=time=0,killLoop(data,ease);frames+=sample.frame-last.frame,lanes+=sample.lane-last.lane,time+=dt,last=sample}else last=sample;samples.length=0,time&&(ease.ms=data.easeUpdateTime,ease.lane=data.lane,ease.lanes=0,ease.laneStep=lanes/time*ease.ms,ease.frame=data.frame,ease.frames=0,ease.frameStep=frames/time*ease.ms,loop(data,ease))}function sampleInput(data,ease){for(ease.samples.push({time:(new Date).getTime(),frame:data.dragFrame,lane:data.dragLane});ease.samples.length>data.easeSamples;)ease.samples.shift()}function killLoop(data,ease){null!=ease.timeout&&(window.clearTimeout(ease.timeout),ease.timeout=null)}function loop(data,ease){ease.timeout=window.setTimeout(function(){tick(data,ease)},ease.ms)}function tick(data,ease){ease.lanes+=ease.laneStep,ease.frames+=ease.frameStep,ease.laneStep*=data.easeDamping,ease.frameStep*=data.easeDamping;var frame=Math.floor(ease.frame+ease.frames),lane=Math.floor(ease.lane+ease.lanes);SpriteSpin.updateFrame(data,frame,lane),data.dragging?killLoop(data,ease):Math.abs(ease.frameStep)>.005||Math.abs(ease.laneStep)>.005?loop(data,ease):killLoop(data,ease)}var max=Math.max,min=Math.min;SpriteSpin.registerModule("ease",{onLoad:init,mousemove:update,mouseup:end,mouseleave:end,touchmove:update,touchend:end,touchcancel:end})}(window.jQuery||window.Zepto||window.$,window.SpriteSpin),function($,SpriteSpin){"use strict";function load(e,data){data.galleryImages=[],data.galleryOffsets=[],data.gallerySpeed=500,data.galleryOpacity=.25,data.galleryFrame=0,data.galleryStage=data.galleryStage||$("<div/>"),data.stage.prepend(data.galleryStage),data.galleryStage.empty();var i,size=0;for(i=0;i<data.source.length;i+=1){var img=$("<img src='"+data.source[i]+"'/>");data.galleryStage.append(img),data.galleryImages.push(img);var scale=data.height/img[0].height;data.galleryOffsets.push(-size+(data.width-img[0].width*scale)/2),size+=data.width,img.css({"max-width":"initial",opacity:data.galleryOpacity,width:data.width,height:data.height})}var css=SpriteSpin.calculateInnerLayout(data);data.galleryStage.css(css).css({width:size}),data.galleryImages[data.galleryFrame].animate({opacity:1},data.gallerySpeed)}function draw(e,data){data.galleryFrame===data.frame||data.dragging?(data.dragging||data.dX!=data.gallerydX)&&(data.galleryDX=data.DX,data.galleryDDX=data.DDX,data.galleryStage.stop(!0,!0).animate({left:data.galleryOffsets[data.frame]+data.dX})):(data.galleryStage.stop(!0,!1),data.galleryStage.animate({left:data.galleryOffsets[data.frame]},data.gallerySpeed),data.galleryImages[data.galleryFrame].animate({opacity:data.galleryOpacity},data.gallerySpeed),data.galleryFrame=data.frame,data.galleryImages[data.galleryFrame].animate({opacity:1},data.gallerySpeed))}SpriteSpin.registerModule("gallery",{onLoad:load,onDraw:draw})}(window.jQuery||window.Zepto||window.$,window.SpriteSpin),function($,SpriteSpin){"use strict";var floor=Math.floor;SpriteSpin.registerModule("panorama",{onLoad:function(e,data){data.stage.empty().show(),data.frames=data.sourceWidth,"horizontal"===data.orientation?(data.scale=data.height/data.sourceHeight,data.frames=data.sourceWidth):(data.scale=data.width/data.sourceWidth,data.frames=data.sourceHeight);var w=floor(data.sourceWidth*data.scale),h=floor(data.sourceHeight*data.scale),background=[w,"px ",h,"px"].join("");data.stage.css({"max-width":"initial","background-image":["url('",data.source[0],"')"].join(""),"background-repeat":"repeat-both","-webkit-background-size":background,"-moz-background-size":background,"-o-background-size":background,"background-size":background})},onDraw:function(e,data){var x=0,y=0;"horizontal"===data.orientation?x=-floor(data.frame%data.frames*data.scale):y=-floor(data.frame%data.frames*data.scale),data.stage.css({"background-position":[x,"px ",y,"px"].join("")})}})}(window.jQuery||window.Zepto||window.$,window.SpriteSpin),function($,SpriteSpin){"use strict";function onCreate(e,data){data.zoomStage||(data.zoomStage=$("<div class='spritezoom-stage'></div>").css({width:"100%",height:"100%",top:0,left:0,bottom:0,right:0,position:"absolute"}).appendTo(data.target).hide())}function onDestroy(e,data){data.zoomStage&&data.zoomStage.remove()}function updateInput(e,data){e.preventDefault(),data.dragging=!1,!e.touches&&e.originalEvent&&(e.touches=e.originalEvent.touches);var x,y,dx,dy;e.touches&&e.touches.length?(x=e.touches[0].clientX||0,y=e.touches[0].clientY||0):(x=e.clientX||0,y=e.clientY||0),x/=data.width,y/=data.height,null==data.zoomPX&&(data.zoomPX=x,data.zoomPY=y),null==data.zoomX&&(data.zoomX=x,data.zoomY=y),dx=x-data.zoomPX,dy=y-data.zoomPY,data.zoomPX=x,data.zoomPY=y,e.type.match(/touch/)&&(dx=-dx,dy=-dy),data.zoomX=SpriteSpin.clamp(data.zoomX+dx,0,1),data.zoomY=SpriteSpin.clamp(data.zoomY+dy,0,1),SpriteSpin.updateFrame(data)}function onDraw(e,data){var index=data.lane*data.frames+data.frame,source=(data.zoomSource||data.source)[index];if(!source)return void $.error("'zoomSource' option is missing or it contains unsufficient number of frames.");
var x=data.zoomX,y=data.zoomY;null!=x&&null!=y||(x=data.zoomX=.5,y=data.zoomY=.5),x=100*x|0,y=100*y|0,data.zoomStage.css({"background-repeat":"no-repeat","background-image":["url('",source,"')"].join(""),"background-position":[x,"% ",y,"%"].join("")})}function onClick(e,data){e.preventDefault();var clickTime=(new Date).getTime();if(!data.zoomClickTime)return void(data.zoomClickTime=clickTime);var timeDelta=clickTime-data.zoomClickTime,doubleClickTime=data.zoomDoubleClickTime||500;return timeDelta>doubleClickTime?void(data.zoomClickTime=clickTime):(data.zoomClickTime=0,void($(this).spritespin("api").toggleZoom()&&updateInput(e,data)))}function onMove(e,data){data.zoomStage.is(":visible")&&updateInput(e,data)}function toggleZoom(){var data=this.data;return data.zoomStage?data.zoomStage.is(":visible")?(data.zoomStage.fadeOut(),data.stage.fadeIn(),!1):(data.zoomStage.fadeIn(),data.stage.fadeOut(),!0):($.error("zoom module is not initialized or is not available."),!1)}SpriteSpin.registerModule("zoom",{mousedown:onClick,touchstart:onClick,mousemove:onMove,touchmove:onMove,onInit:onCreate,onDestroy:onDestroy,onDraw:onDraw}),SpriteSpin.extendApi({toggleZoom:toggleZoom})}(window.jQuery||window.Zepto||window.$,window.SpriteSpin);
(function($){

    /**
     * Copyright 2012, Digital Fusion
     * Licensed under the MIT license.
     * http://teamdf.com/jquery-plugins/license/
     *
     * @author Sam Sehnert
     * @desc A small plugin that checks whether elements are within
     *       the user visible viewport of a web browser.
     *       only accounts for vertical position, not horizontal.
     */
    var $w=$(window);
    $.fn.visible = function(partial,hidden,direction,container){

        if (this.length < 1)
            return;
	
	// Set direction default to 'both'.
	direction = direction || 'both';
	    
        var $t          = this.length > 1 ? this.eq(0) : this,
						isContained = typeof container !== 'undefined' && container !== null,
						$c				  = isContained ? $(container) : $w,
						wPosition        = isContained ? $c.position() : 0,
            t           = $t.get(0),
            vpWidth     = $c.outerWidth(),
            vpHeight    = $c.outerHeight(),
            clientSize  = hidden === true ? t.offsetWidth * t.offsetHeight : true;

        if (typeof t.getBoundingClientRect === 'function'){

            // Use this native browser method, if available.
            var rec = t.getBoundingClientRect(),
                tViz = isContained ?
												rec.top - wPosition.top >= 0 && rec.top < vpHeight + wPosition.top :
												rec.top >= 0 && rec.top < vpHeight,
                bViz = isContained ?
												rec.bottom - wPosition.top > 0 && rec.bottom <= vpHeight + wPosition.top :
												rec.bottom > 0 && rec.bottom <= vpHeight,
                lViz = isContained ?
												rec.left - wPosition.left >= 0 && rec.left < vpWidth + wPosition.left :
												rec.left >= 0 && rec.left <  vpWidth,
                rViz = isContained ?
												rec.right - wPosition.left > 0  && rec.right < vpWidth + wPosition.left  :
												rec.right > 0 && rec.right <= vpWidth,
                vVisible   = partial ? tViz || bViz : tViz && bViz,
                hVisible   = partial ? lViz || rViz : lViz && rViz,
		vVisible = (rec.top < 0 && rec.bottom > vpHeight) ? true : vVisible,
                hVisible = (rec.left < 0 && rec.right > vpWidth) ? true : hVisible;

            if(direction === 'both')
                return clientSize && vVisible && hVisible;
            else if(direction === 'vertical')
                return clientSize && vVisible;
            else if(direction === 'horizontal')
                return clientSize && hVisible;
        } else {

            var viewTop 				= isContained ? 0 : wPosition,
                viewBottom      = viewTop + vpHeight,
                viewLeft        = $c.scrollLeft(),
                viewRight       = viewLeft + vpWidth,
                position          = $t.position(),
                _top            = position.top,
                _bottom         = _top + $t.height(),
                _left           = position.left,
                _right          = _left + $t.width(),
                compareTop      = partial === true ? _bottom : _top,
                compareBottom   = partial === true ? _top : _bottom,
                compareLeft     = partial === true ? _right : _left,
                compareRight    = partial === true ? _left : _right;

            if(direction === 'both')
                return !!clientSize && ((compareBottom <= viewBottom) && (compareTop >= viewTop)) && ((compareRight <= viewRight) && (compareLeft >= viewLeft));
            else if(direction === 'vertical')
                return !!clientSize && ((compareBottom <= viewBottom) && (compareTop >= viewTop));
            else if(direction === 'horizontal')
                return !!clientSize && ((compareRight <= viewRight) && (compareLeft >= viewLeft));
        }
    };

})(jQuery);

/*
 * Copyright (C) 2012 PrimeBox
 * 
 * This work is licensed under the Creative Commons
 * Attribution 3.0 Unported License. To view a copy
 * of this license, visit
 * http://creativecommons.org/licenses/by/3.0/.
 * 
 * Documentation available at:
 * http://www.primebox.co.uk/projects/cookie-bar/
 * 
 * When using this software you use it at your own risk. We hold
 * no responsibility for any damage caused by using this plugin
 * or the documentation provided.
 */
(function($){
	$.cookieBar = function(options,val){
		if(options=='cookies'){
			var doReturn = 'cookies';
		}else if(options=='set'){
			var doReturn = 'set';
		}else{
			var doReturn = false;
		}
		var defaults = {
			message: 'We use cookies to track usage and preferences.', //Message displayed on bar
			acceptButton: true, //Set to true to show accept/enable button
			acceptText: 'I Understand', //Text on accept/enable button
			acceptFunction: function(cookieValue){if(cookieValue!='enabled' && cookieValue!='accepted') window.location = window.location.href;}, //Function to run after accept
			declineButton: false, //Set to true to show decline/disable button
			declineText: 'Disable Cookies', //Text on decline/disable button
			declineFunction: function(cookieValue){if(cookieValue=='enabled' || cookieValue=='accepted') window.location = window.location.href;}, //Function to run after decline
			policyButton: false, //Set to true to show Privacy Policy button
			policyText: 'Privacy Policy', //Text on Privacy Policy button
			policyURL: '/privacy-policy/', //URL of Privacy Policy
			autoEnable: true, //Set to true for cookies to be accepted automatically. Banner still shows
			acceptOnContinue: false, //Set to true to accept cookies when visitor moves to another page
			acceptOnScroll: false, //Set to true to accept cookies when visitor scrolls X pixels up or down
			acceptAnyClick: false, //Set to true to accept cookies when visitor clicks anywhere on the page
			expireDays: 365, //Number of days for cookieBar cookie to be stored for
			renewOnVisit: false, //Renew the cookie upon revisit to website
			forceShow: false, //Force cookieBar to show regardless of user cookie preference
			effect: 'slide', //Options: slide, fade, hide
			element: 'body', //Element to append/prepend cookieBar to. Remember "." for class or "#" for id.
			append: false, //Set to true for cookieBar HTML to be placed at base of website. Actual position may change according to CSS
			fixed: false, //Set to true to add the class "fixed" to the cookie bar. Default CSS should fix the position
			bottom: false, //Force CSS when fixed, so bar appears at bottom of website
			zindex: '', //Can be set in CSS, although some may prefer to set here
			domain: String(window.location.hostname), //Location of privacy policy
			referrer: String(document.referrer) //Where visitor has come from
		};
		var options = $.extend(defaults,options);
		
		//Sets expiration date for cookie
		var expireDate = new Date();
		expireDate.setTime(expireDate.getTime()+(options.expireDays*86400000));
		expireDate = expireDate.toGMTString();
		
		var cookieEntry = 'cb-enabled={value}; expires='+expireDate+'; path=/';
		
		//Retrieves current cookie preference
		var i,cookieValue='',aCookie,aCookies=document.cookie.split('; ');
		for (i=0;i<aCookies.length;i++){
			aCookie = aCookies[i].split('=');
			if(aCookie[0]=='cb-enabled'){
    			cookieValue = aCookie[1];
			}
		}
		//Sets up default cookie preference if not already set
		if(cookieValue=='' && doReturn!='cookies' && options.autoEnable){
			cookieValue = 'enabled';
			document.cookie = cookieEntry.replace('{value}','enabled');
		}else if((cookieValue=='accepted' || cookieValue=='declined') && doReturn!='cookies' && options.renewOnVisit){
			document.cookie = cookieEntry.replace('{value}',cookieValue);
		}
		if(options.acceptOnContinue){
			if(options.referrer.indexOf(options.domain)>=0 && String(window.location.href).indexOf(options.policyURL)==-1 && doReturn!='cookies' && doReturn!='set' && cookieValue!='accepted' && cookieValue!='declined'){
				doReturn = 'set';
				val = 'accepted';
			}
		}
		if(doReturn=='cookies'){
			//Returns true if cookies are enabled, false otherwise
			if(cookieValue=='enabled' || cookieValue=='accepted'){
				return true;
			}else{
				return false;
			}
		}else if(doReturn=='set' && (val=='accepted' || val=='declined')){
			//Sets value of cookie to 'accepted' or 'declined'
			document.cookie = cookieEntry.replace('{value}',val);
			if(val=='accepted'){
				return true;
			}else{
				return false;
			}
		}else{
			//Sets up enable/accept button if required
			var message = options.message.replace('{policy_url}',options.policyURL);
			
			if(options.acceptButton){
                //Changed for WCAG - Miguel Castro
                var acceptButton = '<bt tabindex="0" class="cb-enable">'+options.acceptText+'</bt>';
                // var acceptButton = '<bt href="#" class="cb-enable">'+options.acceptText+'</bt>';
			}else{
				var acceptButton = '';
			}
			//Sets up disable/decline button if required
			if(options.declineButton){
				var declineButton = '<bt href="#" class="cb-disable">'+options.declineText+'</bt>';
			}else{
				var declineButton = '';
			}
			//Sets up privacy policy button if required
			if(options.policyButton){
				var policyButton = '<bt href="'+options.policyURL+'" class="cb-policy">'+options.policyText+'</bt>';
			}else{
				var policyButton = '';
			}
			//Whether to add "fixed" class to cookie bar
			if(options.fixed){
				if(options.bottom){
					var fixed = ' class="fixed bottom"';
				}else{
					var fixed = ' class="fixed"';
				}
			}else{
				var fixed = '';
			}
			if(options.zindex!=''){
				var zindex = ' style="z-index:'+options.zindex+';"';
			}else{
				var zindex = '';
			}
			
			//Displays the cookie bar if arguments met
			if(options.forceShow || cookieValue=='enabled' || cookieValue==''){
				if(options.append){
					$(options.element).append('<div id="cookie-bar"'+fixed+zindex+'><div>'+'<p>'+message+'</p>'+acceptButton+declineButton+policyButton+'</div></div>');
				}else{
					$(options.element).prepend('<div id="cookie-bar"'+fixed+zindex+'><div>'+'<p>'+message+'</p>'+acceptButton+declineButton+policyButton+'</div></div>');
				}
			}
			
			var removeBar = function(func){
				if(options.acceptOnScroll) $(document).off('scroll');
				if(typeof(func)==='function') func(cookieValue);
				if(options.effect=='slide'){
					$('#cookie-bar').slideUp(300,function(){$('#cookie-bar').remove();});
				}else if(options.effect=='fade'){
					$('#cookie-bar').fadeOut(300,function(){$('#cookie-bar').remove();});
				}else{
					$('#cookie-bar').hide(0,function(){$('#cookie-bar').remove();});
				}
				$(document).unbind('click',anyClick);
			};
			var cookieAccept = function(){
				document.cookie = cookieEntry.replace('{value}','accepted');
				removeBar(options.acceptFunction);
			};
			var cookieDecline = function(){
				var deleteDate = new Date();
				deleteDate.setTime(deleteDate.getTime()-(864000000));
				deleteDate = deleteDate.toGMTString();
				aCookies=document.cookie.split('; ');
				for (i=0;i<aCookies.length;i++){
					aCookie = aCookies[i].split('=');
					if(aCookie[0].indexOf('_')>=0){
						document.cookie = aCookie[0]+'=0; expires='+deleteDate+'; domain='+options.domain.replace('www','')+'; path=/';
					}else{
						document.cookie = aCookie[0]+'=0; expires='+deleteDate+'; path=/';
					}
				}
				document.cookie = cookieEntry.replace('{value}','declined');
				removeBar(options.declineFunction);
			};
			var anyClick = function(e){
				if(!$(e.target).hasClass('cb-policy')) cookieAccept();
			};
			
			$('#cookie-bar .cb-enable').click(function(){cookieAccept();return false;});
			$('#cookie-bar .cb-disable').click(function(){cookieDecline();return false;});
			if(options.acceptOnScroll){
				var scrollStart = $(document).scrollTop(),scrollNew,scrollDiff;
				$(document).on('scroll',function(){
					scrollNew = $(document).scrollTop();
					if(scrollNew>scrollStart){
						scrollDiff = scrollNew - scrollStart;
					}else{
						scrollDiff = scrollStart - scrollNew;
					}
					if(scrollDiff>=Math.round(options.acceptOnScroll)) cookieAccept();
				});
			}
			if(options.acceptAnyClick){
				$(document).bind('click',anyClick);
			}
		}
	};
})(jQuery);
(function(){var t,e,n,r,a,o,i,l,u,s,c,h,p,g,v,f,d,m,y,C,T,w,$,D,S=[].slice,k=[].indexOf||function(t){for(var e=0,n=this.length;n>e;e++)if(e in this&&this[e]===t)return e;return-1};t=window.jQuery||window.Zepto||window.$,t.payment={},t.payment.fn={},t.fn.payment=function(){var e,n;return n=arguments[0],e=2<=arguments.length?S.call(arguments,1):[],t.payment.fn[n].apply(this,e)},a=/(\d{1,4})/g,t.payment.cards=r=[{type:"maestro",patterns:[5018,502,503,506,56,58,639,6220,67],format:a,length:[12,13,14,15,16,17,18,19],cvcLength:[3],luhn:!0},{type:"forbrugsforeningen",patterns:[600],format:a,length:[16],cvcLength:[3],luhn:!0},{type:"dankort",patterns:[5019],format:a,length:[16],cvcLength:[3],luhn:!0},{type:"visa",patterns:[4],format:a,length:[13,16],cvcLength:[3],luhn:!0},{type:"mastercard",patterns:[51,52,53,54,55,22,23,24,25,26,27],format:a,length:[16],cvcLength:[3],luhn:!0},{type:"amex",patterns:[34,37],format:/(\d{1,4})(\d{1,6})?(\d{1,5})?/,length:[15],cvcLength:[3,4],luhn:!0},{type:"dinersclub",patterns:[30,36,38,39],format:/(\d{1,4})(\d{1,6})?(\d{1,4})?/,length:[14],cvcLength:[3],luhn:!0},{type:"discover",patterns:[60,64,65,622],format:a,length:[16],cvcLength:[3],luhn:!0},{type:"unionpay",patterns:[62,88],format:a,length:[16,17,18,19],cvcLength:[3],luhn:!1},{type:"jcb",patterns:[35],format:a,length:[16],cvcLength:[3],luhn:!0}],e=function(t){var e,n,a,o,i,l,u,s;for(t=(t+"").replace(/\D/g,""),o=0,l=r.length;l>o;o++)for(e=r[o],s=e.patterns,i=0,u=s.length;u>i;i++)if(a=s[i],n=a+"",t.substr(0,n.length)===n)return e},n=function(t){var e,n,a;for(n=0,a=r.length;a>n;n++)if(e=r[n],e.type===t)return e},p=function(t){var e,n,r,a,o,i;for(r=!0,a=0,n=(t+"").split("").reverse(),o=0,i=n.length;i>o;o++)e=n[o],e=parseInt(e,10),(r=!r)&&(e*=2),e>9&&(e-=9),a+=e;return a%10===0},h=function(t){var e;return null!=t.prop("selectionStart")&&t.prop("selectionStart")!==t.prop("selectionEnd")?!0:null!=("undefined"!=typeof document&&null!==document&&null!=(e=document.selection)?e.createRange:void 0)&&document.selection.createRange().text?!0:!1},$=function(t,e){var n,r,a,o,i,l;try{r=e.prop("selectionStart")}catch(u){o=u,r=null}return i=e.val(),e.val(t),null!==r&&e.is(":focus")?(r===i.length&&(r=t.length),i!==t&&(l=i.slice(r-1,+r+1||9e9),n=t.slice(r-1,+r+1||9e9),a=t[r],/\d/.test(a)&&l===""+a+" "&&n===" "+a&&(r+=1)),e.prop("selectionStart",r),e.prop("selectionEnd",r)):void 0},m=function(t){var e,n,r,a,o,i,l,u;for(null==t&&(t=""),r="０１２３４５６７８９",a="0123456789",i="",e=t.split(""),l=0,u=e.length;u>l;l++)n=e[l],o=r.indexOf(n),o>-1&&(n=a[o]),i+=n;return i},d=function(e){var n;return n=t(e.currentTarget),setTimeout(function(){var t;return t=n.val(),t=m(t),t=t.replace(/\D/g,""),$(t,n)})},v=function(e){var n;return n=t(e.currentTarget),setTimeout(function(){var e;return e=n.val(),e=m(e),e=t.payment.formatCardNumber(e),$(e,n)})},l=function(n){var r,a,o,i,l,u,s;return o=String.fromCharCode(n.which),!/^\d+$/.test(o)||(r=t(n.currentTarget),s=r.val(),a=e(s+o),i=(s.replace(/\D/g,"")+o).length,u=16,a&&(u=a.length[a.length.length-1]),i>=u||null!=r.prop("selectionStart")&&r.prop("selectionStart")!==s.length)?void 0:(l=a&&"amex"===a.type?/^(\d{4}|\d{4}\s\d{6})$/:/(?:^|\s)(\d{4})$/,l.test(s)?(n.preventDefault(),setTimeout(function(){return r.val(s+" "+o)})):l.test(s+o)?(n.preventDefault(),setTimeout(function(){return r.val(s+o+" ")})):void 0)},o=function(e){var n,r;return n=t(e.currentTarget),r=n.val(),8!==e.which||null!=n.prop("selectionStart")&&n.prop("selectionStart")!==r.length?void 0:/\d\s$/.test(r)?(e.preventDefault(),setTimeout(function(){return n.val(r.replace(/\d\s$/,""))})):/\s\d?$/.test(r)?(e.preventDefault(),setTimeout(function(){return n.val(r.replace(/\d$/,""))})):void 0},f=function(e){var n;return n=t(e.currentTarget),setTimeout(function(){var e;return e=n.val(),e=m(e),e=t.payment.formatExpiry(e),$(e,n)})},u=function(e){var n,r,a;return r=String.fromCharCode(e.which),/^\d+$/.test(r)?(n=t(e.currentTarget),a=n.val()+r,/^\d$/.test(a)&&"0"!==a&&"1"!==a?(e.preventDefault(),setTimeout(function(){return n.val("0"+a+" / ")})):/^\d\d$/.test(a)?(e.preventDefault(),setTimeout(function(){var t,e;return t=parseInt(a[0],10),e=parseInt(a[1],10),e>2&&0!==t?n.val("0"+t+" / "+e):n.val(""+a+" / ")})):void 0):void 0},s=function(e){var n,r,a;return r=String.fromCharCode(e.which),/^\d+$/.test(r)?(n=t(e.currentTarget),a=n.val(),/^\d\d$/.test(a)?n.val(""+a+" / "):void 0):void 0},c=function(e){var n,r,a;return a=String.fromCharCode(e.which),"/"===a||" "===a?(n=t(e.currentTarget),r=n.val(),/^\d$/.test(r)&&"0"!==r?n.val("0"+r+" / "):void 0):void 0},i=function(e){var n,r;return n=t(e.currentTarget),r=n.val(),8!==e.which||null!=n.prop("selectionStart")&&n.prop("selectionStart")!==r.length?void 0:/\d\s\/\s$/.test(r)?(e.preventDefault(),setTimeout(function(){return n.val(r.replace(/\d\s\/\s$/,""))})):void 0},g=function(e){var n;return n=t(e.currentTarget),setTimeout(function(){var t;return t=n.val(),t=m(t),t=t.replace(/\D/g,"").slice(0,4),$(t,n)})},w=function(t){var e;return t.metaKey||t.ctrlKey?!0:32===t.which?!1:0===t.which?!0:t.which<33?!0:(e=String.fromCharCode(t.which),!!/[\d\s]/.test(e))},C=function(n){var r,a,o,i;return r=t(n.currentTarget),o=String.fromCharCode(n.which),/^\d+$/.test(o)&&!h(r)?(i=(r.val()+o).replace(/\D/g,""),a=e(i),a?i.length<=a.length[a.length.length-1]:i.length<=16):void 0},T=function(e){var n,r,a;return n=t(e.currentTarget),r=String.fromCharCode(e.which),/^\d+$/.test(r)&&!h(n)?(a=n.val()+r,a=a.replace(/\D/g,""),a.length>6?!1:void 0):void 0},y=function(e){var n,r,a;return n=t(e.currentTarget),r=String.fromCharCode(e.which),/^\d+$/.test(r)&&!h(n)?(a=n.val()+r,a.length<=4):void 0},D=function(e){var n,a,o,i,l;return n=t(e.currentTarget),l=n.val(),i=t.payment.cardType(l)||"unknown",n.hasClass(i)?void 0:(a=function(){var t,e,n;for(n=[],t=0,e=r.length;e>t;t++)o=r[t],n.push(o.type);return n}(),n.removeClass("unknown"),n.removeClass(a.join(" ")),n.addClass(i),n.toggleClass("identified","unknown"!==i),n.trigger("payment.cardType",i))},t.payment.fn.formatCardCVC=function(){return this.on("keypress",w),this.on("keypress",y),this.on("paste",g),this.on("change",g),this.on("input",g),this},t.payment.fn.formatCardExpiry=function(){return this.on("keypress",w),this.on("keypress",T),this.on("keypress",u),this.on("keypress",c),this.on("keypress",s),this.on("keydown",i),this.on("change",f),this.on("input",f),this},t.payment.fn.formatCardNumber=function(){return this.on("keypress",w),this.on("keypress",C),this.on("keypress",l),this.on("keydown",o),this.on("keyup",D),this.on("paste",v),this.on("change",v),this.on("input",v),this.on("input",D),this},t.payment.fn.restrictNumeric=function(){return this.on("keypress",w),this.on("paste",d),this.on("change",d),this.on("input",d),this},t.payment.fn.cardExpiryVal=function(){return t.payment.cardExpiryVal(t(this).val())},t.payment.cardExpiryVal=function(t){var e,n,r,a;return a=t.split(/[\s\/]+/,2),e=a[0],r=a[1],2===(null!=r?r.length:void 0)&&/^\d+$/.test(r)&&(n=(new Date).getFullYear(),n=n.toString().slice(0,2),r=n+r),e=parseInt(e,10),r=parseInt(r,10),{month:e,year:r}},t.payment.validateCardNumber=function(t){var n,r;return t=(t+"").replace(/\s+|-/g,""),/^\d+$/.test(t)?(n=e(t),n?(r=t.length,k.call(n.length,r)>=0&&(n.luhn===!1||p(t))):!1):!1},t.payment.validateCardExpiry=function(e,n){var r,a,o;return"object"==typeof e&&"month"in e&&(o=e,e=o.month,n=o.year),e&&n?(e=t.trim(e),n=t.trim(n),/^\d+$/.test(e)&&/^\d+$/.test(n)&&e>=1&&12>=e?(2===n.length&&(n=70>n?"20"+n:"19"+n),4!==n.length?!1:(a=new Date(n,e),r=new Date,a.setMonth(a.getMonth()-1),a.setMonth(a.getMonth()+1,1),a>r)):!1):!1},t.payment.validateCardCVC=function(e,r){var a,o;return e=t.trim(e),/^\d+$/.test(e)?(a=n(r),null!=a?(o=e.length,k.call(a.cvcLength,o)>=0):e.length>=3&&e.length<=4):!1},t.payment.cardType=function(t){var n;return t?(null!=(n=e(t))?n.type:void 0)||null:null},t.payment.formatCardNumber=function(n){var r,a,o,i;return n=n.replace(/\D/g,""),(r=e(n))?(o=r.length[r.length.length-1],n=n.slice(0,o),r.format.global?null!=(i=n.match(r.format))?i.join(" "):void 0:(a=r.format.exec(n),null!=a?(a.shift(),a=t.grep(a,function(t){return t}),a.join(" ")):void 0)):n},t.payment.formatExpiry=function(t){var e,n,r,a;return(n=t.match(/^\D*(\d{1,2})(\D+)?(\d{1,4})?/))?(e=n[1]||"",r=n[2]||"",a=n[3]||"",a.length>0?r=" / ":" /"===r?(e=e.substring(0,1),r=""):2===e.length||r.length>0?r=" / ":1===e.length&&"0"!==e&&"1"!==e&&(e="0"+e,r=" / "),e+r+a):""}}).call(this);
/*! picturefill - v3.0.2 - 2016-02-12
 * https://scottjehl.github.io/picturefill/
 * Copyright (c) 2016 https://github.com/scottjehl/picturefill/blob/master/Authors.txt; Licensed MIT
 */
!function(a){var b=navigator.userAgent;a.HTMLPictureElement&&/ecko/.test(b)&&b.match(/rv\:(\d+)/)&&RegExp.$1<45&&addEventListener("resize",function(){var b,c=document.createElement("source"),d=function(a){var b,d,e=a.parentNode;"PICTURE"===e.nodeName.toUpperCase()?(b=c.cloneNode(),e.insertBefore(b,e.firstElementChild),setTimeout(function(){e.removeChild(b)})):(!a._pfLastSize||a.offsetWidth>a._pfLastSize)&&(a._pfLastSize=a.offsetWidth,d=a.sizes,a.sizes+=",100vw",setTimeout(function(){a.sizes=d}))},e=function(){var a,b=document.querySelectorAll("picture > img, img[srcset][sizes]");for(a=0;a<b.length;a++)d(b[a])},f=function(){clearTimeout(b),b=setTimeout(e,99)},g=a.matchMedia&&matchMedia("(orientation: landscape)"),h=function(){f(),g&&g.addListener&&g.addListener(f)};return c.srcset="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==",/^[c|i]|d$/.test(document.readyState||"")?h():document.addEventListener("DOMContentLoaded",h),f}())}(window),function(a,b,c){"use strict";function d(a){return" "===a||"	"===a||"\n"===a||"\f"===a||"\r"===a}function e(b,c){var d=new a.Image;return d.onerror=function(){A[b]=!1,ba()},d.onload=function(){A[b]=1===d.width,ba()},d.src=c,"pending"}function f(){M=!1,P=a.devicePixelRatio,N={},O={},s.DPR=P||1,Q.width=Math.max(a.innerWidth||0,z.clientWidth),Q.height=Math.max(a.innerHeight||0,z.clientHeight),Q.vw=Q.width/100,Q.vh=Q.height/100,r=[Q.height,Q.width,P].join("-"),Q.em=s.getEmValue(),Q.rem=Q.em}function g(a,b,c,d){var e,f,g,h;return"saveData"===B.algorithm?a>2.7?h=c+1:(f=b-c,e=Math.pow(a-.6,1.5),g=f*e,d&&(g+=.1*e),h=a+g):h=c>1?Math.sqrt(a*b):a,h>c}function h(a){var b,c=s.getSet(a),d=!1;"pending"!==c&&(d=r,c&&(b=s.setRes(c),s.applySetCandidate(b,a))),a[s.ns].evaled=d}function i(a,b){return a.res-b.res}function j(a,b,c){var d;return!c&&b&&(c=a[s.ns].sets,c=c&&c[c.length-1]),d=k(b,c),d&&(b=s.makeUrl(b),a[s.ns].curSrc=b,a[s.ns].curCan=d,d.res||aa(d,d.set.sizes)),d}function k(a,b){var c,d,e;if(a&&b)for(e=s.parseSet(b),a=s.makeUrl(a),c=0;c<e.length;c++)if(a===s.makeUrl(e[c].url)){d=e[c];break}return d}function l(a,b){var c,d,e,f,g=a.getElementsByTagName("source");for(c=0,d=g.length;d>c;c++)e=g[c],e[s.ns]=!0,f=e.getAttribute("srcset"),f&&b.push({srcset:f,media:e.getAttribute("media"),type:e.getAttribute("type"),sizes:e.getAttribute("sizes")})}function m(a,b){function c(b){var c,d=b.exec(a.substring(m));return d?(c=d[0],m+=c.length,c):void 0}function e(){var a,c,d,e,f,i,j,k,l,m=!1,o={};for(e=0;e<h.length;e++)f=h[e],i=f[f.length-1],j=f.substring(0,f.length-1),k=parseInt(j,10),l=parseFloat(j),X.test(j)&&"w"===i?((a||c)&&(m=!0),0===k?m=!0:a=k):Y.test(j)&&"x"===i?((a||c||d)&&(m=!0),0>l?m=!0:c=l):X.test(j)&&"h"===i?((d||c)&&(m=!0),0===k?m=!0:d=k):m=!0;m||(o.url=g,a&&(o.w=a),c&&(o.d=c),d&&(o.h=d),d||c||a||(o.d=1),1===o.d&&(b.has1x=!0),o.set=b,n.push(o))}function f(){for(c(T),i="",j="in descriptor";;){if(k=a.charAt(m),"in descriptor"===j)if(d(k))i&&(h.push(i),i="",j="after descriptor");else{if(","===k)return m+=1,i&&h.push(i),void e();if("("===k)i+=k,j="in parens";else{if(""===k)return i&&h.push(i),void e();i+=k}}else if("in parens"===j)if(")"===k)i+=k,j="in descriptor";else{if(""===k)return h.push(i),void e();i+=k}else if("after descriptor"===j)if(d(k));else{if(""===k)return void e();j="in descriptor",m-=1}m+=1}}for(var g,h,i,j,k,l=a.length,m=0,n=[];;){if(c(U),m>=l)return n;g=c(V),h=[],","===g.slice(-1)?(g=g.replace(W,""),e()):f()}}function n(a){function b(a){function b(){f&&(g.push(f),f="")}function c(){g[0]&&(h.push(g),g=[])}for(var e,f="",g=[],h=[],i=0,j=0,k=!1;;){if(e=a.charAt(j),""===e)return b(),c(),h;if(k){if("*"===e&&"/"===a[j+1]){k=!1,j+=2,b();continue}j+=1}else{if(d(e)){if(a.charAt(j-1)&&d(a.charAt(j-1))||!f){j+=1;continue}if(0===i){b(),j+=1;continue}e=" "}else if("("===e)i+=1;else if(")"===e)i-=1;else{if(","===e){b(),c(),j+=1;continue}if("/"===e&&"*"===a.charAt(j+1)){k=!0,j+=2;continue}}f+=e,j+=1}}}function c(a){return k.test(a)&&parseFloat(a)>=0?!0:l.test(a)?!0:"0"===a||"-0"===a||"+0"===a?!0:!1}var e,f,g,h,i,j,k=/^(?:[+-]?[0-9]+|[0-9]*\.[0-9]+)(?:[eE][+-]?[0-9]+)?(?:ch|cm|em|ex|in|mm|pc|pt|px|rem|vh|vmin|vmax|vw)$/i,l=/^calc\((?:[0-9a-z \.\+\-\*\/\(\)]+)\)$/i;for(f=b(a),g=f.length,e=0;g>e;e++)if(h=f[e],i=h[h.length-1],c(i)){if(j=i,h.pop(),0===h.length)return j;if(h=h.join(" "),s.matchesMedia(h))return j}return"100vw"}b.createElement("picture");var o,p,q,r,s={},t=!1,u=function(){},v=b.createElement("img"),w=v.getAttribute,x=v.setAttribute,y=v.removeAttribute,z=b.documentElement,A={},B={algorithm:""},C="data-pfsrc",D=C+"set",E=navigator.userAgent,F=/rident/.test(E)||/ecko/.test(E)&&E.match(/rv\:(\d+)/)&&RegExp.$1>35,G="currentSrc",H=/\s+\+?\d+(e\d+)?w/,I=/(\([^)]+\))?\s*(.+)/,J=a.picturefillCFG,K="position:absolute;left:0;visibility:hidden;display:block;padding:0;border:none;font-size:1em;width:1em;overflow:hidden;clip:rect(0px, 0px, 0px, 0px)",L="font-size:100%!important;",M=!0,N={},O={},P=a.devicePixelRatio,Q={px:1,"in":96},R=b.createElement("a"),S=!1,T=/^[ \t\n\r\u000c]+/,U=/^[, \t\n\r\u000c]+/,V=/^[^ \t\n\r\u000c]+/,W=/[,]+$/,X=/^\d+$/,Y=/^-?(?:[0-9]+|[0-9]*\.[0-9]+)(?:[eE][+-]?[0-9]+)?$/,Z=function(a,b,c,d){a.addEventListener?a.addEventListener(b,c,d||!1):a.attachEvent&&a.attachEvent("on"+b,c)},$=function(a){var b={};return function(c){return c in b||(b[c]=a(c)),b[c]}},_=function(){var a=/^([\d\.]+)(em|vw|px)$/,b=function(){for(var a=arguments,b=0,c=a[0];++b in a;)c=c.replace(a[b],a[++b]);return c},c=$(function(a){return"return "+b((a||"").toLowerCase(),/\band\b/g,"&&",/,/g,"||",/min-([a-z-\s]+):/g,"e.$1>=",/max-([a-z-\s]+):/g,"e.$1<=",/calc([^)]+)/g,"($1)",/(\d+[\.]*[\d]*)([a-z]+)/g,"($1 * e.$2)",/^(?!(e.[a-z]|[0-9\.&=|><\+\-\*\(\)\/])).*/gi,"")+";"});return function(b,d){var e;if(!(b in N))if(N[b]=!1,d&&(e=b.match(a)))N[b]=e[1]*Q[e[2]];else try{N[b]=new Function("e",c(b))(Q)}catch(f){}return N[b]}}(),aa=function(a,b){return a.w?(a.cWidth=s.calcListLength(b||"100vw"),a.res=a.w/a.cWidth):a.res=a.d,a},ba=function(a){if(t){var c,d,e,f=a||{};if(f.elements&&1===f.elements.nodeType&&("IMG"===f.elements.nodeName.toUpperCase()?f.elements=[f.elements]:(f.context=f.elements,f.elements=null)),c=f.elements||s.qsa(f.context||b,f.reevaluate||f.reselect?s.sel:s.selShort),e=c.length){for(s.setupRun(f),S=!0,d=0;e>d;d++)s.fillImg(c[d],f);s.teardownRun(f)}}};o=a.console&&console.warn?function(a){console.warn(a)}:u,G in v||(G="src"),A["image/jpeg"]=!0,A["image/gif"]=!0,A["image/png"]=!0,A["image/svg+xml"]=b.implementation.hasFeature("http://www.w3.org/TR/SVG11/feature#Image","1.1"),s.ns=("pf"+(new Date).getTime()).substr(0,9),s.supSrcset="srcset"in v,s.supSizes="sizes"in v,s.supPicture=!!a.HTMLPictureElement,s.supSrcset&&s.supPicture&&!s.supSizes&&!function(a){v.srcset="data:,a",a.src="data:,a",s.supSrcset=v.complete===a.complete,s.supPicture=s.supSrcset&&s.supPicture}(b.createElement("img")),s.supSrcset&&!s.supSizes?!function(){var a="data:image/gif;base64,R0lGODlhAgABAPAAAP///wAAACH5BAAAAAAALAAAAAACAAEAAAICBAoAOw==",c="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==",d=b.createElement("img"),e=function(){var a=d.width;2===a&&(s.supSizes=!0),q=s.supSrcset&&!s.supSizes,t=!0,setTimeout(ba)};d.onload=e,d.onerror=e,d.setAttribute("sizes","9px"),d.srcset=c+" 1w,"+a+" 9w",d.src=c}():t=!0,s.selShort="picture>img,img[srcset]",s.sel=s.selShort,s.cfg=B,s.DPR=P||1,s.u=Q,s.types=A,s.setSize=u,s.makeUrl=$(function(a){return R.href=a,R.href}),s.qsa=function(a,b){return"querySelector"in a?a.querySelectorAll(b):[]},s.matchesMedia=function(){return a.matchMedia&&(matchMedia("(min-width: 0.1em)")||{}).matches?s.matchesMedia=function(a){return!a||matchMedia(a).matches}:s.matchesMedia=s.mMQ,s.matchesMedia.apply(this,arguments)},s.mMQ=function(a){return a?_(a):!0},s.calcLength=function(a){var b=_(a,!0)||!1;return 0>b&&(b=!1),b},s.supportsType=function(a){return a?A[a]:!0},s.parseSize=$(function(a){var b=(a||"").match(I);return{media:b&&b[1],length:b&&b[2]}}),s.parseSet=function(a){return a.cands||(a.cands=m(a.srcset,a)),a.cands},s.getEmValue=function(){var a;if(!p&&(a=b.body)){var c=b.createElement("div"),d=z.style.cssText,e=a.style.cssText;c.style.cssText=K,z.style.cssText=L,a.style.cssText=L,a.appendChild(c),p=c.offsetWidth,a.removeChild(c),p=parseFloat(p,10),z.style.cssText=d,a.style.cssText=e}return p||16},s.calcListLength=function(a){if(!(a in O)||B.uT){var b=s.calcLength(n(a));O[a]=b?b:Q.width}return O[a]},s.setRes=function(a){var b;if(a){b=s.parseSet(a);for(var c=0,d=b.length;d>c;c++)aa(b[c],a.sizes)}return b},s.setRes.res=aa,s.applySetCandidate=function(a,b){if(a.length){var c,d,e,f,h,k,l,m,n,o=b[s.ns],p=s.DPR;if(k=o.curSrc||b[G],l=o.curCan||j(b,k,a[0].set),l&&l.set===a[0].set&&(n=F&&!b.complete&&l.res-.1>p,n||(l.cached=!0,l.res>=p&&(h=l))),!h)for(a.sort(i),f=a.length,h=a[f-1],d=0;f>d;d++)if(c=a[d],c.res>=p){e=d-1,h=a[e]&&(n||k!==s.makeUrl(c.url))&&g(a[e].res,c.res,p,a[e].cached)?a[e]:c;break}h&&(m=s.makeUrl(h.url),o.curSrc=m,o.curCan=h,m!==k&&s.setSrc(b,h),s.setSize(b))}},s.setSrc=function(a,b){var c;a.src=b.url,"image/svg+xml"===b.set.type&&(c=a.style.width,a.style.width=a.offsetWidth+1+"px",a.offsetWidth+1&&(a.style.width=c))},s.getSet=function(a){var b,c,d,e=!1,f=a[s.ns].sets;for(b=0;b<f.length&&!e;b++)if(c=f[b],c.srcset&&s.matchesMedia(c.media)&&(d=s.supportsType(c.type))){"pending"===d&&(c=d),e=c;break}return e},s.parseSets=function(a,b,d){var e,f,g,h,i=b&&"PICTURE"===b.nodeName.toUpperCase(),j=a[s.ns];(j.src===c||d.src)&&(j.src=w.call(a,"src"),j.src?x.call(a,C,j.src):y.call(a,C)),(j.srcset===c||d.srcset||!s.supSrcset||a.srcset)&&(e=w.call(a,"srcset"),j.srcset=e,h=!0),j.sets=[],i&&(j.pic=!0,l(b,j.sets)),j.srcset?(f={srcset:j.srcset,sizes:w.call(a,"sizes")},j.sets.push(f),g=(q||j.src)&&H.test(j.srcset||""),g||!j.src||k(j.src,f)||f.has1x||(f.srcset+=", "+j.src,f.cands.push({url:j.src,d:1,set:f}))):j.src&&j.sets.push({srcset:j.src,sizes:null}),j.curCan=null,j.curSrc=c,j.supported=!(i||f&&!s.supSrcset||g&&!s.supSizes),h&&s.supSrcset&&!j.supported&&(e?(x.call(a,D,e),a.srcset=""):y.call(a,D)),j.supported&&!j.srcset&&(!j.src&&a.src||a.src!==s.makeUrl(j.src))&&(null===j.src?a.removeAttribute("src"):a.src=j.src),j.parsed=!0},s.fillImg=function(a,b){var c,d=b.reselect||b.reevaluate;a[s.ns]||(a[s.ns]={}),c=a[s.ns],(d||c.evaled!==r)&&((!c.parsed||b.reevaluate)&&s.parseSets(a,a.parentNode,b),c.supported?c.evaled=r:h(a))},s.setupRun=function(){(!S||M||P!==a.devicePixelRatio)&&f()},s.supPicture?(ba=u,s.fillImg=u):!function(){var c,d=a.attachEvent?/d$|^c/:/d$|^c|^i/,e=function(){var a=b.readyState||"";f=setTimeout(e,"loading"===a?200:999),b.body&&(s.fillImgs(),c=c||d.test(a),c&&clearTimeout(f))},f=setTimeout(e,b.body?9:99),g=function(a,b){var c,d,e=function(){var f=new Date-d;b>f?c=setTimeout(e,b-f):(c=null,a())};return function(){d=new Date,c||(c=setTimeout(e,b))}},h=z.clientHeight,i=function(){M=Math.max(a.innerWidth||0,z.clientWidth)!==Q.width||z.clientHeight!==h,h=z.clientHeight,M&&s.fillImgs()};Z(a,"resize",g(i,99)),Z(b,"readystatechange",e)}(),s.picturefill=ba,s.fillImgs=ba,s.teardownRun=u,ba._=s,a.picturefillCFG={pf:s,push:function(a){var b=a.shift();"function"==typeof s[b]?s[b].apply(s,a):(B[b]=a[0],S&&s.fillImgs({reselect:!0}))}};for(;J&&J.length;)a.picturefillCFG.push(J.shift());a.picturefill=ba,"object"==typeof module&&"object"==typeof module.exports?module.exports=ba:"function"==typeof define&&define.amd&&define("picturefill",function(){return ba}),s.supPicture||(A["image/webp"]=e("image/webp","data:image/webp;base64,UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAABBxAR/Q9ERP8DAABWUDggGAAAADABAJ0BKgEAAQADADQlpAADcAD++/1QAA=="))}(window,document);
/* ------- Begin Common/WCAG/WCAG.js ------- */

$(document).ready(function () {
    /**
     * This function looks for all the ID on the current page, except for Vogue brand.
     * If there is any ID duplicated, it will change it.
     */
    if(!isVogue) {
        document.querySelectorAll('[id]').forEach(function (cur) {
            var ids = document.querySelectorAll('[id="' + cur.id + '"]');
            var labels = document.querySelectorAll('[for="' + cur.id + '"]');
            var curId = cur.id;
    
            if (ids.length > 1) {
                ids.forEach(function (cur, index) {
                    if (index !== 0) {
                        cur.setAttribute('id', curId + "_" + index);
                        console.debug('----------------------------------');
                        $('#' + curId).siblings().each(function() {
                            var hasComment = false;
                            $(this).contents().each(function() {                            
                                if (this.nodeType == 8) {
                                    var msg = '';
                                    if(this.nodeValue != null || this.nodeValue !=undefined) {
                                        msg = (this.nodeValue).trim();
                                    }
                                    if (msg.startsWith('Begin') || msg.startsWith('BEGIN')) {
                                        //This comment shows in which JSP/JSPF the duplicated id is
                                        console.debug('MCB ---> jsp/jspf: ' + this.nodeValue);
                                        hasComment = true;
                                        if(msg.includes('Content_UI')) {
                                            //This comment shows in which EMS the duplicated id is
                                            console.debug('MCB ---> EMS: ' + this.parentElement.id);
                                        }
                                        return false;
                                    }
                                }
                            });
                            if(hasComment) {
                                return false;
                            }
                        });
                        $('#' + curId).parents().each(function() {
                            var hasComment = false;
                            $(this).contents().each(function() {                            
                                if (this.nodeType == 8) {
                                    var msg = '';
                                    if(this.nodeValue != null || this.nodeValue !=undefined) {
                                        msg = (this.nodeValue).trim();
                                    }
                                    if (msg.startsWith('Begin') || msg.startsWith('BEGIN')) {
                                        //This comment shows in which JSP/JSPF the duplicated id is
                                        console.debug('MCB ---> jsp/jspf: ' + this.nodeValue);
                                        hasComment = true;
                                        if(msg.includes('Content_UI')) {
                                            //This comment shows in which EMS the duplicated id is
                                            console.debug('MCB ---> EMS: ' + this.parentElement.id);
                                        }
                                        return false;
                                    }
                                }
                            });
                            if(hasComment) {
                                return false;
                            }
                        });
                        //This comment shows the duplicated id                              
                        console.debug('MCB ---> ID duplicado: ' + curId);
                        console.debug('----------------------------------');
                    }
                });
            }

            //This code only affects at duplicated ids inside the for label's attribute
            if (labels.length > 1) {
                labels.forEach(function (cur, index) {
                    if (index !== 0) {
                        cur.setAttribute('for', curId + "_" + index);
                        console.debug('----------------------------------');
                        $('#' + curId).parents().each(function() {
                            var hasComment = false;
                            $(this).contents().each(function() {                            
                                if (this.nodeType == 8) {
                                    var msg = '';
                                    if(this.nodeValue != null || this.nodeValue !=undefined) msg = (this.nodeValue).trim();
                                    if (msg.startsWith('Begin') || msg.startsWith('BEGIN')) {
                                        //This comment shows in which JSP/JSPF the duplicated id is
                                        console.debug('MCB ---> jsp/jspf: ' + this.nodeValue);
                                        hasComment = true;
                                        if(msg.includes('Content_UI')) {
                                            //This comment shows in which EMS the duplicated id is
                                            console.debug('MCB ---> EMS: ' + this.parentElement.id);
                                        }
                                        return false;
                                    }
                                }
                            });
                            if(hasComment) {
                                return false;
                            }
                        });
                        //This comment shows the duplicated id                                
                        console.debug('MCB ---> FOR duplicado: ' + curId);
                        console.debug('----------------------------------');
                    }
                });
            }                       
        });
    }
});

$(window).on('load', function () {
    defautBehaviourOwlCarousel();
    clickOnElementWithEnter();
    closeElementOnEscape();

    $('.prop65__a').click(function() {
    	$('html').css('overflow', 'hidden');
        $('body').prepend($('#prop65__popup')[0]);
        $('#prop65__popup').addClass('display');
        $('.prop65__popup-wrapper *:focusable').first().focus();
    });
    
    $('.prop65__close').click(function() {
    	$('html').css('overflow', 'unset');
        $('#prop65__popup').removeClass('display');
    });
});

/**
 * This function change all tabindex inside a block of code from 0 to -1 or vice versa
 * 
 * @param {content} -  code block to change the tabindex of its elements
 */
function changeTabIndex(content) {
    $(content).find('*').each(function(){
        var attr = $(this).attr('tabindex');
        if(typeof attr !== typeof undefined && attr !== false) {
            if(attr === '0') {
                $(this).attr('tabindex', '-1').removeClass('focus');
            } else {
                $(this).attr('tabindex', '0').addClass('focus');
            }
        }
    });
}

/**
 * Function that adds a focus only with tab press
 */
function setFocusOnTab() {
    
    $(':focusable, *[tabindex]:not([tabindex="-1"]), button, a, .button_primary').keyup(function (e) {
        var key = e.which;
        if (key == 9) {
            $(this).addClass('focus');
            // console.log('Element with focus::' + document.activeElement.innerHTML);
        }
    }).blur(function () {
        $(this).removeClass('focus');
    });
}

/**
 * Function that make a click event on the focused element when you press enter
 */
function clickOnElementWithEnter() {
    $(':focusable, *[tabindex]:not([tabindex="-1"]), button, a').keyup(function (e) {
        var key = e.which;
        if (key == 13) {
            var isCatalogEntryRecom = $(this).parents('.catalogEntryRecommendationWidget').length > 0;
            var isAdd2Cart = $(this).is('#add2CartBtn');
            var isDropDownInput = $(this).find('*[role="option"]').length > 0;
            var attr = $(this).attr('href');

            if ($(this).is('[aria-describedby="quick_cart_container"] #cartDropdown') ||
                $(this).is('[aria-describedby="MiniShopCartProductAdded"] #cartDropdown')) {
                    e.preventDefault();
            }

            if(typeof attr !== typeof undefined && attr !== false) {
                window.location = $(this).attr('href');
            } else if (isCatalogEntryRecom && !(typeof attr !== typeof undefined && attr !== false)) {
                window.location = $(this).find('a').first().attr('href');
            } else if(isDropDownInput){
                $(this).click();
                $(prevElementClicked).focus();
            } else if(isAdd2Cart && isOliver) {
                $(this).click();
                productPageAdd2Cart();
                $('#MiniShopCartProductAdded #cartDropdown *:focusable').first().focus();
            } else {
                $(this).click();

            }                
            prevElementClicked = $(this);
            return false;
        }
    });
}

/**
 * This function set the focus in the first form error
 */
function moveToError() {
    $('.wcag__error:focusable').first().focus();
    // console.log("MCB :: enter in the function moveToError for WCAG.js");
}

/**
 * This function makes posible to close popups or hide them when the user press the ESC key
 */
function closeElementOnEscape(){
    $('*').keyup(function (e) {
        var key = e.which;
        if (key == 27) {
            $(".popup").removeClass("open");
            $(".popup").css("display","none");
            $(".panel.signInForm").addClass("hide");
        };
    }); 
}

/**
 * This function set the default carousel behaviour 
 * @param {carouselId} - this param is an element id but can be empty. If its not empty, the following behavior 
 *                       only affects to the element passed in this variable. If its empty, affects at all 
 *                       carousels that doesn't have carouselCMC class
 */

function defautBehaviourOwlCarousel(carouselId) {
    //previus element clicked
    var prevElementClicked = "";
    var carousel = '.owl-carousel:not(.carouselCMC) ';
    if(carouselId != null) {
        carousel = '#' + carouselId + ' ';
    }

    if(isVogue) {
        $('.nextPageButton, .prevPageButton').each(function () {
            $(this).attr("tabindex", "-1");
        });
    }

    /**
     * This function make all anchor tags inside owl-items no focusables except the first one 
     * to prevent a malfunction with the position of owl-carousel.
     */
    $(carousel + '.owl-item').each(function() {
        $(this).find('a').each(function(i) {
            var isCatalogEntryRecom = $(this).parents('.catalogEntryRecommendationWidget').length > 0;
            var isOPHomePageZone3Slider = isOliver && $(this).parents("#x-hp-zone3-slider").length > 0;
            var isOPCustomLenses = isOliver && $(this).find('.owl-custom-lenses__product').length > 0;

            if (i !== 0 && (isCatalogEntryRecom == true && isOPCustomLenses == false) && isOPHomePageZone3Slider == false) {
                $(this).attr("tabindex", "-1");
            }
            
            //this is a fix for Edge
            if (i !== 0) {
                $(this).css('display', 'block');
            }
        });
    });

    /**
     * This function make all anchor tags inside products in PLP no focusables except the first one.
     */
    if($('.plp').length > 0) {
        $('.product').each(function() {
            $(this).find('a').each(function(i) {
                if (i !== 0) {
                    $(this).attr("tabindex", "-1");
                }
            });
        });
    }

    /**
     * This function make all anchor tags focusables inside owl-items except inside in 
     * the catalog entry recommendation. OPCustomLenses is excluded.
     */
    $(carousel + '.owl-item a').focus(function () {
        var owlItem = $(this).parents('.owl-item');
        var isCatalogEntryRecom = $(this).parents('.catalogEntryRecommendationWidget').length > 0;
        var links = $(owlItem).find('a');
        var isOPCustomLenses = $(this).closest('.owl-custom-lenses__product').length > 0;    

        if (links[0] == $(this)[0] && links.length > 1 && isCatalogEntryRecom == false || (isCatalogEntryRecom == true && isOPCustomLenses == true)) {
            for (var x = 1; x < links.length; x++) {
                $(links[x]).attr("tabindex", "0")
            }
        }
    }).blur(function () {
        var owlItem = $(this).parents('.owl-item');
        var isCatalogEntryRecom = $(this).parents('.catalogEntryRecommendationWidget').length > 0;
        var isOPHomePageZone3Slider = $(this).parents("#x-hp-zone3-slider").length > 0;
        var links = $(owlItem).find('a');
        var owlItemLostFocus = true;

        if (links.length > 1 && isCatalogEntryRecom == false && isOPHomePageZone3Slider == false) {
            for (var i = 0; i < links.length; i++) {
                if ($(links[i]).is(':focus')) {
                    owlItemLostFocus = false;
                    break;
                }
            }
            if (owlItemLostFocus == true) {
                for (var x = 1; x < links.length; x++) {
                    $(links[x]).attr("tabindex", "-1")
                }
            }
        }
    });

    /**
     * This function set tabindex attribute to owl-items to make them focusable 
     * only if they haven't got a focusable link inside
     */
    $(carousel + ".owl-item").each(function () {
        var haveLink = $(this).find("a").length > 0;
        var isCatalogEntryRecom = $(this).parents('.catalogEntryRecommendationWidget').length > 0;
        // var isOPCustomLenses = $(this).find('.owl-custom-lenses__product').length > 0;

        if (haveLink === false && isCatalogEntryRecom == false) {
        // if (haveLink === false) {

            $(this).attr("tabindex", "0");
        }            
    });

    /**
     * This function catch the key pressed when the focus is inside the owl-carousel
     * and it makes navigable with cursor arrows
     */
    $(carousel).keyup(function (e) {
        e.preventDefault();
        var key = e.which;
        var isLink = $('a:focus').length > 0;
        var links = "";

        if (key == 37) {
            if (isLink) {
                links = $(':focus').parents('.owl-item').prev('.owl-item').find('a');
                $(links[0]).focus().addClass('focus');

            } else {
                $(':focus').prev('.owl-item').focus().addClass('focus');
            }
        } else if (key == 39) {
            if (isLink) {
                links = $(':focus').parents('.owl-item').next('.owl-item').find('a');
                $(links[0]).focus().addClass('focus');

            } else {
                $(':focus').next('.owl-item').focus().addClass('focus');
            }
        }
    });

    setFocusOnTab();

    /**
     * This function move the active owl-item to the owl-item focused only if the visible owl items are par
     */
    $(carousel + ".owl-item").focus(function () {
        var carousel = $(this).parents('.owl-carousel');
        var owl = carousel.data('owlCarousel');
        var visibleOwlItems = owl.visibleItems.length;

        if (visibleOwlItems % 2 == false) {
            owl.goTo($(this).index());
        }
    });
    
}
/* ------- END Common/WCAG/WCAG.js ------- */
/*
Copyright © 2013 Adobe Systems Incorporated.
Licensed under the Apache License, Version 2.0 (the “License”);
you may not use this file except in compliance with the License.
You may obtain a copy of the License at
http://www.apache.org/licenses/LICENSE-2.0
Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an “AS IS” BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/

/**
 * See <a href="http://jquery.com">http://jquery.com</a>.
 * @name jquery
 * @class
 * See the jQuery Library  (<a href="http://jquery.com">http://jquery.com</a>) for full details.  This just
 * documents the function and classes that are added to jQuery by this plug-in.
 */

/**
 * See <a href="http://jquery.com">http://jquery.com</a>
 * @name fn
 * @class
 * See the jQuery Library  (<a href="http://jquery.com">http://jquery.com</a>) for full details.  This just
 * documents the function and classes that are added to jQuery by this plug-in.
 * @memberOf jquery
 */

/**
 * @fileOverview accessibleMegaMenu plugin
 *
 *<p>Licensed under the Apache License, Version 2.0 (the “License”)
 *<br />Copyright © 2013 Adobe Systems Incorporated.
 *<br />Project page <a href="https://github.com/adobe-accessibility/Accessible-Mega-Menu">https://github.com/adobe-accessibility/Accessible-Mega-Menu</a>
 * @version 0.1
 * @author Michael Jordan
 * @requires jquery
 */

/*jslint browser: true, devel: true, plusplus: true, nomen: true */
/*global jQuery, window, document */
(function ($, window, document) {
    "use strict";
    var pluginName = "accessibleMegaMenu",
        defaults = {
            uuidPrefix: "accessible-megamenu", // unique ID's are required to indicate aria-owns, aria-controls and aria-labelledby
            menuClass: "accessible-megamenu", // default css class used to define the megamenu styling
            topNavItemClass: "accessible-megamenu-top-nav-item", // default css class for a top-level navigation item in the megamenu
            panelClass: "accessible-megamenu-panel", // default css class for a megamenu panel
            panelGroupClass: "accessible-megamenu-panel-group", // default css class for a group of items within a megamenu panel
            hoverClass: "hover", // default css class for the hover state
            focusClass: "focus", // default css class for the focus state
            openClass: "open", // default css class for the open state,
            toggleButtonClass: "accessible-megamenu-toggle", // default css class responsive toggle button
            openDelay: 0, // default open delay when opening menu via mouseover
            closeDelay: 250, // default open delay when opening menu via mouseover
            openOnMouseover: false // default setting for whether menu should open on mouseover
        },
        Keyboard = {
            BACKSPACE: 8,
            COMMA: 188,
            DELETE: 46,
            DOWN: 40,
            END: 35,
            ENTER: 13,
            ESCAPE: 27,
            HOME: 36,
            LEFT: 37,
            PAGE_DOWN: 34,
            PAGE_UP: 33,
            PERIOD: 190,
            RIGHT: 39,
            SPACE: 32,
            TAB: 9,
            UP: 38,
            keyMap: {
                48: "0",
                49: "1",
                50: "2",
                51: "3",
                52: "4",
                53: "5",
                54: "6",
                55: "7",
                56: "8",
                57: "9",
                59: ";",
                65: "a",
                66: "b",
                67: "c",
                68: "d",
                69: "e",
                70: "f",
                71: "g",
                72: "h",
                73: "i",
                74: "j",
                75: "k",
                76: "l",
                77: "m",
                78: "n",
                79: "o",
                80: "p",
                81: "q",
                82: "r",
                83: "s",
                84: "t",
                85: "u",
                86: "v",
                87: "w",
                88: "x",
                89: "y",
                90: "z",
                96: "0",
                97: "1",
                98: "2",
                99: "3",
                100: "4",
                101: "5",
                102: "6",
                103: "7",
                104: "8",
                105: "9",
                190: "."
            }
        },
        clearTimeout = window.clearTimeout,
        setTimeout = window.setTimeout,
        isOpera = window.opera && window.opera.toString() === '[object Opera]';
    /**
     * @desc Creates a new accessible mega menu instance.
     * @param {jquery} element
     * @param {object} [options] Mega Menu options
     * @param {string} [options.uuidPrefix=accessible-megamenu] - Prefix for generated unique id attributes, which are required to indicate aria-owns, aria-controls and aria-labelledby
     * @param {string} [options.menuClass=accessible-megamenu] - CSS class used to define the megamenu styling
     * @param {string} [options.topNavItemClass=accessible-megamenu-top-nav-item] - CSS class for a top-level navigation item in the megamenu
     * @param {string} [options.panelClass=accessible-megamenu-panel] - CSS class for a megamenu panel
     * @param {string} [options.panelGroupClass=accessible-megamenu-panel-group] - CSS class for a group of items within a megamenu panel
     * @param {string} [options.hoverClass=hover] - CSS class for the hover state
     * @param {string} [options.focusClass=focus] - CSS class for the focus state
     * @param {string} [options.openClass=open] - CSS class for the open state
     * @constructor
     */
    function AccessibleMegaMenu(element, options) {
        this.element = element;

        // merge optional settings and defaults into settings
        this.settings = $.extend({}, defaults, options);

        this._defaults = defaults;
        this._name = pluginName;

        this.mouseTimeoutID = null;
        this.focusTimeoutID = null;
        this.mouseFocused = false;
        this.justFocused = false;

        this.init();
    }

    AccessibleMegaMenu.prototype = (function () {

        /* private attributes and methods ------------------------ */
        var uuid = 0,
            keydownTimeoutDuration = 1000,
            keydownSearchString = "",
            isTouch = 'ontouchstart' in window || window.navigator.msMaxTouchPoints,
            _getPlugin,
            _addUniqueId,
            _togglePanel,
            _clickHandler,
            _touchmoveHandler,
            _clickOutsideHandler,
            _DOMAttrModifiedHandler,
            _focusInHandler,
            _focusOutHandler,
            _keyDownHandler,
            _mouseDownHandler,
            _mouseOverHandler,
            _mouseOutHandler,
            _clickToggleHandler,
            _toggleExpandedEventHandlers,
            _addEventHandlers,
            _removeEventHandlers;

        /**
         * @name jQuery.fn.accessibleMegaMenu~_getPlugin
         * @desc Returns the parent accessibleMegaMenu instance for a given element
         * @param {jQuery} element
         * @memberof jQuery.fn.accessibleMegaMenu
         * @inner
         * @private
         */
        _getPlugin = function (element) {
            return $(element).closest(':data(plugin_' + pluginName + ')').data("plugin_" + pluginName);
        };

        /**
         * @name jQuery.fn.accessibleMegaMenu~_addUniqueId
         * @desc Adds a unique id and element.
         * The id string starts with the
         * string defined in settings.uuidPrefix.
         * @param {jQuery} element
         * @memberof jQuery.fn.accessibleMegaMenu
         * @inner
         * @private
         */
        _addUniqueId = function (element) {
            element = $(element);
            var settings = this.settings;
            if (!element.attr("id")) {
                element.attr("id", settings.uuidPrefix + "-" + new Date().getTime() + "-" + (++uuid));
            }
        };

        /**
         * @name jQuery.fn.accessibleMegaMenu~_togglePanel
         * @desc Toggle the display of mega menu panels in response to an event.
         * The optional boolean value 'hide' forces all panels to hide.
         * @param {event} event
         * @param {Boolean} [hide] Hide all mega menu panels when true
         * @memberof jQuery.fn.accessibleMegaMenu
         * @inner
         * @private
         */
        _togglePanel = function (event, hide) {
            var target = $(event.target),
                that = this,
                settings = this.settings,
                menu = this.menu,
                topli = target.closest('.' + settings.topNavItemClass),
                panel = target.hasClass(settings.panelClass) ? target : target.closest('.' + settings.panelClass),
                newfocus;

            _toggleExpandedEventHandlers.call(this, true);

            if (hide) {
                topli = menu.find('.' + settings.topNavItemClass + ' .' + settings.openClass + ':first').closest('.' + settings.topNavItemClass);
                if (!(topli.is(event.relatedTarget) || topli.has(event.relatedTarget).length > 0)) {
                    if ((event.type === 'mouseout' || event.type === 'focusout') && topli.has(document.activeElement).length > 0) {
                        return;
                    }
                    topli.find('[aria-expanded]')
                        .attr('aria-expanded', 'false')
                        .removeClass(settings.openClass)
                        .filter('.' + settings.panelClass)
                        .attr('aria-hidden', 'true');
                    if ((event.type === 'keydown' && event.keyCode === Keyboard.ESCAPE) || event.type === 'DOMAttrModified') {
                        newfocus = topli.find(':tabbable:first');
                        setTimeout(function () {
                            menu.find('[aria-expanded].' + that.settings.panelClass).off('DOMAttrModified.accessible-megamenu');
                            newfocus.focus();
                            that.justFocused = false;
                        }, 99);
                    }
                } else if (topli.length === 0) {
                    menu.find('[aria-expanded=true]')
                        .attr('aria-expanded', 'false')
                        .removeClass(settings.openClass)
                        .filter('.' + settings.panelClass)
                        .attr('aria-hidden', 'true');
                }
            } else {
                clearTimeout(that.focusTimeoutID);
                topli.siblings()
                    .find('[aria-expanded]')
                    .attr('aria-expanded', 'false')
                    .removeClass(settings.openClass)
                    .filter('.' + settings.panelClass)
                    .attr('aria-hidden', 'true');
                topli.find('[aria-expanded]')
                    .attr('aria-expanded', 'true')
                    .addClass(settings.openClass)
                    .filter('.' + settings.panelClass)
                    .attr('aria-hidden', 'false');

                var pageScrollPosition = $('html')[0].scrollTop;
                var openPanelTopPosition = $('.' + settings.panelClass + '.' + settings.openClass).parent().offset().top;

                if(pageScrollPosition > openPanelTopPosition) {
                    $('html')[0].scrollTop = openPanelTopPosition;
                }

                if (event.type === 'mouseover' && target.is(':tabbable') && topli.length === 1 && panel.length === 0 && menu.has(document.activeElement).length > 0) {
                    target.focus();
                    that.justFocused = false;
                }

                _toggleExpandedEventHandlers.call(that);
            }
        };

        /**
         * @name jQuery.fn.accessibleMegaMenu~_clickHandler
         * @desc Handle click event on mega menu item
         * @param {event} Event object
         * @memberof jQuery.fn.accessibleMegaMenu
         * @inner
         * @private
         */
        _clickHandler = function (event) {
            var target = $(event.target).closest(':tabbable'),
                topli = target.closest('.' + this.settings.topNavItemClass),
                panel = target.closest('.' + this.settings.panelClass);
            if (topli.length === 1
                    && panel.length === 0
                    && topli.find('.' + this.settings.panelClass).length === 1) {
                if (!target.hasClass(this.settings.openClass)) {
                    event.preventDefault();
                    event.stopPropagation();
                    _togglePanel.call(this, event);
                    this.justFocused = false;
                } else {
                    if (this.justFocused) {
                        event.preventDefault();
                        event.stopPropagation();
                        this.justFocused = false;
                    } else if (isTouch || !isTouch && !this.settings.openOnMouseover) {
                        event.preventDefault();
                        event.stopPropagation();
                        _togglePanel.call(this, event, target.hasClass(this.settings.openClass));
                    }
                }
            }
        };

        /**
         * @name jQuery.fn.accessibleMegaMenu~_touchmoveHandler
         * @desc Handle touch move event on menu
         * @memberof jQuery.fn.accessibleMegaMenu
         * @inner
         * @private
         */
        _touchmoveHandler = function () {
            this.justMoved = true;
        };

        /**
         * @name jQuery.fn.accessibleMegaMenu~_clickOutsideHandler
         * @desc Handle click event outside of a the megamenu
         * @param {event} Event object
         * @memberof jQuery.fn.accessibleMegaMenu
         * @inner
         * @private
         */
        _clickOutsideHandler = function (event) {
            if ($(event.target).closest(this.menu).length === 0) {
                event.preventDefault();
                event.stopPropagation();
                _togglePanel.call(this, event, true);
            }
        };

        /**
         * @name jQuery.fn.accessibleMegaMenu~_DOMAttrModifiedHandler
         * @desc Handle DOMAttrModified event on panel to respond to Windows 8 Narrator ExpandCollapse pattern
         * @param {event} Event object
         * @memberof jQuery.fn.accessibleMegaMenu
         * @inner
         * @private
         */
        _DOMAttrModifiedHandler = function (event) {
            if (event.originalEvent.attrName === 'aria-expanded'
                    && event.originalEvent.newValue === 'false'
                    && $(event.target).hasClass(this.settings.openClass)) {
                event.preventDefault();
                event.stopPropagation();
                _togglePanel.call(this, event, true);
            }
        };

        /**
         * @name jQuery.fn.accessibleMegaMenu~_focusInHandler
         * @desc Handle focusin event on mega menu item.
         * @param {event} Event object
         * @memberof jQuery.fn.accessibleMegaMenu
         * @inner
         * @private
         */
        _focusInHandler = function (event) {
            clearTimeout(this.focusTimeoutID);
            var target = $(event.target),
                panel = target.closest('.' + this.settings.panelClass);
            target
                .addClass(this.settings.focusClass);
            this.justFocused = !this.mouseFocused || (!this.settings.openOnMouseover && this.mouseFocused);
            this.mouseFocused = false;
            if (this.justFocused && this.panels.not(panel).filter('.' + this.settings.openClass).length) {
                _togglePanel.call(this, event);
            }
        };

        /**
         * @name jQuery.fn.accessibleMegaMenu~_focusOutHandler
         * @desc Handle focusout event on mega menu item.
         * @param {event} Event object
         * @memberof jQuery.fn.accessibleMegaMenu
         * @inner
         * @private
         */
        _focusOutHandler = function (event) {
            this.justFocused = false;
            var that = this,
                target = $(event.target),
                topli = target.closest('.' + this.settings.topNavItemClass);
            target
                .removeClass(this.settings.focusClass);

            if (window.cvox) {
                // If ChromeVox is running...
                that.focusTimeoutID = setTimeout(function () {
                    window.cvox.Api.getCurrentNode(function (node) {
                        if (topli.has(node).length) {
                            // and the current node being voiced is in
                            // the mega menu, clearTimeout,
                            // so the panel stays open.
                            clearTimeout(that.focusTimeoutID);
                        } else {
                            that.focusTimeoutID = setTimeout(function (scope, event, hide) {
                                _togglePanel.call(scope, event, hide);
                            }, 275, that, event, true);
                        }
                    });
                }, 25);
            } else {
                that.focusTimeoutID = setTimeout(function () {
                    if (that.mouseFocused && event.relatedTarget === null) {
                        return;
                    }
                    _togglePanel.call(that, event, true);
                }, 300);
            }
        };

        /**
         * @name jQuery.fn.accessibleMegaMenu~_keyDownHandler
         * @desc Handle keydown event on mega menu.
         * @param {event} Event object
         * @memberof jQuery.fn.accessibleMegaMenu
         * @inner
         * @private
         */
        _keyDownHandler = function (event) {
            var that = (this.constructor === AccessibleMegaMenu) ? this : _getPlugin(this), // determine the AccessibleMegaMenu plugin instance
                settings = that.settings,
                target = $($(this).is('.' + settings.hoverClass + ':tabbable') ? this : event.target), // if the element is hovered the target is this, otherwise, its the focused element
                menu = that.menu,
                topnavitems = that.topnavitems,
                topli = target.closest('.' + settings.topNavItemClass),
                tabbables = menu.find(':tabbable'),
                panel = target.hasClass(settings.panelClass) ? target : target.closest('.' + settings.panelClass),
                panelGroups = panel.find('.' + settings.panelGroupClass),
                currentPanelGroup = target.closest('.' + settings.panelGroupClass),
                next,
                keycode = event.keyCode || event.which,
                start,
                i,
                o,
                label,
                found = false,
                newString = Keyboard.keyMap[event.keyCode] || '',
                regex,
                isTopNavItem = (topli.length === 1 && panel.length === 0);

            if (target.is("input:focus, select:focus, textarea:focus, button:focus")) {
                // if the event target is a form element we should handle keydown normally
                return;
            }

            if (target.is('.' + settings.hoverClass + ':tabbable')) {
                $('html').off('keydown.accessible-megamenu');
            }

            switch (keycode) {
            case Keyboard.ESCAPE:
                this.mouseFocused = false;
                _togglePanel.call(that, event, true);
                break;
            case Keyboard.DOWN:
                event.preventDefault();
                this.mouseFocused = false;
                if (isTopNavItem) {
                    _togglePanel.call(that, event);
                    found = (topli.find('.' + settings.panelClass + ' :tabbable:first').focus().length === 1);
                } else {
                    found = (tabbables.filter(':gt(' + tabbables.index(target) + '):first').focus().length === 1);
                }

                if (!found && isOpera && (event.ctrlKey || event.metaKey)) {
                    tabbables = $(':tabbable');
                    i = tabbables.index(target);
                    found = ($(':tabbable:gt(' + $(':tabbable').index(target) + '):first').focus().length === 1);
                }
                break;
            case Keyboard.UP:
                event.preventDefault();
                this.mouseFocused = false;
                if (isTopNavItem && target.hasClass(settings.openClass)) {
                    _togglePanel.call(that, event, true);
                    next = topnavitems.filter(':lt(' + topnavitems.index(topli) + '):last');
                    if (next.children('.' + settings.panelClass).length) {
                        found = (next.find('[aria-expanded]')
                            .attr('aria-expanded', 'true')
                            .addClass(settings.openClass)
                            .filter('.' + settings.panelClass)
                            .attr('aria-hidden', 'false')
                            .find(':tabbable:last')
                            .focus() === 1);
                    }
                } else if (!isTopNavItem) {
                    found = (tabbables.filter(':lt(' + tabbables.index(target) + '):last').focus().length === 1);
                }

                if (!found && isOpera && (event.ctrlKey || event.metaKey)) {
                    tabbables = $(':tabbable');
                    i = tabbables.index(target);
                    found = ($(':tabbable:lt(' + $(':tabbable').index(target) + '):first').focus().length === 1);
                }
                break;
            case Keyboard.RIGHT:
                event.preventDefault();
                this.mouseFocused = false;
                if (isTopNavItem) {
                    found = (topnavitems.filter(':gt(' + topnavitems.index(topli) + '):first').find(':tabbable:first').focus().length === 1);
                } else {
                    if (panelGroups.length && currentPanelGroup.length) {
                        // if the current panel contains panel groups, and we are able to focus the first tabbable element of the next panel group
                        found = (panelGroups.filter(':gt(' + panelGroups.index(currentPanelGroup) + '):first').find(':tabbable:first').focus().length === 1);
                    }

                    if (!found) {
                        found = (topli.find(':tabbable:first').focus().length === 1);
                    }
                }
                break;
            case Keyboard.LEFT:
                event.preventDefault();
                this.mouseFocused = false;
                if (isTopNavItem) {
                    found = (topnavitems.filter(':lt(' + topnavitems.index(topli) + '):last').find(':tabbable:first').focus().length === 1);
                } else {
                    if (panelGroups.length && currentPanelGroup.length) {
                        // if the current panel contains panel groups, and we are able to focus the first tabbable element of the previous panel group
                        found = (panelGroups.filter(':lt(' + panelGroups.index(currentPanelGroup) + '):last').find(':tabbable:first').focus().length === 1);
                    }

                    if (!found) {
                        found = (topli.find(':tabbable:first').focus().length === 1);
                    }
                }
                break;
            case Keyboard.TAB:
                this.mouseFocused = false;
                i = tabbables.index(target);
                if (event.shiftKey && isTopNavItem && target.hasClass(settings.openClass)) {
                    _togglePanel.call(that, event, true);
                    next = topnavitems.filter(':lt(' + topnavitems.index(topli) + '):last');
                    if (next.children('.' + settings.panelClass).length) {
                        found = next.children()
                            .attr('aria-expanded', 'true')
                            .addClass(settings.openClass)
                            .filter('.' + settings.panelClass)
                            .attr('aria-hidden', 'false')
                            .find(':tabbable:last')
                            .focus();
                    }
                } else if (event.shiftKey && i > 0) {
                    found = (tabbables.filter(':lt(' + i + '):last').focus().length === 1);
                } else if (!event.shiftKey && i < tabbables.length - 1) {
                    found = (tabbables.filter(':gt(' + i + '):first').focus().length === 1);
                } else if (isOpera) {
                    tabbables = $(':tabbable');
                    i = tabbables.index(target);
                    if (event.shiftKey) {
                        found = ($(':tabbable:lt(' + $(':tabbable').index(target) + '):last').focus().length === 1);
                    } else {
                        found = ($(':tabbable:gt(' + $(':tabbable').index(target) + '):first').focus().length === 1);
                    }
                }

                if (found) {
                    event.preventDefault();
                }
                break;
            case Keyboard.SPACE:
            case Keyboard.ENTER:
                if (isTopNavItem) {
                    event.preventDefault();
                    _clickHandler.call(that, event);
                } else {
                    return true;
                }
                break;
            default:
                // alphanumeric filter
                clearTimeout(this.keydownTimeoutID);

                keydownSearchString += newString !== keydownSearchString ? newString : '';

                if (keydownSearchString.length === 0) {
                    return;
                }

                this.keydownTimeoutID = setTimeout(function () {
                    keydownSearchString = '';
                }, keydownTimeoutDuration);

                if (isTopNavItem && !target.hasClass(settings.openClass)) {
                    tabbables = tabbables.filter(':not(.' + settings.panelClass + ' :tabbable)');
                } else {
                    tabbables = topli.find(':tabbable');
                }

                if (event.shiftKey) {
                    tabbables = $(tabbables.get()
                        .reverse());
                }

                for (i = 0; i < tabbables.length; i++) {
                    o = tabbables.eq(i);
                    if (o.is(target)) {
                        start = (keydownSearchString.length === 1) ? i + 1 : i;
                        break;
                    }
                }

                regex = new RegExp('^' + keydownSearchString.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, '\\$&'), 'i');

                for (i = start; i < tabbables.length; i++) {
                    o = tabbables.eq(i);
                    label = $.trim(o.text());
                    if (regex.test(label)) {
                        found = true;
                        o.focus();
                        break;
                    }
                }
                if (!found) {
                    for (i = 0; i < start; i++) {
                        o = tabbables.eq(i);
                        label = $.trim(o.text());
                        if (regex.test(label)) {
                            o.focus();
                            break;
                        }
                    }
                }
                break;
            }
            that.justFocused = false;
        };

        /**
         * @name jQuery.fn.accessibleMegaMenu~_mouseDownHandler
         * @desc Handle mousedown event on mega menu.
         * @param {event} Event object
         * @memberof accessibleMegaMenu
         * @inner
         * @private
         */
        _mouseDownHandler = function (event) {
            if ($(event.target).closest(this.settings.panelClass) || $(event.target).closest(":focusable").length) {
                this.mouseFocused = true;
                if ($(event.target).closest(this.settings.menuClass)) {
                    $('html').on('keydown.accessible-megamenu', $.proxy(_keyDownHandler, event.target));
                }
            }
            clearTimeout(this.mouseTimeoutID);
            this.mouseTimeoutID = setTimeout(function () {
                clearTimeout(this.focusTimeoutID);
            }, 1);
        };

        /**
         * @name jQuery.fn.accessibleMegaMenu~_mouseOverHandler
         * @desc Handle mouseover event on mega menu.
         * @param {event} Event object
         * @memberof jQuery.fn.accessibleMegaMenu
         * @inner
         * @private
         */
        _mouseOverHandler = function (event) {
            clearTimeout(this.mouseTimeoutID);
            var that = this;

            if (!that.settings.openOnMouseover) {
                return;
            }

            this.mouseTimeoutID = setTimeout(function () {
                $(event.target).addClass(that.settings.hoverClass);
                _togglePanel.call(that, event);
                if ($(event.target).closest(that.settings.menuClass)) {
                    $('html').on('keydown.accessible-megamenu', $.proxy(_keyDownHandler, event.target));
                }
            }, this.settings.openDelay);
        };

        /**
         * @name jQuery.fn.accessibleMegaMenu~_mouseOutHandler
         * @desc Handle mouseout event on mega menu.
         * @param {event} Event object
         * @memberof jQuery.fn.accessibleMegaMenu
         * @inner
         * @private
         */
        _mouseOutHandler = function (event) {
            clearTimeout(this.mouseTimeoutID);
            var that = this;

            if (!that.settings.openOnMouseover) {
                return;
            }

            $(event.target)
                .removeClass(that.settings.hoverClass);

            that.mouseTimeoutID = setTimeout(function () {
                _togglePanel.call(that, event, true);
            }, this.settings.closeDelay);
            if ($(event.target).is(':tabbable')) {
                $('html').off('keydown.accessible-megamenu');
            }
        };

        /**
         * @name jQuery.fn.accessibleMegaMenu~_clickToggleHandler
         * @desc Handle click event on menu toggle button.
         * @memberof jQuery.fn.accessibleMegaMenu
         * @inner
         * @private
         */
        _clickToggleHandler = function () {
            var isExpanded = this.toggleButton.attr('aria-expanded') === 'true';
            this.toggleButton.attr({'aria-expanded': !isExpanded, 'aria-pressed': !isExpanded});
        };

        _toggleExpandedEventHandlers = function (hide) {
            var menu = this.menu;
            if (hide) {
                $('html').off('mouseup.outside-accessible-megamenu, touchend.outside-accessible-megamenu, mspointerup.outside-accessible-megamenu,  pointerup.outside-accessible-megamenu');

                menu.find('[aria-expanded].' + this.settings.panelClass).off('DOMAttrModified.accessible-megamenu');
            } else {
                $('html').on('mouseup.outside-accessible-megamenu, touchend.outside-accessible-megamenu, mspointerup.outside-accessible-megamenu,  pointerup.outside-accessible-megamenu', $.proxy(_clickOutsideHandler, this));

                /* Narrator in Windows 8 automatically toggles the aria-expanded property on double tap or click.
                   To respond to the change to collapse the panel, we must add a listener for a DOMAttrModified event. */
                menu.find('[aria-expanded=true].' + this.settings.panelClass).on('DOMAttrModified.accessible-megamenu', $.proxy(_DOMAttrModifiedHandler, this));
            }
        };

        _addEventHandlers = function() {
            var menu = this.menu,
                toggleButton = this.toggleButton;
            menu.on("focusin.accessible-megamenu", ":focusable, ." + this.settings.panelClass, $.proxy(_focusInHandler, this))
                .on("focusout.accessible-megamenu", ":focusable, ." + this.settings.panelClass, $.proxy(_focusOutHandler, this))
                .on("keydown.accessible-megamenu", $.proxy(_keyDownHandler, this))
                .on("mouseover.accessible-megamenu", $.proxy(_mouseOverHandler, this))
                .on("mouseout.accessible-megamenu", $.proxy(_mouseOutHandler, this))
                .on("mousedown.accessible-megamenu", $.proxy(_mouseDownHandler, this))
                .on("click.accessible-megamenu", $.proxy(_clickHandler, this));

            toggleButton.on('click.accessible-megamenu', $.proxy(_clickToggleHandler, this));

            if (isTouch) {
                menu.on("touchmove.accessible-megamenu", $.proxy(_touchmoveHandler, this));
            }

            if ($(document.activeElement).closest(menu).length) {
              $(document.activeElement).trigger("focusin.accessible-megamenu");
            }
        };

        _removeEventHandlers = function () {
            var menu = this.menu,
                toggleButton = this.toggleButton;
            menu.off('.accessible-megamenu');
            if (menu.find('[aria-expanded=true].' + this.settings.panelClass).length) {
                _toggleExpandedEventHandlers.call(this, true);
            }

            toggleButton.off('.accessible-megamenu');
        };

        /* public attributes and methods ------------------------- */
        return {
            constructor: AccessibleMegaMenu,

            /**
             * @lends jQuery.fn.accessibleMegaMenu
             * @desc Initializes an instance of the accessibleMegaMenu plugins
             * @memberof jQuery.fn.accessibleMegaMenu
             * @instance
             */
            init: function () {
                var settings = this.settings,
                    nav = $(this.element),
                    menu = nav.children('ol,ul').first(),
                    topnavitems = menu.children(),
                    toggleButton = nav.children('button').first();
                this.start(settings, nav, menu, topnavitems, toggleButton);
            },

            start: function(settings, nav, menu, topnavitems, toggleButton) {
                var that = this;
                this.settings = settings;
                this.menu = menu;
                this.topnavitems = topnavitems;
                this.toggleButton = toggleButton;

                nav.attr("role", "navigation");
                _addUniqueId.call(that, menu);
                menu.addClass(settings.menuClass);
                menu.addClass(['js', settings.menuClass].join('-'));
                topnavitems.each(function (i, topnavitem) {
                    var topnavitemlink, topnavitempanel;
                    topnavitem = $(topnavitem);
                    topnavitem.addClass(settings.topNavItemClass);
                    topnavitemlink = topnavitem.find(":tabbable:first");
                    topnavitempanel = topnavitem.children(":not(:tabbable):last");
                    _addUniqueId.call(that, topnavitemlink);
                    if (topnavitempanel.length) {
                        _addUniqueId.call(that, topnavitempanel);
                        topnavitemlink.attr({
                            "role": "button",
                            "aria-controls": topnavitempanel.attr("id"),
                            "aria-expanded": false,
                            "tabindex": 0
                        });

                        topnavitempanel.attr({
                            "role": "region",
                            "aria-expanded": false,
                            "aria-hidden": true
                        })
                            .addClass(settings.panelClass)
                            .not("[aria-labelledby]")
                            .attr("aria-labelledby", topnavitemlink.attr("id"));
                    }
                });

                this.panels = menu.find("." + settings.panelClass);

                menu.find("hr").attr("role", "separator");

                toggleButton.addClass(settings.toggleButtonClass);
                toggleButton.attr({'aria-expanded': false, 'aria-pressed': false, 'aria-controls': menu.attr('id')});

                _addEventHandlers.call(this);
            },

            /**
             * @desc Removes maga menu javascript behavior
             * @example $(selector).accessibleMegaMenu("destroy");
             * @return {object}
             * @memberof jQuery.fn.accessibleMegaMenu
             * @instance
             */
            destroy: function () {
                this.menu.removeClass(['js', this.settings.menuClass].join('-'));
                _removeEventHandlers.call(this, true);
            },

            /**
             * @desc Get default values
             * @example $(selector).accessibleMegaMenu("getDefaults");
             * @return {object}
             * @memberof jQuery.fn.accessibleMegaMenu
             * @instance
             */
            getDefaults: function () {
                return this._defaults;
            },

            /**
             * @desc Get any option set to plugin using its name (as string)
             * @example $(selector).accessibleMegaMenu("getOption", some_option);
             * @param {string} opt
             * @return {string}
             * @memberof jQuery.fn.accessibleMegaMenu
             * @instance
             */
            getOption: function (opt) {
                return this.settings[opt];
            },

            /**
             * @desc Get all options
             * @example $(selector).accessibleMegaMenu("getAllOptions");
             * @return {object}
             * @memberof jQuery.fn.accessibleMegaMenu
             * @instance
             */
            getAllOptions: function () {
                return this.settings;
            },

            /**
             * @desc Set option
             * @example $(selector).accessibleMegaMenu("setOption", "option_name",  "option_value",  reinitialize);
             * @param {string} opt - Option name
             * @param {string} val - Option value
             * @param {boolean} [reinitialize] - boolean to re-initialize the menu.
             * @memberof jQuery.fn.accessibleMegaMenu
             * @instance
             */
            setOption: function (opt, value, reinitialize) {
                this.settings[opt] = value;
                if (reinitialize) {
                    this.init();
                }
            }
        };
    }());

    /* lightweight plugin wrapper around the constructor,
       to prevent against multiple instantiations */

    /**
     * @class accessibleMegaMenu
     * @memberOf jQuery.fn
     * @classdesc Implements an accessible mega menu as a jQuery plugin.
     * <p>The mega-menu It is modeled after the mega menu on {@link http://adobe.com|adobe.com} but has been simplified for use by others. A brief description of the interaction design choices can be found in a blog post at {@link http://blogs.adobe.com/accessibility/2013/05/adobe-com.html|Mega menu accessibility on adobe.com}.</p>
     * <h3>Keyboard Accessibility</h3>
     * <p>The accessible mega menu supports keyboard interaction modeled after the behavior described in the {@link http://www.w3.org/TR/wai-aria-practices/#menu|WAI-ARIA Menu or Menu bar (widget) design pattern}, however we also try to respect users' general expectations for the behavior of links in a global navigation. To this end, the accessible mega menu implementation permits tab focus on each of the six top-level menu items. When one of the menu items has focus, pressing the Enter key, Spacebar or Down arrow will open the submenu panel, and pressing the Left or Right arrow key will shift focus to the adjacent menu item. Links within the submenu panels are included in the tab order when the panel is open. They can also be navigated with the arrow keys or by typing the first character in the link name, which speeds up keyboard navigation considerably. Pressing the Escape key closes the submenu and restores focus to the parent menu item.</p>
     * <h3>Screen Reader Accessibility</h3>
     * <p>The accessible mega menu models its use of WAI-ARIA Roles, States, and Properties after those described in the {@link http://www.w3.org/TR/wai-aria-practices/#menu|WAI-ARIA Menu or Menu bar (widget) design pattern} with some notable exceptions, so that it behaves better with screen reader user expectations for global navigation. We don't use <code class="prettyprint prettyprinted" style=""><span class="pln">role</span><span class="pun">=</span><span class="str">"menu"</span></code> for the menu container and <code class="prettyprint prettyprinted" style=""><span class="pln">role</span><span class="pun">=</span><span class="str">"menuitem"</span></code> for each of the links therein, because if we do, assistive technology will no longer interpret the links as links, but instead, as menu items, and the links in our global navigation will no longer show up when a screen reader user executes a shortcut command to bring up a list of links in the page.</p>
     * @example <h4>HTML</h4><hr/>
&lt;nav&gt;
    &lt;ul class=&quot;nav-menu&quot;&gt;
        &lt;li class=&quot;nav-item&quot;&gt;
            &lt;a href=&quot;?movie&quot;&gt;Movies&lt;/a&gt;
            &lt;div class=&quot;sub-nav&quot;&gt;
                &lt;ul class=&quot;sub-nav-group&quot;&gt;
                    &lt;li&gt;&lt;a href=&quot;?movie&amp;genre=0&quot;&gt;Action &amp;amp; Adventure&lt;/a&gt;&lt;/li&gt;
                    &lt;li&gt;&lt;a href=&quot;?movie&amp;genre=2&quot;&gt;Children &amp;amp; Family&lt;/a&gt;&lt;/li&gt;
                    &lt;li&gt;&amp;#8230;&lt;/li&gt;
                &lt;/ul&gt;
                &lt;ul class=&quot;sub-nav-group&quot;&gt;
                    &lt;li&gt;&lt;a href=&quot;?movie&amp;genre=7&quot;&gt;Dramas&lt;/a&gt;&lt;/li&gt;
                    &lt;li&gt;&lt;a href=&quot;?movie&amp;genre=9&quot;&gt;Foreign&lt;/a&gt;&lt;/li&gt;
                    &lt;li&gt;&amp;#8230;&lt;/li&gt;
                &lt;/ul&gt;
                &lt;ul class=&quot;sub-nav-group&quot;&gt;
                    &lt;li&gt;&lt;a href=&quot;?movie&amp;genre=14&quot;&gt;Musicals&lt;/a&gt;&lt;/li&gt;
                    &lt;li&gt;&lt;a href=&quot;?movie&amp;genre=15&quot;&gt;Romance&lt;/a&gt;&lt;/li&gt;
                    &lt;li&gt;&amp;#8230;&lt;/li&gt;
                &lt;/ul&gt;
            &lt;/div&gt;
        &lt;/li&gt;
        &lt;li class=&quot;nav-item&quot;&gt;
            &lt;a href=&quot;?tv&quot;&gt;TV Shows&lt;/a&gt;
            &lt;div class=&quot;sub-nav&quot;&gt;
                &lt;ul class=&quot;sub-nav-group&quot;&gt;
                    &lt;li&gt;&lt;a href=&quot;?tv&amp;genre=20&quot;&gt;Classic TV&lt;/a&gt;&lt;/li&gt;
                    &lt;li&gt;&lt;a href=&quot;?tv&amp;genre=21&quot;&gt;Crime TV&lt;/a&gt;&lt;/li&gt;
                    &lt;li&gt;&amp;#8230;&lt;/li&gt;
                &lt;/ul&gt;
                &lt;ul class=&quot;sub-nav-group&quot;&gt;
                    &lt;li&gt;&lt;a href=&quot;?tv&amp;genre=27&quot;&gt;Reality TV&lt;/a&gt;&lt;/li&gt;
                    &lt;li&gt;&lt;a href=&quot;?tv&amp;genre=30&quot;&gt;TV Action&lt;/a&gt;&lt;/li&gt;
                    &lt;li&gt;&amp;#8230;&lt;/li&gt;
                &lt;/ul&gt;
                &lt;ul class=&quot;sub-nav-group&quot;&gt;
                    &lt;li&gt;&lt;a href=&quot;?tv&amp;genre=33&quot;&gt;TV Dramas&lt;/a&gt;&lt;/li&gt;
                    &lt;li&gt;&lt;a href=&quot;?tv&amp;genre=34&quot;&gt;TV Horror&lt;/a&gt;&lt;/li&gt;
                    &lt;li&gt;&amp;#8230;&lt;/li&gt;
                &lt;/ul&gt;
            &lt;/div&gt;
        &lt;/li&gt;
    &lt;/ul&gt;
&lt;/nav&gt;
     * @example <h4>CSS</h4><hr/>
&#47;* Rudimentary mega menu CSS for demonstration *&#47;
&#47;* mega menu list *&#47;
.nav-menu {
    display: block;
    position: relative;
    list-style: none;
    margin: 0;
    padding: 0;
    z-index: 15;
}
&#47;* a top level navigation item in the mega menu *&#47;
.nav-item {
    list-style: none;
    display: inline-block;
    padding: 0;
    margin: 0;
}
&#47;* first descendant link within a top level navigation item *&#47;
.nav-item &gt; a {
    position: relative;
    display: inline-block;
    padding: 0.5em 1em;
    margin: 0 0 -1px 0;
    border: 1px solid transparent;
}
&#47;* focus/open states of first descendant link within a top level
   navigation item *&#47;
.nav-item &gt; a:focus,
.nav-item &gt; a.open {
    border: 1px solid #dedede;
}
&#47;* open state of first descendant link within a top level
   navigation item *&#47;
.nav-item &gt; a.open {
    background-color: #fff;
    border-bottom: none;
    z-index: 1;
}
&#47;* sub-navigation panel *&#47;
.sub-nav {
    position: absolute;
    display: none;
    top: 2.2em;
    margin-top: -1px;
    padding: 0.5em 1em;
    border: 1px solid #dedede;
    background-color: #fff;
}
&#47;* sub-navigation panel open state *&#47;
.sub-nav.open {
    display: block;
}
&#47;* list of items within sub-navigation panel *&#47;
.sub-nav ul {
    display: inline-block;
    vertical-align: top;
    margin: 0 1em 0 0;
    padding: 0;
}
&#47;* list item within sub-navigation panel *&#47;
.sub-nav li {
    display: block;
    list-style-type: none;
    margin: 0;
    padding: 0;
}
     * @example <h4>JavaScript</h4><hr/>
&lt;!-- include jquery --&gt;
&lt;script src=&quot;http://code.jquery.com/jquery-1.10.1.min.js&quot;&gt;&lt;/script&gt;
&lt;!-- include the jquery-accessibleMegaMenu plugin script --&gt;
&lt;script src=&quot;js/jquery-accessibleMegaMenu.js&quot;&gt;&lt;/script&gt;
&lt;!-- initialize a selector as an accessibleMegaMenu --&gt;
&lt;script&gt;
    $(&quot;nav:first&quot;).accessibleMegaMenu({
        &#47;* prefix for generated unique id attributes, which are required to indicate aria-owns, aria-controls and aria-labelledby *&#47;
        uuidPrefix: &quot;accessible-megamenu&quot;,
        &#47;* css class used to define the megamenu styling *&#47;
        menuClass: &quot;nav-menu&quot;,
        &#47;* css class for a top-level navigation item in the megamenu *&#47;
        topNavItemClass: &quot;nav-item&quot;,
        &#47;* css class for a megamenu panel *&#47;
        panelClass: &quot;sub-nav&quot;,
        &#47;* css class for a group of items within a megamenu panel *&#47;
        panelGroupClass: &quot;sub-nav-group&quot;,
        &#47;* css class for the hover state *&#47;
        hoverClass: &quot;hover&quot;,
        &#47;* css class for the focus state *&#47;
        focusClass: &quot;focus&quot;,
        &#47;* css class for the open state *&#47;
        openClass: &quot;open&quot;
    });
&lt;/script&gt;
     * @param {object} [options] Mega Menu options
     * @param {string} [options.uuidPrefix=accessible-megamenu] - Prefix for generated unique id attributes, which are required to indicate aria-owns, aria-controls and aria-labelledby
     * @param {string} [options.menuClass=accessible-megamenu] - CSS class used to define the megamenu styling
     * @param {string} [options.topNavItemClass=accessible-megamenu-top-nav-item] - CSS class for a top-level navigation item in the megamenu
     * @param {string} [options.panelClass=accessible-megamenu-panel] - CSS class for a megamenu panel
     * @param {string} [options.panelGroupClass=accessible-megamenu-panel-group] - CSS class for a group of items within a megamenu panel
     * @param {string} [options.hoverClass=hover] - CSS class for the hover state
     * @param {string} [options.focusClass=focus] - CSS class for the focus state
     * @param {string} [options.openClass=open] - CSS class for the open state
     * @param {string} [options.openDelay=0] - Open delay when opening menu via mouseover
     * @param {string} [options.closeDelay=250] - Open delay when opening menu via mouseover
     * @param {boolean} [options.openOnMouseover=false] - Should menu open on mouseover
     */
    $.fn[pluginName] = function (options) {
        return this.each(function () {
            var pluginInstance = $.data(this, "plugin_" + pluginName);
            if (!pluginInstance) {
                $.data(this, "plugin_" + pluginName, new $.fn[pluginName].AccessibleMegaMenu(this, options));
            } else if (typeof pluginInstance[options] === 'function') {
                pluginInstance[options].apply(pluginInstance, Array.prototype.slice.call(arguments, 1));
            }
        });
    };

    $.fn[pluginName].AccessibleMegaMenu = AccessibleMegaMenu;

    /* :focusable and :tabbable selectors from
       https://raw.github.com/jquery/jquery-ui/master/ui/jquery.ui.core.js */

    /**
     * @private
     */
    function visible(element) {
        return $.expr.filters.visible(element) && !$(element).parents().addBack().filter(function () {
            return $.css(this, "visibility") === "hidden";
        }).length;
    }

    /**
     * @private
     */
    function focusable(element, isTabIndexNotNaN) {
        var map, mapName, img,
            nodeName = element.nodeName.toLowerCase();
        if ("area" === nodeName) {
            map = element.parentNode;
            mapName = map.name;
            if (!element.href || !mapName || map.nodeName.toLowerCase() !== "map") {
                return false;
            }
            img = $("img[usemap=#" + mapName + "]")[0];
            return !!img && visible(img);
        }
        return (/input|select|textarea|button|object/.test(nodeName) ? !element.disabled :
                "a" === nodeName ?
                        element.href || isTabIndexNotNaN :
                        isTabIndexNotNaN) &&
                            // the element and all of its ancestors must be visible
                            visible(element);
    }

    $.extend($.expr[":"], {
        data: $.expr.createPseudo ? $.expr.createPseudo(function (dataName) {
            return function (elem) {
                return !!$.data(elem, dataName);
            };
        }) : // support: jQuery <1.8
                function (elem, i, match) {
                    return !!$.data(elem, match[3]);
                },

        focusable: function (element) {
            return focusable(element, !isNaN($.attr(element, "tabindex")));
        },

        tabbable: function (element) {
            var tabIndex = $.attr(element, "tabindex"),
                isTabIndexNaN = isNaN(tabIndex);
            return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
        }
    });
}(jQuery, window, document));
/* @preserve
 * The MIT License (MIT)
 * 
 * Copyright (c) 2013-2018 Petka Antonov
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.  IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 * 
 */
/**
 * bluebird build version 3.5.5
 * Features enabled: core, race, call_get, generators, map, nodeify, promisify, props, reduce, settle, some, using, timers, filter, any, each
*/
!function(t){if("object"==typeof exports&&"undefined"!=typeof module)module.exports=t();else if("function"==typeof define&&define.amd)define([],t);else{var e;"undefined"!=typeof window?e=window:"undefined"!=typeof global?e=global:"undefined"!=typeof self&&(e=self),e.Promise=t()}}(function(){var t,e,n;return function r(t,e,n){function i(s,a){if(!e[s]){if(!t[s]){var c="function"==typeof _dereq_&&_dereq_;if(!a&&c)return c(s,!0);if(o)return o(s,!0);var l=new Error("Cannot find module '"+s+"'");throw l.code="MODULE_NOT_FOUND",l}var u=e[s]={exports:{}};t[s][0].call(u.exports,function(e){var n=t[s][1][e];return i(n?n:e)},u,u.exports,r,t,e,n)}return e[s].exports}for(var o="function"==typeof _dereq_&&_dereq_,s=0;s<n.length;s++)i(n[s]);return i}({1:[function(t,e,n){"use strict";e.exports=function(t){function e(t){var e=new n(t),r=e.promise();return e.setHowMany(1),e.setUnwrap(),e.init(),r}var n=t._SomePromiseArray;t.any=function(t){return e(t)},t.prototype.any=function(){return e(this)}}},{}],2:[function(t,e,n){"use strict";function r(){this._customScheduler=!1,this._isTickUsed=!1,this._lateQueue=new h(16),this._normalQueue=new h(16),this._haveDrainedQueues=!1,this._trampolineEnabled=!0;var t=this;this.drainQueues=function(){t._drainQueues()},this._schedule=p}function i(t,e,n){this._lateQueue.push(t,e,n),this._queueTick()}function o(t,e,n){this._normalQueue.push(t,e,n),this._queueTick()}function s(t){this._normalQueue._pushOne(t),this._queueTick()}function a(t){for(;t.length()>0;)c(t)}function c(t){var e=t.shift();if("function"!=typeof e)e._settlePromises();else{var n=t.shift(),r=t.shift();e.call(n,r)}}var l;try{throw new Error}catch(u){l=u}var p=t("./schedule"),h=t("./queue"),f=t("./util");r.prototype.setScheduler=function(t){var e=this._schedule;return this._schedule=t,this._customScheduler=!0,e},r.prototype.hasCustomScheduler=function(){return this._customScheduler},r.prototype.enableTrampoline=function(){this._trampolineEnabled=!0},r.prototype.disableTrampolineIfNecessary=function(){f.hasDevTools&&(this._trampolineEnabled=!1)},r.prototype.haveItemsQueued=function(){return this._isTickUsed||this._haveDrainedQueues},r.prototype.fatalError=function(t,e){e?(process.stderr.write("Fatal "+(t instanceof Error?t.stack:t)+"\n"),process.exit(2)):this.throwLater(t)},r.prototype.throwLater=function(t,e){if(1===arguments.length&&(e=t,t=function(){throw e}),"undefined"!=typeof setTimeout)setTimeout(function(){t(e)},0);else try{this._schedule(function(){t(e)})}catch(n){throw new Error("No async scheduler available\n\n    See http://goo.gl/MqrFmX\n")}},f.hasDevTools?(r.prototype.invokeLater=function(t,e,n){this._trampolineEnabled?i.call(this,t,e,n):this._schedule(function(){setTimeout(function(){t.call(e,n)},100)})},r.prototype.invoke=function(t,e,n){this._trampolineEnabled?o.call(this,t,e,n):this._schedule(function(){t.call(e,n)})},r.prototype.settlePromises=function(t){this._trampolineEnabled?s.call(this,t):this._schedule(function(){t._settlePromises()})}):(r.prototype.invokeLater=i,r.prototype.invoke=o,r.prototype.settlePromises=s),r.prototype._drainQueues=function(){a(this._normalQueue),this._reset(),this._haveDrainedQueues=!0,a(this._lateQueue)},r.prototype._queueTick=function(){this._isTickUsed||(this._isTickUsed=!0,this._schedule(this.drainQueues))},r.prototype._reset=function(){this._isTickUsed=!1},e.exports=r,e.exports.firstLineError=l},{"./queue":26,"./schedule":29,"./util":36}],3:[function(t,e,n){"use strict";e.exports=function(t,e,n,r){var i=!1,o=function(t,e){this._reject(e)},s=function(t,e){e.promiseRejectionQueued=!0,e.bindingPromise._then(o,o,null,this,t)},a=function(t,e){0===(50397184&this._bitField)&&this._resolveCallback(e.target)},c=function(t,e){e.promiseRejectionQueued||this._reject(t)};t.prototype.bind=function(o){i||(i=!0,t.prototype._propagateFrom=r.propagateFromFunction(),t.prototype._boundValue=r.boundValueFunction());var l=n(o),u=new t(e);u._propagateFrom(this,1);var p=this._target();if(u._setBoundTo(l),l instanceof t){var h={promiseRejectionQueued:!1,promise:u,target:p,bindingPromise:l};p._then(e,s,void 0,u,h),l._then(a,c,void 0,u,h),u._setOnCancel(l)}else u._resolveCallback(p);return u},t.prototype._setBoundTo=function(t){void 0!==t?(this._bitField=2097152|this._bitField,this._boundTo=t):this._bitField=-2097153&this._bitField},t.prototype._isBound=function(){return 2097152===(2097152&this._bitField)},t.bind=function(e,n){return t.resolve(n).bind(e)}}},{}],4:[function(t,e,n){"use strict";function r(){try{Promise===o&&(Promise=i)}catch(t){}return o}var i;"undefined"!=typeof Promise&&(i=Promise);var o=t("./promise")();o.noConflict=r,e.exports=o},{"./promise":22}],5:[function(t,e,n){"use strict";var r=Object.create;if(r){var i=r(null),o=r(null);i[" size"]=o[" size"]=0}e.exports=function(e){function n(t,n){var r;if(null!=t&&(r=t[n]),"function"!=typeof r){var i="Object "+a.classString(t)+" has no method '"+a.toString(n)+"'";throw new e.TypeError(i)}return r}function r(t){var e=this.pop(),r=n(t,e);return r.apply(t,this)}function i(t){return t[this]}function o(t){var e=+this;return 0>e&&(e=Math.max(0,e+t.length)),t[e]}var s,a=t("./util"),c=a.canEvaluate;a.isIdentifier;e.prototype.call=function(t){var e=[].slice.call(arguments,1);return e.push(t),this._then(r,void 0,void 0,e,void 0)},e.prototype.get=function(t){var e,n="number"==typeof t;if(n)e=o;else if(c){var r=s(t);e=null!==r?r:i}else e=i;return this._then(e,void 0,void 0,t,void 0)}}},{"./util":36}],6:[function(t,e,n){"use strict";e.exports=function(e,n,r,i){var o=t("./util"),s=o.tryCatch,a=o.errorObj,c=e._async;e.prototype["break"]=e.prototype.cancel=function(){if(!i.cancellation())return this._warn("cancellation is disabled");for(var t=this,e=t;t._isCancellable();){if(!t._cancelBy(e)){e._isFollowing()?e._followee().cancel():e._cancelBranched();break}var n=t._cancellationParent;if(null==n||!n._isCancellable()){t._isFollowing()?t._followee().cancel():t._cancelBranched();break}t._isFollowing()&&t._followee().cancel(),t._setWillBeCancelled(),e=t,t=n}},e.prototype._branchHasCancelled=function(){this._branchesRemainingToCancel--},e.prototype._enoughBranchesHaveCancelled=function(){return void 0===this._branchesRemainingToCancel||this._branchesRemainingToCancel<=0},e.prototype._cancelBy=function(t){return t===this?(this._branchesRemainingToCancel=0,this._invokeOnCancel(),!0):(this._branchHasCancelled(),this._enoughBranchesHaveCancelled()?(this._invokeOnCancel(),!0):!1)},e.prototype._cancelBranched=function(){this._enoughBranchesHaveCancelled()&&this._cancel()},e.prototype._cancel=function(){this._isCancellable()&&(this._setCancelled(),c.invoke(this._cancelPromises,this,void 0))},e.prototype._cancelPromises=function(){this._length()>0&&this._settlePromises()},e.prototype._unsetOnCancel=function(){this._onCancelField=void 0},e.prototype._isCancellable=function(){return this.isPending()&&!this._isCancelled()},e.prototype.isCancellable=function(){return this.isPending()&&!this.isCancelled()},e.prototype._doInvokeOnCancel=function(t,e){if(o.isArray(t))for(var n=0;n<t.length;++n)this._doInvokeOnCancel(t[n],e);else if(void 0!==t)if("function"==typeof t){if(!e){var r=s(t).call(this._boundValue());r===a&&(this._attachExtraTrace(r.e),c.throwLater(r.e))}}else t._resultCancelled(this)},e.prototype._invokeOnCancel=function(){var t=this._onCancel();this._unsetOnCancel(),c.invoke(this._doInvokeOnCancel,this,t)},e.prototype._invokeInternalOnCancel=function(){this._isCancellable()&&(this._doInvokeOnCancel(this._onCancel(),!0),this._unsetOnCancel())},e.prototype._resultCancelled=function(){this.cancel()}}},{"./util":36}],7:[function(t,e,n){"use strict";e.exports=function(e){function n(t,n,a){return function(c){var l=a._boundValue();t:for(var u=0;u<t.length;++u){var p=t[u];if(p===Error||null!=p&&p.prototype instanceof Error){if(c instanceof p)return o(n).call(l,c)}else if("function"==typeof p){var h=o(p).call(l,c);if(h===s)return h;if(h)return o(n).call(l,c)}else if(r.isObject(c)){for(var f=i(p),_=0;_<f.length;++_){var d=f[_];if(p[d]!=c[d])continue t}return o(n).call(l,c)}}return e}}var r=t("./util"),i=t("./es5").keys,o=r.tryCatch,s=r.errorObj;return n}},{"./es5":13,"./util":36}],8:[function(t,e,n){"use strict";e.exports=function(t){function e(){this._trace=new e.CapturedTrace(r())}function n(){return i?new e:void 0}function r(){var t=o.length-1;return t>=0?o[t]:void 0}var i=!1,o=[];return t.prototype._promiseCreated=function(){},t.prototype._pushContext=function(){},t.prototype._popContext=function(){return null},t._peekContext=t.prototype._peekContext=function(){},e.prototype._pushContext=function(){void 0!==this._trace&&(this._trace._promiseCreated=null,o.push(this._trace))},e.prototype._popContext=function(){if(void 0!==this._trace){var t=o.pop(),e=t._promiseCreated;return t._promiseCreated=null,e}return null},e.CapturedTrace=null,e.create=n,e.deactivateLongStackTraces=function(){},e.activateLongStackTraces=function(){var n=t.prototype._pushContext,o=t.prototype._popContext,s=t._peekContext,a=t.prototype._peekContext,c=t.prototype._promiseCreated;e.deactivateLongStackTraces=function(){t.prototype._pushContext=n,t.prototype._popContext=o,t._peekContext=s,t.prototype._peekContext=a,t.prototype._promiseCreated=c,i=!1},i=!0,t.prototype._pushContext=e.prototype._pushContext,t.prototype._popContext=e.prototype._popContext,t._peekContext=t.prototype._peekContext=r,t.prototype._promiseCreated=function(){var t=this._peekContext();t&&null==t._promiseCreated&&(t._promiseCreated=this)}},e}},{}],9:[function(t,e,n){"use strict";e.exports=function(e,n){function r(t,e){return{promise:e}}function i(){return!1}function o(t,e,n){var r=this;try{t(e,n,function(t){if("function"!=typeof t)throw new TypeError("onCancel must be a function, got: "+H.toString(t));r._attachCancellationCallback(t)})}catch(i){return i}}function s(t){if(!this._isCancellable())return this;var e=this._onCancel();void 0!==e?H.isArray(e)?e.push(t):this._setOnCancel([e,t]):this._setOnCancel(t)}function a(){return this._onCancelField}function c(t){this._onCancelField=t}function l(){this._cancellationParent=void 0,this._onCancelField=void 0}function u(t,e){if(0!==(1&e)){this._cancellationParent=t;var n=t._branchesRemainingToCancel;void 0===n&&(n=0),t._branchesRemainingToCancel=n+1}0!==(2&e)&&t._isBound()&&this._setBoundTo(t._boundTo)}function p(t,e){0!==(2&e)&&t._isBound()&&this._setBoundTo(t._boundTo)}function h(){var t=this._boundTo;return void 0!==t&&t instanceof e?t.isFulfilled()?t.value():void 0:t}function f(){this._trace=new O(this._peekContext())}function _(t,e){if(U(t)){var n=this._trace;if(void 0!==n&&e&&(n=n._parent),void 0!==n)n.attachExtraTrace(t);else if(!t.__stackCleaned__){var r=E(t);H.notEnumerableProp(t,"stack",r.message+"\n"+r.stack.join("\n")),H.notEnumerableProp(t,"__stackCleaned__",!0)}}}function d(){this._trace=void 0}function v(t,e,n,r,i){if(void 0===t&&null!==e&&J){if(void 0!==i&&i._returnedNonUndefined())return;if(0===(65535&r._bitField))return;n&&(n+=" ");var o="",s="";if(e._trace){for(var a=e._trace.stack.split("\n"),c=C(a),l=c.length-1;l>=0;--l){var u=c[l];if(!q.test(u)){var p=u.match($);p&&(o="at "+p[1]+":"+p[2]+":"+p[3]+" ");break}}if(c.length>0)for(var h=c[0],l=0;l<a.length;++l)if(a[l]===h){l>0&&(s="\n"+a[l-1]);break}}var f="a promise was created in a "+n+"handler "+o+"but was not returned from it, see http://goo.gl/rRqMUw"+s;r._warn(f,!0,e)}}function y(t,e){var n=t+" is deprecated and will be removed in a future version.";return e&&(n+=" Use "+e+" instead."),m(n)}function m(t,n,r){if(at.warnings){var i,o=new N(t);if(n)r._attachExtraTrace(o);else if(at.longStackTraces&&(i=e._peekContext()))i.attachExtraTrace(o);else{var s=E(o);o.stack=s.message+"\n"+s.stack.join("\n")}nt("warning",o)||k(o,"",!0)}}function g(t,e){for(var n=0;n<e.length-1;++n)e[n].push("From previous event:"),e[n]=e[n].join("\n");return n<e.length&&(e[n]=e[n].join("\n")),t+"\n"+e.join("\n")}function b(t){for(var e=0;e<t.length;++e)(0===t[e].length||e+1<t.length&&t[e][0]===t[e+1][0])&&(t.splice(e,1),e--)}function w(t){for(var e=t[0],n=1;n<t.length;++n){for(var r=t[n],i=e.length-1,o=e[i],s=-1,a=r.length-1;a>=0;--a)if(r[a]===o){s=a;break}for(var a=s;a>=0;--a){var c=r[a];if(e[i]!==c)break;e.pop(),i--}e=r}}function C(t){for(var e=[],n=0;n<t.length;++n){var r=t[n],i="    (No stack trace)"===r||Q.test(r),o=i&&it(r);i&&!o&&(z&&" "!==r.charAt(0)&&(r="    "+r),e.push(r))}return e}function j(t){for(var e=t.stack.replace(/\s+$/g,"").split("\n"),n=0;n<e.length;++n){var r=e[n];if("    (No stack trace)"===r||Q.test(r))break}return n>0&&"SyntaxError"!=t.name&&(e=e.slice(n)),e}function E(t){var e=t.stack,n=t.toString();return e="string"==typeof e&&e.length>0?j(t):["    (No stack trace)"],{message:n,stack:"SyntaxError"==t.name?e:C(e)}}function k(t,e,n){if("undefined"!=typeof console){var r;if(H.isObject(t)){var i=t.stack;r=e+G(i,t)}else r=e+String(t);"function"==typeof V?V(r,n):("function"==typeof console.log||"object"==typeof console.log)&&console.log(r)}}function F(t,e,n,r){var i=!1;try{"function"==typeof e&&(i=!0,"rejectionHandled"===t?e(r):e(n,r))}catch(o){L.throwLater(o)}"unhandledRejection"===t?nt(t,n,r)||i||k(n,"Unhandled rejection "):nt(t,r)}function T(t){var e;if("function"==typeof t)e="[function "+(t.name||"anonymous")+"]";else{e=t&&"function"==typeof t.toString?t.toString():H.toString(t);var n=/\[object [a-zA-Z0-9$_]+\]/;if(n.test(e))try{var r=JSON.stringify(t);e=r}catch(i){}0===e.length&&(e="(empty array)")}return"(<"+x(e)+">, no stack trace)"}function x(t){var e=41;return t.length<e?t:t.substr(0,e-3)+"..."}function P(){return"function"==typeof st}function S(t){var e=t.match(ot);return e?{fileName:e[1],line:parseInt(e[2],10)}:void 0}function R(t,e){if(P()){for(var n,r,i=(t.stack||"").split("\n"),o=(e.stack||"").split("\n"),s=-1,a=-1,c=0;c<i.length;++c){var l=S(i[c]);if(l){n=l.fileName,s=l.line;break}}for(var c=0;c<o.length;++c){var l=S(o[c]);if(l){r=l.fileName,a=l.line;break}}0>s||0>a||!n||!r||n!==r||s>=a||(it=function(t){if(M.test(t))return!0;var e=S(t);return e&&e.fileName===n&&s<=e.line&&e.line<=a?!0:!1})}}function O(t){this._parent=t,this._promisesCreated=0;var e=this._length=1+(void 0===t?0:t._length);st(this,O),e>32&&this.uncycle()}var A,D,V,I=e._getDomain,L=e._async,N=t("./errors").Warning,H=t("./util"),B=t("./es5"),U=H.canAttachTrace,M=/[\\\/]bluebird[\\\/]js[\\\/](release|debug|instrumented)/,q=/\((?:timers\.js):\d+:\d+\)/,$=/[\/<\(](.+?):(\d+):(\d+)\)?\s*$/,Q=null,G=null,z=!1,X=!(0==H.env("BLUEBIRD_DEBUG")||!H.env("BLUEBIRD_DEBUG")&&"development"!==H.env("NODE_ENV")),W=!(0==H.env("BLUEBIRD_WARNINGS")||!X&&!H.env("BLUEBIRD_WARNINGS")),K=!(0==H.env("BLUEBIRD_LONG_STACK_TRACES")||!X&&!H.env("BLUEBIRD_LONG_STACK_TRACES")),J=0!=H.env("BLUEBIRD_W_FORGOTTEN_RETURN")&&(W||!!H.env("BLUEBIRD_W_FORGOTTEN_RETURN"));e.prototype.suppressUnhandledRejections=function(){var t=this._target();t._bitField=-1048577&t._bitField|524288},e.prototype._ensurePossibleRejectionHandled=function(){if(0===(524288&this._bitField)){this._setRejectionIsUnhandled();var t=this;setTimeout(function(){t._notifyUnhandledRejection()},1)}},e.prototype._notifyUnhandledRejectionIsHandled=function(){F("rejectionHandled",A,void 0,this)},e.prototype._setReturnedNonUndefined=function(){this._bitField=268435456|this._bitField},e.prototype._returnedNonUndefined=function(){return 0!==(268435456&this._bitField)},e.prototype._notifyUnhandledRejection=function(){if(this._isRejectionUnhandled()){var t=this._settledValue();this._setUnhandledRejectionIsNotified(),F("unhandledRejection",D,t,this)}},e.prototype._setUnhandledRejectionIsNotified=function(){this._bitField=262144|this._bitField},e.prototype._unsetUnhandledRejectionIsNotified=function(){this._bitField=-262145&this._bitField},e.prototype._isUnhandledRejectionNotified=function(){return(262144&this._bitField)>0},e.prototype._setRejectionIsUnhandled=function(){this._bitField=1048576|this._bitField},e.prototype._unsetRejectionIsUnhandled=function(){this._bitField=-1048577&this._bitField,this._isUnhandledRejectionNotified()&&(this._unsetUnhandledRejectionIsNotified(),this._notifyUnhandledRejectionIsHandled())},e.prototype._isRejectionUnhandled=function(){return(1048576&this._bitField)>0},e.prototype._warn=function(t,e,n){return m(t,e,n||this)},e.onPossiblyUnhandledRejection=function(t){var e=I();D="function"==typeof t?null===e?t:H.domainBind(e,t):void 0},e.onUnhandledRejectionHandled=function(t){var e=I();A="function"==typeof t?null===e?t:H.domainBind(e,t):void 0};var Y=function(){};e.longStackTraces=function(){if(L.haveItemsQueued()&&!at.longStackTraces)throw new Error("cannot enable long stack traces after promises have been created\n\n    See http://goo.gl/MqrFmX\n");if(!at.longStackTraces&&P()){var t=e.prototype._captureStackTrace,r=e.prototype._attachExtraTrace,i=e.prototype._dereferenceTrace;at.longStackTraces=!0,Y=function(){if(L.haveItemsQueued()&&!at.longStackTraces)throw new Error("cannot enable long stack traces after promises have been created\n\n    See http://goo.gl/MqrFmX\n");e.prototype._captureStackTrace=t,e.prototype._attachExtraTrace=r,e.prototype._dereferenceTrace=i,n.deactivateLongStackTraces(),L.enableTrampoline(),at.longStackTraces=!1},e.prototype._captureStackTrace=f,e.prototype._attachExtraTrace=_,e.prototype._dereferenceTrace=d,n.activateLongStackTraces(),L.disableTrampolineIfNecessary()}},e.hasLongStackTraces=function(){return at.longStackTraces&&P()};var Z=function(){try{if("function"==typeof CustomEvent){var t=new CustomEvent("CustomEvent");return H.global.dispatchEvent(t),function(t,e){var n={detail:e,cancelable:!0};B.defineProperty(n,"promise",{value:e.promise}),B.defineProperty(n,"reason",{value:e.reason});var r=new CustomEvent(t.toLowerCase(),n);return!H.global.dispatchEvent(r)}}if("function"==typeof Event){var t=new Event("CustomEvent");return H.global.dispatchEvent(t),function(t,e){var n=new Event(t.toLowerCase(),{cancelable:!0});return n.detail=e,B.defineProperty(n,"promise",{value:e.promise}),B.defineProperty(n,"reason",{value:e.reason}),!H.global.dispatchEvent(n)}}var t=document.createEvent("CustomEvent");return t.initCustomEvent("testingtheevent",!1,!0,{}),H.global.dispatchEvent(t),function(t,e){var n=document.createEvent("CustomEvent");return n.initCustomEvent(t.toLowerCase(),!1,!0,e),!H.global.dispatchEvent(n)}}catch(e){}return function(){return!1}}(),tt=function(){return H.isNode?function(){return process.emit.apply(process,arguments)}:H.global?function(t){var e="on"+t.toLowerCase(),n=H.global[e];return n?(n.apply(H.global,[].slice.call(arguments,1)),!0):!1}:function(){return!1}}(),et={promiseCreated:r,promiseFulfilled:r,promiseRejected:r,promiseResolved:r,promiseCancelled:r,promiseChained:function(t,e,n){return{promise:e,child:n}},warning:function(t,e){return{warning:e}},unhandledRejection:function(t,e,n){return{reason:e,promise:n}},rejectionHandled:r},nt=function(t){var e=!1;try{e=tt.apply(null,arguments)}catch(n){L.throwLater(n),e=!0}var r=!1;try{r=Z(t,et[t].apply(null,arguments))}catch(n){L.throwLater(n),r=!0}return r||e};e.config=function(t){if(t=Object(t),"longStackTraces"in t&&(t.longStackTraces?e.longStackTraces():!t.longStackTraces&&e.hasLongStackTraces()&&Y()),"warnings"in t){var n=t.warnings;at.warnings=!!n,J=at.warnings,H.isObject(n)&&"wForgottenReturn"in n&&(J=!!n.wForgottenReturn)}if("cancellation"in t&&t.cancellation&&!at.cancellation){if(L.haveItemsQueued())throw new Error("cannot enable cancellation after promises are in use");e.prototype._clearCancellationData=l,e.prototype._propagateFrom=u,e.prototype._onCancel=a,e.prototype._setOnCancel=c,e.prototype._attachCancellationCallback=s,e.prototype._execute=o,rt=u,at.cancellation=!0}return"monitoring"in t&&(t.monitoring&&!at.monitoring?(at.monitoring=!0,e.prototype._fireEvent=nt):!t.monitoring&&at.monitoring&&(at.monitoring=!1,e.prototype._fireEvent=i)),e},e.prototype._fireEvent=i,e.prototype._execute=function(t,e,n){try{t(e,n)}catch(r){return r}},e.prototype._onCancel=function(){},e.prototype._setOnCancel=function(t){},e.prototype._attachCancellationCallback=function(t){},e.prototype._captureStackTrace=function(){},e.prototype._attachExtraTrace=function(){},e.prototype._dereferenceTrace=function(){},e.prototype._clearCancellationData=function(){},e.prototype._propagateFrom=function(t,e){};var rt=p,it=function(){return!1},ot=/[\/<\(]([^:\/]+):(\d+):(?:\d+)\)?\s*$/;H.inherits(O,Error),n.CapturedTrace=O,O.prototype.uncycle=function(){var t=this._length;if(!(2>t)){for(var e=[],n={},r=0,i=this;void 0!==i;++r)e.push(i),i=i._parent;t=this._length=r;for(var r=t-1;r>=0;--r){var o=e[r].stack;void 0===n[o]&&(n[o]=r)}for(var r=0;t>r;++r){var s=e[r].stack,a=n[s];if(void 0!==a&&a!==r){a>0&&(e[a-1]._parent=void 0,e[a-1]._length=1),e[r]._parent=void 0,e[r]._length=1;var c=r>0?e[r-1]:this;t-1>a?(c._parent=e[a+1],c._parent.uncycle(),c._length=c._parent._length+1):(c._parent=void 0,c._length=1);for(var l=c._length+1,u=r-2;u>=0;--u)e[u]._length=l,l++;return}}}},O.prototype.attachExtraTrace=function(t){if(!t.__stackCleaned__){this.uncycle();for(var e=E(t),n=e.message,r=[e.stack],i=this;void 0!==i;)r.push(C(i.stack.split("\n"))),i=i._parent;w(r),b(r),H.notEnumerableProp(t,"stack",g(n,r)),H.notEnumerableProp(t,"__stackCleaned__",!0)}};var st=function(){var t=/^\s*at\s*/,e=function(t,e){return"string"==typeof t?t:void 0!==e.name&&void 0!==e.message?e.toString():T(e)};if("number"==typeof Error.stackTraceLimit&&"function"==typeof Error.captureStackTrace){Error.stackTraceLimit+=6,Q=t,G=e;var n=Error.captureStackTrace;return it=function(t){return M.test(t)},function(t,e){Error.stackTraceLimit+=6,n(t,e),Error.stackTraceLimit-=6}}var r=new Error;if("string"==typeof r.stack&&r.stack.split("\n")[0].indexOf("stackDetection@")>=0)return Q=/@/,G=e,z=!0,function(t){t.stack=(new Error).stack};var i;try{throw new Error}catch(o){i="stack"in o}return"stack"in r||!i||"number"!=typeof Error.stackTraceLimit?(G=function(t,e){return"string"==typeof t?t:"object"!=typeof e&&"function"!=typeof e||void 0===e.name||void 0===e.message?T(e):e.toString()},null):(Q=t,G=e,function(t){Error.stackTraceLimit+=6;try{throw new Error}catch(e){t.stack=e.stack}Error.stackTraceLimit-=6})}([]);"undefined"!=typeof console&&"undefined"!=typeof console.warn&&(V=function(t){console.warn(t)},H.isNode&&process.stderr.isTTY?V=function(t,e){var n=e?"[33m":"[31m";console.warn(n+t+"[0m\n")}:H.isNode||"string"!=typeof(new Error).stack||(V=function(t,e){console.warn("%c"+t,e?"color: darkorange":"color: red")}));var at={warnings:W,longStackTraces:!1,cancellation:!1,monitoring:!1};return K&&e.longStackTraces(),{longStackTraces:function(){return at.longStackTraces},warnings:function(){return at.warnings},cancellation:function(){return at.cancellation},monitoring:function(){return at.monitoring},propagateFromFunction:function(){return rt},boundValueFunction:function(){return h},checkForgottenReturns:v,setBounds:R,warn:m,deprecated:y,CapturedTrace:O,fireDomEvent:Z,fireGlobalEvent:tt}}},{"./errors":12,"./es5":13,"./util":36}],10:[function(t,e,n){"use strict";e.exports=function(t){function e(){return this.value}function n(){throw this.reason}t.prototype["return"]=t.prototype.thenReturn=function(n){return n instanceof t&&n.suppressUnhandledRejections(),this._then(e,void 0,void 0,{value:n},void 0)},t.prototype["throw"]=t.prototype.thenThrow=function(t){return this._then(n,void 0,void 0,{reason:t},void 0)},t.prototype.catchThrow=function(t){if(arguments.length<=1)return this._then(void 0,n,void 0,{reason:t},void 0);var e=arguments[1],r=function(){throw e};return this.caught(t,r)},t.prototype.catchReturn=function(n){if(arguments.length<=1)return n instanceof t&&n.suppressUnhandledRejections(),this._then(void 0,e,void 0,{value:n},void 0);var r=arguments[1];r instanceof t&&r.suppressUnhandledRejections();var i=function(){return r};return this.caught(n,i)}}},{}],11:[function(t,e,n){"use strict";e.exports=function(t,e){function n(){return o(this)}function r(t,n){return i(t,n,e,e)}var i=t.reduce,o=t.all;t.prototype.each=function(t){return i(this,t,e,0)._then(n,void 0,void 0,this,void 0)},t.prototype.mapSeries=function(t){return i(this,t,e,e)},t.each=function(t,r){return i(t,r,e,0)._then(n,void 0,void 0,t,void 0)},t.mapSeries=r}},{}],12:[function(t,e,n){"use strict";function r(t,e){function n(r){return this instanceof n?(p(this,"message","string"==typeof r?r:e),p(this,"name",t),void(Error.captureStackTrace?Error.captureStackTrace(this,this.constructor):Error.call(this))):new n(r)}return u(n,Error),n}function i(t){return this instanceof i?(p(this,"name","OperationalError"),p(this,"message",t),this.cause=t,this.isOperational=!0,void(t instanceof Error?(p(this,"message",t.message),p(this,"stack",t.stack)):Error.captureStackTrace&&Error.captureStackTrace(this,this.constructor))):new i(t)}var o,s,a=t("./es5"),c=a.freeze,l=t("./util"),u=l.inherits,p=l.notEnumerableProp,h=r("Warning","warning"),f=r("CancellationError","cancellation error"),_=r("TimeoutError","timeout error"),d=r("AggregateError","aggregate error");try{o=TypeError,s=RangeError}catch(v){o=r("TypeError","type error"),s=r("RangeError","range error")}for(var y="join pop push shift unshift slice filter forEach some every map indexOf lastIndexOf reduce reduceRight sort reverse".split(" "),m=0;m<y.length;++m)"function"==typeof Array.prototype[y[m]]&&(d.prototype[y[m]]=Array.prototype[y[m]]);a.defineProperty(d.prototype,"length",{value:0,configurable:!1,writable:!0,enumerable:!0}),d.prototype.isOperational=!0;var g=0;d.prototype.toString=function(){var t=Array(4*g+1).join(" "),e="\n"+t+"AggregateError of:\n";g++,t=Array(4*g+1).join(" ");for(var n=0;n<this.length;++n){for(var r=this[n]===this?"[Circular AggregateError]":this[n]+"",i=r.split("\n"),o=0;o<i.length;++o)i[o]=t+i[o];r=i.join("\n"),e+=r+"\n"}return g--,e},u(i,Error);var b=Error.__BluebirdErrorTypes__;b||(b=c({CancellationError:f,TimeoutError:_,OperationalError:i,RejectionError:i,AggregateError:d}),a.defineProperty(Error,"__BluebirdErrorTypes__",{value:b,writable:!1,enumerable:!1,configurable:!1})),e.exports={Error:Error,TypeError:o,RangeError:s,CancellationError:b.CancellationError,OperationalError:b.OperationalError,TimeoutError:b.TimeoutError,AggregateError:b.AggregateError,Warning:h}},{"./es5":13,"./util":36}],13:[function(t,e,n){var r=function(){"use strict";return void 0===this}();if(r)e.exports={freeze:Object.freeze,defineProperty:Object.defineProperty,getDescriptor:Object.getOwnPropertyDescriptor,keys:Object.keys,names:Object.getOwnPropertyNames,getPrototypeOf:Object.getPrototypeOf,isArray:Array.isArray,isES5:r,propertyIsWritable:function(t,e){var n=Object.getOwnPropertyDescriptor(t,e);return!(n&&!n.writable&&!n.set)}};else{var i={}.hasOwnProperty,o={}.toString,s={}.constructor.prototype,a=function(t){var e=[];for(var n in t)i.call(t,n)&&e.push(n);return e},c=function(t,e){return{value:t[e]}},l=function(t,e,n){return t[e]=n.value,t},u=function(t){return t},p=function(t){try{return Object(t).constructor.prototype}catch(e){return s}},h=function(t){try{return"[object Array]"===o.call(t)}catch(e){return!1}};e.exports={isArray:h,keys:a,names:a,defineProperty:l,getDescriptor:c,freeze:u,getPrototypeOf:p,isES5:r,propertyIsWritable:function(){return!0}}}},{}],14:[function(t,e,n){"use strict";e.exports=function(t,e){var n=t.map;t.prototype.filter=function(t,r){return n(this,t,r,e)},t.filter=function(t,r,i){return n(t,r,i,e)}}},{}],15:[function(t,e,n){"use strict";e.exports=function(e,n,r){function i(t,e,n){this.promise=t,this.type=e,this.handler=n,this.called=!1,this.cancelPromise=null}function o(t){this.finallyHandler=t}function s(t,e){return null!=t.cancelPromise?(arguments.length>1?t.cancelPromise._reject(e):t.cancelPromise._cancel(),t.cancelPromise=null,!0):!1}function a(){return l.call(this,this.promise._target()._settledValue())}function c(t){return s(this,t)?void 0:(h.e=t,h)}function l(t){var i=this.promise,l=this.handler;if(!this.called){this.called=!0;var u=this.isFinallyHandler()?l.call(i._boundValue()):l.call(i._boundValue(),t);if(u===r)return u;if(void 0!==u){i._setReturnedNonUndefined();var f=n(u,i);if(f instanceof e){if(null!=this.cancelPromise){if(f._isCancelled()){var _=new p("late cancellation observer");return i._attachExtraTrace(_),h.e=_,h}f.isPending()&&f._attachCancellationCallback(new o(this))}return f._then(a,c,void 0,this,void 0)}}}return i.isRejected()?(s(this),h.e=t,h):(s(this),t)}var u=t("./util"),p=e.CancellationError,h=u.errorObj,f=t("./catch_filter")(r);return i.prototype.isFinallyHandler=function(){return 0===this.type},o.prototype._resultCancelled=function(){s(this.finallyHandler)},e.prototype._passThrough=function(t,e,n,r){return"function"!=typeof t?this.then():this._then(n,r,void 0,new i(this,e,t),void 0)},e.prototype.lastly=e.prototype["finally"]=function(t){return this._passThrough(t,0,l,l)},e.prototype.tap=function(t){return this._passThrough(t,1,l)},e.prototype.tapCatch=function(t){var n=arguments.length;if(1===n)return this._passThrough(t,1,void 0,l);var r,i=new Array(n-1),o=0;for(r=0;n-1>r;++r){var s=arguments[r];if(!u.isObject(s))return e.reject(new TypeError("tapCatch statement predicate: expecting an object but got "+u.classString(s)));i[o++]=s}i.length=o;var a=arguments[r];return this._passThrough(f(i,a,this),1,void 0,l)},i}},{"./catch_filter":7,"./util":36}],16:[function(t,e,n){"use strict";e.exports=function(e,n,r,i,o,s){function a(t,n,r){for(var o=0;o<n.length;++o){r._pushContext();var s=f(n[o])(t);if(r._popContext(),s===h){r._pushContext();var a=e.reject(h.e);return r._popContext(),a}var c=i(s,r);if(c instanceof e)return c}return null}function c(t,n,i,o){if(s.cancellation()){var a=new e(r),c=this._finallyPromise=new e(r);this._promise=a.lastly(function(){return c}),a._captureStackTrace(),a._setOnCancel(this)}else{var l=this._promise=new e(r);l._captureStackTrace()}this._stack=o,this._generatorFunction=t,this._receiver=n,this._generator=void 0,this._yieldHandlers="function"==typeof i?[i].concat(_):_,this._yieldedPromise=null,this._cancellationPhase=!1}var l=t("./errors"),u=l.TypeError,p=t("./util"),h=p.errorObj,f=p.tryCatch,_=[];p.inherits(c,o),c.prototype._isResolved=function(){return null===this._promise},c.prototype._cleanup=function(){this._promise=this._generator=null,s.cancellation()&&null!==this._finallyPromise&&(this._finallyPromise._fulfill(),this._finallyPromise=null)},c.prototype._promiseCancelled=function(){if(!this._isResolved()){var t,n="undefined"!=typeof this._generator["return"];if(n)this._promise._pushContext(),t=f(this._generator["return"]).call(this._generator,void 0),this._promise._popContext();else{var r=new e.CancellationError("generator .return() sentinel");e.coroutine.returnSentinel=r,this._promise._attachExtraTrace(r),this._promise._pushContext(),t=f(this._generator["throw"]).call(this._generator,r),this._promise._popContext()}this._cancellationPhase=!0,this._yieldedPromise=null,this._continue(t)}},c.prototype._promiseFulfilled=function(t){this._yieldedPromise=null,this._promise._pushContext();var e=f(this._generator.next).call(this._generator,t);this._promise._popContext(),this._continue(e)},c.prototype._promiseRejected=function(t){this._yieldedPromise=null,this._promise._attachExtraTrace(t),this._promise._pushContext();var e=f(this._generator["throw"]).call(this._generator,t);this._promise._popContext(),this._continue(e)},c.prototype._resultCancelled=function(){if(this._yieldedPromise instanceof e){var t=this._yieldedPromise;this._yieldedPromise=null,t.cancel()}},c.prototype.promise=function(){return this._promise},c.prototype._run=function(){this._generator=this._generatorFunction.call(this._receiver),this._receiver=this._generatorFunction=void 0,this._promiseFulfilled(void 0)},c.prototype._continue=function(t){var n=this._promise;if(t===h)return this._cleanup(),this._cancellationPhase?n.cancel():n._rejectCallback(t.e,!1);var r=t.value;if(t.done===!0)return this._cleanup(),this._cancellationPhase?n.cancel():n._resolveCallback(r);var o=i(r,this._promise);if(!(o instanceof e)&&(o=a(o,this._yieldHandlers,this._promise),
null===o))return void this._promiseRejected(new u("A value %s was yielded that could not be treated as a promise\n\n    See http://goo.gl/MqrFmX\n\n".replace("%s",String(r))+"From coroutine:\n"+this._stack.split("\n").slice(1,-7).join("\n")));o=o._target();var s=o._bitField;0===(50397184&s)?(this._yieldedPromise=o,o._proxy(this,null)):0!==(33554432&s)?e._async.invoke(this._promiseFulfilled,this,o._value()):0!==(16777216&s)?e._async.invoke(this._promiseRejected,this,o._reason()):this._promiseCancelled()},e.coroutine=function(t,e){if("function"!=typeof t)throw new u("generatorFunction must be a function\n\n    See http://goo.gl/MqrFmX\n");var n=Object(e).yieldHandler,r=c,i=(new Error).stack;return function(){var e=t.apply(this,arguments),o=new r(void 0,void 0,n,i),s=o.promise();return o._generator=e,o._promiseFulfilled(void 0),s}},e.coroutine.addYieldHandler=function(t){if("function"!=typeof t)throw new u("expecting a function but got "+p.classString(t));_.push(t)},e.spawn=function(t){if(s.deprecated("Promise.spawn()","Promise.coroutine()"),"function"!=typeof t)return n("generatorFunction must be a function\n\n    See http://goo.gl/MqrFmX\n");var r=new c(t,this),i=r.promise();return r._run(e.spawn),i}}},{"./errors":12,"./util":36}],17:[function(t,e,n){"use strict";e.exports=function(e,n,r,i,o,s){var a=t("./util");a.canEvaluate,a.tryCatch,a.errorObj;e.join=function(){var t,e=arguments.length-1;if(e>0&&"function"==typeof arguments[e]){t=arguments[e];var r}var i=[].slice.call(arguments);t&&i.pop();var r=new n(i).promise();return void 0!==t?r.spread(t):r}}},{"./util":36}],18:[function(t,e,n){"use strict";e.exports=function(e,n,r,i,o,s){function a(t,e,n,r){this.constructor$(t),this._promise._captureStackTrace();var i=l();this._callback=null===i?e:u.domainBind(i,e),this._preservedValues=r===o?new Array(this.length()):null,this._limit=n,this._inFlight=0,this._queue=[],f.invoke(this._asyncInit,this,void 0)}function c(t,n,i,o){if("function"!=typeof n)return r("expecting a function but got "+u.classString(n));var s=0;if(void 0!==i){if("object"!=typeof i||null===i)return e.reject(new TypeError("options argument must be an object but it is "+u.classString(i)));if("number"!=typeof i.concurrency)return e.reject(new TypeError("'concurrency' must be a number but it is "+u.classString(i.concurrency)));s=i.concurrency}return s="number"==typeof s&&isFinite(s)&&s>=1?s:0,new a(t,n,s,o).promise()}var l=e._getDomain,u=t("./util"),p=u.tryCatch,h=u.errorObj,f=e._async;u.inherits(a,n),a.prototype._asyncInit=function(){this._init$(void 0,-2)},a.prototype._init=function(){},a.prototype._promiseFulfilled=function(t,n){var r=this._values,o=this.length(),a=this._preservedValues,c=this._limit;if(0>n){if(n=-1*n-1,r[n]=t,c>=1&&(this._inFlight--,this._drainQueue(),this._isResolved()))return!0}else{if(c>=1&&this._inFlight>=c)return r[n]=t,this._queue.push(n),!1;null!==a&&(a[n]=t);var l=this._promise,u=this._callback,f=l._boundValue();l._pushContext();var _=p(u).call(f,t,n,o),d=l._popContext();if(s.checkForgottenReturns(_,d,null!==a?"Promise.filter":"Promise.map",l),_===h)return this._reject(_.e),!0;var v=i(_,this._promise);if(v instanceof e){v=v._target();var y=v._bitField;if(0===(50397184&y))return c>=1&&this._inFlight++,r[n]=v,v._proxy(this,-1*(n+1)),!1;if(0===(33554432&y))return 0!==(16777216&y)?(this._reject(v._reason()),!0):(this._cancel(),!0);_=v._value()}r[n]=_}var m=++this._totalResolved;return m>=o?(null!==a?this._filter(r,a):this._resolve(r),!0):!1},a.prototype._drainQueue=function(){for(var t=this._queue,e=this._limit,n=this._values;t.length>0&&this._inFlight<e;){if(this._isResolved())return;var r=t.pop();this._promiseFulfilled(n[r],r)}},a.prototype._filter=function(t,e){for(var n=e.length,r=new Array(n),i=0,o=0;n>o;++o)t[o]&&(r[i++]=e[o]);r.length=i,this._resolve(r)},a.prototype.preservedValues=function(){return this._preservedValues},e.prototype.map=function(t,e){return c(this,t,e,null)},e.map=function(t,e,n,r){return c(t,e,n,r)}}},{"./util":36}],19:[function(t,e,n){"use strict";e.exports=function(e,n,r,i,o){var s=t("./util"),a=s.tryCatch;e.method=function(t){if("function"!=typeof t)throw new e.TypeError("expecting a function but got "+s.classString(t));return function(){var r=new e(n);r._captureStackTrace(),r._pushContext();var i=a(t).apply(this,arguments),s=r._popContext();return o.checkForgottenReturns(i,s,"Promise.method",r),r._resolveFromSyncValue(i),r}},e.attempt=e["try"]=function(t){if("function"!=typeof t)return i("expecting a function but got "+s.classString(t));var r=new e(n);r._captureStackTrace(),r._pushContext();var c;if(arguments.length>1){o.deprecated("calling Promise.try with more than 1 argument");var l=arguments[1],u=arguments[2];c=s.isArray(l)?a(t).apply(u,l):a(t).call(u,l)}else c=a(t)();var p=r._popContext();return o.checkForgottenReturns(c,p,"Promise.try",r),r._resolveFromSyncValue(c),r},e.prototype._resolveFromSyncValue=function(t){t===s.errorObj?this._rejectCallback(t.e,!1):this._resolveCallback(t,!0)}}},{"./util":36}],20:[function(t,e,n){"use strict";function r(t){return t instanceof Error&&u.getPrototypeOf(t)===Error.prototype}function i(t){var e;if(r(t)){e=new l(t),e.name=t.name,e.message=t.message,e.stack=t.stack;for(var n=u.keys(t),i=0;i<n.length;++i){var o=n[i];p.test(o)||(e[o]=t[o])}return e}return s.markAsOriginatingFromRejection(t),t}function o(t,e){return function(n,r){if(null!==t){if(n){var o=i(a(n));t._attachExtraTrace(o),t._reject(o)}else if(e){var s=[].slice.call(arguments,1);t._fulfill(s)}else t._fulfill(r);t=null}}}var s=t("./util"),a=s.maybeWrapAsError,c=t("./errors"),l=c.OperationalError,u=t("./es5"),p=/^(?:name|message|stack|cause)$/;e.exports=o},{"./errors":12,"./es5":13,"./util":36}],21:[function(t,e,n){"use strict";e.exports=function(e){function n(t,e){var n=this;if(!o.isArray(t))return r.call(n,t,e);var i=a(e).apply(n._boundValue(),[null].concat(t));i===c&&s.throwLater(i.e)}function r(t,e){var n=this,r=n._boundValue(),i=void 0===t?a(e).call(r,null):a(e).call(r,null,t);i===c&&s.throwLater(i.e)}function i(t,e){var n=this;if(!t){var r=new Error(t+"");r.cause=t,t=r}var i=a(e).call(n._boundValue(),t);i===c&&s.throwLater(i.e)}var o=t("./util"),s=e._async,a=o.tryCatch,c=o.errorObj;e.prototype.asCallback=e.prototype.nodeify=function(t,e){if("function"==typeof t){var o=r;void 0!==e&&Object(e).spread&&(o=n),this._then(o,i,void 0,this,t)}return this}}},{"./util":36}],22:[function(t,e,n){"use strict";e.exports=function(){function n(){}function r(t,e){if(null==t||t.constructor!==i)throw new m("the promise constructor cannot be invoked directly\n\n    See http://goo.gl/MqrFmX\n");if("function"!=typeof e)throw new m("expecting a function but got "+f.classString(e))}function i(t){t!==b&&r(this,t),this._bitField=0,this._fulfillmentHandler0=void 0,this._rejectionHandler0=void 0,this._promise0=void 0,this._receiver0=void 0,this._resolveFromExecutor(t),this._promiseCreated(),this._fireEvent("promiseCreated",this)}function o(t){this.promise._resolveCallback(t)}function s(t){this.promise._rejectCallback(t,!1)}function a(t){var e=new i(b);e._fulfillmentHandler0=t,e._rejectionHandler0=t,e._promise0=t,e._receiver0=t}var c,l=function(){return new m("circular promise resolution chain\n\n    See http://goo.gl/MqrFmX\n")},u=function(){return new i.PromiseInspection(this._target())},p=function(t){return i.reject(new m(t))},h={},f=t("./util");c=f.isNode?function(){var t=process.domain;return void 0===t&&(t=null),t}:function(){return null},f.notEnumerableProp(i,"_getDomain",c);var _=t("./es5"),d=t("./async"),v=new d;_.defineProperty(i,"_async",{value:v});var y=t("./errors"),m=i.TypeError=y.TypeError;i.RangeError=y.RangeError;var g=i.CancellationError=y.CancellationError;i.TimeoutError=y.TimeoutError,i.OperationalError=y.OperationalError,i.RejectionError=y.OperationalError,i.AggregateError=y.AggregateError;var b=function(){},w={},C={},j=t("./thenables")(i,b),E=t("./promise_array")(i,b,j,p,n),k=t("./context")(i),F=k.create,T=t("./debuggability")(i,k),x=(T.CapturedTrace,t("./finally")(i,j,C)),P=t("./catch_filter")(C),S=t("./nodeback"),R=f.errorObj,O=f.tryCatch;return i.prototype.toString=function(){return"[object Promise]"},i.prototype.caught=i.prototype["catch"]=function(t){var e=arguments.length;if(e>1){var n,r=new Array(e-1),i=0;for(n=0;e-1>n;++n){var o=arguments[n];if(!f.isObject(o))return p("Catch statement predicate: expecting an object but got "+f.classString(o));r[i++]=o}if(r.length=i,t=arguments[n],"function"!=typeof t)throw new m("The last argument to .catch() must be a function, got "+f.toString(t));return this.then(void 0,P(r,t,this))}return this.then(void 0,t)},i.prototype.reflect=function(){return this._then(u,u,void 0,this,void 0)},i.prototype.then=function(t,e){if(T.warnings()&&arguments.length>0&&"function"!=typeof t&&"function"!=typeof e){var n=".then() only accepts functions but was passed: "+f.classString(t);arguments.length>1&&(n+=", "+f.classString(e)),this._warn(n)}return this._then(t,e,void 0,void 0,void 0)},i.prototype.done=function(t,e){var n=this._then(t,e,void 0,void 0,void 0);n._setIsFinal()},i.prototype.spread=function(t){return"function"!=typeof t?p("expecting a function but got "+f.classString(t)):this.all()._then(t,void 0,void 0,w,void 0)},i.prototype.toJSON=function(){var t={isFulfilled:!1,isRejected:!1,fulfillmentValue:void 0,rejectionReason:void 0};return this.isFulfilled()?(t.fulfillmentValue=this.value(),t.isFulfilled=!0):this.isRejected()&&(t.rejectionReason=this.reason(),t.isRejected=!0),t},i.prototype.all=function(){return arguments.length>0&&this._warn(".all() was passed arguments but it does not take any"),new E(this).promise()},i.prototype.error=function(t){return this.caught(f.originatesFromRejection,t)},i.getNewLibraryCopy=e.exports,i.is=function(t){return t instanceof i},i.fromNode=i.fromCallback=function(t){var e=new i(b);e._captureStackTrace();var n=arguments.length>1?!!Object(arguments[1]).multiArgs:!1,r=O(t)(S(e,n));return r===R&&e._rejectCallback(r.e,!0),e._isFateSealed()||e._setAsyncGuaranteed(),e},i.all=function(t){return new E(t).promise()},i.cast=function(t){var e=j(t);return e instanceof i||(e=new i(b),e._captureStackTrace(),e._setFulfilled(),e._rejectionHandler0=t),e},i.resolve=i.fulfilled=i.cast,i.reject=i.rejected=function(t){var e=new i(b);return e._captureStackTrace(),e._rejectCallback(t,!0),e},i.setScheduler=function(t){if("function"!=typeof t)throw new m("expecting a function but got "+f.classString(t));return v.setScheduler(t)},i.prototype._then=function(t,e,n,r,o){var s=void 0!==o,a=s?o:new i(b),l=this._target(),u=l._bitField;s||(a._propagateFrom(this,3),a._captureStackTrace(),void 0===r&&0!==(2097152&this._bitField)&&(r=0!==(50397184&u)?this._boundValue():l===this?void 0:this._boundTo),this._fireEvent("promiseChained",this,a));var p=c();if(0!==(50397184&u)){var h,_,d=l._settlePromiseCtx;0!==(33554432&u)?(_=l._rejectionHandler0,h=t):0!==(16777216&u)?(_=l._fulfillmentHandler0,h=e,l._unsetRejectionIsUnhandled()):(d=l._settlePromiseLateCancellationObserver,_=new g("late cancellation observer"),l._attachExtraTrace(_),h=e),v.invoke(d,l,{handler:null===p?h:"function"==typeof h&&f.domainBind(p,h),promise:a,receiver:r,value:_})}else l._addCallbacks(t,e,a,r,p);return a},i.prototype._length=function(){return 65535&this._bitField},i.prototype._isFateSealed=function(){return 0!==(117506048&this._bitField)},i.prototype._isFollowing=function(){return 67108864===(67108864&this._bitField)},i.prototype._setLength=function(t){this._bitField=-65536&this._bitField|65535&t},i.prototype._setFulfilled=function(){this._bitField=33554432|this._bitField,this._fireEvent("promiseFulfilled",this)},i.prototype._setRejected=function(){this._bitField=16777216|this._bitField,this._fireEvent("promiseRejected",this)},i.prototype._setFollowing=function(){this._bitField=67108864|this._bitField,this._fireEvent("promiseResolved",this)},i.prototype._setIsFinal=function(){this._bitField=4194304|this._bitField},i.prototype._isFinal=function(){return(4194304&this._bitField)>0},i.prototype._unsetCancelled=function(){this._bitField=-65537&this._bitField},i.prototype._setCancelled=function(){this._bitField=65536|this._bitField,this._fireEvent("promiseCancelled",this)},i.prototype._setWillBeCancelled=function(){this._bitField=8388608|this._bitField},i.prototype._setAsyncGuaranteed=function(){v.hasCustomScheduler()||(this._bitField=134217728|this._bitField)},i.prototype._receiverAt=function(t){var e=0===t?this._receiver0:this[4*t-4+3];return e===h?void 0:void 0===e&&this._isBound()?this._boundValue():e},i.prototype._promiseAt=function(t){return this[4*t-4+2]},i.prototype._fulfillmentHandlerAt=function(t){return this[4*t-4+0]},i.prototype._rejectionHandlerAt=function(t){return this[4*t-4+1]},i.prototype._boundValue=function(){},i.prototype._migrateCallback0=function(t){var e=(t._bitField,t._fulfillmentHandler0),n=t._rejectionHandler0,r=t._promise0,i=t._receiverAt(0);void 0===i&&(i=h),this._addCallbacks(e,n,r,i,null)},i.prototype._migrateCallbackAt=function(t,e){var n=t._fulfillmentHandlerAt(e),r=t._rejectionHandlerAt(e),i=t._promiseAt(e),o=t._receiverAt(e);void 0===o&&(o=h),this._addCallbacks(n,r,i,o,null)},i.prototype._addCallbacks=function(t,e,n,r,i){var o=this._length();if(o>=65531&&(o=0,this._setLength(0)),0===o)this._promise0=n,this._receiver0=r,"function"==typeof t&&(this._fulfillmentHandler0=null===i?t:f.domainBind(i,t)),"function"==typeof e&&(this._rejectionHandler0=null===i?e:f.domainBind(i,e));else{var s=4*o-4;this[s+2]=n,this[s+3]=r,"function"==typeof t&&(this[s+0]=null===i?t:f.domainBind(i,t)),"function"==typeof e&&(this[s+1]=null===i?e:f.domainBind(i,e))}return this._setLength(o+1),o},i.prototype._proxy=function(t,e){this._addCallbacks(void 0,void 0,e,t,null)},i.prototype._resolveCallback=function(t,e){if(0===(117506048&this._bitField)){if(t===this)return this._rejectCallback(l(),!1);var n=j(t,this);if(!(n instanceof i))return this._fulfill(t);e&&this._propagateFrom(n,2);var r=n._target();if(r===this)return void this._reject(l());var o=r._bitField;if(0===(50397184&o)){var s=this._length();s>0&&r._migrateCallback0(this);for(var a=1;s>a;++a)r._migrateCallbackAt(this,a);this._setFollowing(),this._setLength(0),this._setFollowee(r)}else if(0!==(33554432&o))this._fulfill(r._value());else if(0!==(16777216&o))this._reject(r._reason());else{var c=new g("late cancellation observer");r._attachExtraTrace(c),this._reject(c)}}},i.prototype._rejectCallback=function(t,e,n){var r=f.ensureErrorObject(t),i=r===t;if(!i&&!n&&T.warnings()){var o="a promise was rejected with a non-error: "+f.classString(t);this._warn(o,!0)}this._attachExtraTrace(r,e?i:!1),this._reject(t)},i.prototype._resolveFromExecutor=function(t){if(t!==b){var e=this;this._captureStackTrace(),this._pushContext();var n=!0,r=this._execute(t,function(t){e._resolveCallback(t)},function(t){e._rejectCallback(t,n)});n=!1,this._popContext(),void 0!==r&&e._rejectCallback(r,!0)}},i.prototype._settlePromiseFromHandler=function(t,e,n,r){var i=r._bitField;if(0===(65536&i)){r._pushContext();var o;e===w?n&&"number"==typeof n.length?o=O(t).apply(this._boundValue(),n):(o=R,o.e=new m("cannot .spread() a non-array: "+f.classString(n))):o=O(t).call(e,n);var s=r._popContext();i=r._bitField,0===(65536&i)&&(o===C?r._reject(n):o===R?r._rejectCallback(o.e,!1):(T.checkForgottenReturns(o,s,"",r,this),r._resolveCallback(o)))}},i.prototype._target=function(){for(var t=this;t._isFollowing();)t=t._followee();return t},i.prototype._followee=function(){return this._rejectionHandler0},i.prototype._setFollowee=function(t){this._rejectionHandler0=t},i.prototype._settlePromise=function(t,e,r,o){var s=t instanceof i,a=this._bitField,c=0!==(134217728&a);0!==(65536&a)?(s&&t._invokeInternalOnCancel(),r instanceof x&&r.isFinallyHandler()?(r.cancelPromise=t,O(e).call(r,o)===R&&t._reject(R.e)):e===u?t._fulfill(u.call(r)):r instanceof n?r._promiseCancelled(t):s||t instanceof E?t._cancel():r.cancel()):"function"==typeof e?s?(c&&t._setAsyncGuaranteed(),this._settlePromiseFromHandler(e,r,o,t)):e.call(r,o,t):r instanceof n?r._isResolved()||(0!==(33554432&a)?r._promiseFulfilled(o,t):r._promiseRejected(o,t)):s&&(c&&t._setAsyncGuaranteed(),0!==(33554432&a)?t._fulfill(o):t._reject(o))},i.prototype._settlePromiseLateCancellationObserver=function(t){var e=t.handler,n=t.promise,r=t.receiver,o=t.value;"function"==typeof e?n instanceof i?this._settlePromiseFromHandler(e,r,o,n):e.call(r,o,n):n instanceof i&&n._reject(o)},i.prototype._settlePromiseCtx=function(t){this._settlePromise(t.promise,t.handler,t.receiver,t.value)},i.prototype._settlePromise0=function(t,e,n){var r=this._promise0,i=this._receiverAt(0);this._promise0=void 0,this._receiver0=void 0,this._settlePromise(r,t,i,e)},i.prototype._clearCallbackDataAtIndex=function(t){var e=4*t-4;this[e+2]=this[e+3]=this[e+0]=this[e+1]=void 0},i.prototype._fulfill=function(t){var e=this._bitField;if(!((117506048&e)>>>16)){if(t===this){var n=l();return this._attachExtraTrace(n),this._reject(n)}this._setFulfilled(),this._rejectionHandler0=t,(65535&e)>0&&(0!==(134217728&e)?this._settlePromises():v.settlePromises(this),this._dereferenceTrace())}},i.prototype._reject=function(t){var e=this._bitField;if(!((117506048&e)>>>16))return this._setRejected(),this._fulfillmentHandler0=t,this._isFinal()?v.fatalError(t,f.isNode):void((65535&e)>0?v.settlePromises(this):this._ensurePossibleRejectionHandled())},i.prototype._fulfillPromises=function(t,e){for(var n=1;t>n;n++){var r=this._fulfillmentHandlerAt(n),i=this._promiseAt(n),o=this._receiverAt(n);this._clearCallbackDataAtIndex(n),this._settlePromise(i,r,o,e)}},i.prototype._rejectPromises=function(t,e){for(var n=1;t>n;n++){var r=this._rejectionHandlerAt(n),i=this._promiseAt(n),o=this._receiverAt(n);this._clearCallbackDataAtIndex(n),this._settlePromise(i,r,o,e)}},i.prototype._settlePromises=function(){var t=this._bitField,e=65535&t;if(e>0){if(0!==(16842752&t)){var n=this._fulfillmentHandler0;this._settlePromise0(this._rejectionHandler0,n,t),this._rejectPromises(e,n)}else{var r=this._rejectionHandler0;this._settlePromise0(this._fulfillmentHandler0,r,t),this._fulfillPromises(e,r)}this._setLength(0)}this._clearCancellationData()},i.prototype._settledValue=function(){var t=this._bitField;return 0!==(33554432&t)?this._rejectionHandler0:0!==(16777216&t)?this._fulfillmentHandler0:void 0},"undefined"!=typeof Symbol&&Symbol.toStringTag&&_.defineProperty(i.prototype,Symbol.toStringTag,{get:function(){return"Object"}}),i.defer=i.pending=function(){T.deprecated("Promise.defer","new Promise");var t=new i(b);return{promise:t,resolve:o,reject:s}},f.notEnumerableProp(i,"_makeSelfResolutionError",l),t("./method")(i,b,j,p,T),t("./bind")(i,b,j,T),t("./cancel")(i,E,p,T),t("./direct_resolve")(i),t("./synchronous_inspection")(i),t("./join")(i,E,j,b,v,c),i.Promise=i,i.version="3.5.5",t("./call_get.js")(i),t("./generators.js")(i,p,b,j,n,T),t("./map.js")(i,E,p,j,b,T),t("./nodeify.js")(i),t("./promisify.js")(i,b),t("./props.js")(i,E,j,p),t("./race.js")(i,b,j,p),t("./reduce.js")(i,E,p,j,b,T),t("./settle.js")(i,E,T),t("./some.js")(i,E,p),t("./timers.js")(i,b,T),t("./using.js")(i,p,j,F,b,T),t("./any.js")(i),t("./each.js")(i,b),t("./filter.js")(i,b),f.toFastProperties(i),f.toFastProperties(i.prototype),a({a:1}),a({b:2}),a({c:3}),a(1),a(function(){}),a(void 0),a(!1),a(new i(b)),T.setBounds(d.firstLineError,f.lastLineError),i}},{"./any.js":1,"./async":2,"./bind":3,"./call_get.js":5,"./cancel":6,"./catch_filter":7,"./context":8,"./debuggability":9,"./direct_resolve":10,"./each.js":11,"./errors":12,"./es5":13,"./filter.js":14,"./finally":15,"./generators.js":16,"./join":17,"./map.js":18,"./method":19,"./nodeback":20,"./nodeify.js":21,"./promise_array":23,"./promisify.js":24,"./props.js":25,"./race.js":27,"./reduce.js":28,"./settle.js":30,"./some.js":31,"./synchronous_inspection":32,"./thenables":33,"./timers.js":34,"./using.js":35,"./util":36}],23:[function(t,e,n){"use strict";e.exports=function(e,n,r,i,o){function s(t){switch(t){case-2:return[];case-3:return{};case-6:return new Map}}function a(t){var r=this._promise=new e(n);t instanceof e&&r._propagateFrom(t,3),r._setOnCancel(this),this._values=t,this._length=0,this._totalResolved=0,this._init(void 0,-2)}var c=t("./util");c.isArray;return c.inherits(a,o),a.prototype.length=function(){return this._length},a.prototype.promise=function(){return this._promise},a.prototype._init=function l(t,n){var o=r(this._values,this._promise);if(o instanceof e){o=o._target();var a=o._bitField;if(this._values=o,0===(50397184&a))return this._promise._setAsyncGuaranteed(),o._then(l,this._reject,void 0,this,n);if(0===(33554432&a))return 0!==(16777216&a)?this._reject(o._reason()):this._cancel();o=o._value()}if(o=c.asArray(o),null===o){var u=i("expecting an array or an iterable object but got "+c.classString(o)).reason();return void this._promise._rejectCallback(u,!1)}return 0===o.length?void(-5===n?this._resolveEmptyArray():this._resolve(s(n))):void this._iterate(o)},a.prototype._iterate=function(t){var n=this.getActualLength(t.length);this._length=n,this._values=this.shouldCopyValues()?new Array(n):this._values;for(var i=this._promise,o=!1,s=null,a=0;n>a;++a){var c=r(t[a],i);c instanceof e?(c=c._target(),s=c._bitField):s=null,o?null!==s&&c.suppressUnhandledRejections():null!==s?0===(50397184&s)?(c._proxy(this,a),this._values[a]=c):o=0!==(33554432&s)?this._promiseFulfilled(c._value(),a):0!==(16777216&s)?this._promiseRejected(c._reason(),a):this._promiseCancelled(a):o=this._promiseFulfilled(c,a)}o||i._setAsyncGuaranteed()},a.prototype._isResolved=function(){return null===this._values},a.prototype._resolve=function(t){this._values=null,this._promise._fulfill(t)},a.prototype._cancel=function(){!this._isResolved()&&this._promise._isCancellable()&&(this._values=null,this._promise._cancel())},a.prototype._reject=function(t){this._values=null,this._promise._rejectCallback(t,!1)},a.prototype._promiseFulfilled=function(t,e){this._values[e]=t;var n=++this._totalResolved;return n>=this._length?(this._resolve(this._values),!0):!1},a.prototype._promiseCancelled=function(){return this._cancel(),!0},a.prototype._promiseRejected=function(t){return this._totalResolved++,this._reject(t),!0},a.prototype._resultCancelled=function(){if(!this._isResolved()){var t=this._values;if(this._cancel(),t instanceof e)t.cancel();else for(var n=0;n<t.length;++n)t[n]instanceof e&&t[n].cancel()}},a.prototype.shouldCopyValues=function(){return!0},a.prototype.getActualLength=function(t){return t},a}},{"./util":36}],24:[function(t,e,n){"use strict";e.exports=function(e,n){function r(t){return!C.test(t)}function i(t){try{return t.__isPromisified__===!0}catch(e){return!1}}function o(t,e,n){var r=f.getDataPropertyOrDefault(t,e+n,b);return r?i(r):!1}function s(t,e,n){for(var r=0;r<t.length;r+=2){var i=t[r];if(n.test(i))for(var o=i.replace(n,""),s=0;s<t.length;s+=2)if(t[s]===o)throw new m("Cannot promisify an API that has normal methods with '%s'-suffix\n\n    See http://goo.gl/MqrFmX\n".replace("%s",e))}}function a(t,e,n,r){for(var a=f.inheritedDataKeys(t),c=[],l=0;l<a.length;++l){var u=a[l],p=t[u],h=r===j?!0:j(u,p,t);"function"!=typeof p||i(p)||o(t,u,e)||!r(u,p,t,h)||c.push(u,p)}return s(c,e,n),c}function c(t,r,i,o,s,a){function c(){var i=r;r===h&&(i=this);var o=new e(n);o._captureStackTrace();var s="string"==typeof u&&this!==l?this[u]:t,c=_(o,a);try{s.apply(i,d(arguments,c))}catch(p){o._rejectCallback(v(p),!0,!0)}return o._isFateSealed()||o._setAsyncGuaranteed(),o}var l=function(){return this}(),u=t;return"string"==typeof u&&(t=o),f.notEnumerableProp(c,"__isPromisified__",!0),c}function l(t,e,n,r,i){for(var o=new RegExp(E(e)+"$"),s=a(t,e,o,n),c=0,l=s.length;l>c;c+=2){var u=s[c],p=s[c+1],_=u+e;if(r===k)t[_]=k(u,h,u,p,e,i);else{var d=r(p,function(){return k(u,h,u,p,e,i)});f.notEnumerableProp(d,"__isPromisified__",!0),t[_]=d}}return f.toFastProperties(t),t}function u(t,e,n){return k(t,e,void 0,t,null,n)}var p,h={},f=t("./util"),_=t("./nodeback"),d=f.withAppended,v=f.maybeWrapAsError,y=f.canEvaluate,m=t("./errors").TypeError,g="Async",b={__isPromisified__:!0},w=["arity","length","name","arguments","caller","callee","prototype","__isPromisified__"],C=new RegExp("^(?:"+w.join("|")+")$"),j=function(t){return f.isIdentifier(t)&&"_"!==t.charAt(0)&&"constructor"!==t},E=function(t){return t.replace(/([$])/,"\\$")},k=y?p:c;e.promisify=function(t,e){if("function"!=typeof t)throw new m("expecting a function but got "+f.classString(t));if(i(t))return t;e=Object(e);var n=void 0===e.context?h:e.context,o=!!e.multiArgs,s=u(t,n,o);return f.copyDescriptors(t,s,r),s},e.promisifyAll=function(t,e){if("function"!=typeof t&&"object"!=typeof t)throw new m("the target of promisifyAll must be an object or a function\n\n    See http://goo.gl/MqrFmX\n");e=Object(e);var n=!!e.multiArgs,r=e.suffix;"string"!=typeof r&&(r=g);var i=e.filter;"function"!=typeof i&&(i=j);var o=e.promisifier;if("function"!=typeof o&&(o=k),!f.isIdentifier(r))throw new RangeError("suffix must be a valid identifier\n\n    See http://goo.gl/MqrFmX\n");for(var s=f.inheritedDataKeys(t),a=0;a<s.length;++a){var c=t[s[a]];"constructor"!==s[a]&&f.isClass(c)&&(l(c.prototype,r,i,o,n),l(c,r,i,o,n))}return l(t,r,i,o,n)}}},{"./errors":12,"./nodeback":20,"./util":36}],25:[function(t,e,n){"use strict";e.exports=function(e,n,r,i){function o(t){var e,n=!1;if(void 0!==a&&t instanceof a)e=p(t),n=!0;else{var r=u.keys(t),i=r.length;e=new Array(2*i);for(var o=0;i>o;++o){var s=r[o];e[o]=t[s],e[o+i]=s}}this.constructor$(e),this._isMap=n,this._init$(void 0,n?-6:-3)}function s(t){var n,s=r(t);return l(s)?(n=s instanceof e?s._then(e.props,void 0,void 0,void 0,void 0):new o(s).promise(),s instanceof e&&n._propagateFrom(s,2),n):i("cannot await properties of a non-object\n\n    See http://goo.gl/MqrFmX\n")}var a,c=t("./util"),l=c.isObject,u=t("./es5");"function"==typeof Map&&(a=Map);var p=function(){function t(t,r){this[e]=t,this[e+n]=r,e++}var e=0,n=0;return function(r){n=r.size,e=0;var i=new Array(2*r.size);return r.forEach(t,i),i}}(),h=function(t){for(var e=new a,n=t.length/2|0,r=0;n>r;++r){var i=t[n+r],o=t[r];e.set(i,o)}return e};c.inherits(o,n),o.prototype._init=function(){},o.prototype._promiseFulfilled=function(t,e){this._values[e]=t;var n=++this._totalResolved;if(n>=this._length){var r;if(this._isMap)r=h(this._values);else{r={};for(var i=this.length(),o=0,s=this.length();s>o;++o)r[this._values[o+i]]=this._values[o]}return this._resolve(r),!0}return!1},o.prototype.shouldCopyValues=function(){return!1},o.prototype.getActualLength=function(t){return t>>1},e.prototype.props=function(){return s(this)},e.props=function(t){return s(t)}}},{"./es5":13,"./util":36}],26:[function(t,e,n){"use strict";function r(t,e,n,r,i){for(var o=0;i>o;++o)n[o+r]=t[o+e],t[o+e]=void 0}function i(t){this._capacity=t,this._length=0,this._front=0}i.prototype._willBeOverCapacity=function(t){return this._capacity<t},i.prototype._pushOne=function(t){var e=this.length();this._checkCapacity(e+1);var n=this._front+e&this._capacity-1;this[n]=t,this._length=e+1},i.prototype.push=function(t,e,n){var r=this.length()+3;if(this._willBeOverCapacity(r))return this._pushOne(t),this._pushOne(e),void this._pushOne(n);var i=this._front+r-3;this._checkCapacity(r);var o=this._capacity-1;this[i+0&o]=t,this[i+1&o]=e,this[i+2&o]=n,this._length=r},i.prototype.shift=function(){var t=this._front,e=this[t];return this[t]=void 0,this._front=t+1&this._capacity-1,this._length--,e},i.prototype.length=function(){return this._length},i.prototype._checkCapacity=function(t){this._capacity<t&&this._resizeTo(this._capacity<<1)},i.prototype._resizeTo=function(t){var e=this._capacity;this._capacity=t;var n=this._front,i=this._length,o=n+i&e-1;r(this,0,this,e,o)},e.exports=i},{}],27:[function(t,e,n){"use strict";e.exports=function(e,n,r,i){function o(t,o){var c=r(t);if(c instanceof e)return a(c);if(t=s.asArray(t),null===t)return i("expecting an array or an iterable object but got "+s.classString(t));var l=new e(n);void 0!==o&&l._propagateFrom(o,3);for(var u=l._fulfill,p=l._reject,h=0,f=t.length;f>h;++h){var _=t[h];(void 0!==_||h in t)&&e.cast(_)._then(u,p,void 0,l,null)}return l}var s=t("./util"),a=function(t){return t.then(function(e){return o(e,t)})};e.race=function(t){return o(t,void 0)},e.prototype.race=function(){return o(this,void 0)}}},{"./util":36}],28:[function(t,e,n){"use strict";e.exports=function(e,n,r,i,o,s){function a(t,n,r,i){this.constructor$(t);var s=h();this._fn=null===s?n:f.domainBind(s,n),void 0!==r&&(r=e.resolve(r),r._attachCancellationCallback(this)),this._initialValue=r,this._currentCancellable=null,i===o?this._eachValues=Array(this._length):0===i?this._eachValues=null:this._eachValues=void 0,this._promise._captureStackTrace(),this._init$(void 0,-5)}function c(t,e){this.isFulfilled()?e._resolve(t):e._reject(t)}function l(t,e,n,i){if("function"!=typeof e)return r("expecting a function but got "+f.classString(e));var o=new a(t,e,n,i);return o.promise()}function u(t){this.accum=t,this.array._gotAccum(t);var n=i(this.value,this.array._promise);return n instanceof e?(this.array._currentCancellable=n,n._then(p,void 0,void 0,this,void 0)):p.call(this,n)}function p(t){var n=this.array,r=n._promise,i=_(n._fn);r._pushContext();var o;o=void 0!==n._eachValues?i.call(r._boundValue(),t,this.index,this.length):i.call(r._boundValue(),this.accum,t,this.index,this.length),o instanceof e&&(n._currentCancellable=o);var a=r._popContext();return s.checkForgottenReturns(o,a,void 0!==n._eachValues?"Promise.each":"Promise.reduce",r),o}var h=e._getDomain,f=t("./util"),_=f.tryCatch;f.inherits(a,n),a.prototype._gotAccum=function(t){void 0!==this._eachValues&&null!==this._eachValues&&t!==o&&this._eachValues.push(t)},a.prototype._eachComplete=function(t){return null!==this._eachValues&&this._eachValues.push(t),this._eachValues},a.prototype._init=function(){},a.prototype._resolveEmptyArray=function(){this._resolve(void 0!==this._eachValues?this._eachValues:this._initialValue)},a.prototype.shouldCopyValues=function(){return!1},a.prototype._resolve=function(t){this._promise._resolveCallback(t),this._values=null},a.prototype._resultCancelled=function(t){return t===this._initialValue?this._cancel():void(this._isResolved()||(this._resultCancelled$(),this._currentCancellable instanceof e&&this._currentCancellable.cancel(),this._initialValue instanceof e&&this._initialValue.cancel()))},a.prototype._iterate=function(t){this._values=t;var n,r,i=t.length;if(void 0!==this._initialValue?(n=this._initialValue,r=0):(n=e.resolve(t[0]),r=1),this._currentCancellable=n,!n.isRejected())for(;i>r;++r){var o={accum:null,value:t[r],index:r,length:i,array:this};n=n._then(u,void 0,void 0,o,void 0)}void 0!==this._eachValues&&(n=n._then(this._eachComplete,void 0,void 0,this,void 0)),n._then(c,c,void 0,n,this)},e.prototype.reduce=function(t,e){return l(this,t,e,null)},e.reduce=function(t,e,n,r){return l(t,e,n,r)}}},{"./util":36}],29:[function(t,e,n){"use strict";var r,i=t("./util"),o=function(){throw new Error("No async scheduler available\n\n    See http://goo.gl/MqrFmX\n")},s=i.getNativePromise();if(i.isNode&&"undefined"==typeof MutationObserver){var a=global.setImmediate,c=process.nextTick;r=i.isRecentNode?function(t){a.call(global,t)}:function(t){c.call(process,t)}}else if("function"==typeof s&&"function"==typeof s.resolve){var l=s.resolve();r=function(t){l.then(t)}}else r="undefined"!=typeof MutationObserver&&("undefined"==typeof window||!window.navigator||!window.navigator.standalone&&!window.cordova)&&"classList"in document.documentElement?function(){var t=document.createElement("div"),e={attributes:!0},n=!1,r=document.createElement("div"),i=new MutationObserver(function(){t.classList.toggle("foo"),n=!1});i.observe(r,e);var o=function(){n||(n=!0,r.classList.toggle("foo"))};return function(n){var r=new MutationObserver(function(){r.disconnect(),n()});r.observe(t,e),o()}}():"undefined"!=typeof setImmediate?function(t){setImmediate(t)}:"undefined"!=typeof setTimeout?function(t){setTimeout(t,0)}:o;e.exports=r},{"./util":36
}],30:[function(t,e,n){"use strict";e.exports=function(e,n,r){function i(t){this.constructor$(t)}var o=e.PromiseInspection,s=t("./util");s.inherits(i,n),i.prototype._promiseResolved=function(t,e){this._values[t]=e;var n=++this._totalResolved;return n>=this._length?(this._resolve(this._values),!0):!1},i.prototype._promiseFulfilled=function(t,e){var n=new o;return n._bitField=33554432,n._settledValueField=t,this._promiseResolved(e,n)},i.prototype._promiseRejected=function(t,e){var n=new o;return n._bitField=16777216,n._settledValueField=t,this._promiseResolved(e,n)},e.settle=function(t){return r.deprecated(".settle()",".reflect()"),new i(t).promise()},e.prototype.settle=function(){return e.settle(this)}}},{"./util":36}],31:[function(t,e,n){"use strict";e.exports=function(e,n,r){function i(t){this.constructor$(t),this._howMany=0,this._unwrap=!1,this._initialized=!1}function o(t,e){if((0|e)!==e||0>e)return r("expecting a positive integer\n\n    See http://goo.gl/MqrFmX\n");var n=new i(t),o=n.promise();return n.setHowMany(e),n.init(),o}var s=t("./util"),a=t("./errors").RangeError,c=t("./errors").AggregateError,l=s.isArray,u={};s.inherits(i,n),i.prototype._init=function(){if(this._initialized){if(0===this._howMany)return void this._resolve([]);this._init$(void 0,-5);var t=l(this._values);!this._isResolved()&&t&&this._howMany>this._canPossiblyFulfill()&&this._reject(this._getRangeError(this.length()))}},i.prototype.init=function(){this._initialized=!0,this._init()},i.prototype.setUnwrap=function(){this._unwrap=!0},i.prototype.howMany=function(){return this._howMany},i.prototype.setHowMany=function(t){this._howMany=t},i.prototype._promiseFulfilled=function(t){return this._addFulfilled(t),this._fulfilled()===this.howMany()?(this._values.length=this.howMany(),1===this.howMany()&&this._unwrap?this._resolve(this._values[0]):this._resolve(this._values),!0):!1},i.prototype._promiseRejected=function(t){return this._addRejected(t),this._checkOutcome()},i.prototype._promiseCancelled=function(){return this._values instanceof e||null==this._values?this._cancel():(this._addRejected(u),this._checkOutcome())},i.prototype._checkOutcome=function(){if(this.howMany()>this._canPossiblyFulfill()){for(var t=new c,e=this.length();e<this._values.length;++e)this._values[e]!==u&&t.push(this._values[e]);return t.length>0?this._reject(t):this._cancel(),!0}return!1},i.prototype._fulfilled=function(){return this._totalResolved},i.prototype._rejected=function(){return this._values.length-this.length()},i.prototype._addRejected=function(t){this._values.push(t)},i.prototype._addFulfilled=function(t){this._values[this._totalResolved++]=t},i.prototype._canPossiblyFulfill=function(){return this.length()-this._rejected()},i.prototype._getRangeError=function(t){var e="Input array must contain at least "+this._howMany+" items but contains only "+t+" items";return new a(e)},i.prototype._resolveEmptyArray=function(){this._reject(this._getRangeError(0))},e.some=function(t,e){return o(t,e)},e.prototype.some=function(t){return o(this,t)},e._SomePromiseArray=i}},{"./errors":12,"./util":36}],32:[function(t,e,n){"use strict";e.exports=function(t){function e(t){void 0!==t?(t=t._target(),this._bitField=t._bitField,this._settledValueField=t._isFateSealed()?t._settledValue():void 0):(this._bitField=0,this._settledValueField=void 0)}e.prototype._settledValue=function(){return this._settledValueField};var n=e.prototype.value=function(){if(!this.isFulfilled())throw new TypeError("cannot get fulfillment value of a non-fulfilled promise\n\n    See http://goo.gl/MqrFmX\n");return this._settledValue()},r=e.prototype.error=e.prototype.reason=function(){if(!this.isRejected())throw new TypeError("cannot get rejection reason of a non-rejected promise\n\n    See http://goo.gl/MqrFmX\n");return this._settledValue()},i=e.prototype.isFulfilled=function(){return 0!==(33554432&this._bitField)},o=e.prototype.isRejected=function(){return 0!==(16777216&this._bitField)},s=e.prototype.isPending=function(){return 0===(50397184&this._bitField)},a=e.prototype.isResolved=function(){return 0!==(50331648&this._bitField)};e.prototype.isCancelled=function(){return 0!==(8454144&this._bitField)},t.prototype.__isCancelled=function(){return 65536===(65536&this._bitField)},t.prototype._isCancelled=function(){return this._target().__isCancelled()},t.prototype.isCancelled=function(){return 0!==(8454144&this._target()._bitField)},t.prototype.isPending=function(){return s.call(this._target())},t.prototype.isRejected=function(){return o.call(this._target())},t.prototype.isFulfilled=function(){return i.call(this._target())},t.prototype.isResolved=function(){return a.call(this._target())},t.prototype.value=function(){return n.call(this._target())},t.prototype.reason=function(){var t=this._target();return t._unsetRejectionIsUnhandled(),r.call(t)},t.prototype._value=function(){return this._settledValue()},t.prototype._reason=function(){return this._unsetRejectionIsUnhandled(),this._settledValue()},t.PromiseInspection=e}},{}],33:[function(t,e,n){"use strict";e.exports=function(e,n){function r(t,r){if(u(t)){if(t instanceof e)return t;var i=o(t);if(i===l){r&&r._pushContext();var c=e.reject(i.e);return r&&r._popContext(),c}if("function"==typeof i){if(s(t)){var c=new e(n);return t._then(c._fulfill,c._reject,void 0,c,null),c}return a(t,i,r)}}return t}function i(t){return t.then}function o(t){try{return i(t)}catch(e){return l.e=e,l}}function s(t){try{return p.call(t,"_promise0")}catch(e){return!1}}function a(t,r,i){function o(t){a&&(a._resolveCallback(t),a=null)}function s(t){a&&(a._rejectCallback(t,p,!0),a=null)}var a=new e(n),u=a;i&&i._pushContext(),a._captureStackTrace(),i&&i._popContext();var p=!0,h=c.tryCatch(r).call(t,o,s);return p=!1,a&&h===l&&(a._rejectCallback(h.e,!0,!0),a=null),u}var c=t("./util"),l=c.errorObj,u=c.isObject,p={}.hasOwnProperty;return r}},{"./util":36}],34:[function(t,e,n){"use strict";e.exports=function(e,n,r){function i(t){this.handle=t}function o(t){return clearTimeout(this.handle),t}function s(t){throw clearTimeout(this.handle),t}var a=t("./util"),c=e.TimeoutError;i.prototype._resultCancelled=function(){clearTimeout(this.handle)};var l=function(t){return u(+this).thenReturn(t)},u=e.delay=function(t,o){var s,a;return void 0!==o?(s=e.resolve(o)._then(l,null,null,t,void 0),r.cancellation()&&o instanceof e&&s._setOnCancel(o)):(s=new e(n),a=setTimeout(function(){s._fulfill()},+t),r.cancellation()&&s._setOnCancel(new i(a)),s._captureStackTrace()),s._setAsyncGuaranteed(),s};e.prototype.delay=function(t){return u(t,this)};var p=function(t,e,n){var r;r="string"!=typeof e?e instanceof Error?e:new c("operation timed out"):new c(e),a.markAsOriginatingFromRejection(r),t._attachExtraTrace(r),t._reject(r),null!=n&&n.cancel()};e.prototype.timeout=function(t,e){t=+t;var n,a,c=new i(setTimeout(function(){n.isPending()&&p(n,e,a)},t));return r.cancellation()?(a=this.then(),n=a._then(o,s,void 0,c,void 0),n._setOnCancel(c)):n=this._then(o,s,void 0,c,void 0),n}}},{"./util":36}],35:[function(t,e,n){"use strict";e.exports=function(e,n,r,i,o,s){function a(t){setTimeout(function(){throw t},0)}function c(t){var e=r(t);return e!==t&&"function"==typeof t._isDisposable&&"function"==typeof t._getDisposer&&t._isDisposable()&&e._setDisposable(t._getDisposer()),e}function l(t,n){function i(){if(s>=l)return u._fulfill();var o=c(t[s++]);if(o instanceof e&&o._isDisposable()){try{o=r(o._getDisposer().tryDispose(n),t.promise)}catch(p){return a(p)}if(o instanceof e)return o._then(i,a,null,null,null)}i()}var s=0,l=t.length,u=new e(o);return i(),u}function u(t,e,n){this._data=t,this._promise=e,this._context=n}function p(t,e,n){this.constructor$(t,e,n)}function h(t){return u.isDisposer(t)?(this.resources[this.index]._setDisposable(t),t.promise()):t}function f(t){this.length=t,this.promise=null,this[t-1]=null}var _=t("./util"),d=t("./errors").TypeError,v=t("./util").inherits,y=_.errorObj,m=_.tryCatch,g={};u.prototype.data=function(){return this._data},u.prototype.promise=function(){return this._promise},u.prototype.resource=function(){return this.promise().isFulfilled()?this.promise().value():g},u.prototype.tryDispose=function(t){var e=this.resource(),n=this._context;void 0!==n&&n._pushContext();var r=e!==g?this.doDispose(e,t):null;return void 0!==n&&n._popContext(),this._promise._unsetDisposable(),this._data=null,r},u.isDisposer=function(t){return null!=t&&"function"==typeof t.resource&&"function"==typeof t.tryDispose},v(p,u),p.prototype.doDispose=function(t,e){var n=this.data();return n.call(t,t,e)},f.prototype._resultCancelled=function(){for(var t=this.length,n=0;t>n;++n){var r=this[n];r instanceof e&&r.cancel()}},e.using=function(){var t=arguments.length;if(2>t)return n("you must pass at least 2 arguments to Promise.using");var i=arguments[t-1];if("function"!=typeof i)return n("expecting a function but got "+_.classString(i));var o,a=!0;2===t&&Array.isArray(arguments[0])?(o=arguments[0],t=o.length,a=!1):(o=arguments,t--);for(var c=new f(t),p=0;t>p;++p){var d=o[p];if(u.isDisposer(d)){var v=d;d=d.promise(),d._setDisposable(v)}else{var g=r(d);g instanceof e&&(d=g._then(h,null,null,{resources:c,index:p},void 0))}c[p]=d}for(var b=new Array(c.length),p=0;p<b.length;++p)b[p]=e.resolve(c[p]).reflect();var w=e.all(b).then(function(t){for(var e=0;e<t.length;++e){var n=t[e];if(n.isRejected())return y.e=n.error(),y;if(!n.isFulfilled())return void w.cancel();t[e]=n.value()}C._pushContext(),i=m(i);var r=a?i.apply(void 0,t):i(t),o=C._popContext();return s.checkForgottenReturns(r,o,"Promise.using",C),r}),C=w.lastly(function(){var t=new e.PromiseInspection(w);return l(c,t)});return c.promise=C,C._setOnCancel(c),C},e.prototype._setDisposable=function(t){this._bitField=131072|this._bitField,this._disposer=t},e.prototype._isDisposable=function(){return(131072&this._bitField)>0},e.prototype._getDisposer=function(){return this._disposer},e.prototype._unsetDisposable=function(){this._bitField=-131073&this._bitField,this._disposer=void 0},e.prototype.disposer=function(t){if("function"==typeof t)return new p(t,this,i());throw new d}}},{"./errors":12,"./util":36}],36:[function(t,e,n){"use strict";function r(){try{var t=P;return P=null,t.apply(this,arguments)}catch(e){return x.e=e,x}}function i(t){return P=t,r}function o(t){return null==t||t===!0||t===!1||"string"==typeof t||"number"==typeof t}function s(t){return"function"==typeof t||"object"==typeof t&&null!==t}function a(t){return o(t)?new Error(v(t)):t}function c(t,e){var n,r=t.length,i=new Array(r+1);for(n=0;r>n;++n)i[n]=t[n];return i[n]=e,i}function l(t,e,n){if(!F.isES5)return{}.hasOwnProperty.call(t,e)?t[e]:void 0;var r=Object.getOwnPropertyDescriptor(t,e);return null!=r?null==r.get&&null==r.set?r.value:n:void 0}function u(t,e,n){if(o(t))return t;var r={value:n,configurable:!0,enumerable:!1,writable:!0};return F.defineProperty(t,e,r),t}function p(t){throw t}function h(t){try{if("function"==typeof t){var e=F.names(t.prototype),n=F.isES5&&e.length>1,r=e.length>0&&!(1===e.length&&"constructor"===e[0]),i=A.test(t+"")&&F.names(t).length>0;if(n||r||i)return!0}return!1}catch(o){return!1}}function f(t){function e(){}function n(){return typeof r.foo}e.prototype=t;var r=new e;return n(),n(),t}function _(t){return D.test(t)}function d(t,e,n){for(var r=new Array(t),i=0;t>i;++i)r[i]=e+i+n;return r}function v(t){try{return t+""}catch(e){return"[no string representation]"}}function y(t){return t instanceof Error||null!==t&&"object"==typeof t&&"string"==typeof t.message&&"string"==typeof t.name}function m(t){try{u(t,"isOperational",!0)}catch(e){}}function g(t){return null==t?!1:t instanceof Error.__BluebirdErrorTypes__.OperationalError||t.isOperational===!0}function b(t){return y(t)&&F.propertyIsWritable(t,"stack")}function w(t){return{}.toString.call(t)}function C(t,e,n){for(var r=F.names(t),i=0;i<r.length;++i){var o=r[i];if(n(o))try{F.defineProperty(e,o,F.getDescriptor(t,o))}catch(s){}}}function j(t){return H?process.env[t]:void 0}function E(){if("function"==typeof Promise)try{var t=new Promise(function(){});if("[object Promise]"==={}.toString.call(t))return Promise}catch(e){}}function k(t,e){return t.bind(e)}var F=t("./es5"),T="undefined"==typeof navigator,x={e:{}},P,S="undefined"!=typeof self?self:"undefined"!=typeof window?window:"undefined"!=typeof global?global:void 0!==this?this:null,R=function(t,e){function n(){this.constructor=t,this.constructor$=e;for(var n in e.prototype)r.call(e.prototype,n)&&"$"!==n.charAt(n.length-1)&&(this[n+"$"]=e.prototype[n])}var r={}.hasOwnProperty;return n.prototype=e.prototype,t.prototype=new n,t.prototype},O=function(){var t=[Array.prototype,Object.prototype,Function.prototype],e=function(e){for(var n=0;n<t.length;++n)if(t[n]===e)return!0;return!1};if(F.isES5){var n=Object.getOwnPropertyNames;return function(t){for(var r=[],i=Object.create(null);null!=t&&!e(t);){var o;try{o=n(t)}catch(s){return r}for(var a=0;a<o.length;++a){var c=o[a];if(!i[c]){i[c]=!0;var l=Object.getOwnPropertyDescriptor(t,c);null!=l&&null==l.get&&null==l.set&&r.push(c)}}t=F.getPrototypeOf(t)}return r}}var r={}.hasOwnProperty;return function(n){if(e(n))return[];var i=[];t:for(var o in n)if(r.call(n,o))i.push(o);else{for(var s=0;s<t.length;++s)if(r.call(t[s],o))continue t;i.push(o)}return i}}(),A=/this\s*\.\s*\S+\s*=/,D=/^[a-z$_][a-z$_0-9]*$/i,V=function(){return"stack"in new Error?function(t){return b(t)?t:new Error(v(t))}:function(t){if(b(t))return t;try{throw new Error(v(t))}catch(e){return e}}}(),I=function(t){return F.isArray(t)?t:null};if("undefined"!=typeof Symbol&&Symbol.iterator){var L="function"==typeof Array.from?function(t){return Array.from(t)}:function(t){for(var e,n=[],r=t[Symbol.iterator]();!(e=r.next()).done;)n.push(e.value);return n};I=function(t){return F.isArray(t)?t:null!=t&&"function"==typeof t[Symbol.iterator]?L(t):null}}var N="undefined"!=typeof process&&"[object process]"===w(process).toLowerCase(),H="undefined"!=typeof process&&"undefined"!=typeof process.env,B={isClass:h,isIdentifier:_,inheritedDataKeys:O,getDataPropertyOrDefault:l,thrower:p,isArray:F.isArray,asArray:I,notEnumerableProp:u,isPrimitive:o,isObject:s,isError:y,canEvaluate:T,errorObj:x,tryCatch:i,inherits:R,withAppended:c,maybeWrapAsError:a,toFastProperties:f,filledRange:d,toString:v,canAttachTrace:b,ensureErrorObject:V,originatesFromRejection:g,markAsOriginatingFromRejection:m,classString:w,copyDescriptors:C,hasDevTools:"undefined"!=typeof chrome&&chrome&&"function"==typeof chrome.loadTimes,isNode:N,hasEnvVariables:H,env:j,global:S,getNativePromise:E,domainBind:k};B.isRecentNode=B.isNode&&function(){var t;return process.versions&&process.versions.node?t=process.versions.node.split(".").map(Number):process.version&&(t=process.version.split(".").map(Number)),0===t[0]&&t[1]>10||t[0]>0}(),B.isNode&&B.toFastProperties(process);try{throw new Error}catch(U){B.lastLineError=U}e.exports=B},{"./es5":13}]},{},[4])(4)}),"undefined"!=typeof window&&null!==window?window.P=window.Promise:"undefined"!=typeof self&&null!==self&&(self.P=self.Promise);
/********************************************************************
*-------------------------------------------------------------------
* Licensed Materials - Property of IBM
*
* WebSphere Commerce
*
* (c) Copyright IBM Corp. 2000
*
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*
*-------------------------------------------------------------------*/

/** XBUtil **********************************************************
*
* Cross Browser API
*
*********************************************************************/

// Global browser flags
// isIE (Internet Explorer 5.5+)
// isNS (Netscape 6+)
// isDHTML (DHTML cross-browser support)
var isIE = (document.all) ? true : false;
var isNS = (document.getElementById && !isIE) ? true : false;
var isDHTML = (isIE || isNS) ? true : false;

/**********************************************************
* XBElement Class
*
* Read-Only Attributes:
* element       : The original DOM element.
* id            : ID of the element.
* type          : "XBElement"
* tagName       : Tag name of this element.
* class         : Currrent class applies to it. 
* style         : The style object of the DOM element.
* left          : The left position obtained from style.
* top           : The top position obtained from style.
* pageX         : Horizontal coordinate relative to the page.
* pageY         : Vertical coordinate relative to the page.
* offsetLeft    : Position relative to the left of the parent element.
* offsetTop     : Position relative to the top of the parent element.
* offsetWidth   : Width relative to the parent element.
* offsetHeight  : Height relative to the parent element.
* offsetParent  : A reference to the object in which the current element is offset.
*
* Methods:
* getAttribute          : Retrieves an attribute of the DOM element.
* setAttribute          : Sets an attribute value to the DOM element.
* getParentElement      : Returns the parent element in XBElement type.
* getFirstChild         : Returns the first child element in XBElement type.
* getLastChild          : Returns the last child element in XBElement type.
* getPreviousSibling    : Returns the previous sibling element in XBElement type.
* getNextSibling        : Returns the next sibling element in XBElement type.
* getChildElements      : Returns an array of children elemtns in XBElement types.
* getStyleClass         : Returns the current style class name.
* setStyleClass         : Sets the style class name.
* getStylePropertyValue : Returns a style property value.
* setStylePropertyValue : Sets a style property value.
* getInnerHTML          : Returns the innerHTML of the element.
* setInnerHTML          : Sets the innerHTML of the element.
* addEventListener      : Attaches an event to the element.
* removeEventListener   : Detaches an event to the element.
**********************************************************/
function XBElement(obj) {
	if (typeof(obj) == "string")
		obj = document.getElementById(obj);

	if (obj == document)
		return;

	this.element = obj;
	this.id = obj.id;
	this.type = "XBElement";
	this.tagName = obj.tagName;
	this.className = obj.className;
	this.style = obj.style;
	this.left = getObjStylePropertyValue(obj, "left");	
	this.top = getObjStylePropertyValue(obj, "top");
	this.pageX = getObjPageX(obj);
	this.pageY = getObjPageY(obj);
	this.offsetLeft = obj.offsetLeft;
	this.offsetTop = obj.offsetTop;
	this.offsetWidth = obj.offsetWidth;
	this.offsetHeight = obj.offsetHeight;
	this.offsetParent = obj.offsetParent;
	this.setAttribute = function(attr, val) { eval("this." + attr + " = val"); }
	this.getAttribute = function(attr) { return eval("this." + attr); }
	this.getParentElement = function() { return (obj.parentNode != null)?(new XBElement(obj.parentNode)):(null); }
	this.getFirstChild = function() { return (obj.firstChild != null)?(new XBElement(obj.firstChild)):(null); }
	this.getLastChild = function() { return (obj.lastChild != null)?(new XBElement(obj.lastChild)):(null); }
	this.getPreviousSibling = function() { return (obj.previousSibling != null)?(new XBElement(obj.previousSibling)):(null); }
	this.getNextSibling = function() { return (obj.nextSibling != null)?(new XBElement(obj.nextSibling)):(null); }
	this.getChildElements = function() {
		var childrenElements = new Array();

		for (var i = 0; i < obj.childNodes.length; i++) {
			childrenElements[i] = new XBElement(obj.childNodes[i]);
		}

		return childrenElements;
	}
	this.getStyleClass = function() { return obj.className; }
	this.setStyleClass = function(newClass) { obj.className = newClass; }
	this.getStylePropertyValue = function(property) {
		return getObjStylePropertyValue(this.element, property);
	}
	this.setStylePropertyValue = function(property, value) {
		setObjStylePropertyValue(this.element, property, value);
	}
	this.getInnerHTML = function() { return obj.innerHTML; }
	this.setInnerHTML = function(html) { obj.innerHTML = html; }
	this.addEventListener = function(eventType, eventListener) {
		addObjEventListener(this.element, eventType, eventListener);
	}
	this.removeEventListener = function(eventType, eventListener) {
		removeObjEventListener(this.element, eventType, eventListener);
	}
}

/**********************************************************
* XBEvent Class
*
* Read-Only Attributes:
* event         : The original event object.
* type          : The event type.
* target        : A reference to the target object to which the event was originally dispatched.
* currentTarget : A reference to the currently registered target element.
* relatedTarget : A reference to indentify a secondary target element.
* eventPhase    : Indicates the current event phase.
* bubbles       : Boolean value to indicate if the event is bubbling.
* cancelable    : Boolean value to indicate if the default action can be prevented.
* timeStamp     : Timstamp at which the event was created.
* screenX       : Horizontal coordinate relative to the screen.
* screenY       : Vertical coordinate relative to the screen.
* clientX       : Horizontal coordinate relative to the client/browser visible area.
* clientY       : Vertical coordinate relative to the client/browser visible area.
* pageX         : Horizontal coordinate relative to the page.
* pageY         : Vertical coordinate relative to the page.
* ctrlKey       : Boolean value to indicate if <ctrl> key was pressed.
* shiftKey      : Boolean value to indicate if <shift> key was pressed.
* altKey        : Boolean value to indicate if <alt> key was pressed.
* metaKey       : Boolean value to indicate if meta key was pressed.
* keyCode       : A numeric value to represent the key tha was pressed.
*
* Methods:
* button          : Indicates which mouse button was pressed during the event.
* stopPropagation : Stops the event from propagating along the DOM.
* preventDefault  : Cancels the default action of the event, only if it is cancelable.
**********************************************************/
function XBEvent(e) {
	this.AT_TARGET = 1;
	this.BUBBLING_PHASE = 2;
	this.CAPTURING_PHASE = 3;
	this.LEFT = 0;
	this.MIDDLE = 1;
	this.RIGHT = 2;
	this.event = e;

	// DOM2 InterfaceEvent
	this.type = (isIE)?(e.type):(e.type);
	this.target = XBEvent_getTarget(e);
	this.currentTarget = XBEvent_getCurrentTarget(e);
	this.eventPhase = (isIE)?(0):(e.eventPhase);
	this.bubbles = (isIE)?(e.cancelBubble):(e.bubbles);
	this.cancelable = (isIE)?((e.returnValue)?(e.returnValue):(false)):(e.cancelable);
	this.timeStamp = (isIE)?(new Date().getTime()):(e.timeStamp);
	this.stopPropagation = function() {
		if (isIE)
			e.cancelBubble = true;
		else
			e.stopPropagation();
	}
	this.preventCapture = function() {
		if (isIE)
			e.returnValue = false;
		else
			e.preventCapture();
	}
	this.preventDefault = function() {
		if (this.cancelable) {
			if (isIE)
				e.returnValue = false;
			else
				e.preventDefault();
		}
	}

	// DOM2 MouseEvent
	this.screenX = e.screenX;
	this.screenY = e.screenY;
	this.clientX = e.clientX;
	this.clientY = e.clientY;
	this.pageX = e.clientX + getPageXOffset();
	this.pageY = e.clientY + getPageYOffset();
	this.ctrlKey = e.ctrlKey;
	this.shiftKey = e.shiftKey;
 	this.altKey = e.altKey;
 	this.metaKey = (isIE)?(0):(e.metaKey);
 	if (this.type.indexOf("mouse") != -1) {
 		this.button = function() {
 			if (isIE) {
 				switch(e.button) {
 					case 1:
 						return this.LEFT;
 					case 2:
 						return this.RIGHT;
 					case 4:
 						return this.MIDDLE;
 					default:
 						return -1;
 				}
 			}
 			else {
				return e.button;
 			}
 		}
 	}
 	else if (this.type.indexOf("click") != -1) {
 		this.button = function() { return this.LEFT; }
 	}
 	this.relatedTarget = XBEvent_getRelatedTarget(e);

 	// IE Specific AddOn
 	this.keyCode = (isIE)?(parseInt(e.keyCode)):(parseInt(e.which));
}

function XBEvent_getTarget(e) {
	var result = null;

	if (isIE) {
		result = e.srcElement;
	}
	else {
		var node = e.target;
		if (node) {
		    while (node.nodeType != 1)
		        node = node.parentNode;
		    result = node;
	    }
	}

	if (result != null)
		return result;
	else
		return null;
}

function XBEvent_getCurrentTarget(e) {
	var result = null;

	if (isIE) {
		if (e.type.indexOf("mouseover") != -1)
			result = e.toElement;
		else if (e.type.indexOf("mouseout") != -1)
			result = e.fromElement;
	}
	else {
		result = e.currentTarget;
	}

	if (result != null)
		return result;
	else
		return null;

}

function XBEvent_getRelatedTarget(e) {
	var result = null;

	if (isIE) {
		if (e.type.indexOf("mouseover") != -1)
			result = e.fromElement;
		else if (e.type.indexOf("mouseout") != -1)
			result = e.toElement;
	}
	else {
		result = e.relatedTarget;
	}

	if (result != null)
		return result;
	else
		return null;
}

/**********************************************************
* Event Utils
**********************************************************/

function addObjEventListener(obj, eventType, eventListener) {
	// Disable event capturing, since IE doesn't support event capture
	var useCapture = false;
	var eventStart = "obj.on" + eventType.toLowerCase() + " = eventListener";

	if (obj.addEventListener) {
		obj.addEventListener(eventType, eventListener, useCapture);
	}
	else if (obj.attachEvent) {
		obj.attachEvent("on" + eventType, eventListener);
	}
	else {
		eval(eventStart);
	}
}

function removeObjEventListener(obj, eventType, eventListener) {
	// Disable event capturing, since IE doesn't support event capture
	var useCapture = false;
	var eventStop = "obj.on" + eventType.toLowerCase() + " = null";

	if (obj.removeEventListener) {
		obj.removeEventListener(eventType, eventListener, useCapture);
	}
	else if (obj.detachEvent) {
		obj.detachEvent(eventType, eventListener);
  	}
	else {
		eval(eventStop);
	}
}

/**********************************************************
* CSS Style Utils
**********************************************************/

///////////////////////////////////////////////////////////
// Given a DOM element and one of its style properties,
// returns the current style property value.
///////////////////////////////////////////////////////////
function getObjStylePropertyValue(obj, property) {
	var result = null;

	if (obj != null && obj != document) {
		if (isIE) {
			property = toJSPropertyName(property);
			result = obj.currentStyle.getAttribute(property);
		}
		else if (isNS) {
			if (obj.nodeName.indexOf("text") == -1) {
				result = obj.ownerDocument.defaultView.getComputedStyle(obj, "").getPropertyValue(property);
			}
		}
	}

	return result;
}

///////////////////////////////////////////////////////////
// Sets a style property value to a given DOM element.
///////////////////////////////////////////////////////////
function setObjStylePropertyValue(obj, property, value) {
	property = toJSPropertyName(property);
	eval("obj.style." + property + " = value");
}

///////////////////////////////////////////////////////////
// Returns the horizontal position of a given DOM element 
// relative to the page.
///////////////////////////////////////////////////////////
function getObjPageX(obj) {
	var num = 0;

	if (obj != document) {
		for (var p = obj; p && p.tagName != "BODY"; p = p.offsetParent)
			num += p.offsetLeft;
	}

	return num;
}

///////////////////////////////////////////////////////////
// Returns the vertical position of a given DOM element 
// relative to the page.
///////////////////////////////////////////////////////////
function getObjPageY(obj) {
	var num = 0;

	if (obj != document) {
		for (var p = obj; p && p.tagName != "BODY"; p = p.offsetParent)
			num += p.offsetTop;
	}
	return num;
}

///////////////////////////////////////////////////////////
// Returns the client/browser visible width in pixels.
///////////////////////////////////////////////////////////
function getClientWidth(winRef) {
	if (arguments.length == 0)
		winRef = window;

	var doc = winRef.document;
	var width = 0;

	if (isIE)
		width = doc.documentElement.clientWidth;
	else if (isNS)
		width = winRef.innerWidth;

	return width;
}

///////////////////////////////////////////////////////////
// Returns the client/browser visible height in pixels.
///////////////////////////////////////////////////////////
function getClientHeight(winRef) {
	if (arguments.length == 0)
		winRef = window;

	var doc = winRef.document;
	var height = 0;

	if (isIE)
		height = doc.documentElement.clientHeight;
	else if (isNS)
		height = winRef.innerHeight;

	return height;
}

///////////////////////////////////////////////////////////
// Returns the page width in pixels.
///////////////////////////////////////////////////////////
function getPageWidth(winRef) {
	if (arguments.length == 0)
		winRef = window;

	var doc = winRef.document;
	var width = 0;

	if (isIE)
		width = doc.body.scrollWidth;
	else if (isNS)
		width = doc.width;

	return width;
}

///////////////////////////////////////////////////////////
// Returns the page height in pixels.
///////////////////////////////////////////////////////////
function getPageHeight(winRef) {
	if (arguments.length == 0)
		winRef = window;

	var doc = winRef.document;
	var height = 0;

	if (isIE)
		height = doc.body.scrollHeight;
	else if (isNS)
		height = doc.height;

	return height;
}

///////////////////////////////////////////////////////////
// Returns the amount of content that has been hidden 
// by scrolling to the right.
///////////////////////////////////////////////////////////
function getPageXOffset(winRef) {
	if (arguments.length == 0)
		winRef = window;

	var doc = winRef.document;
	var offset = 0;

	if (isIE)
		offset = doc.documentElement.scrollLeft;
	else if (isNS)
		offset = winRef.pageXOffset;

	return offset;
}

///////////////////////////////////////////////////////////
// Returns the amount of content that has been hidden 
// by scrolling down.
///////////////////////////////////////////////////////////
function getPageYOffset(winRef) {
	if (arguments.length == 0)
		winRef = window;

	var doc = winRef.document;
	var offset = 0;

	if (isIE)
		offset = doc.documentElement.scrollTop;
	else if (isNS)
		offset = winRef.pageYOffset;

	return offset;
}

///////////////////////////////////////////////////////////
// Converts a style property in CSS format to JavaScript
// format. (e.g. background-color  --> backgroundColor)
///////////////////////////////////////////////////////////
function toJSPropertyName(property) {
	while (property.lastIndexOf("-") != -1) {
		var dashPos = property.lastIndexOf("-");
		var upChar = property.charAt(dashPos + 1).toUpperCase();
		property = property.substring(0, dashPos) + upChar + property.substring(dashPos + 2);
	}
	return property;
}

/**********************************************************
* IFrame Utils
**********************************************************/

///////////////////////////////////////////////////////////
// Returns the window reference of an IFRAME by its ID.
// IE handles the content in an IFRAME in a special 
// attribute called "contentWindow".
///////////////////////////////////////////////////////////
function getIFrameById(iframeID, winRef) {
	if (arguments.length == 1)
		winRef = window;

	var doc = winRef.document;	
	var iframeElement = doc.getElementById(iframeID);

	if (iframeElement != null && iframeElement.contentWindow)
		return iframeElement.contentWindow;
	else
		return iframeElement;
}

///////////////////////////////////////////////////////////
// Returns the document reference of an IFRAME by its ID.
// IE handles the document in an IFRAME in a special 
// attribute called "contentDocument".
///////////////////////////////////////////////////////////
function getIFrameDocumentById(iframeID, winRef) {
	if (arguments.length == 1)
		winRef = window;
	
	var iframeDoc = null;
	var iframeObj = getIFrameById(iframeID, winRef);

	if (iframeObj != null && iframeObj.contentDocument) {
		iframeDoc = iframeObj.contentDocument;
	}
	else if (iframeObj != null && iframeObj.document) {
		iframeDoc = iframeObj.document;
	}

	return iframeDoc;
}

/**********************************************************
* Debug Utils
**********************************************************/

///////////////////////////////////////////////////////////
// Given any object, output its content in the following
// format:
//    attribute:::value<end>
///////////////////////////////////////////////////////////
function inspect(obj) {
	var output = "";

	if (obj == null) {
		return null;
	}
	else if (typeof(obj) == "string") {
		return obj;	
	}
	else {
		for (var i in obj) {
			if (typeof(obj[i]) != "unknown" && typeof(obj[i]) != "undefined")
				output += i + " ::: " + obj[i] + "<end>\n";
			else if (typeof(obj[i]) == "unknown")
				output += i + " ::: unknown<end>\n";
			else
				output += i + " ::: undefined<end>\n";
		}
		return output;
	}
}

///////////////////////////////////////////////////////////
// Given a DOM element, output its style properties and
// values in the following format:
//    attribute:::value<end>
// Can be used in conjunction with debugDialog:
//    debugDialog(insepect(obj));
///////////////////////////////////////////////////////////
function inspectStyle(obj) {
	var output = "";

	if (obj.style) {
		for (var i in obj.style) {
			if (typeof(obj.style[i]) != "unknown" && typeof(obj.style[i]) != "undefined")
				output += i + " ::: " + obj.style[i] + "<end>\n";
			else if (typeof(obj[i]) == "unknown")
				output += i + " ::: unknown<end>\n";
			else
				output += i + " ::: undefined<end>\n";
		}
	}
	else {
		output += "Error: style is undefined in this object.";
	}

	return output;
}

///////////////////////////////////////////////////////////
// Shows the mouse status information in window status bar.
///////////////////////////////////////////////////////////
function showMouseMoveStatus(isEnable) {
	if (isEnable) {
		addObjEventListener(document, "mousemove", XBDebug_mouseMoveListener);
	}
	else {
		removeObjEventListener(document, "mousemove", XBDebug_mouseMoveListener);
	}
}

///////////////////////////////////////////////////////////
// Event handler of showMouseMoveStatus.
// For internal use only.
///////////////////////////////////////////////////////////
function XBDebug_mouseMoveListener(evt) {
	var e = new XBEvent(evt);
	var mouseStatus = "Mouse Status:";
	mouseStatus += " ClientX: " + e.clientX;
	mouseStatus += " ClientY: " + e.clientY;
	mouseStatus += " PageX: " + e.pageX;
	mouseStatus += " PageY: " + e.pageY;
	mouseStatus += " ScreenX: " + e.screenX;
	mouseStatus += " ScreenY: " + e.screenY;
	window.status = mouseStatus;
}

/**********************************************************
* Modal Dialog Utils
**********************************************************/

///////////////////////////////////////////////////////////
// Open an UTF-8 modal dialog
///////////////////////////////////////////////////////////
function openModalDialog(url, width, height, scrolling, args) {
	var features = "";
	var dialogName = (new Date()).getMilliseconds().toString();
	var dialogWidth = width;
	var dialogHeight = height;
	var dialogArgs = new Object();
	var returnValue = null;

	for (i in args) {
		dialogArgs[i] = args[i];
	}

	dialogArgs.timeout = false;
	if (isIE) {
		features = "dialogWidth: " + dialogWidth + "px; dialogHeight: " + dialogHeight + "px; center; status: no; help: no;";
		features += (scrolling)?(" scroll: yes;"):(" scroll: no;");
		returnValue = window.showModalDialog(url, dialogArgs, features);
		if (dialogArgs.timeout == true) {
			top.close();
		}
		return returnValue;
	}
	else {
		dialogWidth = (dialogWidth - 20 <= 0)?(dialogWidth):(dialogWidth - 20);
		dialogHeight = (dialogHeight - 20 <= 0)?(dialogHeight):(dialogHeight - 20);
		var posX = window.screenX + ((window.outerWidth - parseInt(dialogWidth)) / 2);
		var posY = window.screenY + ((window.outerHeight - parseInt(dialogHeight)) / 2);
		window.dialogArguments = dialogArgs;
		features = "screenX=" + posX + ", screenY=" + posY + ", width=" + dialogWidth + "px, height=" + dialogHeight + "px, modal=yes, sidebars=no, menubars=no";
		features += (scrolling)?(", scrollbars=yes"):(", scrollbars=no");
		window.returnValue = null;
		window.open(url, dialogName, features);

		if (window.returnValue != null)
			return window.returnValue;
	}
}

///////////////////////////////////////////////////////////
// Adjusts the size of the modal dialog to fit the content.
///////////////////////////////////////////////////////////
function autoResizeModalDialog() {
	var hiddenWidth = getPageWidth() - getClientWidth();
	var hiddenHeight = getPageHeight() - getClientHeight();

	if (isIE) {
		window.dialogWidth = parseInt(window.dialogWidth) + hiddenWidth + 18 + "px";
		window.dialogHeight = parseInt(window.dialogHeight) + hiddenHeight + 18 + "px";
	}
	else if (isNS) {
		window.sizeToContent();
	}
}

/** END OF XBUtil **********************************************************/


/****************************************************************************
* Open a new window.
*
* url - The URL of the help file.
* windowName - The title of the window.
* offset     - The offset in pixels from the parent window
* features   - The various attributes of the window to be created.
*
* Returns the opened window
****************************************************************************/
function openWindow(url, windowName, offset, features)
{
  if (features == null)
    features = "resizable=yes,scrollbars=yes,menubar=yes, copyhistory=no";

  if (offset == null)
    offset = 0;

  offset += 20;

  if(navigator.appName == "Netscape")
  {
    if(parseInt(navigator.appVersion) > 3)
    {
      // set width and height
      if (features.indexOf(",width=") < 0)
        features += ",width=" + top.innerWidth + ",height=" + top.innerHeight;

      // set window position
      features += ",screenX=" + (top.screenX+offset) + ",screenY=" + (top.screenY+offset);
    }
    else
    {
      // set width and height
      if (features.indexOf(",width=") < 0)
        features += ",width=" + top.width + ",height=" + top.height;

      // set window position not available in version 3 and less
    }
  }// END if

  else
  {
    // set width and height
    if (features.indexOf(",width=") < 0)
    {
      var width=",width=", height=",height=";

      if (screen.width < 750)
        width += screen.availWidth;
      else
        width += "750";

      if (screen.height < 500)
        height += screen.availHeight;
      else
        height += "500";
      features += width + height;
    }

    // No way to query current window position in IE...
    // features += ",left=" + (screen.availLeft+offset) + ",top=" + (screen.availTop+offset);
    features += ",screenLeft=" + (screen.availLeft+offset) + ",screenTop=" + (screen.availTop+offset);

  }// END else

  var target = window.open( "", windowName, features);

  target.location.href = url;
  // focus function is not working under IE4 with Service pack 2
  // it will crash, we need to detect the specific IE version 'MSIE 4.01' - d48999
  // we only use focus() function for all browser except IE 4.01
  var navVersion = navigator.appVersion
  if ( navVersion.indexOf("MSIE 4.01") == -1 )
  {
    target.focus();
  }

  return target;

}// END openWindow

/****************************************************************************
* Determines whether an object has been assigned a value.
*
* Returns TRUE if it has been assigned a value; FALSE otherwise
****************************************************************************/
function defined(obj)
{
  var str = typeof obj;

  if((str == "undefined") || (obj == null))
    return false;
  else
    return true;
}// END defined

/****************************************************************************
* Returns the type of object.
****************************************************************************/
function objectType(obj)
{
 //
 // alert( "The function Util::objectType() is deprecated!"
 //      + "It fails in IE and thus must not be used.\n\n"
 //      + "If you see this message open a defect immediately.");

  var constructor = (String)(obj.constructor);
  var tokens = constructor.split(" ");

  for(var i=0; i<tokens.length; i++)
  {
    if(tokens[i].indexOf("function") != -1)
    {
      var end = tokens[i+1].indexOf("(");

      if(end == -1)
        return(tokens[i+1]);
      else
        return(tokens[i+1].substring(0, end));
    }
  }

}// END objectType

/****************************************************************************
* Trim the leading and trailing blank of the input string 'word'
*
* Returns a string
****************************************************************************/
function trim(inword)
{
   word = inword.toString();
   var i=0;
   var j=word.length-1;
   while(word.charAt(i) == " ") i++;
   while(word.charAt(j) == " ") j--;
   if (i > j) {
		return word.substring(i,i);
	} else {
		return word.substring(i,j+1);
	}
}

/****************************************************************************
* Check if the input string 'id' is empty
*
* Returns true or false
****************************************************************************/
function isInputStringEmpty(id)
{
  return !id.match(/[^\s]/);
}


/****************************************************************************
* This will alert the user with the error/warning message 'message' and
* highlight the text field 'field'.
*
*
****************************************************************************/
function reprompt(field, message) {
    window.status = "";
    alertDialog(message);
    field.focus();
    field.select();

}

/****************************************************************************
* This will remove the Return \r \n chars from a string and
* replace them by " " char.
*
*
****************************************************************************/
function removeReturnChar(word)
{
   var i=0;
   var j=word.length;
   var result="";

   for (i=0; i<j; ++i) {
      if((word.charAt(i) == "\r") || (word.charAt(i) == "\n" )) {
         result += " ";
      } else {
         result += word.charAt(i);
      }
   }

   return result;
}


/**************************************************************************
* This will return the index position that a char in a given string
* return "false" if couldn't found, otherwise it returns the first invalid
* character.
*
***************************************************************************/
function find(givenString, searchChars)
{
  for ( var i=0; i< searchChars.length; i++)
  {
   var achar = searchChars.substring(i, i+1);

   if ( givenString.indexOf(achar) != -1 )
     return achar;
  }
   return "false";
}

/*********************************************************************
* Return the number of occurrence of a given char
**********************************************************************/
function numOfOccur(givenString, searchChars)
{
  var count = 0;

  for (var i=0; i< givenString.length; i++)
  {
     if ( givenString.charAt(i) == searchChars.charAt(0) )
       count ++;
  }

  return count;
}


function convertFromTextToHTML(obj)
{
   var string = new String(obj);
   var result = "";

   for (var i=0; i < string.length; i++ ) {
      if (string.charAt(i) == "<")       result += "&lt;";
      else if (string.charAt(i) == ">")  result += "&gt;";
      else result += string.charAt(i);
   }
   return result;
}

function convertFromHTMLToText(obj)
{
   /* add some padding to the string so we don't
      require bounds checking */
   var string = new String(obj + "_____");
   var result = "";

   for (var i=0; i < string.length; ) {
      if (string.charAt(i) == "&") {
         if (string.substring(i, i+4) == "&lt;") {
            result += "<";
            i += 4;
         }
         else if (string.substring(i, i+4) == "&gt;") {
            result += ">";
            i += 4;
         }
         else {
            result += string.charAt(i);
            i++;
         }
      }
      else {
         result += string.charAt(i);
         i++;
      }
   }
   return result.substring(0, result.length-5);
}


function isEmpty(id) {
	if (typeof(id) == "string") {
		return !id.match(/[^\s]/);
	}
	else {
		return (id)?(false):(true);
	}
}


//////////////////////////////////////////////////////////
// This function will check whether or not the time has
// a valid format. hh:mm
//
// by Tony Mao
// Input: time
// Return code = "true", time has a right format
// Return code = "false", time format is wrong
//
//////////////////////////////////////////////////////////
function validTime(time1) {
   var delimiter = ":";
   var hh, mm;
   var time1Length;
   var hhlength;
   var mmlength;

   time1Length = time1.length;

   if (time1 == "" || time1.indexOf(delimiter) == -1 ||  time1Length > 5 ) return false;

   hh = time1.substring(0,time1.indexOf(delimiter));
   mm = time1.substring(time1.indexOf(delimiter) + 1);

   hhlength = hh.length;
   mmlength = mm.length;

   if (hhlength <1 || hhlength >2 || mmlength <1 || mmlength >2) return false;
   if (hh=="" || mm == "" ) return false;
   if (isNaN(hh) || isNaN(mm) ) return false;

   if ( parseInt(hh) > 23 || parseInt(hh) < 0 ) return false;
   if ( parseInt(mm) > 59 || parseInt(mm) < 0 ) return false;

   return true;
}


//////////////////////////////////////////////////////////
// This function will limit a text area input box to a
// specified size.  just use the onKeyUp and onKeyDown events
// with the text area box.
// call with ::
//    arg1=this.form.<myTextAreaName>
//    arg2=<maximumSizeForTextArea>
// by Glen Shortliffe
//////////////////////////////////////////////////////////
function limitTextArea(field, maxlimit) {
    if (field.value.length > maxlimit) {
       //  field is too long... chop it down
       field.value = field.value.substring(0, maxlimit);
    }
}


//////////////////////////////////////////////////////////
// This function will validate a typical name field
// and restrict it to pretty much alphanumerics.
// All special characters are invalid with some exceptions
// " ", "-", "_", and "." are all valid
// The string can also not start with a leading number
// The string can also not be empty
// call with ::
//    arg1=<myInputString>
//
// return true is name is valid, false otherwise
// by Glen Shortliffe
//////////////////////////////////////////////////////////
function isValidName(myString) {
    var invalidChars = "~!@#$%^&*()+=[]{};:,<>?/|`"; // invalid chars
    invalidChars += "\t\'\"\\"; // escape sequences
    var invalidStartChars = "0123456789";

    // if the string is empty it is not a valid name
    if (isEmpty(myString)) return false;

    // look for presence of invalid characters.  if one is
    // found return false.  otherwise return true
    for (var i=0; i<myString.length; i++) {
      if (invalidChars.indexOf(myString.substring(i, i+1)) >= 0) {
        return false;
      }
    }

    // look for a leading number... and disallow it.
    var startChar = myString.substring(0,1);
    for (var i=0; i<invalidStartChars.length; i++) {
      if (invalidStartChars.indexOf(startChar) >= 0) {
        return false;
      }
    }

    return true;
}

//////////////////////////////////////////////////////////
// This function will dump out the content of a javascript object
// This is useful for debugging purposes.
// In your code you can do this:
// alert(dumpObject(myBigFatObject));
//
// This will dump out the objects contents
// arg1 = the object you want info on...
// return a string which you can send to alert()
// by Glen Shortliffe
//////////////////////////////////////////////////////////
function dumpObject(what) {
   var output = '';
   for (i in what) {
       if (typeof what[i] == 'object') {
           output += dumpObject(what[i]);
       }
       else
           output += i + ' = ' + what[i] + '\n';
   }
   return output;
}

// function to clone a javascript object
function cloneObject(what) {
    for (i in what) {
       if (typeof i == 'object') {
          this[i] = new cloneObject(what[i]);
       }
       else {
          this[i] = what[i];
       }
    }
}

//////////////////////////////////////////////////////////
// This function will validate a positive integer quantity (including 0)
//
// arg1 = the object you want info on...
// Return true is this input arg is a valid positive int,
// otherwise return false...
//
//////////////////////////////////////////////////////////
function isValidPositiveInteger(myString) {
    var validChars = "0123456789";

    // if the string is empty it is not a valid integer
    if (isEmpty(myString)) return false;

    // look for non numeric characters in the input string
    for (var i=0; i<myString.length; i++) {
      if (validChars.indexOf(myString.substring(i, i+1)) == "-1") {
        return false;
      }
    }
    // look for bad leading zeroes in the input string
    if (myString.length > 1 && myString.substring(0,1) == "0") {
       return false;
    }

    return true;
}

//////////////////////////////////////////////////////////
// This function will validate a positive integer quantity (excluding 0)
//
// arg1 = the object you want info on...
// Return true is this input arg is a valid positive int,
// otherwise return false...
//
//////////////////////////////////////////////////////////
function isValidNZPosInt(myString) {
    var validChars = "0123456789";

    // if the string is empty it is not a valid integer
    if (isEmpty(myString)) return false;

    // look for non numeric characters in the input string
    for (var i=0; i<myString.length; i++) {
      if (validChars.indexOf(myString.substring(i, i+1)) == "-1") {
        return false;
      }
    }
    // look for bad leading zeroes in the input string
    if (myString.substring(0,1) == "0") {
       return false;
    }

    return true;
}

//////////////////////////////////////////////////////////
// This function will count the number of bytes
// represented in a UTF-8 string
//
// arg1 = the UTF-8 string
// arg2 = the maximum number of bytes allowed in your input field
// Return false is this UTF-8 string is larger then arg2
// Otherwise return true...
//////////////////////////////////////////////////////////
function isValidUTF8length(UTF8String, maxlength) {
    // alert('UTF8String='+UTF8String+'\nUTF-8 length='+utf8StringByteLength(UTF8String)+'\nmaxlength='+maxlength);
    if (utf8StringByteLength(UTF8String) > maxlength) return false;
    else return true;
}

//////////////////////////////////////////////////////////
// This function will count the number of bytes
// represented in a UTF-8 string
//
// arg1 = the UTF-8 string you want a byte count of...
// Return the integer number of bytes represented by the string
//////////////////////////////////////////////////////////
function utf8StringByteLength(UTF8String) {
  if (UTF8String === null) return 0;
  var str = String(UTF8String);
  var oneByteMax = 0x007F;
  var twoByteMax = 0x07FF;
  var byteSize = str.length;

  for (i = 0; i < str.length; i++) {
    chr = str.charCodeAt(i);
    if (chr > oneByteMax) byteSize = byteSize + 1;
    if (chr > twoByteMax) byteSize = byteSize + 1;
  }
  return byteSize;
}

/**********************************************************
* Globalized Modal Dialogs
**********************************************************/
function debugDialog(sMsg)
{
	if (typeof(sMsg) == "undefined")
		sMsg = "undefined";
	
	if (top.webappPath)
		openWindow(top.webappPath + 'tools/common/Debug.jsp', "Debug", 5);
	else
		openWindow('tools/common/Debug.jsp', "Debug", 5);

	window.debugMessage = sMsg;
}

function alertDialog(sMsg)
{
	if (typeof(sMsg) == "undefined")
		sMsg = "undefined";

	var dialogArgs = new Array();
	dialogArgs.message = sMsg;

	if (top.webappPath)
		openModalDialog(top.webappPath + 'AlertDialogView', 500, 145, true, dialogArgs);
	else
		openModalDialog('AlertDialogView', 480, 150, true, dialogArgs);		
}

function confirmDialog(sMsg)
{
	if (sMsg == null)
		sMsg = "";

	dialogArgs = new Array();
	dialogArgs.message = sMsg;

	if (top.webappPath)
		returnValue = openModalDialog(top.webappPath + 'ConfirmDialogView', 500, 145, true, dialogArgs);
	else
		returnValue = openModalDialog('ConfirmDialogView', 500, 145, true, dialogArgs);

	if (returnValue == null)
		returnValue = false;

	return returnValue;
}

function promptDialog(sMsg, sDefaultValue, iLength, bPasswordInput)
{
	if (sMsg == null)
		sMsg = "";

	dialogArgs = new Array();
	dialogArgs.message = sMsg;
	dialogArgs.defaultValue = (sDefaultValue != null)?(sDefaultValue):("");

	if (iLength == null)
		dialogArgs.iLength = 256;   // default length
	else
		dialogArgs.iLength = iLength;

	if (bPasswordInput == null)
		dialogArgs.passwordInput = false;
	else
		dialogArgs.passwordInput = bPasswordInput;

	if (top.webappPath)
		returnValue = openModalDialog(top.webappPath + 'PromptDialogView', 500, 145, true, dialogArgs);
	else
		returnValue = openModalDialog('PromptDialogView', 500, 150, true, dialogArgs);

	if (typeof(returnValue) == "undefined")
		returnValue = null;

	return returnValue;
}

function infoDialog(sMsg)
{
	if (typeof(sMsg) == "undefined")
		sMsg = "undefined";

	var dialogArgs = new Array();
	dialogArgs.message = sMsg;

	if (top.webappPath)
		openModalDialog(top.webappPath + 'tools/common/Information.jsp', 500, 145, true, dialogArgs);
	else
		openModalDialog('tools/common/Information.jsp', 480, 150, true, dialogArgs);		
}

(function defineMustache(global,factory){if(typeof exports==="object"&&exports&&typeof exports.nodeName!=="string"){factory(exports)}else if(typeof define==="function"&&define.amd){define(["exports"],factory)}else{global.Mustache={};factory(global.Mustache)}})(this,function mustacheFactory(mustache){var objectToString=Object.prototype.toString;var isArray=Array.isArray||function isArrayPolyfill(object){return objectToString.call(object)==="[object Array]"};function isFunction(object){return typeof object==="function"}function typeStr(obj){return isArray(obj)?"array":typeof obj}function escapeRegExp(string){return string.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g,"\\$&")}function hasProperty(obj,propName){return obj!=null&&typeof obj==="object"&&propName in obj}function primitiveHasOwnProperty(primitive,propName){return primitive!=null&&typeof primitive!=="object"&&primitive.hasOwnProperty&&primitive.hasOwnProperty(propName)}var regExpTest=RegExp.prototype.test;function testRegExp(re,string){return regExpTest.call(re,string)}var nonSpaceRe=/\S/;function isWhitespace(string){return!testRegExp(nonSpaceRe,string)}var entityMap={"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;","/":"&#x2F;","`":"&#x60;","=":"&#x3D;"};function escapeHtml(string){return String(string).replace(/[&<>"'`=\/]/g,function fromEntityMap(s){return entityMap[s]})}var whiteRe=/\s*/;var spaceRe=/\s+/;var equalsRe=/\s*=/;var curlyRe=/\s*\}/;var tagRe=/#|\^|\/|>|\{|&|=|!/;function parseTemplate(template,tags){if(!template)return[];var lineHasNonSpace=false;var sections=[];var tokens=[];var spaces=[];var hasTag=false;var nonSpace=false;var indentation="";var tagIndex=0;function stripSpace(){if(hasTag&&!nonSpace){while(spaces.length)delete tokens[spaces.pop()]}else{spaces=[]}hasTag=false;nonSpace=false}var openingTagRe,closingTagRe,closingCurlyRe;function compileTags(tagsToCompile){if(typeof tagsToCompile==="string")tagsToCompile=tagsToCompile.split(spaceRe,2);if(!isArray(tagsToCompile)||tagsToCompile.length!==2)throw new Error("Invalid tags: "+tagsToCompile);openingTagRe=new RegExp(escapeRegExp(tagsToCompile[0])+"\\s*");closingTagRe=new RegExp("\\s*"+escapeRegExp(tagsToCompile[1]));closingCurlyRe=new RegExp("\\s*"+escapeRegExp("}"+tagsToCompile[1]))}compileTags(tags||mustache.tags);var scanner=new Scanner(template);var start,type,value,chr,token,openSection;while(!scanner.eos()){start=scanner.pos;value=scanner.scanUntil(openingTagRe);if(value){for(var i=0,valueLength=value.length;i<valueLength;++i){chr=value.charAt(i);if(isWhitespace(chr)){spaces.push(tokens.length);indentation+=chr}else{nonSpace=true;lineHasNonSpace=true;indentation+=" "}tokens.push(["text",chr,start,start+1]);start+=1;if(chr==="\n"){stripSpace();indentation="";tagIndex=0;lineHasNonSpace=false}}}if(!scanner.scan(openingTagRe))break;hasTag=true;type=scanner.scan(tagRe)||"name";scanner.scan(whiteRe);if(type==="="){value=scanner.scanUntil(equalsRe);scanner.scan(equalsRe);scanner.scanUntil(closingTagRe)}else if(type==="{"){value=scanner.scanUntil(closingCurlyRe);scanner.scan(curlyRe);scanner.scanUntil(closingTagRe);type="&"}else{value=scanner.scanUntil(closingTagRe)}if(!scanner.scan(closingTagRe))throw new Error("Unclosed tag at "+scanner.pos);if(type==">"){token=[type,value,start,scanner.pos,indentation,tagIndex,lineHasNonSpace]}else{token=[type,value,start,scanner.pos]}tagIndex++;tokens.push(token);if(type==="#"||type==="^"){sections.push(token)}else if(type==="/"){openSection=sections.pop();if(!openSection)throw new Error('Unopened section "'+value+'" at '+start);if(openSection[1]!==value)throw new Error('Unclosed section "'+openSection[1]+'" at '+start)}else if(type==="name"||type==="{"||type==="&"){nonSpace=true}else if(type==="="){compileTags(value)}}stripSpace();openSection=sections.pop();if(openSection)throw new Error('Unclosed section "'+openSection[1]+'" at '+scanner.pos);return nestTokens(squashTokens(tokens))}function squashTokens(tokens){var squashedTokens=[];var token,lastToken;for(var i=0,numTokens=tokens.length;i<numTokens;++i){token=tokens[i];if(token){if(token[0]==="text"&&lastToken&&lastToken[0]==="text"){lastToken[1]+=token[1];lastToken[3]=token[3]}else{squashedTokens.push(token);lastToken=token}}}return squashedTokens}function nestTokens(tokens){var nestedTokens=[];var collector=nestedTokens;var sections=[];var token,section;for(var i=0,numTokens=tokens.length;i<numTokens;++i){token=tokens[i];switch(token[0]){case"#":case"^":collector.push(token);sections.push(token);collector=token[4]=[];break;case"/":section=sections.pop();section[5]=token[2];collector=sections.length>0?sections[sections.length-1][4]:nestedTokens;break;default:collector.push(token)}}return nestedTokens}function Scanner(string){this.string=string;this.tail=string;this.pos=0}Scanner.prototype.eos=function eos(){return this.tail===""};Scanner.prototype.scan=function scan(re){var match=this.tail.match(re);if(!match||match.index!==0)return"";var string=match[0];this.tail=this.tail.substring(string.length);this.pos+=string.length;return string};Scanner.prototype.scanUntil=function scanUntil(re){var index=this.tail.search(re),match;switch(index){case-1:match=this.tail;this.tail="";break;case 0:match="";break;default:match=this.tail.substring(0,index);this.tail=this.tail.substring(index)}this.pos+=match.length;return match};function Context(view,parentContext){this.view=view;this.cache={".":this.view};this.parent=parentContext}Context.prototype.push=function push(view){return new Context(view,this)};Context.prototype.lookup=function lookup(name){var cache=this.cache;var value;if(cache.hasOwnProperty(name)){value=cache[name]}else{var context=this,intermediateValue,names,index,lookupHit=false;while(context){if(name.indexOf(".")>0){intermediateValue=context.view;names=name.split(".");index=0;while(intermediateValue!=null&&index<names.length){if(index===names.length-1)lookupHit=hasProperty(intermediateValue,names[index])||primitiveHasOwnProperty(intermediateValue,names[index]);intermediateValue=intermediateValue[names[index++]]}}else{intermediateValue=context.view[name];lookupHit=hasProperty(context.view,name)}if(lookupHit){value=intermediateValue;break}context=context.parent}cache[name]=value}if(isFunction(value))value=value.call(this.view);return value};function Writer(){this.cache={}}Writer.prototype.clearCache=function clearCache(){this.cache={}};Writer.prototype.parse=function parse(template,tags){var cache=this.cache;var cacheKey=template+":"+(tags||mustache.tags).join(":");var tokens=cache[cacheKey];if(tokens==null)tokens=cache[cacheKey]=parseTemplate(template,tags);return tokens};Writer.prototype.render=function render(template,view,partials,tags){var tokens=this.parse(template,tags);var context=view instanceof Context?view:new Context(view);return this.renderTokens(tokens,context,partials,template,tags)};Writer.prototype.renderTokens=function renderTokens(tokens,context,partials,originalTemplate,tags){var buffer="";var token,symbol,value;for(var i=0,numTokens=tokens.length;i<numTokens;++i){value=undefined;token=tokens[i];symbol=token[0];if(symbol==="#")value=this.renderSection(token,context,partials,originalTemplate);else if(symbol==="^")value=this.renderInverted(token,context,partials,originalTemplate);else if(symbol===">")value=this.renderPartial(token,context,partials,tags);else if(symbol==="&")value=this.unescapedValue(token,context);else if(symbol==="name")value=this.escapedValue(token,context);else if(symbol==="text")value=this.rawValue(token);if(value!==undefined)buffer+=value}return buffer};Writer.prototype.renderSection=function renderSection(token,context,partials,originalTemplate){var self=this;var buffer="";var value=context.lookup(token[1]);function subRender(template){return self.render(template,context,partials)}if(!value)return;if(isArray(value)){for(var j=0,valueLength=value.length;j<valueLength;++j){buffer+=this.renderTokens(token[4],context.push(value[j]),partials,originalTemplate)}}else if(typeof value==="object"||typeof value==="string"||typeof value==="number"){buffer+=this.renderTokens(token[4],context.push(value),partials,originalTemplate)}else if(isFunction(value)){if(typeof originalTemplate!=="string")throw new Error("Cannot use higher-order sections without the original template");value=value.call(context.view,originalTemplate.slice(token[3],token[5]),subRender);if(value!=null)buffer+=value}else{buffer+=this.renderTokens(token[4],context,partials,originalTemplate)}return buffer};Writer.prototype.renderInverted=function renderInverted(token,context,partials,originalTemplate){var value=context.lookup(token[1]);if(!value||isArray(value)&&value.length===0)return this.renderTokens(token[4],context,partials,originalTemplate)};Writer.prototype.indentPartial=function indentPartial(partial,indentation,lineHasNonSpace){var filteredIndentation=indentation.replace(/[^ \t]/g,"");var partialByNl=partial.split("\n");for(var i=0;i<partialByNl.length;i++){if(partialByNl[i].length&&(i>0||!lineHasNonSpace)){partialByNl[i]=filteredIndentation+partialByNl[i]}}return partialByNl.join("\n")};Writer.prototype.renderPartial=function renderPartial(token,context,partials,tags){if(!partials)return;var value=isFunction(partials)?partials(token[1]):partials[token[1]];if(value!=null){var lineHasNonSpace=token[6];var tagIndex=token[5];var indentation=token[4];var indentedValue=value;if(tagIndex==0&&indentation){indentedValue=this.indentPartial(value,indentation,lineHasNonSpace)}return this.renderTokens(this.parse(indentedValue,tags),context,partials,indentedValue)}};Writer.prototype.unescapedValue=function unescapedValue(token,context){var value=context.lookup(token[1]);if(value!=null)return value};Writer.prototype.escapedValue=function escapedValue(token,context){var value=context.lookup(token[1]);if(value!=null)return mustache.escape(value)};Writer.prototype.rawValue=function rawValue(token){return token[1]};mustache.name="mustache.js";mustache.version="3.1.0";mustache.tags=["{{","}}"];var defaultWriter=new Writer;mustache.clearCache=function clearCache(){return defaultWriter.clearCache()};mustache.parse=function parse(template,tags){return defaultWriter.parse(template,tags)};mustache.render=function render(template,view,partials,tags){if(typeof template!=="string"){throw new TypeError('Invalid template! Template should be a "string" '+'but "'+typeStr(template)+'" was given as the first '+"argument for mustache#render(template, view, partials)")}return defaultWriter.render(template,view,partials,tags)};mustache.to_html=function to_html(template,view,partials,send){var result=mustache.render(template,view,partials);if(isFunction(send)){send(result)}else{return result}};mustache.escape=escapeHtml;mustache.Scanner=Scanner;mustache.Context=Context;mustache.Writer=Writer;return mustache});

/*
 *  jQuery screen skeleton - scheletrone - v1.0.6
 *  A jQuery plugin to make a skeleton loading of your html elements.
 *
 *  GitHub: https://github.com/enbifa/jquery.skeleton.loader
 *  Copyright (c) 2017 - Vincenzo Bifano
 */


;(function ( $, window, document ) {
'use strict';

    var debugLog = false;
    var IdElement = "";
    var Name = 'scheletrone';
    var ReplaceText;
    var Words = [
        "lorem", "ipsum", "dolor", "sit", "amet,", "consectetur", "adipiscing", "elit", "ut", "aliquam,", "purus", "sit", "amet", "luctus", "venenatis,", "lectus", "magna", "fringilla", "urna,", "porttitor", "rhoncus", "dolor", "purus", "non", "enim", "praesent", "elementum", "facilisis", "leo,", "vel", "fringilla", "est", "ullamcorper", "eget", "nulla", "facilisi", "etiam", "dignissim", "diam", "quis", "enim", "lobortis", "scelerisque", "fermentum", "dui", "faucibus", "in", "ornare", "quam", "viverra", "orci", "sagittis", "eu", "volutpat", "odio", "facilisis", "mauris", "sit", "amet", "massa", "vitae", "tortor", "condimentum", "lacinia", "quis", "vel", "eros", "donec", "ac", "odio", "tempor", "orci", "dapibus", "ultrices", "in", "iaculis", "nunc", "sed", "augue", "lacus,", "viverra", "vitae", "congue", "eu,", "consequat", "ac", "felis", "donec", "et", "odio", "pellentesque", "diam", "volutpat", "commodo", "sed", "egestas", "egestas", "fringilla", "phasellus", "faucibus", "scelerisque", "eleifend", "donec", "pretium", "vulputate", "sapien", "nec", "sagittis", "aliquam", "malesuada", "bibendum", "arcu", "vitae", "elementum",
        "curabitur", "vitae", "nunc", "sed", "velit", "dignissim", "sodales", "ut", "eu", "sem", "integer", "vitae", "justo", "eget", "magna", "fermentum", "iaculis", "eu", "non", "diam", "phasellus", "vestibulum", "lorem", "sed", "risus", "ultricies", "tristique", "nulla", "aliquet", "enim", "tortor,", "at", "auctor", "urna", "nunc", "id", "cursus", "metus", "aliquam", "eleifend", "mi", "in", "nulla", "posuere", "sollicitudin", "aliquam", "ultrices", "sagittis", "orci,", "a", "scelerisque", "purus", "semper", "eget", "duis", "at", "tellus", "at", "urna", "condimentum", "mattis", "pellentesque", "id", "nibh", "tortor,", "id", "aliquet", "lectus", "proin", "nibh", "nisl,", "condimentum", "id", "venenatis", "a,", "condimentum", "vitae", "sapien", "pellentesque", "habitant", "morbi", "tristique", "senectus", "et", "netus", "et", "malesuada", "fames", "ac", "turpis", "egestas", "sed", "tempus,", "urna", "et", "pharetra", "pharetra,", "massa", "massa", "ultricies", "mi,", "quis", "hendrerit", "dolor", "magna", "eget", "est", "lorem", "ipsum", "dolor", "sit", "amet,", "consectetur", "adipiscing", "elit", "pellentesque", "habitant", "morbi", "tristique", "senectus", "et", "netus", "et", "malesuada", "fames", "ac", "turpis", "egestas", "integer", "eget", "aliquet", "nibh", "praesent", "tristique", "magna", "sit", "amet", "purus", "gravida", "quis", "blandit", "turpis", "cursus", "in", "hac", "habitasse", "platea", "dictumst", "quisque", "sagittis,", "purus", "sit", "amet", "volutpat", "consequat,", "mauris", "nunc", "congue", "nisi,", "vitae", "suscipit", "tellus", "mauris", "a", "diam",
        "maecenas", "sed", "enim", "ut", "sem", "viverra", "aliquet", "eget", "sit", "amet", "tellus", "cras", "adipiscing", "enim", "eu", "turpis", "egestas", "pretium", "aenean", "pharetra,", "magna", "ac", "placerat", "vestibulum,", "lectus", "mauris", "ultrices", "eros,", "in", "cursus", "turpis", "massa", "tincidunt", "dui", "ut", "ornare", "lectus", "sit", "amet", "est", "placerat", "in", "egestas", "erat", "imperdiet", "sed", "euismod", "nisi", "porta", "lorem", "mollis", "aliquam", "ut", "porttitor", "leo", "a", "diam", "sollicitudin", "tempor", "id", "eu", "nisl", "nunc", "mi", "ipsum,", "faucibus", "vitae", "aliquet", "nec,", "ullamcorper", "sit", "amet", "risus", "nullam", "eget", "felis", "eget", "nunc", "lobortis", "mattis", "aliquam", "faucibus", "purus", "in", "massa", "tempor", "nec", "feugiat", "nisl", "pretium", "fusce", "id", "velit", "ut", "tortor", "pretium", "viverra", "suspendisse", "potenti", "nullam", "ac", "tortor", "vitae", "purus", "faucibus", "ornare", "suspendisse", "sed", "nisi", "lacus,", "sed", "viverra", "tellus", "in", "hac", "habitasse", "platea", "dictumst", "vestibulum", "rhoncus", "est", "pellentesque", "elit", "ullamcorper", "dignissim", "cras", "tincidunt", "lobortis", "feugiat", "vivamus", "at", "augue", "eget", "arcu", "dictum", "varius", "duis", "at", "consectetur", "lorem",
        "donec", "massa", "sapien,", "faucibus", "et", "molestie", "ac,", "feugiat", "sed", "lectus", "vestibulum", "mattis", "ullamcorper", "velit", "sed", "ullamcorper", "morbi", "tincidunt", "ornare", "massa,", "eget", "egestas", "purus", "viverra", "accumsan", "in", "nisl", "nisi,", "scelerisque", "eu", "ultrices", "vitae,", "auctor", "eu", "augue", "ut", "lectus", "arcu,", "bibendum", "at", "varius", "vel,", "pharetra", "vel", "turpis", "nunc", "eget", "lorem", "dolor,", "sed", "viverra", "ipsum", "nunc", "aliquet", "bibendum", "enim,", "facilisis", "gravida", "neque", "convallis", "a", "cras", "semper", "auctor", "neque,", "vitae", "tempus", "quam", "pellentesque", "nec", "nam", "aliquam", "sem", "et", "tortor", "consequat", "id", "porta", "nibh", "venenatis", "cras", "sed", "felis", "eget", "velit", "aliquet", "sagittis", "id", "consectetur", "purus", "ut", "faucibus", "pulvinar", "elementum", "integer", "enim", "neque,", "volutpat", "ac", "tincidunt", "vitae,", "semper", "quis", "lectus", "nulla", "at", "volutpat", "diam", "ut", "venenatis", "tellus", "in", "metus", "vulputate", "eu", "scelerisque", "felis", "imperdiet", "proin", "fermentum", "leo", "vel", "orci", "porta", "non", "pulvinar", "neque", "laoreet", "suspendisse", "interdum", "consectetur", "libero,", "id", "faucibus", "nisl", "tincidunt", "eget", "nullam", "non", "nisi", "est,", "sit", "amet", "facilisis", "magna",
        "etiam", "tempor,", "orci", "eu", "lobortis", "elementum,", "nibh", "tellus", "molestie", "nunc,", "non", "blandit", "massa", "enim", "nec", "dui", "nunc", "mattis", "enim", "ut", "tellus", "elementum", "sagittis", "vitae", "et", "leo", "duis", "ut", "diam", "quam", "nulla", "porttitor", "massa", "id", "neque", "aliquam", "vestibulum", "morbi", "blandit", "cursus", "risus,", "at", "ultrices", "mi", "tempus", "imperdiet", "nulla", "malesuada", "pellentesque", "elit", "eget", "gravida", "cum", "sociis", "natoque", "penatibus", "et", "magnis", "dis", "parturient", "montes,", "nascetur", "ridiculus", "mus", "mauris", "vitae", "ultricies", "leo", "integer", "malesuada", "nunc", "vel", "risus", "commodo", "viverra", "maecenas", "accumsan,", "lacus", "vel", "facilisis", "volutpat,", "est", "velit", "egestas", "dui,", "id", "ornare", "arcu", "odio", "ut", "sem", "nulla", "pharetra", "diam", "sit", "amet", "nisl", "suscipit", "adipiscing", "bibendum", "est", "ultricies", "integer", "quis", "auctor", "elit",
        "sed", "vulputate", "mi", "sit", "amet", "mauris", "commodo", "quis", "imperdiet", "massa", "tincidunt", "nunc", "pulvinar", "sapien", "et", "ligula", "ullamcorper", "malesuada", "proin", "libero", "nunc,", "consequat", "interdum", "varius", "sit", "amet,", "mattis", "vulputate", "enim", "nulla", "aliquet", "porttitor", "lacus,", "luctus", "accumsan", "tortor", "posuere", "ac", "ut", "consequat", "semper", "viverra", "nam", "libero", "justo,", "laoreet", "sit", "amet", "cursus", "sit", "amet,", "dictum", "sit", "amet", "justo", "donec", "enim", "diam,", "vulputate", "ut", "pharetra", "sit", "amet,", "aliquam", "id", "diam", "maecenas", "ultricies", "mi", "eget", "mauris", "pharetra", "et", "ultrices", "neque", "ornare", "aenean", "euismod", "elementum", "nisi,", "quis", "eleifend", "quam", "adipiscing", "vitae", "proin", "sagittis,", "nisl", "rhoncus", "mattis", "rhoncus,", "urna", "neque", "viverra", "justo,", "nec", "ultrices", "dui", "sapien", "eget", "mi", "proin", "sed", "libero", "enim,", "sed", "faucibus", "turpis", "in", "eu", "mi", "bibendum", "neque", "egestas", "congue", "quisque", "egestas", "diam", "in", "arcu", "cursus", "euismod", "quis", "viverra", "nibh", "cras", "pulvinar", "mattis", "nunc,", "sed", "blandit", "libero", "volutpat", "sed", "cras", "ornare", "arcu", "dui", "vivamus", "arcu", "felis,", "bibendum", "ut", "tristique", "et,", "egestas", "quis", "ipsum", "suspendisse", "ultrices", "gravida", "dictum",
        "fusce", "ut", "placerat", "orci", "nulla", "pellentesque", "dignissim", "enim,", "sit", "amet", "venenatis", "urna", "cursus", "eget", "nunc", "scelerisque", "viverra", "mauris,", "in", "aliquam", "sem", "fringilla", "ut", "morbi", "tincidunt", "augue", "interdum", "velit", "euismod", "in", "pellentesque", "massa", "placerat", "duis", "ultricies", "lacus", "sed", "turpis", "tincidunt", "id", "aliquet", "risus", "feugiat", "in", "ante", "metus,", "dictum", "at", "tempor", "commodo,", "ullamcorper", "a", "lacus", "vestibulum", "sed", "arcu", "non", "odio", "euismod", "lacinia", "at", "quis", "risus", "sed", "vulputate", "odio", "ut", "enim", "blandit", "volutpat", "maecenas", "volutpat", "blandit", "aliquam", "etiam", "erat", "velit,", "scelerisque", "in", "dictum", "non,", "consectetur", "a", "erat", "nam", "at", "lectus", "urna", "duis", "convallis", "convallis", "tellus,", "id", "interdum", "velit", "laoreet", "id", "donec", "ultrices", "tincidunt", "arcu,", "non", "sodales", "neque", "sodales", "ut", "etiam", "sit", "amet", "nisl", "purus,", "in", "mollis", "nunc",
        "sed", "id", "semper", "risus", "in", "hendrerit", "gravida", "rutrum", "quisque", "non", "tellus", "orci,", "ac", "auctor", "augue", "mauris", "augue", "neque,", "gravida", "in", "fermentum", "et,", "sollicitudin", "ac", "orci", "phasellus", "egestas", "tellus", "rutrum", "tellus", "pellentesque", "eu", "tincidunt", "tortor", "aliquam", "nulla", "facilisi", "cras", "fermentum,", "odio", "eu", "feugiat", "pretium,", "nibh", "ipsum", "consequat", "nisl,", "vel", "pretium", "lectus", "quam", "id", "leo", "in", "vitae", "turpis", "massa", "sed", "elementum", "tempus", "egestas", "sed", "sed", "risus", "pretium", "quam", "vulputate", "dignissim", "suspendisse", "in", "est", "ante", "in", "nibh", "mauris,", "cursus", "mattis", "molestie", "a,", "iaculis", "at", "erat",
        "pellentesque", "adipiscing", "commodo", "elit,", "at", "imperdiet", "dui", "accumsan", "sit", "amet", "nulla", "facilisi", "morbi", "tempus", "iaculis", "urna,", "id", "volutpat", "lacus", "laoreet", "non", "curabitur", "gravida", "arcu", "ac", "tortor", "dignissim", "convallis", "aenean", "et", "tortor", "at", "risus", "viverra", "adipiscing", "at", "in", "tellus", "integer", "feugiat", "scelerisque", "varius", "morbi", "enim", "nunc,", "faucibus", "a", "pellentesque", "sit", "amet,", "porttitor", "eget", "dolor", "morbi", "non", "arcu", "risus,", "quis", "varius", "quam", "quisque", "id", "diam", "vel", "quam", "elementum", "pulvinar", "etiam", "non", "quam", "lacus", "suspendisse", "faucibus", "interdum", "posuere", "lorem", "ipsum", "dolor", "sit", "amet,", "consectetur", "adipiscing", "elit", "duis", "tristique", "sollicitudin", "nibh", "sit", "amet", "commodo", "nulla", "facilisi",
        "nullam", "vehicula", "ipsum", "a", "arcu", "cursus", "vitae", "congue", "mauris", "rhoncus", "aenean", "vel", "elit", "scelerisque", "mauris", "pellentesque", "pulvinar", "pellentesque", "habitant", "morbi", "tristique", "senectus", "et", "netus", "et", "malesuada", "fames", "ac", "turpis", "egestas", "maecenas", "pharetra", "convallis", "posuere", "morbi", "leo", "urna,", "molestie", "at", "elementum", "eu,", "facilisis", "sed", "odio", "morbi", "quis", "commodo", "odio", "aenean", "sed", "adipiscing", "diam", "donec", "adipiscing", "tristique", "risus", "nec", "feugiat", "in", "fermentum", "posuere", "urna", "nec", "tincidunt", "praesent", "semper", "feugiat", "nibh", "sed", "pulvinar", "proin", "gravida", "hendrerit", "lectus", "a", "molestie"
    ];
        
    var  dataPlugin = 'plugin_' + Name,

            // default options, used for instantion, if not explicitly set
            defaults = {
			url         : '',
            ajaxData    : {},
            debug        : {
                log: false,
                latency: 0
            },
            maskText: false,
            skelParentText: false,
            removeIframe: false,
            backgroundImage: true,
            replaceImageWith: '',
            selector: '',
            incache : false,
            onComplete     : function() {
                _logger('default onComplete() event');
            }
		};


    /**
     *  jQuery screen skeleton - scheletrone
     *
     *  @alias scheletrone
     *  @constructor
     *
     *  @author   Vincenzo Bifano
     *
     *  @requires jquery.js
     *
     *  @param   {Object}        [options]                 - a set of options, to override the defaults
     *  @param   {Function}      [options.onComplete]      - the event is triggered after plugin is complete
     *
     *  @example 
     // minimal setup
        var instance = $('#element').square();

     // customized setup
        var instance = $('#skeleton').skeleton({
                url   : "index2.html",
                debug		: {
                    latency: 3000
                },
                incache: false,
                onComplete	: function() { _logger('plugin complete!'); }
           });

     */



    var Scheletrone  = function(element, options) {
        
        IdElement = $(element).attr('id');

        // This is the plugin's constructor
        // It is instantiated for each matched DOM element
        // The huge comment block above is JSDoc syntax, for generated documentation
        // The name of the constructor is used ONLY internally
        // As a general best-practise, constructors should be Capitalized

        // store the element element
        this.element = $(element);

        // override default options
        // create a new object, with all default settings, overridden only by the init options
        this.options = $.extend( {}, defaults, options );
        debugLog = this.options.debug.log;

        //element to skeletrize
        this.element    = element;
	    this.$container = $( element );


        //this.init();
        this.init();



    };
    /////////////////////////////////////
    //         Private methods         //
    /////////////////////////////////////
    /**
     *  Make the skeleton of a passed element 
     *
     *  @param   {Object}  objToSkeletrize  the element
     */
    var _makeitSkeleton = function (objToSkeletrize) {

                objToSkeletrize.addClass("pending_el ");

    }
    /**
     *  Make a text log 
     *
     *  @param   {string}  message text to log
     */
    var _logger = function (message) {
             
             if (debugLog)
             {
               console.log(message);
             }
    }

    var _replaceBackgroundImage = function (replaceImageWith,element)
    {
        _logger("*** _replaceBackgroundImage ***");
        var bgimage_url = $( element ).css('background-image');
        
        // ^ Either "none" or url("...urlhere..")
        bgimage_url = /^url\((['"]?)(.*)\1\)$/.exec(bgimage_url);
        bgimage_url = bgimage_url ? bgimage_url[2] : ""; // If matched, retrieve url, otherwise ""
        
        var bg_url = $( element ).css('background');
      
        // ^ Either "none" or url("...urlhere..")
        bg_url = /^url\((['"]?)(.*)\1\)$/.exec(bg_url);
        bg_url = bg_url ? bg_url[2] : ""; // If matched, retrieve url, otherwise ""
            

        

  

        if ((bgimage_url != '') || (bg_url != '') ) {
          
            $( element ).replaceWith("<div class='pending_el "+replaceImageWith+"' style='width:"+$( element ).width()+"px;height:"+$( element ).height()+"px;'></div>")
        
        }
        _logger("*** End _replaceBackgroundImage ***");
    }

    var _getAllStyles = function (elem) {
        if (!elem) return []; // Element does not exist, empty list.
        var win = document.defaultView || window, style, styleNode = [];
        if (win.getComputedStyle) { /* Modern browsers */
            
            style = win.getComputedStyle(elem, '');
            for (var i=0; i<style.length; i++) {
                styleNode.push( style[i] + ':' + style.getPropertyValue(style[i]) );
                //               ^name ^           ^ value ^
            }
        } else if (elem.currentStyle) { /* IE */
            style = elem.currentStyle;
            for (var name in style) {
                styleNode.push( name + ':' + style[name] );
            }
        } else { /* Ancient browser..*/
            style = elem.style;
            for (var i=0; i<style.length; i++) {
                styleNode.push( style[i] + ':' + style[style[i]] );
            }
        }
        return styleNode;
    }



    /**
     *  Delete node without data attribute
     *
     *  @param   {Object}  objToSkeletrize  the element
     *  @return  {Object}
     */

    var _retrieveOnlyToCache = function(data)
    {
        _logger("_retrieveOnlyToCache");
        _logger(data);
        var div = document.createElement('div');
        div.innerHTML = data;
        $( div ).children().each(function( index ) {
             _logger('a');
             _logger($(this).data("scheletrone") );
            if ( $(this).data("scheletrone") ) 
            {

            }
            else
            {
                 $( this ).remove();
                //IE11 compatibility issue #2
                //A small Element.remove() polyfill for IE 
                //https://stackoverflow.com/questions/20428877/javascript-remove-doesnt-work-in-ie
                //
                if (!('remove' in Element.prototype)) {
                    Element.prototype['remove'] = function () {
                    if (this.parentNode) {
                        this.parentNode.removeChild(this);
                    }
                    };
                }
            }
         });
        
         _logger("*** Cache Data ***");
         _logger(div.innerHTML);
         return div.innerHTML;
    }

    /**
     *  For an integer randomly
     *
     *  @param   {integer}  min  minimum
     *  @param   {integer}  max  maximum
     *  @return  {integer}
     */
    var _randomInt = function (min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    /**
     *  Count number of words in a text
     *
     *  @param   {string}  s  Text
     *  @return  {integer}
     */

    var _countWords =  function(s){
        s = s.replace(/(^\s*)|(\s*$)/gi,"");//exclude  start and end white-space
        s = s.replace(/[ ]{2,}/gi," ");//2 or more space to 1
        s = s.replace(/\n /,"\n"); // exclude newline with a start spacing
        return s.split(' ').length; 
    }


    /**
     *  Create text with Lore Ipsum words
     *
     *  @param   {integer}  count  number of words
     *  @param   {integer}  lenght  maximum lenght of the sentence
     *  @return  {string}
     */
    //text creator method with parameters: how many, what
    var _createText = function(count, length) {
        
          var wordIndex = _randomInt(0, Words.length - count - 1);
          var newWord = Words.slice(wordIndex, wordIndex + count).join(' ').replace(/[\.\,]/g,'');

         while (length - newWord.length > 0){
            newWord = _addWord(newWord  );
        }
        return newWord;
    
          
        
    }

    var _addWord = function(string) {
          
          var wordIndex = _randomInt(0, Words.length - 1);
          return string + " " +  Words[wordIndex];
    }



    ////////////////////////////////////
    //         Public methods         //
    ////////////////////////////////////
    Scheletrone.prototype = {

        /**
         *  Initializes the scheletrone.
         *  This is automatically called when the plugin is called.
         *
         *  @private
         */
        init: function () {
            var _this  = this.element;
            var __this = this;


            _logger(this);
            // iterate all children in element to make a skeleton
            
            if(this.options.removeIframe)
                jQuery('html').find('iframe').remove();


            if (this.options.incache)
            {
                _logger(this.getCache());
                 
                    this.element.innerHTML = this.getCache();
                   
            }

            

            $( _this ).find('*').each(function( index ) {
              
               

                $( this )
                .contents()
                    .filter(function() {
                        
                        return this.nodeType === 3;
                    })
                    .each(function(  ) {
                       if(typeof this.nodeValue != 'undefined'){ 
                        if(this.nodeValue.trim() != '')
                        {
                            _logger(this,"-- " + this.nodeValue.trim() + '--');

                            if (__this.options.maskText)
                            {
                                var numberOfWords = _countWords(this.nodeValue.trim());
                                var newText = _createText(numberOfWords,this.nodeValue.trim().length);
                                
                                this.nodeValue = newText;
                            }
                            if (__this.options.skelParentText)
                            {
                               var color = $( this ).parent().css( {"background-color" : "#ccc"} );
                             _logger(this,color);
                            }
                            return this
                        }
                       }
                        else
                        {
                            this.remove();
                              //IE11 compatibility issue #2
                            //A small Element.remove() polyfill for IE 
                            //https://stackoverflow.com/questions/20428877/javascript-remove-doesnt-work-in-ie
                            //
                            if (!('remove' in Element.prototype)) {
                                Element.prototype['remove'] = function () {
                                if (this.parentNode) {
                                    this.parentNode.removeChild(this);
                                }
                                };
                            }
                        }
                            
                    })
                    .wrap( "<div class='nodeType3' ></div>" )
                    .end()
                   
            });

             $( _this ).find('*').each(function( index ) {
                    var skeletizza = true;
                    //search for children
 
                    if (!__this.options.backgroundImage)
                         _replaceBackgroundImage(__this.options.replaceImageWith,this);

                    $( this ).css('color', '#ccc');

                    
                    
                    if($( this ).children().length == 0)
                    {
                                
                                if($( this ).is("BR"))
                                {
                                    skeletizza = false;
                                }

                                if($( this ).is("IMG"))
                                {
                                   
                                    var width = this.width;
                                    var height = this.height;
                                    var tempThis = this;
                                    var replaced = "<div class='pending_el " + __this.options.replaceImageWith + " ' style='width:"+width+"px;height:"+height+"px;)'></div>"
                                    $( this ).replaceWith(replaced);
                          
                                   
                                 
                                    skeletizza = false;
                                }

                                if (skeletizza)
                                {
                                    
                                    _makeitSkeleton($( this ));
                                
                                }
                    }
             });

            
            
     



            if (this.options.url != '')
            {
                _logger('prova');
                this.retrieveData();
            }
            // trigger onComplete callback
            if (this.options.onComplete && typeof(this.options.onComplete) == "function")
                this.options.onComplete();
        },
        retrieveData: function () {
        var obj = this;
 
       
                if (this.options.debug.latency > 0)
                {
                    
                setTimeout(function(){
                 
                            $.ajax({
                                url: obj.options.url,
                                dataType: "html",
                                data: obj.options.ajaxData,
                                success: function(data) {
                                    
                                    _logger(obj.options.debug.log,"obj.element " + obj.element);
                                   
                                      
                                        if (obj.options.selector != '')
                                        {
                                            var parsedResponse = $.parseHTML(data);
                                      
                                            var result = $(parsedResponse).filter(obj.options.selector);
                                            _logger("*** Selector *** ");
                                            _logger(obj.options.selector);
                                            _logger(result.html());
                                            _logger("*** End Selector *** ");
                                            $( obj.element ).html('').append((result));
                                        }
                                        else
                                        {
                                            $( obj.element ).html('').append((data));
                                        }



                                        if (obj.options.incache)
                                        {
                                            _logger(obj.options.debug.log,'setcache');
                                            var cacheData = _retrieveOnlyToCache(data);
                                            obj.setCache(cacheData);
                                        }
                                }
                            });
                    }, obj.options.debug.latency);
                }
                else{
                    
                    $.ajax({
                                url: obj.options.url,
                                dataType: "html",
                                data: obj.options.ajaxData,
                                success: function(data) {
                                    
                                    _logger(obj.options.debug.log,obj);
                                  
                                    if (obj.options.selector != '')
                                    {
                                        //Populate with only a specific content Issue #4
                                        var parsedResponse = $.parseHTML(data);
                                        var result = $(parsedResponse).filter(obj.options.selector);
                                        _logger("*** Selector *** ");
                                        _logger(obj.options.selector);
                                        _logger(result.html());
                                        _logger("*** End Selector *** ");
                                        $( obj.element ).html('').append((result));
                                    }
                                    else
                                    {
                                        $( obj.element ).html('').append((data));
                                    }


                                }
                            });
                }

        },
        /**
         *  Stop loading on div - pass it on construction
         *
         * @example this.stopLoader();
         */
        stopLoader: function () {
            var obj = this;
            $(obj.element).html('');
            
        },
        /**
         *  Store the asynchronus data in localstorage
         *
         *  @example this.setCache(data);
         */
        setCache : function ( result_data ) {
            // Cache data
           
            if ( window.localStorage ) {
                var url = window.location.pathname;
                var filename = url.substring(url.lastIndexOf('/')+1);


                window.localStorage.setItem( filename + "-" + "div-"+IdElement+"-skeleton:" ,  result_data  );
            }
        },
        /**
         *  Retrieve stored scheletrone in localstorage
         *
         *  @example this.getCache();
         */
        getCache : function() {

            if ( window.localStorage ) {
                var url = window.location.pathname;
                var filename = url.substring(url.lastIndexOf('/')+1);
                return window.localStorage.getItem( filename + "-" + "div-"+IdElement+"-skeleton:" );
            }
            else {
                return false;
            }
        },
        
    };



  
    







   //////////////////////////////////////////////////
    //         Plugin wrapper                       //
    //////////////////////////////////////////////////


    // A plugin wrapper around the constructor, preventing against multiple instantiations
    $.fn[Name] = function ( options ) {
        var instance;

        // If the first parameter is an object (options), or was omitted,
        // call Plugin.init()
        if ( typeof options === 'undefined' || typeof options === 'object' ) {
            return this.each(function () {
                // prevent multiple instantiations
                if ( !$.data(this, dataPlugin )) {
                    $.data(
                        this, 
                        dataPlugin, 
                        new Scheletrone( this, options )
                    );
                }

                instance = $(this).data( dataPlugin );

                if ( typeof instance['init'] === 'function' ) {
                    instance.init();
                }
            });

        // checks that the requested public method exists
        } else if ( typeof options === 'string' ) {
            var methodName = arguments[0],
                args = Array.prototype.slice.call(arguments, 1),
                returnVal;

            this.each(function() {
                var instance = $(this).data( dataPlugin );

                // Check that the element has a plugin instance, and that
                // the requested public method exists.
                if ( $.data(this, dataPlugin) && typeof $.data(this, dataPlugin)[methodName] === 'function' ) {
                    // Call the method of the Plugin instance, and Pass it
                    // the supplied arguments.
                    returnVal = $.data(this, dataPlugin)[methodName].apply(instance, args);
                } else {
                    console.info('Method ' + options + ' does not exist on jQuery.' + Name);
                }
            });

            if ( typeof returnVal !== 'undefined' ){
                // If the method returned a value, return the value
                return returnVal;
            } else {
                // Otherwise, returning 'this' preserves chainability
                return this;
            }
        } else {
            console.info('Method ' + options + ' does not exist on jQuery.' + Name);
        }
    };
})( jQuery, window, document );
//#EMAIL_ME#

$(document).ready(function () {
   //alert("funziona2")
    /**
    * Function that open the newsletter email from button pdp
    */


    /**
    * Function that close the newsletter
    */
    $('.comingSoon__close').click(function () {
      closeform();
    });

    /**
    * Function that close the newsletter emailme when click in fade layer
    */
    $('.comingSoon--fade').click(function () {
        $('.comingSoon__close').click();
        $('body').removeClass('no-scroll');
        $('body, html').css('height', 'auto');
        $('body, html').css('overflow', 'visible');
    });

    $('#close_emailme').click(function () { 
     closeform();
    });
}).mouseup(function (e) {

});

function closeform(){
    changeTabIndex($('.comingSoon'));
    $('.comingSoon').removeClass('opend');
    $('.comingSoon--fade').hide();
    $('body').removeClass('no-scroll');
    $('body, html').css('height', 'auto');
    $('body, html').css('overflow', 'visible');
}

function resetFrom(){
//form completo da visualizzare
$('#mce-error-response_emailme').hide();
$('.comingSoon__infoSuccess').hide();
$('.comingSoon__titleSuccess').hide();
$('.comingSoon__info').show();
$('.comingSoon__title').show();
$('.input_emailme').show();
$('.check_emailme').show();
$('#confirm_emailme').show();
$('#close_emailme').hide();
$('.buttonEmailme').css('margin-top','0px');
}
//#EMAIL_ME#

function assignCustomerSegmentToUser(espotName){
  
  /*for ex- > espotName = AddToCustomerSegment_Espot*/
  /* When AddToCustomerSegment_Espot is called, activity AddToCustomerSegment_CustomerWeek is triggered*/
  /*Activiy adds the current user to customer segment, specified in the activity*/
    
  var espotServiceUrl = WCParamJS.urlPrefixForHTTPS + "/wcs/resources/store/" + WCParamJS.storeId + "/espot/" + espotName+"?"+Date.now();
    $.ajax({
      url: espotServiceUrl,
      dataType: "html",
      async: true,
      success: function(data) {
        console.log("User added to customer segment correctly");
        /* Reload page after 1st cookie creation so that the espots related to cookie can work */
        if (isPersol && $("meta[name='pageIdentifier'").attr("content") != 'POnewsletterpromo' || isVogue && $("meta[name='pageIdentifier'").attr("content") != 'MBBnewsletterpromo1'){
             if(window.location.href.toLocaleLowerCase().includes("cid") && window.location.href.toLocaleLowerCase().includes("promo") ){
                 var redirectUrl = removeParam("promo",window.location.href);
                 window.location = redirectUrl; // Reload without promo parameter
             }else{
            	 if(!window.location.href.includes("UserRegistrationForm") && !window.location.href.includes("AjaxLogonForm") ){
            		 window.location = window.location.href.split("?")[0]; // Reload without promo parameter
            	 }
             }	   
          }
      },
      error: function(data){
        console.log("Error adding user to customer segment");
      }
    });
}
     

     
function removeCustomerSegmentToUser(espotName){
  
  /*for ex- > espotName = AddToCustomerSegment_Espot*/
  /* When AddToCustomerSegment_Espot is called, activity AddToCustomerSegment_CustomerWeek is triggered*/
  /*Activiy removes the current user to customer segment, specified in the activity*/
 
  var espotServiceUrl = WCParamJS.urlPrefixForHTTPS + "/wcs/resources/store/" + WCParamJS.storeId + "/espot/" + espotName+"?"+Date.now();

    $.ajax({
        url: espotServiceUrl,
        dataType: "html",
        success: function(data) {
          console.log("User removed to customer segment correctly");
          /* Reload page after 1st cookie creation so that the espots related to cookie can work */
          if (isPersol && $("meta[name='pageIdentifier'").attr("content") != 'POnewsletterpromo' || isVogue && $("meta[name='pageIdentifier'").attr("content") != 'MBBnewsletterpromo1'){
            if(window.location.href.toLocaleLowerCase().includes("cid") && window.location.href.toLocaleLowerCase().includes("promo") ){
              var redirectUrl = removeParam("promo",window.location.href);
              window.location = redirectUrl; // Reload without promo parameter
              }else{
            	  if(!window.location.href.includes("UserRegistrationForm") && !window.location.href.includes("AjaxLogonForm") ){
             		 window.location = window.location.href.split("?")[0]; // Reload without promo parameter
             	 }
             }	 
           }
        },
        error: function(data){
          console.log("Error removing user to customer segment");
        }
    });
     
}

/*function activateCustomerWeek(){
        if(typeof getCookie(CustomerWeek.cookieName) == "undefined" || getCookie(CustomerWeek.cookieName) == ""){
        var date = new Date();
        date.setDate(date.getDate() + 14);
        setCookie(CustomerWeek.cookieName,CustomerWeek.cookieValue, {path:'/', domain:cookieDomain, expires:date.toUTCString()});
        customerWeekActive=true;
        
        if (typeof ct_customerWeek_cookieCheck !== "undefined") { 
          ct_customerWeek_cookieCheck(); //It's a content team function
          } 
      }
}*/


function assignCustomerSegment(segment){
  try {
      var currentDate = new Date();
      if ($("#customerSegmentJSONdata .left_espot").text().length > 0) {
        window.segmentsArray = JSON.parse($("#customerSegmentJSONdata .left_espot").text());
        if (segmentsArray != undefined && segmentsArray.length>0){ 
          var userCSegmentsList = [];
          $(segmentsArray).each(function(){
              /* segment is an optional parameter used to search for a specific segment without scrolling the whole segmentsArray */
              if (segment == undefined || this.customerSegment == segment){
              /* Check expiration date */
              this.startDate = new Date(this.startDate);
              this.endDate = new Date(this.endDate);
              if (this.startDate <= currentDate && currentDate <= this.endDate){
                  if(!(document.cookie.includes('X_WC_PR_SEGMENTS'))) {
                    var currentActiveSegment = this;
                    /* Call REST Service with all current customer segments */
                    userCSegmentsList = getUserSegments();
                    $(userCSegmentsList).each(function(){
                      var activeUserSegment = (this.segments != "") ? this.segments.replace("PST","").replaceAll("_","").toLowerCase() : "";
                      if (currentActiveSegment.customerSegment.toLowerCase() != activeUserSegment){
                        /* Set cookie with active customerSegment */
                        setCustomerSegmentCookie(currentActiveSegment.customerSegment, currentActiveSegment.endDate);
                        /* Call the proper Web activity URL to add the customer to the promotional segment Early Access */
                        assignCustomerSegmentToUser("AddToCustomerSegment_Espot");
                      /*
                      } else {
                        setCustomerSegmentCookie(currentActiveSegment.customerSegment, currentActiveSegment.endDate);
                      */
                      }
                    });
                  } else window.customerSegment = getCookie('X_WC_PR_SEGMENTS');
              } else if (currentDate > this.endDate && document.cookie.includes('X_WC_PR_SEGMENTS')){
                /* Delete X_WC_PR_SEGMENTS cookie */
                var customerSegment = getCookie("X_WC_PR_SEGMENTS");
                setCustomerSegmentCookie(customerSegment, this.endDate)
                /* Call the proper Web activity URL to remove the customer from the promotional segment Early Access */
                removeCustomerSegmentToUser("RemoveFromCustomerSegment_Espot");
              }
            }
          });
        }
      }
      //  Hide PDP tooltip [Replaced by Activity]
      /*
      if (document.cookie.includes('X_WC_PR_SEGMENTS')) {
        $("<style type='text/css'> #customerSegmentTooltip { display: none; } </style>").appendTo("head");
      }
      */
  } catch (e) {
    	console.error("Error in assigning customer segment",e);
    }
}

function setCustomerSegmentCookie(customerSegment, endDate){

    setCookie("X_WC_PR_SEGMENTS", customerSegment, {path:'/', domain:cookieDomain, expires: endDate});
    window.customerSegment = customerSegment;
}

/* This function gets all the customer segments active on user */

function getUserSegments(){

  var userSegments;
  var userId = getUserId();
  if (userId == "-1002") userId = setUserIdentity();
  var url = WCParamJS.urlPrefixForHTTPS + "/wcs/resources/store/" + WCParamJS.storeId + "/earlyaccess/" + "?userId=" + userId;

  $.ajax({
      url: url,
      method: "GET",
      async: false,
      success: function(data) {
        console.log("User customer segments retrieved correctly");
        userSegments = data;
      },
      error: function(data){
        console.log("Error retrieving user customer segments");
      }
  });
  return userSegments;
}



function closeTooltip(){
  $("#customerSegmentTooltip .closeButton").parent().hide();
}




function removeParam(key, sourceURL) {
  var rtn = sourceURL.split("?")[0],
      param,
      params_arr = [],
      queryString = (sourceURL.indexOf("?") !== -1) ? sourceURL.split("?")[1] : "";
  if (queryString !== "") {
      params_arr = queryString.split("&");
      for (var i = params_arr.length - 1; i >= 0; i -= 1) {
          param = params_arr[i].split("=")[0];
          if (param === key) {
              params_arr.splice(i, 1);
          }
      }
      if (params_arr.length) rtn = rtn + "?" + params_arr.join("&");
  }
  return rtn;
}

!function(e,o){if("function"==typeof define&&define.amd)define(["exports"],o);else if("undefined"!=typeof exports)o(exports);else{var t={};o(t),e.bodyScrollLock=t}}(this,function(exports){"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var t=!1;if("undefined"!=typeof window){var e={get passive(){t=!0}};window.addEventListener("testPassive",null,e),window.removeEventListener("testPassive",null,e)}function l(o){return c.some(function(e){return!(!e.options.allowTouchMove||!e.options.allowTouchMove(o))})}function d(e){var o=e||window.event;return!!l(o.target)||(1<o.touches.length||(o.preventDefault&&o.preventDefault(),!1))}function n(){void 0!==v&&(document.body.style.paddingRight=v,v=void 0),void 0!==s&&(document.body.style.overflow=s,s=void 0)}var i="undefined"!=typeof window&&window.navigator&&window.navigator.platform&&(/iP(ad|hone|od)/.test(window.navigator.platform)||"MacIntel"===window.navigator.platform&&1<window.navigator.maxTouchPoints),c=[],a=!1,u=-1,s=void 0,v=void 0;exports.disableBodyScroll=function(r,e){if(r){if(!c.some(function(e){return e.targetElement===r})){var o={targetElement:r,options:e||{}};c=[].concat(function(e){if(Array.isArray(e)){for(var o=0,t=Array(e.length);o<e.length;o++)t[o]=e[o];return t}return Array.from(e)}(c),[o]),i?(r.ontouchstart=function(e){1===e.targetTouches.length&&(u=e.targetTouches[0].clientY)},r.ontouchmove=function(e){var o,t,n,i;1===e.targetTouches.length&&(t=r,i=(o=e).targetTouches[0].clientY-u,l(o.target)||(t&&0===t.scrollTop&&0<i||(n=t)&&n.scrollHeight-n.scrollTop<=n.clientHeight&&i<0?d(o):o.stopPropagation()))},a||(document.addEventListener("touchmove",d,t?{passive:!1}:void 0),a=!0)):function(e){if(void 0===v){var o=!!e&&!0===e.reserveScrollBarGap,t=window.innerWidth-document.documentElement.clientWidth;o&&0<t&&(v=document.body.style.paddingRight,document.body.style.paddingRight=t+"px")}void 0===s&&(s=document.body.style.overflow,document.body.style.overflow="hidden")}(e)}}else console.error("disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.")},exports.clearAllBodyScrollLocks=function(){i?(c.forEach(function(e){e.targetElement.ontouchstart=null,e.targetElement.ontouchmove=null}),a&&(document.removeEventListener("touchmove",d,t?{passive:!1}:void 0),a=!1),u=-1):n(),c=[]},exports.enableBodyScroll=function(o){o?(c=c.filter(function(e){return e.targetElement!==o}),i?(o.ontouchstart=null,o.ontouchmove=null,a&&0===c.length&&(document.removeEventListener("touchmove",d,t?{passive:!1}:void 0),a=!1)):c.length||n()):console.error("enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.")}});

/*! jquery.cookie v1.4.1 | MIT */
!function(a){"function"==typeof define&&define.amd?define(["jquery"],a):"object"==typeof exports?a(require("jquery")):a(jQuery)}(function(a){function b(a){return h.raw?a:encodeURIComponent(a)}function c(a){return h.raw?a:decodeURIComponent(a)}function d(a){return b(h.json?JSON.stringify(a):String(a))}function e(a){0===a.indexOf('"')&&(a=a.slice(1,-1).replace(/\\"/g,'"').replace(/\\\\/g,"\\"));try{return a=decodeURIComponent(a.replace(g," ")),h.json?JSON.parse(a):a}catch(b){}}function f(b,c){var d=h.raw?b:e(b);return a.isFunction(c)?c(d):d}var g=/\+/g,h=a.cookie=function(e,g,i){if(void 0!==g&&!a.isFunction(g)){if(i=a.extend({},h.defaults,i),"number"==typeof i.expires){var j=i.expires,k=i.expires=new Date;k.setTime(+k+864e5*j)}return document.cookie=[b(e),"=",d(g),i.expires?"; expires="+i.expires.toUTCString():"",i.path?"; path="+i.path:"",i.domain?"; domain="+i.domain:"",i.secure?"; secure":""].join("")}for(var l=e?void 0:{},m=document.cookie?document.cookie.split("; "):[],n=0,o=m.length;o>n;n++){var p=m[n].split("="),q=c(p.shift()),r=p.join("=");if(e&&e===q){l=f(r,g);break}e||void 0===(r=f(r))||(l[q]=r)}return l};h.defaults={},a.removeCookie=function(b,c){return void 0===a.cookie(b)?!1:(a.cookie(b,"",a.extend({},c,{expires:-1})),!a.cookie(b))}});
var badgeVisible = true;

if (!Object.assign) {
    Object.defineProperty(Object, 'assign', {
      enumerable: false,
      configurable: true,
      writable: true,
      value: function(target, firstSource) {
        'use strict';
        if (target === undefined || target === null) {
          throw new TypeError('Cannot convert first argument to object');
        }

        var to = Object(target);
        for (var i = 1; i < arguments.length; i++) {
          var nextSource = arguments[i];
          if (nextSource === undefined || nextSource === null) {
            continue;
          }
          nextSource = Object(nextSource);

          var keysArray = Object.keys(Object(nextSource));
          for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex++) {
            var nextKey = keysArray[nextIndex];
            var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
            if (desc !== undefined && desc.enumerable) {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
        return to;
      }
    });
  }

// Global variables
var defaultSearchProfile = getUrlParameter('searchTerm') ? 'LUX_findProductsBySearchTerm' : 'LUX_findProductsByCategory_group';
var countSelectedFacets = 0, defaultOrderBy, selectedFacetsData = {}, selectedFacets = {}, originalHrefApply = '', previousFilter = {}, originalSelectedSort = "";
var tileIndex = 0;
var indexSearchPanel = 0;

//Filter & OrderBy variables
var queryFilters = [],
    queryOrderBy = [],
    emptyFilters = true,
    emptyOrderBy = true,
    numMaxofPages,
    index,
    isFacetApplied = false;

queryParams = {
    storeId: WCParamJS.storeId,
    catalogId: WCParamJS.catalogId,
    responseFormat: 'json',
    langId: WCParamJS.langId,
    currency: WCParamJS.commandContextCurrency,
    profileName: defaultSearchProfile,
    searchSource: 'E',
    isForPLP: true
};

var featuredProductHtml = "";

/* BEGIN - Workarounds for IE */
if (!String.prototype.startsWith) {
  String.prototype.startsWith = function(searchString, position) {
    position = position || 0;
    return this.indexOf(searchString, position) === position;
  };
}
if (!String.prototype.endsWith) {
  String.prototype.endsWith = function(searchString, position) {
      var subjectString = this.toString();
      if (typeof position !== 'number' || !isFinite(position)
          || Math.floor(position) !== position || position > subjectString.length) {
        position = subjectString.length;
      }
      position -= searchString.length;
      var lastIndex = subjectString.indexOf(searchString, position);
      return lastIndex !== -1 && lastIndex === position;
  };
}
(function() {
	  function remove() { this.parentNode && this.parentNode.removeChild(this); }
	  if (!Element.prototype.remove) Element.prototype.remove = remove;
	  if (Text && !Text.prototype.remove) Text.prototype.remove = remove;
	})();
/* END - Workarounds for IE */
columnsToShow = 4
//	Skeleton Loader variables
var $plpSearchObj = {};
$plpSearchObj.itemsPerPage = 0;		// infinite scroll page(group) size
$plpSearchObj.itemsFromServer = 0;	// how many to get from API
$plpSearchObj.viewIndex = 0;		// index of items to show in view
$plpSearchObj.lastIndex = 0;
$plpSearchObj.resultCount = 0;
$plpSearchObj.viewMoreClicked = false;
$plpSearchObj.viewMoreSearchCount = 0;
$plpSearchObj.viewMoreSearchStartIndex = 0;
$plpSearchObj.productsServiceUrl = function(searchedWord) {
	if(storeDirectory === 'PersolGR' && host !== 'localhost'){
        WCParamJS.homePageURL = "https://"+ host + "/greece";
    }
	var baseSearchURL = (isInToolkit ? '' : WCParamJS.homePageURL)+'/search/resources/store/'+WCParamJS.storeId+'/productview/';
	var searchTerm = getUrlParameter('searchTerm');
    /* START Early Access */
    if (isPersol) {
        if (window.customerSegment != undefined && window.customerSegment != ""){
            queryParams.customerSegment = window.customerSegment;
        }
    }
    /* END Early Access */
	if (searchTerm || searchedWord) {
		return baseSearchURL+'bySearchTerm/' + (searchedWord ? searchedWord : searchTerm); // Search Obtimization
	}
	return baseSearchURL+'byCategory/'+ document.querySelector('meta[name="pageId"]').getAttribute('content');
}
$plpSearchObj.lastIndexbkp = 0;

function fn_plpFirstTiles(productData,searchedWord,isWishlist,wishlistToDeleteData,firstSearch) {
	// # Load Espot contents (TOP e MIDDLE creati durante il render delle tile)
	if (typeof isWishlist == "undefined"){
        var isWishlist = $("#page").hasClass("wishListDisplay") ? true : false;
    }

    if (!isWishlist){
        selectedFacetsData = {
            storeId : WCParamJS.storeId,
            catalogId: WCParamJS.catalogId,
            fromPage: 'catalogEntryList',
            beginIndex: '0',
            responseFormat: 'json',
            orderBy: defaultOrderBy,
            categoryId: ""
        };
    } else {
        if (typeof sessionStorage.wishlistObj != "undefined"){
            var wishlistObjCount = Object.keys(JSON.parse(sessionStorage.wishlistObj)).length;
            var countString = "(" + wishlistObjCount + ")";
            $(".title-wishlist_count").html(countString);
            if (wishlistObjCount == 0){
                $("#box.wishlist").addClass("emptyWishlist");
                $("#empty-wishlist-container").removeClass("hidden");
                if (isOliver && $("#wishlistAppointmentEspot").length > 0) $("#wishlistAppointmentEspot").remove();
            } else {
                $("#box.wishlist").removeClass("emptyWishlist");
                $("#empty-wishlist-container").addClass("hidden");
            }
        }
    }

 
	$plpSearchObj.itemsPerPage = (typeof pageSection_1 !== 'undefined' && sessionStorage.plpTitle == pageSection_1 && sessionStorage.backItemsPerPage) ? parseInt(sessionStorage.backItemsPerPage) : columnsToShow*parseInt($("#rowsPerPage").val());			// infinite scroll page(group) size
	$plpSearchObj.itemsFromServer = (typeof pageSection_1 !== 'undefined' && sessionStorage.plpTitle == pageSection_1 & sessionStorage.itemsToLoad) ? parseInt(sessionStorage.itemsToLoad) : parseInt($("#itemsFromServer").val());					// how many to get from API
	//facet search page e plp credo
    
    if(document.querySelector('.plp') || document.querySelector('.search') || document.querySelector('.searchPanel') ) {
        // Get facets to show in filter by if it's not the Persol search
        /**
        // facets are excluded by search in Persol 
        if (!isWishlist){
            if (isOliver || isPersol) {
                $plpSearchObj.facetsForFilterBy = {};
                if ($('input#facetsForFilterBy').length){
                var facetsForFilterByArr = $('input#facetsForFilterBy').val().split(';');
                    for (var i=0;i<facetsForFilterByArr.length; i++) {
                        var facetArr = facetsForFilterByArr[i].split(':');
                        if (facetArr.length == 2) {
                            $plpSearchObj.facetsForFilterBy[facetArr[0]] = facetArr[1];
                            //queryParams['f.'+facetArr[1].substring(0,facetArr[1].indexOf('%3A'))+'.facet.mincount'] = 0;
                        }
                    }
                // Get facets to be ignored
                $plpSearchObj.facetsToBeIgnored = $('input#facetsToBeIgnored').val().split(';');
                }
            }
        }
        */

        setDefaultSortBy(defaultOrderBy, false, productData,searchedWord,isWishlist,wishlistToDeleteData,firstSearch);
        var pageElem = document.getElementById('page');
        var blockFilter = document.querySelector('.block-filter');
        var originalFilterParentElem = "";
        var facetButtonElem = document.querySelector('.plp-filter-button');

        //Different views buttons - By default, on mobile show 2 columns view; on desktop show 3 columns view
        if(!searchedWord){
            if (window.tabletPortraitCheck() || window.mobilecheck()){
                if (!isWishlist) {
                    $('.button-views.two-col-icon').addClass("active");
                    $('.grid_mode').addClass('grid_mode-two-cols');
                }
            }

            // ex --Apply facets when you click the apply button
            

            if(document.querySelector('.search-page')) {
                originalFilterParentElem = document.querySelector('#content > .search-page');
            } else {
                originalFilterParentElem = document.querySelector('#content > .plp');
            }

            if (document.querySelector(".facet__apply")) {
                originalHrefApply = document.querySelector(".facet__apply").getAttribute('data-href');
            }

            //show description before offset calculation: description can born displayed?
            if (isOliver){
                $('.description.descriptionDefault').css('display','flex');
                if (window.tabletPortraitCheck() || window.mobilecheck()) {
                    var espotHeight= $( "#contentRecommendationWidget_X_PLP_HeroBanner_X_PLP_HeroBanner").height();
                    //var textHeight =$(".descriptionDefault").height();
                    //var marginButtons= espotHeight - textHeight
                    //$('.plp-filter-view-button').css("margin-top","-"+$('.grid.product-list').css('margin-top'));
                }
            }

            // Change DOM facet button position to make it FIXED
                if (!isWishlist){
                    var class_startscroll = ".plp-filter-button_wrapper";
                    if (isPersol && document.querySelector('.search')) {
                        class_startscroll = ".searchSummaryWidget";
                    }
                    
                    var offset = $(class_startscroll).offset().top;
                    var totalOffset = offset;
                    if(window.mobilecheck() || window.tabletPortraitCheck()) {
                        totalOffset = offset + $(class_startscroll + ' .espot-plp-beans').outerHeight() + 56;
                    }
                } else {
                    if($plpSearchObj.viewIndex >= $plpSearchObj.lastIndex) {                    
                        //clean up the grid
                        $('.plp-grid-skeleton').remove();
                    }

                    //Remove extra empty <li> tags in wishlist page
                    if (isWishlist) {
                        if (typeof sessionStorage.wishlistObj != "undefined"){
                            var wishlistProducts = JSON.parse(sessionStorage.wishlistObj);
                            var productsLength = Object.keys(wishlistProducts).length;

                            if (productsLength == 0){
                                if ($("#wishlist_grid li").length > 0) {
                                    $("#wishlist_grid li").remove();
                                }
                            } else {
                                for (var i=0 ;i<productsLength; i++){
                                    var wishlistLi = $("#wishlist_grid li")[i];
                                    if ($(wishlistLi).html() == ""){
                                        $(wishlistLi).remove();
                                    }
                                }
                            }
                        }
                    }
                }
                window.addEventListener('scroll', function() {
                    if (!isWishlist){
                    /** Sticky submenu in plp */
                        if (isPersol) {
                            if(window.mobilecheck() || window.tabletPortraitCheck()) {
                                if ($('#ci_espot__X_Header_GlobalBanner').length){
                                    var checkPersol = $(this).scrollTop() + $('#ci_espot__X_Header_GlobalBanner').height();
                                } else {
                                    var checkPersol = $(this).scrollTop() +1;
                                }
                            } else {
                                if ($('#ci_espot__X_Header_GlobalBanner').length){
                                    var checkPersol = $(this).scrollTop() - $(".ct-global--slider-container.ct-strip").height() + $('#ci_espot__X_Header_GlobalBanner').height();
                                }
                                else {
                                    var checkPersol = $(this).scrollTop() - $(".ct-global--slider-container.ct-strip").height();
                                }
                            }

                            var getBannerTopHeight = function () {
                                if($('#bannerTop').length && $('#bannerTop').is(":visible")) {
                                    return $('#bannerTop').height();
                                } else {
                                    return 0;
                                }
                            }

                            var offset2 = 0;
                            if (window.mobilecheck() || window.tabletPortraitCheck()) {
                                offset2 = $(class_startscroll + " .espot-plp-beans").outerHeight() + 10;
                            }

                            if(checkPersol >= (offset + offset2)){
                                if(window.innerWidth >= 1024 && window.innerWidth < 1300 && window.matchMedia("(orientation: landscape)").matches){
                                    $(class_startscroll).css('top', getBannerTopHeight());
                                } else if(!(window.mobilecheck() || window.tabletPortraitCheck())){
                                    $(class_startscroll).css('top', getBannerTopHeight());
                                } else {
                                    $(class_startscroll).css('top', $('#header').height() + getBannerTopHeight()-1);
                                }

                                if (document.querySelector('.search') == null) {
                                    $(class_startscroll).addClass('plp-filter-button_wrapper--sticky');
                                    if(!(window.mobilecheck() || window.tabletPortraitCheck())){
                                        $(".grid.product-list:not(.grid.product-list-espot)").css("margin-top", $(".plp-filter-button_wrapper").outerHeight() );
                                        $('.plp-wrapper-title').show();
                                        $('.plp-filter-button_wrapper--sticky').css("top",$('.ct-promo-banner').height());
                                    }else {
                                        $(".grid.product-list:not(.grid.product-list-espot)").css("margin-top", "168.8px" );
                                        var stripHeight = $('.ct-promo-banner').height();
                                        var headerHeight = $('#header').outerHeight();
                                        $('.plp-filter-button_wrapper--sticky').css("top",parseInt(stripHeight)+parseInt(headerHeight));
                                    }
                                }
                            }else{
                                $(class_startscroll).css('top', 'auto');

                                if (document.querySelector('.search') == null) {
                                    $(class_startscroll).removeClass('plp-filter-button_wrapper--sticky');
                                    $('.plp-wrapper-title').hide();
                                    $(".grid.product-list:not(.grid.product-list-espot)").css("margin-top", 0 );
                                }
                            }
                        }
                    }
                    
                    var documentBottom = $(window).scrollTop()+$(window).outerHeight();
                    
                    if($(".plp-grid-skeleton").length > 0) {
                        var skeletonTop =  $(".plp-grid-skeleton").offset().top;
                        //retiver info origina plp 
                        
                        
                        if (skeletonTop <= documentBottom
                                && $plpSearchObj.viewIndex < $plpSearchObj.lastIndex
                                && !$plpSearchObj.busy) {
                            $plpSearchObj.viewMoreTiles($plpSearchObj.itemsPerPage);
                        }

                        if($plpSearchObj.viewIndex >= $plpSearchObj.lastIndex && $plpSearchObj.viewIndex!=0) {                    
                            //clean up the grid
                            $('.plp-grid-skeleton').remove();

                            //Remove extra empty <li> tags in wishlist page
                            if (isWishlist) {
                                if (typeof sessionStorage.wishlistObj != "undefined"){
                                    var wishlistProducts = JSON.parse(sessionStorage.wishlistObj);
                                    var productsLength = Object.keys(wishlistProducts).length;

                                    if (productsLength == 0){
                                        if ($("#wishlist_grid li").length > 0) {
                                            $("#wishlist_grid li").remove();
                                        }
                                    } else {
                                        for (var i=0 ;i<productsLength; i++){
                                            var wishlistLi = $("#wishlist_grid li")[i];
                                            if ($(wishlistLi).html() == ""){
                                                $(wishlistLi).remove();
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                });

                //  Begin Change DOM filter position to make it FIXED
                if (!isWishlist){
                    if (isOliver){
                        document.querySelector('body').appendChild(blockFilter);
                    }
                }

                window.addEventListener('resize', function() {
                    if(!isWishlist){
                        if(window.innerWidth >= 1024 && blockFilter.parentNode !== originalFilterParentElem) {
                            facetButtonElem.classList.remove('scroll');
                        }
                        else if (window.innerWidth < 1024 && blockFilter.parentNode !== pageElem) {
                            document.querySelector('body').appendChild(blockFilter);
                        }
                    }
                    if(!(window.mobilecheck() || window.tabletPortraitCheck())){
                        if(isOliver) {
                            if (isWishlist){
                                $('#wishlist_grid .grid-item:not(.product-espot)').outerHeight("100%");
                            } else {
                                $('.grid-item:not(.product-espot)').outerHeight("100%");
                            }
                        } else if(isPersol) {
                            if(isWishlist){
                                $('.grid-item:not(.product-espot):not(.grid-item-search)').outerHeight("100%");

                            }else{
                                $('.grid-item:not(.product-espot)').height("100%");
                            }
                            
                        }
                    }
                    if(!isWishlist){
                        if(blockFilter.classList.contains('opend') && window.innerWidth >= 1024) {
                            document.querySelector('html').removeAttribute("style");
                            document.querySelector('body').removeAttribute("style");
                        } else if(blockFilter.classList.contains('opend') && window.innerWidth < 1024) {
                            document.querySelector('html').setAttribute("style", "overflow: hidden;");
                            document.querySelector('body').setAttribute("style", "position: static; overflow: hidden");
                        }
                    }
                }, true);
                //  End Change DOM filter position

                //Add classes to Persol if on mobile
                if (isPersol) {
                    if (window.tabletPortraitCheck() || window.mobilecheck()){
                        $('.sale_badge').addClass('submenu__subheader');
                        $('.sale_badge').addClass('submenu__subheader--mobile');
                        $('.submenu__list-block--desktop li:not(".sale_badge") > a').addClass('submenu__subheader');
                        $('.submenu__list-block--desktop li:not(".sale_badge") > a').addClass('submenu__subheader--mobile');
                    } else {
                        $('.sale_badge').removeClass('submenu__subheader');
                        $('.sale_badge').removeClass('submenu__subheader--mobile');
                        $('.submenu__list-block--desktop li > a').removeClass('submenu__subheader');
                        $('.submenu__list-block--desktop li > a').removeClass('submenu__subheader--mobile');
                    }
                }

                // deleted function --- see //START FILTER SECTION in non critical js 

        
          
        }
    }

        initButtonViewOnClick();

		



    // # X_PLP_SalesBeans
    if ($('#ci_espot__X_PLP_SalesBeans').length > 0) {

    	// Change event for select
    	$('select.select-bean').change(function(e) {
        	document.location.href = $(e.target).val();
        });

    	// Active/Select current dash button page
		var urlPage= window.location.href;
	    var splitUrl = urlPage.split("/");
	    var salesCategory = splitUrl[splitUrl.length - 1];
	    $('.nav-beans #' + decodeURI(salesCategory.split('?')[0])).addClass("active");
	    $("select option[value='"+salesCategory.split('?')[0]+"']").prop("selected",true);
	}
}

function initButtonViewOnClick(){
    // Change view when clicking on different buttons
    $('.button-views.one-col-icon').click(function() {
        columnsToShow = 1;
        $('.button-views').removeClass("active");
        $('.button-views.one-col-icon').addClass("active");
        $('.grid_mode').addClass('grid_mode-one-col');
        $('.grid_mode').removeClass('grid_mode-two-cols');
        $('.plp-main-carousel').slick('unslick');
        initSlick();
        manageCarousel($('.plp-other-color-carousel'));
        $(".grid_mode").addClass("-one-col");
    });

    $('.button-views.two-col-icon').click(function() {
        columnsToShow = 2;
        $('.button-views').removeClass("active");
        $('.button-views.two-col-icon').addClass("active");
        $('#plp_grid.grid_mode').addClass('grid_mode-two-cols');
        $('#plp_grid.grid_mode').removeClass('grid_mode-one-col');
        $('#plp_grid.grid-item').removeAttr('style')
        $('.product--wrapper__container').removeAttr('style')
        $('.plp-main-carousel').slick('unslick');
        initSlick();
        manageCarousel($('.plp-other-color-carousel'));
        $(".grid_mode").removeClass("-one-col");
    });
}

/**
 * @function setDefaultSortBy
 * @desc This function select the default sort by inside facet section
 *
 * @param {*} num
 */
function setDefaultSortBy(num, isViewMore, productData,searchedWord, isWishlist, wishlistToDeleteData,firstSearch) {
    var sortElems = document.querySelectorAll('.facet__sortBy .facet__filter-button');
    for(var sortElem = 0; sortElem < sortElems.length; sortElem++) {
        if(sortElems[sortElem].getAttribute('data-facet') == num){
            sortElems[sortElem].parentElement.classList.add('selected');
            break;
        }
    }
    originalSelectedSort = document.querySelector('#facet__sortBy .facet__filter-noimg.selected');
    ajaxCallFacet(callbackSortBy, null, isViewMore, productData,searchedWord, isWishlist, wishlistToDeleteData,firstSearch);
}

function ajaxCallFacet(callback, elem, isViewMore, productData,searchedWord, isWishlist, wishlistToDeleteData,firstSearch) {
    
    if(typeof firstSearch != undefined){
        $plpSearchObj.firstSearch = firstSearch;
    }else{
        $plpSearchObj.firstSearch = undefined;
    }
    $plpSearchObj.viewIndex = 0;
    $plpSearchObj.lastIndex = 0;
    $plpSearchObj.resultCount = 0;
    $plpSearchObj.getData(isViewMore, function() {
        $plpSearchObj.attrValIdentifierObject = [];//object use to retrive indetifier value of attribute value
    	$plpSearchObj.busy = false;
    	createNewTileProducts(0,$plpSearchObj.itemsPerPage,searchedWord,isWishlist,false,wishlistToDeleteData);
        $plpSearchObj.itemsPerPage = columnsToShow*parseInt($("#rowsPerPage").val());
        $plpSearchObj.itemsFromServer = parseInt($("#itemsFromServer").val());
    	callback(elem);
    }, productData,searchedWord, isWishlist);
    if (typeof productData === 'undefined') {
        $plpSearchObj.busy = true;
    }
}

//function to load plp data 
$plpSearchObj.getData = function(isViewMore,callback,productData,searchedWord,isWishlist) {
	if (!isViewMore) {
		$plpSearchObj.items = {};
		$plpSearchObj.currentPage = 1;
		$plpSearchObj.viewIndex = 0;
		$plpSearchObj.lastIndex = 0;
        
        /*if (document.querySelector('.search')) {
            $("span[id^=searchTotalCount]").html($("span[id^=searchTotalCount]").html().replace(/\d/g, ''));
        }*/
		window.scrollTo(0,0);
	} else {
        $plpSearchObj.viewMoreClicked = true;
		$plpSearchObj.currentPage = Math.floor(($plpSearchObj.lastIndex||0)/$plpSearchObj.itemsFromServer)+1;
        
        var ulGrid = !isWishlist ? document.querySelector('#plp_grid') : document.querySelector('#wishlist_grid');
        
        for(var i = 0; i  < $plpSearchObj.itemsFromServer; i++) {
            var createDOMLi = document.createElement('li');
            if(isOliver) createDOMLi.classList.add('product');
            createDOMLi.classList.add('plp-grid-skeleton');
            ulGrid.appendChild(createDOMLi);
        }
        // 	$('.product--wrapper').height($('.product').width());
        // }
    } 
	
    if (isPersol) {
    	$('.skeleton .product--wrapper').height($('.skeleton .product-container').width() * (400/360));
    }

    $plpSearchObj.queryParams = queryParams;
    if(searchedWord || isWishlist){
        $plpSearchObj.queryParams['categoryId'] = '';
    }else{
        $plpSearchObj.queryParams['categoryId'] = document.querySelector('meta[name="pageId"]').getAttribute('content');
    }
	if (selectedFacetsData["orderBy"]) {
		$plpSearchObj.queryParams['orderBy'] = selectedFacetsData["orderBy"];
	    if (isPriceOrdering()) {
	    	queryParams['profileName'] = 'LUX_findProductsByCategory';
	    } else if (isNewArrivalsOrdering() && getUrlParameter('searchTerm') == null) {
	    	queryParams['profileName'] = defaultSearchProfile+'_new_first';
	    } else {
	    	queryParams['profileName'] = defaultSearchProfile;
	    }
	} else {
		delete $plpSearchObj.queryParams['orderBy'];
    	queryParams['profileName'] = defaultSearchProfile;
	}
	if (!categoryToGroupTile()) {
		queryParams['profileName'] = 'LUX_findProductsByCategory';
	}
	$plpSearchObj.queryParams['pageNumber'] = $plpSearchObj.currentPage;
	$plpSearchObj.queryParams['pageSize'] = $plpSearchObj.itemsFromServer;
    var facetArr = [];
    var queryString = window.location.search.substr(1);
    if (queryString.trim() != "") {
        var parameters = queryString.split('&');
        $.each(parameters, function(i,el){
       	 	var facetKey = el.split('=')[0];
       	 	if (facetKey.startsWith('facet')) {
       	 		var facetValue = el.split('=')[1];
       	 		facetArr.push(facetValue);
       	 	}
        });
    }
    if(searchedWord || isWishlist){
        $plpSearchObj.queryParams['facet'] = [];
    }else{
        $plpSearchObj.queryParams['facet'] = facetArr;
    }
    

    var ajaxPLPSuccess = function(data) {
    	
    	   if(location.href.includes("facet") && !$plpSearchObj.viewMoreClicked){
           	tileIndex = 0;
           }

        $plpSearchObj.resultCount = !isWishlist ? data.recordSetTotal : Object.keys(data).length;
        var dataRecordCount = !isWishlist ? data.recordSetCount : Object.keys(data).length;
        if (dataRecordCount === 0) {
        	var dataSpellCheck = '';
        	if ($('.suggestions_container .suggestion').length > 0){
        		dataSpellCheck = $('.suggestions_container .suggestion')[0].text;
        	} else if (data.metaData){
        		dataSpellCheck = data.metaData.spellcheck[0];
        	}
        	if (dataSpellCheck){
        		$.ajax({
                    url: $plpSearchObj.productsServiceUrl(dataSpellCheck),
                    type: 'GET',
                    async: true,
                    data: $.param($plpSearchObj.queryParams,true),
                    success: ajaxPLPSuccess,
                    error: function(error) {
                    	return error;
                    }
                });
        	} else {
                if(searchedWord && typeof $plpSearchObj.firstSearch == undefined){//no result in search panel 
                    searchError(true);
                    resetSearchTile(true);//resetFeature
                    if(searchedWord != 'X_Search_FeaturedProducts'){
                        tealiumPushSearchPageReady(searchedWord,'0');
                    }
                    
                }else if(searchedWord && $plpSearchObj.firstSearch ){//no result in search panel firstsearch
                    searchError(true);
                    resetSearchTile(true);
                    if(searchedWord != 'X_Search_FeaturedProducts'){
                        tealiumPushSearchPageReady(searchedWord,'0');
                    }
                    
                }else if(isWishlist){
                    $("#wishlist_grid li .grid-item").remove(); //wishlist is empty
                }else {
                    //	Hide View More button
                    //populateUtagDataAfterAjax();
                    $('.plp__view-more.button.secondary').attr('style','display:none !important');
                    if (isOliver && getUrlParameter('searchTerm') === null){
                        $('#noProducts').css('display','block');
                        //add default empty element in plp_grid for wcag
                        var createDOMProduct = document.createElement('li');
                        createDOMProduct.classList.add('grid-item');
                        createDOMProduct.setAttribute('id','dummyElement');
                        ulGrid.appendChild(createDOMProduct);
                    }

                }
                
            }
        }
        
        else if (dataRecordCount > 0) {
        	if(($plpSearchObj.queryParams.profileName === 'LUX_findProductsBySearchTerm' && $('.suggestions_container .suggestion').length > 0 && $('.suggestions_container .suggestion')[0].text.toLowerCase() != (data.catalogEntryView[0].name).toLowerCase())){
        		for (var i = 0; i < dataRecordCount; i++) {
        			if($('.suggestions_container .suggestion')[0].text.toLowerCase() == (data.catalogEntryView[i].name).toLowerCase()){
        				var shortDescription = (data.catalogEntryView[i].shortDescription);
        				$.ajax({
                            url: $plpSearchObj.productsServiceUrl(shortDescription),
                            type: 'GET',
                            async: true,
                            data: $.param($plpSearchObj.queryParams,true),
                            success: ajaxPLPSuccess,
                            error: function(error) {
                            	return error;
                            }
                        });
        				break;
        			}
        		}
        	}
            var results = getUrlParameter('searchTerm') || isPriceOrdering() || !categoryToGroupTile() || searchedWord ? data.catalogEntryView : (isWishlist ? data : data.catalogEntryGroupView); 
             // Display message when no products are shown
            $('#noProducts').css('display','none');
            //delete dummyElement in plp_grid for WCAG
            $('#dummyElement').remove();
            if(searchedWord){
                searchError(false);
                $(".title_result").hide();
                $(".redirect_result_container").css("display","flex");
                $(".redirect_result_container .redirect_result_link").show()
                $(".redirect_result_link #serched_word").html($('input:text[name=searchInput]').val());
                
            }
            /* populate items */
            if (getUrlParameter('searchTerm') || isPriceOrdering() || !categoryToGroupTile() || searchedWord) {
                $.each(results, function(key,value) {
                    $plpSearchObj.items[(parseInt(key)+($plpSearchObj.itemsFromServer*($plpSearchObj.currentPage-1)))] = value;
                    
                });
                if(!searchedWord){
                    $plpSearchObj.itemsbkp =  $plpSearchObj.items;
                }
            } else {
                //  START - Email me sorting by inventory
                function fn_sortByInventory(p) {
                    var r = 0;
                    if (p['inventory']
                            && p['inventory']['ranking']
                            && p['inventory']['flComingSoon']) {
                        r = p['inventory']['ranking'] + (p['inventory']['flComingSoon'] == 'true' ? 0.5 : 0);
                    }
                    return r; 
                }
                if (!isWishlist){
                    $.each(results,function(group,products) {
                        products.sort(function(a, b){
                            var sortedResults = fn_sortByInventory(b) - fn_sortByInventory(a);
                            return sortedResults;
                        });
                    });
                }
                //  END - Email me sorting by inventory
                Object.assign($plpSearchObj.items,results);
                if(!searchedWord){
                    //search Optimization save PLP items info 
                    $plpSearchObj.itemsbkp =  $plpSearchObj.items;
                }
            }

            //  LCP
            /*
            let count = 0;
            $.each($plpSearchObj.items,function (key,value) {
                if (count == 0
                        && value[0] != undefined) {
                    var lcp = new Image();
                    if (isOliver){
                        lcp.src = replaceTileImgByDevice(value[0].thumbnail.replace('OV_OpPlp','OV_parameters&WID'),'WID','small');
                    } else if (isPersol) {
                        lcp.src = replaceTileImgByDevice(value[0].thumbnail,'sclw=0.25&sclh=0.25','small');
                    }
                    return false;
                }
            });
            */

            /*populate tealiumProducts HB-5614*/
            var status = 'undefined';
            if (getUrlParameter('searchTerm') || isPriceOrdering() || !categoryToGroupTile() || searchedWord || isWishlist) {
                if(typeof tealiumProducts === 'undefined'){
                     tealiumProducts = {};
                }
                $.each($plpSearchObj.items,function (key,value) {
                    try {
                        var tealiumProduct = {};
                        var category = "";
                        if(pageType=='Wishlist'){
                        	category = getAttributeValue(value.attributes,"PRODUCTTYPE");
                        	category = category.toLowerCase();
                        	
                        	if(category.includes("sun")){
                        		category = "SUN";
                        	}
                        	if(category.includes("optical")){
                        		category = "OPTICS";
                        	}
                        	
                        	if(category.includes("accessories")){
                        		category = "ACCESSORIES"; 
                        	}
                        }else{
                        	category = getCategoryName(key ,"_")
                        }
                        
                        tealiumProduct['Category'] = category; 
                        tealiumProduct['Price'] = parseFloat(value['price']['price']).toFixed(2);
                        tealiumProduct['PriceFull'] = parseFloat(value['price']['listprice']).toFixed(2);
                        tealiumProduct['Brand'] = currentBrand;
                        tealiumProduct['Status'] = getStatus(value.inventory);
                        $(addProductsToTealium(value.partNumber,tealiumProduct)); // fix for HB-13178 inserted in document ready to avoid it being called before its declaration
                    } catch (e) {
                        console.error('Error while parsing product for Tealium');
                        console.error(e);
                    }
                });
            }
            else {
                $.each($plpSearchObj.items,function (key,value) {
                    try {
                        var tealiumProduct = {};
                        tealiumProduct['Category'] = getCategoryName(key ,"_");
                        tealiumProduct['Price'] = parseFloat(value[0]['price']['price']).toFixed(2);
                        tealiumProduct['PriceFull'] = parseFloat(value[0]['price']['listprice']).toFixed(2);
                        tealiumProduct['Brand'] = currentBrand;
                        tealiumProduct['Status'] = getStatus(value[0].inventory);
                        $(addProductsToTealium(value[0].partNumber,tealiumProduct));// fix for HB-13178 inserted in document ready to avoid it being called before its declaration
                    } catch (e) {
                        console.error('Error while parsing product for Tealium');
                        console.error(value[0]);
                    }
                });
            }
            
            
            if(pageType=='Search'){
               var obj = {};
               obj['Search_Keyword'] = getUrlParameter('searchTerm');
               obj['Search_ResultItemsQnt'] = $plpSearchObj.resultCount;
               obj['Search_View'] = 'SERP';
               obj['Event_Source'] = 'SERP'
               pushDataToTealium(obj)
            } 
            
            if (typeof monetateQ !== 'undefined'){
                  monetateTrackPlp();
            }

            /*END 5614*/
    
            if(!searchedWord){
                if($plpSearchObj.lastIndexbkp > 0 && !$plpSearchObj.isFilterPanel){ // search Optimization  if is after search and not use filter
                    $plpSearchObj.lastIndex = $plpSearchObj.lastIndexbkp
                    $plpSearchObj.lastIndex += Object.keys(results).length;
                    $plpSearchObj.lastIndexbkp = $plpSearchObj.lastIndex;
                }else{
                    //if apply filter 
                    $plpSearchObj.lastIndex = Object.keys(results).length;
                    $plpSearchObj.lastIndexbkp = $plpSearchObj.lastIndex
                    $plpSearchObj.isFilterPanel = false;
                }
 
                
            }
            
            $plpSearchObj.loading = false;
            if (typeof callback == 'function') {
            	if($plpSearchObj.queryParams.profileName === 'LUX_findProductsBySearchTerm'){
            		resetSearchTile(false,false,false);
            	}
            	callback();
            }

            /* facets are included only in PLP */
            if (!isWishlist){
                if(!searchedWord){
                    closeFilterMenu();
                    isFacetApplied = true;
                    originalSelectedSort = $('#facet__sortBy .facet__filter-noimg.selected button').attr("data-facet-name-en");
                    if(countSelectedFacets == 0) {
                        $(".facet__apply").removeClass('show');
                        document.querySelector('.facet__widget').classList.remove('active');
                        isFacetApplied = false;
                    }
                }
            }

            //	View More button
            if (!isWishlist){
                if ($plpSearchObj.resultCount-$plpSearchObj.lastIndex <= 0) {
                    $('.plp__view-more.button.secondary').attr('style','display:none !important');
                } else {
                    $('.plp__view-more.button.secondary').show();
                }
            }

            if (!isViewMore) {
                /* facets are excluded by search in Persol */
                if (!searchedWord) { // SearchOptimiztion ! (isPersol && getUrlParameter('searchTerm'))
                    //	Inner function used to handle filters drawing and toggle
                    if (!isWishlist){

                        var filtersHandling = function(dataPartial,dataAll) {
                        // $plpSearchObj.attrValIdentifierObject =  createAttrValIdentifierObject(dataAll.catalogEntryGroupView);
                            drawFilters(dataAll.facetView,facetArr,parameters,$('#facet__sortBy .facet__filter-noimg.selected button').attr("data-facet-name-en"));
                            $('.facet__apply-number').text($plpSearchObj.resultCount);
                            $('.numframe').html($plpSearchObj.resultCount + ' ' + $('#frameTranslate').val());
                            $("#productsFacets li.facet__list-item li").each(function(i,e) {
                                toggleFilter(e,dataPartial);
                            });
                        };
                        //	If there are no GET parameters, then use the normal flow
                        if (facetArr.length == 0) {
                            filtersHandling(data,data);
                        } else {
                            new Promise((resolve, reject) => {
                                // else do an AJAX call to get the full facets list
                                var queryParamsAllFilters = $.extend({},$plpSearchObj.queryParams);
                                queryParamsAllFilters['facet'] = [];
                                delete queryParamsAllFilters['isForPLP'];
                                queryParamsAllFilters['isForPLPFilters'] = true;
                                $.ajax({
                                    url: $plpSearchObj.productsServiceUrl(),
                                    type: 'GET',
                                    async: true,
                                    data: $.param(queryParamsAllFilters,true),
                                    success: function(dataAll) {
                                        filtersHandling(data,dataAll);
                                        resolve(dataAll);
                                    },
                                    error: function(error) {
                                        reject(all);
                                        return error;
                                    },
                                    beforeSend: function(jqXHR, settings) {
                                        //  Security check, if true then stop the request and show 0 results
                                        if (settings.url.indexOf('TopCategoriesDisplay') > -1) {
                                            return false;
                                        }
                                    }
                                });
                            });
                        }
                    }
                }

                if (!isWishlist){
                    if(!searchedWord){
                        if(originalSelectedSort != undefined){
                            if(!(isPersol && getUrlParameter('searchTerm')) && facetArr.length == 0 && originalSelectedSort.innerText!==''){
                                setUTagData(parameters,originalSelectedSort);
                            }
                        }
                    }
                }

                if (document.querySelector('.search') ) {
                    $("span[id^=searchTotalCount] #totalCount").html("("+ $plpSearchObj.resultCount + ") " );
                }
            }
        }

        // Remove top and middle espot skeleton
        $('#plp_top_espot_skeleton').remove();
        $('#plp_middle_espot_skeleton').remove();

        //  CLS
        $('.plp-hide').show();
    };
    if (!isWishlist && typeof productData === 'undefined') {

        if(searchedWord || getUrlParameter('searchTerm') ){
            $plpSearchObj.queryParams.profileName = "LUX_findProductsBySearchTerm"
            if(isPersol){
                $plpSearchObj.queryParams.filterQuery = "-parentCatgroup_id_search eq '(3074457345616688668_3074457345616688669_3074457345616718183_3074457345616718182)'"; // catgoria LEnti + categorie servizi
            }else{
                $plpSearchObj.queryParams.filterQuery = "-parentCatgroup_id_search eq '(3074457345616688676_3074457345616714198_3074457345616714199_3074457345616688675)'"; // catgoria LEnti + categorie servizi
            }
             
            
        }else{
            $plpSearchObj.queryParams.profileName = $plpSearchObj.queryParams.profileName;
            delete $plpSearchObj.queryParams.filterQuery 
        }
        if(!isWishlist && !(searchedWord || getUrlParameter('searchTerm'))){}else{
        	$.ajax({
                url: $plpSearchObj.productsServiceUrl(searchedWord),
                type: 'GET',
                async: true,
                data: $.param($plpSearchObj.queryParams,true),
                success: ajaxPLPSuccess,
                error: function(error) {
                    return error;
                },
                beforeSend: function(jqXHR, settings) {
                    //  Security check, if true then stop the request and show 0 results
                    if (settings.url.indexOf('TopCategoriesDisplay') > -1) {

                        $plpSearchObj.resultCount = 0;

                        //	Hide View More button
                        $('.plp__view-more.button.secondary').attr('style','display:none !important');
                        if (isOliver && getUrlParameter('searchTerm') === null){
                            $('#noProducts').css('display','block');
                            //add default empty element in plp_gid for wcag
                            var createDOMProduct = document.createElement('li');
                            createDOMProduct.classList.add('grid-item');
                            createDOMProduct.setAttribute('id','dummyElement');
                            ulGrid.appendChild(createDOMProduct);
                            
                        }

                        return false;
                    }
                }
            });
        }
        
    } else {
        ajaxPLPSuccess(productData);
    }

};

/**
 * @funtion createNewTileProducts
 * @desc This function creates the new tile products with a template html
 */
function createNewTileProducts(startAt,count,searchedWord,isWishlist,isWishlistViewMoreTiles,wishlistToDeleteData,firstSearch) {
	// TEMPORARY FIX FOR HB-9977
	if(pageSection_1 == 'Accessories' && (window.tabletPortraitCheck() || window.mobilecheck())){
		count = 6;
	}
	$plpSearchObj.viewIndex = startAt+count;
    if(!searchedWord){
        //search Optimization -- save viewIndex 
        $plpSearchObj.viewIndexbkp = $plpSearchObj.viewIndex
    }
	//	Remove extra skeleton tiles
	var toShow = $plpSearchObj.lastIndex-$plpSearchObj.viewIndex;
	var toRemove = $plpSearchObj.itemsFromServer-toShow;
	
    var products = {}, i = 0;

    if (getUrlParameter('searchTerm') && $plpSearchObj.viewMoreClicked && !searchedWord) {
        var stopAt = $plpSearchObj.viewMoreSearchStartIndex+count;
        i = $plpSearchObj.viewMoreSearchStartIndex;
        if (toShow < 0) {
            // check for the end on products
            stopAt += toShow;
        }
        for (m in $plpSearchObj.items) {
            if (i>=$plpSearchObj.viewMoreSearchStartIndex && i < stopAt) {
                products[m] = $plpSearchObj.items[parseInt(m)+startAt];
            }
            i++;
        }
        $plpSearchObj.viewMoreSearchCount++;
        $plpSearchObj.viewMoreSearchStartIndex = count * $plpSearchObj.viewMoreSearchCount;
    } else {
        for (m in $plpSearchObj.items) {
            if (startAt<=i && i<startAt+count) {
                if(searchedWord){
                    if(isPersol && i <= 2){
                        products[m] = $plpSearchObj.items[m];
                    }else if(isOliver && i <= 1){
                        products[m] = $plpSearchObj.items[m];
                    }
                }else{
                    products[m] = $plpSearchObj.items[m];
                }
                
            }
            i++;
        }
    }

    // Show number of selected facets in the filter button
    if (countSelectedFacets >= 1) {
        $('.plp-filter-button').addClass('active');
    	$('.filter__button-number').text(countSelectedFacets);
    } else {
        $('.plp-filter-button').removeClass('active'); 
    }

    var tileCount = Object.keys($plpSearchObj.items).length;

    
    renderTileProducts(products, startAt, count, toRemove,searchedWord,isWishlist, isWishlistViewMoreTiles, wishlistToDeleteData);
}

/**
 * @funtion manageWishlistGuestEspot
 * @desc This function adds the sign in/register espot in the wishlist page as last tile of first grid row. This only happens when user is guest
 * */
function manageWishlistGuestEspot(createDOMEspot, espotLi, ulGridChilds, productIndex, productsLength, wishlistToDeleteData) {
    var parentElement = ulGridChilds[0].parentNode;
    if (isPersol){
        if (productsLength > 0 && productsLength < 4) {
            if (typeof wishlistToDeleteData != "undefined" && wishlistToDeleteData.isWishlistProductToDelete){
                //Remove empty <li> and add guest espot
                if ($("#wishlist_grid").children().eq(productsLength).html() == ""){
                    $("#wishlist_grid").children().eq(productsLength).remove();
                }
                $("#wishlist_grid").children().eq(productsLength-1).after($(espotLi));
            } else {
                ulGridChilds[productIndex+1].replaceChildren(createDOMEspot);
            }
            ulGridChilds[productIndex+1].classList.remove("plp-grid-skeleton");
        } else {
            if (typeof wishlistToDeleteData != "undefined" && wishlistToDeleteData.isWishlistProductToDelete){
                $("#wishlist_grid").children().eq(3).before($(espotLi));
            } else {
                parentElement.insertBefore(espotLi, ulGridChilds[3]);
            }
            ulGridChilds[productIndex+1].classList.remove("plp-grid-skeleton");
        }
    } else {
        if (productsLength > 0 && productsLength < 3) {
            if (typeof wishlistToDeleteData != "undefined" && wishlistToDeleteData.isWishlistProductToDelete){
                //Remove empty <li> and add guest espot
                if ($("#wishlist_grid").children().eq(productsLength).html() == ""){
                    $("#wishlist_grid").children().eq(productsLength).remove();
                }
                $("#wishlist_grid").children().eq(productsLength-1).after($(espotLi));
            } else {
                ulGridChilds[productIndex+1].replaceChildren(createDOMEspot);
            }
            ulGridChilds[productIndex+1].classList.remove("plp-grid-skeleton");
        } else {
            if (typeof wishlistToDeleteData != "undefined" && wishlistToDeleteData.isWishlistProductToDelete){
                $("#wishlist_grid").children().eq(2).before($(espotLi));
            } else {
                parentElement.insertBefore(espotLi, ulGridChilds[2]);
            }
            ulGridChilds[productIndex+1].classList.remove("plp-grid-skeleton");
        }
    }
    if (typeof setWishlistEspotCtaClick == "function"){
        setWishlistEspotCtaClick();
    }
}

/**
 * @funtion renderTileProducts
 * @desc This function creates the new tile products with a template html
 * @param {products} products
 * @param {inventory} inventory
 */
function renderTileProducts(products,startAt,count, toRemove,searchedWord,isWishlist, isWishlistViewMoreTiles, wishlistToDeleteData) {

    var ulGrid = !isWishlist ? document.querySelector('#plp_grid') : document.querySelector('#wishlist_grid');
    var productArray = [];

  
    
    const ulGridChilds = searchedWord ? document.querySelectorAll('.search-grid-skeleton') : ((isWishlist && $('.plp-grid-skeleton').length == 0) ? document.querySelectorAll('#wishlist_grid li') : document.querySelectorAll('.plp-grid-skeleton')); //search optimization

    var productIndex = 0;
   
    var productsLength = Object.keys(products).length;

    for(var product in products) {

        if (typeof wishlistToDeleteData == "undefined" || !wishlistToDeleteData.isWishlistProductToDelete){
            var createDOMProduct = document.createElement('div');
            createDOMProduct.classList.add('grid-item');
            if(searchedWord){
                createDOMProduct.classList.add('grid-item-search');
                if(searchedWord == "X_Search_FeaturedProducts"){
                    $(".grid-item-search").parent().addClass("featured-products");
                }
            }

            var isLCPTile = startAt == 0 && productIndex == 0;
           

            if(searchedWord == "X_Search_FeaturedProducts"){
                var html = getSingleTileHtml(product, products[product].productModel, true,productIndex,isLCPTile, tileIndex,searchedWord,isWishlist);
            }else{
                var html = getSingleTileHtml(product, products[product], true,productIndex,isLCPTile, tileIndex,searchedWord,isWishlist);
            }
            
            
            $(createDOMProduct).html(html);
            ulGridChilds[productIndex].replaceChildren(createDOMProduct);
        }
        
        if (isWishlist){
            //If there is at least one product and user is guest, display sign in/register espot at last position of first grid row
            if (userType == "G" && productsLength > 0){
                if (!isWishlistViewMoreTiles || typeof wishlistToDeleteData != "undefined" && wishlistToDeleteData.isWishlistProductToDelete){
                    if (productIndex == productsLength - 1) {
                        if (typeof wishlistContentEspotHTML == 'undefined'){
                            returnEspotContent("X_Wishlist_Login");
                            var wishlistContentEspotHTML = $("#guestWishlistEspotContent").val();
                        }
                        if (typeof wishlistContentEspotHTML != "undefined" && wishlistContentEspotHTML != ""){
                            var espotLi = document.createElement('li');
                            espotLi.classList.add("wishlist-li");
                            var createDOMEspot = document.createElement('div');
                            createDOMEspot.classList.add('grid-item', 'wishlist-espot');
                            $(createDOMEspot).html(wishlistContentEspotHTML);
                            espotLi.appendChild(createDOMEspot);
                            if ($(".wishlist-espot").length == 0){
                                manageWishlistGuestEspot(createDOMEspot, espotLi, ulGridChilds, productIndex, productsLength, wishlistToDeleteData);
                            } else {
                                $(".wishlist-espot").parent().addClass("wishlist-li");
                                if ($(".wishlist-li").length > 0) {
                                    $(".wishlist-li").remove();
                                }
                                manageWishlistGuestEspot(createDOMEspot, espotLi, ulGridChilds, productIndex, productsLength, wishlistToDeleteData);
                            }
                        }
                    }
                }
            }


            if(typeof checkIsInWishlist === 'function'){ 
                if(checkIsInWishlist(product)){ // WISHLIST -- check if current product is in wishist
                    $("[data-id=" + product + "] .wishlist-icon-container").addClass("wishlist_product");
                    $("[data-id=" + product + "] .wishlist-icon-container").show();
                }else{
                    $("[data-id=" + product + "] .wishlist-icon-container").removeClass("wishlist_product");
                    $("[data-id=" + product + "] .wishlist-icon-container").show();
                }
            }
            wishlistAvailabilityCheckCTA(products, product);
        }

        if(searchedWord){
           ulGridChilds[productIndex].classList.remove("search-grid-skeleton");
           //$(".search-grid-skeleton").eq(productIndex).hide()
        }else {
            ulGridChilds[productIndex].classList.remove("plp-grid-skeleton");
            
        }

        ulGridChilds[productIndex].classList.remove("product");
        ulGridChilds[productIndex].querySelector('.square-container').classList.remove("skeleton-element");
        ulGridChilds[productIndex].querySelector('.product__wrapper-info').classList.remove("skeleton-element");
        
        
        productArray.push(createDOMProduct);
       
        removeLoader();


        
        productIndex++;
        tileIndex++;
    }


    if(searchedWord && $("#search_grid .search-grid-skeleton").length > 0){ //hide skeleton if result <3 /2
        $("#search_grid .search-grid-skeleton").hide();
    }

    if (!isWishlist){
        if(searchedWord != 'X_Search_FeaturedProducts' && searchedWord){
            var resultItemsQnt = $("#search_grid li:not(.search-grid-skeleton)").length;
            tealiumPushSearchPageReady(searchedWord,resultItemsQnt);
        }
    } else {
        init_wishlist_tooltip();
    }


  

    // Show images in IE, as Yall does not work properly
    if (!('IntersectionObserver' in window)) {
        if (typeof mokeupLazyLoad === "function") {
            mokeupLazyLoad();
        }
    }
    if(window.location.href.includes("?facet=")){
    	$('#X_PLP_TopBanner').hide();
    	$('#X_PLP_BottomBanner').hide();
    	$('#X_PLP_MiddleBanner').hide();
    	$('#X_PLP_PromoBanner').hide();
        $('#X_PLP_BottomGridBanner').hide();
        $('#X_PLP_GridBannerTop').hide();
        $('#X_PLP_GridBannerBottom').hide();
    }

    if(isEdgeOrIExplorer()){
        $('.grid.product-list').css("width","auto");
    }
    
    /**
     * Handle back button : scroll to the last product clicked by user 
    * */
    if(sessionStorage.plpTitle == pageSection_1 && sessionStorage.pageY) {
            if($plpSearchObj.viewIndex  > 16) { //middle espot non renderizzato
                $('html, body').animate({
                    scrollTop: sessionStorage.pageY - sessionStorage.middleEspotHeight
                },0);
            }
            else {
                $('html, body').animate({
                    scrollTop: sessionStorage.pageY
                },0);
            }
            sessionStorage.removeItem('pageY');
            sessionStorage.removeItem('plpTitle');
            sessionStorage.removeItem('itemsToLoad');
            sessionStorage.removeItem('backItemsPerPage');
            sessionStorage.removeItem('middleEspotHeight');
    }
    if(searchedWord == "X_Search_FeaturedProducts"){ // save Feautured 
        $('#search_grid li').each(function() {
            if(!$(this).hasClass("search-grid-skeleton")){
                featuredProductHtml += this.outerHTML
            }
        })
    }
    
}
/**
 * @funtion getSingleTileHtml
 * @desc This function creates a single product tile with a template html
 * @param {model} model
 * @param {product} product
*/
function getSingleTileHtml(product, model, insideGrid,productIndex=0,isLCPTile, tileIndex,searchedWord,isWishlist,isEspot) {

    var html = '';

    try {

        var listPrice = '';
        var offerPrice = '';
        var percentage = '';

        var polarized = '';
        var isPhotocromic = false;
        var isRox = false;
        var modelNameValue = "";
        var group2BadgeValue = '';
        var wishlistAddedSize = "";
        var wishlistAddedSizeNumber = "";
        var productMoco = "";
        var isPolar = false;
        var catentryIdDefaultSize = [];

        if (typeof isWishlist == "undefined"){
            var isWishlist = $("#page").hasClass("wishListDisplay") ? true : false;
        }

        //var model = products[product];
        var showedProduct = getUrlParameter('searchTerm') || isPriceOrdering() || !categoryToGroupTile() || searchedWord || isWishlist ? model : model[0];
        if (showedProduct.thumbnail === undefined) {
            showedProduct.thumbnail = '';
        }
        $(model).each(function (ind) {
            var currProduct = $(this)[0];
            if (isOliver) {
                currProduct.thumbnail = replaceTileImgByDevice(currProduct.thumbnail.replace('OV_OpPlp','OV_parameters_transp&WID'),'WID','small');
            } else if (isPersol) {
                currProduct.thumbnail = replaceTileImgByDevice(currProduct.thumbnail,'sclw=0.25&sclh=0.25','small');
            }

            try {
                if(WCParamJS.countryCode == 'US' || WCParamJS.countryCode == 'CA'){
                    catentryIdDefaultSize[ind]= currProduct.mostSoldSize['NA'].uniqueID;
                }else if(WCParamJS.countryCode == 'JP'){
                    catentryIdDefaultSize[ind] = currProduct.mostSoldSize['JP'].uniqueID;
                }else{
                    catentryIdDefaultSize[ind] = currProduct.mostSoldSize['EMEA'].uniqueID;
                }
            } catch (e) {
                console.error('Error in finding default size for wishlist');
            }
        });

        if(showedProduct != undefined
                && showedProduct.attributes != undefined) {
            for(var i=0; showedProduct.attributes.length>i; i++) {
                if(showedProduct.attributes[i].identifier === 'MODELNAME' && showedProduct.attributes[i].usage === 'Descriptive' ) modelNameValue = showedProduct.attributes[i].values[0].value;
                if(showedProduct.attributes[i].identifier === 'POLARIZED' && showedProduct.attributes[i].usage === 'Descriptive' ){
                    for(var k=0; showedProduct.attributes[i].values.length > k; k++ ){
                        if(showedProduct.attributes[i].values[k].value == true || showedProduct.attributes[i].values[k].value.toLowerCase() === 'yes'){
                            polarized = showedProduct.attributes[i].name;
                        }
                    }
                }
                if(showedProduct.attributes[i].identifier === 'MOCO' && showedProduct.attributes[i].usage === 'Descriptive' ) {
                    productMoco = showedProduct.attributes[i].values[0].value;
                }

            }
            if (isWishlist){
                for(var i=0; showedProduct.attributes.length>i; i++) {
                    if(showedProduct.attributes[i].identifier === "MODEL_SIZE" && showedProduct.attributes[i].usage === "Descriptive" ) {
                        if (typeof wishlistAddedSizeNumber == "undefined" || wishlistAddedSizeNumber == ""){
                            wishlistAddedSizeNumber = showedProduct.attributes[i].values[0].value;
                        }
                    }

                    if(showedProduct.attributes[i].identifier === "MODEL_SIZE_DISPLAY" && showedProduct.attributes[i].usage === "Defining" ) {
                        if (typeof wishlistAddedSize == "undefined" || wishlistAddedSize == ""){
                            wishlistAddedSize = showedProduct.attributes[i].values[0].value;
                        }
                    }
                }
            }
        }

        

        var indexOtherColors = 0;
        var eachLensColor = "";
        var eachFrontColor = "";
        var isClipon = modelNameValue.toLowerCase().includes('clip');
        /*if (isClipon) {
            showedProduct.thumbnail = showedProduct.thumbnail.replace('/is/image/OliverPeoples','/extra/image/OliverPeoples/clipon').replace('_shad_fr','_shad_fr_clipon');
        }*/

        var inventoryStatus = false;
        var cbsCounter = 0;
        var csCounter = 0;
        var soCounter = 0;
        //prova
        var colorProp = "Color"
        var colorsProp = "Colors"
        //prova
        if (!(getUrlParameter('searchTerm') || isPriceOrdering() || !categoryToGroupTile()|| searchedWord || isWishlist)){
            $(model).each(function (ind) {
                if (!(typeof model[ind]['inventory'] === 'undefined')){
                    if (model[ind]['inventory']['ranking'] == '1' && model[ind]['inventory']['flComingSoon'] == 'true'){
                        csCounter++;
                    } else if (model[ind]['inventory']['ranking'] == '0'){
                        soCounter++;
                    } else if (model[ind]['inventory']['ranking'] == '1' && model[ind]['inventory']['flComingSoon'] == 'false'){
                        cbsCounter++;
                    }
                } else return false;

                if (csCounter == model.length || cbsCounter == model.length || soCounter == model.length) {
                    inventoryStatus = true;
                    return inventoryStatus;
                }
            });
         }//else{
        //     $(model).each(function (ind) {
        //         if (!(typeof model['inventory'] === 'undefined')){
        //             if (model['inventory']['ranking'] == '1' && model['inventory']['flComingSoon'] == 'true'){
        //                 csCounter++;
        //             } else if (model['inventory']['ranking'] == '0'){
        //                 soCounter++;
        //             } else if (model['inventory']['ranking'] == '1' && model['inventory']['flComingSoon'] == 'false'){
        //                 cbsCounter++;
        //             }
        //         } else return false;

        //         if (csCounter == 1 || cbsCounter == 1 || soCounter == 1) {
        //             inventoryStatus = true;
        //             return inventoryStatus;
        //         }
        //     });
        // }

        var mustacheObj = {
            modelName: modelNameValue != undefined ? modelNameValue : '',
            inventoryStatus: inventoryStatus,
            //indexPlp:productIndex+1,
            indexPlp:tileIndex+1,
            indexSearchPanel: indexSearchPanel+1,
            isSearchPanel: function () {
                if(searchedWord != undefined) {
                    return true;
                } else {
                    return false;
                }
            },
            isSearchFeturedProduct: function () {
                if(searchedWord == "X_Search_FeaturedProducts") {
                    return true;
                } else {
                    return false;
                }
            },
            isSearchPageResult: function(){
                if(searchedWord == undefined && getUrlParameter('searchTerm')){
                    return true;
                }else{
                    return false;
                }
            },
            isWishlistPage: function(){
                if (isWishlist){
                    return true;
                } else {
                    return false;
                }
            },
            catentryIdDefaultSize : function(){
                return catentryIdDefaultSize[indexOtherColors];
            },
            catentryIsPresentInWishlist: function(){
                if(typeof checkIsInWishlist === 'function'){
                    return checkIsInWishlist(catentryIdDefaultSize[indexOtherColors]);
                }
            },
            image: function () {
            	var stringOfThumbnail = null;
                var backgroundColor = "";
                if (isOliver){
                    backgroundColor = "";
                    // OP: using of OV_OpPlp
                	if(isEspot){
                		stringOfThumbnail = showedProduct.thumbnail.replace('wid=800','wid=1000');
                	}else{
                		stringOfThumbnail =  replaceTileImgByDevice(this.thumbnail.replace('OV_OpPlp','OV_parameters&WID'),'WID','small');
                	}
                } else  {
                    // PO: scaling of 45% on desktop
                    backgroundColor = "&bgcolor=%23f7f7f7";
                	if(isEspot){
                		stringOfThumbnail = showedProduct.thumbnail.replace('wid=800','wid=1500');
                	}else{
                		stringOfThumbnail =  replaceTileImgByDevice(this.thumbnail,'sclw=0.25&sclh=0.25','small');
                	}
                }
                return stringOfThumbnail + backgroundColor;
            },
            imageScaled: function () {
                var backgroundColor = "";
                if (isOliver){
                    // OP: scaling of 25% on mobile
                    var backgroundColor = "";
                    return replaceTileImgByDevice(showedProduct.thumbnail.replace('OV_OpPlp','OV_parameters&WID'),'WID','small') + backgroundColor;
                } else  {
                    // PO: scaling of 25% on mobile
                    var backgroundColor = "&bgcolor=%23f7f7f7";
                    return replaceTileImgByDevice(showedProduct.thumbnail,'sclw=0.25&sclh=0.25','small') + backgroundColor;
                }
            },
            thumbnail: function () {
                if (isOliver){
                    return replaceTileImgByDevice(showedProduct.thumbnail.replace('OV_OpPlp','OV_parameters&WID'),'WID','small');
                } else {
                    return replaceTileImgByDevice(showedProduct.thumbnail,'sclw=0.25&sclh=0.25','small');
                }
            },
            uniqueID: showedProduct != undefined ? showedProduct.uniqueID : '',
            partNumber: (getUrlParameter('searchTerm') || isPriceOrdering() || !categoryToGroupTile() || searchedWord || isWishlist ? model : model[indexOtherColors]).partNumber,
            partNumberAlt: function () {
                if (!isWishlist){
                    return this.partNumber.replaceAll('_','-').replaceAll('/', '-');
                } else {
                    return productMoco.toUpperCase();
                }
            },
            colorProperty: !(getUrlParameter('searchTerm') || isPriceOrdering() || !categoryToGroupTile() || searchedWord || isWishlist) && model.length > 1 ? colorsProp : colorProp,
            offerPrice: offerPrice ? WCCurrencyJS.format(offerPrice) : '',
            listPrice: listPrice ? WCCurrencyJS.format(listPrice) : '',
            percentage: percentage,
            baseURL: WCParamJS.homePageURL,
            group2BadgeValue: group2BadgeValue,
            otherColors: getUrlParameter('searchTerm') || isPriceOrdering() || !categoryToGroupTile() || searchedWord || isWishlist ? [ model ] : model,
            replaceImageUrl: function () {
            	var replaceImage = null;
                var backgroundColor = "";
                if (this.thumbnail != undefined) {
                    if (isOliver){
                        backgroundColor = "";
                        // OP: using of OV_OpPlp
                    	if(isEspot){
                    		if (isClipon) {
                            	replaceImage = this.thumbnail.replace('OV_OpPlp','OV_parameters&WID').replace('WID','wid=1000');
                            }else{
                            	replaceImage = this.thumbnail2.replace('OV_OpPlp','OV_parameters_transp&WID').replace('WID','wid=1000');
                            }
                    	}else{
                    		if (isClipon) {
                            	replaceImage = replaceTileImgByDevice(this.thumbnail.replace('OV_OpPlp','OV_parameters&WID'),'WID','small');
                            }else{
                            	replaceImage = replaceTileImgByDevice(this.thumbnail2.replace('OV_OpPlp','OV_parameters_transp&WID'),'WID','small');
                            }
                    	}
                    } else {
                        var backgroundColor = "&bgcolor=%23f7f7f7";
                    	if(isEspot){
                    		if (isClipon) {
                            	replaceImage = this.thumbnail.replace('sclw=0.25&sclh=0.25','wid=1500');
                            }else{
                            	replaceImage = this.thumbnail2.replace('sclw=0.25&sclh=0.25','wid=1500');
                            }
                    	}else{
                    		if (isClipon) {
                            	replaceImage = replaceTileImgByDevice(this.thumbnail, 'sclw=0.25&sclh=0.25', 'small') + backgroundColor;
                            }else{
    	                        // PO: scaling of 45% on desktop
    	                        //return replaceTileImgByDevice(this.thumbnail.replace('_fr','_qt').replace('_001','_002'),'sclw=0.25&sclh=0.25','small');
    	                        //AC: effettuate modifiche per persol anche se non indicate nel file excel
    	                        replaceImage = replaceTileImgByDevice(this.thumbnail2,'sclw=0.25&sclh=0.25','small') + backgroundColor;
                            }
                    	}
                    }
                }else{
                	replaceImage = this.thumbnail;
                }
                return replaceImage ;
            },
            replaceImageUrlScaled: function () {
                var backgroundColor = "";
                if (this.thumbnail != undefined) {
                    if (isOliver){
                        
                        backgroundColor = "";
                        // OP: scaling of 25% on mobile
                        if (isClipon) {
                            return replaceTileImgByDevice(this.thumbnail.replace('OV_OpPlp','OV_parameters&WID'),'WID','small') + backgroundColor;
                        }
                        return replaceTileImgByDevice(this.thumbnail2.replace('OV_OpPlp','OV_parameters&WID'),'WID','small') +  backgroundColor;
                    } else {
                        backgroundColor = "&bgcolor=%23f7f7f7";
                        // PO: scaling of 25% on mobile
                        if (isClipon) {
                            return replaceTileImgByDevice(this.thumbnail, 'sclw=0.25&sclh=0.25', 'small') + backgroundColor;
                        }
                        //return replaceTileImgByDevice(this.thumbnail.replace('_fr','_qt').replace('_001','_002'),'sclw=0.25&sclh=0.25','small');
                        //AC: effettuate modifiche per persol anche se non indicate nel file excel
                        return replaceTileImgByDevice(this.thumbnail2,'sclw=0.25&sclh=0.25','small') + backgroundColor;
                    }
                }
                return this.thumbnail;
            },
            replaceImageUrl1Tile: function () {
                if (this.thumbnail != undefined) {
                    if (isOliver){
                        return replaceTileImgByDevice(this.thumbnail.replace('OV_OpPlp','OV_parameters&WID'),'WID','small');
                    } else
                        //return this.thumbnail;
                        return replaceTileImgByDevice(this.thumbnail,'sclw=0.25&sclh=0.25','big');
                }
                return this.thumbnail;
            },
            index: function() {
                indexOtherColors++;
            },
            // Show color names under image
            printColorsName: function(){
                $(this.attributes).each(function (){
                    if ((this.identifier) === "FRONT_COLOR"){
                        eachFrontColor = ((this).values[0].identifier);
                    }
                    if ((this.identifier) === "LENS_COLOR"){
                        eachLensColor = ((this).values[0].identifier);
                    }
                })
                if ($("#categoryName").val() === 'OV_Sun') {
                    return (eachFrontColor + '/' + eachLensColor);
                } else {
                    return (eachFrontColor);
                }
            },
            printListPrice: function() {
                var product = this;
                var listPrice =  product['price']['listprice'] ? product['price']['listprice'] : "";
                return listPrice != '' ? WCCurrencyJS.format(listPrice) : MESSAGE_NO_PRICE_AVAILABLE;
            },
            printOfferPrice: function() {
                var product = this;
                offerPrice = getPriceByCustomerSegment(product["price"]);
                return offerPrice != '' ? WCCurrencyJS.format(offerPrice) : MESSAGE_NO_PRICE_AVAILABLE;
            },
            showListPrice: function() {
            	var product = this;
            	var listPrice =  product['price']['listprice'] ? product['price']['listprice'] : "";
            	var offerPrice = getPriceByCustomerSegment(product["price"]);
            	if(offerPrice != '' && listPrice != ''){
	            	if(offerPrice < listPrice) {
	            		return 'showListPrice';
	            	}
            	}
            	return '';
            },
            printStatus: function() {
                return printStatus(this);
            },
            printWishlistSize: function() {
                return wishlistAddedSize;
            },
            printWishlistSizeNumber: function() {
                return wishlistAddedSizeNumber;
            },
            isWishlistSizeEmpty: function() {
                if (wishlistAddedSize == "" || typeof wishlistAddedSize == "undefined"){
                    return true;
                } else {
                    return false;
                }
            },
            printPolarBadge: function() {
                return getPolarized(this.attributes);
            },
            printTransitionBadge : function () {
                return getTransitionBadge(this.attributes);
            },
            printTopBadge: function() {
                /**
                 * Group 1 Badges Hierarchy
                 * PO Transition > Polar
                 * OP Polar
                 */
                var isPolar = getPolarized(this.attributes);
                var isTransition =  getTransitionBadge(this.attributes);
             
                if(isTransition && isPersol){
                    return isTransition;
                }
                else if(isPolar){
                    if(isOliver){
                        return "— "+isPolar+" —";
                    }else{
                        return isPolar;
                    }
                }
            },
            printBottomBadge : function(){
               return  printBadges(this.attributes);
            },
            isPreOrder : function() {
                return getPreOrderBadge(this.attributes) != undefined ;
            },
            isPrescription: function(){
                return isPrescription(this.attributes);
            },
            printSeparator: function(){
                if((printBadges(this.attributes) != "" || getPreOrderBadge(this.attributes) != undefined) && isPrescription(this.attributes,searchedWord) == true){
                    return true;
                }else{
                    return false;
                }
            },
            isFastLoadImg: function() {
                return this.indexPlp < 4
            },
            isLCPTile: isLCPTile
          }

        if(searchedWord) {
            indexSearchPanel++;
        }

        if (insideGrid && !searchedWord) {
            if(typeof tealiumProducts === 'undefined'){
                var tealiumProducts = {};
            }

            //	Tealium
            var tealiumProduct = {};
            var myPartNumber = (getUrlParameter('searchTerm') || isPriceOrdering() || !categoryToGroupTile() || searchedWord || isWishlist ? model : model[0]).partNumber;
            if (isPersol){
                tealiumProduct['Sku'] = myPartNumber.replaceAll('RX_','');
            } else {
                tealiumProduct['Sku'] = myPartNumber;
            }
            tealiumProduct['ModelName'] = (modelNameValue != undefined ? modelNameValue : '').toUpperCase();
            tealiumProduct['Category'] = !isWishlist ? getSunOpticalCategoryName($("#categoryName").val()) : '';
            tealiumProduct['Price'] = offerPrice;
            tealiumProduct['PriceFull'] = listPrice;
            tealiumProduct['Brand'] = currentBrand;
            tealiumProducts[myPartNumber] = tealiumProduct;
            if(typeof pushWkndSkuInPLP == 'function' && window.wunderkind && window.wunderkind.category !== undefined)
                pushWkndSkuInPLP(tealiumProduct['Sku']);
        }

        var templateHtml = $('#plpTemplate2024').html();
        html = Mustache.to_html(templateHtml, mustacheObj);
        

    } catch (error) {
        console.error('Error in tile creation',error);
    }

    return html;
}



/**
* Opens the search bar when the search icon is clicked.
* Change the tabindex value to every focusable element into the search.
*/
function openSearchBar(element){
    //hideHeaderTimeout.cancel();
    var searchPanel = $('.header__search-wrapper');
    changeTabIndex($('.header__search-wrapper'));
    searchPanel.hasClass("opend") ? searchPanel.removeClass('opend') : searchPanel.addClass('opend');
    searchPanel.removeClass("hidden-panel");
    $('.search--fade').show();
    history.pushState({}, '') // added state in chronology To close the panel when the back button is clicked
    if(!((window.mobilecheck() || window.tabletPortraitCheck()) && isPersol)){
        $("html").css("overflow","hidden");
    }
    
    $("body").css("overflow","hidden");
    $("#page").css("overflow","hidden");
    if(!(window.mobilecheck() || window.tabletPortraitCheck())){
        loadHeaderEspot("X_Search_FeaturedProducts"); // load Feature Products
    }

    $("#contentRecommendationWidget_X_Header_GlobalBanner_X_Header_GlobalBanner").addClass("searchPanelIsOpen");

    if(isOliver){
        tealium_data2track.push({
            'id':'Click', 
            'data_element_id': 'MainNav_Search_Open',
            'Click_FocusElement' : element
        });
    }
 
    
};

function closeSearchBar() {
    if((window.mobilecheck() || window.tabletPortraitCheck()) && isPersol){
        if($(".searchPanel .search_panel_container").hasClass("active")){
            $(".searchPanel .search_panel_container").removeClass("active");
            $(".searchPanel .search_panel_container").focusout();
            window.history.go(-1);
            if(isPersol){
            	$('.header_wishlist').show(); 
                $("#logo").hide();
            }
        }

    }else{
        $('.header__search-wrapper').removeClass('opend');
        $('.search--fade').hide();
        window.history.go(-1);// delete the state added at opening
        if($plpSearchObj.itemsbkp != undefined){
            //search Optimization --retrieve info on the plp that was being navigated
            $plpSearchObj.items =  $plpSearchObj.itemsbkp;
            $plpSearchObj.busy = false;
            $plpSearchObj.lastIndex = $plpSearchObj.lastIndexbkp;
            $plpSearchObj.viewIndex = $plpSearchObj.viewIndexbkp ;
        }
    }
    
   
    if(!((window.mobilecheck() || window.tabletPortraitCheck()) && isPersol)){
        $("html").css("overflow","auto");
    }
    $("body").css("overflow","auto");
    $("#page").css("overflow","auto");

    resetSearchTile(true,true,false);
    $("#contentRecommendationWidget_X_Header_GlobalBanner_X_Header_GlobalBanner").removeClass("searchPanelIsOpen");

    if(isOliver){
        setTimeout(function() {
            $('.header__search-wrapper').addClass("hidden-panel"); //HB-12925 Overlay fade effect when close panel
        }, 600);
    }
};


window.onpopstate = function() { //interface is fired when the active history entry changes while the user navigates the session history.
    if((window.mobilecheck() || window.tabletPortraitCheck()) && isPersol){
        var searchPanel = $(".searchPanel .search_panel_container");
        if(searchPanel.hasClass("active")){
            closeSearchBar();
        }
    }else{
        var searchPanel = $('.header__search-wrapper');
        if(searchPanel.hasClass("opend")){
            closeSearchBar();
        }
    }     
  };






function getUrlParameter(paramName) {
    var results = new RegExp('[\?&]' + paramName + '=([^&#]*)').exec(window.location.href);
    if (results == null){
       return null;
    } else {
       return decodeURI(results[1]) || 0;
    }
}

/**
 * @function callbackSortBy
 * @desc callback function for default sort by
 */
function callbackSortBy(elem){
    if(elem) {
        checkFacetsAndSearch($(elem));
    }
    $('.facet__apply-number').text($plpSearchObj.resultCount);

}

function isNewArrivalsOrdering() {
	return selectedFacetsData["orderBy"] === '8';
}

function isPriceOrdering() {
	return selectedFacetsData["orderBy"] === '3' || selectedFacetsData["orderBy"] === '4';
}

function categoryToGroupTile() {
	if ($('input#notGroupTile').val() == 1)
		return false;

	return true;
}





function resetSearchTile(reloadFeaturedProducts,resetInputButton,resetSuggestion){
    if(reloadFeaturedProducts){
        if( !(window.tabletPortraitCheck() || window.mobilecheck()) && $(".searchPanel .featured-products").length == 0 ){
            $("#search_grid").html(featuredProductHtml);
        } 
        $(".title_result").show();
        $(".redirect_result_container").css("display","none");
    }else{
        $("#search_grid .search-grid-skeleton").show();
        $('#search_grid li').each(function() {
            $(".redirect_result_container .redirect_result_link").css("display","none");
            if(!$(this).hasClass("search-grid-skeleton")){
                 $(this).empty(); // elimina il contenuto 
                 $(this).append('<div class="grid-item">' +
                                    '<div class="product">' +
                                        '<div class="product--wrapper">' +
                                            '<div class="product--wrapper__container">' +
                                                '<div class="plp__other-product-carousel new-plp">' +
                                                    '<div class="square-container skeleton-element">' +
                                                        '<div class="square-content">' +
                                                        '</div>' +
                                                    '</div>' +
                                                    '<div class="product__wrapper-info skeleton-element">' +
                                                        '<a class="lower-tile-container ">' +
                                                        '</a>' +
                                                    '</div>' +
                                                '</div>' +
                                            '</div>' +
                                        '</div>' +
                                    '</div>' +
                                '</div>');
                 $(this).addClass("search-grid-skeleton");
                 $(this).removeClass("featured-products");
                
                 
            }
         });
    }
    if(resetInputButton){
        $('input:text[name=searchInput]').val("");
        $(".searchPanel .delete-input-icon").hide();
    }
    if(resetSuggestion){
        $("#search_UsefulLinks").show();
        $("#search_popular").show();
        $(".searchPanel .suggestions_container").empty();
        $(".searchPanel .suggestions_container").hide();
        searchError(false);
    }

    removeLoader();
    
}

function updateSearchTermHistoryCookieAndRedirect(updatedSearchTerm, redirectURL){
	
	this.updateSearchTermHistoryCookie(updatedSearchTerm);
    if (navigator.userAgent.toLowerCase().indexOf('firefox') == -1) {document.location.href = appendWcCommonRequestParameters(redirectURL);}
    
}

function fn_startSearch() {
    var searchTimeout;
    indexSearchPanel = 0;
    var dInput = $('input:text[name=searchInput]').val().toLowerCase();
    if(!(window.tabletPortraitCheck() || window.mobilecheck())){
        if(dInput.length >= 2){
        	$plpSearchObj.search = true;
            resetSearchTile();
            const promise2 = Promise.resolve(printAutoSuggestions(dInput));
            const promise3 = new Promise((resolve, reject) => {
                setTimeout(resolve, 500, 'Success');
            });
            const promise1 = Promise.resolve(fn_plpFirstTiles(undefined,dInput,undefined,undefined,true));
            Promise.all([promise1,promise2, promise3]).then((values) => {
                if(values[1].suggestionView[0].entry.length > 0 && ($(".error_search_message").is(":visible") || $('.title_result').is(":visible") || $('#search_grid .square-container.skeleton-element').is(":visible")) ){
                    searchError(false);
                    resetSearchTile(false,false,false);
                    fn_plpFirstTiles(undefined,values[1].suggestionView[0].entry[0].name);
                }else if( (!$(".error_search_message").is(":visible") || !$('.title_result').is(":visible")) ){
                    searchError(false);
                }else{
                    searchError(true);
                    resetSearchTile(true,false,false); 
                }
            });
        }
    }else{
        if(dInput.length >= 2){
            printAutoSuggestions(dInput);
        } 
    }
    if(dInput.length > 0){
        if(dInput.length < 2){
            resetSearchTile(true,false,true);
        }
       // $(".searchPanel .delete-input-icon").show();
    }else if(dInput == 0){
        resetSearchTile(true,true,true);
    }
}

function tealiumPushSearchPageReady(dInput,resultItemsQnt) {
    console.log("TEALIUM::tealiumPushSearchPageReady function invoked");
    if(typeof tealium_data2track !== 'undefined' && !mobilecheck()) {
        var trackData = {};
        trackData['id'] = 'SearchPageReady';
        trackData['Search_Keyword'] = dInput.toLowerCase();
        trackData['Search_KeywordActual'] = '';
        trackData['Search_Type'] = 'text';
        trackData['Search_ResultItemsQnt'] = resultItemsQnt; 
        trackData['Search_FacetValues_String'] = "";
        trackData['Search_View'] = "SERB"
        tealium_data2track.push(trackData);
    }
}


function goToSearchPage(input){
    var searchType = ""
    if(input != undefined){
        var dInput = input  
        searchType = "suggested"
       
    }else {
        var dInput = $('input:text[name=searchInput]').val();
        searchType = "text"
        
    }
    var typeResult = checkTileEditorialProduct(numItems,numEditorials);
    if(dInput.length > 0){
        updateSearchTermHistoryCookie(dInput);
        var baseSearchPage = (isInToolkit ? '' : WCParamJS.homePageURL +"/")+'SearchDisplay?storeId='+WCParamJS.storeId+'&catalogId='+ WCParamJS.catalogId + '&langId='+ WCParamJS.langId + '&design=' + typeResult + '&searchTerm=' + dInput +'&Search_Type='+ searchType;   
        location.href = baseSearchPage;
    }
   
}

/**
function printAutoSuggestions(dInput){
    dInput = dInput.replaceAll("’","'");
    $(".searchPanel .suggestions_container").empty();//clean suggestion div 
    var searchHistory = getSearchTermsCookie();
    var limit = 10 - searchHistory.length; //total suggestions + history search = 10

    if(searchHistory.length > 0){ //check for research already done
        searchHistory.forEach(function (term) { 
            historySearchDiv = '<div><a class="search-history" onclick=" goToSearchPage(\''+ term.replace("-","").replace(" ","") +'\')" data-element-id="SearchPanel_Results_query">' + term.replace("%27","'")+ '</a></div>';
            $(".searchPanel .suggestions_container").append(historySearchDiv);//print the latest research
        }) 
    }
    queryAutoSuggestions = {
        storeId: WCParamJS.storeId,
        catalogId: WCParamJS.catalogId,
        responseFormat: 'json',
        langId: WCParamJS.langId,
        categoryId: WCParamJS.categoryId,
        limit: limit
    };
    return new Promise((resolve, reject) => {
        $.ajax({
            url: (isInToolkit ? '' : WCParamJS.homePageURL) +"/search/resources/store/" + WCParamJS.storeId  + "/sitecontent/productSuggestionsBySearchTerm/"+ dInput ,
            type: 'GET',
            async: true,
            data: queryAutoSuggestions,
            success: function(data){
                var suggestionDiv = "";
                if(data.suggestionView && data.suggestionView[0].entry.length > 0){
                    if(!(window.tabletPortraitCheck() || window.mobilecheck())){
                        $("#search_UsefulLinks").hide();
                        $("#search_popular").hide();
                        
                    }else{
                        tealiumPushSearchPageReady(dInput,limit);
                    }
                    searchError(false);
                    $(".searchPanel .suggestions_container").show();
                    var searchTerms = [];
                    for (var i = 0; i < data.suggestionView[0].entry.length; i++) {
                    	var isPresent = false;
                    	var temporaryTerm = data.suggestionView[0].entry[i].name;
                		for (var j = 0; j < searchTerms.length; j++) {
                		//check if the result name has been already shown
                    		if (temporaryTerm === searchTerms[j]){
                    			isPresent = true;
                    		}
                    	}
                    	if(!isPresent){
                    		var spanTerm = data.suggestionView[0].entry[i].name.replace(dInput.toLowerCase(),"<span class='serched-word'>" + dInput.toLowerCase() +"</span>" );
                            suggestionDiv = '<div><a class="suggestion" onclick="goToSearchPage(\'' + data.suggestionView[0].entry[i].name.replace("'","%27") + '\')">' + spanTerm.toLowerCase() + '</a></div>';
                            $(".searchPanel .suggestions_container").append(suggestionDiv);//print suggestions
                    	}
                    	searchTerms.push(data.suggestionView[0].entry[i].name);
                    }
                }
                else if (data.metaData){
                	dInput = data.metaData.spellcheck[0];
                	printAutoSuggestions(dInput);
                }
                else if(!(searchHistory.length > 0 && data.suggestionView && data.suggestionView[0].entry.length > 0)){
                    if((window.tabletPortraitCheck() || window.mobilecheck())){
                        searchError(true);
                        tealiumPushSearchPageReady(dInput,'0');
                    }
                    $(".suggestions_container").hide();
                    $("#search_UsefulLinks").show();
                    $("#search_popular").show();
                    
                }
                resolve(data);
            },
            error: function(error) {
                console.error(error);  
                reject(error);
            }
        });
    });

    

}
*/ 

var inputTimer = null;

function loadHeaderEspot(espotName) {

    // If espot div is not present, skip the loading
    if ($("#" + espotName).length == 0) return;
  
    // Get product, if present
    let products = {};
    let contents = [];
  
    // Compose service url
    var espotServiceUrl =
      WCParamJS.urlPrefixForHTTPS +
      "/wcs/resources/store/" +
      WCParamJS.storeId +
      "/espot/" +
      espotName +
      "?langId=" +
      WCParamJS.langId;
  
    return new Promise((resolve, reject) => {
  
      $.getJSON(espotServiceUrl, function (data) {
        products = {};
        contents = [];
        //con la risposta del servizio mi creo due array di oggetti di prodotti e contenuti
        data["MarketingSpotData"].forEach(function (msd, index) {
          if (msd["baseMarketingSpotActivityData"]) {
            var savedActivityPriority;
            msd["baseMarketingSpotActivityData"].every(function (bmspd, index) {
              if (
                typeof savedActivityPriority != "undefined" &&
                savedActivityPriority != bmspd["activityPriority"]
              ) {
                return false;
              }
              savedActivityPriority = bmspd["activityPriority"];
              if (bmspd["baseMarketingSpotDataType"] === "CatalogEntry") {
                // controllo che sia un prodotto
                var productsobj = {
                  product: bmspd["baseMarketingSpotActivityName"],
                  productId: bmspd["productId"]
                };
                //prendo le info sul modello
                var isProductPresent =
                  productsobj["product"].length > 0 &&
                  productsobj["productId"].length > 0;
                  if (isProductPresent) {
                    products[productsobj["productId"]] = productsobj;
                }
              } else if (
                bmspd["baseMarketingSpotDataType"] === "MarketingContent"
              ) {
                // controllo che sia un contenuto
                bmspd["marketingContentDescription"].forEach(function (mkd, index) {
                  if(typeof mkd["marketingText"] != 'undefined'){
                    contents.push(
                        mkd["marketingText"].replaceAll(
                          "[fullPathHomeURL]",
                          WCParamJS.homePageURL
                        )
                      ); //metto nell array di contenuto tutti i contenuti
                  }  
                });
              }
              return true;
            });
          }
        });
  
      }).done(function(data) {
  
        if (Object.keys(products).length > 0) {
  
          getProductsModelHeader(products,function() {
            if(espotName=="X_Search_FeaturedProducts"){
              renderTileProducts(products,0,0,0,espotName);
            }else{
                if( typeof espotCallback == 'function'){
                    espotCallback(products, contents, espotName);
                }
            }
            
          })
          .then((data) => {
            console.log(data);
          })
          .catch((error) => {
            console.error(error)
          });
  
        } else {
            if( typeof espotCallback == 'function'){
                espotCallback(products, contents, espotName)
            }
        }
  
        resolve(data);
    }).fail(function(error) {
      reject(error);
    });
  
    });
  
  }

  function getProductsModelHeader(products,callback) {

    var productIds = [];
    $.each(products,function(k,v) {
      productIds.push(k);
    });
  
    // Compose service url
    var productServiceUrl =
      (isInToolkit ? "" : WCParamJS.homePageURL) +
      "/search/resources/store/" +
      WCParamJS.storeId +
      "/productview/byIds?id=" +
      productIds.join("&id=") +
      "&storeId=" +
      WCParamJS.storeId +
      "&catalogId=" +
      WCParamJS.catalogId +
      "&responseFormat=json&langId=" +
      WCParamJS.langId +
      "&currency=" +
      WCParamJS.commandContextCurrency +
      "&profileName=LUX_findProductByIds_Details" +
      "&isForDDM=true"
      ;
  
    return new Promise((resolve, reject) => {
      $.getJSON(productServiceUrl, function (data) {
        var productModel = data["catalogEntryView"];
  
        // To align objects with those expected by Mustache
        productModel.forEach(function (m, index) {
          m["modelCode"] = m.partNumber.split('__')[0];
          products[m["uniqueID"]]["productModel"] = m;
        });
  
        if (typeof callback === 'function') {
          callback();
        }
  
      }).done(function(data) {
        resolve(data);
      }).fail(function(error) {
        reject(error);
      });
    });
    
  }
  /** 
  function updateSearchTermHistoryCookie(updatedSearchTerm){
    // Set the expiration date to one month from the current date
    var expirationDate = new Date();
    expirationDate.setMonth(expirationDate.getMonth() + 1);
    var cookieKey = "searchTermHistory";
    var cookieValue = "|" + updatedSearchTerm;
    var searchTermHistoryCookie = getCookie(cookieKey);
    if( searchTermHistoryCookie != undefined && searchTermHistoryCookie != 'undefined') {
        var termsArray = searchTermHistoryCookie.split("|");
        if(!termsArray.includes(cookieValue.replace("|",""))){
            cookieValue = getCookie(cookieKey) + cookieValue;
        }
        
    }
    setCookie(cookieKey, cookieValue,{path:'/', domain:cookieDomain, expires: expirationDate});
}


function getSearchTermsCookie(){
    var searchHistoryCookie = getCookie("searchTermHistory");
    var theLastTerms=[];
    if( searchHistoryCookie != undefined && searchHistoryCookie != 'undefined') {
        var termsArray = searchHistoryCookie.split("|");
        var count = 0; 
        for(var i = termsArray.length - 3; i < termsArray.length; i++) {
            if(termsArray[i] != undefined && termsArray[i] != "" && termsArray[i] != 'undefined'){
                theLastTerms[count]= termsArray[i];
                count++;
            }
        }
    }
    return theLastTerms.reverse();
}
**/

function searchError(show){
    if(show){
        var searchedWord = $('input:text[name=searchInput]').val();
        $(".error_search_message #error_word").html(searchedWord);
        $(".error_search_message").show();
        $(".error-search-icon").show();
        $(".input-icon").hide();
    }else{
        $(".error_search_message").hide();
        $(".error-search-icon").hide();
        $(".input-icon").show();
    }
    
}



/**
 * @funtion getStatus 
 * @desc get Product Status (Available, SoldOut, Out-of-stock, etc.) based on inventory informations
 */
function getStatus(inventoryStatus) {
    //var flComingSoon = inventoryStatus.flComingSoon;
    var ranking = inventoryStatus.ranking;
    var status = "";

    switch(ranking) {
        case "0" : {
            status =  "SoldOut";
            break;
        }
        case "1" : {//Coming Soon & Coming Back Soon
            status = "Out-of-stock";  
            break;
        }
        case "2" : {
            status = "Available";
            break;
        } 
        default : {
            status= "/";
        }
    }
    return status;
}

//remove loader as soon as image is displayed
function removeLoader(){
    var articleImages = document.querySelectorAll(".image-container.main > picture >  img");
    var imageSkeleton = '';
    articleImages.forEach(function(img) {
        img.addEventListener('load', function() {
            imageSkeleton = $(img).closest(".image-container");
            $(imageSkeleton).removeClass("skeleton-element");
        });       
    });
}

function clearSearchPanelEditorial(){
	while ($('#search_hits .ais-Hits .ais-Hits-item.is-editorial').length != 0){
		$('#search_hits .ais-Hits .ais-Hits-item.is-editorial')[$('#search_hits .ais-Hits .ais-Hits-item.is-editorial').length-1].remove()
	}
}



window.addEventListener('load', (event) => {

    if($('#page').hasClass('pdp')){
        var timestamp = new Date().getTime() / 1000;
        var diff = timestamp - renderingPageStarterTime;
        console.log('Performance Improvements PDP - #22 - Header_Content.js (PO only) - ' + diff.toString().slice(0 , 5) + 's');
    }
    

  //Sunglasses
  loadHeaderEspot("X_Header_NavSunglasses_EditorialCards"); 
  //Eyeglasses
  loadHeaderEspot("X_Header_NavEyeglasses_EditorialCards");

  if (window.mobilecheck() || window.tabletPortraitCheck()) {
    loadHeaderEspot("M_Header_NavCollection_RightCards");
    loadHeaderEspot("M_Header_NavCollaboration_RightCards");
  } else {
    loadHeaderEspot("D_Header_NavCollection_RightCards");
  }
  loadHeaderEspot("X_Header_NavGifts_RightCards");
  loadHeaderEspot("X_Header_NavOurWorld_RightCards");
  loadHeaderEspot("X_Header_NavSale_RightCards");
  //adattare header quando c'è banner
  if ($("#page").hasClass("pdp")) {
    if ($("#page").find(".ct-promo-bannerTop").length) {
      //solo se c'è il banner sposta in basso la barra dei menu
      //$("#header").css("top", "35px");
      $(".header .nav__section").css("top", "90px !important");
      if (window.mobilecheck() || window.tabletPortraitCheck()) {
        //da fare solo in mobile
       // $("#shoppingCart").css("top", "16px");
        //$("#hamResponsive").css("top", "12px");
        //$("#header").css("top", "40px");
        //$(".long-description-widget").css("top","37px");
        /*$(".long-description-widget").css(
          "margin-top",
          $(".ct-promo-bannerTop").height()
        ); commented in PDP Resesign_2023*/
      }
    } else {
      if (!window.mobilecheck() || !window.tabletPortraitCheck()) {
        $(".nav__section.sub.nav").css("top", "62px");
      }
      $("#header").css("height", "53px");
    }
  }

  $(document)
    .find("#TitleLiMobile")
    .find(".submenu__subheader--mobile")
    .html($("#ourWorld").val());

  $(document)
    .find("#TitleLiMobile_Gift")
    .find(".submenu__subheader--mobile")
    .html($("#gifts").val());  

  //  Remove SALES badge from non e-commerce countries
  if (isEcommerceStoreJS.toLowerCase() != "true") {
    $(".submenu__list-block .submenu__item.sale_badge").remove();
  }

});



function espotCallback(products, contents, espotName) {
  // Get HTML content
  var content = productPlusContentHtmlHeader(products, contents, false, espotName); // chiamo la funzione che mi restituisce in ordine contenuti e prodotti con la struttura html
  var espotWithCarousel = false;

  if(espotName == "X_Header_NavEyeglasses_IconsCards" || espotName == "X_Header_NavEyeglasses_BestsellersCards" || espotName == "X_Header_NavEyeglasses_EditorialCards" || espotName== "X_Header_NavSunglasses_IconsCards" || espotName == "X_Header_NavSunglasses_BestsellersCards" || espotName == "X_Header_NavSunglasses_EditorialCards" || espotName== "X_Header_NavSale_IconsCards" || espotName == "X_Header_NavSale_BestsellersCards" || espotName == "X_Header_NavSale_RightCards"){
    if((Object.keys(products).length > 0 || !isScriptContent(contents[0])) && (window.mobilecheck() || window.tabletPortraitCheck())){
      espotWithCarousel = true;
    }
  }

  if( (espotName == "X_Header_NavOurWorld_RightCards" || espotName == "X_Header_NavGifts_RightCards" ) && contents.length != 0 && !isScriptContent(contents[0])){
    espotWithCarousel = true;
  }

  $("#" + espotName).html(content); // stampa il contenuto html (nel caso di uno script lo esegue)
  var items = 4.3;
  var isGifOrWorld = false;
  if (
    espotName === "X_Header_NavOurWorld_RightCards" ||
    espotName == "X_Header_NavGifts_RightCards"
  ) {
    items = 5.9;
    isGifOrWorld = true;
  } else if (espotName === "X_Header_NavEyeglasses_RightCards") {
    items = 5.2;
  }
  if(espotName != "" && espotWithCarousel){
    drawCarouselHeader(espotName, items);
  }
    
  if (
    espotName == "X_Header_NavOurWorld_RightCards" &&
    (pageType == "Plp" || pageType == "Static") &&
    !(window.mobilecheck() || window.tabletPortraitCheck())
  ) {
    mapMenuAndUnderline();
  } 
}

function isScriptContent(content){
  return (typeof(content) === 'string' && content.includes("<script>"));
}

function productPlusContentHtmlHeader(products, contents, productFirst, espotName) {
  var contentHtml = "";
  var productHtml = ""; // concatena tutti i div di prodotto all'interno ci sarà il template di mustache

  contents.forEach(function (cont, index) {
    contentHtml += cont; // concatena tutte i div con solo il contenuto html
  });

  Object.keys(products).forEach(function (prod, index) {
    productHtml += printMustacheProducts(products[prod], espotName); // concatena tutte i div con solo il contenuto html
  });

  if (productFirst) return productHtml + contentHtml;
  else return contentHtml + productHtml;
}

function printMustacheProducts(prod, espotName) {
  var modelNameValue = "";
  var polarized = "";

  if (prod != undefined) {
    var productModel = prod.productModel;
    if (productModel && productModel.length != 0) {
      for (var i = 0; productModel.attributes.length > i; i++) {
        if (
          productModel.attributes[i].identifier === "MODELNAME" &&
          productModel.attributes[i].usage === "Descriptive"
        )
          modelNameValue = productModel.attributes[i].values[0].value;
        if (
          productModel.attributes[i].identifier === "POLARIZED" &&
          productModel.attributes[i].usage === "Descriptive"
        ) {
          for (var k = 0; productModel.attributes[i].values.length > k; k++) {
            if (
              productModel.attributes[i].values[k].value == true ||
              productModel.attributes[i].values[k].value.toLowerCase() === "yes"
            ) {
              polarized = prodproductModel.attributes[i].name;
            }
          }
        }
      }
    }
  }
  console.log(espotName)

  var mustacheObj = {
    modelName: modelNameValue != undefined ? modelNameValue : "",
    image:
      replaceTileImgByDevice(
        productModel.thumbnail,
        "sclw=0.25&sclh=0.25",
        "small"
      ) + "&bgcolor=%23ffffff",
    uniqueID: productModel != undefined ? productModel.uniqueID : "",
    partNumber: productModel.partNumber,
    partNumberAlt: function () {
      return this.partNumber
        .replace("__", "--")
        .replace("_", "-")
        .replace("/", "-");
    },
    baseURL: WCParamJS.homePageURL,
    replaceImageUrl: function () {
      return this.image.replace("_fr", "_qt");
    },
    checkisPolar: function () {
      return getPolarized(productModel.attributes, true);
    },
    printPolarBadge: function () {
      return getPolarized(productModel.attributes);
    },
    espotName
  };

  var templateHtml = $("#CaroselMustacheHeader").html();

  var html = Mustache.to_html(templateHtml, mustacheObj);

  return html;
}

function drawCarouselHeader(id, items) {
  // if(window.mobilecheck()|| window.tabletPortraitCheck()){
  //     $("#"+id).owlCarousel({
  //         items: 1,
  //         pagination: false,
  //         responsive: true,
  //         mouseDrag: true,
  //         touchDrag: true,
  //         navigation: false,
  //         lazyLoad: true,
  //         rewindNav: false,
  //         singleItem:false,
  //         addClassActive: false,
  //     });
  // } else {
  $("#" + id).on("init", function (event, slick) {
    setTimeout(function () {
      var slide = $("#" + id).find(".slick-slide");
      //$(slide).height($(slide).width());

      //$(".nav-left").css("display", "flex");
    }, 1500);
  });

  if (
    id == "X_Header_NavOurWorld_RightCards" ||
    id == "X_Header_NavGifts_RightCards"
  ) {
    $("#" + id).slick({
      lazyLoad: "ondemand",
      slidesToShow:
        window.mobilecheck() || window.tabletPortraitCheck()
          ? undefined
          : items,
      slidesToScroll: undefined,
      infinite: false,
      prevArrow: `<span class="nav-left" id="nav-left-${id}" aria-label="previous slide" role="button" tabindex="0" > <span class="prev" id="prev-${id}">  </span> </span>`,
      nextArrow: `<span class="nav-right" id="nav-right-${id}" aria-label="next slide" role="button" tabindex="0"> <span class="next" id="next-${id}">  </span> </span>`,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: undefined,
            slidesToScroll: undefined,
            vertical: true,
          },
        },
        {
          breakpoint: 1250,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 2,
            prevArrow:
              `<span class="nav-left" id="nav-left-${id}" aria-label="previous slide" role="button" tabindex="0" style="display: flex;"> <span class="prev" id="prev-${id}">  </span> </span>`,
          },
        },
        {
          breakpoint: 1400,
          settings: {
            slidesToShow: 4.8,
            slidesToScroll: 2.3,
            prevArrow:
            `<span class="nav-left" id="nav-left-${id}" aria-label="previous slide" role="button" tabindex="0" style="display: flex;"> <span class="prev" id="prev-${id}">  </span> </span>`,
          },
        },
        {
          breakpoint: 1500,
          settings: {
            slidesToShow: 5.1,
            slidesToScroll: 2.3,
            prevArrow:
              `<span class="nav-left" id="nav-left-${id}" aria-label="previous slide" role="button" tabindex="0" style="display: flex;"> <span class="prev" id="prev-${id}">  </span> </span>`,
          },
        },
        {
          breakpoint: 1681,
          settings: {
            slidesToShow: 6,
            slidesToScroll: 3,
            prevArrow:
            `<span class="nav-left" id="nav-left-${id}" aria-label="previous slide" role="button" tabindex="0" style="display: flex;"> <span class="prev" id="prev-${id}">  </span> </span>`,
          },
        },
      ],
      vertical:
        window.mobilecheck() || window.tabletPortraitCheck() ? true : false,
      accessibility: false,
    });
  } if( id == "X_Header_NavSunglasses_EditorialCards" || id == "X_Header_NavEyeglasses_EditorialCards" || id == "X_Header_NavSunglasses_IconsCards" ||
         id == "X_Header_NavEyeglasses_IconsCards" || id == "X_Header_NavSale_IconsCards" || id == "X_Header_NavSale_RightCards"){
    $("#" + id).slick({
      lazyLoad: "ondemand",
      slidesToShow: 1.48,
      slidesToScroll: 1.48,
      infinite: false,
      prevArrow:
        `<span class="nav-left" id="nav-left-${id}" aria-label="previous slide" role="button" tabindex="0" > <span class="prev" id="prev-${id}">  </span> </span>`,
      nextArrow:
        `<span class="nav-right" id="nav-right-${id}" aria-label="next slide" role="button" tabindex="0"> <span class="next" id="next-${id}">  </span> </span>`,
      accessibility: false,
    });
  } else if(id == "X_Header_NavSunglasses_BestsellersCards" || id == "X_Header_NavEyeglasses_BestsellersCards"|| id == "X_Header_NavSale_BestsellersCards"){
    $("#" + id).slick({
      lazyLoad: "ondemand",
      slidesToShow: 1.55,
      slidesToScroll: 1.55,
      infinite: false,
      prevArrow:
        `<span class="nav-left" id="nav-left-${id}" aria-label="previous slide" role="button" tabindex="0" > <span class="prev" id="prev-${id}">  </span> </span>`,
      nextArrow:
        `<span class="nav-right" id="nav-right-${id}" aria-label="next slide" role="button" tabindex="0"> <span class="next" id="next-${id}">  </span> </span>`,
      accessibility: false,
    });
  }
  else {
    $("#" + id).slick({
      lazyLoad: "ondemand",
      slidesToShow: items,
      slidesToScroll: undefined,
      infinite: false,
      prevArrow:
        `<span class="nav-left" id="nav-left-${id}" aria-label="previous slide" role="button" tabindex="0" > <span class="prev" id="prev-${id}">  </span> </span>`,
      nextArrow:
        `<span class="nav-right" id="nav-right-${id}" aria-label="next slide" role="button" tabindex="0"> <span class="next" id="next-${id}">  </span> </span>`,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 1.7,
            slidesToScroll: 1.7,
          },
        },
        {
          breakpoint: 1300,
          settings: {
            slidesToShow:
              id == "X_Header_NavSunglasses_RightCards" ||
              id == "D_Header_NavCollection_RightCards"
                ? 2.5
                : 3,
            slidesToScroll: 1.5,
            prevArrow:
              `<span class="nav-left" id="nav-left-${id}" aria-label="previous slide" role="button" tabindex="0" style="display: flex;"> <span class="prev" id="prev-${id}">  </span> </span>`,
          },
        },
        {
          breakpoint: 1400,
          settings: {
            slidesToShow:
              id == "X_Header_NavSunglasses_RightCards" ||
              id == "D_Header_NavCollection_RightCards"
                ? 3
                : 3.9,
            slidesToScroll: id == "X_Header_NavSunglasses_RightCards" ? 2 : 1.7,
            prevArrow:
              `<span class="nav-left" id="nav-left-${id}" aria-label="previous slide" role="button" tabindex="0" style="display: flex;"> <span class="prev" id="prev-${id}">  </span> </span>`,
          },
        },
        {
          breakpoint: 1500,
          settings: {
            slidesToShow: id == "X_Header_NavEyeglasses_RightCards" ? 4.2 : 3.5,
            slidesToScroll:
              id == "X_Header_NavEyeglasses_RightCards" ? 2.3 : 1.7,
            prevArrow:
              `<span class="nav-left" id="nav-left-${id}" aria-label="previous slide" role="button" tabindex="0" style="display: flex;"> <span class="prev" id="prev-${id}">  </span> </span>`,
          },
        },
        {
          breakpoint: 1681,
          settings: {
            slidesToShow: id == "X_Header_NavEyeglasses_RightCards" ? 4.9 : 4,
            slidesToScroll: 1.7,
            prevArrow:
              `<span class="nav-left" id="nav-left-${id}" aria-label="previous slide" role="button" tabindex="0" style="display: flex;"> <span class="prev" id="prev-${id}">  </span> </span>`,
          },
        },
      ],
      accessibility: false,
    });
  }

  // $("#"+id).owlCarousel({
  //     items: items,
  //     pagination: false,
  //     responsive: true,
  //     mouseDrag: true,
  //     touchDrag: true,
  //     navigation: true,
  //     lazyLoad: true,
  //     rewindNav: false,
  //     singleItem:false,
  //     addClassActive: false,
  //     navigationText:[
  //         '<span class="nav-left" aria-label="next slide" role="button" tabindex="0" >PREV</span>',
  //         '<span class="nav-right" aria-label="next slide" role="button" tabindex="0">NEXT</span>'
  //     ],
  //     afterInit: function(){
  //         var owlitems = $('#'+ id).find(".owl-item")
  //         $(owlitems).height($(owlitems).width());
  //     }
  // });
  // }

  $("#" + id + " .slick-slide a").focusin(function () {
    $(this).get(0).scrollIntoView();
  });
}

//countdown
// Set the date we're counting down to
var countDownDate = new Date("Jan 5, 2021 15:37:25").getTime();
/*
// Update the count down every 1 second
var interval = setInterval(function() {

  // Get today's date and time
  var now = new Date().getTime();
    
  // Find the distance between now and the count down date
  var distance = countDownDate - now;
    
  // Time calculations for days, hours, minutes and seconds
  var days = Math.floor(distance / (1000 * 60 * 60 * 24));
  var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
  var seconds = Math.floor((distance % (1000 * 60)) / 1000);
    
  // Output the result in an element with id="demo"
  if(document.getElementsByClassName("ct-promo-countTop")[0]){
 document.getElementsByClassName("ct-promo-countTop")[0].innerHTML ="- "+"End in " + " " + hours + "H " + ": "
  + minutes + "M "+ ": " + seconds + "S ";
  document.getElementsByClassName("ct-promo-countTop")[0].innerHTML ="- "+"End in " + " " + '10' + "H " + ": "
  + '20' + "M "+ ": " + '10' + "S ";
  }
  // If the count down is over, write some text 
  if (distance < 0) {
    clearInterval(interval);
  //  document.getElementById("demo").innerHTML = "EXPIRED";
  }
}, 1000);}*/


window.onload = function() {
	  const navBeansElement = document.querySelector('.nav-beans');
	  if (navBeansElement || window.mobilecheck() || window.tabletPortraitCheck() ) {
		  // Se .nav-beans è presente, attiva il bottone in FilterButtonsBar.jspf 
		  // e rimuovi la classe dal bottone in PersolSubCategoryPageContainer.jsp
		  const persolButton = document.querySelector('.persol-page .plp-filter-button');
		  if (persolButton) {
			  persolButton.classList.remove('plp-filter-button');
			  persolButton.classList.add('plp-filter-button--inactive');
		  }
		  const filterButton = document.querySelector('.filter-bar-page .plp-filter-button');
		  if (filterButton) {
			  filterButton.classList.add('plp-filter-button');
			  filterButton.classList.remove('plp-filter-button--inactive');
		  }
	  	} else {
		// Esegui solo su desktop
		// Se .nav-beans non è presente, attiva il bottone in PersolSubCategoryPageContainer.jsp
		// e rimuovi la classe dal bottone in FilterButtonsBar.jspf
		const filterButton = document.querySelector('.filter-bar-page .plp-filter-button');
		if (filterButton) {
			filterButton.classList.remove('plp-filter-button');
			filterButton.classList.add('plp-filter-button--inactive');
		}
		//rimuovo la barra grigia di FilterButtonsBar.jspf
	    const onlyFilterButton = document.querySelector('.filter-bar-page');
	    if (onlyFilterButton){
		    onlyFilterButton.classList.remove('filter-bar-page');
		    onlyFilterButton.classList.add('filter-bar-page--inactive');
	    }
		const persolButton = document.querySelector('.persol-page .plp-filter-button');
		if (persolButton) {
			persolButton.classList.add('plp-filter-button');
			persolButton.style.display = 'flex';
			persolButton.classList.remove('plp-filter-button--inactive');
		}
	  }
  };
  
